var fS = (t) => {
  throw TypeError(t);
};
var ij = (t, e) => () => (e || t((e = { exports: {} }).exports, e), e.exports);
var lx = (t, e, n) => e.has(t) || fS("Cannot " + n);
var J = (t, e, n) => (
    lx(t, e, "read from private field"),
    n ? n.call(t) : e.get(t)
  ),
  We = (t, e, n) =>
    e.has(t)
      ? fS("Cannot add the same private member more than once")
      : e instanceof WeakSet
        ? e.add(t)
        : e.set(t, n),
  Pe = (t, e, n, i) => (
    lx(t, e, "write to private field"),
    i ? i.call(t, n) : e.set(t, n),
    n
  ),
  Mt = (t, e, n) => (lx(t, e, "access private method"), n);
var v0 = (t, e, n, i) => ({
  set _(a) {
    Pe(t, e, a, n);
  },
  get _() {
    return J(t, e, i);
  },
});
var vI = ij((II, tb) => {
  (function () {
    const e = document.createElement("link").relList;
    if (e && e.supports && e.supports("modulepreload")) return;
    for (const a of document.querySelectorAll('link[rel="modulepreload"]'))
      i(a);
    new MutationObserver((a) => {
      for (const l of a)
        if (l.type === "childList")
          for (const u of l.addedNodes)
            u.tagName === "LINK" && u.rel === "modulepreload" && i(u);
    }).observe(document, { childList: !0, subtree: !0 });
    function n(a) {
      const l = {};
      return (
        a.integrity && (l.integrity = a.integrity),
        a.referrerPolicy && (l.referrerPolicy = a.referrerPolicy),
        a.crossOrigin === "use-credentials"
          ? (l.credentials = "include")
          : a.crossOrigin === "anonymous"
            ? (l.credentials = "omit")
            : (l.credentials = "same-origin"),
        l
      );
    }
    function i(a) {
      if (a.ep) return;
      a.ep = !0;
      const l = n(a);
      fetch(a.href, l);
    }
  })();
  var y0 =
    typeof globalThis < "u"
      ? globalThis
      : typeof window < "u"
        ? window
        : typeof global < "u"
          ? global
          : typeof self < "u"
            ? self
            : {};
  function aw(t) {
    return t &&
      t.__esModule &&
      Object.prototype.hasOwnProperty.call(t, "default")
      ? t.default
      : t;
  }
  var ox = { exports: {} },
    tg = {};
  /**
   * @license React
   * react-jsx-runtime.production.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var dS;
  function sj() {
    if (dS) return tg;
    dS = 1;
    var t = Symbol.for("react.transitional.element"),
      e = Symbol.for("react.fragment");
    function n(i, a, l) {
      var u = null;
      if (
        (l !== void 0 && (u = "" + l),
        a.key !== void 0 && (u = "" + a.key),
        "key" in a)
      ) {
        l = {};
        for (var d in a) d !== "key" && (l[d] = a[d]);
      } else l = a;
      return (
        (a = l.ref),
        { $$typeof: t, type: i, key: u, ref: a !== void 0 ? a : null, props: l }
      );
    }
    return ((tg.Fragment = e), (tg.jsx = n), (tg.jsxs = n), tg);
  }
  var hS;
  function rj() {
    return (hS || ((hS = 1), (ox.exports = sj())), ox.exports);
  }
  var h = rj(),
    cx = { exports: {} },
    ng = {},
    ux = { exports: {} },
    fx = {};
  /**
   * @license React
   * scheduler.production.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var pS;
  function aj() {
    return (
      pS ||
        ((pS = 1),
        (function (t) {
          function e(V, pe) {
            var de = V.length;
            V.push(pe);
            e: for (; 0 < de; ) {
              var he = (de - 1) >>> 1,
                Te = V[he];
              if (0 < a(Te, pe)) ((V[he] = pe), (V[de] = Te), (de = he));
              else break e;
            }
          }
          function n(V) {
            return V.length === 0 ? null : V[0];
          }
          function i(V) {
            if (V.length === 0) return null;
            var pe = V[0],
              de = V.pop();
            if (de !== pe) {
              V[0] = de;
              e: for (var he = 0, Te = V.length, F = Te >>> 1; he < F; ) {
                var ae = 2 * (he + 1) - 1,
                  xe = V[ae],
                  Me = ae + 1,
                  le = V[Me];
                if (0 > a(xe, de))
                  Me < Te && 0 > a(le, xe)
                    ? ((V[he] = le), (V[Me] = de), (he = Me))
                    : ((V[he] = xe), (V[ae] = de), (he = ae));
                else if (Me < Te && 0 > a(le, de))
                  ((V[he] = le), (V[Me] = de), (he = Me));
                else break e;
              }
            }
            return pe;
          }
          function a(V, pe) {
            var de = V.sortIndex - pe.sortIndex;
            return de !== 0 ? de : V.id - pe.id;
          }
          if (
            ((t.unstable_now = void 0),
            typeof performance == "object" &&
              typeof performance.now == "function")
          ) {
            var l = performance;
            t.unstable_now = function () {
              return l.now();
            };
          } else {
            var u = Date,
              d = u.now();
            t.unstable_now = function () {
              return u.now() - d;
            };
          }
          var m = [],
            g = [],
            v = 1,
            y = null,
            w = 3,
            S = !1,
            T = !1,
            E = !1,
            j = !1,
            O = typeof setTimeout == "function" ? setTimeout : null,
            M = typeof clearTimeout == "function" ? clearTimeout : null,
            N = typeof setImmediate < "u" ? setImmediate : null;
          function R(V) {
            for (var pe = n(g); pe !== null; ) {
              if (pe.callback === null) i(g);
              else if (pe.startTime <= V)
                (i(g), (pe.sortIndex = pe.expirationTime), e(m, pe));
              else break;
              pe = n(g);
            }
          }
          function P(V) {
            if (((E = !1), R(V), !T))
              if (n(m) !== null) ((T = !0), G || ((G = !0), fe()));
              else {
                var pe = n(g);
                pe !== null && Oe(P, pe.startTime - V);
              }
          }
          var G = !1,
            Y = -1,
            B = 5,
            I = -1;
          function H() {
            return j ? !0 : !(t.unstable_now() - I < B);
          }
          function X() {
            if (((j = !1), G)) {
              var V = t.unstable_now();
              I = V;
              var pe = !0;
              try {
                e: {
                  ((T = !1), E && ((E = !1), M(Y), (Y = -1)), (S = !0));
                  var de = w;
                  try {
                    t: {
                      for (
                        R(V), y = n(m);
                        y !== null && !(y.expirationTime > V && H());

                      ) {
                        var he = y.callback;
                        if (typeof he == "function") {
                          ((y.callback = null), (w = y.priorityLevel));
                          var Te = he(y.expirationTime <= V);
                          if (
                            ((V = t.unstable_now()), typeof Te == "function")
                          ) {
                            ((y.callback = Te), R(V), (pe = !0));
                            break t;
                          }
                          (y === n(m) && i(m), R(V));
                        } else i(m);
                        y = n(m);
                      }
                      if (y !== null) pe = !0;
                      else {
                        var F = n(g);
                        (F !== null && Oe(P, F.startTime - V), (pe = !1));
                      }
                    }
                    break e;
                  } finally {
                    ((y = null), (w = de), (S = !1));
                  }
                  pe = void 0;
                }
              } finally {
                pe ? fe() : (G = !1);
              }
            }
          }
          var fe;
          if (typeof N == "function")
            fe = function () {
              N(X);
            };
          else if (typeof MessageChannel < "u") {
            var ve = new MessageChannel(),
              be = ve.port2;
            ((ve.port1.onmessage = X),
              (fe = function () {
                be.postMessage(null);
              }));
          } else
            fe = function () {
              O(X, 0);
            };
          function Oe(V, pe) {
            Y = O(function () {
              V(t.unstable_now());
            }, pe);
          }
          ((t.unstable_IdlePriority = 5),
            (t.unstable_ImmediatePriority = 1),
            (t.unstable_LowPriority = 4),
            (t.unstable_NormalPriority = 3),
            (t.unstable_Profiling = null),
            (t.unstable_UserBlockingPriority = 2),
            (t.unstable_cancelCallback = function (V) {
              V.callback = null;
            }),
            (t.unstable_forceFrameRate = function (V) {
              0 > V || 125 < V
                ? console.error(
                    "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                  )
                : (B = 0 < V ? Math.floor(1e3 / V) : 5);
            }),
            (t.unstable_getCurrentPriorityLevel = function () {
              return w;
            }),
            (t.unstable_next = function (V) {
              switch (w) {
                case 1:
                case 2:
                case 3:
                  var pe = 3;
                  break;
                default:
                  pe = w;
              }
              var de = w;
              w = pe;
              try {
                return V();
              } finally {
                w = de;
              }
            }),
            (t.unstable_requestPaint = function () {
              j = !0;
            }),
            (t.unstable_runWithPriority = function (V, pe) {
              switch (V) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                  break;
                default:
                  V = 3;
              }
              var de = w;
              w = V;
              try {
                return pe();
              } finally {
                w = de;
              }
            }),
            (t.unstable_scheduleCallback = function (V, pe, de) {
              var he = t.unstable_now();
              switch (
                (typeof de == "object" && de !== null
                  ? ((de = de.delay),
                    (de = typeof de == "number" && 0 < de ? he + de : he))
                  : (de = he),
                V)
              ) {
                case 1:
                  var Te = -1;
                  break;
                case 2:
                  Te = 250;
                  break;
                case 5:
                  Te = 1073741823;
                  break;
                case 4:
                  Te = 1e4;
                  break;
                default:
                  Te = 5e3;
              }
              return (
                (Te = de + Te),
                (V = {
                  id: v++,
                  callback: pe,
                  priorityLevel: V,
                  startTime: de,
                  expirationTime: Te,
                  sortIndex: -1,
                }),
                de > he
                  ? ((V.sortIndex = de),
                    e(g, V),
                    n(m) === null &&
                      V === n(g) &&
                      (E ? (M(Y), (Y = -1)) : (E = !0), Oe(P, de - he)))
                  : ((V.sortIndex = Te),
                    e(m, V),
                    T || S || ((T = !0), G || ((G = !0), fe()))),
                V
              );
            }),
            (t.unstable_shouldYield = H),
            (t.unstable_wrapCallback = function (V) {
              var pe = w;
              return function () {
                var de = w;
                w = pe;
                try {
                  return V.apply(this, arguments);
                } finally {
                  w = de;
                }
              };
            }));
        })(fx)),
      fx
    );
  }
  var mS;
  function lj() {
    return (mS || ((mS = 1), (ux.exports = aj())), ux.exports);
  }
  var dx = { exports: {} },
    at = {};
  /**
   * @license React
   * react.production.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var gS;
  function oj() {
    if (gS) return at;
    gS = 1;
    var t = Symbol.for("react.transitional.element"),
      e = Symbol.for("react.portal"),
      n = Symbol.for("react.fragment"),
      i = Symbol.for("react.strict_mode"),
      a = Symbol.for("react.profiler"),
      l = Symbol.for("react.consumer"),
      u = Symbol.for("react.context"),
      d = Symbol.for("react.forward_ref"),
      m = Symbol.for("react.suspense"),
      g = Symbol.for("react.memo"),
      v = Symbol.for("react.lazy"),
      y = Symbol.for("react.activity"),
      w = Symbol.iterator;
    function S(F) {
      return F === null || typeof F != "object"
        ? null
        : ((F = (w && F[w]) || F["@@iterator"]),
          typeof F == "function" ? F : null);
    }
    var T = {
        isMounted: function () {
          return !1;
        },
        enqueueForceUpdate: function () {},
        enqueueReplaceState: function () {},
        enqueueSetState: function () {},
      },
      E = Object.assign,
      j = {};
    function O(F, ae, xe) {
      ((this.props = F),
        (this.context = ae),
        (this.refs = j),
        (this.updater = xe || T));
    }
    ((O.prototype.isReactComponent = {}),
      (O.prototype.setState = function (F, ae) {
        if (typeof F != "object" && typeof F != "function" && F != null)
          throw Error(
            "takes an object of state variables to update or a function which returns an object of state variables.",
          );
        this.updater.enqueueSetState(this, F, ae, "setState");
      }),
      (O.prototype.forceUpdate = function (F) {
        this.updater.enqueueForceUpdate(this, F, "forceUpdate");
      }));
    function M() {}
    M.prototype = O.prototype;
    function N(F, ae, xe) {
      ((this.props = F),
        (this.context = ae),
        (this.refs = j),
        (this.updater = xe || T));
    }
    var R = (N.prototype = new M());
    ((R.constructor = N), E(R, O.prototype), (R.isPureReactComponent = !0));
    var P = Array.isArray;
    function G() {}
    var Y = { H: null, A: null, T: null, S: null },
      B = Object.prototype.hasOwnProperty;
    function I(F, ae, xe) {
      var Me = xe.ref;
      return {
        $$typeof: t,
        type: F,
        key: ae,
        ref: Me !== void 0 ? Me : null,
        props: xe,
      };
    }
    function H(F, ae) {
      return I(F.type, ae, F.props);
    }
    function X(F) {
      return typeof F == "object" && F !== null && F.$$typeof === t;
    }
    function fe(F) {
      var ae = { "=": "=0", ":": "=2" };
      return (
        "$" +
        F.replace(/[=:]/g, function (xe) {
          return ae[xe];
        })
      );
    }
    var ve = /\/+/g;
    function be(F, ae) {
      return typeof F == "object" && F !== null && F.key != null
        ? fe("" + F.key)
        : ae.toString(36);
    }
    function Oe(F) {
      switch (F.status) {
        case "fulfilled":
          return F.value;
        case "rejected":
          throw F.reason;
        default:
          switch (
            (typeof F.status == "string"
              ? F.then(G, G)
              : ((F.status = "pending"),
                F.then(
                  function (ae) {
                    F.status === "pending" &&
                      ((F.status = "fulfilled"), (F.value = ae));
                  },
                  function (ae) {
                    F.status === "pending" &&
                      ((F.status = "rejected"), (F.reason = ae));
                  },
                )),
            F.status)
          ) {
            case "fulfilled":
              return F.value;
            case "rejected":
              throw F.reason;
          }
      }
      throw F;
    }
    function V(F, ae, xe, Me, le) {
      var Re = typeof F;
      (Re === "undefined" || Re === "boolean") && (F = null);
      var Je = !1;
      if (F === null) Je = !0;
      else
        switch (Re) {
          case "bigint":
          case "string":
          case "number":
            Je = !0;
            break;
          case "object":
            switch (F.$$typeof) {
              case t:
              case e:
                Je = !0;
                break;
              case v:
                return ((Je = F._init), V(Je(F._payload), ae, xe, Me, le));
            }
        }
      if (Je)
        return (
          (le = le(F)),
          (Je = Me === "" ? "." + be(F, 0) : Me),
          P(le)
            ? ((xe = ""),
              Je != null && (xe = Je.replace(ve, "$&/") + "/"),
              V(le, ae, xe, "", function (di) {
                return di;
              }))
            : le != null &&
              (X(le) &&
                (le = H(
                  le,
                  xe +
                    (le.key == null || (F && F.key === le.key)
                      ? ""
                      : ("" + le.key).replace(ve, "$&/") + "/") +
                    Je,
                )),
              ae.push(le)),
          1
        );
      Je = 0;
      var ut = Me === "" ? "." : Me + ":";
      if (P(F))
        for (var ot = 0; ot < F.length; ot++)
          ((Me = F[ot]), (Re = ut + be(Me, ot)), (Je += V(Me, ae, xe, Re, le)));
      else if (((ot = S(F)), typeof ot == "function"))
        for (F = ot.call(F), ot = 0; !(Me = F.next()).done; )
          ((Me = Me.value),
            (Re = ut + be(Me, ot++)),
            (Je += V(Me, ae, xe, Re, le)));
      else if (Re === "object") {
        if (typeof F.then == "function") return V(Oe(F), ae, xe, Me, le);
        throw (
          (ae = String(F)),
          Error(
            "Objects are not valid as a React child (found: " +
              (ae === "[object Object]"
                ? "object with keys {" + Object.keys(F).join(", ") + "}"
                : ae) +
              "). If you meant to render a collection of children, use an array instead.",
          )
        );
      }
      return Je;
    }
    function pe(F, ae, xe) {
      if (F == null) return F;
      var Me = [],
        le = 0;
      return (
        V(F, Me, "", "", function (Re) {
          return ae.call(xe, Re, le++);
        }),
        Me
      );
    }
    function de(F) {
      if (F._status === -1) {
        var ae = F._result;
        ((ae = ae()),
          ae.then(
            function (xe) {
              (F._status === 0 || F._status === -1) &&
                ((F._status = 1), (F._result = xe));
            },
            function (xe) {
              (F._status === 0 || F._status === -1) &&
                ((F._status = 2), (F._result = xe));
            },
          ),
          F._status === -1 && ((F._status = 0), (F._result = ae)));
      }
      if (F._status === 1) return F._result.default;
      throw F._result;
    }
    var he =
        typeof reportError == "function"
          ? reportError
          : function (F) {
              if (
                typeof window == "object" &&
                typeof window.ErrorEvent == "function"
              ) {
                var ae = new window.ErrorEvent("error", {
                  bubbles: !0,
                  cancelable: !0,
                  message:
                    typeof F == "object" &&
                    F !== null &&
                    typeof F.message == "string"
                      ? String(F.message)
                      : String(F),
                  error: F,
                });
                if (!window.dispatchEvent(ae)) return;
              } else if (
                typeof process == "object" &&
                typeof process.emit == "function"
              ) {
                process.emit("uncaughtException", F);
                return;
              }
              console.error(F);
            },
      Te = {
        map: pe,
        forEach: function (F, ae, xe) {
          pe(
            F,
            function () {
              ae.apply(this, arguments);
            },
            xe,
          );
        },
        count: function (F) {
          var ae = 0;
          return (
            pe(F, function () {
              ae++;
            }),
            ae
          );
        },
        toArray: function (F) {
          return (
            pe(F, function (ae) {
              return ae;
            }) || []
          );
        },
        only: function (F) {
          if (!X(F))
            throw Error(
              "React.Children.only expected to receive a single React element child.",
            );
          return F;
        },
      };
    return (
      (at.Activity = y),
      (at.Children = Te),
      (at.Component = O),
      (at.Fragment = n),
      (at.Profiler = a),
      (at.PureComponent = N),
      (at.StrictMode = i),
      (at.Suspense = m),
      (at.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Y),
      (at.__COMPILER_RUNTIME = {
        __proto__: null,
        c: function (F) {
          return Y.H.useMemoCache(F);
        },
      }),
      (at.cache = function (F) {
        return function () {
          return F.apply(null, arguments);
        };
      }),
      (at.cacheSignal = function () {
        return null;
      }),
      (at.cloneElement = function (F, ae, xe) {
        if (F == null)
          throw Error(
            "The argument must be a React element, but you passed " + F + ".",
          );
        var Me = E({}, F.props),
          le = F.key;
        if (ae != null)
          for (Re in (ae.key !== void 0 && (le = "" + ae.key), ae))
            !B.call(ae, Re) ||
              Re === "key" ||
              Re === "__self" ||
              Re === "__source" ||
              (Re === "ref" && ae.ref === void 0) ||
              (Me[Re] = ae[Re]);
        var Re = arguments.length - 2;
        if (Re === 1) Me.children = xe;
        else if (1 < Re) {
          for (var Je = Array(Re), ut = 0; ut < Re; ut++)
            Je[ut] = arguments[ut + 2];
          Me.children = Je;
        }
        return I(F.type, le, Me);
      }),
      (at.createContext = function (F) {
        return (
          (F = {
            $$typeof: u,
            _currentValue: F,
            _currentValue2: F,
            _threadCount: 0,
            Provider: null,
            Consumer: null,
          }),
          (F.Provider = F),
          (F.Consumer = { $$typeof: l, _context: F }),
          F
        );
      }),
      (at.createElement = function (F, ae, xe) {
        var Me,
          le = {},
          Re = null;
        if (ae != null)
          for (Me in (ae.key !== void 0 && (Re = "" + ae.key), ae))
            B.call(ae, Me) &&
              Me !== "key" &&
              Me !== "__self" &&
              Me !== "__source" &&
              (le[Me] = ae[Me]);
        var Je = arguments.length - 2;
        if (Je === 1) le.children = xe;
        else if (1 < Je) {
          for (var ut = Array(Je), ot = 0; ot < Je; ot++)
            ut[ot] = arguments[ot + 2];
          le.children = ut;
        }
        if (F && F.defaultProps)
          for (Me in ((Je = F.defaultProps), Je))
            le[Me] === void 0 && (le[Me] = Je[Me]);
        return I(F, Re, le);
      }),
      (at.createRef = function () {
        return { current: null };
      }),
      (at.forwardRef = function (F) {
        return { $$typeof: d, render: F };
      }),
      (at.isValidElement = X),
      (at.lazy = function (F) {
        return {
          $$typeof: v,
          _payload: { _status: -1, _result: F },
          _init: de,
        };
      }),
      (at.memo = function (F, ae) {
        return { $$typeof: g, type: F, compare: ae === void 0 ? null : ae };
      }),
      (at.startTransition = function (F) {
        var ae = Y.T,
          xe = {};
        Y.T = xe;
        try {
          var Me = F(),
            le = Y.S;
          (le !== null && le(xe, Me),
            typeof Me == "object" &&
              Me !== null &&
              typeof Me.then == "function" &&
              Me.then(G, he));
        } catch (Re) {
          he(Re);
        } finally {
          (ae !== null && xe.types !== null && (ae.types = xe.types),
            (Y.T = ae));
        }
      }),
      (at.unstable_useCacheRefresh = function () {
        return Y.H.useCacheRefresh();
      }),
      (at.use = function (F) {
        return Y.H.use(F);
      }),
      (at.useActionState = function (F, ae, xe) {
        return Y.H.useActionState(F, ae, xe);
      }),
      (at.useCallback = function (F, ae) {
        return Y.H.useCallback(F, ae);
      }),
      (at.useContext = function (F) {
        return Y.H.useContext(F);
      }),
      (at.useDebugValue = function () {}),
      (at.useDeferredValue = function (F, ae) {
        return Y.H.useDeferredValue(F, ae);
      }),
      (at.useEffect = function (F, ae) {
        return Y.H.useEffect(F, ae);
      }),
      (at.useEffectEvent = function (F) {
        return Y.H.useEffectEvent(F);
      }),
      (at.useId = function () {
        return Y.H.useId();
      }),
      (at.useImperativeHandle = function (F, ae, xe) {
        return Y.H.useImperativeHandle(F, ae, xe);
      }),
      (at.useInsertionEffect = function (F, ae) {
        return Y.H.useInsertionEffect(F, ae);
      }),
      (at.useLayoutEffect = function (F, ae) {
        return Y.H.useLayoutEffect(F, ae);
      }),
      (at.useMemo = function (F, ae) {
        return Y.H.useMemo(F, ae);
      }),
      (at.useOptimistic = function (F, ae) {
        return Y.H.useOptimistic(F, ae);
      }),
      (at.useReducer = function (F, ae, xe) {
        return Y.H.useReducer(F, ae, xe);
      }),
      (at.useRef = function (F) {
        return Y.H.useRef(F);
      }),
      (at.useState = function (F) {
        return Y.H.useState(F);
      }),
      (at.useSyncExternalStore = function (F, ae, xe) {
        return Y.H.useSyncExternalStore(F, ae, xe);
      }),
      (at.useTransition = function () {
        return Y.H.useTransition();
      }),
      (at.version = "19.2.3"),
      at
    );
  }
  var vS;
  function qg() {
    return (vS || ((vS = 1), (dx.exports = oj())), dx.exports);
  }
  var hx = { exports: {} },
    ki = {};
  /**
   * @license React
   * react-dom.production.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var yS;
  function cj() {
    if (yS) return ki;
    yS = 1;
    var t = qg();
    function e(m) {
      var g = "https://react.dev/errors/" + m;
      if (1 < arguments.length) {
        g += "?args[]=" + encodeURIComponent(arguments[1]);
        for (var v = 2; v < arguments.length; v++)
          g += "&args[]=" + encodeURIComponent(arguments[v]);
      }
      return (
        "Minified React error #" +
        m +
        "; visit " +
        g +
        " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
      );
    }
    function n() {}
    var i = {
        d: {
          f: n,
          r: function () {
            throw Error(e(522));
          },
          D: n,
          C: n,
          L: n,
          m: n,
          X: n,
          S: n,
          M: n,
        },
        p: 0,
        findDOMNode: null,
      },
      a = Symbol.for("react.portal");
    function l(m, g, v) {
      var y =
        3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      return {
        $$typeof: a,
        key: y == null ? null : "" + y,
        children: m,
        containerInfo: g,
        implementation: v,
      };
    }
    var u = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    function d(m, g) {
      if (m === "font") return "";
      if (typeof g == "string") return g === "use-credentials" ? g : "";
    }
    return (
      (ki.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i),
      (ki.createPortal = function (m, g) {
        var v =
          2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
        if (!g || (g.nodeType !== 1 && g.nodeType !== 9 && g.nodeType !== 11))
          throw Error(e(299));
        return l(m, g, null, v);
      }),
      (ki.flushSync = function (m) {
        var g = u.T,
          v = i.p;
        try {
          if (((u.T = null), (i.p = 2), m)) return m();
        } finally {
          ((u.T = g), (i.p = v), i.d.f());
        }
      }),
      (ki.preconnect = function (m, g) {
        typeof m == "string" &&
          (g
            ? ((g = g.crossOrigin),
              (g =
                typeof g == "string"
                  ? g === "use-credentials"
                    ? g
                    : ""
                  : void 0))
            : (g = null),
          i.d.C(m, g));
      }),
      (ki.prefetchDNS = function (m) {
        typeof m == "string" && i.d.D(m);
      }),
      (ki.preinit = function (m, g) {
        if (typeof m == "string" && g && typeof g.as == "string") {
          var v = g.as,
            y = d(v, g.crossOrigin),
            w = typeof g.integrity == "string" ? g.integrity : void 0,
            S = typeof g.fetchPriority == "string" ? g.fetchPriority : void 0;
          v === "style"
            ? i.d.S(
                m,
                typeof g.precedence == "string" ? g.precedence : void 0,
                { crossOrigin: y, integrity: w, fetchPriority: S },
              )
            : v === "script" &&
              i.d.X(m, {
                crossOrigin: y,
                integrity: w,
                fetchPriority: S,
                nonce: typeof g.nonce == "string" ? g.nonce : void 0,
              });
        }
      }),
      (ki.preinitModule = function (m, g) {
        if (typeof m == "string")
          if (typeof g == "object" && g !== null) {
            if (g.as == null || g.as === "script") {
              var v = d(g.as, g.crossOrigin);
              i.d.M(m, {
                crossOrigin: v,
                integrity:
                  typeof g.integrity == "string" ? g.integrity : void 0,
                nonce: typeof g.nonce == "string" ? g.nonce : void 0,
              });
            }
          } else g == null && i.d.M(m);
      }),
      (ki.preload = function (m, g) {
        if (
          typeof m == "string" &&
          typeof g == "object" &&
          g !== null &&
          typeof g.as == "string"
        ) {
          var v = g.as,
            y = d(v, g.crossOrigin);
          i.d.L(m, v, {
            crossOrigin: y,
            integrity: typeof g.integrity == "string" ? g.integrity : void 0,
            nonce: typeof g.nonce == "string" ? g.nonce : void 0,
            type: typeof g.type == "string" ? g.type : void 0,
            fetchPriority:
              typeof g.fetchPriority == "string" ? g.fetchPriority : void 0,
            referrerPolicy:
              typeof g.referrerPolicy == "string" ? g.referrerPolicy : void 0,
            imageSrcSet:
              typeof g.imageSrcSet == "string" ? g.imageSrcSet : void 0,
            imageSizes: typeof g.imageSizes == "string" ? g.imageSizes : void 0,
            media: typeof g.media == "string" ? g.media : void 0,
          });
        }
      }),
      (ki.preloadModule = function (m, g) {
        if (typeof m == "string")
          if (g) {
            var v = d(g.as, g.crossOrigin);
            i.d.m(m, {
              as: typeof g.as == "string" && g.as !== "script" ? g.as : void 0,
              crossOrigin: v,
              integrity: typeof g.integrity == "string" ? g.integrity : void 0,
            });
          } else i.d.m(m);
      }),
      (ki.requestFormReset = function (m) {
        i.d.r(m);
      }),
      (ki.unstable_batchedUpdates = function (m, g) {
        return m(g);
      }),
      (ki.useFormState = function (m, g, v) {
        return u.H.useFormState(m, g, v);
      }),
      (ki.useFormStatus = function () {
        return u.H.useHostTransitionStatus();
      }),
      (ki.version = "19.2.3"),
      ki
    );
  }
  var bS;
  function uj() {
    if (bS) return hx.exports;
    bS = 1;
    function t() {
      if (
        !(
          typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
          typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
        )
      )
        try {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
        } catch (e) {
          console.error(e);
        }
    }
    return (t(), (hx.exports = cj()), hx.exports);
  }
  /**
   * @license React
   * react-dom-client.production.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var xS;
  function fj() {
    if (xS) return ng;
    xS = 1;
    var t = lj(),
      e = qg(),
      n = uj();
    function i(s) {
      var r = "https://react.dev/errors/" + s;
      if (1 < arguments.length) {
        r += "?args[]=" + encodeURIComponent(arguments[1]);
        for (var o = 2; o < arguments.length; o++)
          r += "&args[]=" + encodeURIComponent(arguments[o]);
      }
      return (
        "Minified React error #" +
        s +
        "; visit " +
        r +
        " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
      );
    }
    function a(s) {
      return !(
        !s ||
        (s.nodeType !== 1 && s.nodeType !== 9 && s.nodeType !== 11)
      );
    }
    function l(s) {
      var r = s,
        o = s;
      if (s.alternate) for (; r.return; ) r = r.return;
      else {
        s = r;
        do ((r = s), (r.flags & 4098) !== 0 && (o = r.return), (s = r.return));
        while (s);
      }
      return r.tag === 3 ? o : null;
    }
    function u(s) {
      if (s.tag === 13) {
        var r = s.memoizedState;
        if (
          (r === null &&
            ((s = s.alternate), s !== null && (r = s.memoizedState)),
          r !== null)
        )
          return r.dehydrated;
      }
      return null;
    }
    function d(s) {
      if (s.tag === 31) {
        var r = s.memoizedState;
        if (
          (r === null &&
            ((s = s.alternate), s !== null && (r = s.memoizedState)),
          r !== null)
        )
          return r.dehydrated;
      }
      return null;
    }
    function m(s) {
      if (l(s) !== s) throw Error(i(188));
    }
    function g(s) {
      var r = s.alternate;
      if (!r) {
        if (((r = l(s)), r === null)) throw Error(i(188));
        return r !== s ? null : s;
      }
      for (var o = s, f = r; ; ) {
        var b = o.return;
        if (b === null) break;
        var _ = b.alternate;
        if (_ === null) {
          if (((f = b.return), f !== null)) {
            o = f;
            continue;
          }
          break;
        }
        if (b.child === _.child) {
          for (_ = b.child; _; ) {
            if (_ === o) return (m(b), s);
            if (_ === f) return (m(b), r);
            _ = _.sibling;
          }
          throw Error(i(188));
        }
        if (o.return !== f.return) ((o = b), (f = _));
        else {
          for (var A = !1, D = b.child; D; ) {
            if (D === o) {
              ((A = !0), (o = b), (f = _));
              break;
            }
            if (D === f) {
              ((A = !0), (f = b), (o = _));
              break;
            }
            D = D.sibling;
          }
          if (!A) {
            for (D = _.child; D; ) {
              if (D === o) {
                ((A = !0), (o = _), (f = b));
                break;
              }
              if (D === f) {
                ((A = !0), (f = _), (o = b));
                break;
              }
              D = D.sibling;
            }
            if (!A) throw Error(i(189));
          }
        }
        if (o.alternate !== f) throw Error(i(190));
      }
      if (o.tag !== 3) throw Error(i(188));
      return o.stateNode.current === o ? s : r;
    }
    function v(s) {
      var r = s.tag;
      if (r === 5 || r === 26 || r === 27 || r === 6) return s;
      for (s = s.child; s !== null; ) {
        if (((r = v(s)), r !== null)) return r;
        s = s.sibling;
      }
      return null;
    }
    var y = Object.assign,
      w = Symbol.for("react.element"),
      S = Symbol.for("react.transitional.element"),
      T = Symbol.for("react.portal"),
      E = Symbol.for("react.fragment"),
      j = Symbol.for("react.strict_mode"),
      O = Symbol.for("react.profiler"),
      M = Symbol.for("react.consumer"),
      N = Symbol.for("react.context"),
      R = Symbol.for("react.forward_ref"),
      P = Symbol.for("react.suspense"),
      G = Symbol.for("react.suspense_list"),
      Y = Symbol.for("react.memo"),
      B = Symbol.for("react.lazy"),
      I = Symbol.for("react.activity"),
      H = Symbol.for("react.memo_cache_sentinel"),
      X = Symbol.iterator;
    function fe(s) {
      return s === null || typeof s != "object"
        ? null
        : ((s = (X && s[X]) || s["@@iterator"]),
          typeof s == "function" ? s : null);
    }
    var ve = Symbol.for("react.client.reference");
    function be(s) {
      if (s == null) return null;
      if (typeof s == "function")
        return s.$$typeof === ve ? null : s.displayName || s.name || null;
      if (typeof s == "string") return s;
      switch (s) {
        case E:
          return "Fragment";
        case O:
          return "Profiler";
        case j:
          return "StrictMode";
        case P:
          return "Suspense";
        case G:
          return "SuspenseList";
        case I:
          return "Activity";
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case T:
            return "Portal";
          case N:
            return s.displayName || "Context";
          case M:
            return (s._context.displayName || "Context") + ".Consumer";
          case R:
            var r = s.render;
            return (
              (s = s.displayName),
              s ||
                ((s = r.displayName || r.name || ""),
                (s = s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef")),
              s
            );
          case Y:
            return (
              (r = s.displayName || null),
              r !== null ? r : be(s.type) || "Memo"
            );
          case B:
            ((r = s._payload), (s = s._init));
            try {
              return be(s(r));
            } catch {}
        }
      return null;
    }
    var Oe = Array.isArray,
      V = e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
      pe = n.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
      de = { pending: !1, data: null, method: null, action: null },
      he = [],
      Te = -1;
    function F(s) {
      return { current: s };
    }
    function ae(s) {
      0 > Te || ((s.current = he[Te]), (he[Te] = null), Te--);
    }
    function xe(s, r) {
      (Te++, (he[Te] = s.current), (s.current = r));
    }
    var Me = F(null),
      le = F(null),
      Re = F(null),
      Je = F(null);
    function ut(s, r) {
      switch ((xe(Re, r), xe(le, s), xe(Me, null), r.nodeType)) {
        case 9:
        case 11:
          s = (s = r.documentElement) && (s = s.namespaceURI) ? nf(s) : 0;
          break;
        default:
          if (((s = r.tagName), (r = r.namespaceURI)))
            ((r = nf(r)), (s = Li(r, s)));
          else
            switch (s) {
              case "svg":
                s = 1;
                break;
              case "math":
                s = 2;
                break;
              default:
                s = 0;
            }
      }
      (ae(Me), xe(Me, s));
    }
    function ot() {
      (ae(Me), ae(le), ae(Re));
    }
    function di(s) {
      s.memoizedState !== null && xe(Je, s);
      var r = Me.current,
        o = Li(r, s.type);
      r !== o && (xe(le, s), xe(Me, o));
    }
    function ri(s) {
      (le.current === s && (ae(Me), ae(le)),
        Je.current === s && (ae(Je), (yc._currentValue = de)));
    }
    var Bi, Cn;
    function Gt(s) {
      if (Bi === void 0)
        try {
          throw Error();
        } catch (o) {
          var r = o.stack.trim().match(/\n( *(at )?)/);
          ((Bi = (r && r[1]) || ""),
            (Cn =
              -1 <
              o.stack.indexOf(`
    at`)
                ? " (<anonymous>)"
                : -1 < o.stack.indexOf("@")
                  ? "@unknown:0:0"
                  : ""));
        }
      return (
        `
` +
        Bi +
        s +
        Cn
      );
    }
    var An = !1;
    function bl(s, r) {
      if (!s || An) return "";
      An = !0;
      var o = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        var f = {
          DetermineComponentFrameRoot: function () {
            try {
              if (r) {
                var _e = function () {
                  throw Error();
                };
                if (
                  (Object.defineProperty(_e.prototype, "props", {
                    set: function () {
                      throw Error();
                    },
                  }),
                  typeof Reflect == "object" && Reflect.construct)
                ) {
                  try {
                    Reflect.construct(_e, []);
                  } catch (ue) {
                    var re = ue;
                  }
                  Reflect.construct(s, [], _e);
                } else {
                  try {
                    _e.call();
                  } catch (ue) {
                    re = ue;
                  }
                  s.call(_e.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (ue) {
                  re = ue;
                }
                (_e = s()) &&
                  typeof _e.catch == "function" &&
                  _e.catch(function () {});
              }
            } catch (ue) {
              if (ue && re && typeof ue.stack == "string")
                return [ue.stack, re.stack];
            }
            return [null, null];
          },
        };
        f.DetermineComponentFrameRoot.displayName =
          "DetermineComponentFrameRoot";
        var b = Object.getOwnPropertyDescriptor(
          f.DetermineComponentFrameRoot,
          "name",
        );
        b &&
          b.configurable &&
          Object.defineProperty(f.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot",
          });
        var _ = f.DetermineComponentFrameRoot(),
          A = _[0],
          D = _[1];
        if (A && D) {
          var $ = A.split(`
`),
            se = D.split(`
`);
          for (
            b = f = 0;
            f < $.length && !$[f].includes("DetermineComponentFrameRoot");

          )
            f++;
          for (
            ;
            b < se.length && !se[b].includes("DetermineComponentFrameRoot");

          )
            b++;
          if (f === $.length || b === se.length)
            for (
              f = $.length - 1, b = se.length - 1;
              1 <= f && 0 <= b && $[f] !== se[b];

            )
              b--;
          for (; 1 <= f && 0 <= b; f--, b--)
            if ($[f] !== se[b]) {
              if (f !== 1 || b !== 1)
                do
                  if ((f--, b--, 0 > b || $[f] !== se[b])) {
                    var ge =
                      `
` + $[f].replace(" at new ", " at ");
                    return (
                      s.displayName &&
                        ge.includes("<anonymous>") &&
                        (ge = ge.replace("<anonymous>", s.displayName)),
                      ge
                    );
                  }
                while (1 <= f && 0 <= b);
              break;
            }
        }
      } finally {
        ((An = !1), (Error.prepareStackTrace = o));
      }
      return (o = s ? s.displayName || s.name : "") ? Gt(o) : "";
    }
    function Hi(s, r) {
      switch (s.tag) {
        case 26:
        case 27:
        case 5:
          return Gt(s.type);
        case 16:
          return Gt("Lazy");
        case 13:
          return s.child !== r && r !== null
            ? Gt("Suspense Fallback")
            : Gt("Suspense");
        case 19:
          return Gt("SuspenseList");
        case 0:
        case 15:
          return bl(s.type, !1);
        case 11:
          return bl(s.type.render, !1);
        case 1:
          return bl(s.type, !0);
        case 31:
          return Gt("Activity");
        default:
          return "";
      }
    }
    function vr(s) {
      try {
        var r = "",
          o = null;
        do ((r += Hi(s, o)), (o = s), (s = s.return));
        while (s);
        return r;
      } catch (f) {
        return (
          `
Error generating stack: ` +
          f.message +
          `
` +
          f.stack
        );
      }
    }
    var Ca = Object.prototype.hasOwnProperty,
      xs = t.unstable_scheduleCallback,
      ai = t.unstable_cancelCallback,
      Oa = t.unstable_shouldYield,
      wo = t.unstable_requestPaint,
      Xn = t.unstable_now,
      Gs = t.unstable_getCurrentPriorityLevel,
      Br = t.unstable_ImmediatePriority,
      Qn = t.unstable_UserBlockingPriority,
      Yi = t.unstable_NormalPriority,
      So = t.unstable_LowPriority,
      xl = t.unstable_IdlePriority,
      _l = t.log,
      To = t.unstable_setDisableYieldValue,
      _s = null,
      Rn = null;
    function Ln(s) {
      if (
        (typeof _l == "function" && To(s),
        Rn && typeof Rn.setStrictMode == "function")
      )
        try {
          Rn.setStrictMode(_s, s);
        } catch {}
    }
    var bn = Math.clz32 ? Math.clz32 : lp,
      wl = Math.log,
      Hc = Math.LN2;
    function lp(s) {
      return ((s >>>= 0), s === 0 ? 32 : (31 - ((wl(s) / Hc) | 0)) | 0);
    }
    var Hr = 256,
      yr = 262144,
      Sl = 4194304;
    function qi(s) {
      var r = s & 42;
      if (r !== 0) return r;
      switch (s & -s) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
          return s & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return s & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return s & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return s;
      }
    }
    function Eo(s, r, o) {
      var f = s.pendingLanes;
      if (f === 0) return 0;
      var b = 0,
        _ = s.suspendedLanes,
        A = s.pingedLanes;
      s = s.warmLanes;
      var D = f & 134217727;
      return (
        D !== 0
          ? ((f = D & ~_),
            f !== 0
              ? (b = qi(f))
              : ((A &= D),
                A !== 0
                  ? (b = qi(A))
                  : o || ((o = D & ~s), o !== 0 && (b = qi(o)))))
          : ((D = f & ~_),
            D !== 0
              ? (b = qi(D))
              : A !== 0
                ? (b = qi(A))
                : o || ((o = f & ~s), o !== 0 && (b = qi(o)))),
        b === 0
          ? 0
          : r !== 0 &&
              r !== b &&
              (r & _) === 0 &&
              ((_ = b & -b),
              (o = r & -r),
              _ >= o || (_ === 32 && (o & 4194048) !== 0))
            ? r
            : b
      );
    }
    function Tl(s, r) {
      return (s.pendingLanes & ~(s.suspendedLanes & ~s.pingedLanes) & r) === 0;
    }
    function On(s, r) {
      switch (s) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return r + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return r + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return -1;
      }
    }
    function br() {
      var s = Sl;
      return ((Sl <<= 1), (Sl & 62914560) === 0 && (Sl = 4194304), s);
    }
    function Yc(s) {
      for (var r = [], o = 0; 31 > o; o++) r.push(s);
      return r;
    }
    function ja(s, r) {
      ((s.pendingLanes |= r),
        r !== 268435456 &&
          ((s.suspendedLanes = 0), (s.pingedLanes = 0), (s.warmLanes = 0)));
    }
    function qc(s, r, o, f, b, _) {
      var A = s.pendingLanes;
      ((s.pendingLanes = o),
        (s.suspendedLanes = 0),
        (s.pingedLanes = 0),
        (s.warmLanes = 0),
        (s.expiredLanes &= o),
        (s.entangledLanes &= o),
        (s.errorRecoveryDisabledLanes &= o),
        (s.shellSuspendCounter = 0));
      var D = s.entanglements,
        $ = s.expirationTimes,
        se = s.hiddenUpdates;
      for (o = A & ~o; 0 < o; ) {
        var ge = 31 - bn(o),
          _e = 1 << ge;
        ((D[ge] = 0), ($[ge] = -1));
        var re = se[ge];
        if (re !== null)
          for (se[ge] = null, ge = 0; ge < re.length; ge++) {
            var ue = re[ge];
            ue !== null && (ue.lane &= -536870913);
          }
        o &= ~_e;
      }
      (f !== 0 && El(s, f, 0),
        _ !== 0 &&
          b === 0 &&
          s.tag !== 0 &&
          (s.suspendedLanes |= _ & ~(A & ~r)));
    }
    function El(s, r, o) {
      ((s.pendingLanes |= r), (s.suspendedLanes &= ~r));
      var f = 31 - bn(r);
      ((s.entangledLanes |= r),
        (s.entanglements[f] = s.entanglements[f] | 1073741824 | (o & 261930)));
    }
    function $c(s, r) {
      var o = (s.entangledLanes |= r);
      for (s = s.entanglements; o; ) {
        var f = 31 - bn(o),
          b = 1 << f;
        ((b & r) | (s[f] & r) && (s[f] |= r), (o &= ~b));
      }
    }
    function Co(s, r) {
      var o = r & -r;
      return (
        (o = (o & 42) !== 0 ? 1 : _i(o)),
        (o & (s.suspendedLanes | r)) !== 0 ? 0 : o
      );
    }
    function _i(s) {
      switch (s) {
        case 2:
          s = 1;
          break;
        case 8:
          s = 4;
          break;
        case 32:
          s = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          s = 128;
          break;
        case 268435456:
          s = 134217728;
          break;
        default:
          s = 0;
      }
      return s;
    }
    function Vs(s) {
      return (
        (s &= -s),
        2 < s ? (8 < s ? ((s & 134217727) !== 0 ? 32 : 268435456) : 8) : 2
      );
    }
    function Gc() {
      var s = pe.p;
      return s !== 0 ? s : ((s = window.event), s === void 0 ? 32 : f0(s.type));
    }
    function Vc(s, r) {
      var o = pe.p;
      try {
        return ((pe.p = s), r());
      } finally {
        pe.p = o;
      }
    }
    var ws = Math.random().toString(36).slice(2),
      Dn = "__reactFiber$" + ws,
      on = "__reactProps$" + ws,
      Yr = "__reactContainer$" + ws,
      Cl = "__reactEvents$" + ws,
      Uf = "__reactListeners$" + ws,
      Ff = "__reactHandles$" + ws,
      Bf = "__reactResources$" + ws,
      Fe = "__reactMarker$" + ws;
    function Z(s) {
      (delete s[Dn], delete s[on], delete s[Cl], delete s[Uf], delete s[Ff]);
    }
    function Ce(s) {
      var r = s[Dn];
      if (r) return r;
      for (var o = s.parentNode; o; ) {
        if ((r = o[Yr] || o[Dn])) {
          if (
            ((o = r.alternate),
            r.child !== null || (o !== null && o.child !== null))
          )
            for (s = Wy(s); s !== null; ) {
              if ((o = s[Dn])) return o;
              s = Wy(s);
            }
          return r;
        }
        ((s = o), (o = s.parentNode));
      }
      return null;
    }
    function Le(s) {
      if ((s = s[Dn] || s[Yr])) {
        var r = s.tag;
        if (
          r === 5 ||
          r === 6 ||
          r === 13 ||
          r === 31 ||
          r === 26 ||
          r === 27 ||
          r === 3
        )
          return s;
      }
      return null;
    }
    function zt(s) {
      var r = s.tag;
      if (r === 5 || r === 26 || r === 27 || r === 6) return s.stateNode;
      throw Error(i(33));
    }
    function nn(s) {
      var r = s[Bf];
      return (
        r ||
          (r = s[Bf] =
            { hoistableStyles: new Map(), hoistableScripts: new Map() }),
        r
      );
    }
    function ft(s) {
      s[Fe] = !0;
    }
    var Zn = new Set(),
      Ss = {};
    function hi(s, r) {
      (Ws(s, r), Ws(s + "Capture", r));
    }
    function Ws(s, r) {
      for (Ss[s] = r, s = 0; s < r.length; s++) Zn.add(r[s]);
    }
    var kn = RegExp(
        "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$",
      ),
      Wc = {},
      Xc = {};
    function s1(s) {
      return Ca.call(Xc, s)
        ? !0
        : Ca.call(Wc, s)
          ? !1
          : kn.test(s)
            ? (Xc[s] = !0)
            : ((Wc[s] = !0), !1);
    }
    function Hf(s, r, o) {
      if (s1(r))
        if (o === null) s.removeAttribute(r);
        else {
          switch (typeof o) {
            case "undefined":
            case "function":
            case "symbol":
              s.removeAttribute(r);
              return;
            case "boolean":
              var f = r.toLowerCase().slice(0, 5);
              if (f !== "data-" && f !== "aria-") {
                s.removeAttribute(r);
                return;
              }
          }
          s.setAttribute(r, "" + o);
        }
    }
    function Qc(s, r, o) {
      if (o === null) s.removeAttribute(r);
      else {
        switch (typeof o) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            s.removeAttribute(r);
            return;
        }
        s.setAttribute(r, "" + o);
      }
    }
    function xr(s, r, o, f) {
      if (f === null) s.removeAttribute(o);
      else {
        switch (typeof f) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            s.removeAttribute(o);
            return;
        }
        s.setAttributeNS(r, o, "" + f);
      }
    }
    function $i(s) {
      switch (typeof s) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return s;
        case "object":
          return s;
        default:
          return "";
      }
    }
    function Yf(s) {
      var r = s.type;
      return (
        (s = s.nodeName) &&
        s.toLowerCase() === "input" &&
        (r === "checkbox" || r === "radio")
      );
    }
    function r1(s, r, o) {
      var f = Object.getOwnPropertyDescriptor(s.constructor.prototype, r);
      if (
        !s.hasOwnProperty(r) &&
        typeof f < "u" &&
        typeof f.get == "function" &&
        typeof f.set == "function"
      ) {
        var b = f.get,
          _ = f.set;
        return (
          Object.defineProperty(s, r, {
            configurable: !0,
            get: function () {
              return b.call(this);
            },
            set: function (A) {
              ((o = "" + A), _.call(this, A));
            },
          }),
          Object.defineProperty(s, r, { enumerable: f.enumerable }),
          {
            getValue: function () {
              return o;
            },
            setValue: function (A) {
              o = "" + A;
            },
            stopTracking: function () {
              ((s._valueTracker = null), delete s[r]);
            },
          }
        );
      }
    }
    function qf(s) {
      if (!s._valueTracker) {
        var r = Yf(s) ? "checked" : "value";
        s._valueTracker = r1(s, r, "" + s[r]);
      }
    }
    function Zc(s) {
      if (!s) return !1;
      var r = s._valueTracker;
      if (!r) return !0;
      var o = r.getValue(),
        f = "";
      return (
        s && (f = Yf(s) ? (s.checked ? "true" : "false") : s.value),
        (s = f),
        s !== o ? (r.setValue(s), !0) : !1
      );
    }
    function Kc(s) {
      if (
        ((s = s || (typeof document < "u" ? document : void 0)), typeof s > "u")
      )
        return null;
      try {
        return s.activeElement || s.body;
      } catch {
        return s.body;
      }
    }
    var a1 = /[\n"\\]/g;
    function Gi(s) {
      return s.replace(a1, function (r) {
        return "\\" + r.charCodeAt(0).toString(16) + " ";
      });
    }
    function $f(s, r, o, f, b, _, A, D) {
      ((s.name = ""),
        A != null &&
        typeof A != "function" &&
        typeof A != "symbol" &&
        typeof A != "boolean"
          ? (s.type = A)
          : s.removeAttribute("type"),
        r != null
          ? A === "number"
            ? ((r === 0 && s.value === "") || s.value != r) &&
              (s.value = "" + $i(r))
            : s.value !== "" + $i(r) && (s.value = "" + $i(r))
          : (A !== "submit" && A !== "reset") || s.removeAttribute("value"),
        r != null
          ? op(s, A, $i(r))
          : o != null
            ? op(s, A, $i(o))
            : f != null && s.removeAttribute("value"),
        b == null && _ != null && (s.defaultChecked = !!_),
        b != null &&
          (s.checked = b && typeof b != "function" && typeof b != "symbol"),
        D != null &&
        typeof D != "function" &&
        typeof D != "symbol" &&
        typeof D != "boolean"
          ? (s.name = "" + $i(D))
          : s.removeAttribute("name"));
    }
    function Gf(s, r, o, f, b, _, A, D) {
      if (
        (_ != null &&
          typeof _ != "function" &&
          typeof _ != "symbol" &&
          typeof _ != "boolean" &&
          (s.type = _),
        r != null || o != null)
      ) {
        if (!((_ !== "submit" && _ !== "reset") || r != null)) {
          qf(s);
          return;
        }
        ((o = o != null ? "" + $i(o) : ""),
          (r = r != null ? "" + $i(r) : o),
          D || r === s.value || (s.value = r),
          (s.defaultValue = r));
      }
      ((f = f ?? b),
        (f = typeof f != "function" && typeof f != "symbol" && !!f),
        (s.checked = D ? s.checked : !!f),
        (s.defaultChecked = !!f),
        A != null &&
          typeof A != "function" &&
          typeof A != "symbol" &&
          typeof A != "boolean" &&
          (s.name = A),
        qf(s));
    }
    function op(s, r, o) {
      (r === "number" && Kc(s.ownerDocument) === s) ||
        s.defaultValue === "" + o ||
        (s.defaultValue = "" + o);
    }
    function Ol(s, r, o, f) {
      if (((s = s.options), r)) {
        r = {};
        for (var b = 0; b < o.length; b++) r["$" + o[b]] = !0;
        for (o = 0; o < s.length; o++)
          ((b = r.hasOwnProperty("$" + s[o].value)),
            s[o].selected !== b && (s[o].selected = b),
            b && f && (s[o].defaultSelected = !0));
      } else {
        for (o = "" + $i(o), r = null, b = 0; b < s.length; b++) {
          if (s[b].value === o) {
            ((s[b].selected = !0), f && (s[b].defaultSelected = !0));
            return;
          }
          r !== null || s[b].disabled || (r = s[b]);
        }
        r !== null && (r.selected = !0);
      }
    }
    function Vf(s, r, o) {
      if (
        r != null &&
        ((r = "" + $i(r)), r !== s.value && (s.value = r), o == null)
      ) {
        s.defaultValue !== r && (s.defaultValue = r);
        return;
      }
      s.defaultValue = o != null ? "" + $i(o) : "";
    }
    function Wf(s, r, o, f) {
      if (r == null) {
        if (f != null) {
          if (o != null) throw Error(i(92));
          if (Oe(f)) {
            if (1 < f.length) throw Error(i(93));
            f = f[0];
          }
          o = f;
        }
        (o == null && (o = ""), (r = o));
      }
      ((o = $i(r)),
        (s.defaultValue = o),
        (f = s.textContent),
        f === o && f !== "" && f !== null && (s.value = f),
        qf(s));
    }
    function Xs(s, r) {
      if (r) {
        var o = s.firstChild;
        if (o && o === s.lastChild && o.nodeType === 3) {
          o.nodeValue = r;
          return;
        }
      }
      s.textContent = r;
    }
    var ov = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " ",
      ),
    );
    function cp(s, r, o) {
      var f = r.indexOf("--") === 0;
      o == null || typeof o == "boolean" || o === ""
        ? f
          ? s.setProperty(r, "")
          : r === "float"
            ? (s.cssFloat = "")
            : (s[r] = "")
        : f
          ? s.setProperty(r, o)
          : typeof o != "number" || o === 0 || ov.has(r)
            ? r === "float"
              ? (s.cssFloat = o)
              : (s[r] = ("" + o).trim())
            : (s[r] = o + "px");
    }
    function cv(s, r, o) {
      if (r != null && typeof r != "object") throw Error(i(62));
      if (((s = s.style), o != null)) {
        for (var f in o)
          !o.hasOwnProperty(f) ||
            (r != null && r.hasOwnProperty(f)) ||
            (f.indexOf("--") === 0
              ? s.setProperty(f, "")
              : f === "float"
                ? (s.cssFloat = "")
                : (s[f] = ""));
        for (var b in r)
          ((f = r[b]), r.hasOwnProperty(b) && o[b] !== f && cp(s, b, f));
      } else for (var _ in r) r.hasOwnProperty(_) && cp(s, _, r[_]);
    }
    function Xf(s) {
      if (s.indexOf("-") === -1) return !1;
      switch (s) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var uv = new Map([
        ["acceptCharset", "accept-charset"],
        ["htmlFor", "for"],
        ["httpEquiv", "http-equiv"],
        ["crossOrigin", "crossorigin"],
        ["accentHeight", "accent-height"],
        ["alignmentBaseline", "alignment-baseline"],
        ["arabicForm", "arabic-form"],
        ["baselineShift", "baseline-shift"],
        ["capHeight", "cap-height"],
        ["clipPath", "clip-path"],
        ["clipRule", "clip-rule"],
        ["colorInterpolation", "color-interpolation"],
        ["colorInterpolationFilters", "color-interpolation-filters"],
        ["colorProfile", "color-profile"],
        ["colorRendering", "color-rendering"],
        ["dominantBaseline", "dominant-baseline"],
        ["enableBackground", "enable-background"],
        ["fillOpacity", "fill-opacity"],
        ["fillRule", "fill-rule"],
        ["floodColor", "flood-color"],
        ["floodOpacity", "flood-opacity"],
        ["fontFamily", "font-family"],
        ["fontSize", "font-size"],
        ["fontSizeAdjust", "font-size-adjust"],
        ["fontStretch", "font-stretch"],
        ["fontStyle", "font-style"],
        ["fontVariant", "font-variant"],
        ["fontWeight", "font-weight"],
        ["glyphName", "glyph-name"],
        ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
        ["glyphOrientationVertical", "glyph-orientation-vertical"],
        ["horizAdvX", "horiz-adv-x"],
        ["horizOriginX", "horiz-origin-x"],
        ["imageRendering", "image-rendering"],
        ["letterSpacing", "letter-spacing"],
        ["lightingColor", "lighting-color"],
        ["markerEnd", "marker-end"],
        ["markerMid", "marker-mid"],
        ["markerStart", "marker-start"],
        ["overlinePosition", "overline-position"],
        ["overlineThickness", "overline-thickness"],
        ["paintOrder", "paint-order"],
        ["panose-1", "panose-1"],
        ["pointerEvents", "pointer-events"],
        ["renderingIntent", "rendering-intent"],
        ["shapeRendering", "shape-rendering"],
        ["stopColor", "stop-color"],
        ["stopOpacity", "stop-opacity"],
        ["strikethroughPosition", "strikethrough-position"],
        ["strikethroughThickness", "strikethrough-thickness"],
        ["strokeDasharray", "stroke-dasharray"],
        ["strokeDashoffset", "stroke-dashoffset"],
        ["strokeLinecap", "stroke-linecap"],
        ["strokeLinejoin", "stroke-linejoin"],
        ["strokeMiterlimit", "stroke-miterlimit"],
        ["strokeOpacity", "stroke-opacity"],
        ["strokeWidth", "stroke-width"],
        ["textAnchor", "text-anchor"],
        ["textDecoration", "text-decoration"],
        ["textRendering", "text-rendering"],
        ["transformOrigin", "transform-origin"],
        ["underlinePosition", "underline-position"],
        ["underlineThickness", "underline-thickness"],
        ["unicodeBidi", "unicode-bidi"],
        ["unicodeRange", "unicode-range"],
        ["unitsPerEm", "units-per-em"],
        ["vAlphabetic", "v-alphabetic"],
        ["vHanging", "v-hanging"],
        ["vIdeographic", "v-ideographic"],
        ["vMathematical", "v-mathematical"],
        ["vectorEffect", "vector-effect"],
        ["vertAdvY", "vert-adv-y"],
        ["vertOriginX", "vert-origin-x"],
        ["vertOriginY", "vert-origin-y"],
        ["wordSpacing", "word-spacing"],
        ["writingMode", "writing-mode"],
        ["xmlnsXlink", "xmlns:xlink"],
        ["xHeight", "x-height"],
      ]),
      fv =
        /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
    function Jc(s) {
      return fv.test("" + s)
        ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
        : s;
    }
    function qr() {}
    var up = null;
    function fp(s) {
      return (
        (s = s.target || s.srcElement || window),
        s.correspondingUseElement && (s = s.correspondingUseElement),
        s.nodeType === 3 ? s.parentNode : s
      );
    }
    var jl = null,
      Oo = null;
    function dv(s) {
      var r = Le(s);
      if (r && (s = r.stateNode)) {
        var o = s[on] || null;
        e: switch (((s = r.stateNode), r.type)) {
          case "input":
            if (
              ($f(
                s,
                o.value,
                o.defaultValue,
                o.defaultValue,
                o.checked,
                o.defaultChecked,
                o.type,
                o.name,
              ),
              (r = o.name),
              o.type === "radio" && r != null)
            ) {
              for (o = s; o.parentNode; ) o = o.parentNode;
              for (
                o = o.querySelectorAll(
                  'input[name="' + Gi("" + r) + '"][type="radio"]',
                ),
                  r = 0;
                r < o.length;
                r++
              ) {
                var f = o[r];
                if (f !== s && f.form === s.form) {
                  var b = f[on] || null;
                  if (!b) throw Error(i(90));
                  $f(
                    f,
                    b.value,
                    b.defaultValue,
                    b.defaultValue,
                    b.checked,
                    b.defaultChecked,
                    b.type,
                    b.name,
                  );
                }
              }
              for (r = 0; r < o.length; r++)
                ((f = o[r]), f.form === s.form && Zc(f));
            }
            break e;
          case "textarea":
            Vf(s, o.value, o.defaultValue);
            break e;
          case "select":
            ((r = o.value), r != null && Ol(s, !!o.multiple, r, !1));
        }
      }
    }
    var dp = !1;
    function hv(s, r, o) {
      if (dp) return s(r, o);
      dp = !0;
      try {
        var f = s(r);
        return f;
      } finally {
        if (
          ((dp = !1),
          (jl !== null || Oo !== null) &&
            (Kd(), jl && ((r = jl), (s = Oo), (Oo = jl = null), dv(r), s)))
        )
          for (r = 0; r < s.length; r++) dv(s[r]);
      }
    }
    function Ml(s, r) {
      var o = s.stateNode;
      if (o === null) return null;
      var f = o[on] || null;
      if (f === null) return null;
      o = f[r];
      e: switch (r) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          ((f = !f.disabled) ||
            ((s = s.type),
            (f = !(
              s === "button" ||
              s === "input" ||
              s === "select" ||
              s === "textarea"
            ))),
            (s = !f));
          break e;
        default:
          s = !1;
      }
      if (s) return null;
      if (o && typeof o != "function") throw Error(i(231, r, typeof o));
      return o;
    }
    var $r = !(
        typeof window > "u" ||
        typeof window.document > "u" ||
        typeof window.document.createElement > "u"
      ),
      hp = !1;
    if ($r)
      try {
        var eu = {};
        (Object.defineProperty(eu, "passive", {
          get: function () {
            hp = !0;
          },
        }),
          window.addEventListener("test", eu, eu),
          window.removeEventListener("test", eu, eu));
      } catch {
        hp = !1;
      }
    var Ma = null,
      pp = null,
      Vt = null;
    function Jt() {
      if (Vt) return Vt;
      var s,
        r = pp,
        o = r.length,
        f,
        b = "value" in Ma ? Ma.value : Ma.textContent,
        _ = b.length;
      for (s = 0; s < o && r[s] === b[s]; s++);
      var A = o - s;
      for (f = 1; f <= A && r[o - f] === b[_ - f]; f++);
      return (Vt = b.slice(s, 1 < f ? 1 - f : void 0));
    }
    function Qf(s) {
      var r = s.keyCode;
      return (
        "charCode" in s
          ? ((s = s.charCode), s === 0 && r === 13 && (s = 13))
          : (s = r),
        s === 10 && (s = 13),
        32 <= s || s === 13 ? s : 0
      );
    }
    function Zf() {
      return !0;
    }
    function pv() {
      return !1;
    }
    function wi(s) {
      function r(o, f, b, _, A) {
        ((this._reactName = o),
          (this._targetInst = b),
          (this.type = f),
          (this.nativeEvent = _),
          (this.target = A),
          (this.currentTarget = null));
        for (var D in s)
          s.hasOwnProperty(D) && ((o = s[D]), (this[D] = o ? o(_) : _[D]));
        return (
          (this.isDefaultPrevented = (
            _.defaultPrevented != null
              ? _.defaultPrevented
              : _.returnValue === !1
          )
            ? Zf
            : pv),
          (this.isPropagationStopped = pv),
          this
        );
      }
      return (
        y(r.prototype, {
          preventDefault: function () {
            this.defaultPrevented = !0;
            var o = this.nativeEvent;
            o &&
              (o.preventDefault
                ? o.preventDefault()
                : typeof o.returnValue != "unknown" && (o.returnValue = !1),
              (this.isDefaultPrevented = Zf));
          },
          stopPropagation: function () {
            var o = this.nativeEvent;
            o &&
              (o.stopPropagation
                ? o.stopPropagation()
                : typeof o.cancelBubble != "unknown" && (o.cancelBubble = !0),
              (this.isPropagationStopped = Zf));
          },
          persist: function () {},
          isPersistent: Zf,
        }),
        r
      );
    }
    var Nl = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function (s) {
          return s.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0,
      },
      Kf = wi(Nl),
      jo = y({}, Nl, { view: 0, detail: 0 }),
      l1 = wi(jo),
      Bn,
      tu,
      Qs,
      nu = y({}, jo, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: iu,
        button: 0,
        buttons: 0,
        relatedTarget: function (s) {
          return s.relatedTarget === void 0
            ? s.fromElement === s.srcElement
              ? s.toElement
              : s.fromElement
            : s.relatedTarget;
        },
        movementX: function (s) {
          return "movementX" in s
            ? s.movementX
            : (s !== Qs &&
                (Qs && s.type === "mousemove"
                  ? ((Bn = s.screenX - Qs.screenX),
                    (tu = s.screenY - Qs.screenY))
                  : (tu = Bn = 0),
                (Qs = s)),
              Bn);
        },
        movementY: function (s) {
          return "movementY" in s ? s.movementY : tu;
        },
      }),
      Jf = wi(nu),
      Ts = y({}, nu, { dataTransfer: 0 }),
      mv = wi(Ts),
      gv = y({}, jo, { relatedTarget: 0 }),
      ed = wi(gv),
      vv = y({}, Nl, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
      yv = wi(vv),
      bv = y({}, Nl, {
        clipboardData: function (s) {
          return "clipboardData" in s ? s.clipboardData : window.clipboardData;
        },
      }),
      Vi = wi(bv),
      o1 = y({}, Nl, { data: 0 }),
      Wi = wi(o1),
      c1 = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified",
      },
      xv = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta",
      },
      Na = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey",
      };
    function td(s) {
      var r = this.nativeEvent;
      return r.getModifierState
        ? r.getModifierState(s)
        : (s = Na[s])
          ? !!r[s]
          : !1;
    }
    function iu() {
      return td;
    }
    var cn = y({}, jo, {
        key: function (s) {
          if (s.key) {
            var r = c1[s.key] || s.key;
            if (r !== "Unidentified") return r;
          }
          return s.type === "keypress"
            ? ((s = Qf(s)), s === 13 ? "Enter" : String.fromCharCode(s))
            : s.type === "keydown" || s.type === "keyup"
              ? xv[s.keyCode] || "Unidentified"
              : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: iu,
        charCode: function (s) {
          return s.type === "keypress" ? Qf(s) : 0;
        },
        keyCode: function (s) {
          return s.type === "keydown" || s.type === "keyup" ? s.keyCode : 0;
        },
        which: function (s) {
          return s.type === "keypress"
            ? Qf(s)
            : s.type === "keydown" || s.type === "keyup"
              ? s.keyCode
              : 0;
        },
      }),
      Aa = wi(cn),
      mp = y({}, nu, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0,
      }),
      _v = wi(mp),
      gp = y({}, jo, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: iu,
      }),
      u1 = wi(gp),
      f1 = y({}, Nl, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
      d1 = wi(f1),
      wv = y({}, nu, {
        deltaX: function (s) {
          return "deltaX" in s
            ? s.deltaX
            : "wheelDeltaX" in s
              ? -s.wheelDeltaX
              : 0;
        },
        deltaY: function (s) {
          return "deltaY" in s
            ? s.deltaY
            : "wheelDeltaY" in s
              ? -s.wheelDeltaY
              : "wheelDelta" in s
                ? -s.wheelDelta
                : 0;
        },
        deltaZ: 0,
        deltaMode: 0,
      }),
      nd = wi(wv),
      Mo = y({}, Nl, { newState: 0, oldState: 0 }),
      h1 = wi(Mo),
      Sv = [9, 13, 27, 32],
      id = $r && "CompositionEvent" in window,
      Al = null;
    $r && "documentMode" in document && (Al = document.documentMode);
    var vp = $r && "TextEvent" in window && !Al,
      yp = $r && (!id || (Al && 8 < Al && 11 >= Al)),
      Tv = " ",
      sd = !1;
    function rd(s, r) {
      switch (s) {
        case "keyup":
          return Sv.indexOf(r.keyCode) !== -1;
        case "keydown":
          return r.keyCode !== 229;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Ev(s) {
      return (
        (s = s.detail),
        typeof s == "object" && "data" in s ? s.data : null
      );
    }
    var Rl = !1;
    function Xi(s, r) {
      switch (s) {
        case "compositionend":
          return Ev(r);
        case "keypress":
          return r.which !== 32 ? null : ((sd = !0), Tv);
        case "textInput":
          return ((s = r.data), s === Tv && sd ? null : s);
        default:
          return null;
      }
    }
    function bp(s, r) {
      if (Rl)
        return s === "compositionend" || (!id && rd(s, r))
          ? ((s = Jt()), (Vt = pp = Ma = null), (Rl = !1), s)
          : null;
      switch (s) {
        case "paste":
          return null;
        case "keypress":
          if (
            !(r.ctrlKey || r.altKey || r.metaKey) ||
            (r.ctrlKey && r.altKey)
          ) {
            if (r.char && 1 < r.char.length) return r.char;
            if (r.which) return String.fromCharCode(r.which);
          }
          return null;
        case "compositionend":
          return yp && r.locale !== "ko" ? null : r.data;
        default:
          return null;
      }
    }
    var su = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
    };
    function xp(s) {
      var r = s && s.nodeName && s.nodeName.toLowerCase();
      return r === "input" ? !!su[s.type] : r === "textarea";
    }
    function _p(s, r, o, f) {
      (jl ? (Oo ? Oo.push(f) : (Oo = [f])) : (jl = f),
        (r = Ku(r, "onChange")),
        0 < r.length &&
          ((o = new Kf("onChange", "change", null, o, f)),
          s.push({ event: o, listeners: r })));
    }
    var ru = null,
      au = null;
    function p1(s) {
      Uy(s, 0);
    }
    function ad(s) {
      var r = zt(s);
      if (Zc(r)) return s;
    }
    function Cv(s, r) {
      if (s === "change") return r;
    }
    var Ll = !1;
    if ($r) {
      var wp;
      if ($r) {
        var Sp = "oninput" in document;
        if (!Sp) {
          var ld = document.createElement("div");
          (ld.setAttribute("oninput", "return;"),
            (Sp = typeof ld.oninput == "function"));
        }
        wp = Sp;
      } else wp = !1;
      Ll = wp && (!document.documentMode || 9 < document.documentMode);
    }
    function Tp() {
      ru && (ru.detachEvent("onpropertychange", Gr), (au = ru = null));
    }
    function Gr(s) {
      if (s.propertyName === "value" && ad(au)) {
        var r = [];
        (_p(r, au, s, fp(s)), hv(p1, r));
      }
    }
    function od(s, r, o) {
      s === "focusin"
        ? (Tp(), (ru = r), (au = o), ru.attachEvent("onpropertychange", Gr))
        : s === "focusout" && Tp();
    }
    function m1(s) {
      if (s === "selectionchange" || s === "keyup" || s === "keydown")
        return ad(au);
    }
    function g1(s, r) {
      if (s === "click") return ad(r);
    }
    function v1(s, r) {
      if (s === "input" || s === "change") return ad(r);
    }
    function No(s, r) {
      return (s === r && (s !== 0 || 1 / s === 1 / r)) || (s !== s && r !== r);
    }
    var hn = typeof Object.is == "function" ? Object.is : No;
    function Ao(s, r) {
      if (hn(s, r)) return !0;
      if (
        typeof s != "object" ||
        s === null ||
        typeof r != "object" ||
        r === null
      )
        return !1;
      var o = Object.keys(s),
        f = Object.keys(r);
      if (o.length !== f.length) return !1;
      for (f = 0; f < o.length; f++) {
        var b = o[f];
        if (!Ca.call(r, b) || !hn(s[b], r[b])) return !1;
      }
      return !0;
    }
    function Ov(s) {
      for (; s && s.firstChild; ) s = s.firstChild;
      return s;
    }
    function jv(s, r) {
      var o = Ov(s);
      s = 0;
      for (var f; o; ) {
        if (o.nodeType === 3) {
          if (((f = s + o.textContent.length), s <= r && f >= r))
            return { node: o, offset: r - s };
          s = f;
        }
        e: {
          for (; o; ) {
            if (o.nextSibling) {
              o = o.nextSibling;
              break e;
            }
            o = o.parentNode;
          }
          o = void 0;
        }
        o = Ov(o);
      }
    }
    function Mv(s, r) {
      return s && r
        ? s === r
          ? !0
          : s && s.nodeType === 3
            ? !1
            : r && r.nodeType === 3
              ? Mv(s, r.parentNode)
              : "contains" in s
                ? s.contains(r)
                : s.compareDocumentPosition
                  ? !!(s.compareDocumentPosition(r) & 16)
                  : !1
        : !1;
    }
    function Nv(s) {
      s =
        s != null &&
        s.ownerDocument != null &&
        s.ownerDocument.defaultView != null
          ? s.ownerDocument.defaultView
          : window;
      for (var r = Kc(s.document); r instanceof s.HTMLIFrameElement; ) {
        try {
          var o = typeof r.contentWindow.location.href == "string";
        } catch {
          o = !1;
        }
        if (o) s = r.contentWindow;
        else break;
        r = Kc(s.document);
      }
      return r;
    }
    function Ep(s) {
      var r = s && s.nodeName && s.nodeName.toLowerCase();
      return (
        r &&
        ((r === "input" &&
          (s.type === "text" ||
            s.type === "search" ||
            s.type === "tel" ||
            s.type === "url" ||
            s.type === "password")) ||
          r === "textarea" ||
          s.contentEditable === "true")
      );
    }
    var Ro = $r && "documentMode" in document && 11 >= document.documentMode,
      ee = null,
      me = null,
      oe = null,
      ke = !1;
    function et(s, r, o) {
      var f =
        o.window === o ? o.document : o.nodeType === 9 ? o : o.ownerDocument;
      ke ||
        ee == null ||
        ee !== Kc(f) ||
        ((f = ee),
        "selectionStart" in f && Ep(f)
          ? (f = { start: f.selectionStart, end: f.selectionEnd })
          : ((f = (
              (f.ownerDocument && f.ownerDocument.defaultView) ||
              window
            ).getSelection()),
            (f = {
              anchorNode: f.anchorNode,
              anchorOffset: f.anchorOffset,
              focusNode: f.focusNode,
              focusOffset: f.focusOffset,
            })),
        (oe && Ao(oe, f)) ||
          ((oe = f),
          (f = Ku(me, "onSelect")),
          0 < f.length &&
            ((r = new Kf("onSelect", "select", null, r, o)),
            s.push({ event: r, listeners: f }),
            (r.target = ee))));
    }
    function pt(s, r) {
      var o = {};
      return (
        (o[s.toLowerCase()] = r.toLowerCase()),
        (o["Webkit" + s] = "webkit" + r),
        (o["Moz" + s] = "moz" + r),
        o
      );
    }
    var un = {
        animationend: pt("Animation", "AnimationEnd"),
        animationiteration: pt("Animation", "AnimationIteration"),
        animationstart: pt("Animation", "AnimationStart"),
        transitionrun: pt("Transition", "TransitionRun"),
        transitionstart: pt("Transition", "TransitionStart"),
        transitioncancel: pt("Transition", "TransitionCancel"),
        transitionend: pt("Transition", "TransitionEnd"),
      },
      Ht = {},
      cd = {};
    $r &&
      ((cd = document.createElement("div").style),
      "AnimationEvent" in window ||
        (delete un.animationend.animation,
        delete un.animationiteration.animation,
        delete un.animationstart.animation),
      "TransitionEvent" in window || delete un.transitionend.transition);
    function Dl(s) {
      if (Ht[s]) return Ht[s];
      if (!un[s]) return s;
      var r = un[s],
        o;
      for (o in r) if (r.hasOwnProperty(o) && o in cd) return (Ht[s] = r[o]);
      return s;
    }
    var Qi = Dl("animationend"),
      lu = Dl("animationiteration"),
      Av = Dl("animationstart"),
      Lo = Dl("transitionrun"),
      ud = Dl("transitionstart"),
      fd = Dl("transitioncancel"),
      Pt = Dl("transitionend"),
      Rv = new Map(),
      dd =
        "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
          " ",
        );
    dd.push("scrollEnd");
    function Si(s, r) {
      (Rv.set(s, r), hi(r, [s]));
    }
    var hd =
        typeof reportError == "function"
          ? reportError
          : function (s) {
              if (
                typeof window == "object" &&
                typeof window.ErrorEvent == "function"
              ) {
                var r = new window.ErrorEvent("error", {
                  bubbles: !0,
                  cancelable: !0,
                  message:
                    typeof s == "object" &&
                    s !== null &&
                    typeof s.message == "string"
                      ? String(s.message)
                      : String(s),
                  error: s,
                });
                if (!window.dispatchEvent(r)) return;
              } else if (
                typeof process == "object" &&
                typeof process.emit == "function"
              ) {
                process.emit("uncaughtException", s);
                return;
              }
              console.error(s);
            },
      Es = [],
      Do = 0,
      ko = 0;
    function Zs() {
      for (var s = Do, r = (ko = Do = 0); r < s; ) {
        var o = Es[r];
        Es[r++] = null;
        var f = Es[r];
        Es[r++] = null;
        var b = Es[r];
        Es[r++] = null;
        var _ = Es[r];
        if (((Es[r++] = null), f !== null && b !== null)) {
          var A = f.pending;
          (A === null ? (b.next = b) : ((b.next = A.next), (A.next = b)),
            (f.pending = b));
        }
        _ !== 0 && Cp(o, b, _);
      }
    }
    function kl(s, r, o, f) {
      ((Es[Do++] = s),
        (Es[Do++] = r),
        (Es[Do++] = o),
        (Es[Do++] = f),
        (ko |= f),
        (s.lanes |= f),
        (s = s.alternate),
        s !== null && (s.lanes |= f));
    }
    function pd(s, r, o, f) {
      return (kl(s, r, o, f), ou(s));
    }
    function _r(s, r) {
      return (kl(s, null, null, r), ou(s));
    }
    function Cp(s, r, o) {
      s.lanes |= o;
      var f = s.alternate;
      f !== null && (f.lanes |= o);
      for (var b = !1, _ = s.return; _ !== null; )
        ((_.childLanes |= o),
          (f = _.alternate),
          f !== null && (f.childLanes |= o),
          _.tag === 22 &&
            ((s = _.stateNode), s === null || s._visibility & 1 || (b = !0)),
          (s = _),
          (_ = _.return));
      return s.tag === 3
        ? ((_ = s.stateNode),
          b &&
            r !== null &&
            ((b = 31 - bn(o)),
            (s = _.hiddenUpdates),
            (f = s[b]),
            f === null ? (s[b] = [r]) : f.push(r),
            (r.lane = o | 536870912)),
          _)
        : null;
    }
    function ou(s) {
      if (50 < $u) throw (($u = 0), (Em = null), Error(i(185)));
      for (var r = s.return; r !== null; ) ((s = r), (r = s.return));
      return s.tag === 3 ? s.stateNode : null;
    }
    var Vr = {};
    function Lv(s, r, o, f) {
      ((this.tag = s),
        (this.key = o),
        (this.sibling =
          this.child =
          this.return =
          this.stateNode =
          this.type =
          this.elementType =
            null),
        (this.index = 0),
        (this.refCleanup = this.ref = null),
        (this.pendingProps = r),
        (this.dependencies =
          this.memoizedState =
          this.updateQueue =
          this.memoizedProps =
            null),
        (this.mode = f),
        (this.subtreeFlags = this.flags = 0),
        (this.deletions = null),
        (this.childLanes = this.lanes = 0),
        (this.alternate = null));
    }
    function Kn(s, r, o, f) {
      return new Lv(s, r, o, f);
    }
    function Wr(s) {
      return ((s = s.prototype), !(!s || !s.isReactComponent));
    }
    function Cs(s, r) {
      var o = s.alternate;
      return (
        o === null
          ? ((o = Kn(s.tag, r, s.key, s.mode)),
            (o.elementType = s.elementType),
            (o.type = s.type),
            (o.stateNode = s.stateNode),
            (o.alternate = s),
            (s.alternate = o))
          : ((o.pendingProps = r),
            (o.type = s.type),
            (o.flags = 0),
            (o.subtreeFlags = 0),
            (o.deletions = null)),
        (o.flags = s.flags & 65011712),
        (o.childLanes = s.childLanes),
        (o.lanes = s.lanes),
        (o.child = s.child),
        (o.memoizedProps = s.memoizedProps),
        (o.memoizedState = s.memoizedState),
        (o.updateQueue = s.updateQueue),
        (r = s.dependencies),
        (o.dependencies =
          r === null ? null : { lanes: r.lanes, firstContext: r.firstContext }),
        (o.sibling = s.sibling),
        (o.index = s.index),
        (o.ref = s.ref),
        (o.refCleanup = s.refCleanup),
        o
      );
    }
    function Dv(s, r) {
      s.flags &= 65011714;
      var o = s.alternate;
      return (
        o === null
          ? ((s.childLanes = 0),
            (s.lanes = r),
            (s.child = null),
            (s.subtreeFlags = 0),
            (s.memoizedProps = null),
            (s.memoizedState = null),
            (s.updateQueue = null),
            (s.dependencies = null),
            (s.stateNode = null))
          : ((s.childLanes = o.childLanes),
            (s.lanes = o.lanes),
            (s.child = o.child),
            (s.subtreeFlags = 0),
            (s.deletions = null),
            (s.memoizedProps = o.memoizedProps),
            (s.memoizedState = o.memoizedState),
            (s.updateQueue = o.updateQueue),
            (s.type = o.type),
            (r = o.dependencies),
            (s.dependencies =
              r === null
                ? null
                : { lanes: r.lanes, firstContext: r.firstContext })),
        s
      );
    }
    function md(s, r, o, f, b, _) {
      var A = 0;
      if (((f = s), typeof s == "function")) Wr(s) && (A = 1);
      else if (typeof s == "string")
        A = K1(s, o, Me.current)
          ? 26
          : s === "html" || s === "head" || s === "body"
            ? 27
            : 5;
      else
        e: switch (s) {
          case I:
            return (
              (s = Kn(31, o, r, b)),
              (s.elementType = I),
              (s.lanes = _),
              s
            );
          case E:
            return zl(o.children, b, _, r);
          case j:
            ((A = 8), (b |= 24));
            break;
          case O:
            return (
              (s = Kn(12, o, r, b | 2)),
              (s.elementType = O),
              (s.lanes = _),
              s
            );
          case P:
            return (
              (s = Kn(13, o, r, b)),
              (s.elementType = P),
              (s.lanes = _),
              s
            );
          case G:
            return (
              (s = Kn(19, o, r, b)),
              (s.elementType = G),
              (s.lanes = _),
              s
            );
          default:
            if (typeof s == "object" && s !== null)
              switch (s.$$typeof) {
                case N:
                  A = 10;
                  break e;
                case M:
                  A = 9;
                  break e;
                case R:
                  A = 11;
                  break e;
                case Y:
                  A = 14;
                  break e;
                case B:
                  ((A = 16), (f = null));
                  break e;
              }
            ((A = 29),
              (o = Error(i(130, s === null ? "null" : typeof s, ""))),
              (f = null));
        }
      return (
        (r = Kn(A, o, r, b)),
        (r.elementType = s),
        (r.type = f),
        (r.lanes = _),
        r
      );
    }
    function zl(s, r, o, f) {
      return ((s = Kn(7, s, f, r)), (s.lanes = o), s);
    }
    function zo(s, r, o) {
      return ((s = Kn(6, s, null, r)), (s.lanes = o), s);
    }
    function cu(s) {
      var r = Kn(18, null, null, 0);
      return ((r.stateNode = s), r);
    }
    function uu(s, r, o) {
      return (
        (r = Kn(4, s.children !== null ? s.children : [], s.key, r)),
        (r.lanes = o),
        (r.stateNode = {
          containerInfo: s.containerInfo,
          pendingChildren: null,
          implementation: s.implementation,
        }),
        r
      );
    }
    var kv = new WeakMap();
    function Zi(s, r) {
      if (typeof s == "object" && s !== null) {
        var o = kv.get(s);
        return o !== void 0
          ? o
          : ((r = { value: s, source: r, stack: vr(r) }), kv.set(s, r), r);
      }
      return { value: s, source: r, stack: vr(r) };
    }
    var Po = [],
      Io = 0,
      xn = null,
      zn = 0,
      Os = [],
      js = 0,
      Xr = null,
      wr = 1,
      Ms = "";
    function Ki(s, r) {
      ((Po[Io++] = zn), (Po[Io++] = xn), (xn = s), (zn = r));
    }
    function gd(s, r, o) {
      ((Os[js++] = wr), (Os[js++] = Ms), (Os[js++] = Xr), (Xr = s));
      var f = wr;
      s = Ms;
      var b = 32 - bn(f) - 1;
      ((f &= ~(1 << b)), (o += 1));
      var _ = 32 - bn(r) + b;
      if (30 < _) {
        var A = b - (b % 5);
        ((_ = (f & ((1 << A) - 1)).toString(32)),
          (f >>= A),
          (b -= A),
          (wr = (1 << (32 - bn(r) + b)) | (o << b) | f),
          (Ms = _ + s));
      } else ((wr = (1 << _) | (o << b) | f), (Ms = s));
    }
    function Ra(s) {
      s.return !== null && (Ki(s, 1), gd(s, 1, 0));
    }
    function Pl(s) {
      for (; s === xn; )
        ((xn = Po[--Io]), (Po[Io] = null), (zn = Po[--Io]), (Po[Io] = null));
      for (; s === Xr; )
        ((Xr = Os[--js]),
          (Os[js] = null),
          (Ms = Os[--js]),
          (Os[js] = null),
          (wr = Os[--js]),
          (Os[js] = null));
    }
    function Uo(s, r) {
      ((Os[js++] = wr),
        (Os[js++] = Ms),
        (Os[js++] = Xr),
        (wr = r.id),
        (Ms = r.overflow),
        (Xr = s));
    }
    var Pn = null,
      It = null,
      wt = !1,
      La = null,
      Ns = !1,
      Op = Error(i(519));
    function Da(s) {
      var r = Error(
        i(
          418,
          1 < arguments.length && arguments[1] !== void 0 && arguments[1]
            ? "text"
            : "HTML",
          "",
        ),
      );
      throw (za(Zi(r, s)), Op);
    }
    function fu(s) {
      var r = s.stateNode,
        o = s.type,
        f = s.memoizedProps;
      switch (((r[Dn] = s), (r[on] = f), o)) {
        case "dialog":
          (gt("cancel", r), gt("close", r));
          break;
        case "iframe":
        case "object":
        case "embed":
          gt("load", r);
          break;
        case "video":
        case "audio":
          for (o = 0; o < Zu.length; o++) gt(Zu[o], r);
          break;
        case "source":
          gt("error", r);
          break;
        case "img":
        case "image":
        case "link":
          (gt("error", r), gt("load", r));
          break;
        case "details":
          gt("toggle", r);
          break;
        case "input":
          (gt("invalid", r),
            Gf(
              r,
              f.value,
              f.defaultValue,
              f.checked,
              f.defaultChecked,
              f.type,
              f.name,
              !0,
            ));
          break;
        case "select":
          gt("invalid", r);
          break;
        case "textarea":
          (gt("invalid", r), Wf(r, f.value, f.defaultValue, f.children));
      }
      ((o = f.children),
        (typeof o != "string" &&
          typeof o != "number" &&
          typeof o != "bigint") ||
        r.textContent === "" + o ||
        f.suppressHydrationWarning === !0 ||
        Hy(r.textContent, o)
          ? (f.popover != null && (gt("beforetoggle", r), gt("toggle", r)),
            f.onScroll != null && gt("scroll", r),
            f.onScrollEnd != null && gt("scrollend", r),
            f.onClick != null && (r.onclick = qr),
            (r = !0))
          : (r = !1),
        r || Da(s, !0));
    }
    function Fo(s) {
      for (Pn = s.return; Pn; )
        switch (Pn.tag) {
          case 5:
          case 31:
          case 13:
            Ns = !1;
            return;
          case 27:
          case 3:
            Ns = !0;
            return;
          default:
            Pn = Pn.return;
        }
    }
    function Il(s) {
      if (s !== Pn) return !1;
      if (!wt) return (Fo(s), (wt = !0), !1);
      var r = s.tag,
        o;
      if (
        ((o = r !== 3 && r !== 27) &&
          ((o = r === 5) &&
            ((o = s.type),
            (o =
              !(o !== "form" && o !== "button") ||
              Ka(s.type, s.memoizedProps))),
          (o = !o)),
        o && It && Da(s),
        Fo(s),
        r === 13)
      ) {
        if (((s = s.memoizedState), (s = s !== null ? s.dehydrated : null), !s))
          throw Error(i(317));
        It = Vy(s);
      } else if (r === 31) {
        if (((s = s.memoizedState), (s = s !== null ? s.dehydrated : null), !s))
          throw Error(i(317));
        It = Vy(s);
      } else
        r === 27
          ? ((r = It),
            Qe(s.type) ? ((s = $m), ($m = null), (It = s)) : (It = r))
          : (It = Pn ? Ps(s.stateNode.nextSibling) : null);
      return !0;
    }
    function k() {
      ((It = Pn = null), (wt = !1));
    }
    function ka() {
      var s = La;
      return (
        s !== null &&
          (Ni === null ? (Ni = s) : Ni.push.apply(Ni, s), (La = null)),
        s
      );
    }
    function za(s) {
      La === null ? (La = [s]) : La.push(s);
    }
    var Ti = F(null),
      it = null,
      Qr = null;
    function Pa(s, r, o) {
      (xe(Ti, r._currentValue), (r._currentValue = o));
    }
    function Zr(s) {
      ((s._currentValue = Ti.current), ae(Ti));
    }
    function Kr(s, r, o) {
      for (; s !== null; ) {
        var f = s.alternate;
        if (
          ((s.childLanes & r) !== r
            ? ((s.childLanes |= r), f !== null && (f.childLanes |= r))
            : f !== null && (f.childLanes & r) !== r && (f.childLanes |= r),
          s === o)
        )
          break;
        s = s.return;
      }
    }
    function jp(s, r, o, f) {
      var b = s.child;
      for (b !== null && (b.return = s); b !== null; ) {
        var _ = b.dependencies;
        if (_ !== null) {
          var A = b.child;
          _ = _.firstContext;
          e: for (; _ !== null; ) {
            var D = _;
            _ = b;
            for (var $ = 0; $ < r.length; $++)
              if (D.context === r[$]) {
                ((_.lanes |= o),
                  (D = _.alternate),
                  D !== null && (D.lanes |= o),
                  Kr(_.return, o, s),
                  f || (A = null));
                break e;
              }
            _ = D.next;
          }
        } else if (b.tag === 18) {
          if (((A = b.return), A === null)) throw Error(i(341));
          ((A.lanes |= o),
            (_ = A.alternate),
            _ !== null && (_.lanes |= o),
            Kr(A, o, s),
            (A = null));
        } else A = b.child;
        if (A !== null) A.return = b;
        else
          for (A = b; A !== null; ) {
            if (A === s) {
              A = null;
              break;
            }
            if (((b = A.sibling), b !== null)) {
              ((b.return = A.return), (A = b));
              break;
            }
            A = A.return;
          }
        b = A;
      }
    }
    function Bo(s, r, o, f) {
      s = null;
      for (var b = r, _ = !1; b !== null; ) {
        if (!_) {
          if ((b.flags & 524288) !== 0) _ = !0;
          else if ((b.flags & 262144) !== 0) break;
        }
        if (b.tag === 10) {
          var A = b.alternate;
          if (A === null) throw Error(i(387));
          if (((A = A.memoizedProps), A !== null)) {
            var D = b.type;
            hn(b.pendingProps.value, A.value) ||
              (s !== null ? s.push(D) : (s = [D]));
          }
        } else if (b === Je.current) {
          if (((A = b.alternate), A === null)) throw Error(i(387));
          A.memoizedState.memoizedState !== b.memoizedState.memoizedState &&
            (s !== null ? s.push(yc) : (s = [yc]));
        }
        b = b.return;
      }
      (s !== null && jp(r, s, o, f), (r.flags |= 262144));
    }
    function vd(s) {
      for (s = s.firstContext; s !== null; ) {
        if (!hn(s.context._currentValue, s.memoizedValue)) return !0;
        s = s.next;
      }
      return !1;
    }
    function Ul(s) {
      ((it = s),
        (Qr = null),
        (s = s.dependencies),
        s !== null && (s.firstContext = null));
    }
    function Jn(s) {
      return zv(it, s);
    }
    function As(s, r) {
      return (it === null && Ul(s), zv(s, r));
    }
    function zv(s, r) {
      var o = r._currentValue;
      if (((r = { context: r, memoizedValue: o, next: null }), Qr === null)) {
        if (s === null) throw Error(i(308));
        ((Qr = r),
          (s.dependencies = { lanes: 0, firstContext: r }),
          (s.flags |= 524288));
      } else Qr = Qr.next = r;
      return o;
    }
    var y1 =
        typeof AbortController < "u"
          ? AbortController
          : function () {
              var s = [],
                r = (this.signal = {
                  aborted: !1,
                  addEventListener: function (o, f) {
                    s.push(f);
                  },
                });
              this.abort = function () {
                ((r.aborted = !0),
                  s.forEach(function (o) {
                    return o();
                  }));
              };
            },
      b1 = t.unstable_scheduleCallback,
      x1 = t.unstable_NormalPriority,
      In = {
        $$typeof: N,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0,
      };
    function Ks() {
      return { controller: new y1(), data: new Map(), refCount: 0 };
    }
    function du(s) {
      (s.refCount--,
        s.refCount === 0 &&
          b1(x1, function () {
            s.controller.abort();
          }));
    }
    var hu = null,
      Mp = 0,
      Ho = 0,
      Yo = null;
    function Fl(s, r) {
      if (hu === null) {
        var o = (hu = []);
        ((Mp = 0),
          (Ho = ls()),
          (Yo = {
            status: "pending",
            value: void 0,
            then: function (f) {
              o.push(f);
            },
          }));
      }
      return (Mp++, r.then(Pv, Pv), r);
    }
    function Pv() {
      if (--Mp === 0 && hu !== null) {
        Yo !== null && (Yo.status = "fulfilled");
        var s = hu;
        ((hu = null), (Ho = 0), (Yo = null));
        for (var r = 0; r < s.length; r++) (0, s[r])();
      }
    }
    function _1(s, r) {
      var o = [],
        f = {
          status: "pending",
          value: null,
          reason: null,
          then: function (b) {
            o.push(b);
          },
        };
      return (
        s.then(
          function () {
            ((f.status = "fulfilled"), (f.value = r));
            for (var b = 0; b < o.length; b++) (0, o[b])(r);
          },
          function (b) {
            for (f.status = "rejected", f.reason = b, b = 0; b < o.length; b++)
              (0, o[b])(void 0);
          },
        ),
        f
      );
    }
    var Rs = V.S;
    V.S = function (s, r) {
      ((_y = Xn()),
        typeof r == "object" &&
          r !== null &&
          typeof r.then == "function" &&
          Fl(s, r),
        Rs !== null && Rs(s, r));
    };
    var Bl = F(null);
    function Np() {
      var s = Bl.current;
      return s !== null ? s : tn.pooledCache;
    }
    function yd(s, r) {
      r === null ? xe(Bl, Bl.current) : xe(Bl, r.pool);
    }
    function Iv() {
      var s = Np();
      return s === null ? null : { parent: In._currentValue, pool: s };
    }
    var qo = Error(i(460)),
      bd = Error(i(474)),
      pu = Error(i(542)),
      xd = { then: function () {} };
    function Uv(s) {
      return ((s = s.status), s === "fulfilled" || s === "rejected");
    }
    function _d(s, r, o) {
      switch (
        ((o = s[o]),
        o === void 0 ? s.push(r) : o !== r && (r.then(qr, qr), (r = o)),
        r.status)
      ) {
        case "fulfilled":
          return r.value;
        case "rejected":
          throw ((s = r.reason), Ap(s), s);
        default:
          if (typeof r.status == "string") r.then(qr, qr);
          else {
            if (((s = tn), s !== null && 100 < s.shellSuspendCounter))
              throw Error(i(482));
            ((s = r),
              (s.status = "pending"),
              s.then(
                function (f) {
                  if (r.status === "pending") {
                    var b = r;
                    ((b.status = "fulfilled"), (b.value = f));
                  }
                },
                function (f) {
                  if (r.status === "pending") {
                    var b = r;
                    ((b.status = "rejected"), (b.reason = f));
                  }
                },
              ));
          }
          switch (r.status) {
            case "fulfilled":
              return r.value;
            case "rejected":
              throw ((s = r.reason), Ap(s), s);
          }
          throw ((Sr = r), qo);
      }
    }
    function Js(s) {
      try {
        var r = s._init;
        return r(s._payload);
      } catch (o) {
        throw o !== null && typeof o == "object" && typeof o.then == "function"
          ? ((Sr = o), qo)
          : o;
      }
    }
    var Sr = null;
    function Fv() {
      if (Sr === null) throw Error(i(459));
      var s = Sr;
      return ((Sr = null), s);
    }
    function Ap(s) {
      if (s === qo || s === pu) throw Error(i(483));
    }
    var $o = null,
      Ji = 0;
    function Go(s) {
      var r = Ji;
      return ((Ji += 1), $o === null && ($o = []), _d($o, s, r));
    }
    function er(s, r) {
      ((r = r.props.ref), (s.ref = r !== void 0 ? r : null));
    }
    function pi(s, r) {
      throw r.$$typeof === w
        ? Error(i(525))
        : ((s = Object.prototype.toString.call(r)),
          Error(
            i(
              31,
              s === "[object Object]"
                ? "object with keys {" + Object.keys(r).join(", ") + "}"
                : s,
            ),
          ));
    }
    function Bv(s) {
      function r(te, K) {
        if (s) {
          var ie = te.deletions;
          ie === null ? ((te.deletions = [K]), (te.flags |= 16)) : ie.push(K);
        }
      }
      function o(te, K) {
        if (!s) return null;
        for (; K !== null; ) (r(te, K), (K = K.sibling));
        return null;
      }
      function f(te) {
        for (var K = new Map(); te !== null; )
          (te.key !== null ? K.set(te.key, te) : K.set(te.index, te),
            (te = te.sibling));
        return K;
      }
      function b(te, K) {
        return ((te = Cs(te, K)), (te.index = 0), (te.sibling = null), te);
      }
      function _(te, K, ie) {
        return (
          (te.index = ie),
          s
            ? ((ie = te.alternate),
              ie !== null
                ? ((ie = ie.index), ie < K ? ((te.flags |= 67108866), K) : ie)
                : ((te.flags |= 67108866), K))
            : ((te.flags |= 1048576), K)
        );
      }
      function A(te) {
        return (s && te.alternate === null && (te.flags |= 67108866), te);
      }
      function D(te, K, ie, ye) {
        return K === null || K.tag !== 6
          ? ((K = zo(ie, te.mode, ye)), (K.return = te), K)
          : ((K = b(K, ie)), (K.return = te), K);
      }
      function $(te, K, ie, ye) {
        var qe = ie.type;
        return qe === E
          ? ge(te, K, ie.props.children, ye, ie.key)
          : K !== null &&
              (K.elementType === qe ||
                (typeof qe == "object" &&
                  qe !== null &&
                  qe.$$typeof === B &&
                  Js(qe) === K.type))
            ? ((K = b(K, ie.props)), er(K, ie), (K.return = te), K)
            : ((K = md(ie.type, ie.key, ie.props, null, te.mode, ye)),
              er(K, ie),
              (K.return = te),
              K);
      }
      function se(te, K, ie, ye) {
        return K === null ||
          K.tag !== 4 ||
          K.stateNode.containerInfo !== ie.containerInfo ||
          K.stateNode.implementation !== ie.implementation
          ? ((K = uu(ie, te.mode, ye)), (K.return = te), K)
          : ((K = b(K, ie.children || [])), (K.return = te), K);
      }
      function ge(te, K, ie, ye, qe) {
        return K === null || K.tag !== 7
          ? ((K = zl(ie, te.mode, ye, qe)), (K.return = te), K)
          : ((K = b(K, ie)), (K.return = te), K);
      }
      function _e(te, K, ie) {
        if (
          (typeof K == "string" && K !== "") ||
          typeof K == "number" ||
          typeof K == "bigint"
        )
          return ((K = zo("" + K, te.mode, ie)), (K.return = te), K);
        if (typeof K == "object" && K !== null) {
          switch (K.$$typeof) {
            case S:
              return (
                (ie = md(K.type, K.key, K.props, null, te.mode, ie)),
                er(ie, K),
                (ie.return = te),
                ie
              );
            case T:
              return ((K = uu(K, te.mode, ie)), (K.return = te), K);
            case B:
              return ((K = Js(K)), _e(te, K, ie));
          }
          if (Oe(K) || fe(K))
            return ((K = zl(K, te.mode, ie, null)), (K.return = te), K);
          if (typeof K.then == "function") return _e(te, Go(K), ie);
          if (K.$$typeof === N) return _e(te, As(te, K), ie);
          pi(te, K);
        }
        return null;
      }
      function re(te, K, ie, ye) {
        var qe = K !== null ? K.key : null;
        if (
          (typeof ie == "string" && ie !== "") ||
          typeof ie == "number" ||
          typeof ie == "bigint"
        )
          return qe !== null ? null : D(te, K, "" + ie, ye);
        if (typeof ie == "object" && ie !== null) {
          switch (ie.$$typeof) {
            case S:
              return ie.key === qe ? $(te, K, ie, ye) : null;
            case T:
              return ie.key === qe ? se(te, K, ie, ye) : null;
            case B:
              return ((ie = Js(ie)), re(te, K, ie, ye));
          }
          if (Oe(ie) || fe(ie))
            return qe !== null ? null : ge(te, K, ie, ye, null);
          if (typeof ie.then == "function") return re(te, K, Go(ie), ye);
          if (ie.$$typeof === N) return re(te, K, As(te, ie), ye);
          pi(te, ie);
        }
        return null;
      }
      function ue(te, K, ie, ye, qe) {
        if (
          (typeof ye == "string" && ye !== "") ||
          typeof ye == "number" ||
          typeof ye == "bigint"
        )
          return ((te = te.get(ie) || null), D(K, te, "" + ye, qe));
        if (typeof ye == "object" && ye !== null) {
          switch (ye.$$typeof) {
            case S:
              return (
                (te = te.get(ye.key === null ? ie : ye.key) || null),
                $(K, te, ye, qe)
              );
            case T:
              return (
                (te = te.get(ye.key === null ? ie : ye.key) || null),
                se(K, te, ye, qe)
              );
            case B:
              return ((ye = Js(ye)), ue(te, K, ie, ye, qe));
          }
          if (Oe(ye) || fe(ye))
            return ((te = te.get(ie) || null), ge(K, te, ye, qe, null));
          if (typeof ye.then == "function") return ue(te, K, ie, Go(ye), qe);
          if (ye.$$typeof === N) return ue(te, K, ie, As(K, ye), qe);
          pi(K, ye);
        }
        return null;
      }
      function Ie(te, K, ie, ye) {
        for (
          var qe = null, Rt = null, Be = K, lt = (K = 0), yt = null;
          Be !== null && lt < ie.length;
          lt++
        ) {
          Be.index > lt ? ((yt = Be), (Be = null)) : (yt = Be.sibling);
          var Lt = re(te, Be, ie[lt], ye);
          if (Lt === null) {
            Be === null && (Be = yt);
            break;
          }
          (s && Be && Lt.alternate === null && r(te, Be),
            (K = _(Lt, K, lt)),
            Rt === null ? (qe = Lt) : (Rt.sibling = Lt),
            (Rt = Lt),
            (Be = yt));
        }
        if (lt === ie.length) return (o(te, Be), wt && Ki(te, lt), qe);
        if (Be === null) {
          for (; lt < ie.length; lt++)
            ((Be = _e(te, ie[lt], ye)),
              Be !== null &&
                ((K = _(Be, K, lt)),
                Rt === null ? (qe = Be) : (Rt.sibling = Be),
                (Rt = Be)));
          return (wt && Ki(te, lt), qe);
        }
        for (Be = f(Be); lt < ie.length; lt++)
          ((yt = ue(Be, te, lt, ie[lt], ye)),
            yt !== null &&
              (s &&
                yt.alternate !== null &&
                Be.delete(yt.key === null ? lt : yt.key),
              (K = _(yt, K, lt)),
              Rt === null ? (qe = yt) : (Rt.sibling = yt),
              (Rt = yt)));
        return (
          s &&
            Be.forEach(function (sl) {
              return r(te, sl);
            }),
          wt && Ki(te, lt),
          qe
        );
      }
      function Ve(te, K, ie, ye) {
        if (ie == null) throw Error(i(151));
        for (
          var qe = null,
            Rt = null,
            Be = K,
            lt = (K = 0),
            yt = null,
            Lt = ie.next();
          Be !== null && !Lt.done;
          lt++, Lt = ie.next()
        ) {
          Be.index > lt ? ((yt = Be), (Be = null)) : (yt = Be.sibling);
          var sl = re(te, Be, Lt.value, ye);
          if (sl === null) {
            Be === null && (Be = yt);
            break;
          }
          (s && Be && sl.alternate === null && r(te, Be),
            (K = _(sl, K, lt)),
            Rt === null ? (qe = sl) : (Rt.sibling = sl),
            (Rt = sl),
            (Be = yt));
        }
        if (Lt.done) return (o(te, Be), wt && Ki(te, lt), qe);
        if (Be === null) {
          for (; !Lt.done; lt++, Lt = ie.next())
            ((Lt = _e(te, Lt.value, ye)),
              Lt !== null &&
                ((K = _(Lt, K, lt)),
                Rt === null ? (qe = Lt) : (Rt.sibling = Lt),
                (Rt = Lt)));
          return (wt && Ki(te, lt), qe);
        }
        for (Be = f(Be); !Lt.done; lt++, Lt = ie.next())
          ((Lt = ue(Be, te, lt, Lt.value, ye)),
            Lt !== null &&
              (s &&
                Lt.alternate !== null &&
                Be.delete(Lt.key === null ? lt : Lt.key),
              (K = _(Lt, K, lt)),
              Rt === null ? (qe = Lt) : (Rt.sibling = Lt),
              (Rt = Lt)));
        return (
          s &&
            Be.forEach(function (ax) {
              return r(te, ax);
            }),
          wt && Ki(te, lt),
          qe
        );
      }
      function Qt(te, K, ie, ye) {
        if (
          (typeof ie == "object" &&
            ie !== null &&
            ie.type === E &&
            ie.key === null &&
            (ie = ie.props.children),
          typeof ie == "object" && ie !== null)
        ) {
          switch (ie.$$typeof) {
            case S:
              e: {
                for (var qe = ie.key; K !== null; ) {
                  if (K.key === qe) {
                    if (((qe = ie.type), qe === E)) {
                      if (K.tag === 7) {
                        (o(te, K.sibling),
                          (ye = b(K, ie.props.children)),
                          (ye.return = te),
                          (te = ye));
                        break e;
                      }
                    } else if (
                      K.elementType === qe ||
                      (typeof qe == "object" &&
                        qe !== null &&
                        qe.$$typeof === B &&
                        Js(qe) === K.type)
                    ) {
                      (o(te, K.sibling),
                        (ye = b(K, ie.props)),
                        er(ye, ie),
                        (ye.return = te),
                        (te = ye));
                      break e;
                    }
                    o(te, K);
                    break;
                  } else r(te, K);
                  K = K.sibling;
                }
                ie.type === E
                  ? ((ye = zl(ie.props.children, te.mode, ye, ie.key)),
                    (ye.return = te),
                    (te = ye))
                  : ((ye = md(ie.type, ie.key, ie.props, null, te.mode, ye)),
                    er(ye, ie),
                    (ye.return = te),
                    (te = ye));
              }
              return A(te);
            case T:
              e: {
                for (qe = ie.key; K !== null; ) {
                  if (K.key === qe)
                    if (
                      K.tag === 4 &&
                      K.stateNode.containerInfo === ie.containerInfo &&
                      K.stateNode.implementation === ie.implementation
                    ) {
                      (o(te, K.sibling),
                        (ye = b(K, ie.children || [])),
                        (ye.return = te),
                        (te = ye));
                      break e;
                    } else {
                      o(te, K);
                      break;
                    }
                  else r(te, K);
                  K = K.sibling;
                }
                ((ye = uu(ie, te.mode, ye)), (ye.return = te), (te = ye));
              }
              return A(te);
            case B:
              return ((ie = Js(ie)), Qt(te, K, ie, ye));
          }
          if (Oe(ie)) return Ie(te, K, ie, ye);
          if (fe(ie)) {
            if (((qe = fe(ie)), typeof qe != "function")) throw Error(i(150));
            return ((ie = qe.call(ie)), Ve(te, K, ie, ye));
          }
          if (typeof ie.then == "function") return Qt(te, K, Go(ie), ye);
          if (ie.$$typeof === N) return Qt(te, K, As(te, ie), ye);
          pi(te, ie);
        }
        return (typeof ie == "string" && ie !== "") ||
          typeof ie == "number" ||
          typeof ie == "bigint"
          ? ((ie = "" + ie),
            K !== null && K.tag === 6
              ? (o(te, K.sibling), (ye = b(K, ie)), (ye.return = te), (te = ye))
              : (o(te, K),
                (ye = zo(ie, te.mode, ye)),
                (ye.return = te),
                (te = ye)),
            A(te))
          : o(te, K);
      }
      return function (te, K, ie, ye) {
        try {
          Ji = 0;
          var qe = Qt(te, K, ie, ye);
          return (($o = null), qe);
        } catch (Be) {
          if (Be === qo || Be === pu) throw Be;
          var Rt = Kn(29, Be, null, te.mode);
          return ((Rt.lanes = ye), (Rt.return = te), Rt);
        } finally {
        }
      };
    }
    var Ia = Bv(!0),
      Rp = Bv(!1),
      Ls = !1;
    function Tr(s) {
      s.updateQueue = {
        baseState: s.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null,
      };
    }
    function wd(s, r) {
      ((s = s.updateQueue),
        r.updateQueue === s &&
          (r.updateQueue = {
            baseState: s.baseState,
            firstBaseUpdate: s.firstBaseUpdate,
            lastBaseUpdate: s.lastBaseUpdate,
            shared: s.shared,
            callbacks: null,
          }));
    }
    function Ua(s) {
      return { lane: s, tag: 0, payload: null, callback: null, next: null };
    }
    function tr(s, r, o) {
      var f = s.updateQueue;
      if (f === null) return null;
      if (((f = f.shared), (kt & 2) !== 0)) {
        var b = f.pending;
        return (
          b === null ? (r.next = r) : ((r.next = b.next), (b.next = r)),
          (f.pending = r),
          (r = ou(s)),
          Cp(s, null, o),
          r
        );
      }
      return (kl(s, f, r, o), ou(s));
    }
    function mu(s, r, o) {
      if (
        ((r = r.updateQueue),
        r !== null && ((r = r.shared), (o & 4194048) !== 0))
      ) {
        var f = r.lanes;
        ((f &= s.pendingLanes), (o |= f), (r.lanes = o), $c(s, o));
      }
    }
    function Sd(s, r) {
      var o = s.updateQueue,
        f = s.alternate;
      if (f !== null && ((f = f.updateQueue), o === f)) {
        var b = null,
          _ = null;
        if (((o = o.firstBaseUpdate), o !== null)) {
          do {
            var A = {
              lane: o.lane,
              tag: o.tag,
              payload: o.payload,
              callback: null,
              next: null,
            };
            (_ === null ? (b = _ = A) : (_ = _.next = A), (o = o.next));
          } while (o !== null);
          _ === null ? (b = _ = r) : (_ = _.next = r);
        } else b = _ = r;
        ((o = {
          baseState: f.baseState,
          firstBaseUpdate: b,
          lastBaseUpdate: _,
          shared: f.shared,
          callbacks: f.callbacks,
        }),
          (s.updateQueue = o));
        return;
      }
      ((s = o.lastBaseUpdate),
        s === null ? (o.firstBaseUpdate = r) : (s.next = r),
        (o.lastBaseUpdate = r));
    }
    var Hn = !1;
    function Hl() {
      if (Hn) {
        var s = Yo;
        if (s !== null) throw s;
      }
    }
    function Vo(s, r, o, f) {
      Hn = !1;
      var b = s.updateQueue;
      Ls = !1;
      var _ = b.firstBaseUpdate,
        A = b.lastBaseUpdate,
        D = b.shared.pending;
      if (D !== null) {
        b.shared.pending = null;
        var $ = D,
          se = $.next;
        (($.next = null), A === null ? (_ = se) : (A.next = se), (A = $));
        var ge = s.alternate;
        ge !== null &&
          ((ge = ge.updateQueue),
          (D = ge.lastBaseUpdate),
          D !== A &&
            (D === null ? (ge.firstBaseUpdate = se) : (D.next = se),
            (ge.lastBaseUpdate = $)));
      }
      if (_ !== null) {
        var _e = b.baseState;
        ((A = 0), (ge = se = $ = null), (D = _));
        do {
          var re = D.lane & -536870913,
            ue = re !== D.lane;
          if (ue ? (vt & re) === re : (f & re) === re) {
            (re !== 0 && re === Ho && (Hn = !0),
              ge !== null &&
                (ge = ge.next =
                  {
                    lane: 0,
                    tag: D.tag,
                    payload: D.payload,
                    callback: null,
                    next: null,
                  }));
            e: {
              var Ie = s,
                Ve = D;
              re = r;
              var Qt = o;
              switch (Ve.tag) {
                case 1:
                  if (((Ie = Ve.payload), typeof Ie == "function")) {
                    _e = Ie.call(Qt, _e, re);
                    break e;
                  }
                  _e = Ie;
                  break e;
                case 3:
                  Ie.flags = (Ie.flags & -65537) | 128;
                case 0:
                  if (
                    ((Ie = Ve.payload),
                    (re = typeof Ie == "function" ? Ie.call(Qt, _e, re) : Ie),
                    re == null)
                  )
                    break e;
                  _e = y({}, _e, re);
                  break e;
                case 2:
                  Ls = !0;
              }
            }
            ((re = D.callback),
              re !== null &&
                ((s.flags |= 64),
                ue && (s.flags |= 8192),
                (ue = b.callbacks),
                ue === null ? (b.callbacks = [re]) : ue.push(re)));
          } else
            ((ue = {
              lane: re,
              tag: D.tag,
              payload: D.payload,
              callback: D.callback,
              next: null,
            }),
              ge === null ? ((se = ge = ue), ($ = _e)) : (ge = ge.next = ue),
              (A |= re));
          if (((D = D.next), D === null)) {
            if (((D = b.shared.pending), D === null)) break;
            ((ue = D),
              (D = ue.next),
              (ue.next = null),
              (b.lastBaseUpdate = ue),
              (b.shared.pending = null));
          }
        } while (!0);
        (ge === null && ($ = _e),
          (b.baseState = $),
          (b.firstBaseUpdate = se),
          (b.lastBaseUpdate = ge),
          _ === null && (b.shared.lanes = 0),
          (Va |= A),
          (s.lanes = A),
          (s.memoizedState = _e));
      }
    }
    function nr(s, r) {
      if (typeof s != "function") throw Error(i(191, s));
      s.call(r);
    }
    function Td(s, r) {
      var o = s.callbacks;
      if (o !== null)
        for (s.callbacks = null, s = 0; s < o.length; s++) nr(o[s], r);
    }
    var Jr = F(null),
      Er = F(0);
    function Lp(s, r) {
      ((s = or), xe(Er, s), xe(Jr, r), (or = s | r.baseLanes));
    }
    function ei() {
      (xe(Er, or), xe(Jr, Jr.current));
    }
    function gu() {
      ((or = Er.current), ae(Jr), ae(Er));
    }
    var es = F(null),
      Ds = null;
    function Fa(s) {
      var r = s.alternate;
      (xe(jn, jn.current & 1),
        xe(es, s),
        Ds === null &&
          (r === null || Jr.current !== null || r.memoizedState !== null) &&
          (Ds = s));
    }
    function vu(s) {
      (xe(jn, jn.current), xe(es, s), Ds === null && (Ds = s));
    }
    function Hv(s) {
      s.tag === 22
        ? (xe(jn, jn.current), xe(es, s), Ds === null && (Ds = s))
        : ks();
    }
    function ks() {
      (xe(jn, jn.current), xe(es, es.current));
    }
    function Ei(s) {
      (ae(es), Ds === s && (Ds = null), ae(jn));
    }
    var jn = F(0);
    function Ed(s) {
      for (var r = s; r !== null; ) {
        if (r.tag === 13) {
          var o = r.memoizedState;
          if (o !== null && ((o = o.dehydrated), o === null || oh(o) || dc(o)))
            return r;
        } else if (
          r.tag === 19 &&
          (r.memoizedProps.revealOrder === "forwards" ||
            r.memoizedProps.revealOrder === "backwards" ||
            r.memoizedProps.revealOrder === "unstable_legacy-backwards" ||
            r.memoizedProps.revealOrder === "together")
        ) {
          if ((r.flags & 128) !== 0) return r;
        } else if (r.child !== null) {
          ((r.child.return = r), (r = r.child));
          continue;
        }
        if (r === s) break;
        for (; r.sibling === null; ) {
          if (r.return === null || r.return === s) return null;
          r = r.return;
        }
        ((r.sibling.return = r.return), (r = r.sibling));
      }
      return null;
    }
    var ts = 0,
      st = null,
      Wt = null,
      _n = null,
      yu = !1,
      Wo = !1,
      Yl = !1,
      Cd = 0,
      Xo = 0,
      Ba = null,
      w1 = 0;
    function fn() {
      throw Error(i(321));
    }
    function Od(s, r) {
      if (r === null) return !1;
      for (var o = 0; o < r.length && o < s.length; o++)
        if (!hn(s[o], r[o])) return !1;
      return !0;
    }
    function jd(s, r, o, f, b, _) {
      return (
        (ts = _),
        (st = r),
        (r.memoizedState = null),
        (r.updateQueue = null),
        (r.lanes = 0),
        (V.H = s === null || s.memoizedState === null ? Jv : Pd),
        (Yl = !1),
        (_ = o(f, b)),
        (Yl = !1),
        Wo && (_ = bu(r, o, f, b)),
        Dp(s),
        _
      );
    }
    function Dp(s) {
      V.H = Ya;
      var r = Wt !== null && Wt.next !== null;
      if (
        ((ts = 0), (_n = Wt = st = null), (yu = !1), (Xo = 0), (Ba = null), r)
      )
        throw Error(i(300));
      s === null ||
        pn ||
        ((s = s.dependencies), s !== null && vd(s) && (pn = !0));
    }
    function bu(s, r, o, f) {
      st = s;
      var b = 0;
      do {
        if ((Wo && (Ba = null), (Xo = 0), (Wo = !1), 25 <= b))
          throw Error(i(301));
        if (((b += 1), (_n = Wt = null), s.updateQueue != null)) {
          var _ = s.updateQueue;
          ((_.lastEffect = null),
            (_.events = null),
            (_.stores = null),
            _.memoCache != null && (_.memoCache.index = 0));
        }
        ((V.H = Ou), (_ = r(o, f)));
      } while (Wo);
      return _;
    }
    function S1() {
      var s = V.H,
        r = s.useState()[0];
      return (
        (r = typeof r.then == "function" ? Zo(r) : r),
        (s = s.useState()[0]),
        (Wt !== null ? Wt.memoizedState : null) !== s && (st.flags |= 1024),
        r
      );
    }
    function Md() {
      var s = Cd !== 0;
      return ((Cd = 0), s);
    }
    function Nd(s, r, o) {
      ((r.updateQueue = s.updateQueue), (r.flags &= -2053), (s.lanes &= ~o));
    }
    function kp(s) {
      if (yu) {
        for (s = s.memoizedState; s !== null; ) {
          var r = s.queue;
          (r !== null && (r.pending = null), (s = s.next));
        }
        yu = !1;
      }
      ((ts = 0), (_n = Wt = st = null), (Wo = !1), (Xo = Cd = 0), (Ba = null));
    }
    function li() {
      var s = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null,
      };
      return (
        _n === null ? (st.memoizedState = _n = s) : (_n = _n.next = s),
        _n
      );
    }
    function Mn() {
      if (Wt === null) {
        var s = st.alternate;
        s = s !== null ? s.memoizedState : null;
      } else s = Wt.next;
      var r = _n === null ? st.memoizedState : _n.next;
      if (r !== null) ((_n = r), (Wt = s));
      else {
        if (s === null)
          throw st.alternate === null ? Error(i(467)) : Error(i(310));
        ((Wt = s),
          (s = {
            memoizedState: Wt.memoizedState,
            baseState: Wt.baseState,
            baseQueue: Wt.baseQueue,
            queue: Wt.queue,
            next: null,
          }),
          _n === null ? (st.memoizedState = _n = s) : (_n = _n.next = s));
      }
      return _n;
    }
    function Qo() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function Zo(s) {
      var r = Xo;
      return (
        (Xo += 1),
        Ba === null && (Ba = []),
        (s = _d(Ba, s, r)),
        (r = st),
        (_n === null ? r.memoizedState : _n.next) === null &&
          ((r = r.alternate),
          (V.H = r === null || r.memoizedState === null ? Jv : Pd)),
        s
      );
    }
    function Ko(s) {
      if (s !== null && typeof s == "object") {
        if (typeof s.then == "function") return Zo(s);
        if (s.$$typeof === N) return Jn(s);
      }
      throw Error(i(438, String(s)));
    }
    function zp(s) {
      var r = null,
        o = st.updateQueue;
      if ((o !== null && (r = o.memoCache), r == null)) {
        var f = st.alternate;
        f !== null &&
          ((f = f.updateQueue),
          f !== null &&
            ((f = f.memoCache),
            f != null &&
              (r = {
                data: f.data.map(function (b) {
                  return b.slice();
                }),
                index: 0,
              })));
      }
      if (
        (r == null && (r = { data: [], index: 0 }),
        o === null && ((o = Qo()), (st.updateQueue = o)),
        (o.memoCache = r),
        (o = r.data[r.index]),
        o === void 0)
      )
        for (o = r.data[r.index] = Array(s), f = 0; f < s; f++) o[f] = H;
      return (r.index++, o);
    }
    function ir(s, r) {
      return typeof r == "function" ? r(s) : r;
    }
    function rt(s) {
      var r = Mn();
      return Pp(r, Wt, s);
    }
    function Pp(s, r, o) {
      var f = s.queue;
      if (f === null) throw Error(i(311));
      f.lastRenderedReducer = o;
      var b = s.baseQueue,
        _ = f.pending;
      if (_ !== null) {
        if (b !== null) {
          var A = b.next;
          ((b.next = _.next), (_.next = A));
        }
        ((r.baseQueue = b = _), (f.pending = null));
      }
      if (((_ = s.baseState), b === null)) s.memoizedState = _;
      else {
        r = b.next;
        var D = (A = null),
          $ = null,
          se = r,
          ge = !1;
        do {
          var _e = se.lane & -536870913;
          if (_e !== se.lane ? (vt & _e) === _e : (ts & _e) === _e) {
            var re = se.revertLane;
            if (re === 0)
              ($ !== null &&
                ($ = $.next =
                  {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: se.action,
                    hasEagerState: se.hasEagerState,
                    eagerState: se.eagerState,
                    next: null,
                  }),
                _e === Ho && (ge = !0));
            else if ((ts & re) === re) {
              ((se = se.next), re === Ho && (ge = !0));
              continue;
            } else
              ((_e = {
                lane: 0,
                revertLane: se.revertLane,
                gesture: null,
                action: se.action,
                hasEagerState: se.hasEagerState,
                eagerState: se.eagerState,
                next: null,
              }),
                $ === null ? ((D = $ = _e), (A = _)) : ($ = $.next = _e),
                (st.lanes |= re),
                (Va |= re));
            ((_e = se.action),
              Yl && o(_, _e),
              (_ = se.hasEagerState ? se.eagerState : o(_, _e)));
          } else
            ((re = {
              lane: _e,
              revertLane: se.revertLane,
              gesture: se.gesture,
              action: se.action,
              hasEagerState: se.hasEagerState,
              eagerState: se.eagerState,
              next: null,
            }),
              $ === null ? ((D = $ = re), (A = _)) : ($ = $.next = re),
              (st.lanes |= _e),
              (Va |= _e));
          se = se.next;
        } while (se !== null && se !== r);
        if (
          ($ === null ? (A = _) : ($.next = D),
          !hn(_, s.memoizedState) && ((pn = !0), ge && ((o = Yo), o !== null)))
        )
          throw o;
        ((s.memoizedState = _),
          (s.baseState = A),
          (s.baseQueue = $),
          (f.lastRenderedState = _));
      }
      return (b === null && (f.lanes = 0), [s.memoizedState, f.dispatch]);
    }
    function Ip(s) {
      var r = Mn(),
        o = r.queue;
      if (o === null) throw Error(i(311));
      o.lastRenderedReducer = s;
      var f = o.dispatch,
        b = o.pending,
        _ = r.memoizedState;
      if (b !== null) {
        o.pending = null;
        var A = (b = b.next);
        do ((_ = s(_, A.action)), (A = A.next));
        while (A !== b);
        (hn(_, r.memoizedState) || (pn = !0),
          (r.memoizedState = _),
          r.baseQueue === null && (r.baseState = _),
          (o.lastRenderedState = _));
      }
      return [_, f];
    }
    function Jo(s, r, o) {
      var f = st,
        b = Mn(),
        _ = wt;
      if (_) {
        if (o === void 0) throw Error(i(407));
        o = o();
      } else o = r();
      var A = !hn((Wt || b).memoizedState, o);
      if (
        (A && ((b.memoizedState = o), (pn = !0)),
        (b = b.queue),
        Su(qv.bind(null, f, b, s), [s]),
        b.getSnapshot !== r || A || (_n !== null && _n.memoizedState.tag & 1))
      ) {
        if (
          ((f.flags |= 2048),
          is(9, { destroy: void 0 }, Yv.bind(null, f, b, o, r), null),
          tn === null)
        )
          throw Error(i(349));
        _ || (ts & 127) !== 0 || Up(f, r, o);
      }
      return o;
    }
    function Up(s, r, o) {
      ((s.flags |= 16384),
        (s = { getSnapshot: r, value: o }),
        (r = st.updateQueue),
        r === null
          ? ((r = Qo()), (st.updateQueue = r), (r.stores = [s]))
          : ((o = r.stores), o === null ? (r.stores = [s]) : o.push(s)));
    }
    function Yv(s, r, o, f) {
      ((r.value = o), (r.getSnapshot = f), ns(r) && $v(s));
    }
    function qv(s, r, o) {
      return o(function () {
        ns(r) && $v(s);
      });
    }
    function ns(s) {
      var r = s.getSnapshot;
      s = s.value;
      try {
        var o = r();
        return !hn(s, o);
      } catch {
        return !0;
      }
    }
    function $v(s) {
      var r = _r(s, 2);
      r !== null && Ai(r, s, 2);
    }
    function ec(s) {
      var r = li();
      if (typeof s == "function") {
        var o = s;
        if (((s = o()), Yl)) {
          Ln(!0);
          try {
            o();
          } finally {
            Ln(!1);
          }
        }
      }
      return (
        (r.memoizedState = r.baseState = s),
        (r.queue = {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: ir,
          lastRenderedState: s,
        }),
        r
      );
    }
    function Ad(s, r, o, f) {
      return ((s.baseState = o), Pp(s, Wt, typeof f == "function" ? f : ir));
    }
    function Gv(s, r, o, f, b) {
      if (Eu(s)) throw Error(i(485));
      if (((s = r.action), s !== null)) {
        var _ = {
          payload: b,
          action: s,
          next: null,
          isTransition: !0,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function (A) {
            _.listeners.push(A);
          },
        };
        (V.T !== null ? o(!0) : (_.isTransition = !1),
          f(_),
          (o = r.pending),
          o === null
            ? ((_.next = r.pending = _), Fp(r, _))
            : ((_.next = o.next), (r.pending = o.next = _)));
      }
    }
    function Fp(s, r) {
      var o = r.action,
        f = r.payload,
        b = s.state;
      if (r.isTransition) {
        var _ = V.T,
          A = {};
        V.T = A;
        try {
          var D = o(b, f),
            $ = V.S;
          ($ !== null && $(A, D), Ci(s, r, D));
        } catch (se) {
          xu(s, r, se);
        } finally {
          (_ !== null && A.types !== null && (_.types = A.types), (V.T = _));
        }
      } else
        try {
          ((_ = o(b, f)), Ci(s, r, _));
        } catch (se) {
          xu(s, r, se);
        }
    }
    function Ci(s, r, o) {
      o !== null && typeof o == "object" && typeof o.then == "function"
        ? o.then(
            function (f) {
              ea(s, r, f);
            },
            function (f) {
              return xu(s, r, f);
            },
          )
        : ea(s, r, o);
    }
    function ea(s, r, o) {
      ((r.status = "fulfilled"),
        (r.value = o),
        Bp(r),
        (s.state = o),
        (r = s.pending),
        r !== null &&
          ((o = r.next),
          o === r
            ? (s.pending = null)
            : ((o = o.next), (r.next = o), Fp(s, o))));
    }
    function xu(s, r, o) {
      var f = s.pending;
      if (((s.pending = null), f !== null)) {
        f = f.next;
        do ((r.status = "rejected"), (r.reason = o), Bp(r), (r = r.next));
        while (r !== f);
      }
      s.action = null;
    }
    function Bp(s) {
      s = s.listeners;
      for (var r = 0; r < s.length; r++) (0, s[r])();
    }
    function _u(s, r) {
      return r;
    }
    function Hp(s, r) {
      if (wt) {
        var o = tn.formState;
        if (o !== null) {
          e: {
            var f = st;
            if (wt) {
              if (It) {
                t: {
                  for (var b = It, _ = Ns; b.nodeType !== 8; ) {
                    if (!_) {
                      b = null;
                      break t;
                    }
                    if (((b = Ps(b.nextSibling)), b === null)) {
                      b = null;
                      break t;
                    }
                  }
                  ((_ = b.data), (b = _ === "F!" || _ === "F" ? b : null));
                }
                if (b) {
                  ((It = Ps(b.nextSibling)), (f = b.data === "F!"));
                  break e;
                }
              }
              Da(f);
            }
            f = !1;
          }
          f && (r = o[0]);
        }
      }
      return (
        (o = li()),
        (o.memoizedState = o.baseState = r),
        (f = {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: _u,
          lastRenderedState: r,
        }),
        (o.queue = f),
        (o = Jp.bind(null, st, f)),
        (f.dispatch = o),
        (f = ec(!1)),
        (_ = nc.bind(null, st, !1, f.queue)),
        (f = li()),
        (b = { state: r, dispatch: null, action: s, pending: null }),
        (f.queue = b),
        (o = Gv.bind(null, st, b, _, o)),
        (b.dispatch = o),
        (f.memoizedState = s),
        [r, o, !1]
      );
    }
    function Rd(s) {
      var r = Mn();
      return Yp(r, Wt, s);
    }
    function Yp(s, r, o) {
      if (
        ((r = Pp(s, r, _u)[0]),
        (s = rt(ir)[0]),
        typeof r == "object" && r !== null && typeof r.then == "function")
      )
        try {
          var f = Zo(r);
        } catch (A) {
          throw A === qo ? pu : A;
        }
      else f = r;
      r = Mn();
      var b = r.queue,
        _ = b.dispatch;
      return (
        o !== r.memoizedState &&
          ((st.flags |= 2048),
          is(9, { destroy: void 0 }, qp.bind(null, b, o), null)),
        [f, _, s]
      );
    }
    function qp(s, r) {
      s.action = r;
    }
    function Ld(s) {
      var r = Mn(),
        o = Wt;
      if (o !== null) return Yp(r, o, s);
      (Mn(), (r = r.memoizedState), (o = Mn()));
      var f = o.queue.dispatch;
      return ((o.memoizedState = s), [r, f, !1]);
    }
    function is(s, r, o, f) {
      return (
        (s = { tag: s, create: o, deps: f, inst: r, next: null }),
        (r = st.updateQueue),
        r === null && ((r = Qo()), (st.updateQueue = r)),
        (o = r.lastEffect),
        o === null
          ? (r.lastEffect = s.next = s)
          : ((f = o.next), (o.next = s), (s.next = f), (r.lastEffect = s)),
        s
      );
    }
    function Vv() {
      return Mn().memoizedState;
    }
    function sr(s, r, o, f) {
      var b = li();
      ((st.flags |= s),
        (b.memoizedState = is(
          1 | r,
          { destroy: void 0 },
          o,
          f === void 0 ? null : f,
        )));
    }
    function wu(s, r, o, f) {
      var b = Mn();
      f = f === void 0 ? null : f;
      var _ = b.memoizedState.inst;
      Wt !== null && f !== null && Od(f, Wt.memoizedState.deps)
        ? (b.memoizedState = is(r, _, o, f))
        : ((st.flags |= s), (b.memoizedState = is(1 | r, _, o, f)));
    }
    function $p(s, r) {
      sr(8390656, 8, s, r);
    }
    function Su(s, r) {
      wu(2048, 8, s, r);
    }
    function T1(s) {
      st.flags |= 4;
      var r = st.updateQueue;
      if (r === null) ((r = Qo()), (st.updateQueue = r), (r.events = [s]));
      else {
        var o = r.events;
        o === null ? (r.events = [s]) : o.push(s);
      }
    }
    function Wv(s) {
      var r = Mn().memoizedState;
      return (
        T1({ ref: r, nextImpl: s }),
        function () {
          if ((kt & 2) !== 0) throw Error(i(440));
          return r.impl.apply(void 0, arguments);
        }
      );
    }
    function Xv(s, r) {
      return wu(4, 2, s, r);
    }
    function Gp(s, r) {
      return wu(4, 4, s, r);
    }
    function Vp(s, r) {
      if (typeof r == "function") {
        s = s();
        var o = r(s);
        return function () {
          typeof o == "function" ? o() : r(null);
        };
      }
      if (r != null)
        return (
          (s = s()),
          (r.current = s),
          function () {
            r.current = null;
          }
        );
    }
    function Qv(s, r, o) {
      ((o = o != null ? o.concat([s]) : null),
        wu(4, 4, Vp.bind(null, r, s), o));
    }
    function Dd() {}
    function Wp(s, r) {
      var o = Mn();
      r = r === void 0 ? null : r;
      var f = o.memoizedState;
      return r !== null && Od(r, f[1]) ? f[0] : ((o.memoizedState = [s, r]), s);
    }
    function mi(s, r) {
      var o = Mn();
      r = r === void 0 ? null : r;
      var f = o.memoizedState;
      if (r !== null && Od(r, f[1])) return f[0];
      if (((f = s()), Yl)) {
        Ln(!0);
        try {
          s();
        } finally {
          Ln(!1);
        }
      }
      return ((o.memoizedState = [f, r]), f);
    }
    function zs(s, r, o) {
      return o === void 0 || ((ts & 1073741824) !== 0 && (vt & 261930) === 0)
        ? (s.memoizedState = r)
        : ((s.memoizedState = o), (s = Sy()), (st.lanes |= s), (Va |= s), o);
    }
    function Zv(s, r, o, f) {
      return hn(o, r)
        ? o
        : Jr.current !== null
          ? ((s = zs(s, o, f)), hn(s, r) || (pn = !0), s)
          : (ts & 42) === 0 || ((ts & 1073741824) !== 0 && (vt & 261930) === 0)
            ? ((pn = !0), (s.memoizedState = o))
            : ((s = Sy()), (st.lanes |= s), (Va |= s), r);
    }
    function Kv(s, r, o, f, b) {
      var _ = pe.p;
      pe.p = _ !== 0 && 8 > _ ? _ : 8;
      var A = V.T,
        D = {};
      ((V.T = D), nc(s, !1, r, o));
      try {
        var $ = b(),
          se = V.S;
        if (
          (se !== null && se(D, $),
          $ !== null && typeof $ == "object" && typeof $.then == "function")
        ) {
          var ge = _1($, f);
          tc(s, r, ge, as(s));
        } else tc(s, r, f, as(s));
      } catch (_e) {
        tc(
          s,
          r,
          { then: function () {}, status: "rejected", reason: _e },
          as(),
        );
      } finally {
        ((pe.p = _),
          A !== null && D.types !== null && (A.types = D.types),
          (V.T = A));
      }
    }
    function kd() {}
    function Ha(s, r, o, f) {
      if (s.tag !== 5) throw Error(i(476));
      var b = Xp(s).queue;
      Kv(
        s,
        b,
        r,
        de,
        o === null
          ? kd
          : function () {
              return (Qp(s), o(f));
            },
      );
    }
    function Xp(s) {
      var r = s.memoizedState;
      if (r !== null) return r;
      r = {
        memoizedState: de,
        baseState: de,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: ir,
          lastRenderedState: de,
        },
        next: null,
      };
      var o = {};
      return (
        (r.next = {
          memoizedState: o,
          baseState: o,
          baseQueue: null,
          queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: ir,
            lastRenderedState: o,
          },
          next: null,
        }),
        (s.memoizedState = r),
        (s = s.alternate),
        s !== null && (s.memoizedState = r),
        r
      );
    }
    function Qp(s) {
      var r = Xp(s);
      (r.next === null && (r = s.alternate.memoizedState),
        tc(s, r.next.queue, {}, as()));
    }
    function Zp() {
      return Jn(yc);
    }
    function Kp() {
      return Mn().memoizedState;
    }
    function ql() {
      return Mn().memoizedState;
    }
    function Tu(s) {
      for (var r = s.return; r !== null; ) {
        switch (r.tag) {
          case 24:
          case 3:
            var o = as();
            s = Ua(o);
            var f = tr(r, s, o);
            (f !== null && (Ai(f, r, o), mu(f, r, o)),
              (r = { cache: Ks() }),
              (s.payload = r));
            return;
        }
        r = r.return;
      }
    }
    function E1(s, r, o) {
      var f = as();
      ((o = {
        lane: f,
        revertLane: 0,
        gesture: null,
        action: o,
        hasEagerState: !1,
        eagerState: null,
        next: null,
      }),
        Eu(s)
          ? Cu(r, o)
          : ((o = pd(s, r, o, f)), o !== null && (Ai(o, s, f), zd(o, r, f))));
    }
    function Jp(s, r, o) {
      var f = as();
      tc(s, r, o, f);
    }
    function tc(s, r, o, f) {
      var b = {
        lane: f,
        revertLane: 0,
        gesture: null,
        action: o,
        hasEagerState: !1,
        eagerState: null,
        next: null,
      };
      if (Eu(s)) Cu(r, b);
      else {
        var _ = s.alternate;
        if (
          s.lanes === 0 &&
          (_ === null || _.lanes === 0) &&
          ((_ = r.lastRenderedReducer), _ !== null)
        )
          try {
            var A = r.lastRenderedState,
              D = _(A, o);
            if (((b.hasEagerState = !0), (b.eagerState = D), hn(D, A)))
              return (kl(s, r, b, 0), tn === null && Zs(), !1);
          } catch {
          } finally {
          }
        if (((o = pd(s, r, b, f)), o !== null))
          return (Ai(o, s, f), zd(o, r, f), !0);
      }
      return !1;
    }
    function nc(s, r, o, f) {
      if (
        ((f = {
          lane: 2,
          revertLane: ls(),
          gesture: null,
          action: f,
          hasEagerState: !1,
          eagerState: null,
          next: null,
        }),
        Eu(s))
      ) {
        if (r) throw Error(i(479));
      } else ((r = pd(s, o, f, 2)), r !== null && Ai(r, s, 2));
    }
    function Eu(s) {
      var r = s.alternate;
      return s === st || (r !== null && r === st);
    }
    function Cu(s, r) {
      Wo = yu = !0;
      var o = s.pending;
      (o === null ? (r.next = r) : ((r.next = o.next), (o.next = r)),
        (s.pending = r));
    }
    function zd(s, r, o) {
      if ((o & 4194048) !== 0) {
        var f = r.lanes;
        ((f &= s.pendingLanes), (o |= f), (r.lanes = o), $c(s, o));
      }
    }
    var Ya = {
      readContext: Jn,
      use: Ko,
      useCallback: fn,
      useContext: fn,
      useEffect: fn,
      useImperativeHandle: fn,
      useLayoutEffect: fn,
      useInsertionEffect: fn,
      useMemo: fn,
      useReducer: fn,
      useRef: fn,
      useState: fn,
      useDebugValue: fn,
      useDeferredValue: fn,
      useTransition: fn,
      useSyncExternalStore: fn,
      useId: fn,
      useHostTransitionStatus: fn,
      useFormState: fn,
      useActionState: fn,
      useOptimistic: fn,
      useMemoCache: fn,
      useCacheRefresh: fn,
    };
    Ya.useEffectEvent = fn;
    var Jv = {
        readContext: Jn,
        use: Ko,
        useCallback: function (s, r) {
          return ((li().memoizedState = [s, r === void 0 ? null : r]), s);
        },
        useContext: Jn,
        useEffect: $p,
        useImperativeHandle: function (s, r, o) {
          ((o = o != null ? o.concat([s]) : null),
            sr(4194308, 4, Vp.bind(null, r, s), o));
        },
        useLayoutEffect: function (s, r) {
          return sr(4194308, 4, s, r);
        },
        useInsertionEffect: function (s, r) {
          sr(4, 2, s, r);
        },
        useMemo: function (s, r) {
          var o = li();
          r = r === void 0 ? null : r;
          var f = s();
          if (Yl) {
            Ln(!0);
            try {
              s();
            } finally {
              Ln(!1);
            }
          }
          return ((o.memoizedState = [f, r]), f);
        },
        useReducer: function (s, r, o) {
          var f = li();
          if (o !== void 0) {
            var b = o(r);
            if (Yl) {
              Ln(!0);
              try {
                o(r);
              } finally {
                Ln(!1);
              }
            }
          } else b = r;
          return (
            (f.memoizedState = f.baseState = b),
            (s = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: s,
              lastRenderedState: b,
            }),
            (f.queue = s),
            (s = s.dispatch = E1.bind(null, st, s)),
            [f.memoizedState, s]
          );
        },
        useRef: function (s) {
          var r = li();
          return ((s = { current: s }), (r.memoizedState = s));
        },
        useState: function (s) {
          s = ec(s);
          var r = s.queue,
            o = Jp.bind(null, st, r);
          return ((r.dispatch = o), [s.memoizedState, o]);
        },
        useDebugValue: Dd,
        useDeferredValue: function (s, r) {
          var o = li();
          return zs(o, s, r);
        },
        useTransition: function () {
          var s = ec(!1);
          return (
            (s = Kv.bind(null, st, s.queue, !0, !1)),
            (li().memoizedState = s),
            [!1, s]
          );
        },
        useSyncExternalStore: function (s, r, o) {
          var f = st,
            b = li();
          if (wt) {
            if (o === void 0) throw Error(i(407));
            o = o();
          } else {
            if (((o = r()), tn === null)) throw Error(i(349));
            (vt & 127) !== 0 || Up(f, r, o);
          }
          b.memoizedState = o;
          var _ = { value: o, getSnapshot: r };
          return (
            (b.queue = _),
            $p(qv.bind(null, f, _, s), [s]),
            (f.flags |= 2048),
            is(9, { destroy: void 0 }, Yv.bind(null, f, _, o, r), null),
            o
          );
        },
        useId: function () {
          var s = li(),
            r = tn.identifierPrefix;
          if (wt) {
            var o = Ms,
              f = wr;
            ((o = (f & ~(1 << (32 - bn(f) - 1))).toString(32) + o),
              (r = "_" + r + "R_" + o),
              (o = Cd++),
              0 < o && (r += "H" + o.toString(32)),
              (r += "_"));
          } else ((o = w1++), (r = "_" + r + "r_" + o.toString(32) + "_"));
          return (s.memoizedState = r);
        },
        useHostTransitionStatus: Zp,
        useFormState: Hp,
        useActionState: Hp,
        useOptimistic: function (s) {
          var r = li();
          r.memoizedState = r.baseState = s;
          var o = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null,
          };
          return (
            (r.queue = o),
            (r = nc.bind(null, st, !0, o)),
            (o.dispatch = r),
            [s, r]
          );
        },
        useMemoCache: zp,
        useCacheRefresh: function () {
          return (li().memoizedState = Tu.bind(null, st));
        },
        useEffectEvent: function (s) {
          var r = li(),
            o = { impl: s };
          return (
            (r.memoizedState = o),
            function () {
              if ((kt & 2) !== 0) throw Error(i(440));
              return o.impl.apply(void 0, arguments);
            }
          );
        },
      },
      Pd = {
        readContext: Jn,
        use: Ko,
        useCallback: Wp,
        useContext: Jn,
        useEffect: Su,
        useImperativeHandle: Qv,
        useInsertionEffect: Xv,
        useLayoutEffect: Gp,
        useMemo: mi,
        useReducer: rt,
        useRef: Vv,
        useState: function () {
          return rt(ir);
        },
        useDebugValue: Dd,
        useDeferredValue: function (s, r) {
          var o = Mn();
          return Zv(o, Wt.memoizedState, s, r);
        },
        useTransition: function () {
          var s = rt(ir)[0],
            r = Mn().memoizedState;
          return [typeof s == "boolean" ? s : Zo(s), r];
        },
        useSyncExternalStore: Jo,
        useId: Kp,
        useHostTransitionStatus: Zp,
        useFormState: Rd,
        useActionState: Rd,
        useOptimistic: function (s, r) {
          var o = Mn();
          return Ad(o, Wt, s, r);
        },
        useMemoCache: zp,
        useCacheRefresh: ql,
      };
    Pd.useEffectEvent = Wv;
    var Ou = {
      readContext: Jn,
      use: Ko,
      useCallback: Wp,
      useContext: Jn,
      useEffect: Su,
      useImperativeHandle: Qv,
      useInsertionEffect: Xv,
      useLayoutEffect: Gp,
      useMemo: mi,
      useReducer: Ip,
      useRef: Vv,
      useState: function () {
        return Ip(ir);
      },
      useDebugValue: Dd,
      useDeferredValue: function (s, r) {
        var o = Mn();
        return Wt === null ? zs(o, s, r) : Zv(o, Wt.memoizedState, s, r);
      },
      useTransition: function () {
        var s = Ip(ir)[0],
          r = Mn().memoizedState;
        return [typeof s == "boolean" ? s : Zo(s), r];
      },
      useSyncExternalStore: Jo,
      useId: Kp,
      useHostTransitionStatus: Zp,
      useFormState: Ld,
      useActionState: Ld,
      useOptimistic: function (s, r) {
        var o = Mn();
        return Wt !== null
          ? Ad(o, Wt, s, r)
          : ((o.baseState = s), [s, o.queue.dispatch]);
      },
      useMemoCache: zp,
      useCacheRefresh: ql,
    };
    Ou.useEffectEvent = Wv;
    function Id(s, r, o, f) {
      ((r = s.memoizedState),
        (o = o(f, r)),
        (o = o == null ? r : y({}, r, o)),
        (s.memoizedState = o),
        s.lanes === 0 && (s.updateQueue.baseState = o));
    }
    var ju = {
      enqueueSetState: function (s, r, o) {
        s = s._reactInternals;
        var f = as(),
          b = Ua(f);
        ((b.payload = r),
          o != null && (b.callback = o),
          (r = tr(s, b, f)),
          r !== null && (Ai(r, s, f), mu(r, s, f)));
      },
      enqueueReplaceState: function (s, r, o) {
        s = s._reactInternals;
        var f = as(),
          b = Ua(f);
        ((b.tag = 1),
          (b.payload = r),
          o != null && (b.callback = o),
          (r = tr(s, b, f)),
          r !== null && (Ai(r, s, f), mu(r, s, f)));
      },
      enqueueForceUpdate: function (s, r) {
        s = s._reactInternals;
        var o = as(),
          f = Ua(o);
        ((f.tag = 2),
          r != null && (f.callback = r),
          (r = tr(s, f, o)),
          r !== null && (Ai(r, s, o), mu(r, s, o)));
      },
    };
    function ey(s, r, o, f, b, _, A) {
      return (
        (s = s.stateNode),
        typeof s.shouldComponentUpdate == "function"
          ? s.shouldComponentUpdate(f, _, A)
          : r.prototype && r.prototype.isPureReactComponent
            ? !Ao(o, f) || !Ao(b, _)
            : !0
      );
    }
    function em(s, r, o, f) {
      ((s = r.state),
        typeof r.componentWillReceiveProps == "function" &&
          r.componentWillReceiveProps(o, f),
        typeof r.UNSAFE_componentWillReceiveProps == "function" &&
          r.UNSAFE_componentWillReceiveProps(o, f),
        r.state !== s && ju.enqueueReplaceState(r, r.state, null));
    }
    function gi(s, r) {
      var o = r;
      if ("ref" in r) {
        o = {};
        for (var f in r) f !== "ref" && (o[f] = r[f]);
      }
      if ((s = s.defaultProps)) {
        o === r && (o = y({}, o));
        for (var b in s) o[b] === void 0 && (o[b] = s[b]);
      }
      return o;
    }
    function tm(s) {
      hd(s);
    }
    function nm(s) {
      console.error(s);
    }
    function ty(s) {
      hd(s);
    }
    function Mu(s, r) {
      try {
        var o = s.onUncaughtError;
        o(r.value, { componentStack: r.stack });
      } catch (f) {
        setTimeout(function () {
          throw f;
        });
      }
    }
    function ny(s, r, o) {
      try {
        var f = s.onCaughtError;
        f(o.value, {
          componentStack: o.stack,
          errorBoundary: r.tag === 1 ? r.stateNode : null,
        });
      } catch (b) {
        setTimeout(function () {
          throw b;
        });
      }
    }
    function im(s, r, o) {
      return (
        (o = Ua(o)),
        (o.tag = 3),
        (o.payload = { element: null }),
        (o.callback = function () {
          Mu(s, r);
        }),
        o
      );
    }
    function Cr(s) {
      return ((s = Ua(s)), (s.tag = 3), s);
    }
    function Ud(s, r, o, f) {
      var b = o.type.getDerivedStateFromError;
      if (typeof b == "function") {
        var _ = f.value;
        ((s.payload = function () {
          return b(_);
        }),
          (s.callback = function () {
            ny(r, o, f);
          }));
      }
      var A = o.stateNode;
      A !== null &&
        typeof A.componentDidCatch == "function" &&
        (s.callback = function () {
          (ny(r, o, f),
            typeof b != "function" &&
              (Wa === null ? (Wa = new Set([this])) : Wa.add(this)));
          var D = f.stack;
          this.componentDidCatch(f.value, {
            componentStack: D !== null ? D : "",
          });
        });
    }
    function sm(s, r, o, f, b) {
      if (
        ((o.flags |= 32768),
        f !== null && typeof f == "object" && typeof f.then == "function")
      ) {
        if (
          ((r = o.alternate),
          r !== null && Bo(r, o, b, !0),
          (o = es.current),
          o !== null)
        ) {
          switch (o.tag) {
            case 31:
            case 13:
              return (
                Ds === null
                  ? Jd()
                  : o.alternate === null && mn === 0 && (mn = 3),
                (o.flags &= -257),
                (o.flags |= 65536),
                (o.lanes = b),
                f === xd
                  ? (o.flags |= 16384)
                  : ((r = o.updateQueue),
                    r === null ? (o.updateQueue = new Set([f])) : r.add(f),
                    Lm(s, f, b)),
                !1
              );
            case 22:
              return (
                (o.flags |= 65536),
                f === xd
                  ? (o.flags |= 16384)
                  : ((r = o.updateQueue),
                    r === null
                      ? ((r = {
                          transitions: null,
                          markerInstances: null,
                          retryQueue: new Set([f]),
                        }),
                        (o.updateQueue = r))
                      : ((o = r.retryQueue),
                        o === null ? (r.retryQueue = new Set([f])) : o.add(f)),
                    Lm(s, f, b)),
                !1
              );
          }
          throw Error(i(435, o.tag));
        }
        return (Lm(s, f, b), Jd(), !1);
      }
      if (wt)
        return (
          (r = es.current),
          r !== null
            ? ((r.flags & 65536) === 0 && (r.flags |= 256),
              (r.flags |= 65536),
              (r.lanes = b),
              f !== Op && ((s = Error(i(422), { cause: f })), za(Zi(s, o))))
            : (f !== Op && ((r = Error(i(423), { cause: f })), za(Zi(r, o))),
              (s = s.current.alternate),
              (s.flags |= 65536),
              (b &= -b),
              (s.lanes |= b),
              (f = Zi(f, o)),
              (b = im(s.stateNode, f, b)),
              Sd(s, b),
              mn !== 4 && (mn = 2)),
          !1
        );
      var _ = Error(i(520), { cause: f });
      if (
        ((_ = Zi(_, o)),
        Yu === null ? (Yu = [_]) : Yu.push(_),
        mn !== 4 && (mn = 2),
        r === null)
      )
        return !0;
      ((f = Zi(f, o)), (o = r));
      do {
        switch (o.tag) {
          case 3:
            return (
              (o.flags |= 65536),
              (s = b & -b),
              (o.lanes |= s),
              (s = im(o.stateNode, f, s)),
              Sd(o, s),
              !1
            );
          case 1:
            if (
              ((r = o.type),
              (_ = o.stateNode),
              (o.flags & 128) === 0 &&
                (typeof r.getDerivedStateFromError == "function" ||
                  (_ !== null &&
                    typeof _.componentDidCatch == "function" &&
                    (Wa === null || !Wa.has(_)))))
            )
              return (
                (o.flags |= 65536),
                (b &= -b),
                (o.lanes |= b),
                (b = Cr(b)),
                Ud(b, s, o, f),
                Sd(o, b),
                !1
              );
        }
        o = o.return;
      } while (o !== null);
      return !1;
    }
    var Nu = Error(i(461)),
      pn = !1;
    function wn(s, r, o, f) {
      r.child = s === null ? Rp(r, null, o, f) : Ia(r, s.child, o, f);
    }
    function Ge(s, r, o, f, b) {
      o = o.render;
      var _ = r.ref;
      if ("ref" in f) {
        var A = {};
        for (var D in f) D !== "ref" && (A[D] = f[D]);
      } else A = f;
      return (
        Ul(r),
        (f = jd(s, r, o, A, _, b)),
        (D = Md()),
        s !== null && !pn
          ? (Nd(s, r, b), Or(s, r, b))
          : (wt && D && Ra(r), (r.flags |= 1), wn(s, r, f, b), r.child)
      );
    }
    function Au(s, r, o, f, b) {
      if (s === null) {
        var _ = o.type;
        return typeof _ == "function" &&
          !Wr(_) &&
          _.defaultProps === void 0 &&
          o.compare === null
          ? ((r.tag = 15), (r.type = _), Fd(s, r, _, f, b))
          : ((s = md(o.type, null, f, r, r.mode, b)),
            (s.ref = r.ref),
            (s.return = r),
            (r.child = s));
      }
      if (((_ = s.child), !$d(s, b))) {
        var A = _.memoizedProps;
        if (
          ((o = o.compare),
          (o = o !== null ? o : Ao),
          o(A, f) && s.ref === r.ref)
        )
          return Or(s, r, b);
      }
      return (
        (r.flags |= 1),
        (s = Cs(_, f)),
        (s.ref = r.ref),
        (s.return = r),
        (r.child = s)
      );
    }
    function Fd(s, r, o, f, b) {
      if (s !== null) {
        var _ = s.memoizedProps;
        if (Ao(_, f) && s.ref === r.ref)
          if (((pn = !1), (r.pendingProps = f = _), $d(s, b)))
            (s.flags & 131072) !== 0 && (pn = !0);
          else return ((r.lanes = s.lanes), Or(s, r, b));
      }
      return Yd(s, r, o, f, b);
    }
    function qa(s, r, o, f) {
      var b = f.children,
        _ = s !== null ? s.memoizedState : null;
      if (
        (s === null &&
          r.stateNode === null &&
          (r.stateNode = {
            _visibility: 1,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null,
          }),
        f.mode === "hidden")
      ) {
        if ((r.flags & 128) !== 0) {
          if (((_ = _ !== null ? _.baseLanes | o : o), s !== null)) {
            for (f = r.child = s.child, b = 0; f !== null; )
              ((b = b | f.lanes | f.childLanes), (f = f.sibling));
            f = b & ~_;
          } else ((f = 0), (r.child = null));
          return Bd(s, r, _, o, f);
        }
        if ((o & 536870912) !== 0)
          ((r.memoizedState = { baseLanes: 0, cachePool: null }),
            s !== null && yd(r, _ !== null ? _.cachePool : null),
            _ !== null ? Lp(r, _) : ei(),
            Hv(r));
        else
          return (
            (f = r.lanes = 536870912),
            Bd(s, r, _ !== null ? _.baseLanes | o : o, o, f)
          );
      } else
        _ !== null
          ? (yd(r, _.cachePool), Lp(r, _), ks(), (r.memoizedState = null))
          : (s !== null && yd(r, null), ei(), ks());
      return (wn(s, r, b, o), r.child);
    }
    function Ru(s, r) {
      return (
        (s !== null && s.tag === 22) ||
          r.stateNode !== null ||
          (r.stateNode = {
            _visibility: 1,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null,
          }),
        r.sibling
      );
    }
    function Bd(s, r, o, f, b) {
      var _ = Np();
      return (
        (_ = _ === null ? null : { parent: In._currentValue, pool: _ }),
        (r.memoizedState = { baseLanes: o, cachePool: _ }),
        s !== null && yd(r, null),
        ei(),
        Hv(r),
        s !== null && Bo(s, r, f, !0),
        (r.childLanes = b),
        null
      );
    }
    function Lu(s, r) {
      return (
        (r = qd({ mode: r.mode, children: r.children }, s.mode)),
        (r.ref = s.ref),
        (s.child = r),
        (r.return = s),
        r
      );
    }
    function ti(s, r, o) {
      return (
        Ia(r, s.child, null, o),
        (s = Lu(r, r.pendingProps)),
        (s.flags |= 2),
        Ei(r),
        (r.memoizedState = null),
        s
      );
    }
    function C1(s, r, o) {
      var f = r.pendingProps,
        b = (r.flags & 128) !== 0;
      if (((r.flags &= -129), s === null)) {
        if (wt) {
          if (f.mode === "hidden")
            return ((s = Lu(r, f)), (r.lanes = 536870912), Ru(null, s));
          if (
            (vu(r),
            (s = It)
              ? ((s = Gy(s, Ns)),
                (s = s !== null && s.data === "&" ? s : null),
                s !== null &&
                  ((r.memoizedState = {
                    dehydrated: s,
                    treeContext: Xr !== null ? { id: wr, overflow: Ms } : null,
                    retryLane: 536870912,
                    hydrationErrors: null,
                  }),
                  (o = cu(s)),
                  (o.return = r),
                  (r.child = o),
                  (Pn = r),
                  (It = null)))
              : (s = null),
            s === null)
          )
            throw Da(r);
          return ((r.lanes = 536870912), null);
        }
        return Lu(r, f);
      }
      var _ = s.memoizedState;
      if (_ !== null) {
        var A = _.dehydrated;
        if ((vu(r), b))
          if (r.flags & 256) ((r.flags &= -257), (r = ti(s, r, o)));
          else if (r.memoizedState !== null)
            ((r.child = s.child), (r.flags |= 128), (r = null));
          else throw Error(i(558));
        else if (
          (pn || Bo(s, r, o, !1), (b = (o & s.childLanes) !== 0), pn || b)
        ) {
          if (
            ((f = tn),
            f !== null && ((A = Co(f, o)), A !== 0 && A !== _.retryLane))
          )
            throw ((_.retryLane = A), _r(s, A), Ai(f, s, A), Nu);
          (Jd(), (r = ti(s, r, o)));
        } else
          ((s = _.treeContext),
            (It = Ps(A.nextSibling)),
            (Pn = r),
            (wt = !0),
            (La = null),
            (Ns = !1),
            s !== null && Uo(r, s),
            (r = Lu(r, f)),
            (r.flags |= 4096));
        return r;
      }
      return (
        (s = Cs(s.child, { mode: f.mode, children: f.children })),
        (s.ref = r.ref),
        (r.child = s),
        (s.return = r),
        s
      );
    }
    function Hd(s, r) {
      var o = r.ref;
      if (o === null) s !== null && s.ref !== null && (r.flags |= 4194816);
      else {
        if (typeof o != "function" && typeof o != "object") throw Error(i(284));
        (s === null || s.ref !== o) && (r.flags |= 4194816);
      }
    }
    function Yd(s, r, o, f, b) {
      return (
        Ul(r),
        (o = jd(s, r, o, f, void 0, b)),
        (f = Md()),
        s !== null && !pn
          ? (Nd(s, r, b), Or(s, r, b))
          : (wt && f && Ra(r), (r.flags |= 1), wn(s, r, o, b), r.child)
      );
    }
    function iy(s, r, o, f, b, _) {
      return (
        Ul(r),
        (r.updateQueue = null),
        (o = bu(r, f, o, b)),
        Dp(s),
        (f = Md()),
        s !== null && !pn
          ? (Nd(s, r, _), Or(s, r, _))
          : (wt && f && Ra(r), (r.flags |= 1), wn(s, r, o, _), r.child)
      );
    }
    function rm(s, r, o, f, b) {
      if ((Ul(r), r.stateNode === null)) {
        var _ = Vr,
          A = o.contextType;
        (typeof A == "object" && A !== null && (_ = Jn(A)),
          (_ = new o(f, _)),
          (r.memoizedState =
            _.state !== null && _.state !== void 0 ? _.state : null),
          (_.updater = ju),
          (r.stateNode = _),
          (_._reactInternals = r),
          (_ = r.stateNode),
          (_.props = f),
          (_.state = r.memoizedState),
          (_.refs = {}),
          Tr(r),
          (A = o.contextType),
          (_.context = typeof A == "object" && A !== null ? Jn(A) : Vr),
          (_.state = r.memoizedState),
          (A = o.getDerivedStateFromProps),
          typeof A == "function" &&
            (Id(r, o, A, f), (_.state = r.memoizedState)),
          typeof o.getDerivedStateFromProps == "function" ||
            typeof _.getSnapshotBeforeUpdate == "function" ||
            (typeof _.UNSAFE_componentWillMount != "function" &&
              typeof _.componentWillMount != "function") ||
            ((A = _.state),
            typeof _.componentWillMount == "function" && _.componentWillMount(),
            typeof _.UNSAFE_componentWillMount == "function" &&
              _.UNSAFE_componentWillMount(),
            A !== _.state && ju.enqueueReplaceState(_, _.state, null),
            Vo(r, f, _, b),
            Hl(),
            (_.state = r.memoizedState)),
          typeof _.componentDidMount == "function" && (r.flags |= 4194308),
          (f = !0));
      } else if (s === null) {
        _ = r.stateNode;
        var D = r.memoizedProps,
          $ = gi(o, D);
        _.props = $;
        var se = _.context,
          ge = o.contextType;
        ((A = Vr), typeof ge == "object" && ge !== null && (A = Jn(ge)));
        var _e = o.getDerivedStateFromProps;
        ((ge =
          typeof _e == "function" ||
          typeof _.getSnapshotBeforeUpdate == "function"),
          (D = r.pendingProps !== D),
          ge ||
            (typeof _.UNSAFE_componentWillReceiveProps != "function" &&
              typeof _.componentWillReceiveProps != "function") ||
            ((D || se !== A) && em(r, _, f, A)),
          (Ls = !1));
        var re = r.memoizedState;
        ((_.state = re),
          Vo(r, f, _, b),
          Hl(),
          (se = r.memoizedState),
          D || re !== se || Ls
            ? (typeof _e == "function" &&
                (Id(r, o, _e, f), (se = r.memoizedState)),
              ($ = Ls || ey(r, o, $, f, re, se, A))
                ? (ge ||
                    (typeof _.UNSAFE_componentWillMount != "function" &&
                      typeof _.componentWillMount != "function") ||
                    (typeof _.componentWillMount == "function" &&
                      _.componentWillMount(),
                    typeof _.UNSAFE_componentWillMount == "function" &&
                      _.UNSAFE_componentWillMount()),
                  typeof _.componentDidMount == "function" &&
                    (r.flags |= 4194308))
                : (typeof _.componentDidMount == "function" &&
                    (r.flags |= 4194308),
                  (r.memoizedProps = f),
                  (r.memoizedState = se)),
              (_.props = f),
              (_.state = se),
              (_.context = A),
              (f = $))
            : (typeof _.componentDidMount == "function" && (r.flags |= 4194308),
              (f = !1)));
      } else {
        ((_ = r.stateNode),
          wd(s, r),
          (A = r.memoizedProps),
          (ge = gi(o, A)),
          (_.props = ge),
          (_e = r.pendingProps),
          (re = _.context),
          (se = o.contextType),
          ($ = Vr),
          typeof se == "object" && se !== null && ($ = Jn(se)),
          (D = o.getDerivedStateFromProps),
          (se =
            typeof D == "function" ||
            typeof _.getSnapshotBeforeUpdate == "function") ||
            (typeof _.UNSAFE_componentWillReceiveProps != "function" &&
              typeof _.componentWillReceiveProps != "function") ||
            ((A !== _e || re !== $) && em(r, _, f, $)),
          (Ls = !1),
          (re = r.memoizedState),
          (_.state = re),
          Vo(r, f, _, b),
          Hl());
        var ue = r.memoizedState;
        A !== _e ||
        re !== ue ||
        Ls ||
        (s !== null && s.dependencies !== null && vd(s.dependencies))
          ? (typeof D == "function" && (Id(r, o, D, f), (ue = r.memoizedState)),
            (ge =
              Ls ||
              ey(r, o, ge, f, re, ue, $) ||
              (s !== null && s.dependencies !== null && vd(s.dependencies)))
              ? (se ||
                  (typeof _.UNSAFE_componentWillUpdate != "function" &&
                    typeof _.componentWillUpdate != "function") ||
                  (typeof _.componentWillUpdate == "function" &&
                    _.componentWillUpdate(f, ue, $),
                  typeof _.UNSAFE_componentWillUpdate == "function" &&
                    _.UNSAFE_componentWillUpdate(f, ue, $)),
                typeof _.componentDidUpdate == "function" && (r.flags |= 4),
                typeof _.getSnapshotBeforeUpdate == "function" &&
                  (r.flags |= 1024))
              : (typeof _.componentDidUpdate != "function" ||
                  (A === s.memoizedProps && re === s.memoizedState) ||
                  (r.flags |= 4),
                typeof _.getSnapshotBeforeUpdate != "function" ||
                  (A === s.memoizedProps && re === s.memoizedState) ||
                  (r.flags |= 1024),
                (r.memoizedProps = f),
                (r.memoizedState = ue)),
            (_.props = f),
            (_.state = ue),
            (_.context = $),
            (f = ge))
          : (typeof _.componentDidUpdate != "function" ||
              (A === s.memoizedProps && re === s.memoizedState) ||
              (r.flags |= 4),
            typeof _.getSnapshotBeforeUpdate != "function" ||
              (A === s.memoizedProps && re === s.memoizedState) ||
              (r.flags |= 1024),
            (f = !1));
      }
      return (
        (_ = f),
        Hd(s, r),
        (f = (r.flags & 128) !== 0),
        _ || f
          ? ((_ = r.stateNode),
            (o =
              f && typeof o.getDerivedStateFromError != "function"
                ? null
                : _.render()),
            (r.flags |= 1),
            s !== null && f
              ? ((r.child = Ia(r, s.child, null, b)),
                (r.child = Ia(r, null, o, b)))
              : wn(s, r, o, b),
            (r.memoizedState = _.state),
            (s = r.child))
          : (s = Or(s, r, b)),
        s
      );
    }
    function sy(s, r, o, f) {
      return (k(), (r.flags |= 256), wn(s, r, o, f), r.child);
    }
    var am = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null,
    };
    function lm(s) {
      return { baseLanes: s, cachePool: Iv() };
    }
    function rr(s, r, o) {
      return ((s = s !== null ? s.childLanes & ~o : 0), r && (s |= rs), s);
    }
    function oi(s, r, o) {
      var f = r.pendingProps,
        b = !1,
        _ = (r.flags & 128) !== 0,
        A;
      if (
        ((A = _) ||
          (A =
            s !== null && s.memoizedState === null
              ? !1
              : (jn.current & 2) !== 0),
        A && ((b = !0), (r.flags &= -129)),
        (A = (r.flags & 32) !== 0),
        (r.flags &= -33),
        s === null)
      ) {
        if (wt) {
          if (
            (b ? Fa(r) : ks(),
            (s = It)
              ? ((s = Gy(s, Ns)),
                (s = s !== null && s.data !== "&" ? s : null),
                s !== null &&
                  ((r.memoizedState = {
                    dehydrated: s,
                    treeContext: Xr !== null ? { id: wr, overflow: Ms } : null,
                    retryLane: 536870912,
                    hydrationErrors: null,
                  }),
                  (o = cu(s)),
                  (o.return = r),
                  (r.child = o),
                  (Pn = r),
                  (It = null)))
              : (s = null),
            s === null)
          )
            throw Da(r);
          return (dc(s) ? (r.lanes = 32) : (r.lanes = 536870912), null);
        }
        var D = f.children;
        return (
          (f = f.fallback),
          b
            ? (ks(),
              (b = r.mode),
              (D = qd({ mode: "hidden", children: D }, b)),
              (f = zl(f, b, o, null)),
              (D.return = r),
              (f.return = r),
              (D.sibling = f),
              (r.child = D),
              (f = r.child),
              (f.memoizedState = lm(o)),
              (f.childLanes = rr(s, A, o)),
              (r.memoizedState = am),
              Ru(null, f))
            : (Fa(r), Du(r, D))
        );
      }
      var $ = s.memoizedState;
      if ($ !== null && ((D = $.dehydrated), D !== null)) {
        if (_)
          r.flags & 256
            ? (Fa(r), (r.flags &= -257), (r = ku(s, r, o)))
            : r.memoizedState !== null
              ? (ks(), (r.child = s.child), (r.flags |= 128), (r = null))
              : (ks(),
                (D = f.fallback),
                (b = r.mode),
                (f = qd({ mode: "visible", children: f.children }, b)),
                (D = zl(D, b, o, null)),
                (D.flags |= 2),
                (f.return = r),
                (D.return = r),
                (f.sibling = D),
                (r.child = f),
                Ia(r, s.child, null, o),
                (f = r.child),
                (f.memoizedState = lm(o)),
                (f.childLanes = rr(s, A, o)),
                (r.memoizedState = am),
                (r = Ru(null, f)));
        else if ((Fa(r), dc(D))) {
          if (((A = D.nextSibling && D.nextSibling.dataset), A))
            var se = A.dgst;
          ((A = se),
            (f = Error(i(419))),
            (f.stack = ""),
            (f.digest = A),
            za({ value: f, source: null, stack: null }),
            (r = ku(s, r, o)));
        } else if (
          (pn || Bo(s, r, o, !1), (A = (o & s.childLanes) !== 0), pn || A)
        ) {
          if (
            ((A = tn),
            A !== null && ((f = Co(A, o)), f !== 0 && f !== $.retryLane))
          )
            throw (($.retryLane = f), _r(s, f), Ai(A, s, f), Nu);
          (oh(D) || Jd(), (r = ku(s, r, o)));
        } else
          oh(D)
            ? ((r.flags |= 192), (r.child = s.child), (r = null))
            : ((s = $.treeContext),
              (It = Ps(D.nextSibling)),
              (Pn = r),
              (wt = !0),
              (La = null),
              (Ns = !1),
              s !== null && Uo(r, s),
              (r = Du(r, f.children)),
              (r.flags |= 4096));
        return r;
      }
      return b
        ? (ks(),
          (D = f.fallback),
          (b = r.mode),
          ($ = s.child),
          (se = $.sibling),
          (f = Cs($, { mode: "hidden", children: f.children })),
          (f.subtreeFlags = $.subtreeFlags & 65011712),
          se !== null
            ? (D = Cs(se, D))
            : ((D = zl(D, b, o, null)), (D.flags |= 2)),
          (D.return = r),
          (f.return = r),
          (f.sibling = D),
          (r.child = f),
          Ru(null, f),
          (f = r.child),
          (D = s.child.memoizedState),
          D === null
            ? (D = lm(o))
            : ((b = D.cachePool),
              b !== null
                ? (($ = In._currentValue),
                  (b = b.parent !== $ ? { parent: $, pool: $ } : b))
                : (b = Iv()),
              (D = { baseLanes: D.baseLanes | o, cachePool: b })),
          (f.memoizedState = D),
          (f.childLanes = rr(s, A, o)),
          (r.memoizedState = am),
          Ru(s.child, f))
        : (Fa(r),
          (o = s.child),
          (s = o.sibling),
          (o = Cs(o, { mode: "visible", children: f.children })),
          (o.return = r),
          (o.sibling = null),
          s !== null &&
            ((A = r.deletions),
            A === null ? ((r.deletions = [s]), (r.flags |= 16)) : A.push(s)),
          (r.child = o),
          (r.memoizedState = null),
          o);
    }
    function Du(s, r) {
      return (
        (r = qd({ mode: "visible", children: r }, s.mode)),
        (r.return = s),
        (s.child = r)
      );
    }
    function qd(s, r) {
      return ((s = Kn(22, s, null, r)), (s.lanes = 0), s);
    }
    function ku(s, r, o) {
      return (
        Ia(r, s.child, null, o),
        (s = Du(r, r.pendingProps.children)),
        (s.flags |= 2),
        (r.memoizedState = null),
        s
      );
    }
    function ry(s, r, o) {
      s.lanes |= r;
      var f = s.alternate;
      (f !== null && (f.lanes |= r), Kr(s.return, r, o));
    }
    function om(s, r, o, f, b, _) {
      var A = s.memoizedState;
      A === null
        ? (s.memoizedState = {
            isBackwards: r,
            rendering: null,
            renderingStartTime: 0,
            last: f,
            tail: o,
            tailMode: b,
            treeForkCount: _,
          })
        : ((A.isBackwards = r),
          (A.rendering = null),
          (A.renderingStartTime = 0),
          (A.last = f),
          (A.tail = o),
          (A.tailMode = b),
          (A.treeForkCount = _));
    }
    function ic(s, r, o) {
      var f = r.pendingProps,
        b = f.revealOrder,
        _ = f.tail;
      f = f.children;
      var A = jn.current,
        D = (A & 2) !== 0;
      if (
        (D ? ((A = (A & 1) | 2), (r.flags |= 128)) : (A &= 1),
        xe(jn, A),
        wn(s, r, f, o),
        (f = wt ? zn : 0),
        !D && s !== null && (s.flags & 128) !== 0)
      )
        e: for (s = r.child; s !== null; ) {
          if (s.tag === 13) s.memoizedState !== null && ry(s, o, r);
          else if (s.tag === 19) ry(s, o, r);
          else if (s.child !== null) {
            ((s.child.return = s), (s = s.child));
            continue;
          }
          if (s === r) break e;
          for (; s.sibling === null; ) {
            if (s.return === null || s.return === r) break e;
            s = s.return;
          }
          ((s.sibling.return = s.return), (s = s.sibling));
        }
      switch (b) {
        case "forwards":
          for (o = r.child, b = null; o !== null; )
            ((s = o.alternate),
              s !== null && Ed(s) === null && (b = o),
              (o = o.sibling));
          ((o = b),
            o === null
              ? ((b = r.child), (r.child = null))
              : ((b = o.sibling), (o.sibling = null)),
            om(r, !1, b, o, _, f));
          break;
        case "backwards":
        case "unstable_legacy-backwards":
          for (o = null, b = r.child, r.child = null; b !== null; ) {
            if (((s = b.alternate), s !== null && Ed(s) === null)) {
              r.child = b;
              break;
            }
            ((s = b.sibling), (b.sibling = o), (o = b), (b = s));
          }
          om(r, !0, o, null, _, f);
          break;
        case "together":
          om(r, !1, null, null, void 0, f);
          break;
        default:
          r.memoizedState = null;
      }
      return r.child;
    }
    function Or(s, r, o) {
      if (
        (s !== null && (r.dependencies = s.dependencies),
        (Va |= r.lanes),
        (o & r.childLanes) === 0)
      )
        if (s !== null) {
          if ((Bo(s, r, o, !1), (o & r.childLanes) === 0)) return null;
        } else return null;
      if (s !== null && r.child !== s.child) throw Error(i(153));
      if (r.child !== null) {
        for (
          s = r.child, o = Cs(s, s.pendingProps), r.child = o, o.return = r;
          s.sibling !== null;

        )
          ((s = s.sibling),
            (o = o.sibling = Cs(s, s.pendingProps)),
            (o.return = r));
        o.sibling = null;
      }
      return r.child;
    }
    function $d(s, r) {
      return (s.lanes & r) !== 0
        ? !0
        : ((s = s.dependencies), !!(s !== null && vd(s)));
    }
    function O1(s, r, o) {
      switch (r.tag) {
        case 3:
          (ut(r, r.stateNode.containerInfo),
            Pa(r, In, s.memoizedState.cache),
            k());
          break;
        case 27:
        case 5:
          di(r);
          break;
        case 4:
          ut(r, r.stateNode.containerInfo);
          break;
        case 10:
          Pa(r, r.type, r.memoizedProps.value);
          break;
        case 31:
          if (r.memoizedState !== null) return ((r.flags |= 128), vu(r), null);
          break;
        case 13:
          var f = r.memoizedState;
          if (f !== null)
            return f.dehydrated !== null
              ? (Fa(r), (r.flags |= 128), null)
              : (o & r.child.childLanes) !== 0
                ? oi(s, r, o)
                : (Fa(r), (s = Or(s, r, o)), s !== null ? s.sibling : null);
          Fa(r);
          break;
        case 19:
          var b = (s.flags & 128) !== 0;
          if (
            ((f = (o & r.childLanes) !== 0),
            f || (Bo(s, r, o, !1), (f = (o & r.childLanes) !== 0)),
            b)
          ) {
            if (f) return ic(s, r, o);
            r.flags |= 128;
          }
          if (
            ((b = r.memoizedState),
            b !== null &&
              ((b.rendering = null), (b.tail = null), (b.lastEffect = null)),
            xe(jn, jn.current),
            f)
          )
            break;
          return null;
        case 22:
          return ((r.lanes = 0), qa(s, r, o, r.pendingProps));
        case 24:
          Pa(r, In, s.memoizedState.cache);
      }
      return Or(s, r, o);
    }
    function ay(s, r, o) {
      if (s !== null)
        if (s.memoizedProps !== r.pendingProps) pn = !0;
        else {
          if (!$d(s, o) && (r.flags & 128) === 0)
            return ((pn = !1), O1(s, r, o));
          pn = (s.flags & 131072) !== 0;
        }
      else ((pn = !1), wt && (r.flags & 1048576) !== 0 && gd(r, zn, r.index));
      switch (((r.lanes = 0), r.tag)) {
        case 16:
          e: {
            var f = r.pendingProps;
            if (((s = Js(r.elementType)), (r.type = s), typeof s == "function"))
              Wr(s)
                ? ((f = gi(s, f)), (r.tag = 1), (r = rm(null, r, s, f, o)))
                : ((r.tag = 0), (r = Yd(null, r, s, f, o)));
            else {
              if (s != null) {
                var b = s.$$typeof;
                if (b === R) {
                  ((r.tag = 11), (r = Ge(null, r, s, f, o)));
                  break e;
                } else if (b === Y) {
                  ((r.tag = 14), (r = Au(null, r, s, f, o)));
                  break e;
                }
              }
              throw ((r = be(s) || s), Error(i(306, r, "")));
            }
          }
          return r;
        case 0:
          return Yd(s, r, r.type, r.pendingProps, o);
        case 1:
          return ((f = r.type), (b = gi(f, r.pendingProps)), rm(s, r, f, b, o));
        case 3:
          e: {
            if ((ut(r, r.stateNode.containerInfo), s === null))
              throw Error(i(387));
            f = r.pendingProps;
            var _ = r.memoizedState;
            ((b = _.element), wd(s, r), Vo(r, f, null, o));
            var A = r.memoizedState;
            if (
              ((f = A.cache),
              Pa(r, In, f),
              f !== _.cache && jp(r, [In], o, !0),
              Hl(),
              (f = A.element),
              _.isDehydrated)
            )
              if (
                ((_ = { element: f, isDehydrated: !1, cache: A.cache }),
                (r.updateQueue.baseState = _),
                (r.memoizedState = _),
                r.flags & 256)
              ) {
                r = sy(s, r, f, o);
                break e;
              } else if (f !== b) {
                ((b = Zi(Error(i(424)), r)), za(b), (r = sy(s, r, f, o)));
                break e;
              } else {
                switch (((s = r.stateNode.containerInfo), s.nodeType)) {
                  case 9:
                    s = s.body;
                    break;
                  default:
                    s = s.nodeName === "HTML" ? s.ownerDocument.body : s;
                }
                for (
                  It = Ps(s.firstChild),
                    Pn = r,
                    wt = !0,
                    La = null,
                    Ns = !0,
                    o = Rp(r, null, f, o),
                    r.child = o;
                  o;

                )
                  ((o.flags = (o.flags & -3) | 4096), (o = o.sibling));
              }
            else {
              if ((k(), f === b)) {
                r = Or(s, r, o);
                break e;
              }
              wn(s, r, f, o);
            }
            r = r.child;
          }
          return r;
        case 26:
          return (
            Hd(s, r),
            s === null
              ? (o = Ky(r.type, null, r.pendingProps, null))
                ? (r.memoizedState = o)
                : wt ||
                  ((o = r.type),
                  (s = r.pendingProps),
                  (f = tf(Re.current).createElement(o)),
                  (f[Dn] = r),
                  (f[on] = s),
                  ni(f, o, s),
                  ft(f),
                  (r.stateNode = f))
              : (r.memoizedState = Ky(
                  r.type,
                  s.memoizedProps,
                  r.pendingProps,
                  s.memoizedState,
                )),
            null
          );
        case 27:
          return (
            di(r),
            s === null &&
              wt &&
              ((f = r.stateNode = Xy(r.type, r.pendingProps, Re.current)),
              (Pn = r),
              (Ns = !0),
              (b = It),
              Qe(r.type) ? (($m = b), (It = Ps(f.firstChild))) : (It = b)),
            wn(s, r, r.pendingProps.children, o),
            Hd(s, r),
            s === null && (r.flags |= 4194304),
            r.child
          );
        case 5:
          return (
            s === null &&
              wt &&
              ((b = f = It) &&
                ((f = Y1(f, r.type, r.pendingProps, Ns)),
                f !== null
                  ? ((r.stateNode = f),
                    (Pn = r),
                    (It = Ps(f.firstChild)),
                    (Ns = !1),
                    (b = !0))
                  : (b = !1)),
              b || Da(r)),
            di(r),
            (b = r.type),
            (_ = r.pendingProps),
            (A = s !== null ? s.memoizedProps : null),
            (f = _.children),
            Ka(b, _) ? (f = null) : A !== null && Ka(b, A) && (r.flags |= 32),
            r.memoizedState !== null &&
              ((b = jd(s, r, S1, null, null, o)), (yc._currentValue = b)),
            Hd(s, r),
            wn(s, r, f, o),
            r.child
          );
        case 6:
          return (
            s === null &&
              wt &&
              ((s = o = It) &&
                ((o = Ut(o, r.pendingProps, Ns)),
                o !== null
                  ? ((r.stateNode = o), (Pn = r), (It = null), (s = !0))
                  : (s = !1)),
              s || Da(r)),
            null
          );
        case 13:
          return oi(s, r, o);
        case 4:
          return (
            ut(r, r.stateNode.containerInfo),
            (f = r.pendingProps),
            s === null ? (r.child = Ia(r, null, f, o)) : wn(s, r, f, o),
            r.child
          );
        case 11:
          return Ge(s, r, r.type, r.pendingProps, o);
        case 7:
          return (wn(s, r, r.pendingProps, o), r.child);
        case 8:
          return (wn(s, r, r.pendingProps.children, o), r.child);
        case 12:
          return (wn(s, r, r.pendingProps.children, o), r.child);
        case 10:
          return (
            (f = r.pendingProps),
            Pa(r, r.type, f.value),
            wn(s, r, f.children, o),
            r.child
          );
        case 9:
          return (
            (b = r.type._context),
            (f = r.pendingProps.children),
            Ul(r),
            (b = Jn(b)),
            (f = f(b)),
            (r.flags |= 1),
            wn(s, r, f, o),
            r.child
          );
        case 14:
          return Au(s, r, r.type, r.pendingProps, o);
        case 15:
          return Fd(s, r, r.type, r.pendingProps, o);
        case 19:
          return ic(s, r, o);
        case 31:
          return C1(s, r, o);
        case 22:
          return qa(s, r, o, r.pendingProps);
        case 24:
          return (
            Ul(r),
            (f = Jn(In)),
            s === null
              ? ((b = Np()),
                b === null &&
                  ((b = tn),
                  (_ = Ks()),
                  (b.pooledCache = _),
                  _.refCount++,
                  _ !== null && (b.pooledCacheLanes |= o),
                  (b = _)),
                (r.memoizedState = { parent: f, cache: b }),
                Tr(r),
                Pa(r, In, b))
              : ((s.lanes & o) !== 0 && (wd(s, r), Vo(r, null, null, o), Hl()),
                (b = s.memoizedState),
                (_ = r.memoizedState),
                b.parent !== f
                  ? ((b = { parent: f, cache: f }),
                    (r.memoizedState = b),
                    r.lanes === 0 &&
                      (r.memoizedState = r.updateQueue.baseState = b),
                    Pa(r, In, f))
                  : ((f = _.cache),
                    Pa(r, In, f),
                    f !== b.cache && jp(r, [In], o, !0))),
            wn(s, r, r.pendingProps.children, o),
            r.child
          );
        case 29:
          throw r.pendingProps;
      }
      throw Error(i(156, r.tag));
    }
    function ta(s) {
      s.flags |= 4;
    }
    function cm(s, r, o, f, b) {
      if (((r = (s.mode & 32) !== 0) && (r = !1), r)) {
        if (((s.flags |= 16777216), (b & 335544128) === b))
          if (s.stateNode.complete) s.flags |= 8192;
          else if (Gu()) s.flags |= 8192;
          else throw ((Sr = xd), bd);
      } else s.flags &= -16777217;
    }
    function um(s, r) {
      if (r.type !== "stylesheet" || (r.state.loading & 4) !== 0)
        s.flags &= -16777217;
      else if (((s.flags |= 16777216), !i0(r)))
        if (Gu()) s.flags |= 8192;
        else throw ((Sr = xd), bd);
    }
    function zu(s, r) {
      (r !== null && (s.flags |= 4),
        s.flags & 16384 &&
          ((r = s.tag !== 22 ? br() : 536870912), (s.lanes |= r), (lc |= r)));
    }
    function Pu(s, r) {
      if (!wt)
        switch (s.tailMode) {
          case "hidden":
            r = s.tail;
            for (var o = null; r !== null; )
              (r.alternate !== null && (o = r), (r = r.sibling));
            o === null ? (s.tail = null) : (o.sibling = null);
            break;
          case "collapsed":
            o = s.tail;
            for (var f = null; o !== null; )
              (o.alternate !== null && (f = o), (o = o.sibling));
            f === null
              ? r || s.tail === null
                ? (s.tail = null)
                : (s.tail.sibling = null)
              : (f.sibling = null);
        }
    }
    function en(s) {
      var r = s.alternate !== null && s.alternate.child === s.child,
        o = 0,
        f = 0;
      if (r)
        for (var b = s.child; b !== null; )
          ((o |= b.lanes | b.childLanes),
            (f |= b.subtreeFlags & 65011712),
            (f |= b.flags & 65011712),
            (b.return = s),
            (b = b.sibling));
      else
        for (b = s.child; b !== null; )
          ((o |= b.lanes | b.childLanes),
            (f |= b.subtreeFlags),
            (f |= b.flags),
            (b.return = s),
            (b = b.sibling));
      return ((s.subtreeFlags |= f), (s.childLanes = o), r);
    }
    function ly(s, r, o) {
      var f = r.pendingProps;
      switch ((Pl(r), r.tag)) {
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return (en(r), null);
        case 1:
          return (en(r), null);
        case 3:
          return (
            (o = r.stateNode),
            (f = null),
            s !== null && (f = s.memoizedState.cache),
            r.memoizedState.cache !== f && (r.flags |= 2048),
            Zr(In),
            ot(),
            o.pendingContext &&
              ((o.context = o.pendingContext), (o.pendingContext = null)),
            (s === null || s.child === null) &&
              (Il(r)
                ? ta(r)
                : s === null ||
                  (s.memoizedState.isDehydrated && (r.flags & 256) === 0) ||
                  ((r.flags |= 1024), ka())),
            en(r),
            null
          );
        case 26:
          var b = r.type,
            _ = r.memoizedState;
          return (
            s === null
              ? (ta(r),
                _ !== null ? (en(r), um(r, _)) : (en(r), cm(r, b, null, f, o)))
              : _
                ? _ !== s.memoizedState
                  ? (ta(r), en(r), um(r, _))
                  : (en(r), (r.flags &= -16777217))
                : ((s = s.memoizedProps),
                  s !== f && ta(r),
                  en(r),
                  cm(r, b, s, f, o)),
            null
          );
        case 27:
          if (
            (ri(r),
            (o = Re.current),
            (b = r.type),
            s !== null && r.stateNode != null)
          )
            s.memoizedProps !== f && ta(r);
          else {
            if (!f) {
              if (r.stateNode === null) throw Error(i(166));
              return (en(r), null);
            }
            ((s = Me.current),
              Il(r) ? fu(r) : ((s = Xy(b, f, o)), (r.stateNode = s), ta(r)));
          }
          return (en(r), null);
        case 5:
          if ((ri(r), (b = r.type), s !== null && r.stateNode != null))
            s.memoizedProps !== f && ta(r);
          else {
            if (!f) {
              if (r.stateNode === null) throw Error(i(166));
              return (en(r), null);
            }
            if (((_ = Me.current), Il(r))) fu(r);
            else {
              var A = tf(Re.current);
              switch (_) {
                case 1:
                  _ = A.createElementNS("http://www.w3.org/2000/svg", b);
                  break;
                case 2:
                  _ = A.createElementNS(
                    "http://www.w3.org/1998/Math/MathML",
                    b,
                  );
                  break;
                default:
                  switch (b) {
                    case "svg":
                      _ = A.createElementNS("http://www.w3.org/2000/svg", b);
                      break;
                    case "math":
                      _ = A.createElementNS(
                        "http://www.w3.org/1998/Math/MathML",
                        b,
                      );
                      break;
                    case "script":
                      ((_ = A.createElement("div")),
                        (_.innerHTML = "<script><\/script>"),
                        (_ = _.removeChild(_.firstChild)));
                      break;
                    case "select":
                      ((_ =
                        typeof f.is == "string"
                          ? A.createElement("select", { is: f.is })
                          : A.createElement("select")),
                        f.multiple
                          ? (_.multiple = !0)
                          : f.size && (_.size = f.size));
                      break;
                    default:
                      _ =
                        typeof f.is == "string"
                          ? A.createElement(b, { is: f.is })
                          : A.createElement(b);
                  }
              }
              ((_[Dn] = r), (_[on] = f));
              e: for (A = r.child; A !== null; ) {
                if (A.tag === 5 || A.tag === 6) _.appendChild(A.stateNode);
                else if (A.tag !== 4 && A.tag !== 27 && A.child !== null) {
                  ((A.child.return = A), (A = A.child));
                  continue;
                }
                if (A === r) break e;
                for (; A.sibling === null; ) {
                  if (A.return === null || A.return === r) break e;
                  A = A.return;
                }
                ((A.sibling.return = A.return), (A = A.sibling));
              }
              r.stateNode = _;
              e: switch ((ni(_, b, f), b)) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  f = !!f.autoFocus;
                  break e;
                case "img":
                  f = !0;
                  break e;
                default:
                  f = !1;
              }
              f && ta(r);
            }
          }
          return (
            en(r),
            cm(
              r,
              r.type,
              s === null ? null : s.memoizedProps,
              r.pendingProps,
              o,
            ),
            null
          );
        case 6:
          if (s && r.stateNode != null) s.memoizedProps !== f && ta(r);
          else {
            if (typeof f != "string" && r.stateNode === null)
              throw Error(i(166));
            if (((s = Re.current), Il(r))) {
              if (
                ((s = r.stateNode),
                (o = r.memoizedProps),
                (f = null),
                (b = Pn),
                b !== null)
              )
                switch (b.tag) {
                  case 27:
                  case 5:
                    f = b.memoizedProps;
                }
              ((s[Dn] = r),
                (s = !!(
                  s.nodeValue === o ||
                  (f !== null && f.suppressHydrationWarning === !0) ||
                  Hy(s.nodeValue, o)
                )),
                s || Da(r, !0));
            } else
              ((s = tf(s).createTextNode(f)), (s[Dn] = r), (r.stateNode = s));
          }
          return (en(r), null);
        case 31:
          if (((o = r.memoizedState), s === null || s.memoizedState !== null)) {
            if (((f = Il(r)), o !== null)) {
              if (s === null) {
                if (!f) throw Error(i(318));
                if (
                  ((s = r.memoizedState),
                  (s = s !== null ? s.dehydrated : null),
                  !s)
                )
                  throw Error(i(557));
                s[Dn] = r;
              } else
                (k(),
                  (r.flags & 128) === 0 && (r.memoizedState = null),
                  (r.flags |= 4));
              (en(r), (s = !1));
            } else
              ((o = ka()),
                s !== null &&
                  s.memoizedState !== null &&
                  (s.memoizedState.hydrationErrors = o),
                (s = !0));
            if (!s) return r.flags & 256 ? (Ei(r), r) : (Ei(r), null);
            if ((r.flags & 128) !== 0) throw Error(i(558));
          }
          return (en(r), null);
        case 13:
          if (
            ((f = r.memoizedState),
            s === null ||
              (s.memoizedState !== null && s.memoizedState.dehydrated !== null))
          ) {
            if (((b = Il(r)), f !== null && f.dehydrated !== null)) {
              if (s === null) {
                if (!b) throw Error(i(318));
                if (
                  ((b = r.memoizedState),
                  (b = b !== null ? b.dehydrated : null),
                  !b)
                )
                  throw Error(i(317));
                b[Dn] = r;
              } else
                (k(),
                  (r.flags & 128) === 0 && (r.memoizedState = null),
                  (r.flags |= 4));
              (en(r), (b = !1));
            } else
              ((b = ka()),
                s !== null &&
                  s.memoizedState !== null &&
                  (s.memoizedState.hydrationErrors = b),
                (b = !0));
            if (!b) return r.flags & 256 ? (Ei(r), r) : (Ei(r), null);
          }
          return (
            Ei(r),
            (r.flags & 128) !== 0
              ? ((r.lanes = o), r)
              : ((o = f !== null),
                (s = s !== null && s.memoizedState !== null),
                o &&
                  ((f = r.child),
                  (b = null),
                  f.alternate !== null &&
                    f.alternate.memoizedState !== null &&
                    f.alternate.memoizedState.cachePool !== null &&
                    (b = f.alternate.memoizedState.cachePool.pool),
                  (_ = null),
                  f.memoizedState !== null &&
                    f.memoizedState.cachePool !== null &&
                    (_ = f.memoizedState.cachePool.pool),
                  _ !== b && (f.flags |= 2048)),
                o !== s && o && (r.child.flags |= 8192),
                zu(r, r.updateQueue),
                en(r),
                null)
          );
        case 4:
          return (
            ot(),
            s === null && Im(r.stateNode.containerInfo),
            en(r),
            null
          );
        case 10:
          return (Zr(r.type), en(r), null);
        case 19:
          if ((ae(jn), (f = r.memoizedState), f === null)) return (en(r), null);
          if (((b = (r.flags & 128) !== 0), (_ = f.rendering), _ === null))
            if (b) Pu(f, !1);
            else {
              if (mn !== 0 || (s !== null && (s.flags & 128) !== 0))
                for (s = r.child; s !== null; ) {
                  if (((_ = Ed(s)), _ !== null)) {
                    for (
                      r.flags |= 128,
                        Pu(f, !1),
                        s = _.updateQueue,
                        r.updateQueue = s,
                        zu(r, s),
                        r.subtreeFlags = 0,
                        s = o,
                        o = r.child;
                      o !== null;

                    )
                      (Dv(o, s), (o = o.sibling));
                    return (
                      xe(jn, (jn.current & 1) | 2),
                      wt && Ki(r, f.treeForkCount),
                      r.child
                    );
                  }
                  s = s.sibling;
                }
              f.tail !== null &&
                Xn() > Vl &&
                ((r.flags |= 128), (b = !0), Pu(f, !1), (r.lanes = 4194304));
            }
          else {
            if (!b)
              if (((s = Ed(_)), s !== null)) {
                if (
                  ((r.flags |= 128),
                  (b = !0),
                  (s = s.updateQueue),
                  (r.updateQueue = s),
                  zu(r, s),
                  Pu(f, !0),
                  f.tail === null &&
                    f.tailMode === "hidden" &&
                    !_.alternate &&
                    !wt)
                )
                  return (en(r), null);
              } else
                2 * Xn() - f.renderingStartTime > Vl &&
                  o !== 536870912 &&
                  ((r.flags |= 128), (b = !0), Pu(f, !1), (r.lanes = 4194304));
            f.isBackwards
              ? ((_.sibling = r.child), (r.child = _))
              : ((s = f.last),
                s !== null ? (s.sibling = _) : (r.child = _),
                (f.last = _));
          }
          return f.tail !== null
            ? ((s = f.tail),
              (f.rendering = s),
              (f.tail = s.sibling),
              (f.renderingStartTime = Xn()),
              (s.sibling = null),
              (o = jn.current),
              xe(jn, b ? (o & 1) | 2 : o & 1),
              wt && Ki(r, f.treeForkCount),
              s)
            : (en(r), null);
        case 22:
        case 23:
          return (
            Ei(r),
            gu(),
            (f = r.memoizedState !== null),
            s !== null
              ? (s.memoizedState !== null) !== f && (r.flags |= 8192)
              : f && (r.flags |= 8192),
            f
              ? (o & 536870912) !== 0 &&
                (r.flags & 128) === 0 &&
                (en(r), r.subtreeFlags & 6 && (r.flags |= 8192))
              : en(r),
            (o = r.updateQueue),
            o !== null && zu(r, o.retryQueue),
            (o = null),
            s !== null &&
              s.memoizedState !== null &&
              s.memoizedState.cachePool !== null &&
              (o = s.memoizedState.cachePool.pool),
            (f = null),
            r.memoizedState !== null &&
              r.memoizedState.cachePool !== null &&
              (f = r.memoizedState.cachePool.pool),
            f !== o && (r.flags |= 2048),
            s !== null && ae(Bl),
            null
          );
        case 24:
          return (
            (o = null),
            s !== null && (o = s.memoizedState.cache),
            r.memoizedState.cache !== o && (r.flags |= 2048),
            Zr(In),
            en(r),
            null
          );
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(i(156, r.tag));
    }
    function Iu(s, r) {
      switch ((Pl(r), r.tag)) {
        case 1:
          return (
            (s = r.flags),
            s & 65536 ? ((r.flags = (s & -65537) | 128), r) : null
          );
        case 3:
          return (
            Zr(In),
            ot(),
            (s = r.flags),
            (s & 65536) !== 0 && (s & 128) === 0
              ? ((r.flags = (s & -65537) | 128), r)
              : null
          );
        case 26:
        case 27:
        case 5:
          return (ri(r), null);
        case 31:
          if (r.memoizedState !== null) {
            if ((Ei(r), r.alternate === null)) throw Error(i(340));
            k();
          }
          return (
            (s = r.flags),
            s & 65536 ? ((r.flags = (s & -65537) | 128), r) : null
          );
        case 13:
          if (
            (Ei(r), (s = r.memoizedState), s !== null && s.dehydrated !== null)
          ) {
            if (r.alternate === null) throw Error(i(340));
            k();
          }
          return (
            (s = r.flags),
            s & 65536 ? ((r.flags = (s & -65537) | 128), r) : null
          );
        case 19:
          return (ae(jn), null);
        case 4:
          return (ot(), null);
        case 10:
          return (Zr(r.type), null);
        case 22:
        case 23:
          return (
            Ei(r),
            gu(),
            s !== null && ae(Bl),
            (s = r.flags),
            s & 65536 ? ((r.flags = (s & -65537) | 128), r) : null
          );
        case 24:
          return (Zr(In), null);
        case 25:
          return null;
        default:
          return null;
      }
    }
    function Gd(s, r) {
      switch ((Pl(r), r.tag)) {
        case 3:
          (Zr(In), ot());
          break;
        case 26:
        case 27:
        case 5:
          ri(r);
          break;
        case 4:
          ot();
          break;
        case 31:
          r.memoizedState !== null && Ei(r);
          break;
        case 13:
          Ei(r);
          break;
        case 19:
          ae(jn);
          break;
        case 10:
          Zr(r.type);
          break;
        case 22:
        case 23:
          (Ei(r), gu(), s !== null && ae(Bl));
          break;
        case 24:
          Zr(In);
      }
    }
    function sc(s, r) {
      try {
        var o = r.updateQueue,
          f = o !== null ? o.lastEffect : null;
        if (f !== null) {
          var b = f.next;
          o = b;
          do {
            if ((o.tag & s) === s) {
              f = void 0;
              var _ = o.create,
                A = o.inst;
              ((f = _()), (A.destroy = f));
            }
            o = o.next;
          } while (o !== b);
        }
      } catch (D) {
        qt(r, r.return, D);
      }
    }
    function na(s, r, o) {
      try {
        var f = r.updateQueue,
          b = f !== null ? f.lastEffect : null;
        if (b !== null) {
          var _ = b.next;
          f = _;
          do {
            if ((f.tag & s) === s) {
              var A = f.inst,
                D = A.destroy;
              if (D !== void 0) {
                ((A.destroy = void 0), (b = r));
                var $ = o,
                  se = D;
                try {
                  se();
                } catch (ge) {
                  qt(b, $, ge);
                }
              }
            }
            f = f.next;
          } while (f !== _);
        }
      } catch (ge) {
        qt(r, r.return, ge);
      }
    }
    function Uu(s) {
      var r = s.updateQueue;
      if (r !== null) {
        var o = s.stateNode;
        try {
          Td(r, o);
        } catch (f) {
          qt(s, s.return, f);
        }
      }
    }
    function fm(s, r, o) {
      ((o.props = gi(s.type, s.memoizedProps)), (o.state = s.memoizedState));
      try {
        o.componentWillUnmount();
      } catch (f) {
        qt(s, r, f);
      }
    }
    function Oi(s, r) {
      try {
        var o = s.ref;
        if (o !== null) {
          switch (s.tag) {
            case 26:
            case 27:
            case 5:
              var f = s.stateNode;
              break;
            case 30:
              f = s.stateNode;
              break;
            default:
              f = s.stateNode;
          }
          typeof o == "function" ? (s.refCleanup = o(f)) : (o.current = f);
        }
      } catch (b) {
        qt(s, r, b);
      }
    }
    function ci(s, r) {
      var o = s.ref,
        f = s.refCleanup;
      if (o !== null)
        if (typeof f == "function")
          try {
            f();
          } catch (b) {
            qt(s, r, b);
          } finally {
            ((s.refCleanup = null),
              (s = s.alternate),
              s != null && (s.refCleanup = null));
          }
        else if (typeof o == "function")
          try {
            o(null);
          } catch (b) {
            qt(s, r, b);
          }
        else o.current = null;
    }
    function oy(s) {
      var r = s.type,
        o = s.memoizedProps,
        f = s.stateNode;
      try {
        e: switch (r) {
          case "button":
          case "input":
          case "select":
          case "textarea":
            o.autoFocus && f.focus();
            break e;
          case "img":
            o.src ? (f.src = o.src) : o.srcSet && (f.srcset = o.srcSet);
        }
      } catch (b) {
        qt(s, s.return, b);
      }
    }
    function Vd(s, r, o) {
      try {
        var f = s.stateNode;
        (F1(f, s.type, o, r), (f[on] = r));
      } catch (b) {
        qt(s, s.return, b);
      }
    }
    function cy(s) {
      return (
        s.tag === 5 ||
        s.tag === 3 ||
        s.tag === 26 ||
        (s.tag === 27 && Qe(s.type)) ||
        s.tag === 4
      );
    }
    function dm(s) {
      e: for (;;) {
        for (; s.sibling === null; ) {
          if (s.return === null || cy(s.return)) return null;
          s = s.return;
        }
        for (
          s.sibling.return = s.return, s = s.sibling;
          s.tag !== 5 && s.tag !== 6 && s.tag !== 18;

        ) {
          if (
            (s.tag === 27 && Qe(s.type)) ||
            s.flags & 2 ||
            s.child === null ||
            s.tag === 4
          )
            continue e;
          ((s.child.return = s), (s = s.child));
        }
        if (!(s.flags & 2)) return s.stateNode;
      }
    }
    function hm(s, r, o) {
      var f = s.tag;
      if (f === 5 || f === 6)
        ((s = s.stateNode),
          r
            ? (o.nodeType === 9
                ? o.body
                : o.nodeName === "HTML"
                  ? o.ownerDocument.body
                  : o
              ).insertBefore(s, r)
            : ((r =
                o.nodeType === 9
                  ? o.body
                  : o.nodeName === "HTML"
                    ? o.ownerDocument.body
                    : o),
              r.appendChild(s),
              (o = o._reactRootContainer),
              o != null || r.onclick !== null || (r.onclick = qr)));
      else if (
        f !== 4 &&
        (f === 27 && Qe(s.type) && ((o = s.stateNode), (r = null)),
        (s = s.child),
        s !== null)
      )
        for (hm(s, r, o), s = s.sibling; s !== null; )
          (hm(s, r, o), (s = s.sibling));
    }
    function Wd(s, r, o) {
      var f = s.tag;
      if (f === 5 || f === 6)
        ((s = s.stateNode), r ? o.insertBefore(s, r) : o.appendChild(s));
      else if (
        f !== 4 &&
        (f === 27 && Qe(s.type) && (o = s.stateNode), (s = s.child), s !== null)
      )
        for (Wd(s, r, o), s = s.sibling; s !== null; )
          (Wd(s, r, o), (s = s.sibling));
    }
    function uy(s) {
      var r = s.stateNode,
        o = s.memoizedProps;
      try {
        for (var f = s.type, b = r.attributes; b.length; )
          r.removeAttributeNode(b[0]);
        (ni(r, f, o), (r[Dn] = s), (r[on] = o));
      } catch (_) {
        qt(s, s.return, _);
      }
    }
    var ia = !1,
      Un = !1,
      pm = !1,
      fy = typeof WeakSet == "function" ? WeakSet : Set,
      Gn = null;
    function j1(s, r) {
      if (((s = s.containerInfo), (ef = mh), (s = Nv(s)), Ep(s))) {
        if ("selectionStart" in s)
          var o = { start: s.selectionStart, end: s.selectionEnd };
        else
          e: {
            o = ((o = s.ownerDocument) && o.defaultView) || window;
            var f = o.getSelection && o.getSelection();
            if (f && f.rangeCount !== 0) {
              o = f.anchorNode;
              var b = f.anchorOffset,
                _ = f.focusNode;
              f = f.focusOffset;
              try {
                (o.nodeType, _.nodeType);
              } catch {
                o = null;
                break e;
              }
              var A = 0,
                D = -1,
                $ = -1,
                se = 0,
                ge = 0,
                _e = s,
                re = null;
              t: for (;;) {
                for (
                  var ue;
                  _e !== o || (b !== 0 && _e.nodeType !== 3) || (D = A + b),
                    _e !== _ || (f !== 0 && _e.nodeType !== 3) || ($ = A + f),
                    _e.nodeType === 3 && (A += _e.nodeValue.length),
                    (ue = _e.firstChild) !== null;

                )
                  ((re = _e), (_e = ue));
                for (;;) {
                  if (_e === s) break t;
                  if (
                    (re === o && ++se === b && (D = A),
                    re === _ && ++ge === f && ($ = A),
                    (ue = _e.nextSibling) !== null)
                  )
                    break;
                  ((_e = re), (re = _e.parentNode));
                }
                _e = ue;
              }
              o = D === -1 || $ === -1 ? null : { start: D, end: $ };
            } else o = null;
          }
        o = o || { start: 0, end: 0 };
      } else o = null;
      for (
        Hm = { focusedElem: s, selectionRange: o }, mh = !1, Gn = r;
        Gn !== null;

      )
        if (
          ((r = Gn), (s = r.child), (r.subtreeFlags & 1028) !== 0 && s !== null)
        )
          ((s.return = r), (Gn = s));
        else
          for (; Gn !== null; ) {
            switch (((r = Gn), (_ = r.alternate), (s = r.flags), r.tag)) {
              case 0:
                if (
                  (s & 4) !== 0 &&
                  ((s = r.updateQueue),
                  (s = s !== null ? s.events : null),
                  s !== null)
                )
                  for (o = 0; o < s.length; o++)
                    ((b = s[o]), (b.ref.impl = b.nextImpl));
                break;
              case 11:
              case 15:
                break;
              case 1:
                if ((s & 1024) !== 0 && _ !== null) {
                  ((s = void 0),
                    (o = r),
                    (b = _.memoizedProps),
                    (_ = _.memoizedState),
                    (f = o.stateNode));
                  try {
                    var Ie = gi(o.type, b);
                    ((s = f.getSnapshotBeforeUpdate(Ie, _)),
                      (f.__reactInternalSnapshotBeforeUpdate = s));
                  } catch (Ve) {
                    qt(o, o.return, Ve);
                  }
                }
                break;
              case 3:
                if ((s & 1024) !== 0) {
                  if (
                    ((s = r.stateNode.containerInfo), (o = s.nodeType), o === 9)
                  )
                    lh(s);
                  else if (o === 1)
                    switch (s.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        lh(s);
                        break;
                      default:
                        s.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if ((s & 1024) !== 0) throw Error(i(163));
            }
            if (((s = r.sibling), s !== null)) {
              ((s.return = r.return), (Gn = s));
              break;
            }
            Gn = r.return;
          }
    }
    function mm(s, r, o) {
      var f = o.flags;
      switch (o.tag) {
        case 0:
        case 11:
        case 15:
          (ra(s, o), f & 4 && sc(5, o));
          break;
        case 1:
          if ((ra(s, o), f & 4))
            if (((s = o.stateNode), r === null))
              try {
                s.componentDidMount();
              } catch (A) {
                qt(o, o.return, A);
              }
            else {
              var b = gi(o.type, r.memoizedProps);
              r = r.memoizedState;
              try {
                s.componentDidUpdate(
                  b,
                  r,
                  s.__reactInternalSnapshotBeforeUpdate,
                );
              } catch (A) {
                qt(o, o.return, A);
              }
            }
          (f & 64 && Uu(o), f & 512 && Oi(o, o.return));
          break;
        case 3:
          if ((ra(s, o), f & 64 && ((s = o.updateQueue), s !== null))) {
            if (((r = null), o.child !== null))
              switch (o.child.tag) {
                case 27:
                case 5:
                  r = o.child.stateNode;
                  break;
                case 1:
                  r = o.child.stateNode;
              }
            try {
              Td(s, r);
            } catch (A) {
              qt(o, o.return, A);
            }
          }
          break;
        case 27:
          r === null && f & 4 && uy(o);
        case 26:
        case 5:
          (ra(s, o), r === null && f & 4 && oy(o), f & 512 && Oi(o, o.return));
          break;
        case 12:
          ra(s, o);
          break;
        case 31:
          (ra(s, o), f & 4 && vm(s, o));
          break;
        case 13:
          (ra(s, o),
            f & 4 && hy(s, o),
            f & 64 &&
              ((s = o.memoizedState),
              s !== null &&
                ((s = s.dehydrated),
                s !== null && ((o = nh.bind(null, o)), q1(s, o)))));
          break;
        case 22:
          if (((f = o.memoizedState !== null || ia), !f)) {
            ((r = (r !== null && r.memoizedState !== null) || Un), (b = ia));
            var _ = Un;
            ((ia = f),
              (Un = r) && !_
                ? jr(s, o, (o.subtreeFlags & 8772) !== 0)
                : ra(s, o),
              (ia = b),
              (Un = _));
          }
          break;
        case 30:
          break;
        default:
          ra(s, o);
      }
    }
    function gm(s) {
      var r = s.alternate;
      (r !== null && ((s.alternate = null), gm(r)),
        (s.child = null),
        (s.deletions = null),
        (s.sibling = null),
        s.tag === 5 && ((r = s.stateNode), r !== null && Z(r)),
        (s.stateNode = null),
        (s.return = null),
        (s.dependencies = null),
        (s.memoizedProps = null),
        (s.memoizedState = null),
        (s.pendingProps = null),
        (s.stateNode = null),
        (s.updateQueue = null));
    }
    var an = null,
      ji = !1;
    function sa(s, r, o) {
      for (o = o.child; o !== null; ) (dy(s, r, o), (o = o.sibling));
    }
    function dy(s, r, o) {
      if (Rn && typeof Rn.onCommitFiberUnmount == "function")
        try {
          Rn.onCommitFiberUnmount(_s, o);
        } catch {}
      switch (o.tag) {
        case 26:
          (Un || ci(o, r),
            sa(s, r, o),
            o.memoizedState
              ? o.memoizedState.count--
              : o.stateNode &&
                ((o = o.stateNode), o.parentNode.removeChild(o)));
          break;
        case 27:
          Un || ci(o, r);
          var f = an,
            b = ji;
          (Qe(o.type) && ((an = o.stateNode), (ji = !1)),
            sa(s, r, o),
            sf(o.stateNode),
            (an = f),
            (ji = b));
          break;
        case 5:
          Un || ci(o, r);
        case 6:
          if (
            ((f = an),
            (b = ji),
            (an = null),
            sa(s, r, o),
            (an = f),
            (ji = b),
            an !== null)
          )
            if (ji)
              try {
                (an.nodeType === 9
                  ? an.body
                  : an.nodeName === "HTML"
                    ? an.ownerDocument.body
                    : an
                ).removeChild(o.stateNode);
              } catch (_) {
                qt(o, r, _);
              }
            else
              try {
                an.removeChild(o.stateNode);
              } catch (_) {
                qt(o, r, _);
              }
          break;
        case 18:
          an !== null &&
            (ji
              ? ((s = an),
                qm(
                  s.nodeType === 9
                    ? s.body
                    : s.nodeName === "HTML"
                      ? s.ownerDocument.body
                      : s,
                  o.stateNode,
                ),
                xc(s))
              : qm(an, o.stateNode));
          break;
        case 4:
          ((f = an),
            (b = ji),
            (an = o.stateNode.containerInfo),
            (ji = !0),
            sa(s, r, o),
            (an = f),
            (ji = b));
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          (na(2, o, r), Un || na(4, o, r), sa(s, r, o));
          break;
        case 1:
          (Un ||
            (ci(o, r),
            (f = o.stateNode),
            typeof f.componentWillUnmount == "function" && fm(o, r, f)),
            sa(s, r, o));
          break;
        case 21:
          sa(s, r, o);
          break;
        case 22:
          ((Un = (f = Un) || o.memoizedState !== null), sa(s, r, o), (Un = f));
          break;
        default:
          sa(s, r, o);
      }
    }
    function vm(s, r) {
      if (
        r.memoizedState === null &&
        ((s = r.alternate), s !== null && ((s = s.memoizedState), s !== null))
      ) {
        s = s.dehydrated;
        try {
          xc(s);
        } catch (o) {
          qt(r, r.return, o);
        }
      }
    }
    function hy(s, r) {
      if (
        r.memoizedState === null &&
        ((s = r.alternate),
        s !== null &&
          ((s = s.memoizedState),
          s !== null && ((s = s.dehydrated), s !== null)))
      )
        try {
          xc(s);
        } catch (o) {
          qt(r, r.return, o);
        }
    }
    function M1(s) {
      switch (s.tag) {
        case 31:
        case 13:
        case 19:
          var r = s.stateNode;
          return (r === null && (r = s.stateNode = new fy()), r);
        case 22:
          return (
            (s = s.stateNode),
            (r = s._retryCache),
            r === null && (r = s._retryCache = new fy()),
            r
          );
        default:
          throw Error(i(435, s.tag));
      }
    }
    function Xd(s, r) {
      var o = M1(s);
      r.forEach(function (f) {
        if (!o.has(f)) {
          o.add(f);
          var b = z1.bind(null, s, f);
          f.then(b, b);
        }
      });
    }
    function Mi(s, r) {
      var o = r.deletions;
      if (o !== null)
        for (var f = 0; f < o.length; f++) {
          var b = o[f],
            _ = s,
            A = r,
            D = A;
          e: for (; D !== null; ) {
            switch (D.tag) {
              case 27:
                if (Qe(D.type)) {
                  ((an = D.stateNode), (ji = !1));
                  break e;
                }
                break;
              case 5:
                ((an = D.stateNode), (ji = !1));
                break e;
              case 3:
              case 4:
                ((an = D.stateNode.containerInfo), (ji = !0));
                break e;
            }
            D = D.return;
          }
          if (an === null) throw Error(i(160));
          (dy(_, A, b),
            (an = null),
            (ji = !1),
            (_ = b.alternate),
            _ !== null && (_.return = null),
            (b.return = null));
        }
      if (r.subtreeFlags & 13886)
        for (r = r.child; r !== null; ) (py(r, s), (r = r.sibling));
    }
    var ar = null;
    function py(s, r) {
      var o = s.alternate,
        f = s.flags;
      switch (s.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          (Mi(r, s),
            ln(s),
            f & 4 && (na(3, s, s.return), sc(3, s), na(5, s, s.return)));
          break;
        case 1:
          (Mi(r, s),
            ln(s),
            f & 512 && (Un || o === null || ci(o, o.return)),
            f & 64 &&
              ia &&
              ((s = s.updateQueue),
              s !== null &&
                ((f = s.callbacks),
                f !== null &&
                  ((o = s.shared.hiddenCallbacks),
                  (s.shared.hiddenCallbacks = o === null ? f : o.concat(f))))));
          break;
        case 26:
          var b = ar;
          if (
            (Mi(r, s),
            ln(s),
            f & 512 && (Un || o === null || ci(o, o.return)),
            f & 4)
          ) {
            var _ = o !== null ? o.memoizedState : null;
            if (((f = s.memoizedState), o === null))
              if (f === null)
                if (s.stateNode === null) {
                  e: {
                    ((f = s.type),
                      (o = s.memoizedProps),
                      (b = b.ownerDocument || b));
                    t: switch (f) {
                      case "title":
                        ((_ = b.getElementsByTagName("title")[0]),
                          (!_ ||
                            _[Fe] ||
                            _[Dn] ||
                            _.namespaceURI === "http://www.w3.org/2000/svg" ||
                            _.hasAttribute("itemprop")) &&
                            ((_ = b.createElement(f)),
                            b.head.insertBefore(
                              _,
                              b.querySelector("head > title"),
                            )),
                          ni(_, f, o),
                          (_[Dn] = s),
                          ft(_),
                          (f = _));
                        break e;
                      case "link":
                        var A = t0("link", "href", b).get(f + (o.href || ""));
                        if (A) {
                          for (var D = 0; D < A.length; D++)
                            if (
                              ((_ = A[D]),
                              _.getAttribute("href") ===
                                (o.href == null || o.href === ""
                                  ? null
                                  : o.href) &&
                                _.getAttribute("rel") ===
                                  (o.rel == null ? null : o.rel) &&
                                _.getAttribute("title") ===
                                  (o.title == null ? null : o.title) &&
                                _.getAttribute("crossorigin") ===
                                  (o.crossOrigin == null
                                    ? null
                                    : o.crossOrigin))
                            ) {
                              A.splice(D, 1);
                              break t;
                            }
                        }
                        ((_ = b.createElement(f)),
                          ni(_, f, o),
                          b.head.appendChild(_));
                        break;
                      case "meta":
                        if (
                          (A = t0("meta", "content", b).get(
                            f + (o.content || ""),
                          ))
                        ) {
                          for (D = 0; D < A.length; D++)
                            if (
                              ((_ = A[D]),
                              _.getAttribute("content") ===
                                (o.content == null ? null : "" + o.content) &&
                                _.getAttribute("name") ===
                                  (o.name == null ? null : o.name) &&
                                _.getAttribute("property") ===
                                  (o.property == null ? null : o.property) &&
                                _.getAttribute("http-equiv") ===
                                  (o.httpEquiv == null ? null : o.httpEquiv) &&
                                _.getAttribute("charset") ===
                                  (o.charSet == null ? null : o.charSet))
                            ) {
                              A.splice(D, 1);
                              break t;
                            }
                        }
                        ((_ = b.createElement(f)),
                          ni(_, f, o),
                          b.head.appendChild(_));
                        break;
                      default:
                        throw Error(i(468, f));
                    }
                    ((_[Dn] = s), ft(_), (f = _));
                  }
                  s.stateNode = f;
                } else n0(b, s.type, s.stateNode);
              else s.stateNode = e0(b, f, s.memoizedProps);
            else
              _ !== f
                ? (_ === null
                    ? o.stateNode !== null &&
                      ((o = o.stateNode), o.parentNode.removeChild(o))
                    : _.count--,
                  f === null
                    ? n0(b, s.type, s.stateNode)
                    : e0(b, f, s.memoizedProps))
                : f === null &&
                  s.stateNode !== null &&
                  Vd(s, s.memoizedProps, o.memoizedProps);
          }
          break;
        case 27:
          (Mi(r, s),
            ln(s),
            f & 512 && (Un || o === null || ci(o, o.return)),
            o !== null && f & 4 && Vd(s, s.memoizedProps, o.memoizedProps));
          break;
        case 5:
          if (
            (Mi(r, s),
            ln(s),
            f & 512 && (Un || o === null || ci(o, o.return)),
            s.flags & 32)
          ) {
            b = s.stateNode;
            try {
              Xs(b, "");
            } catch (Ie) {
              qt(s, s.return, Ie);
            }
          }
          (f & 4 &&
            s.stateNode != null &&
            ((b = s.memoizedProps), Vd(s, b, o !== null ? o.memoizedProps : b)),
            f & 1024 && (pm = !0));
          break;
        case 6:
          if ((Mi(r, s), ln(s), f & 4)) {
            if (s.stateNode === null) throw Error(i(162));
            ((f = s.memoizedProps), (o = s.stateNode));
            try {
              o.nodeValue = f;
            } catch (Ie) {
              qt(s, s.return, Ie);
            }
          }
          break;
        case 3:
          if (
            ((rf = null),
            (b = ar),
            (ar = ch(r.containerInfo)),
            Mi(r, s),
            (ar = b),
            ln(s),
            f & 4 && o !== null && o.memoizedState.isDehydrated)
          )
            try {
              xc(r.containerInfo);
            } catch (Ie) {
              qt(s, s.return, Ie);
            }
          pm && ((pm = !1), my(s));
          break;
        case 4:
          ((f = ar),
            (ar = ch(s.stateNode.containerInfo)),
            Mi(r, s),
            ln(s),
            (ar = f));
          break;
        case 12:
          (Mi(r, s), ln(s));
          break;
        case 31:
          (Mi(r, s),
            ln(s),
            f & 4 &&
              ((f = s.updateQueue),
              f !== null && ((s.updateQueue = null), Xd(s, f))));
          break;
        case 13:
          (Mi(r, s),
            ln(s),
            s.child.flags & 8192 &&
              (s.memoizedState !== null) !=
                (o !== null && o.memoizedState !== null) &&
              (qu = Xn()),
            f & 4 &&
              ((f = s.updateQueue),
              f !== null && ((s.updateQueue = null), Xd(s, f))));
          break;
        case 22:
          b = s.memoizedState !== null;
          var $ = o !== null && o.memoizedState !== null,
            se = ia,
            ge = Un;
          if (
            ((ia = se || b),
            (Un = ge || $),
            Mi(r, s),
            (Un = ge),
            (ia = se),
            ln(s),
            f & 8192)
          )
            e: for (
              r = s.stateNode,
                r._visibility = b ? r._visibility & -2 : r._visibility | 1,
                b && (o === null || $ || ia || Un || $l(s)),
                o = null,
                r = s;
              ;

            ) {
              if (r.tag === 5 || r.tag === 26) {
                if (o === null) {
                  $ = o = r;
                  try {
                    if (((_ = $.stateNode), b))
                      ((A = _.style),
                        typeof A.setProperty == "function"
                          ? A.setProperty("display", "none", "important")
                          : (A.display = "none"));
                    else {
                      D = $.stateNode;
                      var _e = $.memoizedProps.style,
                        re =
                          _e != null && _e.hasOwnProperty("display")
                            ? _e.display
                            : null;
                      D.style.display =
                        re == null || typeof re == "boolean"
                          ? ""
                          : ("" + re).trim();
                    }
                  } catch (Ie) {
                    qt($, $.return, Ie);
                  }
                }
              } else if (r.tag === 6) {
                if (o === null) {
                  $ = r;
                  try {
                    $.stateNode.nodeValue = b ? "" : $.memoizedProps;
                  } catch (Ie) {
                    qt($, $.return, Ie);
                  }
                }
              } else if (r.tag === 18) {
                if (o === null) {
                  $ = r;
                  try {
                    var ue = $.stateNode;
                    b ? cs(ue, !0) : cs($.stateNode, !1);
                  } catch (Ie) {
                    qt($, $.return, Ie);
                  }
                }
              } else if (
                ((r.tag !== 22 && r.tag !== 23) ||
                  r.memoizedState === null ||
                  r === s) &&
                r.child !== null
              ) {
                ((r.child.return = r), (r = r.child));
                continue;
              }
              if (r === s) break e;
              for (; r.sibling === null; ) {
                if (r.return === null || r.return === s) break e;
                (o === r && (o = null), (r = r.return));
              }
              (o === r && (o = null),
                (r.sibling.return = r.return),
                (r = r.sibling));
            }
          f & 4 &&
            ((f = s.updateQueue),
            f !== null &&
              ((o = f.retryQueue),
              o !== null && ((f.retryQueue = null), Xd(s, o))));
          break;
        case 19:
          (Mi(r, s),
            ln(s),
            f & 4 &&
              ((f = s.updateQueue),
              f !== null && ((s.updateQueue = null), Xd(s, f))));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          (Mi(r, s), ln(s));
      }
    }
    function ln(s) {
      var r = s.flags;
      if (r & 2) {
        try {
          for (var o, f = s.return; f !== null; ) {
            if (cy(f)) {
              o = f;
              break;
            }
            f = f.return;
          }
          if (o == null) throw Error(i(160));
          switch (o.tag) {
            case 27:
              var b = o.stateNode,
                _ = dm(s);
              Wd(s, _, b);
              break;
            case 5:
              var A = o.stateNode;
              o.flags & 32 && (Xs(A, ""), (o.flags &= -33));
              var D = dm(s);
              Wd(s, D, A);
              break;
            case 3:
            case 4:
              var $ = o.stateNode.containerInfo,
                se = dm(s);
              hm(s, se, $);
              break;
            default:
              throw Error(i(161));
          }
        } catch (ge) {
          qt(s, s.return, ge);
        }
        s.flags &= -3;
      }
      r & 4096 && (s.flags &= -4097);
    }
    function my(s) {
      if (s.subtreeFlags & 1024)
        for (s = s.child; s !== null; ) {
          var r = s;
          (my(r),
            r.tag === 5 && r.flags & 1024 && r.stateNode.reset(),
            (s = s.sibling));
        }
    }
    function ra(s, r) {
      if (r.subtreeFlags & 8772)
        for (r = r.child; r !== null; )
          (mm(s, r.alternate, r), (r = r.sibling));
    }
    function $l(s) {
      for (s = s.child; s !== null; ) {
        var r = s;
        switch (r.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
            (na(4, r, r.return), $l(r));
            break;
          case 1:
            ci(r, r.return);
            var o = r.stateNode;
            (typeof o.componentWillUnmount == "function" && fm(r, r.return, o),
              $l(r));
            break;
          case 27:
            sf(r.stateNode);
          case 26:
          case 5:
            (ci(r, r.return), $l(r));
            break;
          case 22:
            r.memoizedState === null && $l(r);
            break;
          case 30:
            $l(r);
            break;
          default:
            $l(r);
        }
        s = s.sibling;
      }
    }
    function jr(s, r, o) {
      for (o = o && (r.subtreeFlags & 8772) !== 0, r = r.child; r !== null; ) {
        var f = r.alternate,
          b = s,
          _ = r,
          A = _.flags;
        switch (_.tag) {
          case 0:
          case 11:
          case 15:
            (jr(b, _, o), sc(4, _));
            break;
          case 1:
            if (
              (jr(b, _, o),
              (f = _),
              (b = f.stateNode),
              typeof b.componentDidMount == "function")
            )
              try {
                b.componentDidMount();
              } catch (se) {
                qt(f, f.return, se);
              }
            if (((f = _), (b = f.updateQueue), b !== null)) {
              var D = f.stateNode;
              try {
                var $ = b.shared.hiddenCallbacks;
                if ($ !== null)
                  for (
                    b.shared.hiddenCallbacks = null, b = 0;
                    b < $.length;
                    b++
                  )
                    nr($[b], D);
              } catch (se) {
                qt(f, f.return, se);
              }
            }
            (o && A & 64 && Uu(_), Oi(_, _.return));
            break;
          case 27:
            uy(_);
          case 26:
          case 5:
            (jr(b, _, o), o && f === null && A & 4 && oy(_), Oi(_, _.return));
            break;
          case 12:
            jr(b, _, o);
            break;
          case 31:
            (jr(b, _, o), o && A & 4 && vm(b, _));
            break;
          case 13:
            (jr(b, _, o), o && A & 4 && hy(b, _));
            break;
          case 22:
            (_.memoizedState === null && jr(b, _, o), Oi(_, _.return));
            break;
          case 30:
            break;
          default:
            jr(b, _, o);
        }
        r = r.sibling;
      }
    }
    function ym(s, r) {
      var o = null;
      (s !== null &&
        s.memoizedState !== null &&
        s.memoizedState.cachePool !== null &&
        (o = s.memoizedState.cachePool.pool),
        (s = null),
        r.memoizedState !== null &&
          r.memoizedState.cachePool !== null &&
          (s = r.memoizedState.cachePool.pool),
        s !== o && (s != null && s.refCount++, o != null && du(o)));
    }
    function bm(s, r) {
      ((s = null),
        r.alternate !== null && (s = r.alternate.memoizedState.cache),
        (r = r.memoizedState.cache),
        r !== s && (r.refCount++, s != null && du(s)));
    }
    function lr(s, r, o, f) {
      if (r.subtreeFlags & 10256)
        for (r = r.child; r !== null; ) (gy(s, r, o, f), (r = r.sibling));
    }
    function gy(s, r, o, f) {
      var b = r.flags;
      switch (r.tag) {
        case 0:
        case 11:
        case 15:
          (lr(s, r, o, f), b & 2048 && sc(9, r));
          break;
        case 1:
          lr(s, r, o, f);
          break;
        case 3:
          (lr(s, r, o, f),
            b & 2048 &&
              ((s = null),
              r.alternate !== null && (s = r.alternate.memoizedState.cache),
              (r = r.memoizedState.cache),
              r !== s && (r.refCount++, s != null && du(s))));
          break;
        case 12:
          if (b & 2048) {
            (lr(s, r, o, f), (s = r.stateNode));
            try {
              var _ = r.memoizedProps,
                A = _.id,
                D = _.onPostCommit;
              typeof D == "function" &&
                D(
                  A,
                  r.alternate === null ? "mount" : "update",
                  s.passiveEffectDuration,
                  -0,
                );
            } catch ($) {
              qt(r, r.return, $);
            }
          } else lr(s, r, o, f);
          break;
        case 31:
          lr(s, r, o, f);
          break;
        case 13:
          lr(s, r, o, f);
          break;
        case 23:
          break;
        case 22:
          ((_ = r.stateNode),
            (A = r.alternate),
            r.memoizedState !== null
              ? _._visibility & 2
                ? lr(s, r, o, f)
                : Fu(s, r)
              : _._visibility & 2
                ? lr(s, r, o, f)
                : ((_._visibility |= 2),
                  $a(s, r, o, f, (r.subtreeFlags & 10256) !== 0 || !1)),
            b & 2048 && ym(A, r));
          break;
        case 24:
          (lr(s, r, o, f), b & 2048 && bm(r.alternate, r));
          break;
        default:
          lr(s, r, o, f);
      }
    }
    function $a(s, r, o, f, b) {
      for (
        b = b && ((r.subtreeFlags & 10256) !== 0 || !1), r = r.child;
        r !== null;

      ) {
        var _ = s,
          A = r,
          D = o,
          $ = f,
          se = A.flags;
        switch (A.tag) {
          case 0:
          case 11:
          case 15:
            ($a(_, A, D, $, b), sc(8, A));
            break;
          case 23:
            break;
          case 22:
            var ge = A.stateNode;
            (A.memoizedState !== null
              ? ge._visibility & 2
                ? $a(_, A, D, $, b)
                : Fu(_, A)
              : ((ge._visibility |= 2), $a(_, A, D, $, b)),
              b && se & 2048 && ym(A.alternate, A));
            break;
          case 24:
            ($a(_, A, D, $, b), b && se & 2048 && bm(A.alternate, A));
            break;
          default:
            $a(_, A, D, $, b);
        }
        r = r.sibling;
      }
    }
    function Fu(s, r) {
      if (r.subtreeFlags & 10256)
        for (r = r.child; r !== null; ) {
          var o = s,
            f = r,
            b = f.flags;
          switch (f.tag) {
            case 22:
              (Fu(o, f), b & 2048 && ym(f.alternate, f));
              break;
            case 24:
              (Fu(o, f), b & 2048 && bm(f.alternate, f));
              break;
            default:
              Fu(o, f);
          }
          r = r.sibling;
        }
    }
    var Bu = 8192;
    function rc(s, r, o) {
      if (s.subtreeFlags & Bu)
        for (s = s.child; s !== null; ) (vy(s, r, o), (s = s.sibling));
    }
    function vy(s, r, o) {
      switch (s.tag) {
        case 26:
          (rc(s, r, o),
            s.flags & Bu &&
              s.memoizedState !== null &&
              vc(o, ar, s.memoizedState, s.memoizedProps));
          break;
        case 5:
          rc(s, r, o);
          break;
        case 3:
        case 4:
          var f = ar;
          ((ar = ch(s.stateNode.containerInfo)), rc(s, r, o), (ar = f));
          break;
        case 22:
          s.memoizedState === null &&
            ((f = s.alternate),
            f !== null && f.memoizedState !== null
              ? ((f = Bu), (Bu = 16777216), rc(s, r, o), (Bu = f))
              : rc(s, r, o));
          break;
        default:
          rc(s, r, o);
      }
    }
    function yy(s) {
      var r = s.alternate;
      if (r !== null && ((s = r.child), s !== null)) {
        r.child = null;
        do ((r = s.sibling), (s.sibling = null), (s = r));
        while (s !== null);
      }
    }
    function Hu(s) {
      var r = s.deletions;
      if ((s.flags & 16) !== 0) {
        if (r !== null)
          for (var o = 0; o < r.length; o++) {
            var f = r[o];
            ((Gn = f), xy(f, s));
          }
        yy(s);
      }
      if (s.subtreeFlags & 10256)
        for (s = s.child; s !== null; ) (by(s), (s = s.sibling));
    }
    function by(s) {
      switch (s.tag) {
        case 0:
        case 11:
        case 15:
          (Hu(s), s.flags & 2048 && na(9, s, s.return));
          break;
        case 3:
          Hu(s);
          break;
        case 12:
          Hu(s);
          break;
        case 22:
          var r = s.stateNode;
          s.memoizedState !== null &&
          r._visibility & 2 &&
          (s.return === null || s.return.tag !== 13)
            ? ((r._visibility &= -3), Qd(s))
            : Hu(s);
          break;
        default:
          Hu(s);
      }
    }
    function Qd(s) {
      var r = s.deletions;
      if ((s.flags & 16) !== 0) {
        if (r !== null)
          for (var o = 0; o < r.length; o++) {
            var f = r[o];
            ((Gn = f), xy(f, s));
          }
        yy(s);
      }
      for (s = s.child; s !== null; ) {
        switch (((r = s), r.tag)) {
          case 0:
          case 11:
          case 15:
            (na(8, r, r.return), Qd(r));
            break;
          case 22:
            ((o = r.stateNode),
              o._visibility & 2 && ((o._visibility &= -3), Qd(r)));
            break;
          default:
            Qd(r);
        }
        s = s.sibling;
      }
    }
    function xy(s, r) {
      for (; Gn !== null; ) {
        var o = Gn;
        switch (o.tag) {
          case 0:
          case 11:
          case 15:
            na(8, o, r);
            break;
          case 23:
          case 22:
            if (
              o.memoizedState !== null &&
              o.memoizedState.cachePool !== null
            ) {
              var f = o.memoizedState.cachePool.pool;
              f != null && f.refCount++;
            }
            break;
          case 24:
            du(o.memoizedState.cache);
        }
        if (((f = o.child), f !== null)) ((f.return = o), (Gn = f));
        else
          e: for (o = s; Gn !== null; ) {
            f = Gn;
            var b = f.sibling,
              _ = f.return;
            if ((gm(f), f === o)) {
              Gn = null;
              break e;
            }
            if (b !== null) {
              ((b.return = _), (Gn = b));
              break e;
            }
            Gn = _;
          }
      }
    }
    var N1 = {
        getCacheForType: function (s) {
          var r = Jn(In),
            o = r.data.get(s);
          return (o === void 0 && ((o = s()), r.data.set(s, o)), o);
        },
        cacheSignal: function () {
          return Jn(In).controller.signal;
        },
      },
      A1 = typeof WeakMap == "function" ? WeakMap : Map,
      kt = 0,
      tn = null,
      mt = null,
      vt = 0,
      Yt = 0,
      ss = null,
      Ga = !1,
      ac = !1,
      xm = !1,
      or = 0,
      mn = 0,
      Va = 0,
      Gl = 0,
      _m = 0,
      rs = 0,
      lc = 0,
      Yu = null,
      Ni = null,
      wm = !1,
      qu = 0,
      _y = 0,
      Vl = 1 / 0,
      Zd = null,
      Wa = null,
      Yn = 0,
      Xa = null,
      oc = null,
      aa = 0,
      Sm = 0,
      Tm = null,
      wy = null,
      $u = 0,
      Em = null;
    function as() {
      return (kt & 2) !== 0 && vt !== 0 ? vt & -vt : V.T !== null ? ls() : Gc();
    }
    function Sy() {
      if (rs === 0)
        if ((vt & 536870912) === 0 || wt) {
          var s = yr;
          ((yr <<= 1), (yr & 3932160) === 0 && (yr = 262144), (rs = s));
        } else rs = 536870912;
      return ((s = es.current), s !== null && (s.flags |= 32), rs);
    }
    function Ai(s, r, o) {
      (((s === tn && (Yt === 2 || Yt === 9)) ||
        s.cancelPendingCommit !== null) &&
        (cc(s, 0), la(s, vt, rs, !1)),
        ja(s, o),
        ((kt & 2) === 0 || s !== tn) &&
          (s === tn &&
            ((kt & 2) === 0 && (Gl |= o), mn === 4 && la(s, vt, rs, !1)),
          Mr(s)));
    }
    function Ty(s, r, o) {
      if ((kt & 6) !== 0) throw Error(i(327));
      var f = (!o && (r & 127) === 0 && (r & s.expiredLanes) === 0) || Tl(s, r),
        b = f ? L1(s, r) : Om(s, r, !0),
        _ = f;
      do {
        if (b === 0) {
          ac && !f && la(s, r, 0, !1);
          break;
        } else {
          if (((o = s.current.alternate), _ && !Cy(o))) {
            ((b = Om(s, r, !1)), (_ = !1));
            continue;
          }
          if (b === 2) {
            if (((_ = r), s.errorRecoveryDisabledLanes & _)) var A = 0;
            else
              ((A = s.pendingLanes & -536870913),
                (A = A !== 0 ? A : A & 536870912 ? 536870912 : 0));
            if (A !== 0) {
              r = A;
              e: {
                var D = s;
                b = Yu;
                var $ = D.current.memoizedState.isDehydrated;
                if (
                  ($ && (cc(D, A).flags |= 256), (A = Om(D, A, !1)), A !== 2)
                ) {
                  if (xm && !$) {
                    ((D.errorRecoveryDisabledLanes |= _), (Gl |= _), (b = 4));
                    break e;
                  }
                  ((_ = Ni),
                    (Ni = b),
                    _ !== null &&
                      (Ni === null ? (Ni = _) : Ni.push.apply(Ni, _)));
                }
                b = A;
              }
              if (((_ = !1), b !== 2)) continue;
            }
          }
          if (b === 1) {
            (cc(s, 0), la(s, r, 0, !0));
            break;
          }
          e: {
            switch (((f = s), (_ = b), _)) {
              case 0:
              case 1:
                throw Error(i(345));
              case 4:
                if ((r & 4194048) !== r) break;
              case 6:
                la(f, r, rs, !Ga);
                break e;
              case 2:
                Ni = null;
                break;
              case 3:
              case 5:
                break;
              default:
                throw Error(i(329));
            }
            if ((r & 62914560) === r && ((b = qu + 300 - Xn()), 10 < b)) {
              if ((la(f, r, rs, !Ga), Eo(f, 0, !0) !== 0)) break e;
              ((aa = r),
                (f.timeoutHandle = Yy(
                  Ey.bind(
                    null,
                    f,
                    o,
                    Ni,
                    Zd,
                    wm,
                    r,
                    rs,
                    Gl,
                    lc,
                    Ga,
                    _,
                    "Throttled",
                    -0,
                    0,
                  ),
                  b,
                )));
              break e;
            }
            Ey(f, o, Ni, Zd, wm, r, rs, Gl, lc, Ga, _, null, -0, 0);
          }
        }
        break;
      } while (!0);
      Mr(s);
    }
    function Ey(s, r, o, f, b, _, A, D, $, se, ge, _e, re, ue) {
      if (
        ((s.timeoutHandle = -1),
        (_e = r.subtreeFlags),
        _e & 8192 || (_e & 16785408) === 16785408)
      ) {
        ((_e = {
          stylesheets: null,
          count: 0,
          imgCount: 0,
          imgBytes: 0,
          suspenseyImages: [],
          waitingForImages: !0,
          waitingForViewTransition: !1,
          unsuspend: qr,
        }),
          vy(r, _, _e));
        var Ie =
          (_ & 62914560) === _
            ? qu - Xn()
            : (_ & 4194048) === _
              ? _y - Xn()
              : 0;
        if (((Ie = J1(_e, Ie)), Ie !== null)) {
          ((aa = _),
            (s.cancelPendingCommit = Ie(
              Ry.bind(null, s, r, _, o, f, b, A, D, $, ge, _e, null, re, ue),
            )),
            la(s, _, A, !se));
          return;
        }
      }
      Ry(s, r, _, o, f, b, A, D, $);
    }
    function Cy(s) {
      for (var r = s; ; ) {
        var o = r.tag;
        if (
          (o === 0 || o === 11 || o === 15) &&
          r.flags & 16384 &&
          ((o = r.updateQueue), o !== null && ((o = o.stores), o !== null))
        )
          for (var f = 0; f < o.length; f++) {
            var b = o[f],
              _ = b.getSnapshot;
            b = b.value;
            try {
              if (!hn(_(), b)) return !1;
            } catch {
              return !1;
            }
          }
        if (((o = r.child), r.subtreeFlags & 16384 && o !== null))
          ((o.return = r), (r = o));
        else {
          if (r === s) break;
          for (; r.sibling === null; ) {
            if (r.return === null || r.return === s) return !0;
            r = r.return;
          }
          ((r.sibling.return = r.return), (r = r.sibling));
        }
      }
      return !0;
    }
    function la(s, r, o, f) {
      ((r &= ~_m),
        (r &= ~Gl),
        (s.suspendedLanes |= r),
        (s.pingedLanes &= ~r),
        f && (s.warmLanes |= r),
        (f = s.expirationTimes));
      for (var b = r; 0 < b; ) {
        var _ = 31 - bn(b),
          A = 1 << _;
        ((f[_] = -1), (b &= ~A));
      }
      o !== 0 && El(s, o, r);
    }
    function Kd() {
      return (kt & 6) === 0 ? (Qu(0), !1) : !0;
    }
    function Cm() {
      if (mt !== null) {
        if (Yt === 0) var s = mt.return;
        else
          ((s = mt), (Qr = it = null), kp(s), ($o = null), (Ji = 0), (s = mt));
        for (; s !== null; ) (Gd(s.alternate, s), (s = s.return));
        mt = null;
      }
    }
    function cc(s, r) {
      var o = s.timeoutHandle;
      (o !== -1 && ((s.timeoutHandle = -1), H1(o)),
        (o = s.cancelPendingCommit),
        o !== null && ((s.cancelPendingCommit = null), o()),
        (aa = 0),
        Cm(),
        (tn = s),
        (mt = o = Cs(s.current, null)),
        (vt = r),
        (Yt = 0),
        (ss = null),
        (Ga = !1),
        (ac = Tl(s, r)),
        (xm = !1),
        (lc = rs = _m = Gl = Va = mn = 0),
        (Ni = Yu = null),
        (wm = !1),
        (r & 8) !== 0 && (r |= r & 32));
      var f = s.entangledLanes;
      if (f !== 0)
        for (s = s.entanglements, f &= r; 0 < f; ) {
          var b = 31 - bn(f),
            _ = 1 << b;
          ((r |= s[b]), (f &= ~_));
        }
      return ((or = r), Zs(), o);
    }
    function Oy(s, r) {
      ((st = null),
        (V.H = Ya),
        r === qo || r === pu
          ? ((r = Fv()), (Yt = 3))
          : r === bd
            ? ((r = Fv()), (Yt = 4))
            : (Yt =
                r === Nu
                  ? 8
                  : r !== null &&
                      typeof r == "object" &&
                      typeof r.then == "function"
                    ? 6
                    : 1),
        (ss = r),
        mt === null && ((mn = 1), Mu(s, Zi(r, s.current))));
    }
    function Gu() {
      var s = es.current;
      return s === null
        ? !0
        : (vt & 4194048) === vt
          ? Ds === null
          : (vt & 62914560) === vt || (vt & 536870912) !== 0
            ? s === Ds
            : !1;
    }
    function jy() {
      var s = V.H;
      return ((V.H = Ya), s === null ? Ya : s);
    }
    function My() {
      var s = V.A;
      return ((V.A = N1), s);
    }
    function Jd() {
      ((mn = 4),
        Ga || ((vt & 4194048) !== vt && es.current !== null) || (ac = !0),
        ((Va & 134217727) === 0 && (Gl & 134217727) === 0) ||
          tn === null ||
          la(tn, vt, rs, !1));
    }
    function Om(s, r, o) {
      var f = kt;
      kt |= 2;
      var b = jy(),
        _ = My();
      ((tn !== s || vt !== r) && ((Zd = null), cc(s, r)), (r = !1));
      var A = mn;
      e: do
        try {
          if (Yt !== 0 && mt !== null) {
            var D = mt,
              $ = ss;
            switch (Yt) {
              case 8:
                (Cm(), (A = 6));
                break e;
              case 3:
              case 2:
              case 9:
              case 6:
                es.current === null && (r = !0);
                var se = Yt;
                if (((Yt = 0), (ss = null), uc(s, D, $, se), o && ac)) {
                  A = 0;
                  break e;
                }
                break;
              default:
                ((se = Yt), (Yt = 0), (ss = null), uc(s, D, $, se));
            }
          }
          (R1(), (A = mn));
          break;
        } catch (ge) {
          Oy(s, ge);
        }
      while (!0);
      return (
        r && s.shellSuspendCounter++,
        (Qr = it = null),
        (kt = f),
        (V.H = b),
        (V.A = _),
        mt === null && ((tn = null), (vt = 0), Zs()),
        A
      );
    }
    function R1() {
      for (; mt !== null; ) Ny(mt);
    }
    function L1(s, r) {
      var o = kt;
      kt |= 2;
      var f = jy(),
        b = My();
      tn !== s || vt !== r
        ? ((Zd = null), (Vl = Xn() + 500), cc(s, r))
        : (ac = Tl(s, r));
      e: do
        try {
          if (Yt !== 0 && mt !== null) {
            r = mt;
            var _ = ss;
            t: switch (Yt) {
              case 1:
                ((Yt = 0), (ss = null), uc(s, r, _, 1));
                break;
              case 2:
              case 9:
                if (Uv(_)) {
                  ((Yt = 0), (ss = null), Ay(r));
                  break;
                }
                ((r = function () {
                  ((Yt !== 2 && Yt !== 9) || tn !== s || (Yt = 7), Mr(s));
                }),
                  _.then(r, r));
                break e;
              case 3:
                Yt = 7;
                break e;
              case 4:
                Yt = 5;
                break e;
              case 7:
                Uv(_)
                  ? ((Yt = 0), (ss = null), Ay(r))
                  : ((Yt = 0), (ss = null), uc(s, r, _, 7));
                break;
              case 5:
                var A = null;
                switch (mt.tag) {
                  case 26:
                    A = mt.memoizedState;
                  case 5:
                  case 27:
                    var D = mt;
                    if (A ? i0(A) : D.stateNode.complete) {
                      ((Yt = 0), (ss = null));
                      var $ = D.sibling;
                      if ($ !== null) mt = $;
                      else {
                        var se = D.return;
                        se !== null ? ((mt = se), eh(se)) : (mt = null);
                      }
                      break t;
                    }
                }
                ((Yt = 0), (ss = null), uc(s, r, _, 5));
                break;
              case 6:
                ((Yt = 0), (ss = null), uc(s, r, _, 6));
                break;
              case 8:
                (Cm(), (mn = 6));
                break e;
              default:
                throw Error(i(462));
            }
          }
          D1();
          break;
        } catch (ge) {
          Oy(s, ge);
        }
      while (!0);
      return (
        (Qr = it = null),
        (V.H = f),
        (V.A = b),
        (kt = o),
        mt !== null ? 0 : ((tn = null), (vt = 0), Zs(), mn)
      );
    }
    function D1() {
      for (; mt !== null && !Oa(); ) Ny(mt);
    }
    function Ny(s) {
      var r = ay(s.alternate, s, or);
      ((s.memoizedProps = s.pendingProps), r === null ? eh(s) : (mt = r));
    }
    function Ay(s) {
      var r = s,
        o = r.alternate;
      switch (r.tag) {
        case 15:
        case 0:
          r = iy(o, r, r.pendingProps, r.type, void 0, vt);
          break;
        case 11:
          r = iy(o, r, r.pendingProps, r.type.render, r.ref, vt);
          break;
        case 5:
          kp(r);
        default:
          (Gd(o, r), (r = mt = Dv(r, or)), (r = ay(o, r, or)));
      }
      ((s.memoizedProps = s.pendingProps), r === null ? eh(s) : (mt = r));
    }
    function uc(s, r, o, f) {
      ((Qr = it = null), kp(r), ($o = null), (Ji = 0));
      var b = r.return;
      try {
        if (sm(s, b, r, o, vt)) {
          ((mn = 1), Mu(s, Zi(o, s.current)), (mt = null));
          return;
        }
      } catch (_) {
        if (b !== null) throw ((mt = b), _);
        ((mn = 1), Mu(s, Zi(o, s.current)), (mt = null));
        return;
      }
      r.flags & 32768
        ? (wt || f === 1
            ? (s = !0)
            : ac || (vt & 536870912) !== 0
              ? (s = !1)
              : ((Ga = s = !0),
                (f === 2 || f === 9 || f === 3 || f === 6) &&
                  ((f = es.current),
                  f !== null && f.tag === 13 && (f.flags |= 16384))),
          Vu(r, s))
        : eh(r);
    }
    function eh(s) {
      var r = s;
      do {
        if ((r.flags & 32768) !== 0) {
          Vu(r, Ga);
          return;
        }
        s = r.return;
        var o = ly(r.alternate, r, or);
        if (o !== null) {
          mt = o;
          return;
        }
        if (((r = r.sibling), r !== null)) {
          mt = r;
          return;
        }
        mt = r = s;
      } while (r !== null);
      mn === 0 && (mn = 5);
    }
    function Vu(s, r) {
      do {
        var o = Iu(s.alternate, s);
        if (o !== null) {
          ((o.flags &= 32767), (mt = o));
          return;
        }
        if (
          ((o = s.return),
          o !== null &&
            ((o.flags |= 32768), (o.subtreeFlags = 0), (o.deletions = null)),
          !r && ((s = s.sibling), s !== null))
        ) {
          mt = s;
          return;
        }
        mt = s = o;
      } while (s !== null);
      ((mn = 6), (mt = null));
    }
    function Ry(s, r, o, f, b, _, A, D, $) {
      s.cancelPendingCommit = null;
      do Wu();
      while (Yn !== 0);
      if ((kt & 6) !== 0) throw Error(i(327));
      if (r !== null) {
        if (r === s.current) throw Error(i(177));
        if (
          ((_ = r.lanes | r.childLanes),
          (_ |= ko),
          qc(s, o, _, A, D, $),
          s === tn && ((mt = tn = null), (vt = 0)),
          (oc = r),
          (Xa = s),
          (aa = o),
          (Sm = _),
          (Tm = b),
          (wy = f),
          (r.subtreeFlags & 10256) !== 0 || (r.flags & 10256) !== 0
            ? ((s.callbackNode = null),
              (s.callbackPriority = 0),
              P1(Yi, function () {
                return (Am(), null);
              }))
            : ((s.callbackNode = null), (s.callbackPriority = 0)),
          (f = (r.flags & 13878) !== 0),
          (r.subtreeFlags & 13878) !== 0 || f)
        ) {
          ((f = V.T),
            (V.T = null),
            (b = pe.p),
            (pe.p = 2),
            (A = kt),
            (kt |= 4));
          try {
            j1(s, r, o);
          } finally {
            ((kt = A), (pe.p = b), (V.T = f));
          }
        }
        ((Yn = 1), jm(), Mm(), th());
      }
    }
    function jm() {
      if (Yn === 1) {
        Yn = 0;
        var s = Xa,
          r = oc,
          o = (r.flags & 13878) !== 0;
        if ((r.subtreeFlags & 13878) !== 0 || o) {
          ((o = V.T), (V.T = null));
          var f = pe.p;
          pe.p = 2;
          var b = kt;
          kt |= 4;
          try {
            py(r, s);
            var _ = Hm,
              A = Nv(s.containerInfo),
              D = _.focusedElem,
              $ = _.selectionRange;
            if (
              A !== D &&
              D &&
              D.ownerDocument &&
              Mv(D.ownerDocument.documentElement, D)
            ) {
              if ($ !== null && Ep(D)) {
                var se = $.start,
                  ge = $.end;
                if ((ge === void 0 && (ge = se), "selectionStart" in D))
                  ((D.selectionStart = se),
                    (D.selectionEnd = Math.min(ge, D.value.length)));
                else {
                  var _e = D.ownerDocument || document,
                    re = (_e && _e.defaultView) || window;
                  if (re.getSelection) {
                    var ue = re.getSelection(),
                      Ie = D.textContent.length,
                      Ve = Math.min($.start, Ie),
                      Qt = $.end === void 0 ? Ve : Math.min($.end, Ie);
                    !ue.extend && Ve > Qt && ((A = Qt), (Qt = Ve), (Ve = A));
                    var te = jv(D, Ve),
                      K = jv(D, Qt);
                    if (
                      te &&
                      K &&
                      (ue.rangeCount !== 1 ||
                        ue.anchorNode !== te.node ||
                        ue.anchorOffset !== te.offset ||
                        ue.focusNode !== K.node ||
                        ue.focusOffset !== K.offset)
                    ) {
                      var ie = _e.createRange();
                      (ie.setStart(te.node, te.offset),
                        ue.removeAllRanges(),
                        Ve > Qt
                          ? (ue.addRange(ie), ue.extend(K.node, K.offset))
                          : (ie.setEnd(K.node, K.offset), ue.addRange(ie)));
                    }
                  }
                }
              }
              for (_e = [], ue = D; (ue = ue.parentNode); )
                ue.nodeType === 1 &&
                  _e.push({
                    element: ue,
                    left: ue.scrollLeft,
                    top: ue.scrollTop,
                  });
              for (
                typeof D.focus == "function" && D.focus(), D = 0;
                D < _e.length;
                D++
              ) {
                var ye = _e[D];
                ((ye.element.scrollLeft = ye.left),
                  (ye.element.scrollTop = ye.top));
              }
            }
            ((mh = !!ef), (Hm = ef = null));
          } finally {
            ((kt = b), (pe.p = f), (V.T = o));
          }
        }
        ((s.current = r), (Yn = 2));
      }
    }
    function Mm() {
      if (Yn === 2) {
        Yn = 0;
        var s = Xa,
          r = oc,
          o = (r.flags & 8772) !== 0;
        if ((r.subtreeFlags & 8772) !== 0 || o) {
          ((o = V.T), (V.T = null));
          var f = pe.p;
          pe.p = 2;
          var b = kt;
          kt |= 4;
          try {
            mm(s, r.alternate, r);
          } finally {
            ((kt = b), (pe.p = f), (V.T = o));
          }
        }
        Yn = 3;
      }
    }
    function th() {
      if (Yn === 4 || Yn === 3) {
        ((Yn = 0), wo());
        var s = Xa,
          r = oc,
          o = aa,
          f = wy;
        (r.subtreeFlags & 10256) !== 0 || (r.flags & 10256) !== 0
          ? (Yn = 5)
          : ((Yn = 0), (oc = Xa = null), Nm(s, s.pendingLanes));
        var b = s.pendingLanes;
        if (
          (b === 0 && (Wa = null),
          Vs(o),
          (r = r.stateNode),
          Rn && typeof Rn.onCommitFiberRoot == "function")
        )
          try {
            Rn.onCommitFiberRoot(
              _s,
              r,
              void 0,
              (r.current.flags & 128) === 128,
            );
          } catch {}
        if (f !== null) {
          ((r = V.T), (b = pe.p), (pe.p = 2), (V.T = null));
          try {
            for (var _ = s.onRecoverableError, A = 0; A < f.length; A++) {
              var D = f[A];
              _(D.value, { componentStack: D.stack });
            }
          } finally {
            ((V.T = r), (pe.p = b));
          }
        }
        ((aa & 3) !== 0 && Wu(),
          Mr(s),
          (b = s.pendingLanes),
          (o & 261930) !== 0 && (b & 42) !== 0
            ? s === Em
              ? $u++
              : (($u = 0), (Em = s))
            : ($u = 0),
          Qu(0));
      }
    }
    function Nm(s, r) {
      (s.pooledCacheLanes &= r) === 0 &&
        ((r = s.pooledCache), r != null && ((s.pooledCache = null), du(r)));
    }
    function Wu() {
      return (jm(), Mm(), th(), Am());
    }
    function Am() {
      if (Yn !== 5) return !1;
      var s = Xa,
        r = Sm;
      Sm = 0;
      var o = Vs(aa),
        f = V.T,
        b = pe.p;
      try {
        ((pe.p = 32 > o ? 32 : o), (V.T = null), (o = Tm), (Tm = null));
        var _ = Xa,
          A = aa;
        if (((Yn = 0), (oc = Xa = null), (aa = 0), (kt & 6) !== 0))
          throw Error(i(331));
        var D = kt;
        if (
          ((kt |= 4),
          by(_.current),
          gy(_, _.current, A, o),
          (kt = D),
          Qu(0, !1),
          Rn && typeof Rn.onPostCommitFiberRoot == "function")
        )
          try {
            Rn.onPostCommitFiberRoot(_s, _);
          } catch {}
        return !0;
      } finally {
        ((pe.p = b), (V.T = f), Nm(s, r));
      }
    }
    function Rm(s, r, o) {
      ((r = Zi(o, r)),
        (r = im(s.stateNode, r, 2)),
        (s = tr(s, r, 2)),
        s !== null && (ja(s, 2), Mr(s)));
    }
    function qt(s, r, o) {
      if (s.tag === 3) Rm(s, s, o);
      else
        for (; r !== null; ) {
          if (r.tag === 3) {
            Rm(r, s, o);
            break;
          } else if (r.tag === 1) {
            var f = r.stateNode;
            if (
              typeof r.type.getDerivedStateFromError == "function" ||
              (typeof f.componentDidCatch == "function" &&
                (Wa === null || !Wa.has(f)))
            ) {
              ((s = Zi(o, s)),
                (o = Cr(2)),
                (f = tr(r, o, 2)),
                f !== null && (Ud(o, f, r, s), ja(f, 2), Mr(f)));
              break;
            }
          }
          r = r.return;
        }
    }
    function Lm(s, r, o) {
      var f = s.pingCache;
      if (f === null) {
        f = s.pingCache = new A1();
        var b = new Set();
        f.set(r, b);
      } else ((b = f.get(r)), b === void 0 && ((b = new Set()), f.set(r, b)));
      b.has(o) ||
        ((xm = !0), b.add(o), (s = k1.bind(null, s, r, o)), r.then(s, s));
    }
    function k1(s, r, o) {
      var f = s.pingCache;
      (f !== null && f.delete(r),
        (s.pingedLanes |= s.suspendedLanes & o),
        (s.warmLanes &= ~o),
        tn === s &&
          (vt & o) === o &&
          (mn === 4 || (mn === 3 && (vt & 62914560) === vt && 300 > Xn() - qu)
            ? (kt & 2) === 0 && cc(s, 0)
            : (_m |= o),
          lc === vt && (lc = 0)),
        Mr(s));
    }
    function Xu(s, r) {
      (r === 0 && (r = br()), (s = _r(s, r)), s !== null && (ja(s, r), Mr(s)));
    }
    function nh(s) {
      var r = s.memoizedState,
        o = 0;
      (r !== null && (o = r.retryLane), Xu(s, o));
    }
    function z1(s, r) {
      var o = 0;
      switch (s.tag) {
        case 31:
        case 13:
          var f = s.stateNode,
            b = s.memoizedState;
          b !== null && (o = b.retryLane);
          break;
        case 19:
          f = s.stateNode;
          break;
        case 22:
          f = s.stateNode._retryCache;
          break;
        default:
          throw Error(i(314));
      }
      (f !== null && f.delete(r), Xu(s, o));
    }
    function P1(s, r) {
      return xs(s, r);
    }
    var fc = null,
      Wl = null,
      Dm = !1,
      ih = !1,
      km = !1,
      Qa = 0;
    function Mr(s) {
      (s !== Wl &&
        s.next === null &&
        (Wl === null ? (fc = Wl = s) : (Wl = Wl.next = s)),
        (ih = !0),
        Dm || ((Dm = !0), U1()));
    }
    function Qu(s, r) {
      if (!km && ih) {
        km = !0;
        do
          for (var o = !1, f = fc; f !== null; ) {
            if (s !== 0) {
              var b = f.pendingLanes;
              if (b === 0) var _ = 0;
              else {
                var A = f.suspendedLanes,
                  D = f.pingedLanes;
                ((_ = (1 << (31 - bn(42 | s) + 1)) - 1),
                  (_ &= b & ~(A & ~D)),
                  (_ = _ & 201326741 ? (_ & 201326741) | 1 : _ ? _ | 2 : 0));
              }
              _ !== 0 && ((o = !0), zy(f, _));
            } else
              ((_ = vt),
                (_ = Eo(
                  f,
                  f === tn ? _ : 0,
                  f.cancelPendingCommit !== null || f.timeoutHandle !== -1,
                )),
                (_ & 3) === 0 || Tl(f, _) || ((o = !0), zy(f, _)));
            f = f.next;
          }
        while (o);
        km = !1;
      }
    }
    function I1() {
      Ly();
    }
    function Ly() {
      ih = Dm = !1;
      var s = 0;
      Qa !== 0 && B1() && (s = Qa);
      for (var r = Xn(), o = null, f = fc; f !== null; ) {
        var b = f.next,
          _ = Dy(f, r);
        (_ === 0
          ? ((f.next = null),
            o === null ? (fc = b) : (o.next = b),
            b === null && (Wl = o))
          : ((o = f), (s !== 0 || (_ & 3) !== 0) && (ih = !0)),
          (f = b));
      }
      ((Yn !== 0 && Yn !== 5) || Qu(s), Qa !== 0 && (Qa = 0));
    }
    function Dy(s, r) {
      for (
        var o = s.suspendedLanes,
          f = s.pingedLanes,
          b = s.expirationTimes,
          _ = s.pendingLanes & -62914561;
        0 < _;

      ) {
        var A = 31 - bn(_),
          D = 1 << A,
          $ = b[A];
        ($ === -1
          ? ((D & o) === 0 || (D & f) !== 0) && (b[A] = On(D, r))
          : $ <= r && (s.expiredLanes |= D),
          (_ &= ~D));
      }
      if (
        ((r = tn),
        (o = vt),
        (o = Eo(
          s,
          s === r ? o : 0,
          s.cancelPendingCommit !== null || s.timeoutHandle !== -1,
        )),
        (f = s.callbackNode),
        o === 0 ||
          (s === r && (Yt === 2 || Yt === 9)) ||
          s.cancelPendingCommit !== null)
      )
        return (
          f !== null && f !== null && ai(f),
          (s.callbackNode = null),
          (s.callbackPriority = 0)
        );
      if ((o & 3) === 0 || Tl(s, o)) {
        if (((r = o & -o), r === s.callbackPriority)) return r;
        switch ((f !== null && ai(f), Vs(o))) {
          case 2:
          case 8:
            o = Qn;
            break;
          case 32:
            o = Yi;
            break;
          case 268435456:
            o = xl;
            break;
          default:
            o = Yi;
        }
        return (
          (f = ky.bind(null, s)),
          (o = xs(o, f)),
          (s.callbackPriority = r),
          (s.callbackNode = o),
          r
        );
      }
      return (
        f !== null && f !== null && ai(f),
        (s.callbackPriority = 2),
        (s.callbackNode = null),
        2
      );
    }
    function ky(s, r) {
      if (Yn !== 0 && Yn !== 5)
        return ((s.callbackNode = null), (s.callbackPriority = 0), null);
      var o = s.callbackNode;
      if (Wu() && s.callbackNode !== o) return null;
      var f = vt;
      return (
        (f = Eo(
          s,
          s === tn ? f : 0,
          s.cancelPendingCommit !== null || s.timeoutHandle !== -1,
        )),
        f === 0
          ? null
          : (Ty(s, f, r),
            Dy(s, Xn()),
            s.callbackNode != null && s.callbackNode === o
              ? ky.bind(null, s)
              : null)
      );
    }
    function zy(s, r) {
      if (Wu()) return null;
      Ty(s, r, !0);
    }
    function U1() {
      $y(function () {
        (kt & 6) !== 0 ? xs(Br, I1) : Ly();
      });
    }
    function ls() {
      if (Qa === 0) {
        var s = Ho;
        (s === 0 && ((s = Hr), (Hr <<= 1), (Hr & 261888) === 0 && (Hr = 256)),
          (Qa = s));
      }
      return Qa;
    }
    function Py(s) {
      return s == null || typeof s == "symbol" || typeof s == "boolean"
        ? null
        : typeof s == "function"
          ? s
          : Jc("" + s);
    }
    function Iy(s, r) {
      var o = r.ownerDocument.createElement("input");
      return (
        (o.name = r.name),
        (o.value = r.value),
        s.id && o.setAttribute("form", s.id),
        r.parentNode.insertBefore(o, r),
        (s = new FormData(s)),
        o.parentNode.removeChild(o),
        s
      );
    }
    function Xl(s, r, o, f, b) {
      if (r === "submit" && o && o.stateNode === b) {
        var _ = Py((b[on] || null).action),
          A = f.submitter;
        A &&
          ((r = (r = A[on] || null)
            ? Py(r.formAction)
            : A.getAttribute("formAction")),
          r !== null && ((_ = r), (A = null)));
        var D = new Kf("action", "action", null, f, b);
        s.push({
          event: D,
          listeners: [
            {
              instance: null,
              listener: function () {
                if (f.defaultPrevented) {
                  if (Qa !== 0) {
                    var $ = A ? Iy(b, A) : new FormData(b);
                    Ha(
                      o,
                      { pending: !0, data: $, method: b.method, action: _ },
                      null,
                      $,
                    );
                  }
                } else
                  typeof _ == "function" &&
                    (D.preventDefault(),
                    ($ = A ? Iy(b, A) : new FormData(b)),
                    Ha(
                      o,
                      { pending: !0, data: $, method: b.method, action: _ },
                      _,
                      $,
                    ));
              },
              currentTarget: b,
            },
          ],
        });
      }
    }
    for (var tt = 0; tt < dd.length; tt++) {
      var zm = dd[tt],
        Ri = zm.toLowerCase(),
        Nn = zm[0].toUpperCase() + zm.slice(1);
      Si(Ri, "on" + Nn);
    }
    (Si(Qi, "onAnimationEnd"),
      Si(lu, "onAnimationIteration"),
      Si(Av, "onAnimationStart"),
      Si("dblclick", "onDoubleClick"),
      Si("focusin", "onFocus"),
      Si("focusout", "onBlur"),
      Si(Lo, "onTransitionRun"),
      Si(ud, "onTransitionStart"),
      Si(fd, "onTransitionCancel"),
      Si(Pt, "onTransitionEnd"),
      Ws("onMouseEnter", ["mouseout", "mouseover"]),
      Ws("onMouseLeave", ["mouseout", "mouseover"]),
      Ws("onPointerEnter", ["pointerout", "pointerover"]),
      Ws("onPointerLeave", ["pointerout", "pointerover"]),
      hi(
        "onChange",
        "change click focusin focusout input keydown keyup selectionchange".split(
          " ",
        ),
      ),
      hi(
        "onSelect",
        "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
          " ",
        ),
      ),
      hi("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
      hi(
        "onCompositionEnd",
        "compositionend focusout keydown keypress keyup mousedown".split(" "),
      ),
      hi(
        "onCompositionStart",
        "compositionstart focusout keydown keypress keyup mousedown".split(" "),
      ),
      hi(
        "onCompositionUpdate",
        "compositionupdate focusout keydown keypress keyup mousedown".split(
          " ",
        ),
      ));
    var Zu =
        "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
          " ",
        ),
      Za = new Set(
        "beforetoggle cancel close invalid load scroll scrollend toggle"
          .split(" ")
          .concat(Zu),
      );
    function Uy(s, r) {
      r = (r & 4) !== 0;
      for (var o = 0; o < s.length; o++) {
        var f = s[o],
          b = f.event;
        f = f.listeners;
        e: {
          var _ = void 0;
          if (r)
            for (var A = f.length - 1; 0 <= A; A--) {
              var D = f[A],
                $ = D.instance,
                se = D.currentTarget;
              if (((D = D.listener), $ !== _ && b.isPropagationStopped()))
                break e;
              ((_ = D), (b.currentTarget = se));
              try {
                _(b);
              } catch (ge) {
                hd(ge);
              }
              ((b.currentTarget = null), (_ = $));
            }
          else
            for (A = 0; A < f.length; A++) {
              if (
                ((D = f[A]),
                ($ = D.instance),
                (se = D.currentTarget),
                (D = D.listener),
                $ !== _ && b.isPropagationStopped())
              )
                break e;
              ((_ = D), (b.currentTarget = se));
              try {
                _(b);
              } catch (ge) {
                hd(ge);
              }
              ((b.currentTarget = null), (_ = $));
            }
        }
      }
    }
    function gt(s, r) {
      var o = r[Cl];
      o === void 0 && (o = r[Cl] = new Set());
      var f = s + "__bubble";
      o.has(f) || (rh(r, s, 2, !1), o.add(f));
    }
    function Pm(s, r, o) {
      var f = 0;
      (r && (f |= 4), rh(o, s, f, r));
    }
    var sh = "_reactListening" + Math.random().toString(36).slice(2);
    function Im(s) {
      if (!s[sh]) {
        ((s[sh] = !0),
          Zn.forEach(function (o) {
            o !== "selectionchange" &&
              (Za.has(o) || Pm(o, !1, s), Pm(o, !0, s));
          }));
        var r = s.nodeType === 9 ? s : s.ownerDocument;
        r === null || r[sh] || ((r[sh] = !0), Pm("selectionchange", !1, r));
      }
    }
    function rh(s, r, o, f) {
      switch (f0(r)) {
        case 2:
          var b = tx;
          break;
        case 8:
          b = nx;
          break;
        default:
          b = Qm;
      }
      ((o = b.bind(null, r, o, s)),
        (b = void 0),
        !hp ||
          (r !== "touchstart" && r !== "touchmove" && r !== "wheel") ||
          (b = !0),
        f
          ? b !== void 0
            ? s.addEventListener(r, o, { capture: !0, passive: b })
            : s.addEventListener(r, o, !0)
          : b !== void 0
            ? s.addEventListener(r, o, { passive: b })
            : s.addEventListener(r, o, !1));
    }
    function Um(s, r, o, f, b) {
      var _ = f;
      if ((r & 1) === 0 && (r & 2) === 0 && f !== null)
        e: for (;;) {
          if (f === null) return;
          var A = f.tag;
          if (A === 3 || A === 4) {
            var D = f.stateNode.containerInfo;
            if (D === b) break;
            if (A === 4)
              for (A = f.return; A !== null; ) {
                var $ = A.tag;
                if (($ === 3 || $ === 4) && A.stateNode.containerInfo === b)
                  return;
                A = A.return;
              }
            for (; D !== null; ) {
              if (((A = Ce(D)), A === null)) return;
              if ((($ = A.tag), $ === 5 || $ === 6 || $ === 26 || $ === 27)) {
                f = _ = A;
                continue e;
              }
              D = D.parentNode;
            }
          }
          f = f.return;
        }
      hv(function () {
        var se = _,
          ge = fp(o),
          _e = [];
        e: {
          var re = Rv.get(s);
          if (re !== void 0) {
            var ue = Kf,
              Ie = s;
            switch (s) {
              case "keypress":
                if (Qf(o) === 0) break e;
              case "keydown":
              case "keyup":
                ue = Aa;
                break;
              case "focusin":
                ((Ie = "focus"), (ue = ed));
                break;
              case "focusout":
                ((Ie = "blur"), (ue = ed));
                break;
              case "beforeblur":
              case "afterblur":
                ue = ed;
                break;
              case "click":
                if (o.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                ue = Jf;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                ue = mv;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                ue = u1;
                break;
              case Qi:
              case lu:
              case Av:
                ue = yv;
                break;
              case Pt:
                ue = d1;
                break;
              case "scroll":
              case "scrollend":
                ue = l1;
                break;
              case "wheel":
                ue = nd;
                break;
              case "copy":
              case "cut":
              case "paste":
                ue = Vi;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                ue = _v;
                break;
              case "toggle":
              case "beforetoggle":
                ue = h1;
            }
            var Ve = (r & 4) !== 0,
              Qt = !Ve && (s === "scroll" || s === "scrollend"),
              te = Ve ? (re !== null ? re + "Capture" : null) : re;
            Ve = [];
            for (var K = se, ie; K !== null; ) {
              var ye = K;
              if (
                ((ie = ye.stateNode),
                (ye = ye.tag),
                (ye !== 5 && ye !== 26 && ye !== 27) ||
                  ie === null ||
                  te === null ||
                  ((ye = Ml(K, te)), ye != null && Ve.push(os(K, ye, ie))),
                Qt)
              )
                break;
              K = K.return;
            }
            0 < Ve.length &&
              ((re = new ue(re, Ie, null, o, ge)),
              _e.push({ event: re, listeners: Ve }));
          }
        }
        if ((r & 7) === 0) {
          e: {
            if (
              ((re = s === "mouseover" || s === "pointerover"),
              (ue = s === "mouseout" || s === "pointerout"),
              re &&
                o !== up &&
                (Ie = o.relatedTarget || o.fromElement) &&
                (Ce(Ie) || Ie[Yr]))
            )
              break e;
            if (
              (ue || re) &&
              ((re =
                ge.window === ge
                  ? ge
                  : (re = ge.ownerDocument)
                    ? re.defaultView || re.parentWindow
                    : window),
              ue
                ? ((Ie = o.relatedTarget || o.toElement),
                  (ue = se),
                  (Ie = Ie ? Ce(Ie) : null),
                  Ie !== null &&
                    ((Qt = l(Ie)),
                    (Ve = Ie.tag),
                    Ie !== Qt || (Ve !== 5 && Ve !== 27 && Ve !== 6)) &&
                    (Ie = null))
                : ((ue = null), (Ie = se)),
              ue !== Ie)
            ) {
              if (
                ((Ve = Jf),
                (ye = "onMouseLeave"),
                (te = "onMouseEnter"),
                (K = "mouse"),
                (s === "pointerout" || s === "pointerover") &&
                  ((Ve = _v),
                  (ye = "onPointerLeave"),
                  (te = "onPointerEnter"),
                  (K = "pointer")),
                (Qt = ue == null ? re : zt(ue)),
                (ie = Ie == null ? re : zt(Ie)),
                (re = new Ve(ye, K + "leave", ue, o, ge)),
                (re.target = Qt),
                (re.relatedTarget = ie),
                (ye = null),
                Ce(ge) === se &&
                  ((Ve = new Ve(te, K + "enter", Ie, o, ge)),
                  (Ve.target = ie),
                  (Ve.relatedTarget = Qt),
                  (ye = Ve)),
                (Qt = ye),
                ue && Ie)
              )
                t: {
                  for (
                    Ve = ah, te = ue, K = Ie, ie = 0, ye = te;
                    ye;
                    ye = Ve(ye)
                  )
                    ie++;
                  ye = 0;
                  for (var qe = K; qe; qe = Ve(qe)) ye++;
                  for (; 0 < ie - ye; ) ((te = Ve(te)), ie--);
                  for (; 0 < ye - ie; ) ((K = Ve(K)), ye--);
                  for (; ie--; ) {
                    if (te === K || (K !== null && te === K.alternate)) {
                      Ve = te;
                      break t;
                    }
                    ((te = Ve(te)), (K = Ve(K)));
                  }
                  Ve = null;
                }
              else Ve = null;
              (ue !== null && dn(_e, re, ue, Ve, !1),
                Ie !== null && Qt !== null && dn(_e, Qt, Ie, Ve, !0));
            }
          }
          e: {
            if (
              ((re = se ? zt(se) : window),
              (ue = re.nodeName && re.nodeName.toLowerCase()),
              ue === "select" || (ue === "input" && re.type === "file"))
            )
              var Rt = Cv;
            else if (xp(re))
              if (Ll) Rt = v1;
              else {
                Rt = m1;
                var Be = od;
              }
            else
              ((ue = re.nodeName),
                !ue ||
                ue.toLowerCase() !== "input" ||
                (re.type !== "checkbox" && re.type !== "radio")
                  ? se && Xf(se.elementType) && (Rt = Cv)
                  : (Rt = g1));
            if (Rt && (Rt = Rt(s, se))) {
              _p(_e, Rt, o, ge);
              break e;
            }
            (Be && Be(s, re, se),
              s === "focusout" &&
                se &&
                re.type === "number" &&
                se.memoizedProps.value != null &&
                op(re, "number", re.value));
          }
          switch (((Be = se ? zt(se) : window), s)) {
            case "focusin":
              (xp(Be) || Be.contentEditable === "true") &&
                ((ee = Be), (me = se), (oe = null));
              break;
            case "focusout":
              oe = me = ee = null;
              break;
            case "mousedown":
              ke = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              ((ke = !1), et(_e, o, ge));
              break;
            case "selectionchange":
              if (Ro) break;
            case "keydown":
            case "keyup":
              et(_e, o, ge);
          }
          var lt;
          if (id)
            e: {
              switch (s) {
                case "compositionstart":
                  var yt = "onCompositionStart";
                  break e;
                case "compositionend":
                  yt = "onCompositionEnd";
                  break e;
                case "compositionupdate":
                  yt = "onCompositionUpdate";
                  break e;
              }
              yt = void 0;
            }
          else
            Rl
              ? rd(s, o) && (yt = "onCompositionEnd")
              : s === "keydown" &&
                o.keyCode === 229 &&
                (yt = "onCompositionStart");
          (yt &&
            (yp &&
              o.locale !== "ko" &&
              (Rl || yt !== "onCompositionStart"
                ? yt === "onCompositionEnd" && Rl && (lt = Jt())
                : ((Ma = ge),
                  (pp = "value" in Ma ? Ma.value : Ma.textContent),
                  (Rl = !0))),
            (Be = Ku(se, yt)),
            0 < Be.length &&
              ((yt = new Wi(yt, s, null, o, ge)),
              _e.push({ event: yt, listeners: Be }),
              lt
                ? (yt.data = lt)
                : ((lt = Ev(o)), lt !== null && (yt.data = lt)))),
            (lt = vp ? Xi(s, o) : bp(s, o)) &&
              ((yt = Ku(se, "onBeforeInput")),
              0 < yt.length &&
                ((Be = new Wi("onBeforeInput", "beforeinput", null, o, ge)),
                _e.push({ event: Be, listeners: yt }),
                (Be.data = lt))),
            Xl(_e, s, se, o, ge));
        }
        Uy(_e, r);
      });
    }
    function os(s, r, o) {
      return { instance: s, listener: r, currentTarget: o };
    }
    function Ku(s, r) {
      for (var o = r + "Capture", f = []; s !== null; ) {
        var b = s,
          _ = b.stateNode;
        if (
          ((b = b.tag),
          (b !== 5 && b !== 26 && b !== 27) ||
            _ === null ||
            ((b = Ml(s, o)),
            b != null && f.unshift(os(s, b, _)),
            (b = Ml(s, r)),
            b != null && f.push(os(s, b, _))),
          s.tag === 3)
        )
          return f;
        s = s.return;
      }
      return [];
    }
    function ah(s) {
      if (s === null) return null;
      do s = s.return;
      while (s && s.tag !== 5 && s.tag !== 27);
      return s || null;
    }
    function dn(s, r, o, f, b) {
      for (var _ = r._reactName, A = []; o !== null && o !== f; ) {
        var D = o,
          $ = D.alternate,
          se = D.stateNode;
        if (((D = D.tag), $ !== null && $ === f)) break;
        ((D !== 5 && D !== 26 && D !== 27) ||
          se === null ||
          (($ = se),
          b
            ? ((se = Ml(o, _)), se != null && A.unshift(os(o, se, $)))
            : b || ((se = Ml(o, _)), se != null && A.push(os(o, se, $)))),
          (o = o.return));
      }
      A.length !== 0 && s.push({ event: r, listeners: A });
    }
    var Sn = /\r\n?/g,
      Fy = /\u0000|\uFFFD/g;
    function By(s) {
      return (typeof s == "string" ? s : "" + s)
        .replace(
          Sn,
          `
`,
        )
        .replace(Fy, "");
    }
    function Hy(s, r) {
      return ((r = By(r)), By(s) === r);
    }
    function Xt(s, r, o, f, b, _) {
      switch (o) {
        case "children":
          typeof f == "string"
            ? r === "body" || (r === "textarea" && f === "") || Xs(s, f)
            : (typeof f == "number" || typeof f == "bigint") &&
              r !== "body" &&
              Xs(s, "" + f);
          break;
        case "className":
          Qc(s, "class", f);
          break;
        case "tabIndex":
          Qc(s, "tabindex", f);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          Qc(s, o, f);
          break;
        case "style":
          cv(s, f, _);
          break;
        case "data":
          if (r !== "object") {
            Qc(s, "data", f);
            break;
          }
        case "src":
        case "href":
          if (f === "" && (r !== "a" || o !== "href")) {
            s.removeAttribute(o);
            break;
          }
          if (
            f == null ||
            typeof f == "function" ||
            typeof f == "symbol" ||
            typeof f == "boolean"
          ) {
            s.removeAttribute(o);
            break;
          }
          ((f = Jc("" + f)), s.setAttribute(o, f));
          break;
        case "action":
        case "formAction":
          if (typeof f == "function") {
            s.setAttribute(
              o,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')",
            );
            break;
          } else
            typeof _ == "function" &&
              (o === "formAction"
                ? (r !== "input" && Xt(s, r, "name", b.name, b, null),
                  Xt(s, r, "formEncType", b.formEncType, b, null),
                  Xt(s, r, "formMethod", b.formMethod, b, null),
                  Xt(s, r, "formTarget", b.formTarget, b, null))
                : (Xt(s, r, "encType", b.encType, b, null),
                  Xt(s, r, "method", b.method, b, null),
                  Xt(s, r, "target", b.target, b, null)));
          if (f == null || typeof f == "symbol" || typeof f == "boolean") {
            s.removeAttribute(o);
            break;
          }
          ((f = Jc("" + f)), s.setAttribute(o, f));
          break;
        case "onClick":
          f != null && (s.onclick = qr);
          break;
        case "onScroll":
          f != null && gt("scroll", s);
          break;
        case "onScrollEnd":
          f != null && gt("scrollend", s);
          break;
        case "dangerouslySetInnerHTML":
          if (f != null) {
            if (typeof f != "object" || !("__html" in f)) throw Error(i(61));
            if (((o = f.__html), o != null)) {
              if (b.children != null) throw Error(i(60));
              s.innerHTML = o;
            }
          }
          break;
        case "multiple":
          s.multiple = f && typeof f != "function" && typeof f != "symbol";
          break;
        case "muted":
          s.muted = f && typeof f != "function" && typeof f != "symbol";
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (
            f == null ||
            typeof f == "function" ||
            typeof f == "boolean" ||
            typeof f == "symbol"
          ) {
            s.removeAttribute("xlink:href");
            break;
          }
          ((o = Jc("" + f)),
            s.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", o));
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          f != null && typeof f != "function" && typeof f != "symbol"
            ? s.setAttribute(o, "" + f)
            : s.removeAttribute(o);
          break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          f && typeof f != "function" && typeof f != "symbol"
            ? s.setAttribute(o, "")
            : s.removeAttribute(o);
          break;
        case "capture":
        case "download":
          f === !0
            ? s.setAttribute(o, "")
            : f !== !1 &&
                f != null &&
                typeof f != "function" &&
                typeof f != "symbol"
              ? s.setAttribute(o, f)
              : s.removeAttribute(o);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          f != null &&
          typeof f != "function" &&
          typeof f != "symbol" &&
          !isNaN(f) &&
          1 <= f
            ? s.setAttribute(o, f)
            : s.removeAttribute(o);
          break;
        case "rowSpan":
        case "start":
          f == null ||
          typeof f == "function" ||
          typeof f == "symbol" ||
          isNaN(f)
            ? s.removeAttribute(o)
            : s.setAttribute(o, f);
          break;
        case "popover":
          (gt("beforetoggle", s), gt("toggle", s), Hf(s, "popover", f));
          break;
        case "xlinkActuate":
          xr(s, "http://www.w3.org/1999/xlink", "xlink:actuate", f);
          break;
        case "xlinkArcrole":
          xr(s, "http://www.w3.org/1999/xlink", "xlink:arcrole", f);
          break;
        case "xlinkRole":
          xr(s, "http://www.w3.org/1999/xlink", "xlink:role", f);
          break;
        case "xlinkShow":
          xr(s, "http://www.w3.org/1999/xlink", "xlink:show", f);
          break;
        case "xlinkTitle":
          xr(s, "http://www.w3.org/1999/xlink", "xlink:title", f);
          break;
        case "xlinkType":
          xr(s, "http://www.w3.org/1999/xlink", "xlink:type", f);
          break;
        case "xmlBase":
          xr(s, "http://www.w3.org/XML/1998/namespace", "xml:base", f);
          break;
        case "xmlLang":
          xr(s, "http://www.w3.org/XML/1998/namespace", "xml:lang", f);
          break;
        case "xmlSpace":
          xr(s, "http://www.w3.org/XML/1998/namespace", "xml:space", f);
          break;
        case "is":
          Hf(s, "is", f);
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          (!(2 < o.length) ||
            (o[0] !== "o" && o[0] !== "O") ||
            (o[1] !== "n" && o[1] !== "N")) &&
            ((o = uv.get(o) || o), Hf(s, o, f));
      }
    }
    function Fm(s, r, o, f, b, _) {
      switch (o) {
        case "style":
          cv(s, f, _);
          break;
        case "dangerouslySetInnerHTML":
          if (f != null) {
            if (typeof f != "object" || !("__html" in f)) throw Error(i(61));
            if (((o = f.__html), o != null)) {
              if (b.children != null) throw Error(i(60));
              s.innerHTML = o;
            }
          }
          break;
        case "children":
          typeof f == "string"
            ? Xs(s, f)
            : (typeof f == "number" || typeof f == "bigint") && Xs(s, "" + f);
          break;
        case "onScroll":
          f != null && gt("scroll", s);
          break;
        case "onScrollEnd":
          f != null && gt("scrollend", s);
          break;
        case "onClick":
          f != null && (s.onclick = qr);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (!Ss.hasOwnProperty(o))
            e: {
              if (
                o[0] === "o" &&
                o[1] === "n" &&
                ((b = o.endsWith("Capture")),
                (r = o.slice(2, b ? o.length - 7 : void 0)),
                (_ = s[on] || null),
                (_ = _ != null ? _[o] : null),
                typeof _ == "function" && s.removeEventListener(r, _, b),
                typeof f == "function")
              ) {
                (typeof _ != "function" &&
                  _ !== null &&
                  (o in s
                    ? (s[o] = null)
                    : s.hasAttribute(o) && s.removeAttribute(o)),
                  s.addEventListener(r, f, b));
                break e;
              }
              o in s
                ? (s[o] = f)
                : f === !0
                  ? s.setAttribute(o, "")
                  : Hf(s, o, f);
            }
      }
    }
    function ni(s, r, o) {
      switch (r) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          (gt("error", s), gt("load", s));
          var f = !1,
            b = !1,
            _;
          for (_ in o)
            if (o.hasOwnProperty(_)) {
              var A = o[_];
              if (A != null)
                switch (_) {
                  case "src":
                    f = !0;
                    break;
                  case "srcSet":
                    b = !0;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(i(137, r));
                  default:
                    Xt(s, r, _, A, o, null);
                }
            }
          (b && Xt(s, r, "srcSet", o.srcSet, o, null),
            f && Xt(s, r, "src", o.src, o, null));
          return;
        case "input":
          gt("invalid", s);
          var D = (_ = A = b = null),
            $ = null,
            se = null;
          for (f in o)
            if (o.hasOwnProperty(f)) {
              var ge = o[f];
              if (ge != null)
                switch (f) {
                  case "name":
                    b = ge;
                    break;
                  case "type":
                    A = ge;
                    break;
                  case "checked":
                    $ = ge;
                    break;
                  case "defaultChecked":
                    se = ge;
                    break;
                  case "value":
                    _ = ge;
                    break;
                  case "defaultValue":
                    D = ge;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (ge != null) throw Error(i(137, r));
                    break;
                  default:
                    Xt(s, r, f, ge, o, null);
                }
            }
          Gf(s, _, D, $, se, A, b, !1);
          return;
        case "select":
          (gt("invalid", s), (f = A = _ = null));
          for (b in o)
            if (o.hasOwnProperty(b) && ((D = o[b]), D != null))
              switch (b) {
                case "value":
                  _ = D;
                  break;
                case "defaultValue":
                  A = D;
                  break;
                case "multiple":
                  f = D;
                default:
                  Xt(s, r, b, D, o, null);
              }
          ((r = _),
            (o = A),
            (s.multiple = !!f),
            r != null ? Ol(s, !!f, r, !1) : o != null && Ol(s, !!f, o, !0));
          return;
        case "textarea":
          (gt("invalid", s), (_ = b = f = null));
          for (A in o)
            if (o.hasOwnProperty(A) && ((D = o[A]), D != null))
              switch (A) {
                case "value":
                  f = D;
                  break;
                case "defaultValue":
                  b = D;
                  break;
                case "children":
                  _ = D;
                  break;
                case "dangerouslySetInnerHTML":
                  if (D != null) throw Error(i(91));
                  break;
                default:
                  Xt(s, r, A, D, o, null);
              }
          Wf(s, f, b, _);
          return;
        case "option":
          for ($ in o)
            if (o.hasOwnProperty($) && ((f = o[$]), f != null))
              switch ($) {
                case "selected":
                  s.selected =
                    f && typeof f != "function" && typeof f != "symbol";
                  break;
                default:
                  Xt(s, r, $, f, o, null);
              }
          return;
        case "dialog":
          (gt("beforetoggle", s),
            gt("toggle", s),
            gt("cancel", s),
            gt("close", s));
          break;
        case "iframe":
        case "object":
          gt("load", s);
          break;
        case "video":
        case "audio":
          for (f = 0; f < Zu.length; f++) gt(Zu[f], s);
          break;
        case "image":
          (gt("error", s), gt("load", s));
          break;
        case "details":
          gt("toggle", s);
          break;
        case "embed":
        case "source":
        case "link":
          (gt("error", s), gt("load", s));
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (se in o)
            if (o.hasOwnProperty(se) && ((f = o[se]), f != null))
              switch (se) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(i(137, r));
                default:
                  Xt(s, r, se, f, o, null);
              }
          return;
        default:
          if (Xf(r)) {
            for (ge in o)
              o.hasOwnProperty(ge) &&
                ((f = o[ge]), f !== void 0 && Fm(s, r, ge, f, o, void 0));
            return;
          }
      }
      for (D in o)
        o.hasOwnProperty(D) &&
          ((f = o[D]), f != null && Xt(s, r, D, f, o, null));
    }
    function F1(s, r, o, f) {
      switch (r) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var b = null,
            _ = null,
            A = null,
            D = null,
            $ = null,
            se = null,
            ge = null;
          for (ue in o) {
            var _e = o[ue];
            if (o.hasOwnProperty(ue) && _e != null)
              switch (ue) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  $ = _e;
                default:
                  f.hasOwnProperty(ue) || Xt(s, r, ue, null, f, _e);
              }
          }
          for (var re in f) {
            var ue = f[re];
            if (
              ((_e = o[re]), f.hasOwnProperty(re) && (ue != null || _e != null))
            )
              switch (re) {
                case "type":
                  _ = ue;
                  break;
                case "name":
                  b = ue;
                  break;
                case "checked":
                  se = ue;
                  break;
                case "defaultChecked":
                  ge = ue;
                  break;
                case "value":
                  A = ue;
                  break;
                case "defaultValue":
                  D = ue;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (ue != null) throw Error(i(137, r));
                  break;
                default:
                  ue !== _e && Xt(s, r, re, ue, f, _e);
              }
          }
          $f(s, A, D, $, se, ge, _, b);
          return;
        case "select":
          ue = A = D = re = null;
          for (_ in o)
            if ((($ = o[_]), o.hasOwnProperty(_) && $ != null))
              switch (_) {
                case "value":
                  break;
                case "multiple":
                  ue = $;
                default:
                  f.hasOwnProperty(_) || Xt(s, r, _, null, f, $);
              }
          for (b in f)
            if (
              ((_ = f[b]),
              ($ = o[b]),
              f.hasOwnProperty(b) && (_ != null || $ != null))
            )
              switch (b) {
                case "value":
                  re = _;
                  break;
                case "defaultValue":
                  D = _;
                  break;
                case "multiple":
                  A = _;
                default:
                  _ !== $ && Xt(s, r, b, _, f, $);
              }
          ((r = D),
            (o = A),
            (f = ue),
            re != null
              ? Ol(s, !!o, re, !1)
              : !!f != !!o &&
                (r != null ? Ol(s, !!o, r, !0) : Ol(s, !!o, o ? [] : "", !1)));
          return;
        case "textarea":
          ue = re = null;
          for (D in o)
            if (
              ((b = o[D]),
              o.hasOwnProperty(D) && b != null && !f.hasOwnProperty(D))
            )
              switch (D) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  Xt(s, r, D, null, f, b);
              }
          for (A in f)
            if (
              ((b = f[A]),
              (_ = o[A]),
              f.hasOwnProperty(A) && (b != null || _ != null))
            )
              switch (A) {
                case "value":
                  re = b;
                  break;
                case "defaultValue":
                  ue = b;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (b != null) throw Error(i(91));
                  break;
                default:
                  b !== _ && Xt(s, r, A, b, f, _);
              }
          Vf(s, re, ue);
          return;
        case "option":
          for (var Ie in o)
            if (
              ((re = o[Ie]),
              o.hasOwnProperty(Ie) && re != null && !f.hasOwnProperty(Ie))
            )
              switch (Ie) {
                case "selected":
                  s.selected = !1;
                  break;
                default:
                  Xt(s, r, Ie, null, f, re);
              }
          for ($ in f)
            if (
              ((re = f[$]),
              (ue = o[$]),
              f.hasOwnProperty($) && re !== ue && (re != null || ue != null))
            )
              switch ($) {
                case "selected":
                  s.selected =
                    re && typeof re != "function" && typeof re != "symbol";
                  break;
                default:
                  Xt(s, r, $, re, f, ue);
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var Ve in o)
            ((re = o[Ve]),
              o.hasOwnProperty(Ve) &&
                re != null &&
                !f.hasOwnProperty(Ve) &&
                Xt(s, r, Ve, null, f, re));
          for (se in f)
            if (
              ((re = f[se]),
              (ue = o[se]),
              f.hasOwnProperty(se) && re !== ue && (re != null || ue != null))
            )
              switch (se) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (re != null) throw Error(i(137, r));
                  break;
                default:
                  Xt(s, r, se, re, f, ue);
              }
          return;
        default:
          if (Xf(r)) {
            for (var Qt in o)
              ((re = o[Qt]),
                o.hasOwnProperty(Qt) &&
                  re !== void 0 &&
                  !f.hasOwnProperty(Qt) &&
                  Fm(s, r, Qt, void 0, f, re));
            for (ge in f)
              ((re = f[ge]),
                (ue = o[ge]),
                !f.hasOwnProperty(ge) ||
                  re === ue ||
                  (re === void 0 && ue === void 0) ||
                  Fm(s, r, ge, re, f, ue));
            return;
          }
      }
      for (var te in o)
        ((re = o[te]),
          o.hasOwnProperty(te) &&
            re != null &&
            !f.hasOwnProperty(te) &&
            Xt(s, r, te, null, f, re));
      for (_e in f)
        ((re = f[_e]),
          (ue = o[_e]),
          !f.hasOwnProperty(_e) ||
            re === ue ||
            (re == null && ue == null) ||
            Xt(s, r, _e, re, f, ue));
    }
    function Bm(s) {
      switch (s) {
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
          return !0;
        default:
          return !1;
      }
    }
    function Ju() {
      if (typeof performance.getEntriesByType == "function") {
        for (
          var s = 0, r = 0, o = performance.getEntriesByType("resource"), f = 0;
          f < o.length;
          f++
        ) {
          var b = o[f],
            _ = b.transferSize,
            A = b.initiatorType,
            D = b.duration;
          if (_ && D && Bm(A)) {
            for (A = 0, D = b.responseEnd, f += 1; f < o.length; f++) {
              var $ = o[f],
                se = $.startTime;
              if (se > D) break;
              var ge = $.transferSize,
                _e = $.initiatorType;
              ge &&
                Bm(_e) &&
                (($ = $.responseEnd),
                (A += ge * ($ < D ? 1 : (D - se) / ($ - se))));
            }
            if ((--f, (r += (8 * (_ + A)) / (b.duration / 1e3)), s++, 10 < s))
              break;
          }
        }
        if (0 < s) return r / s / 1e6;
      }
      return navigator.connection &&
        ((s = navigator.connection.downlink), typeof s == "number")
        ? s
        : 5;
    }
    var ef = null,
      Hm = null;
    function tf(s) {
      return s.nodeType === 9 ? s : s.ownerDocument;
    }
    function nf(s) {
      switch (s) {
        case "http://www.w3.org/2000/svg":
          return 1;
        case "http://www.w3.org/1998/Math/MathML":
          return 2;
        default:
          return 0;
      }
    }
    function Li(s, r) {
      if (s === 0)
        switch (r) {
          case "svg":
            return 1;
          case "math":
            return 2;
          default:
            return 0;
        }
      return s === 1 && r === "foreignObject" ? 0 : s;
    }
    function Ka(s, r) {
      return (
        s === "textarea" ||
        s === "noscript" ||
        typeof r.children == "string" ||
        typeof r.children == "number" ||
        typeof r.children == "bigint" ||
        (typeof r.dangerouslySetInnerHTML == "object" &&
          r.dangerouslySetInnerHTML !== null &&
          r.dangerouslySetInnerHTML.__html != null)
      );
    }
    var Ym = null;
    function B1() {
      var s = window.event;
      return s && s.type === "popstate"
        ? s === Ym
          ? !1
          : ((Ym = s), !0)
        : ((Ym = null), !1);
    }
    var Yy = typeof setTimeout == "function" ? setTimeout : void 0,
      H1 = typeof clearTimeout == "function" ? clearTimeout : void 0,
      qy = typeof Promise == "function" ? Promise : void 0,
      $y =
        typeof queueMicrotask == "function"
          ? queueMicrotask
          : typeof qy < "u"
            ? function (s) {
                return qy.resolve(null).then(s).catch(oa);
              }
            : Yy;
    function oa(s) {
      setTimeout(function () {
        throw s;
      });
    }
    function Qe(s) {
      return s === "head";
    }
    function qm(s, r) {
      var o = r,
        f = 0;
      do {
        var b = o.nextSibling;
        if ((s.removeChild(o), b && b.nodeType === 8))
          if (((o = b.data), o === "/$" || o === "/&")) {
            if (f === 0) {
              (s.removeChild(b), xc(r));
              return;
            }
            f--;
          } else if (
            o === "$" ||
            o === "$?" ||
            o === "$~" ||
            o === "$!" ||
            o === "&"
          )
            f++;
          else if (o === "html") sf(s.ownerDocument.documentElement);
          else if (o === "head") {
            ((o = s.ownerDocument.head), sf(o));
            for (var _ = o.firstChild; _; ) {
              var A = _.nextSibling,
                D = _.nodeName;
              (_[Fe] ||
                D === "SCRIPT" ||
                D === "STYLE" ||
                (D === "LINK" && _.rel.toLowerCase() === "stylesheet") ||
                o.removeChild(_),
                (_ = A));
            }
          } else o === "body" && sf(s.ownerDocument.body);
        o = b;
      } while (o);
      xc(r);
    }
    function cs(s, r) {
      var o = s;
      s = 0;
      do {
        var f = o.nextSibling;
        if (
          (o.nodeType === 1
            ? r
              ? ((o._stashedDisplay = o.style.display),
                (o.style.display = "none"))
              : ((o.style.display = o._stashedDisplay || ""),
                o.getAttribute("style") === "" && o.removeAttribute("style"))
            : o.nodeType === 3 &&
              (r
                ? ((o._stashedText = o.nodeValue), (o.nodeValue = ""))
                : (o.nodeValue = o._stashedText || "")),
          f && f.nodeType === 8)
        )
          if (((o = f.data), o === "/$")) {
            if (s === 0) break;
            s--;
          } else (o !== "$" && o !== "$?" && o !== "$~" && o !== "$!") || s++;
        o = f;
      } while (o);
    }
    function lh(s) {
      var r = s.firstChild;
      for (r && r.nodeType === 10 && (r = r.nextSibling); r; ) {
        var o = r;
        switch (((r = r.nextSibling), o.nodeName)) {
          case "HTML":
          case "HEAD":
          case "BODY":
            (lh(o), Z(o));
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if (o.rel.toLowerCase() === "stylesheet") continue;
        }
        s.removeChild(o);
      }
    }
    function Y1(s, r, o, f) {
      for (; s.nodeType === 1; ) {
        var b = o;
        if (s.nodeName.toLowerCase() !== r.toLowerCase()) {
          if (!f && (s.nodeName !== "INPUT" || s.type !== "hidden")) break;
        } else if (f) {
          if (!s[Fe])
            switch (r) {
              case "meta":
                if (!s.hasAttribute("itemprop")) break;
                return s;
              case "link":
                if (
                  ((_ = s.getAttribute("rel")),
                  _ === "stylesheet" && s.hasAttribute("data-precedence"))
                )
                  break;
                if (
                  _ !== b.rel ||
                  s.getAttribute("href") !==
                    (b.href == null || b.href === "" ? null : b.href) ||
                  s.getAttribute("crossorigin") !==
                    (b.crossOrigin == null ? null : b.crossOrigin) ||
                  s.getAttribute("title") !== (b.title == null ? null : b.title)
                )
                  break;
                return s;
              case "style":
                if (s.hasAttribute("data-precedence")) break;
                return s;
              case "script":
                if (
                  ((_ = s.getAttribute("src")),
                  (_ !== (b.src == null ? null : b.src) ||
                    s.getAttribute("type") !==
                      (b.type == null ? null : b.type) ||
                    s.getAttribute("crossorigin") !==
                      (b.crossOrigin == null ? null : b.crossOrigin)) &&
                    _ &&
                    s.hasAttribute("async") &&
                    !s.hasAttribute("itemprop"))
                )
                  break;
                return s;
              default:
                return s;
            }
        } else if (r === "input" && s.type === "hidden") {
          var _ = b.name == null ? null : "" + b.name;
          if (b.type === "hidden" && s.getAttribute("name") === _) return s;
        } else return s;
        if (((s = Ps(s.nextSibling)), s === null)) break;
      }
      return null;
    }
    function Ut(s, r, o) {
      if (r === "") return null;
      for (; s.nodeType !== 3; )
        if (
          ((s.nodeType !== 1 ||
            s.nodeName !== "INPUT" ||
            s.type !== "hidden") &&
            !o) ||
          ((s = Ps(s.nextSibling)), s === null)
        )
          return null;
      return s;
    }
    function Gy(s, r) {
      for (; s.nodeType !== 8; )
        if (
          ((s.nodeType !== 1 ||
            s.nodeName !== "INPUT" ||
            s.type !== "hidden") &&
            !r) ||
          ((s = Ps(s.nextSibling)), s === null)
        )
          return null;
      return s;
    }
    function oh(s) {
      return s.data === "$?" || s.data === "$~";
    }
    function dc(s) {
      return (
        s.data === "$!" ||
        (s.data === "$?" && s.ownerDocument.readyState !== "loading")
      );
    }
    function q1(s, r) {
      var o = s.ownerDocument;
      if (s.data === "$~") s._reactRetry = r;
      else if (s.data !== "$?" || o.readyState !== "loading") r();
      else {
        var f = function () {
          (r(), o.removeEventListener("DOMContentLoaded", f));
        };
        (o.addEventListener("DOMContentLoaded", f), (s._reactRetry = f));
      }
    }
    function Ps(s) {
      for (; s != null; s = s.nextSibling) {
        var r = s.nodeType;
        if (r === 1 || r === 3) break;
        if (r === 8) {
          if (
            ((r = s.data),
            r === "$" ||
              r === "$!" ||
              r === "$?" ||
              r === "$~" ||
              r === "&" ||
              r === "F!" ||
              r === "F")
          )
            break;
          if (r === "/$" || r === "/&") return null;
        }
      }
      return s;
    }
    var $m = null;
    function Vy(s) {
      s = s.nextSibling;
      for (var r = 0; s; ) {
        if (s.nodeType === 8) {
          var o = s.data;
          if (o === "/$" || o === "/&") {
            if (r === 0) return Ps(s.nextSibling);
            r--;
          } else
            (o !== "$" &&
              o !== "$!" &&
              o !== "$?" &&
              o !== "$~" &&
              o !== "&") ||
              r++;
        }
        s = s.nextSibling;
      }
      return null;
    }
    function Wy(s) {
      s = s.previousSibling;
      for (var r = 0; s; ) {
        if (s.nodeType === 8) {
          var o = s.data;
          if (
            o === "$" ||
            o === "$!" ||
            o === "$?" ||
            o === "$~" ||
            o === "&"
          ) {
            if (r === 0) return s;
            r--;
          } else (o !== "/$" && o !== "/&") || r++;
        }
        s = s.previousSibling;
      }
      return null;
    }
    function Xy(s, r, o) {
      switch (((r = tf(o)), s)) {
        case "html":
          if (((s = r.documentElement), !s)) throw Error(i(452));
          return s;
        case "head":
          if (((s = r.head), !s)) throw Error(i(453));
          return s;
        case "body":
          if (((s = r.body), !s)) throw Error(i(454));
          return s;
        default:
          throw Error(i(451));
      }
    }
    function sf(s) {
      for (var r = s.attributes; r.length; ) s.removeAttributeNode(r[0]);
      Z(s);
    }
    var Is = new Map(),
      Qy = new Set();
    function ch(s) {
      return typeof s.getRootNode == "function"
        ? s.getRootNode()
        : s.nodeType === 9
          ? s
          : s.ownerDocument;
    }
    var ca = pe.d;
    pe.d = { f: $1, r: G1, D: Gm, C: V1, L: W1, m: X1, X: Di, S: Vn, M: Q1 };
    function $1() {
      var s = ca.f(),
        r = Kd();
      return s || r;
    }
    function G1(s) {
      var r = Le(s);
      r !== null && r.tag === 5 && r.type === "form" ? Qp(r) : ca.r(s);
    }
    var Ja = typeof document > "u" ? null : document;
    function Zy(s, r, o) {
      var f = Ja;
      if (f && typeof r == "string" && r) {
        var b = Gi(r);
        ((b = 'link[rel="' + s + '"][href="' + b + '"]'),
          typeof o == "string" && (b += '[crossorigin="' + o + '"]'),
          Qy.has(b) ||
            (Qy.add(b),
            (s = { rel: s, crossOrigin: o, href: r }),
            f.querySelector(b) === null &&
              ((r = f.createElement("link")),
              ni(r, "link", s),
              ft(r),
              f.head.appendChild(r))));
      }
    }
    function Gm(s) {
      (ca.D(s), Zy("dns-prefetch", s, null));
    }
    function V1(s, r) {
      (ca.C(s, r), Zy("preconnect", s, r));
    }
    function W1(s, r, o) {
      ca.L(s, r, o);
      var f = Ja;
      if (f && s && r) {
        var b = 'link[rel="preload"][as="' + Gi(r) + '"]';
        r === "image" && o && o.imageSrcSet
          ? ((b += '[imagesrcset="' + Gi(o.imageSrcSet) + '"]'),
            typeof o.imageSizes == "string" &&
              (b += '[imagesizes="' + Gi(o.imageSizes) + '"]'))
          : (b += '[href="' + Gi(s) + '"]');
        var _ = b;
        switch (r) {
          case "style":
            _ = hc(s);
            break;
          case "script":
            _ = mc(s);
        }
        Is.has(_) ||
          ((s = y(
            {
              rel: "preload",
              href: r === "image" && o && o.imageSrcSet ? void 0 : s,
              as: r,
            },
            o,
          )),
          Is.set(_, s),
          f.querySelector(b) !== null ||
            (r === "style" && f.querySelector(pc(_))) ||
            (r === "script" && f.querySelector(gc(_))) ||
            ((r = f.createElement("link")),
            ni(r, "link", s),
            ft(r),
            f.head.appendChild(r)));
      }
    }
    function X1(s, r) {
      ca.m(s, r);
      var o = Ja;
      if (o && s) {
        var f = r && typeof r.as == "string" ? r.as : "script",
          b =
            'link[rel="modulepreload"][as="' +
            Gi(f) +
            '"][href="' +
            Gi(s) +
            '"]',
          _ = b;
        switch (f) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            _ = mc(s);
        }
        if (
          !Is.has(_) &&
          ((s = y({ rel: "modulepreload", href: s }, r)),
          Is.set(_, s),
          o.querySelector(b) === null)
        ) {
          switch (f) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              if (o.querySelector(gc(_))) return;
          }
          ((f = o.createElement("link")),
            ni(f, "link", s),
            ft(f),
            o.head.appendChild(f));
        }
      }
    }
    function Vn(s, r, o) {
      ca.S(s, r, o);
      var f = Ja;
      if (f && s) {
        var b = nn(f).hoistableStyles,
          _ = hc(s);
        r = r || "default";
        var A = b.get(_);
        if (!A) {
          var D = { loading: 0, preload: null };
          if ((A = f.querySelector(pc(_)))) D.loading = 5;
          else {
            ((s = y({ rel: "stylesheet", href: s, "data-precedence": r }, o)),
              (o = Is.get(_)) && Vm(s, o));
            var $ = (A = f.createElement("link"));
            (ft($),
              ni($, "link", s),
              ($._p = new Promise(function (se, ge) {
                (($.onload = se), ($.onerror = ge));
              })),
              $.addEventListener("load", function () {
                D.loading |= 1;
              }),
              $.addEventListener("error", function () {
                D.loading |= 2;
              }),
              (D.loading |= 4),
              uh(A, r, f));
          }
          ((A = { type: "stylesheet", instance: A, count: 1, state: D }),
            b.set(_, A));
        }
      }
    }
    function Di(s, r) {
      ca.X(s, r);
      var o = Ja;
      if (o && s) {
        var f = nn(o).hoistableScripts,
          b = mc(s),
          _ = f.get(b);
        _ ||
          ((_ = o.querySelector(gc(b))),
          _ ||
            ((s = y({ src: s, async: !0 }, r)),
            (r = Is.get(b)) && fh(s, r),
            (_ = o.createElement("script")),
            ft(_),
            ni(_, "link", s),
            o.head.appendChild(_)),
          (_ = { type: "script", instance: _, count: 1, state: null }),
          f.set(b, _));
      }
    }
    function Q1(s, r) {
      ca.M(s, r);
      var o = Ja;
      if (o && s) {
        var f = nn(o).hoistableScripts,
          b = mc(s),
          _ = f.get(b);
        _ ||
          ((_ = o.querySelector(gc(b))),
          _ ||
            ((s = y({ src: s, async: !0, type: "module" }, r)),
            (r = Is.get(b)) && fh(s, r),
            (_ = o.createElement("script")),
            ft(_),
            ni(_, "link", s),
            o.head.appendChild(_)),
          (_ = { type: "script", instance: _, count: 1, state: null }),
          f.set(b, _));
      }
    }
    function Ky(s, r, o, f) {
      var b = (b = Re.current) ? ch(b) : null;
      if (!b) throw Error(i(446));
      switch (s) {
        case "meta":
        case "title":
          return null;
        case "style":
          return typeof o.precedence == "string" && typeof o.href == "string"
            ? ((r = hc(o.href)),
              (o = nn(b).hoistableStyles),
              (f = o.get(r)),
              f ||
                ((f = { type: "style", instance: null, count: 0, state: null }),
                o.set(r, f)),
              f)
            : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if (
            o.rel === "stylesheet" &&
            typeof o.href == "string" &&
            typeof o.precedence == "string"
          ) {
            s = hc(o.href);
            var _ = nn(b).hoistableStyles,
              A = _.get(s);
            if (
              (A ||
                ((b = b.ownerDocument || b),
                (A = {
                  type: "stylesheet",
                  instance: null,
                  count: 0,
                  state: { loading: 0, preload: null },
                }),
                _.set(s, A),
                (_ = b.querySelector(pc(s))) &&
                  !_._p &&
                  ((A.instance = _), (A.state.loading = 5)),
                Is.has(s) ||
                  ((o = {
                    rel: "preload",
                    as: "style",
                    href: o.href,
                    crossOrigin: o.crossOrigin,
                    integrity: o.integrity,
                    media: o.media,
                    hrefLang: o.hrefLang,
                    referrerPolicy: o.referrerPolicy,
                  }),
                  Is.set(s, o),
                  _ || Z1(b, s, o, A.state))),
              r && f === null)
            )
              throw Error(i(528, ""));
            return A;
          }
          if (r && f !== null) throw Error(i(529, ""));
          return null;
        case "script":
          return (
            (r = o.async),
            (o = o.src),
            typeof o == "string" &&
            r &&
            typeof r != "function" &&
            typeof r != "symbol"
              ? ((r = mc(o)),
                (o = nn(b).hoistableScripts),
                (f = o.get(r)),
                f ||
                  ((f = {
                    type: "script",
                    instance: null,
                    count: 0,
                    state: null,
                  }),
                  o.set(r, f)),
                f)
              : { type: "void", instance: null, count: 0, state: null }
          );
        default:
          throw Error(i(444, s));
      }
    }
    function hc(s) {
      return 'href="' + Gi(s) + '"';
    }
    function pc(s) {
      return 'link[rel="stylesheet"][' + s + "]";
    }
    function Jy(s) {
      return y({}, s, { "data-precedence": s.precedence, precedence: null });
    }
    function Z1(s, r, o, f) {
      s.querySelector('link[rel="preload"][as="style"][' + r + "]")
        ? (f.loading = 1)
        : ((r = s.createElement("link")),
          (f.preload = r),
          r.addEventListener("load", function () {
            return (f.loading |= 1);
          }),
          r.addEventListener("error", function () {
            return (f.loading |= 2);
          }),
          ni(r, "link", o),
          ft(r),
          s.head.appendChild(r));
    }
    function mc(s) {
      return '[src="' + Gi(s) + '"]';
    }
    function gc(s) {
      return "script[async]" + s;
    }
    function e0(s, r, o) {
      if ((r.count++, r.instance === null))
        switch (r.type) {
          case "style":
            var f = s.querySelector('style[data-href~="' + Gi(o.href) + '"]');
            if (f) return ((r.instance = f), ft(f), f);
            var b = y({}, o, {
              "data-href": o.href,
              "data-precedence": o.precedence,
              href: null,
              precedence: null,
            });
            return (
              (f = (s.ownerDocument || s).createElement("style")),
              ft(f),
              ni(f, "style", b),
              uh(f, o.precedence, s),
              (r.instance = f)
            );
          case "stylesheet":
            b = hc(o.href);
            var _ = s.querySelector(pc(b));
            if (_) return ((r.state.loading |= 4), (r.instance = _), ft(_), _);
            ((f = Jy(o)),
              (b = Is.get(b)) && Vm(f, b),
              (_ = (s.ownerDocument || s).createElement("link")),
              ft(_));
            var A = _;
            return (
              (A._p = new Promise(function (D, $) {
                ((A.onload = D), (A.onerror = $));
              })),
              ni(_, "link", f),
              (r.state.loading |= 4),
              uh(_, o.precedence, s),
              (r.instance = _)
            );
          case "script":
            return (
              (_ = mc(o.src)),
              (b = s.querySelector(gc(_)))
                ? ((r.instance = b), ft(b), b)
                : ((f = o),
                  (b = Is.get(_)) && ((f = y({}, o)), fh(f, b)),
                  (s = s.ownerDocument || s),
                  (b = s.createElement("script")),
                  ft(b),
                  ni(b, "link", f),
                  s.head.appendChild(b),
                  (r.instance = b))
            );
          case "void":
            return null;
          default:
            throw Error(i(443, r.type));
        }
      else
        r.type === "stylesheet" &&
          (r.state.loading & 4) === 0 &&
          ((f = r.instance), (r.state.loading |= 4), uh(f, o.precedence, s));
      return r.instance;
    }
    function uh(s, r, o) {
      for (
        var f = o.querySelectorAll(
            'link[rel="stylesheet"][data-precedence],style[data-precedence]',
          ),
          b = f.length ? f[f.length - 1] : null,
          _ = b,
          A = 0;
        A < f.length;
        A++
      ) {
        var D = f[A];
        if (D.dataset.precedence === r) _ = D;
        else if (_ !== b) break;
      }
      _
        ? _.parentNode.insertBefore(s, _.nextSibling)
        : ((r = o.nodeType === 9 ? o.head : o),
          r.insertBefore(s, r.firstChild));
    }
    function Vm(s, r) {
      (s.crossOrigin == null && (s.crossOrigin = r.crossOrigin),
        s.referrerPolicy == null && (s.referrerPolicy = r.referrerPolicy),
        s.title == null && (s.title = r.title));
    }
    function fh(s, r) {
      (s.crossOrigin == null && (s.crossOrigin = r.crossOrigin),
        s.referrerPolicy == null && (s.referrerPolicy = r.referrerPolicy),
        s.integrity == null && (s.integrity = r.integrity));
    }
    var rf = null;
    function t0(s, r, o) {
      if (rf === null) {
        var f = new Map(),
          b = (rf = new Map());
        b.set(o, f);
      } else ((b = rf), (f = b.get(o)), f || ((f = new Map()), b.set(o, f)));
      if (f.has(s)) return f;
      for (
        f.set(s, null), o = o.getElementsByTagName(s), b = 0;
        b < o.length;
        b++
      ) {
        var _ = o[b];
        if (
          !(
            _[Fe] ||
            _[Dn] ||
            (s === "link" && _.getAttribute("rel") === "stylesheet")
          ) &&
          _.namespaceURI !== "http://www.w3.org/2000/svg"
        ) {
          var A = _.getAttribute(r) || "";
          A = s + A;
          var D = f.get(A);
          D ? D.push(_) : f.set(A, [_]);
        }
      }
      return f;
    }
    function n0(s, r, o) {
      ((s = s.ownerDocument || s),
        s.head.insertBefore(
          o,
          r === "title" ? s.querySelector("head > title") : null,
        ));
    }
    function K1(s, r, o) {
      if (o === 1 || r.itemProp != null) return !1;
      switch (s) {
        case "meta":
        case "title":
          return !0;
        case "style":
          if (
            typeof r.precedence != "string" ||
            typeof r.href != "string" ||
            r.href === ""
          )
            break;
          return !0;
        case "link":
          if (
            typeof r.rel != "string" ||
            typeof r.href != "string" ||
            r.href === "" ||
            r.onLoad ||
            r.onError
          )
            break;
          switch (r.rel) {
            case "stylesheet":
              return (
                (s = r.disabled),
                typeof r.precedence == "string" && s == null
              );
            default:
              return !0;
          }
        case "script":
          if (
            r.async &&
            typeof r.async != "function" &&
            typeof r.async != "symbol" &&
            !r.onLoad &&
            !r.onError &&
            r.src &&
            typeof r.src == "string"
          )
            return !0;
      }
      return !1;
    }
    function i0(s) {
      return !(s.type === "stylesheet" && (s.state.loading & 3) === 0);
    }
    function vc(s, r, o, f) {
      if (
        o.type === "stylesheet" &&
        (typeof f.media != "string" || matchMedia(f.media).matches !== !1) &&
        (o.state.loading & 4) === 0
      ) {
        if (o.instance === null) {
          var b = hc(f.href),
            _ = r.querySelector(pc(b));
          if (_) {
            ((r = _._p),
              r !== null &&
                typeof r == "object" &&
                typeof r.then == "function" &&
                (s.count++, (s = dh.bind(s)), r.then(s, s)),
              (o.state.loading |= 4),
              (o.instance = _),
              ft(_));
            return;
          }
          ((_ = r.ownerDocument || r),
            (f = Jy(f)),
            (b = Is.get(b)) && Vm(f, b),
            (_ = _.createElement("link")),
            ft(_));
          var A = _;
          ((A._p = new Promise(function (D, $) {
            ((A.onload = D), (A.onerror = $));
          })),
            ni(_, "link", f),
            (o.instance = _));
        }
        (s.stylesheets === null && (s.stylesheets = new Map()),
          s.stylesheets.set(o, r),
          (r = o.state.preload) &&
            (o.state.loading & 3) === 0 &&
            (s.count++,
            (o = dh.bind(s)),
            r.addEventListener("load", o),
            r.addEventListener("error", o)));
      }
    }
    var Wm = 0;
    function J1(s, r) {
      return (
        s.stylesheets && s.count === 0 && ph(s, s.stylesheets),
        0 < s.count || 0 < s.imgCount
          ? function (o) {
              var f = setTimeout(function () {
                if ((s.stylesheets && ph(s, s.stylesheets), s.unsuspend)) {
                  var _ = s.unsuspend;
                  ((s.unsuspend = null), _());
                }
              }, 6e4 + r);
              0 < s.imgBytes && Wm === 0 && (Wm = 62500 * Ju());
              var b = setTimeout(
                function () {
                  if (
                    ((s.waitingForImages = !1),
                    s.count === 0 &&
                      (s.stylesheets && ph(s, s.stylesheets), s.unsuspend))
                  ) {
                    var _ = s.unsuspend;
                    ((s.unsuspend = null), _());
                  }
                },
                (s.imgBytes > Wm ? 50 : 800) + r,
              );
              return (
                (s.unsuspend = o),
                function () {
                  ((s.unsuspend = null), clearTimeout(f), clearTimeout(b));
                }
              );
            }
          : null
      );
    }
    function dh() {
      if (
        (this.count--,
        this.count === 0 && (this.imgCount === 0 || !this.waitingForImages))
      ) {
        if (this.stylesheets) ph(this, this.stylesheets);
        else if (this.unsuspend) {
          var s = this.unsuspend;
          ((this.unsuspend = null), s());
        }
      }
    }
    var hh = null;
    function ph(s, r) {
      ((s.stylesheets = null),
        s.unsuspend !== null &&
          (s.count++,
          (hh = new Map()),
          r.forEach(s0, s),
          (hh = null),
          dh.call(s)));
    }
    function s0(s, r) {
      if (!(r.state.loading & 4)) {
        var o = hh.get(s);
        if (o) var f = o.get(null);
        else {
          ((o = new Map()), hh.set(s, o));
          for (
            var b = s.querySelectorAll(
                "link[data-precedence],style[data-precedence]",
              ),
              _ = 0;
            _ < b.length;
            _++
          ) {
            var A = b[_];
            (A.nodeName === "LINK" || A.getAttribute("media") !== "not all") &&
              (o.set(A.dataset.precedence, A), (f = A));
          }
          f && o.set(null, f);
        }
        ((b = r.instance),
          (A = b.getAttribute("data-precedence")),
          (_ = o.get(A) || f),
          _ === f && o.set(null, b),
          o.set(A, b),
          this.count++,
          (f = dh.bind(this)),
          b.addEventListener("load", f),
          b.addEventListener("error", f),
          _
            ? _.parentNode.insertBefore(b, _.nextSibling)
            : ((s = s.nodeType === 9 ? s.head : s),
              s.insertBefore(b, s.firstChild)),
          (r.state.loading |= 4));
      }
    }
    var yc = {
      $$typeof: N,
      Provider: null,
      Consumer: null,
      _currentValue: de,
      _currentValue2: de,
      _threadCount: 0,
    };
    function ex(s, r, o, f, b, _, A, D, $) {
      ((this.tag = 1),
        (this.containerInfo = s),
        (this.pingCache = this.current = this.pendingChildren = null),
        (this.timeoutHandle = -1),
        (this.callbackNode =
          this.next =
          this.pendingContext =
          this.context =
          this.cancelPendingCommit =
            null),
        (this.callbackPriority = 0),
        (this.expirationTimes = Yc(-1)),
        (this.entangledLanes =
          this.shellSuspendCounter =
          this.errorRecoveryDisabledLanes =
          this.expiredLanes =
          this.warmLanes =
          this.pingedLanes =
          this.suspendedLanes =
          this.pendingLanes =
            0),
        (this.entanglements = Yc(0)),
        (this.hiddenUpdates = Yc(null)),
        (this.identifierPrefix = f),
        (this.onUncaughtError = b),
        (this.onCaughtError = _),
        (this.onRecoverableError = A),
        (this.pooledCache = null),
        (this.pooledCacheLanes = 0),
        (this.formState = $),
        (this.incompleteTransitions = new Map()));
    }
    function r0(s, r, o, f, b, _, A, D, $, se, ge, _e) {
      return (
        (s = new ex(s, r, o, A, $, se, ge, _e, D)),
        (r = 1),
        _ === !0 && (r |= 24),
        (_ = Kn(3, null, null, r)),
        (s.current = _),
        (_.stateNode = s),
        (r = Ks()),
        r.refCount++,
        (s.pooledCache = r),
        r.refCount++,
        (_.memoizedState = { element: f, isDehydrated: o, cache: r }),
        Tr(_),
        s
      );
    }
    function a0(s) {
      return s ? ((s = Vr), s) : Vr;
    }
    function l0(s, r, o, f, b, _) {
      ((b = a0(b)),
        f.context === null ? (f.context = b) : (f.pendingContext = b),
        (f = Ua(r)),
        (f.payload = { element: o }),
        (_ = _ === void 0 ? null : _),
        _ !== null && (f.callback = _),
        (o = tr(s, f, r)),
        o !== null && (Ai(o, s, r), mu(o, s, r)));
    }
    function o0(s, r) {
      if (((s = s.memoizedState), s !== null && s.dehydrated !== null)) {
        var o = s.retryLane;
        s.retryLane = o !== 0 && o < r ? o : r;
      }
    }
    function Xm(s, r) {
      (o0(s, r), (s = s.alternate) && o0(s, r));
    }
    function c0(s) {
      if (s.tag === 13 || s.tag === 31) {
        var r = _r(s, 67108864);
        (r !== null && Ai(r, s, 67108864), Xm(s, 67108864));
      }
    }
    function u0(s) {
      if (s.tag === 13 || s.tag === 31) {
        var r = as();
        r = _i(r);
        var o = _r(s, r);
        (o !== null && Ai(o, s, r), Xm(s, r));
      }
    }
    var mh = !0;
    function tx(s, r, o, f) {
      var b = V.T;
      V.T = null;
      var _ = pe.p;
      try {
        ((pe.p = 2), Qm(s, r, o, f));
      } finally {
        ((pe.p = _), (V.T = b));
      }
    }
    function nx(s, r, o, f) {
      var b = V.T;
      V.T = null;
      var _ = pe.p;
      try {
        ((pe.p = 8), Qm(s, r, o, f));
      } finally {
        ((pe.p = _), (V.T = b));
      }
    }
    function Qm(s, r, o, f) {
      if (mh) {
        var b = Zm(f);
        if (b === null) (Um(s, r, f, gh, o), d0(s, f));
        else if (h0(b, s, r, o, f)) f.stopPropagation();
        else if ((d0(s, f), r & 4 && -1 < ix.indexOf(s))) {
          for (; b !== null; ) {
            var _ = Le(b);
            if (_ !== null)
              switch (_.tag) {
                case 3:
                  if (
                    ((_ = _.stateNode), _.current.memoizedState.isDehydrated)
                  ) {
                    var A = qi(_.pendingLanes);
                    if (A !== 0) {
                      var D = _;
                      for (D.pendingLanes |= 2, D.entangledLanes |= 2; A; ) {
                        var $ = 1 << (31 - bn(A));
                        ((D.entanglements[1] |= $), (A &= ~$));
                      }
                      (Mr(_), (kt & 6) === 0 && ((Vl = Xn() + 500), Qu(0)));
                    }
                  }
                  break;
                case 31:
                case 13:
                  ((D = _r(_, 2)), D !== null && Ai(D, _, 2), Kd(), Xm(_, 2));
              }
            if (((_ = Zm(f)), _ === null && Um(s, r, f, gh, o), _ === b)) break;
            b = _;
          }
          b !== null && f.stopPropagation();
        } else Um(s, r, f, null, o);
      }
    }
    function Zm(s) {
      return ((s = fp(s)), Km(s));
    }
    var gh = null;
    function Km(s) {
      if (((gh = null), (s = Ce(s)), s !== null)) {
        var r = l(s);
        if (r === null) s = null;
        else {
          var o = r.tag;
          if (o === 13) {
            if (((s = u(r)), s !== null)) return s;
            s = null;
          } else if (o === 31) {
            if (((s = d(r)), s !== null)) return s;
            s = null;
          } else if (o === 3) {
            if (r.stateNode.current.memoizedState.isDehydrated)
              return r.tag === 3 ? r.stateNode.containerInfo : null;
            s = null;
          } else r !== s && (s = null);
        }
      }
      return ((gh = s), null);
    }
    function f0(s) {
      switch (s) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return 8;
        case "message":
          switch (Gs()) {
            case Br:
              return 2;
            case Qn:
              return 8;
            case Yi:
            case So:
              return 32;
            case xl:
              return 268435456;
            default:
              return 32;
          }
        default:
          return 32;
      }
    }
    var Jm = !1,
      el = null,
      tl = null,
      nl = null,
      af = new Map(),
      lf = new Map(),
      il = [],
      ix =
        "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
          " ",
        );
    function d0(s, r) {
      switch (s) {
        case "focusin":
        case "focusout":
          el = null;
          break;
        case "dragenter":
        case "dragleave":
          tl = null;
          break;
        case "mouseover":
        case "mouseout":
          nl = null;
          break;
        case "pointerover":
        case "pointerout":
          af.delete(r.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          lf.delete(r.pointerId);
      }
    }
    function Ql(s, r, o, f, b, _) {
      return s === null || s.nativeEvent !== _
        ? ((s = {
            blockedOn: r,
            domEventName: o,
            eventSystemFlags: f,
            nativeEvent: _,
            targetContainers: [b],
          }),
          r !== null && ((r = Le(r)), r !== null && c0(r)),
          s)
        : ((s.eventSystemFlags |= f),
          (r = s.targetContainers),
          b !== null && r.indexOf(b) === -1 && r.push(b),
          s);
    }
    function h0(s, r, o, f, b) {
      switch (r) {
        case "focusin":
          return ((el = Ql(el, s, r, o, f, b)), !0);
        case "dragenter":
          return ((tl = Ql(tl, s, r, o, f, b)), !0);
        case "mouseover":
          return ((nl = Ql(nl, s, r, o, f, b)), !0);
        case "pointerover":
          var _ = b.pointerId;
          return (af.set(_, Ql(af.get(_) || null, s, r, o, f, b)), !0);
        case "gotpointercapture":
          return (
            (_ = b.pointerId),
            lf.set(_, Ql(lf.get(_) || null, s, r, o, f, b)),
            !0
          );
      }
      return !1;
    }
    function eg(s) {
      var r = Ce(s.target);
      if (r !== null) {
        var o = l(r);
        if (o !== null) {
          if (((r = o.tag), r === 13)) {
            if (((r = u(o)), r !== null)) {
              ((s.blockedOn = r),
                Vc(s.priority, function () {
                  u0(o);
                }));
              return;
            }
          } else if (r === 31) {
            if (((r = d(o)), r !== null)) {
              ((s.blockedOn = r),
                Vc(s.priority, function () {
                  u0(o);
                }));
              return;
            }
          } else if (
            r === 3 &&
            o.stateNode.current.memoizedState.isDehydrated
          ) {
            s.blockedOn = o.tag === 3 ? o.stateNode.containerInfo : null;
            return;
          }
        }
      }
      s.blockedOn = null;
    }
    function vh(s) {
      if (s.blockedOn !== null) return !1;
      for (var r = s.targetContainers; 0 < r.length; ) {
        var o = Zm(s.nativeEvent);
        if (o === null) {
          o = s.nativeEvent;
          var f = new o.constructor(o.type, o);
          ((up = f), o.target.dispatchEvent(f), (up = null));
        } else return ((r = Le(o)), r !== null && c0(r), (s.blockedOn = o), !1);
        r.shift();
      }
      return !0;
    }
    function p0(s, r, o) {
      vh(s) && o.delete(r);
    }
    function sx() {
      ((Jm = !1),
        el !== null && vh(el) && (el = null),
        tl !== null && vh(tl) && (tl = null),
        nl !== null && vh(nl) && (nl = null),
        af.forEach(p0),
        lf.forEach(p0));
    }
    function bc(s, r) {
      s.blockedOn === r &&
        ((s.blockedOn = null),
        Jm ||
          ((Jm = !0),
          t.unstable_scheduleCallback(t.unstable_NormalPriority, sx)));
    }
    var yh = null;
    function m0(s) {
      yh !== s &&
        ((yh = s),
        t.unstable_scheduleCallback(t.unstable_NormalPriority, function () {
          yh === s && (yh = null);
          for (var r = 0; r < s.length; r += 3) {
            var o = s[r],
              f = s[r + 1],
              b = s[r + 2];
            if (typeof f != "function") {
              if (Km(f || o) === null) continue;
              break;
            }
            var _ = Le(o);
            _ !== null &&
              (s.splice(r, 3),
              (r -= 3),
              Ha(
                _,
                { pending: !0, data: b, method: o.method, action: f },
                f,
                b,
              ));
          }
        }));
    }
    function xc(s) {
      function r($) {
        return bc($, s);
      }
      (el !== null && bc(el, s),
        tl !== null && bc(tl, s),
        nl !== null && bc(nl, s),
        af.forEach(r),
        lf.forEach(r));
      for (var o = 0; o < il.length; o++) {
        var f = il[o];
        f.blockedOn === s && (f.blockedOn = null);
      }
      for (; 0 < il.length && ((o = il[0]), o.blockedOn === null); )
        (eg(o), o.blockedOn === null && il.shift());
      if (((o = (s.ownerDocument || s).$$reactFormReplay), o != null))
        for (f = 0; f < o.length; f += 3) {
          var b = o[f],
            _ = o[f + 1],
            A = b[on] || null;
          if (typeof _ == "function") A || m0(o);
          else if (A) {
            var D = null;
            if (_ && _.hasAttribute("formAction")) {
              if (((b = _), (A = _[on] || null))) D = A.formAction;
              else if (Km(b) !== null) continue;
            } else D = A.action;
            (typeof D == "function"
              ? (o[f + 1] = D)
              : (o.splice(f, 3), (f -= 3)),
              m0(o));
          }
        }
    }
    function vi() {
      function s(_) {
        _.canIntercept &&
          _.info === "react-transition" &&
          _.intercept({
            handler: function () {
              return new Promise(function (A) {
                return (b = A);
              });
            },
            focusReset: "manual",
            scroll: "manual",
          });
      }
      function r() {
        (b !== null && (b(), (b = null)), f || setTimeout(o, 20));
      }
      function o() {
        if (!f && !navigation.transition) {
          var _ = navigation.currentEntry;
          _ &&
            _.url != null &&
            navigation.navigate(_.url, {
              state: _.getState(),
              info: "react-transition",
              history: "replace",
            });
        }
      }
      if (typeof navigation == "object") {
        var f = !1,
          b = null;
        return (
          navigation.addEventListener("navigate", s),
          navigation.addEventListener("navigatesuccess", r),
          navigation.addEventListener("navigateerror", r),
          setTimeout(o, 100),
          function () {
            ((f = !0),
              navigation.removeEventListener("navigate", s),
              navigation.removeEventListener("navigatesuccess", r),
              navigation.removeEventListener("navigateerror", r),
              b !== null && (b(), (b = null)));
          }
        );
      }
    }
    function of(s) {
      this._internalRoot = s;
    }
    ((bh.prototype.render = of.prototype.render =
      function (s) {
        var r = this._internalRoot;
        if (r === null) throw Error(i(409));
        var o = r.current,
          f = as();
        l0(o, f, s, r, null, null);
      }),
      (bh.prototype.unmount = of.prototype.unmount =
        function () {
          var s = this._internalRoot;
          if (s !== null) {
            this._internalRoot = null;
            var r = s.containerInfo;
            (l0(s.current, 2, null, s, null, null), Kd(), (r[Yr] = null));
          }
        }));
    function bh(s) {
      this._internalRoot = s;
    }
    bh.prototype.unstable_scheduleHydration = function (s) {
      if (s) {
        var r = Gc();
        s = { blockedOn: null, target: s, priority: r };
        for (var o = 0; o < il.length && r !== 0 && r < il[o].priority; o++);
        (il.splice(o, 0, s), o === 0 && eg(s));
      }
    };
    var g0 = e.version;
    if (g0 !== "19.2.3") throw Error(i(527, g0, "19.2.3"));
    pe.findDOMNode = function (s) {
      var r = s._reactInternals;
      if (r === void 0)
        throw typeof s.render == "function"
          ? Error(i(188))
          : ((s = Object.keys(s).join(",")), Error(i(268, s)));
      return (
        (s = g(r)),
        (s = s !== null ? v(s) : null),
        (s = s === null ? null : s.stateNode),
        s
      );
    };
    var rx = {
      bundleType: 0,
      version: "19.2.3",
      rendererPackageName: "react-dom",
      currentDispatcherRef: V,
      reconcilerVersion: "19.2.3",
    };
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
      var xh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (!xh.isDisabled && xh.supportsFiber)
        try {
          ((_s = xh.inject(rx)), (Rn = xh));
        } catch {}
    }
    return (
      (ng.createRoot = function (s, r) {
        if (!a(s)) throw Error(i(299));
        var o = !1,
          f = "",
          b = tm,
          _ = nm,
          A = ty;
        return (
          r != null &&
            (r.unstable_strictMode === !0 && (o = !0),
            r.identifierPrefix !== void 0 && (f = r.identifierPrefix),
            r.onUncaughtError !== void 0 && (b = r.onUncaughtError),
            r.onCaughtError !== void 0 && (_ = r.onCaughtError),
            r.onRecoverableError !== void 0 && (A = r.onRecoverableError)),
          (r = r0(s, 1, !1, null, null, o, f, null, b, _, A, vi)),
          (s[Yr] = r.current),
          Im(s),
          new of(r)
        );
      }),
      (ng.hydrateRoot = function (s, r, o) {
        if (!a(s)) throw Error(i(299));
        var f = !1,
          b = "",
          _ = tm,
          A = nm,
          D = ty,
          $ = null;
        return (
          o != null &&
            (o.unstable_strictMode === !0 && (f = !0),
            o.identifierPrefix !== void 0 && (b = o.identifierPrefix),
            o.onUncaughtError !== void 0 && (_ = o.onUncaughtError),
            o.onCaughtError !== void 0 && (A = o.onCaughtError),
            o.onRecoverableError !== void 0 && (D = o.onRecoverableError),
            o.formState !== void 0 && ($ = o.formState)),
          (r = r0(s, 1, !0, r, o ?? null, f, b, $, _, A, D, vi)),
          (r.context = a0(null)),
          (o = r.current),
          (f = as()),
          (f = _i(f)),
          (b = Ua(f)),
          (b.callback = null),
          tr(o, b, f),
          (o = f),
          (r.current.lanes = o),
          ja(r, o),
          Mr(r),
          (s[Yr] = r.current),
          Im(s),
          new bh(r)
        );
      }),
      (ng.version = "19.2.3"),
      ng
    );
  }
  var _S;
  function dj() {
    if (_S) return cx.exports;
    _S = 1;
    function t() {
      if (
        !(
          typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
          typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
        )
      )
        try {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
        } catch (e) {
          console.error(e);
        }
    }
    return (t(), (cx.exports = fj()), cx.exports);
  }
  var hj = dj(),
    W = qg();
  const U = aw(W);
  /**
   * react-router v7.11.0
   *
   * Copyright (c) Remix Software Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ var wS = "popstate";
  function pj(t = {}) {
    function e(i, a) {
      let { pathname: l, search: u, hash: d } = i.location;
      return c_(
        "",
        { pathname: l, search: u, hash: d },
        (a.state && a.state.usr) || null,
        (a.state && a.state.key) || "default",
      );
    }
    function n(i, a) {
      return typeof a == "string" ? a : Cg(a);
    }
    return gj(e, n, null, t);
  }
  function En(t, e) {
    if (t === !1 || t === null || typeof t > "u") throw new Error(e);
  }
  function pr(t, e) {
    if (!t) {
      typeof console < "u" && console.warn(e);
      try {
        throw new Error(e);
      } catch {}
    }
  }
  function mj() {
    return Math.random().toString(36).substring(2, 10);
  }
  function SS(t, e) {
    return { usr: t.state, key: t.key, idx: e };
  }
  function c_(t, e, n = null, i) {
    return {
      pathname: typeof t == "string" ? t : t.pathname,
      search: "",
      hash: "",
      ...(typeof e == "string" ? Zh(e) : e),
      state: n,
      key: (e && e.key) || i || mj(),
    };
  }
  function Cg({ pathname: t = "/", search: e = "", hash: n = "" }) {
    return (
      e && e !== "?" && (t += e.charAt(0) === "?" ? e : "?" + e),
      n && n !== "#" && (t += n.charAt(0) === "#" ? n : "#" + n),
      t
    );
  }
  function Zh(t) {
    let e = {};
    if (t) {
      let n = t.indexOf("#");
      n >= 0 && ((e.hash = t.substring(n)), (t = t.substring(0, n)));
      let i = t.indexOf("?");
      (i >= 0 && ((e.search = t.substring(i)), (t = t.substring(0, i))),
        t && (e.pathname = t));
    }
    return e;
  }
  function gj(t, e, n, i = {}) {
    let { window: a = document.defaultView, v5Compat: l = !1 } = i,
      u = a.history,
      d = "POP",
      m = null,
      g = v();
    g == null && ((g = 0), u.replaceState({ ...u.state, idx: g }, ""));
    function v() {
      return (u.state || { idx: null }).idx;
    }
    function y() {
      d = "POP";
      let j = v(),
        O = j == null ? null : j - g;
      ((g = j), m && m({ action: d, location: E.location, delta: O }));
    }
    function w(j, O) {
      d = "PUSH";
      let M = c_(E.location, j, O);
      g = v() + 1;
      let N = SS(M, g),
        R = E.createHref(M);
      try {
        u.pushState(N, "", R);
      } catch (P) {
        if (P instanceof DOMException && P.name === "DataCloneError") throw P;
        a.location.assign(R);
      }
      l && m && m({ action: d, location: E.location, delta: 1 });
    }
    function S(j, O) {
      d = "REPLACE";
      let M = c_(E.location, j, O);
      g = v();
      let N = SS(M, g),
        R = E.createHref(M);
      (u.replaceState(N, "", R),
        l && m && m({ action: d, location: E.location, delta: 0 }));
    }
    function T(j) {
      return vj(j);
    }
    let E = {
      get action() {
        return d;
      },
      get location() {
        return t(a, u);
      },
      listen(j) {
        if (m) throw new Error("A history only accepts one active listener");
        return (
          a.addEventListener(wS, y),
          (m = j),
          () => {
            (a.removeEventListener(wS, y), (m = null));
          }
        );
      },
      createHref(j) {
        return e(a, j);
      },
      createURL: T,
      encodeLocation(j) {
        let O = T(j);
        return { pathname: O.pathname, search: O.search, hash: O.hash };
      },
      push: w,
      replace: S,
      go(j) {
        return u.go(j);
      },
    };
    return E;
  }
  function vj(t, e = !1) {
    let n = "http://localhost";
    (typeof window < "u" &&
      (n =
        window.location.origin !== "null"
          ? window.location.origin
          : window.location.href),
      En(n, "No window.location.(origin|href) available to create URL"));
    let i = typeof t == "string" ? t : Cg(t);
    return (
      (i = i.replace(/ $/, "%20")),
      !e && i.startsWith("//") && (i = n + i),
      new URL(i, n)
    );
  }
  function NE(t, e, n = "/") {
    return yj(t, e, n, !1);
  }
  function yj(t, e, n, i) {
    let a = typeof e == "string" ? Zh(e) : e,
      l = go(a.pathname || "/", n);
    if (l == null) return null;
    let u = AE(t);
    bj(u);
    let d = null;
    for (let m = 0; d == null && m < u.length; ++m) {
      let g = Nj(l);
      d = jj(u[m], g, i);
    }
    return d;
  }
  function AE(t, e = [], n = [], i = "", a = !1) {
    let l = (u, d, m = a, g) => {
      let v = {
        relativePath: g === void 0 ? u.path || "" : g,
        caseSensitive: u.caseSensitive === !0,
        childrenIndex: d,
        route: u,
      };
      if (v.relativePath.startsWith("/")) {
        if (!v.relativePath.startsWith(i) && m) return;
        (En(
          v.relativePath.startsWith(i),
          `Absolute route path "${v.relativePath}" nested under path "${i}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`,
        ),
          (v.relativePath = v.relativePath.slice(i.length)));
      }
      let y = fo([i, v.relativePath]),
        w = n.concat(v);
      (u.children &&
        u.children.length > 0 &&
        (En(
          u.index !== !0,
          `Index routes must not have child routes. Please remove all child routes from route path "${y}".`,
        ),
        AE(u.children, e, w, y, m)),
        !(u.path == null && !u.index) &&
          e.push({ path: y, score: Cj(y, u.index), routesMeta: w }));
    };
    return (
      t.forEach((u, d) => {
        var m;
        if (u.path === "" || !((m = u.path) != null && m.includes("?")))
          l(u, d);
        else for (let g of RE(u.path)) l(u, d, !0, g);
      }),
      e
    );
  }
  function RE(t) {
    let e = t.split("/");
    if (e.length === 0) return [];
    let [n, ...i] = e,
      a = n.endsWith("?"),
      l = n.replace(/\?$/, "");
    if (i.length === 0) return a ? [l, ""] : [l];
    let u = RE(i.join("/")),
      d = [];
    return (
      d.push(...u.map((m) => (m === "" ? l : [l, m].join("/")))),
      a && d.push(...u),
      d.map((m) => (t.startsWith("/") && m === "" ? "/" : m))
    );
  }
  function bj(t) {
    t.sort((e, n) =>
      e.score !== n.score
        ? n.score - e.score
        : Oj(
            e.routesMeta.map((i) => i.childrenIndex),
            n.routesMeta.map((i) => i.childrenIndex),
          ),
    );
  }
  var xj = /^:[\w-]+$/,
    _j = 3,
    wj = 2,
    Sj = 1,
    Tj = 10,
    Ej = -2,
    TS = (t) => t === "*";
  function Cj(t, e) {
    let n = t.split("/"),
      i = n.length;
    return (
      n.some(TS) && (i += Ej),
      e && (i += wj),
      n
        .filter((a) => !TS(a))
        .reduce((a, l) => a + (xj.test(l) ? _j : l === "" ? Sj : Tj), i)
    );
  }
  function Oj(t, e) {
    return t.length === e.length && t.slice(0, -1).every((i, a) => i === e[a])
      ? t[t.length - 1] - e[e.length - 1]
      : 0;
  }
  function jj(t, e, n = !1) {
    let { routesMeta: i } = t,
      a = {},
      l = "/",
      u = [];
    for (let d = 0; d < i.length; ++d) {
      let m = i[d],
        g = d === i.length - 1,
        v = l === "/" ? e : e.slice(l.length) || "/",
        y = nb(
          { path: m.relativePath, caseSensitive: m.caseSensitive, end: g },
          v,
        ),
        w = m.route;
      if (
        (!y &&
          g &&
          n &&
          !i[i.length - 1].route.index &&
          (y = nb(
            { path: m.relativePath, caseSensitive: m.caseSensitive, end: !1 },
            v,
          )),
        !y)
      )
        return null;
      (Object.assign(a, y.params),
        u.push({
          params: a,
          pathname: fo([l, y.pathname]),
          pathnameBase: Dj(fo([l, y.pathnameBase])),
          route: w,
        }),
        y.pathnameBase !== "/" && (l = fo([l, y.pathnameBase])));
    }
    return u;
  }
  function nb(t, e) {
    typeof t == "string" && (t = { path: t, caseSensitive: !1, end: !0 });
    let [n, i] = Mj(t.path, t.caseSensitive, t.end),
      a = e.match(n);
    if (!a) return null;
    let l = a[0],
      u = l.replace(/(.)\/+$/, "$1"),
      d = a.slice(1);
    return {
      params: i.reduce((g, { paramName: v, isOptional: y }, w) => {
        if (v === "*") {
          let T = d[w] || "";
          u = l.slice(0, l.length - T.length).replace(/(.)\/+$/, "$1");
        }
        const S = d[w];
        return (
          y && !S ? (g[v] = void 0) : (g[v] = (S || "").replace(/%2F/g, "/")),
          g
        );
      }, {}),
      pathname: l,
      pathnameBase: u,
      pattern: t,
    };
  }
  function Mj(t, e = !1, n = !0) {
    pr(
      t === "*" || !t.endsWith("*") || t.endsWith("/*"),
      `Route path "${t}" will be treated as if it were "${t.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${t.replace(/\*$/, "/*")}".`,
    );
    let i = [],
      a =
        "^" +
        t
          .replace(/\/*\*?$/, "")
          .replace(/^\/*/, "/")
          .replace(/[\\.*+^${}|()[\]]/g, "\\$&")
          .replace(
            /\/:([\w-]+)(\?)?/g,
            (u, d, m) => (
              i.push({ paramName: d, isOptional: m != null }),
              m ? "/?([^\\/]+)?" : "/([^\\/]+)"
            ),
          )
          .replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    return (
      t.endsWith("*")
        ? (i.push({ paramName: "*" }),
          (a += t === "*" || t === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$"))
        : n
          ? (a += "\\/*$")
          : t !== "" && t !== "/" && (a += "(?:(?=\\/|$))"),
      [new RegExp(a, e ? void 0 : "i"), i]
    );
  }
  function Nj(t) {
    try {
      return t
        .split("/")
        .map((e) => decodeURIComponent(e).replace(/\//g, "%2F"))
        .join("/");
    } catch (e) {
      return (
        pr(
          !1,
          `The URL path "${t}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${e}).`,
        ),
        t
      );
    }
  }
  function go(t, e) {
    if (e === "/") return t;
    if (!t.toLowerCase().startsWith(e.toLowerCase())) return null;
    let n = e.endsWith("/") ? e.length - 1 : e.length,
      i = t.charAt(n);
    return i && i !== "/" ? null : t.slice(n) || "/";
  }
  var LE = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i,
    Aj = (t) => LE.test(t);
  function Rj(t, e = "/") {
    let {
        pathname: n,
        search: i = "",
        hash: a = "",
      } = typeof t == "string" ? Zh(t) : t,
      l;
    if (n)
      if (Aj(n)) l = n;
      else {
        if (n.includes("//")) {
          let u = n;
          ((n = n.replace(/\/\/+/g, "/")),
            pr(
              !1,
              `Pathnames cannot have embedded double slashes - normalizing ${u} -> ${n}`,
            ));
        }
        n.startsWith("/") ? (l = ES(n.substring(1), "/")) : (l = ES(n, e));
      }
    else l = e;
    return { pathname: l, search: kj(i), hash: zj(a) };
  }
  function ES(t, e) {
    let n = e.replace(/\/+$/, "").split("/");
    return (
      t.split("/").forEach((a) => {
        a === ".." ? n.length > 1 && n.pop() : a !== "." && n.push(a);
      }),
      n.length > 1 ? n.join("/") : "/"
    );
  }
  function px(t, e, n, i) {
    return `Cannot include a '${t}' character in a manually specified \`to.${e}\` field [${JSON.stringify(i)}].  Please separate it out to the \`to.${n}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
  }
  function Lj(t) {
    return t.filter(
      (e, n) => n === 0 || (e.route.path && e.route.path.length > 0),
    );
  }
  function lw(t) {
    let e = Lj(t);
    return e.map((n, i) => (i === e.length - 1 ? n.pathname : n.pathnameBase));
  }
  function ow(t, e, n, i = !1) {
    let a;
    typeof t == "string"
      ? (a = Zh(t))
      : ((a = { ...t }),
        En(
          !a.pathname || !a.pathname.includes("?"),
          px("?", "pathname", "search", a),
        ),
        En(
          !a.pathname || !a.pathname.includes("#"),
          px("#", "pathname", "hash", a),
        ),
        En(!a.search || !a.search.includes("#"), px("#", "search", "hash", a)));
    let l = t === "" || a.pathname === "",
      u = l ? "/" : a.pathname,
      d;
    if (u == null) d = n;
    else {
      let y = e.length - 1;
      if (!i && u.startsWith("..")) {
        let w = u.split("/");
        for (; w[0] === ".."; ) (w.shift(), (y -= 1));
        a.pathname = w.join("/");
      }
      d = y >= 0 ? e[y] : "/";
    }
    let m = Rj(a, d),
      g = u && u !== "/" && u.endsWith("/"),
      v = (l || u === ".") && n.endsWith("/");
    return (!m.pathname.endsWith("/") && (g || v) && (m.pathname += "/"), m);
  }
  var fo = (t) => t.join("/").replace(/\/\/+/g, "/"),
    Dj = (t) => t.replace(/\/+$/, "").replace(/^\/*/, "/"),
    kj = (t) => (!t || t === "?" ? "" : t.startsWith("?") ? t : "?" + t),
    zj = (t) => (!t || t === "#" ? "" : t.startsWith("#") ? t : "#" + t),
    Pj = class {
      constructor(t, e, n, i = !1) {
        ((this.status = t),
          (this.statusText = e || ""),
          (this.internal = i),
          n instanceof Error
            ? ((this.data = n.toString()), (this.error = n))
            : (this.data = n));
      }
    };
  function Ij(t) {
    return (
      t != null &&
      typeof t.status == "number" &&
      typeof t.statusText == "string" &&
      typeof t.internal == "boolean" &&
      "data" in t
    );
  }
  function Uj(t) {
    return (
      t
        .map((e) => e.route.path)
        .filter(Boolean)
        .join("/")
        .replace(/\/\/*/g, "/") || "/"
    );
  }
  var DE =
    typeof window < "u" &&
    typeof window.document < "u" &&
    typeof window.document.createElement < "u";
  function kE(t, e) {
    let n = t;
    if (typeof n != "string" || !LE.test(n))
      return { absoluteURL: void 0, isExternal: !1, to: n };
    let i = n,
      a = !1;
    if (DE)
      try {
        let l = new URL(window.location.href),
          u = n.startsWith("//") ? new URL(l.protocol + n) : new URL(n),
          d = go(u.pathname, e);
        u.origin === l.origin && d != null
          ? (n = d + u.search + u.hash)
          : (a = !0);
      } catch {
        pr(
          !1,
          `<Link to="${n}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`,
        );
      }
    return { absoluteURL: i, isExternal: a, to: n };
  }
  Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
  var zE = ["POST", "PUT", "PATCH", "DELETE"];
  new Set(zE);
  var Fj = ["GET", ...zE];
  new Set(Fj);
  var Kh = W.createContext(null);
  Kh.displayName = "DataRouter";
  var Mb = W.createContext(null);
  Mb.displayName = "DataRouterState";
  var Bj = W.createContext(!1),
    PE = W.createContext({ isTransitioning: !1 });
  PE.displayName = "ViewTransition";
  var Hj = W.createContext(new Map());
  Hj.displayName = "Fetchers";
  var Yj = W.createContext(null);
  Yj.displayName = "Await";
  var mr = W.createContext(null);
  mr.displayName = "Navigation";
  var $g = W.createContext(null);
  $g.displayName = "Location";
  var ba = W.createContext({ outlet: null, matches: [], isDataRoute: !1 });
  ba.displayName = "Route";
  var cw = W.createContext(null);
  cw.displayName = "RouteError";
  var IE = "REACT_ROUTER_ERROR",
    qj = "REDIRECT",
    $j = "ROUTE_ERROR_RESPONSE";
  function Gj(t) {
    if (t.startsWith(`${IE}:${qj}:{`))
      try {
        let e = JSON.parse(t.slice(28));
        if (
          typeof e == "object" &&
          e &&
          typeof e.status == "number" &&
          typeof e.statusText == "string" &&
          typeof e.location == "string" &&
          typeof e.reloadDocument == "boolean" &&
          typeof e.replace == "boolean"
        )
          return e;
      } catch {}
  }
  function Vj(t) {
    if (t.startsWith(`${IE}:${$j}:{`))
      try {
        let e = JSON.parse(t.slice(40));
        if (
          typeof e == "object" &&
          e &&
          typeof e.status == "number" &&
          typeof e.statusText == "string"
        )
          return new Pj(e.status, e.statusText, e.data);
      } catch {}
  }
  function Wj(t, { relative: e } = {}) {
    En(
      Jh(),
      "useHref() may be used only in the context of a <Router> component.",
    );
    let { basename: n, navigator: i } = W.useContext(mr),
      { hash: a, pathname: l, search: u } = Gg(t, { relative: e }),
      d = l;
    return (
      n !== "/" && (d = l === "/" ? n : fo([n, l])),
      i.createHref({ pathname: d, search: u, hash: a })
    );
  }
  function Jh() {
    return W.useContext($g) != null;
  }
  function ys() {
    return (
      En(
        Jh(),
        "useLocation() may be used only in the context of a <Router> component.",
      ),
      W.useContext($g).location
    );
  }
  var UE =
    "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
  function FE(t) {
    W.useContext(mr).static || W.useLayoutEffect(t);
  }
  function sn() {
    let { isDataRoute: t } = W.useContext(ba);
    return t ? lM() : Xj();
  }
  function Xj() {
    En(
      Jh(),
      "useNavigate() may be used only in the context of a <Router> component.",
    );
    let t = W.useContext(Kh),
      { basename: e, navigator: n } = W.useContext(mr),
      { matches: i } = W.useContext(ba),
      { pathname: a } = ys(),
      l = JSON.stringify(lw(i)),
      u = W.useRef(!1);
    return (
      FE(() => {
        u.current = !0;
      }),
      W.useCallback(
        (m, g = {}) => {
          if ((pr(u.current, UE), !u.current)) return;
          if (typeof m == "number") {
            n.go(m);
            return;
          }
          let v = ow(m, JSON.parse(l), a, g.relative === "path");
          (t == null &&
            e !== "/" &&
            (v.pathname = v.pathname === "/" ? e : fo([e, v.pathname])),
            (g.replace ? n.replace : n.push)(v, g.state, g));
        },
        [e, n, l, a, t],
      )
    );
  }
  W.createContext(null);
  function Ir() {
    let { matches: t } = W.useContext(ba),
      e = t[t.length - 1];
    return e ? e.params : {};
  }
  function Gg(t, { relative: e } = {}) {
    let { matches: n } = W.useContext(ba),
      { pathname: i } = ys(),
      a = JSON.stringify(lw(n));
    return W.useMemo(() => ow(t, JSON.parse(a), i, e === "path"), [t, a, i, e]);
  }
  function Qj(t, e) {
    return BE(t, e);
  }
  function BE(t, e, n, i, a) {
    var M;
    En(
      Jh(),
      "useRoutes() may be used only in the context of a <Router> component.",
    );
    let { navigator: l } = W.useContext(mr),
      { matches: u } = W.useContext(ba),
      d = u[u.length - 1],
      m = d ? d.params : {},
      g = d ? d.pathname : "/",
      v = d ? d.pathnameBase : "/",
      y = d && d.route;
    {
      let N = (y && y.path) || "";
      YE(
        g,
        !y || N.endsWith("*") || N.endsWith("*?"),
        `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${g}" (under <Route path="${N}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${N}"> to <Route path="${N === "/" ? "*" : `${N}/*`}">.`,
      );
    }
    let w = ys(),
      S;
    if (e) {
      let N = typeof e == "string" ? Zh(e) : e;
      (En(
        v === "/" || ((M = N.pathname) == null ? void 0 : M.startsWith(v)),
        `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${v}" but pathname "${N.pathname}" was given in the \`location\` prop.`,
      ),
        (S = N));
    } else S = w;
    let T = S.pathname || "/",
      E = T;
    if (v !== "/") {
      let N = v.replace(/^\//, "").split("/");
      E = "/" + T.replace(/^\//, "").split("/").slice(N.length).join("/");
    }
    let j = NE(t, { pathname: E });
    (pr(
      y || j != null,
      `No routes matched location "${S.pathname}${S.search}${S.hash}" `,
    ),
      pr(
        j == null ||
          j[j.length - 1].route.element !== void 0 ||
          j[j.length - 1].route.Component !== void 0 ||
          j[j.length - 1].route.lazy !== void 0,
        `Matched leaf route at location "${S.pathname}${S.search}${S.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`,
      ));
    let O = tM(
      j &&
        j.map((N) =>
          Object.assign({}, N, {
            params: Object.assign({}, m, N.params),
            pathname: fo([
              v,
              l.encodeLocation
                ? l.encodeLocation(
                    N.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23"),
                  ).pathname
                : N.pathname,
            ]),
            pathnameBase:
              N.pathnameBase === "/"
                ? v
                : fo([
                    v,
                    l.encodeLocation
                      ? l.encodeLocation(
                          N.pathnameBase
                            .replace(/\?/g, "%3F")
                            .replace(/#/g, "%23"),
                        ).pathname
                      : N.pathnameBase,
                  ]),
          }),
        ),
      u,
      n,
      i,
      a,
    );
    return e && O
      ? W.createElement(
          $g.Provider,
          {
            value: {
              location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...S,
              },
              navigationType: "POP",
            },
          },
          O,
        )
      : O;
  }
  function Zj() {
    let t = aM(),
      e = Ij(t)
        ? `${t.status} ${t.statusText}`
        : t instanceof Error
          ? t.message
          : JSON.stringify(t),
      n = t instanceof Error ? t.stack : null,
      i = "rgba(200,200,200, 0.5)",
      a = { padding: "0.5rem", backgroundColor: i },
      l = { padding: "2px 4px", backgroundColor: i },
      u = null;
    return (
      console.error("Error handled by React Router default ErrorBoundary:", t),
      (u = W.createElement(
        W.Fragment,
        null,
        W.createElement("p", null, "💿 Hey developer 👋"),
        W.createElement(
          "p",
          null,
          "You can provide a way better UX than this when your app throws errors by providing your own ",
          W.createElement("code", { style: l }, "ErrorBoundary"),
          " or",
          " ",
          W.createElement("code", { style: l }, "errorElement"),
          " prop on your route.",
        ),
      )),
      W.createElement(
        W.Fragment,
        null,
        W.createElement("h2", null, "Unexpected Application Error!"),
        W.createElement("h3", { style: { fontStyle: "italic" } }, e),
        n ? W.createElement("pre", { style: a }, n) : null,
        u,
      )
    );
  }
  var Kj = W.createElement(Zj, null),
    HE = class extends W.Component {
      constructor(t) {
        (super(t),
          (this.state = {
            location: t.location,
            revalidation: t.revalidation,
            error: t.error,
          }));
      }
      static getDerivedStateFromError(t) {
        return { error: t };
      }
      static getDerivedStateFromProps(t, e) {
        return e.location !== t.location ||
          (e.revalidation !== "idle" && t.revalidation === "idle")
          ? {
              error: t.error,
              location: t.location,
              revalidation: t.revalidation,
            }
          : {
              error: t.error !== void 0 ? t.error : e.error,
              location: e.location,
              revalidation: t.revalidation || e.revalidation,
            };
      }
      componentDidCatch(t, e) {
        this.props.onError
          ? this.props.onError(t, e)
          : console.error(
              "React Router caught the following error during render",
              t,
            );
      }
      render() {
        let t = this.state.error;
        if (
          this.context &&
          typeof t == "object" &&
          t &&
          "digest" in t &&
          typeof t.digest == "string"
        ) {
          const n = Vj(t.digest);
          n && (t = n);
        }
        let e =
          t !== void 0
            ? W.createElement(
                ba.Provider,
                { value: this.props.routeContext },
                W.createElement(cw.Provider, {
                  value: t,
                  children: this.props.component,
                }),
              )
            : this.props.children;
        return this.context ? W.createElement(Jj, { error: t }, e) : e;
      }
    };
  HE.contextType = Bj;
  var mx = new WeakMap();
  function Jj({ children: t, error: e }) {
    let { basename: n } = W.useContext(mr);
    if (
      typeof e == "object" &&
      e &&
      "digest" in e &&
      typeof e.digest == "string"
    ) {
      let i = Gj(e.digest);
      if (i) {
        let a = mx.get(e);
        if (a) throw a;
        let l = kE(i.location, n);
        if (DE && !mx.get(e))
          if (l.isExternal || i.reloadDocument)
            window.location.href = l.absoluteURL || l.to;
          else {
            const u = Promise.resolve().then(() =>
              window.__reactRouterDataRouter.navigate(l.to, {
                replace: i.replace,
              }),
            );
            throw (mx.set(e, u), u);
          }
        return W.createElement("meta", {
          httpEquiv: "refresh",
          content: `0;url=${l.absoluteURL || l.to}`,
        });
      }
    }
    return t;
  }
  function eM({ routeContext: t, match: e, children: n }) {
    let i = W.useContext(Kh);
    return (
      i &&
        i.static &&
        i.staticContext &&
        (e.route.errorElement || e.route.ErrorBoundary) &&
        (i.staticContext._deepestRenderedBoundaryId = e.route.id),
      W.createElement(ba.Provider, { value: t }, n)
    );
  }
  function tM(t, e = [], n = null, i = null, a = null) {
    if (t == null) {
      if (!n) return null;
      if (n.errors) t = n.matches;
      else if (e.length === 0 && !n.initialized && n.matches.length > 0)
        t = n.matches;
      else return null;
    }
    let l = t,
      u = n == null ? void 0 : n.errors;
    if (u != null) {
      let v = l.findIndex(
        (y) => y.route.id && (u == null ? void 0 : u[y.route.id]) !== void 0,
      );
      (En(
        v >= 0,
        `Could not find a matching route for errors on route IDs: ${Object.keys(u).join(",")}`,
      ),
        (l = l.slice(0, Math.min(l.length, v + 1))));
    }
    let d = !1,
      m = -1;
    if (n)
      for (let v = 0; v < l.length; v++) {
        let y = l[v];
        if (
          ((y.route.HydrateFallback || y.route.hydrateFallbackElement) &&
            (m = v),
          y.route.id)
        ) {
          let { loaderData: w, errors: S } = n,
            T =
              y.route.loader &&
              !w.hasOwnProperty(y.route.id) &&
              (!S || S[y.route.id] === void 0);
          if (y.route.lazy || T) {
            ((d = !0), m >= 0 ? (l = l.slice(0, m + 1)) : (l = [l[0]]));
            break;
          }
        }
      }
    let g =
      n && i
        ? (v, y) => {
            var w, S;
            i(v, {
              location: n.location,
              params:
                ((S = (w = n.matches) == null ? void 0 : w[0]) == null
                  ? void 0
                  : S.params) ?? {},
              unstable_pattern: Uj(n.matches),
              errorInfo: y,
            });
          }
        : void 0;
    return l.reduceRight((v, y, w) => {
      let S,
        T = !1,
        E = null,
        j = null;
      n &&
        ((S = u && y.route.id ? u[y.route.id] : void 0),
        (E = y.route.errorElement || Kj),
        d &&
          (m < 0 && w === 0
            ? (YE(
                "route-fallback",
                !1,
                "No `HydrateFallback` element provided to render during initial hydration",
              ),
              (T = !0),
              (j = null))
            : m === w &&
              ((T = !0), (j = y.route.hydrateFallbackElement || null))));
      let O = e.concat(l.slice(0, w + 1)),
        M = () => {
          let N;
          return (
            S
              ? (N = E)
              : T
                ? (N = j)
                : y.route.Component
                  ? (N = W.createElement(y.route.Component, null))
                  : y.route.element
                    ? (N = y.route.element)
                    : (N = v),
            W.createElement(eM, {
              match: y,
              routeContext: { outlet: v, matches: O, isDataRoute: n != null },
              children: N,
            })
          );
        };
      return n && (y.route.ErrorBoundary || y.route.errorElement || w === 0)
        ? W.createElement(HE, {
            location: n.location,
            revalidation: n.revalidation,
            component: E,
            error: S,
            children: M(),
            routeContext: { outlet: null, matches: O, isDataRoute: !0 },
            onError: g,
          })
        : M();
    }, null);
  }
  function uw(t) {
    return `${t} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
  }
  function nM(t) {
    let e = W.useContext(Kh);
    return (En(e, uw(t)), e);
  }
  function iM(t) {
    let e = W.useContext(Mb);
    return (En(e, uw(t)), e);
  }
  function sM(t) {
    let e = W.useContext(ba);
    return (En(e, uw(t)), e);
  }
  function fw(t) {
    let e = sM(t),
      n = e.matches[e.matches.length - 1];
    return (
      En(
        n.route.id,
        `${t} can only be used on routes that contain a unique "id"`,
      ),
      n.route.id
    );
  }
  function rM() {
    return fw("useRouteId");
  }
  function aM() {
    var i;
    let t = W.useContext(cw),
      e = iM("useRouteError"),
      n = fw("useRouteError");
    return t !== void 0 ? t : (i = e.errors) == null ? void 0 : i[n];
  }
  function lM() {
    let { router: t } = nM("useNavigate"),
      e = fw("useNavigate"),
      n = W.useRef(!1);
    return (
      FE(() => {
        n.current = !0;
      }),
      W.useCallback(
        async (a, l = {}) => {
          (pr(n.current, UE),
            n.current &&
              (typeof a == "number"
                ? await t.navigate(a)
                : await t.navigate(a, { fromRouteId: e, ...l })));
        },
        [t, e],
      )
    );
  }
  var CS = {};
  function YE(t, e, n) {
    !e && !CS[t] && ((CS[t] = !0), pr(!1, n));
  }
  W.memo(oM);
  function oM({ routes: t, future: e, state: n, onError: i }) {
    return BE(t, void 0, n, i, e);
  }
  function cM({ to: t, replace: e, state: n, relative: i }) {
    En(
      Jh(),
      "<Navigate> may be used only in the context of a <Router> component.",
    );
    let { static: a } = W.useContext(mr);
    pr(
      !a,
      "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.",
    );
    let { matches: l } = W.useContext(ba),
      { pathname: u } = ys(),
      d = sn(),
      m = ow(t, lw(l), u, i === "path"),
      g = JSON.stringify(m);
    return (
      W.useEffect(() => {
        d(JSON.parse(g), { replace: e, state: n, relative: i });
      }, [d, g, i, e, n]),
      null
    );
  }
  function hf(t) {
    En(
      !1,
      "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.",
    );
  }
  function uM({
    basename: t = "/",
    children: e = null,
    location: n,
    navigationType: i = "POP",
    navigator: a,
    static: l = !1,
    unstable_useTransitions: u,
  }) {
    En(
      !Jh(),
      "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.",
    );
    let d = t.replace(/^\/*/, "/"),
      m = W.useMemo(
        () => ({
          basename: d,
          navigator: a,
          static: l,
          unstable_useTransitions: u,
          future: {},
        }),
        [d, a, l, u],
      );
    typeof n == "string" && (n = Zh(n));
    let {
        pathname: g = "/",
        search: v = "",
        hash: y = "",
        state: w = null,
        key: S = "default",
      } = n,
      T = W.useMemo(() => {
        let E = go(g, d);
        return E == null
          ? null
          : {
              location: { pathname: E, search: v, hash: y, state: w, key: S },
              navigationType: i,
            };
      }, [d, g, v, y, w, S, i]);
    return (
      pr(
        T != null,
        `<Router basename="${d}"> is not able to match the URL "${g}${v}${y}" because it does not start with the basename, so the <Router> won't render anything.`,
      ),
      T == null
        ? null
        : W.createElement(
            mr.Provider,
            { value: m },
            W.createElement($g.Provider, { children: e, value: T }),
          )
    );
  }
  function fM({ children: t, location: e }) {
    return Qj(u_(t), e);
  }
  function u_(t, e = []) {
    let n = [];
    return (
      W.Children.forEach(t, (i, a) => {
        if (!W.isValidElement(i)) return;
        let l = [...e, a];
        if (i.type === W.Fragment) {
          n.push.apply(n, u_(i.props.children, l));
          return;
        }
        (En(
          i.type === hf,
          `[${typeof i.type == "string" ? i.type : i.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`,
        ),
          En(
            !i.props.index || !i.props.children,
            "An index route cannot have child routes.",
          ));
        let u = {
          id: i.props.id || l.join("-"),
          caseSensitive: i.props.caseSensitive,
          element: i.props.element,
          Component: i.props.Component,
          index: i.props.index,
          path: i.props.path,
          middleware: i.props.middleware,
          loader: i.props.loader,
          action: i.props.action,
          hydrateFallbackElement: i.props.hydrateFallbackElement,
          HydrateFallback: i.props.HydrateFallback,
          errorElement: i.props.errorElement,
          ErrorBoundary: i.props.ErrorBoundary,
          hasErrorBoundary:
            i.props.hasErrorBoundary === !0 ||
            i.props.ErrorBoundary != null ||
            i.props.errorElement != null,
          shouldRevalidate: i.props.shouldRevalidate,
          handle: i.props.handle,
          lazy: i.props.lazy,
        };
        (i.props.children && (u.children = u_(i.props.children, l)), n.push(u));
      }),
      n
    );
  }
  var Y0 = "get",
    q0 = "application/x-www-form-urlencoded";
  function Nb(t) {
    return typeof HTMLElement < "u" && t instanceof HTMLElement;
  }
  function dM(t) {
    return Nb(t) && t.tagName.toLowerCase() === "button";
  }
  function hM(t) {
    return Nb(t) && t.tagName.toLowerCase() === "form";
  }
  function pM(t) {
    return Nb(t) && t.tagName.toLowerCase() === "input";
  }
  function mM(t) {
    return !!(t.metaKey || t.altKey || t.ctrlKey || t.shiftKey);
  }
  function gM(t, e) {
    return t.button === 0 && (!e || e === "_self") && !mM(t);
  }
  function f_(t = "") {
    return new URLSearchParams(
      typeof t == "string" || Array.isArray(t) || t instanceof URLSearchParams
        ? t
        : Object.keys(t).reduce((e, n) => {
            let i = t[n];
            return e.concat(Array.isArray(i) ? i.map((a) => [n, a]) : [[n, i]]);
          }, []),
    );
  }
  function vM(t, e) {
    let n = f_(t);
    return (
      e &&
        e.forEach((i, a) => {
          n.has(a) ||
            e.getAll(a).forEach((l) => {
              n.append(a, l);
            });
        }),
      n
    );
  }
  var b0 = null;
  function yM() {
    if (b0 === null)
      try {
        (new FormData(document.createElement("form"), 0), (b0 = !1));
      } catch {
        b0 = !0;
      }
    return b0;
  }
  var bM = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain",
  ]);
  function gx(t) {
    return t != null && !bM.has(t)
      ? (pr(
          !1,
          `"${t}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${q0}"`,
        ),
        null)
      : t;
  }
  function xM(t, e) {
    let n, i, a, l, u;
    if (hM(t)) {
      let d = t.getAttribute("action");
      ((i = d ? go(d, e) : null),
        (n = t.getAttribute("method") || Y0),
        (a = gx(t.getAttribute("enctype")) || q0),
        (l = new FormData(t)));
    } else if (
      dM(t) ||
      (pM(t) && (t.type === "submit" || t.type === "image"))
    ) {
      let d = t.form;
      if (d == null)
        throw new Error(
          'Cannot submit a <button> or <input type="submit"> without a <form>',
        );
      let m = t.getAttribute("formaction") || d.getAttribute("action");
      if (
        ((i = m ? go(m, e) : null),
        (n = t.getAttribute("formmethod") || d.getAttribute("method") || Y0),
        (a =
          gx(t.getAttribute("formenctype")) ||
          gx(d.getAttribute("enctype")) ||
          q0),
        (l = new FormData(d, t)),
        !yM())
      ) {
        let { name: g, type: v, value: y } = t;
        if (v === "image") {
          let w = g ? `${g}.` : "";
          (l.append(`${w}x`, "0"), l.append(`${w}y`, "0"));
        } else g && l.append(g, y);
      }
    } else {
      if (Nb(t))
        throw new Error(
          'Cannot submit element that is not <form>, <button>, or <input type="submit|image">',
        );
      ((n = Y0), (i = null), (a = q0), (u = t));
    }
    return (
      l && a === "text/plain" && ((u = l), (l = void 0)),
      { action: i, method: n.toLowerCase(), encType: a, formData: l, body: u }
    );
  }
  Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
  function dw(t, e) {
    if (t === !1 || t === null || typeof t > "u") throw new Error(e);
  }
  function _M(t, e, n) {
    let i =
      typeof t == "string"
        ? new URL(
            t,
            typeof window > "u"
              ? "server://singlefetch/"
              : window.location.origin,
          )
        : t;
    return (
      i.pathname === "/"
        ? (i.pathname = `_root.${n}`)
        : e && go(i.pathname, e) === "/"
          ? (i.pathname = `${e.replace(/\/$/, "")}/_root.${n}`)
          : (i.pathname = `${i.pathname.replace(/\/$/, "")}.${n}`),
      i
    );
  }
  async function wM(t, e) {
    if (t.id in e) return e[t.id];
    try {
      let n = await import(t.module);
      return ((e[t.id] = n), n);
    } catch (n) {
      return (
        console.error(
          `Error loading route module \`${t.module}\`, reloading page...`,
        ),
        console.error(n),
        window.__reactRouterContext && window.__reactRouterContext.isSpaMode,
        window.location.reload(),
        new Promise(() => {})
      );
    }
  }
  function SM(t) {
    return t == null
      ? !1
      : t.href == null
        ? t.rel === "preload" &&
          typeof t.imageSrcSet == "string" &&
          typeof t.imageSizes == "string"
        : typeof t.rel == "string" && typeof t.href == "string";
  }
  async function TM(t, e, n) {
    let i = await Promise.all(
      t.map(async (a) => {
        let l = e.routes[a.route.id];
        if (l) {
          let u = await wM(l, n);
          return u.links ? u.links() : [];
        }
        return [];
      }),
    );
    return jM(
      i
        .flat(1)
        .filter(SM)
        .filter((a) => a.rel === "stylesheet" || a.rel === "preload")
        .map((a) =>
          a.rel === "stylesheet"
            ? { ...a, rel: "prefetch", as: "style" }
            : { ...a, rel: "prefetch" },
        ),
    );
  }
  function OS(t, e, n, i, a, l) {
    let u = (m, g) => (n[g] ? m.route.id !== n[g].route.id : !0),
      d = (m, g) => {
        var v;
        return (
          n[g].pathname !== m.pathname ||
          (((v = n[g].route.path) == null ? void 0 : v.endsWith("*")) &&
            n[g].params["*"] !== m.params["*"])
        );
      };
    return l === "assets"
      ? e.filter((m, g) => u(m, g) || d(m, g))
      : l === "data"
        ? e.filter((m, g) => {
            var y;
            let v = i.routes[m.route.id];
            if (!v || !v.hasLoader) return !1;
            if (u(m, g) || d(m, g)) return !0;
            if (m.route.shouldRevalidate) {
              let w = m.route.shouldRevalidate({
                currentUrl: new URL(
                  a.pathname + a.search + a.hash,
                  window.origin,
                ),
                currentParams: ((y = n[0]) == null ? void 0 : y.params) || {},
                nextUrl: new URL(t, window.origin),
                nextParams: m.params,
                defaultShouldRevalidate: !0,
              });
              if (typeof w == "boolean") return w;
            }
            return !0;
          })
        : [];
  }
  function EM(t, e, { includeHydrateFallback: n } = {}) {
    return CM(
      t
        .map((i) => {
          let a = e.routes[i.route.id];
          if (!a) return [];
          let l = [a.module];
          return (
            a.clientActionModule && (l = l.concat(a.clientActionModule)),
            a.clientLoaderModule && (l = l.concat(a.clientLoaderModule)),
            n &&
              a.hydrateFallbackModule &&
              (l = l.concat(a.hydrateFallbackModule)),
            a.imports && (l = l.concat(a.imports)),
            l
          );
        })
        .flat(1),
    );
  }
  function CM(t) {
    return [...new Set(t)];
  }
  function OM(t) {
    let e = {},
      n = Object.keys(t).sort();
    for (let i of n) e[i] = t[i];
    return e;
  }
  function jM(t, e) {
    let n = new Set();
    return (
      new Set(e),
      t.reduce((i, a) => {
        let l = JSON.stringify(OM(a));
        return (n.has(l) || (n.add(l), i.push({ key: l, link: a })), i);
      }, [])
    );
  }
  function qE() {
    let t = W.useContext(Kh);
    return (
      dw(
        t,
        "You must render this element inside a <DataRouterContext.Provider> element",
      ),
      t
    );
  }
  function MM() {
    let t = W.useContext(Mb);
    return (
      dw(
        t,
        "You must render this element inside a <DataRouterStateContext.Provider> element",
      ),
      t
    );
  }
  var hw = W.createContext(void 0);
  hw.displayName = "FrameworkContext";
  function $E() {
    let t = W.useContext(hw);
    return (
      dw(t, "You must render this element inside a <HydratedRouter> element"),
      t
    );
  }
  function NM(t, e) {
    let n = W.useContext(hw),
      [i, a] = W.useState(!1),
      [l, u] = W.useState(!1),
      {
        onFocus: d,
        onBlur: m,
        onMouseEnter: g,
        onMouseLeave: v,
        onTouchStart: y,
      } = e,
      w = W.useRef(null);
    (W.useEffect(() => {
      if ((t === "render" && u(!0), t === "viewport")) {
        let E = (O) => {
            O.forEach((M) => {
              u(M.isIntersecting);
            });
          },
          j = new IntersectionObserver(E, { threshold: 0.5 });
        return (
          w.current && j.observe(w.current),
          () => {
            j.disconnect();
          }
        );
      }
    }, [t]),
      W.useEffect(() => {
        if (i) {
          let E = setTimeout(() => {
            u(!0);
          }, 100);
          return () => {
            clearTimeout(E);
          };
        }
      }, [i]));
    let S = () => {
        a(!0);
      },
      T = () => {
        (a(!1), u(!1));
      };
    return n
      ? t !== "intent"
        ? [l, w, {}]
        : [
            l,
            w,
            {
              onFocus: ig(d, S),
              onBlur: ig(m, T),
              onMouseEnter: ig(g, S),
              onMouseLeave: ig(v, T),
              onTouchStart: ig(y, S),
            },
          ]
      : [!1, w, {}];
  }
  function ig(t, e) {
    return (n) => {
      (t && t(n), n.defaultPrevented || e(n));
    };
  }
  function AM({ page: t, ...e }) {
    let { router: n } = qE(),
      i = W.useMemo(
        () => NE(n.routes, t, n.basename),
        [n.routes, t, n.basename],
      );
    return i ? W.createElement(LM, { page: t, matches: i, ...e }) : null;
  }
  function RM(t) {
    let { manifest: e, routeModules: n } = $E(),
      [i, a] = W.useState([]);
    return (
      W.useEffect(() => {
        let l = !1;
        return (
          TM(t, e, n).then((u) => {
            l || a(u);
          }),
          () => {
            l = !0;
          }
        );
      }, [t, e, n]),
      i
    );
  }
  function LM({ page: t, matches: e, ...n }) {
    let i = ys(),
      { manifest: a, routeModules: l } = $E(),
      { basename: u } = qE(),
      { loaderData: d, matches: m } = MM(),
      g = W.useMemo(() => OS(t, e, m, a, i, "data"), [t, e, m, a, i]),
      v = W.useMemo(() => OS(t, e, m, a, i, "assets"), [t, e, m, a, i]),
      y = W.useMemo(() => {
        if (t === i.pathname + i.search + i.hash) return [];
        let T = new Set(),
          E = !1;
        if (
          (e.forEach((O) => {
            var N;
            let M = a.routes[O.route.id];
            !M ||
              !M.hasLoader ||
              ((!g.some((R) => R.route.id === O.route.id) &&
                O.route.id in d &&
                (N = l[O.route.id]) != null &&
                N.shouldRevalidate) ||
              M.hasClientLoader
                ? (E = !0)
                : T.add(O.route.id));
          }),
          T.size === 0)
        )
          return [];
        let j = _M(t, u, "data");
        return (
          E &&
            T.size > 0 &&
            j.searchParams.set(
              "_routes",
              e
                .filter((O) => T.has(O.route.id))
                .map((O) => O.route.id)
                .join(","),
            ),
          [j.pathname + j.search]
        );
      }, [u, d, i, a, g, e, t, l]),
      w = W.useMemo(() => EM(v, a), [v, a]),
      S = RM(v);
    return W.createElement(
      W.Fragment,
      null,
      y.map((T) =>
        W.createElement("link", {
          key: T,
          rel: "prefetch",
          as: "fetch",
          href: T,
          ...n,
        }),
      ),
      w.map((T) =>
        W.createElement("link", {
          key: T,
          rel: "modulepreload",
          href: T,
          ...n,
        }),
      ),
      S.map(({ key: T, link: E }) =>
        W.createElement("link", { key: T, nonce: n.nonce, ...E }),
      ),
    );
  }
  function DM(...t) {
    return (e) => {
      t.forEach((n) => {
        typeof n == "function" ? n(e) : n != null && (n.current = e);
      });
    };
  }
  var kM =
    typeof window < "u" &&
    typeof window.document < "u" &&
    typeof window.document.createElement < "u";
  try {
    kM && (window.__reactRouterVersion = "7.11.0");
  } catch {}
  function zM({
    basename: t,
    children: e,
    unstable_useTransitions: n,
    window: i,
  }) {
    let a = W.useRef();
    a.current == null && (a.current = pj({ window: i, v5Compat: !0 }));
    let l = a.current,
      [u, d] = W.useState({ action: l.action, location: l.location }),
      m = W.useCallback(
        (g) => {
          n === !1 ? d(g) : W.startTransition(() => d(g));
        },
        [n],
      );
    return (
      W.useLayoutEffect(() => l.listen(m), [l, m]),
      W.createElement(uM, {
        basename: t,
        children: e,
        location: u.location,
        navigationType: u.action,
        navigator: l,
        unstable_useTransitions: n,
      })
    );
  }
  var GE = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i,
    _t = W.forwardRef(function (
      {
        onClick: e,
        discover: n = "render",
        prefetch: i = "none",
        relative: a,
        reloadDocument: l,
        replace: u,
        state: d,
        target: m,
        to: g,
        preventScrollReset: v,
        viewTransition: y,
        unstable_defaultShouldRevalidate: w,
        ...S
      },
      T,
    ) {
      let { basename: E, unstable_useTransitions: j } = W.useContext(mr),
        O = typeof g == "string" && GE.test(g),
        M = kE(g, E);
      g = M.to;
      let N = Wj(g, { relative: a }),
        [R, P, G] = NM(i, S),
        Y = UM(g, {
          replace: u,
          state: d,
          target: m,
          preventScrollReset: v,
          relative: a,
          viewTransition: y,
          unstable_defaultShouldRevalidate: w,
          unstable_useTransitions: j,
        });
      function B(H) {
        (e && e(H), H.defaultPrevented || Y(H));
      }
      let I = W.createElement("a", {
        ...S,
        ...G,
        href: M.absoluteURL || N,
        onClick: M.isExternal || l ? e : B,
        ref: DM(T, P),
        target: m,
        "data-discover": !O && n === "render" ? "true" : void 0,
      });
      return R && !O
        ? W.createElement(W.Fragment, null, I, W.createElement(AM, { page: N }))
        : I;
    });
  _t.displayName = "Link";
  var VE = W.forwardRef(function (
    {
      "aria-current": e = "page",
      caseSensitive: n = !1,
      className: i = "",
      end: a = !1,
      style: l,
      to: u,
      viewTransition: d,
      children: m,
      ...g
    },
    v,
  ) {
    let y = Gg(u, { relative: g.relative }),
      w = ys(),
      S = W.useContext(Mb),
      { navigator: T, basename: E } = W.useContext(mr),
      j = S != null && qM(y) && d === !0,
      O = T.encodeLocation ? T.encodeLocation(y).pathname : y.pathname,
      M = w.pathname,
      N =
        S && S.navigation && S.navigation.location
          ? S.navigation.location.pathname
          : null;
    (n ||
      ((M = M.toLowerCase()),
      (N = N ? N.toLowerCase() : null),
      (O = O.toLowerCase())),
      N && E && (N = go(N, E) || N));
    const R = O !== "/" && O.endsWith("/") ? O.length - 1 : O.length;
    let P = M === O || (!a && M.startsWith(O) && M.charAt(R) === "/"),
      G =
        N != null &&
        (N === O || (!a && N.startsWith(O) && N.charAt(O.length) === "/")),
      Y = { isActive: P, isPending: G, isTransitioning: j },
      B = P ? e : void 0,
      I;
    typeof i == "function"
      ? (I = i(Y))
      : (I = [
          i,
          P ? "active" : null,
          G ? "pending" : null,
          j ? "transitioning" : null,
        ]
          .filter(Boolean)
          .join(" "));
    let H = typeof l == "function" ? l(Y) : l;
    return W.createElement(
      _t,
      {
        ...g,
        "aria-current": B,
        className: I,
        ref: v,
        style: H,
        to: u,
        viewTransition: d,
      },
      typeof m == "function" ? m(Y) : m,
    );
  });
  VE.displayName = "NavLink";
  var PM = W.forwardRef(
    (
      {
        discover: t = "render",
        fetcherKey: e,
        navigate: n,
        reloadDocument: i,
        replace: a,
        state: l,
        method: u = Y0,
        action: d,
        onSubmit: m,
        relative: g,
        preventScrollReset: v,
        viewTransition: y,
        unstable_defaultShouldRevalidate: w,
        ...S
      },
      T,
    ) => {
      let { unstable_useTransitions: E } = W.useContext(mr),
        j = HM(),
        O = YM(d, { relative: g }),
        M = u.toLowerCase() === "get" ? "get" : "post",
        N = typeof d == "string" && GE.test(d),
        R = (P) => {
          if ((m && m(P), P.defaultPrevented)) return;
          P.preventDefault();
          let G = P.nativeEvent.submitter,
            Y = (G == null ? void 0 : G.getAttribute("formmethod")) || u,
            B = () =>
              j(G || P.currentTarget, {
                fetcherKey: e,
                method: Y,
                navigate: n,
                replace: a,
                state: l,
                relative: g,
                preventScrollReset: v,
                viewTransition: y,
                unstable_defaultShouldRevalidate: w,
              });
          E && n !== !1 ? W.startTransition(() => B()) : B();
        };
      return W.createElement("form", {
        ref: T,
        method: M,
        action: O,
        onSubmit: i ? m : R,
        ...S,
        "data-discover": !N && t === "render" ? "true" : void 0,
      });
    },
  );
  PM.displayName = "Form";
  function IM(t) {
    return `${t} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
  }
  function WE(t) {
    let e = W.useContext(Kh);
    return (En(e, IM(t)), e);
  }
  function UM(
    t,
    {
      target: e,
      replace: n,
      state: i,
      preventScrollReset: a,
      relative: l,
      viewTransition: u,
      unstable_defaultShouldRevalidate: d,
      unstable_useTransitions: m,
    } = {},
  ) {
    let g = sn(),
      v = ys(),
      y = Gg(t, { relative: l });
    return W.useCallback(
      (w) => {
        if (gM(w, e)) {
          w.preventDefault();
          let S = n !== void 0 ? n : Cg(v) === Cg(y),
            T = () =>
              g(t, {
                replace: S,
                state: i,
                preventScrollReset: a,
                relative: l,
                viewTransition: u,
                unstable_defaultShouldRevalidate: d,
              });
          m ? W.startTransition(() => T()) : T();
        }
      },
      [v, g, y, n, i, e, t, a, l, u, d, m],
    );
  }
  function XE(t) {
    pr(
      typeof URLSearchParams < "u",
      "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.",
    );
    let e = W.useRef(f_(t)),
      n = W.useRef(!1),
      i = ys(),
      a = W.useMemo(
        () => vM(i.search, n.current ? null : e.current),
        [i.search],
      ),
      l = sn(),
      u = W.useCallback(
        (d, m) => {
          const g = f_(typeof d == "function" ? d(new URLSearchParams(a)) : d);
          ((n.current = !0), l("?" + g, m));
        },
        [l, a],
      );
    return [a, u];
  }
  var FM = 0,
    BM = () => `__${String(++FM)}__`;
  function HM() {
    let { router: t } = WE("useSubmit"),
      { basename: e } = W.useContext(mr),
      n = rM(),
      i = t.fetch,
      a = t.navigate;
    return W.useCallback(
      async (l, u = {}) => {
        let {
          action: d,
          method: m,
          encType: g,
          formData: v,
          body: y,
        } = xM(l, e);
        if (u.navigate === !1) {
          let w = u.fetcherKey || BM();
          await i(w, n, u.action || d, {
            unstable_defaultShouldRevalidate:
              u.unstable_defaultShouldRevalidate,
            preventScrollReset: u.preventScrollReset,
            formData: v,
            body: y,
            formMethod: u.method || m,
            formEncType: u.encType || g,
            flushSync: u.flushSync,
          });
        } else
          await a(u.action || d, {
            unstable_defaultShouldRevalidate:
              u.unstable_defaultShouldRevalidate,
            preventScrollReset: u.preventScrollReset,
            formData: v,
            body: y,
            formMethod: u.method || m,
            formEncType: u.encType || g,
            replace: u.replace,
            state: u.state,
            fromRouteId: n,
            flushSync: u.flushSync,
            viewTransition: u.viewTransition,
          });
      },
      [i, a, e, n],
    );
  }
  function YM(t, { relative: e } = {}) {
    let { basename: n } = W.useContext(mr),
      i = W.useContext(ba);
    En(i, "useFormAction must be used inside a RouteContext");
    let [a] = i.matches.slice(-1),
      l = { ...Gg(t || ".", { relative: e }) },
      u = ys();
    if (t == null) {
      l.search = u.search;
      let d = new URLSearchParams(l.search),
        m = d.getAll("index");
      if (m.some((v) => v === "")) {
        (d.delete("index"),
          m.filter((y) => y).forEach((y) => d.append("index", y)));
        let v = d.toString();
        l.search = v ? `?${v}` : "";
      }
    }
    return (
      (!t || t === ".") &&
        a.route.index &&
        (l.search = l.search ? l.search.replace(/^\?/, "?index&") : "?index"),
      n !== "/" && (l.pathname = l.pathname === "/" ? n : fo([n, l.pathname])),
      Cg(l)
    );
  }
  function qM(t, { relative: e } = {}) {
    let n = W.useContext(PE);
    En(
      n != null,
      "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?",
    );
    let { basename: i } = WE("useViewTransitionState"),
      a = Gg(t, { relative: e });
    if (!n.isTransitioning) return !1;
    let l = go(n.currentLocation.pathname, i) || n.currentLocation.pathname,
      u = go(n.nextLocation.pathname, i) || n.nextLocation.pathname;
    return nb(a.pathname, u) != null || nb(a.pathname, l) != null;
  }
  var QE = {
      color: void 0,
      size: void 0,
      className: void 0,
      style: void 0,
      attr: void 0,
    },
    jS = U.createContext && U.createContext(QE),
    $M = ["attr", "size", "title"];
  function GM(t, e) {
    if (t == null) return {};
    var n = VM(t, e),
      i,
      a;
    if (Object.getOwnPropertySymbols) {
      var l = Object.getOwnPropertySymbols(t);
      for (a = 0; a < l.length; a++)
        ((i = l[a]),
          !(e.indexOf(i) >= 0) &&
            Object.prototype.propertyIsEnumerable.call(t, i) &&
            (n[i] = t[i]));
    }
    return n;
  }
  function VM(t, e) {
    if (t == null) return {};
    var n = {};
    for (var i in t)
      if (Object.prototype.hasOwnProperty.call(t, i)) {
        if (e.indexOf(i) >= 0) continue;
        n[i] = t[i];
      }
    return n;
  }
  function ib() {
    return (
      (ib = Object.assign
        ? Object.assign.bind()
        : function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = arguments[e];
              for (var i in n)
                Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
            }
            return t;
          }),
      ib.apply(this, arguments)
    );
  }
  function MS(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(t);
      (e &&
        (i = i.filter(function (a) {
          return Object.getOwnPropertyDescriptor(t, a).enumerable;
        })),
        n.push.apply(n, i));
    }
    return n;
  }
  function sb(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e] != null ? arguments[e] : {};
      e % 2
        ? MS(Object(n), !0).forEach(function (i) {
            WM(t, i, n[i]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
          : MS(Object(n)).forEach(function (i) {
              Object.defineProperty(
                t,
                i,
                Object.getOwnPropertyDescriptor(n, i),
              );
            });
    }
    return t;
  }
  function WM(t, e, n) {
    return (
      (e = XM(e)),
      e in t
        ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (t[e] = n),
      t
    );
  }
  function XM(t) {
    var e = QM(t, "string");
    return typeof e == "symbol" ? e : e + "";
  }
  function QM(t, e) {
    if (typeof t != "object" || !t) return t;
    var n = t[Symbol.toPrimitive];
    if (n !== void 0) {
      var i = n.call(t, e);
      if (typeof i != "object") return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (e === "string" ? String : Number)(t);
  }
  function ZE(t) {
    return (
      t &&
      t.map((e, n) =>
        U.createElement(e.tag, sb({ key: n }, e.attr), ZE(e.child)),
      )
    );
  }
  function Fi(t) {
    return (e) =>
      U.createElement(ZM, ib({ attr: sb({}, t.attr) }, e), ZE(t.child));
  }
  function ZM(t) {
    var e = (n) => {
      var { attr: i, size: a, title: l } = t,
        u = GM(t, $M),
        d = a || n.size || "1em",
        m;
      return (
        n.className && (m = n.className),
        t.className && (m = (m ? m + " " : "") + t.className),
        U.createElement(
          "svg",
          ib(
            { stroke: "currentColor", fill: "currentColor", strokeWidth: "0" },
            n.attr,
            i,
            u,
            {
              className: m,
              style: sb(sb({ color: t.color || n.color }, n.style), t.style),
              height: d,
              width: d,
              xmlns: "http://www.w3.org/2000/svg",
            },
          ),
          l && U.createElement("title", null, l),
          t.children,
        )
      );
    };
    return jS !== void 0
      ? U.createElement(jS.Consumer, null, (n) => e(n))
      : e(QE);
  }
  function Ab(t) {
    return Fi({
      attr: { viewBox: "0 0 512 512" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z",
          },
          child: [],
        },
      ],
    })(t);
  }
  function KM(t) {
    return Fi({
      attr: { viewBox: "0 0 448 512" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z",
          },
          child: [],
        },
      ],
    })(t);
  }
  function d_(t) {
    return Fi({
      attr: { viewBox: "0 0 512 512" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z",
          },
          child: [],
        },
      ],
    })(t);
  }
  function JM(t) {
    return Fi({
      attr: { viewBox: "0 0 448 512" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z",
          },
          child: [],
        },
      ],
    })(t);
  }
  function KE(t, e) {
    return function () {
      return t.apply(e, arguments);
    };
  }
  const { toString: eN } = Object.prototype,
    { getPrototypeOf: pw } = Object,
    { iterator: Rb, toStringTag: JE } = Symbol,
    Lb = ((t) => (e) => {
      const n = eN.call(e);
      return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
    })(Object.create(null)),
    xa = (t) => ((t = t.toLowerCase()), (e) => Lb(e) === t),
    Db = (t) => (e) => typeof e === t,
    { isArray: ep } = Array,
    Wh = Db("undefined");
  function Vg(t) {
    return (
      t !== null &&
      !Wh(t) &&
      t.constructor !== null &&
      !Wh(t.constructor) &&
      qs(t.constructor.isBuffer) &&
      t.constructor.isBuffer(t)
    );
  }
  const e2 = xa("ArrayBuffer");
  function tN(t) {
    let e;
    return (
      typeof ArrayBuffer < "u" && ArrayBuffer.isView
        ? (e = ArrayBuffer.isView(t))
        : (e = t && t.buffer && e2(t.buffer)),
      e
    );
  }
  const nN = Db("string"),
    qs = Db("function"),
    t2 = Db("number"),
    Wg = (t) => t !== null && typeof t == "object",
    iN = (t) => t === !0 || t === !1,
    $0 = (t) => {
      if (Lb(t) !== "object") return !1;
      const e = pw(t);
      return (
        (e === null ||
          e === Object.prototype ||
          Object.getPrototypeOf(e) === null) &&
        !(JE in t) &&
        !(Rb in t)
      );
    },
    sN = (t) => {
      if (!Wg(t) || Vg(t)) return !1;
      try {
        return (
          Object.keys(t).length === 0 &&
          Object.getPrototypeOf(t) === Object.prototype
        );
      } catch {
        return !1;
      }
    },
    rN = xa("Date"),
    aN = xa("File"),
    lN = xa("Blob"),
    oN = xa("FileList"),
    cN = (t) => Wg(t) && qs(t.pipe),
    uN = (t) => {
      let e;
      return (
        t &&
        ((typeof FormData == "function" && t instanceof FormData) ||
          (qs(t.append) &&
            ((e = Lb(t)) === "formdata" ||
              (e === "object" &&
                qs(t.toString) &&
                t.toString() === "[object FormData]"))))
      );
    },
    fN = xa("URLSearchParams"),
    [dN, hN, pN, mN] = ["ReadableStream", "Request", "Response", "Headers"].map(
      xa,
    ),
    gN = (t) =>
      t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  function Xg(t, e, { allOwnKeys: n = !1 } = {}) {
    if (t === null || typeof t > "u") return;
    let i, a;
    if ((typeof t != "object" && (t = [t]), ep(t)))
      for (i = 0, a = t.length; i < a; i++) e.call(null, t[i], i, t);
    else {
      if (Vg(t)) return;
      const l = n ? Object.getOwnPropertyNames(t) : Object.keys(t),
        u = l.length;
      let d;
      for (i = 0; i < u; i++) ((d = l[i]), e.call(null, t[d], d, t));
    }
  }
  function n2(t, e) {
    if (Vg(t)) return null;
    e = e.toLowerCase();
    const n = Object.keys(t);
    let i = n.length,
      a;
    for (; i-- > 0; ) if (((a = n[i]), e === a.toLowerCase())) return a;
    return null;
  }
  const mf =
      typeof globalThis < "u"
        ? globalThis
        : typeof self < "u"
          ? self
          : typeof window < "u"
            ? window
            : global,
    i2 = (t) => !Wh(t) && t !== mf;
  function h_() {
    const { caseless: t, skipUndefined: e } = (i2(this) && this) || {},
      n = {},
      i = (a, l) => {
        const u = (t && n2(n, l)) || l;
        $0(n[u]) && $0(a)
          ? (n[u] = h_(n[u], a))
          : $0(a)
            ? (n[u] = h_({}, a))
            : ep(a)
              ? (n[u] = a.slice())
              : (!e || !Wh(a)) && (n[u] = a);
      };
    for (let a = 0, l = arguments.length; a < l; a++)
      arguments[a] && Xg(arguments[a], i);
    return n;
  }
  const vN = (t, e, n, { allOwnKeys: i } = {}) => (
      Xg(
        e,
        (a, l) => {
          n && qs(a) ? (t[l] = KE(a, n)) : (t[l] = a);
        },
        { allOwnKeys: i },
      ),
      t
    ),
    yN = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t),
    bN = (t, e, n, i) => {
      ((t.prototype = Object.create(e.prototype, i)),
        (t.prototype.constructor = t),
        Object.defineProperty(t, "super", { value: e.prototype }),
        n && Object.assign(t.prototype, n));
    },
    xN = (t, e, n, i) => {
      let a, l, u;
      const d = {};
      if (((e = e || {}), t == null)) return e;
      do {
        for (a = Object.getOwnPropertyNames(t), l = a.length; l-- > 0; )
          ((u = a[l]),
            (!i || i(u, t, e)) && !d[u] && ((e[u] = t[u]), (d[u] = !0)));
        t = n !== !1 && pw(t);
      } while (t && (!n || n(t, e)) && t !== Object.prototype);
      return e;
    },
    _N = (t, e, n) => {
      ((t = String(t)),
        (n === void 0 || n > t.length) && (n = t.length),
        (n -= e.length));
      const i = t.indexOf(e, n);
      return i !== -1 && i === n;
    },
    wN = (t) => {
      if (!t) return null;
      if (ep(t)) return t;
      let e = t.length;
      if (!t2(e)) return null;
      const n = new Array(e);
      for (; e-- > 0; ) n[e] = t[e];
      return n;
    },
    SN = (
      (t) => (e) =>
        t && e instanceof t
    )(typeof Uint8Array < "u" && pw(Uint8Array)),
    TN = (t, e) => {
      const i = (t && t[Rb]).call(t);
      let a;
      for (; (a = i.next()) && !a.done; ) {
        const l = a.value;
        e.call(t, l[0], l[1]);
      }
    },
    EN = (t, e) => {
      let n;
      const i = [];
      for (; (n = t.exec(e)) !== null; ) i.push(n);
      return i;
    },
    CN = xa("HTMLFormElement"),
    ON = (t) =>
      t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function (n, i, a) {
        return i.toUpperCase() + a;
      }),
    NS = (
      ({ hasOwnProperty: t }) =>
      (e, n) =>
        t.call(e, n)
    )(Object.prototype),
    jN = xa("RegExp"),
    s2 = (t, e) => {
      const n = Object.getOwnPropertyDescriptors(t),
        i = {};
      (Xg(n, (a, l) => {
        let u;
        (u = e(a, l, t)) !== !1 && (i[l] = u || a);
      }),
        Object.defineProperties(t, i));
    },
    MN = (t) => {
      s2(t, (e, n) => {
        if (qs(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
          return !1;
        const i = t[n];
        if (qs(i)) {
          if (((e.enumerable = !1), "writable" in e)) {
            e.writable = !1;
            return;
          }
          e.set ||
            (e.set = () => {
              throw Error("Can not rewrite read-only method '" + n + "'");
            });
        }
      });
    },
    NN = (t, e) => {
      const n = {},
        i = (a) => {
          a.forEach((l) => {
            n[l] = !0;
          });
        };
      return (ep(t) ? i(t) : i(String(t).split(e)), n);
    },
    AN = () => {},
    RN = (t, e) => (t != null && Number.isFinite((t = +t)) ? t : e);
  function LN(t) {
    return !!(t && qs(t.append) && t[JE] === "FormData" && t[Rb]);
  }
  const DN = (t) => {
      const e = new Array(10),
        n = (i, a) => {
          if (Wg(i)) {
            if (e.indexOf(i) >= 0) return;
            if (Vg(i)) return i;
            if (!("toJSON" in i)) {
              e[a] = i;
              const l = ep(i) ? [] : {};
              return (
                Xg(i, (u, d) => {
                  const m = n(u, a + 1);
                  !Wh(m) && (l[d] = m);
                }),
                (e[a] = void 0),
                l
              );
            }
          }
          return i;
        };
      return n(t, 0);
    },
    kN = xa("AsyncFunction"),
    zN = (t) => t && (Wg(t) || qs(t)) && qs(t.then) && qs(t.catch),
    r2 = ((t, e) =>
      t
        ? setImmediate
        : e
          ? ((n, i) => (
              mf.addEventListener(
                "message",
                ({ source: a, data: l }) => {
                  a === mf && l === n && i.length && i.shift()();
                },
                !1,
              ),
              (a) => {
                (i.push(a), mf.postMessage(n, "*"));
              }
            ))(`axios@${Math.random()}`, [])
          : (n) => setTimeout(n))(
      typeof setImmediate == "function",
      qs(mf.postMessage),
    ),
    PN =
      typeof queueMicrotask < "u"
        ? queueMicrotask.bind(mf)
        : (typeof process < "u" && process.nextTick) || r2,
    IN = (t) => t != null && qs(t[Rb]),
    ce = {
      isArray: ep,
      isArrayBuffer: e2,
      isBuffer: Vg,
      isFormData: uN,
      isArrayBufferView: tN,
      isString: nN,
      isNumber: t2,
      isBoolean: iN,
      isObject: Wg,
      isPlainObject: $0,
      isEmptyObject: sN,
      isReadableStream: dN,
      isRequest: hN,
      isResponse: pN,
      isHeaders: mN,
      isUndefined: Wh,
      isDate: rN,
      isFile: aN,
      isBlob: lN,
      isRegExp: jN,
      isFunction: qs,
      isStream: cN,
      isURLSearchParams: fN,
      isTypedArray: SN,
      isFileList: oN,
      forEach: Xg,
      merge: h_,
      extend: vN,
      trim: gN,
      stripBOM: yN,
      inherits: bN,
      toFlatObject: xN,
      kindOf: Lb,
      kindOfTest: xa,
      endsWith: _N,
      toArray: wN,
      forEachEntry: TN,
      matchAll: EN,
      isHTMLForm: CN,
      hasOwnProperty: NS,
      hasOwnProp: NS,
      reduceDescriptors: s2,
      freezeMethods: MN,
      toObjectSet: NN,
      toCamelCase: ON,
      noop: AN,
      toFiniteNumber: RN,
      findKey: n2,
      global: mf,
      isContextDefined: i2,
      isSpecCompliantForm: LN,
      toJSONObject: DN,
      isAsyncFn: kN,
      isThenable: zN,
      setImmediate: r2,
      asap: PN,
      isIterable: IN,
    };
  function ct(t, e, n, i, a) {
    (Error.call(this),
      Error.captureStackTrace
        ? Error.captureStackTrace(this, this.constructor)
        : (this.stack = new Error().stack),
      (this.message = t),
      (this.name = "AxiosError"),
      e && (this.code = e),
      n && (this.config = n),
      i && (this.request = i),
      a && ((this.response = a), (this.status = a.status ? a.status : null)));
  }
  ce.inherits(ct, Error, {
    toJSON: function () {
      return {
        message: this.message,
        name: this.name,
        description: this.description,
        number: this.number,
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        config: ce.toJSONObject(this.config),
        code: this.code,
        status: this.status,
      };
    },
  });
  const a2 = ct.prototype,
    l2 = {};
  [
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL",
  ].forEach((t) => {
    l2[t] = { value: t };
  });
  Object.defineProperties(ct, l2);
  Object.defineProperty(a2, "isAxiosError", { value: !0 });
  ct.from = (t, e, n, i, a, l) => {
    const u = Object.create(a2);
    ce.toFlatObject(
      t,
      u,
      function (v) {
        return v !== Error.prototype;
      },
      (g) => g !== "isAxiosError",
    );
    const d = t && t.message ? t.message : "Error",
      m = e == null && t ? t.code : e;
    return (
      ct.call(u, d, m, n, i, a),
      t &&
        u.cause == null &&
        Object.defineProperty(u, "cause", { value: t, configurable: !0 }),
      (u.name = (t && t.name) || "Error"),
      l && Object.assign(u, l),
      u
    );
  };
  const UN = null;
  function p_(t) {
    return ce.isPlainObject(t) || ce.isArray(t);
  }
  function o2(t) {
    return ce.endsWith(t, "[]") ? t.slice(0, -2) : t;
  }
  function AS(t, e, n) {
    return t
      ? t
          .concat(e)
          .map(function (a, l) {
            return ((a = o2(a)), !n && l ? "[" + a + "]" : a);
          })
          .join(n ? "." : "")
      : e;
  }
  function FN(t) {
    return ce.isArray(t) && !t.some(p_);
  }
  const BN = ce.toFlatObject(ce, {}, null, function (e) {
    return /^is[A-Z]/.test(e);
  });
  function kb(t, e, n) {
    if (!ce.isObject(t)) throw new TypeError("target must be an object");
    ((e = e || new FormData()),
      (n = ce.toFlatObject(
        n,
        { metaTokens: !0, dots: !1, indexes: !1 },
        !1,
        function (E, j) {
          return !ce.isUndefined(j[E]);
        },
      )));
    const i = n.metaTokens,
      a = n.visitor || v,
      l = n.dots,
      u = n.indexes,
      m = (n.Blob || (typeof Blob < "u" && Blob)) && ce.isSpecCompliantForm(e);
    if (!ce.isFunction(a)) throw new TypeError("visitor must be a function");
    function g(T) {
      if (T === null) return "";
      if (ce.isDate(T)) return T.toISOString();
      if (ce.isBoolean(T)) return T.toString();
      if (!m && ce.isBlob(T))
        throw new ct("Blob is not supported. Use a Buffer instead.");
      return ce.isArrayBuffer(T) || ce.isTypedArray(T)
        ? m && typeof Blob == "function"
          ? new Blob([T])
          : Buffer.from(T)
        : T;
    }
    function v(T, E, j) {
      let O = T;
      if (T && !j && typeof T == "object") {
        if (ce.endsWith(E, "{}"))
          ((E = i ? E : E.slice(0, -2)), (T = JSON.stringify(T)));
        else if (
          (ce.isArray(T) && FN(T)) ||
          ((ce.isFileList(T) || ce.endsWith(E, "[]")) && (O = ce.toArray(T)))
        )
          return (
            (E = o2(E)),
            O.forEach(function (N, R) {
              !(ce.isUndefined(N) || N === null) &&
                e.append(
                  u === !0 ? AS([E], R, l) : u === null ? E : E + "[]",
                  g(N),
                );
            }),
            !1
          );
      }
      return p_(T) ? !0 : (e.append(AS(j, E, l), g(T)), !1);
    }
    const y = [],
      w = Object.assign(BN, {
        defaultVisitor: v,
        convertValue: g,
        isVisitable: p_,
      });
    function S(T, E) {
      if (!ce.isUndefined(T)) {
        if (y.indexOf(T) !== -1)
          throw Error("Circular reference detected in " + E.join("."));
        (y.push(T),
          ce.forEach(T, function (O, M) {
            (!(ce.isUndefined(O) || O === null) &&
              a.call(e, O, ce.isString(M) ? M.trim() : M, E, w)) === !0 &&
              S(O, E ? E.concat(M) : [M]);
          }),
          y.pop());
      }
    }
    if (!ce.isObject(t)) throw new TypeError("data must be an object");
    return (S(t), e);
  }
  function RS(t) {
    const e = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+",
      "%00": "\0",
    };
    return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function (i) {
      return e[i];
    });
  }
  function mw(t, e) {
    ((this._pairs = []), t && kb(t, this, e));
  }
  const c2 = mw.prototype;
  c2.append = function (e, n) {
    this._pairs.push([e, n]);
  };
  c2.toString = function (e) {
    const n = e
      ? function (i) {
          return e.call(this, i, RS);
        }
      : RS;
    return this._pairs
      .map(function (a) {
        return n(a[0]) + "=" + n(a[1]);
      }, "")
      .join("&");
  };
  function HN(t) {
    return encodeURIComponent(t)
      .replace(/%3A/gi, ":")
      .replace(/%24/g, "$")
      .replace(/%2C/gi, ",")
      .replace(/%20/g, "+");
  }
  function u2(t, e, n) {
    if (!e) return t;
    const i = (n && n.encode) || HN;
    ce.isFunction(n) && (n = { serialize: n });
    const a = n && n.serialize;
    let l;
    if (
      (a
        ? (l = a(e, n))
        : (l = ce.isURLSearchParams(e)
            ? e.toString()
            : new mw(e, n).toString(i)),
      l)
    ) {
      const u = t.indexOf("#");
      (u !== -1 && (t = t.slice(0, u)),
        (t += (t.indexOf("?") === -1 ? "?" : "&") + l));
    }
    return t;
  }
  class LS {
    constructor() {
      this.handlers = [];
    }
    use(e, n, i) {
      return (
        this.handlers.push({
          fulfilled: e,
          rejected: n,
          synchronous: i ? i.synchronous : !1,
          runWhen: i ? i.runWhen : null,
        }),
        this.handlers.length - 1
      );
    }
    eject(e) {
      this.handlers[e] && (this.handlers[e] = null);
    }
    clear() {
      this.handlers && (this.handlers = []);
    }
    forEach(e) {
      ce.forEach(this.handlers, function (i) {
        i !== null && e(i);
      });
    }
  }
  const f2 = {
      silentJSONParsing: !0,
      forcedJSONParsing: !0,
      clarifyTimeoutError: !1,
    },
    YN = typeof URLSearchParams < "u" ? URLSearchParams : mw,
    qN = typeof FormData < "u" ? FormData : null,
    $N = typeof Blob < "u" ? Blob : null,
    GN = {
      isBrowser: !0,
      classes: { URLSearchParams: YN, FormData: qN, Blob: $N },
      protocols: ["http", "https", "file", "blob", "url", "data"],
    },
    gw = typeof window < "u" && typeof document < "u",
    m_ = (typeof navigator == "object" && navigator) || void 0,
    VN =
      gw &&
      (!m_ || ["ReactNative", "NativeScript", "NS"].indexOf(m_.product) < 0),
    WN =
      typeof WorkerGlobalScope < "u" &&
      self instanceof WorkerGlobalScope &&
      typeof self.importScripts == "function",
    XN = (gw && window.location.href) || "http://localhost",
    QN = Object.freeze(
      Object.defineProperty(
        {
          __proto__: null,
          hasBrowserEnv: gw,
          hasStandardBrowserEnv: VN,
          hasStandardBrowserWebWorkerEnv: WN,
          navigator: m_,
          origin: XN,
        },
        Symbol.toStringTag,
        { value: "Module" },
      ),
    ),
    Pi = { ...QN, ...GN };
  function ZN(t, e) {
    return kb(t, new Pi.classes.URLSearchParams(), {
      visitor: function (n, i, a, l) {
        return Pi.isNode && ce.isBuffer(n)
          ? (this.append(i, n.toString("base64")), !1)
          : l.defaultVisitor.apply(this, arguments);
      },
      ...e,
    });
  }
  function KN(t) {
    return ce
      .matchAll(/\w+|\[(\w*)]/g, t)
      .map((e) => (e[0] === "[]" ? "" : e[1] || e[0]));
  }
  function JN(t) {
    const e = {},
      n = Object.keys(t);
    let i;
    const a = n.length;
    let l;
    for (i = 0; i < a; i++) ((l = n[i]), (e[l] = t[l]));
    return e;
  }
  function d2(t) {
    function e(n, i, a, l) {
      let u = n[l++];
      if (u === "__proto__") return !0;
      const d = Number.isFinite(+u),
        m = l >= n.length;
      return (
        (u = !u && ce.isArray(a) ? a.length : u),
        m
          ? (ce.hasOwnProp(a, u) ? (a[u] = [a[u], i]) : (a[u] = i), !d)
          : ((!a[u] || !ce.isObject(a[u])) && (a[u] = []),
            e(n, i, a[u], l) && ce.isArray(a[u]) && (a[u] = JN(a[u])),
            !d)
      );
    }
    if (ce.isFormData(t) && ce.isFunction(t.entries)) {
      const n = {};
      return (
        ce.forEachEntry(t, (i, a) => {
          e(KN(i), a, n, 0);
        }),
        n
      );
    }
    return null;
  }
  function eA(t, e, n) {
    if (ce.isString(t))
      try {
        return ((e || JSON.parse)(t), ce.trim(t));
      } catch (i) {
        if (i.name !== "SyntaxError") throw i;
      }
    return (n || JSON.stringify)(t);
  }
  const Qg = {
    transitional: f2,
    adapter: ["xhr", "http", "fetch"],
    transformRequest: [
      function (e, n) {
        const i = n.getContentType() || "",
          a = i.indexOf("application/json") > -1,
          l = ce.isObject(e);
        if ((l && ce.isHTMLForm(e) && (e = new FormData(e)), ce.isFormData(e)))
          return a ? JSON.stringify(d2(e)) : e;
        if (
          ce.isArrayBuffer(e) ||
          ce.isBuffer(e) ||
          ce.isStream(e) ||
          ce.isFile(e) ||
          ce.isBlob(e) ||
          ce.isReadableStream(e)
        )
          return e;
        if (ce.isArrayBufferView(e)) return e.buffer;
        if (ce.isURLSearchParams(e))
          return (
            n.setContentType(
              "application/x-www-form-urlencoded;charset=utf-8",
              !1,
            ),
            e.toString()
          );
        let d;
        if (l) {
          if (i.indexOf("application/x-www-form-urlencoded") > -1)
            return ZN(e, this.formSerializer).toString();
          if ((d = ce.isFileList(e)) || i.indexOf("multipart/form-data") > -1) {
            const m = this.env && this.env.FormData;
            return kb(
              d ? { "files[]": e } : e,
              m && new m(),
              this.formSerializer,
            );
          }
        }
        return l || a ? (n.setContentType("application/json", !1), eA(e)) : e;
      },
    ],
    transformResponse: [
      function (e) {
        const n = this.transitional || Qg.transitional,
          i = n && n.forcedJSONParsing,
          a = this.responseType === "json";
        if (ce.isResponse(e) || ce.isReadableStream(e)) return e;
        if (e && ce.isString(e) && ((i && !this.responseType) || a)) {
          const u = !(n && n.silentJSONParsing) && a;
          try {
            return JSON.parse(e, this.parseReviver);
          } catch (d) {
            if (u)
              throw d.name === "SyntaxError"
                ? ct.from(d, ct.ERR_BAD_RESPONSE, this, null, this.response)
                : d;
          }
        }
        return e;
      },
    ],
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: { FormData: Pi.classes.FormData, Blob: Pi.classes.Blob },
    validateStatus: function (e) {
      return e >= 200 && e < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": void 0,
      },
    },
  };
  ce.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
    Qg.headers[t] = {};
  });
  const tA = ce.toObjectSet([
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent",
    ]),
    nA = (t) => {
      const e = {};
      let n, i, a;
      return (
        t &&
          t
            .split(
              `
`,
            )
            .forEach(function (u) {
              ((a = u.indexOf(":")),
                (n = u.substring(0, a).trim().toLowerCase()),
                (i = u.substring(a + 1).trim()),
                !(!n || (e[n] && tA[n])) &&
                  (n === "set-cookie"
                    ? e[n]
                      ? e[n].push(i)
                      : (e[n] = [i])
                    : (e[n] = e[n] ? e[n] + ", " + i : i)));
            }),
        e
      );
    },
    DS = Symbol("internals");
  function sg(t) {
    return t && String(t).trim().toLowerCase();
  }
  function G0(t) {
    return t === !1 || t == null ? t : ce.isArray(t) ? t.map(G0) : String(t);
  }
  function iA(t) {
    const e = Object.create(null),
      n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let i;
    for (; (i = n.exec(t)); ) e[i[1]] = i[2];
    return e;
  }
  const sA = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
  function vx(t, e, n, i, a) {
    if (ce.isFunction(i)) return i.call(this, e, n);
    if ((a && (e = n), !!ce.isString(e))) {
      if (ce.isString(i)) return e.indexOf(i) !== -1;
      if (ce.isRegExp(i)) return i.test(e);
    }
  }
  function rA(t) {
    return t
      .trim()
      .toLowerCase()
      .replace(/([a-z\d])(\w*)/g, (e, n, i) => n.toUpperCase() + i);
  }
  function aA(t, e) {
    const n = ce.toCamelCase(" " + e);
    ["get", "set", "has"].forEach((i) => {
      Object.defineProperty(t, i + n, {
        value: function (a, l, u) {
          return this[i].call(this, e, a, l, u);
        },
        configurable: !0,
      });
    });
  }
  let $s = class {
    constructor(e) {
      e && this.set(e);
    }
    set(e, n, i) {
      const a = this;
      function l(d, m, g) {
        const v = sg(m);
        if (!v) throw new Error("header name must be a non-empty string");
        const y = ce.findKey(a, v);
        (!y || a[y] === void 0 || g === !0 || (g === void 0 && a[y] !== !1)) &&
          (a[y || m] = G0(d));
      }
      const u = (d, m) => ce.forEach(d, (g, v) => l(g, v, m));
      if (ce.isPlainObject(e) || e instanceof this.constructor) u(e, n);
      else if (ce.isString(e) && (e = e.trim()) && !sA(e)) u(nA(e), n);
      else if (ce.isObject(e) && ce.isIterable(e)) {
        let d = {},
          m,
          g;
        for (const v of e) {
          if (!ce.isArray(v))
            throw TypeError("Object iterator must return a key-value pair");
          d[(g = v[0])] = (m = d[g])
            ? ce.isArray(m)
              ? [...m, v[1]]
              : [m, v[1]]
            : v[1];
        }
        u(d, n);
      } else e != null && l(n, e, i);
      return this;
    }
    get(e, n) {
      if (((e = sg(e)), e)) {
        const i = ce.findKey(this, e);
        if (i) {
          const a = this[i];
          if (!n) return a;
          if (n === !0) return iA(a);
          if (ce.isFunction(n)) return n.call(this, a, i);
          if (ce.isRegExp(n)) return n.exec(a);
          throw new TypeError("parser must be boolean|regexp|function");
        }
      }
    }
    has(e, n) {
      if (((e = sg(e)), e)) {
        const i = ce.findKey(this, e);
        return !!(i && this[i] !== void 0 && (!n || vx(this, this[i], i, n)));
      }
      return !1;
    }
    delete(e, n) {
      const i = this;
      let a = !1;
      function l(u) {
        if (((u = sg(u)), u)) {
          const d = ce.findKey(i, u);
          d && (!n || vx(i, i[d], d, n)) && (delete i[d], (a = !0));
        }
      }
      return (ce.isArray(e) ? e.forEach(l) : l(e), a);
    }
    clear(e) {
      const n = Object.keys(this);
      let i = n.length,
        a = !1;
      for (; i--; ) {
        const l = n[i];
        (!e || vx(this, this[l], l, e, !0)) && (delete this[l], (a = !0));
      }
      return a;
    }
    normalize(e) {
      const n = this,
        i = {};
      return (
        ce.forEach(this, (a, l) => {
          const u = ce.findKey(i, l);
          if (u) {
            ((n[u] = G0(a)), delete n[l]);
            return;
          }
          const d = e ? rA(l) : String(l).trim();
          (d !== l && delete n[l], (n[d] = G0(a)), (i[d] = !0));
        }),
        this
      );
    }
    concat(...e) {
      return this.constructor.concat(this, ...e);
    }
    toJSON(e) {
      const n = Object.create(null);
      return (
        ce.forEach(this, (i, a) => {
          i != null &&
            i !== !1 &&
            (n[a] = e && ce.isArray(i) ? i.join(", ") : i);
        }),
        n
      );
    }
    [Symbol.iterator]() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
      return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
    }
    getSetCookie() {
      return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
      return "AxiosHeaders";
    }
    static from(e) {
      return e instanceof this ? e : new this(e);
    }
    static concat(e, ...n) {
      const i = new this(e);
      return (n.forEach((a) => i.set(a)), i);
    }
    static accessor(e) {
      const i = (this[DS] = this[DS] = { accessors: {} }).accessors,
        a = this.prototype;
      function l(u) {
        const d = sg(u);
        i[d] || (aA(a, u), (i[d] = !0));
      }
      return (ce.isArray(e) ? e.forEach(l) : l(e), this);
    }
  };
  $s.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization",
  ]);
  ce.reduceDescriptors($s.prototype, ({ value: t }, e) => {
    let n = e[0].toUpperCase() + e.slice(1);
    return {
      get: () => t,
      set(i) {
        this[n] = i;
      },
    };
  });
  ce.freezeMethods($s);
  function yx(t, e) {
    const n = this || Qg,
      i = e || n,
      a = $s.from(i.headers);
    let l = i.data;
    return (
      ce.forEach(t, function (d) {
        l = d.call(n, l, a.normalize(), e ? e.status : void 0);
      }),
      a.normalize(),
      l
    );
  }
  function h2(t) {
    return !!(t && t.__CANCEL__);
  }
  function tp(t, e, n) {
    (ct.call(this, t ?? "canceled", ct.ERR_CANCELED, e, n),
      (this.name = "CanceledError"));
  }
  ce.inherits(tp, ct, { __CANCEL__: !0 });
  function p2(t, e, n) {
    const i = n.config.validateStatus;
    !n.status || !i || i(n.status)
      ? t(n)
      : e(
          new ct(
            "Request failed with status code " + n.status,
            [ct.ERR_BAD_REQUEST, ct.ERR_BAD_RESPONSE][
              Math.floor(n.status / 100) - 4
            ],
            n.config,
            n.request,
            n,
          ),
        );
  }
  function lA(t) {
    const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
    return (e && e[1]) || "";
  }
  function oA(t, e) {
    t = t || 10;
    const n = new Array(t),
      i = new Array(t);
    let a = 0,
      l = 0,
      u;
    return (
      (e = e !== void 0 ? e : 1e3),
      function (m) {
        const g = Date.now(),
          v = i[l];
        (u || (u = g), (n[a] = m), (i[a] = g));
        let y = l,
          w = 0;
        for (; y !== a; ) ((w += n[y++]), (y = y % t));
        if (((a = (a + 1) % t), a === l && (l = (l + 1) % t), g - u < e))
          return;
        const S = v && g - v;
        return S ? Math.round((w * 1e3) / S) : void 0;
      }
    );
  }
  function cA(t, e) {
    let n = 0,
      i = 1e3 / e,
      a,
      l;
    const u = (g, v = Date.now()) => {
      ((n = v), (a = null), l && (clearTimeout(l), (l = null)), t(...g));
    };
    return [
      (...g) => {
        const v = Date.now(),
          y = v - n;
        y >= i
          ? u(g, v)
          : ((a = g),
            l ||
              (l = setTimeout(() => {
                ((l = null), u(a));
              }, i - y)));
      },
      () => a && u(a),
    ];
  }
  const rb = (t, e, n = 3) => {
      let i = 0;
      const a = oA(50, 250);
      return cA((l) => {
        const u = l.loaded,
          d = l.lengthComputable ? l.total : void 0,
          m = u - i,
          g = a(m),
          v = u <= d;
        i = u;
        const y = {
          loaded: u,
          total: d,
          progress: d ? u / d : void 0,
          bytes: m,
          rate: g || void 0,
          estimated: g && d && v ? (d - u) / g : void 0,
          event: l,
          lengthComputable: d != null,
          [e ? "download" : "upload"]: !0,
        };
        t(y);
      }, n);
    },
    kS = (t, e) => {
      const n = t != null;
      return [(i) => e[0]({ lengthComputable: n, total: t, loaded: i }), e[1]];
    },
    zS =
      (t) =>
      (...e) =>
        ce.asap(() => t(...e)),
    uA = Pi.hasStandardBrowserEnv
      ? ((t, e) => (n) => (
          (n = new URL(n, Pi.origin)),
          t.protocol === n.protocol &&
            t.host === n.host &&
            (e || t.port === n.port)
        ))(
          new URL(Pi.origin),
          Pi.navigator && /(msie|trident)/i.test(Pi.navigator.userAgent),
        )
      : () => !0,
    fA = Pi.hasStandardBrowserEnv
      ? {
          write(t, e, n, i, a, l, u) {
            if (typeof document > "u") return;
            const d = [`${t}=${encodeURIComponent(e)}`];
            (ce.isNumber(n) && d.push(`expires=${new Date(n).toUTCString()}`),
              ce.isString(i) && d.push(`path=${i}`),
              ce.isString(a) && d.push(`domain=${a}`),
              l === !0 && d.push("secure"),
              ce.isString(u) && d.push(`SameSite=${u}`),
              (document.cookie = d.join("; ")));
          },
          read(t) {
            if (typeof document > "u") return null;
            const e = document.cookie.match(
              new RegExp("(?:^|; )" + t + "=([^;]*)"),
            );
            return e ? decodeURIComponent(e[1]) : null;
          },
          remove(t) {
            this.write(t, "", Date.now() - 864e5, "/");
          },
        }
      : {
          write() {},
          read() {
            return null;
          },
          remove() {},
        };
  function dA(t) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
  }
  function hA(t, e) {
    return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
  }
  function m2(t, e, n) {
    let i = !dA(e);
    return t && (i || n == !1) ? hA(t, e) : e;
  }
  const PS = (t) => (t instanceof $s ? { ...t } : t);
  function Rf(t, e) {
    e = e || {};
    const n = {};
    function i(g, v, y, w) {
      return ce.isPlainObject(g) && ce.isPlainObject(v)
        ? ce.merge.call({ caseless: w }, g, v)
        : ce.isPlainObject(v)
          ? ce.merge({}, v)
          : ce.isArray(v)
            ? v.slice()
            : v;
    }
    function a(g, v, y, w) {
      if (ce.isUndefined(v)) {
        if (!ce.isUndefined(g)) return i(void 0, g, y, w);
      } else return i(g, v, y, w);
    }
    function l(g, v) {
      if (!ce.isUndefined(v)) return i(void 0, v);
    }
    function u(g, v) {
      if (ce.isUndefined(v)) {
        if (!ce.isUndefined(g)) return i(void 0, g);
      } else return i(void 0, v);
    }
    function d(g, v, y) {
      if (y in e) return i(g, v);
      if (y in t) return i(void 0, g);
    }
    const m = {
      url: l,
      method: l,
      data: l,
      baseURL: u,
      transformRequest: u,
      transformResponse: u,
      paramsSerializer: u,
      timeout: u,
      timeoutMessage: u,
      withCredentials: u,
      withXSRFToken: u,
      adapter: u,
      responseType: u,
      xsrfCookieName: u,
      xsrfHeaderName: u,
      onUploadProgress: u,
      onDownloadProgress: u,
      decompress: u,
      maxContentLength: u,
      maxBodyLength: u,
      beforeRedirect: u,
      transport: u,
      httpAgent: u,
      httpsAgent: u,
      cancelToken: u,
      socketPath: u,
      responseEncoding: u,
      validateStatus: d,
      headers: (g, v, y) => a(PS(g), PS(v), y, !0),
    };
    return (
      ce.forEach(Object.keys({ ...t, ...e }), function (v) {
        const y = m[v] || a,
          w = y(t[v], e[v], v);
        (ce.isUndefined(w) && y !== d) || (n[v] = w);
      }),
      n
    );
  }
  const g2 = (t) => {
      const e = Rf({}, t);
      let {
        data: n,
        withXSRFToken: i,
        xsrfHeaderName: a,
        xsrfCookieName: l,
        headers: u,
        auth: d,
      } = e;
      if (
        ((e.headers = u = $s.from(u)),
        (e.url = u2(
          m2(e.baseURL, e.url, e.allowAbsoluteUrls),
          t.params,
          t.paramsSerializer,
        )),
        d &&
          u.set(
            "Authorization",
            "Basic " +
              btoa(
                (d.username || "") +
                  ":" +
                  (d.password ? unescape(encodeURIComponent(d.password)) : ""),
              ),
          ),
        ce.isFormData(n))
      ) {
        if (Pi.hasStandardBrowserEnv || Pi.hasStandardBrowserWebWorkerEnv)
          u.setContentType(void 0);
        else if (ce.isFunction(n.getHeaders)) {
          const m = n.getHeaders(),
            g = ["content-type", "content-length"];
          Object.entries(m).forEach(([v, y]) => {
            g.includes(v.toLowerCase()) && u.set(v, y);
          });
        }
      }
      if (
        Pi.hasStandardBrowserEnv &&
        (i && ce.isFunction(i) && (i = i(e)), i || (i !== !1 && uA(e.url)))
      ) {
        const m = a && l && fA.read(l);
        m && u.set(a, m);
      }
      return e;
    },
    pA = typeof XMLHttpRequest < "u",
    mA =
      pA &&
      function (t) {
        return new Promise(function (n, i) {
          const a = g2(t);
          let l = a.data;
          const u = $s.from(a.headers).normalize();
          let {
              responseType: d,
              onUploadProgress: m,
              onDownloadProgress: g,
            } = a,
            v,
            y,
            w,
            S,
            T;
          function E() {
            (S && S(),
              T && T(),
              a.cancelToken && a.cancelToken.unsubscribe(v),
              a.signal && a.signal.removeEventListener("abort", v));
          }
          let j = new XMLHttpRequest();
          (j.open(a.method.toUpperCase(), a.url, !0), (j.timeout = a.timeout));
          function O() {
            if (!j) return;
            const N = $s.from(
                "getAllResponseHeaders" in j && j.getAllResponseHeaders(),
              ),
              P = {
                data:
                  !d || d === "text" || d === "json"
                    ? j.responseText
                    : j.response,
                status: j.status,
                statusText: j.statusText,
                headers: N,
                config: t,
                request: j,
              };
            (p2(
              function (Y) {
                (n(Y), E());
              },
              function (Y) {
                (i(Y), E());
              },
              P,
            ),
              (j = null));
          }
          ("onloadend" in j
            ? (j.onloadend = O)
            : (j.onreadystatechange = function () {
                !j ||
                  j.readyState !== 4 ||
                  (j.status === 0 &&
                    !(j.responseURL && j.responseURL.indexOf("file:") === 0)) ||
                  setTimeout(O);
              }),
            (j.onabort = function () {
              j &&
                (i(new ct("Request aborted", ct.ECONNABORTED, t, j)),
                (j = null));
            }),
            (j.onerror = function (R) {
              const P = R && R.message ? R.message : "Network Error",
                G = new ct(P, ct.ERR_NETWORK, t, j);
              ((G.event = R || null), i(G), (j = null));
            }),
            (j.ontimeout = function () {
              let R = a.timeout
                ? "timeout of " + a.timeout + "ms exceeded"
                : "timeout exceeded";
              const P = a.transitional || f2;
              (a.timeoutErrorMessage && (R = a.timeoutErrorMessage),
                i(
                  new ct(
                    R,
                    P.clarifyTimeoutError ? ct.ETIMEDOUT : ct.ECONNABORTED,
                    t,
                    j,
                  ),
                ),
                (j = null));
            }),
            l === void 0 && u.setContentType(null),
            "setRequestHeader" in j &&
              ce.forEach(u.toJSON(), function (R, P) {
                j.setRequestHeader(P, R);
              }),
            ce.isUndefined(a.withCredentials) ||
              (j.withCredentials = !!a.withCredentials),
            d && d !== "json" && (j.responseType = a.responseType),
            g && (([w, T] = rb(g, !0)), j.addEventListener("progress", w)),
            m &&
              j.upload &&
              (([y, S] = rb(m)),
              j.upload.addEventListener("progress", y),
              j.upload.addEventListener("loadend", S)),
            (a.cancelToken || a.signal) &&
              ((v = (N) => {
                j &&
                  (i(!N || N.type ? new tp(null, t, j) : N),
                  j.abort(),
                  (j = null));
              }),
              a.cancelToken && a.cancelToken.subscribe(v),
              a.signal &&
                (a.signal.aborted
                  ? v()
                  : a.signal.addEventListener("abort", v))));
          const M = lA(a.url);
          if (M && Pi.protocols.indexOf(M) === -1) {
            i(new ct("Unsupported protocol " + M + ":", ct.ERR_BAD_REQUEST, t));
            return;
          }
          j.send(l || null);
        });
      },
    gA = (t, e) => {
      const { length: n } = (t = t ? t.filter(Boolean) : []);
      if (e || n) {
        let i = new AbortController(),
          a;
        const l = function (g) {
          if (!a) {
            ((a = !0), d());
            const v = g instanceof Error ? g : this.reason;
            i.abort(
              v instanceof ct ? v : new tp(v instanceof Error ? v.message : v),
            );
          }
        };
        let u =
          e &&
          setTimeout(() => {
            ((u = null),
              l(new ct(`timeout ${e} of ms exceeded`, ct.ETIMEDOUT)));
          }, e);
        const d = () => {
          t &&
            (u && clearTimeout(u),
            (u = null),
            t.forEach((g) => {
              g.unsubscribe
                ? g.unsubscribe(l)
                : g.removeEventListener("abort", l);
            }),
            (t = null));
        };
        t.forEach((g) => g.addEventListener("abort", l));
        const { signal: m } = i;
        return ((m.unsubscribe = () => ce.asap(d)), m);
      }
    },
    vA = function* (t, e) {
      let n = t.byteLength;
      if (n < e) {
        yield t;
        return;
      }
      let i = 0,
        a;
      for (; i < n; ) ((a = i + e), yield t.slice(i, a), (i = a));
    },
    yA = async function* (t, e) {
      for await (const n of bA(t)) yield* vA(n, e);
    },
    bA = async function* (t) {
      if (t[Symbol.asyncIterator]) {
        yield* t;
        return;
      }
      const e = t.getReader();
      try {
        for (;;) {
          const { done: n, value: i } = await e.read();
          if (n) break;
          yield i;
        }
      } finally {
        await e.cancel();
      }
    },
    IS = (t, e, n, i) => {
      const a = yA(t, e);
      let l = 0,
        u,
        d = (m) => {
          u || ((u = !0), i && i(m));
        };
      return new ReadableStream(
        {
          async pull(m) {
            try {
              const { done: g, value: v } = await a.next();
              if (g) {
                (d(), m.close());
                return;
              }
              let y = v.byteLength;
              if (n) {
                let w = (l += y);
                n(w);
              }
              m.enqueue(new Uint8Array(v));
            } catch (g) {
              throw (d(g), g);
            }
          },
          cancel(m) {
            return (d(m), a.return());
          },
        },
        { highWaterMark: 2 },
      );
    },
    US = 64 * 1024,
    { isFunction: x0 } = ce,
    xA = (({ Request: t, Response: e }) => ({ Request: t, Response: e }))(
      ce.global,
    ),
    { ReadableStream: FS, TextEncoder: BS } = ce.global,
    HS = (t, ...e) => {
      try {
        return !!t(...e);
      } catch {
        return !1;
      }
    },
    _A = (t) => {
      t = ce.merge.call({ skipUndefined: !0 }, xA, t);
      const { fetch: e, Request: n, Response: i } = t,
        a = e ? x0(e) : typeof fetch == "function",
        l = x0(n),
        u = x0(i);
      if (!a) return !1;
      const d = a && x0(FS),
        m =
          a &&
          (typeof BS == "function"
            ? (
                (T) => (E) =>
                  T.encode(E)
              )(new BS())
            : async (T) => new Uint8Array(await new n(T).arrayBuffer())),
        g =
          l &&
          d &&
          HS(() => {
            let T = !1;
            const E = new n(Pi.origin, {
              body: new FS(),
              method: "POST",
              get duplex() {
                return ((T = !0), "half");
              },
            }).headers.has("Content-Type");
            return T && !E;
          }),
        v = u && d && HS(() => ce.isReadableStream(new i("").body)),
        y = { stream: v && ((T) => T.body) };
      a &&
        ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((T) => {
          !y[T] &&
            (y[T] = (E, j) => {
              let O = E && E[T];
              if (O) return O.call(E);
              throw new ct(
                `Response type '${T}' is not supported`,
                ct.ERR_NOT_SUPPORT,
                j,
              );
            });
        });
      const w = async (T) => {
          if (T == null) return 0;
          if (ce.isBlob(T)) return T.size;
          if (ce.isSpecCompliantForm(T))
            return (
              await new n(Pi.origin, { method: "POST", body: T }).arrayBuffer()
            ).byteLength;
          if (ce.isArrayBufferView(T) || ce.isArrayBuffer(T))
            return T.byteLength;
          if ((ce.isURLSearchParams(T) && (T = T + ""), ce.isString(T)))
            return (await m(T)).byteLength;
        },
        S = async (T, E) => {
          const j = ce.toFiniteNumber(T.getContentLength());
          return j ?? w(E);
        };
      return async (T) => {
        let {
            url: E,
            method: j,
            data: O,
            signal: M,
            cancelToken: N,
            timeout: R,
            onDownloadProgress: P,
            onUploadProgress: G,
            responseType: Y,
            headers: B,
            withCredentials: I = "same-origin",
            fetchOptions: H,
          } = g2(T),
          X = e || fetch;
        Y = Y ? (Y + "").toLowerCase() : "text";
        let fe = gA([M, N && N.toAbortSignal()], R),
          ve = null;
        const be =
          fe &&
          fe.unsubscribe &&
          (() => {
            fe.unsubscribe();
          });
        let Oe;
        try {
          if (
            G &&
            g &&
            j !== "get" &&
            j !== "head" &&
            (Oe = await S(B, O)) !== 0
          ) {
            let F = new n(E, { method: "POST", body: O, duplex: "half" }),
              ae;
            if (
              (ce.isFormData(O) &&
                (ae = F.headers.get("content-type")) &&
                B.setContentType(ae),
              F.body)
            ) {
              const [xe, Me] = kS(Oe, rb(zS(G)));
              O = IS(F.body, US, xe, Me);
            }
          }
          ce.isString(I) || (I = I ? "include" : "omit");
          const V = l && "credentials" in n.prototype,
            pe = {
              ...H,
              signal: fe,
              method: j.toUpperCase(),
              headers: B.normalize().toJSON(),
              body: O,
              duplex: "half",
              credentials: V ? I : void 0,
            };
          ve = l && new n(E, pe);
          let de = await (l ? X(ve, H) : X(E, pe));
          const he = v && (Y === "stream" || Y === "response");
          if (v && (P || (he && be))) {
            const F = {};
            ["status", "statusText", "headers"].forEach((le) => {
              F[le] = de[le];
            });
            const ae = ce.toFiniteNumber(de.headers.get("content-length")),
              [xe, Me] = (P && kS(ae, rb(zS(P), !0))) || [];
            de = new i(
              IS(de.body, US, xe, () => {
                (Me && Me(), be && be());
              }),
              F,
            );
          }
          Y = Y || "text";
          let Te = await y[ce.findKey(y, Y) || "text"](de, T);
          return (
            !he && be && be(),
            await new Promise((F, ae) => {
              p2(F, ae, {
                data: Te,
                headers: $s.from(de.headers),
                status: de.status,
                statusText: de.statusText,
                config: T,
                request: ve,
              });
            })
          );
        } catch (V) {
          throw (
            be && be(),
            V && V.name === "TypeError" && /Load failed|fetch/i.test(V.message)
              ? Object.assign(new ct("Network Error", ct.ERR_NETWORK, T, ve), {
                  cause: V.cause || V,
                })
              : ct.from(V, V && V.code, T, ve)
          );
        }
      };
    },
    wA = new Map(),
    v2 = (t) => {
      let e = (t && t.env) || {};
      const { fetch: n, Request: i, Response: a } = e,
        l = [i, a, n];
      let u = l.length,
        d = u,
        m,
        g,
        v = wA;
      for (; d--; )
        ((m = l[d]),
          (g = v.get(m)),
          g === void 0 && v.set(m, (g = d ? new Map() : _A(e))),
          (v = g));
      return g;
    };
  v2();
  const vw = { http: UN, xhr: mA, fetch: { get: v2 } };
  ce.forEach(vw, (t, e) => {
    if (t) {
      try {
        Object.defineProperty(t, "name", { value: e });
      } catch {}
      Object.defineProperty(t, "adapterName", { value: e });
    }
  });
  const YS = (t) => `- ${t}`,
    SA = (t) => ce.isFunction(t) || t === null || t === !1;
  function TA(t, e) {
    t = ce.isArray(t) ? t : [t];
    const { length: n } = t;
    let i, a;
    const l = {};
    for (let u = 0; u < n; u++) {
      i = t[u];
      let d;
      if (
        ((a = i),
        !SA(i) && ((a = vw[(d = String(i)).toLowerCase()]), a === void 0))
      )
        throw new ct(`Unknown adapter '${d}'`);
      if (a && (ce.isFunction(a) || (a = a.get(e)))) break;
      l[d || "#" + u] = a;
    }
    if (!a) {
      const u = Object.entries(l).map(
        ([m, g]) =>
          `adapter ${m} ` +
          (g === !1
            ? "is not supported by the environment"
            : "is not available in the build"),
      );
      let d = n
        ? u.length > 1
          ? `since :
` +
            u.map(YS).join(`
`)
          : " " + YS(u[0])
        : "as no adapter specified";
      throw new ct(
        "There is no suitable adapter to dispatch the request " + d,
        "ERR_NOT_SUPPORT",
      );
    }
    return a;
  }
  const y2 = { getAdapter: TA, adapters: vw };
  function bx(t) {
    if (
      (t.cancelToken && t.cancelToken.throwIfRequested(),
      t.signal && t.signal.aborted)
    )
      throw new tp(null, t);
  }
  function qS(t) {
    return (
      bx(t),
      (t.headers = $s.from(t.headers)),
      (t.data = yx.call(t, t.transformRequest)),
      ["post", "put", "patch"].indexOf(t.method) !== -1 &&
        t.headers.setContentType("application/x-www-form-urlencoded", !1),
      y2
        .getAdapter(
          t.adapter || Qg.adapter,
          t,
        )(t)
        .then(
          function (i) {
            return (
              bx(t),
              (i.data = yx.call(t, t.transformResponse, i)),
              (i.headers = $s.from(i.headers)),
              i
            );
          },
          function (i) {
            return (
              h2(i) ||
                (bx(t),
                i &&
                  i.response &&
                  ((i.response.data = yx.call(
                    t,
                    t.transformResponse,
                    i.response,
                  )),
                  (i.response.headers = $s.from(i.response.headers)))),
              Promise.reject(i)
            );
          },
        )
    );
  }
  const b2 = "1.13.2",
    zb = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach(
    (t, e) => {
      zb[t] = function (i) {
        return typeof i === t || "a" + (e < 1 ? "n " : " ") + t;
      };
    },
  );
  const $S = {};
  zb.transitional = function (e, n, i) {
    function a(l, u) {
      return (
        "[Axios v" +
        b2 +
        "] Transitional option '" +
        l +
        "'" +
        u +
        (i ? ". " + i : "")
      );
    }
    return (l, u, d) => {
      if (e === !1)
        throw new ct(
          a(u, " has been removed" + (n ? " in " + n : "")),
          ct.ERR_DEPRECATED,
        );
      return (
        n &&
          !$S[u] &&
          (($S[u] = !0),
          console.warn(
            a(
              u,
              " has been deprecated since v" +
                n +
                " and will be removed in the near future",
            ),
          )),
        e ? e(l, u, d) : !0
      );
    };
  };
  zb.spelling = function (e) {
    return (n, i) => (console.warn(`${i} is likely a misspelling of ${e}`), !0);
  };
  function EA(t, e, n) {
    if (typeof t != "object")
      throw new ct("options must be an object", ct.ERR_BAD_OPTION_VALUE);
    const i = Object.keys(t);
    let a = i.length;
    for (; a-- > 0; ) {
      const l = i[a],
        u = e[l];
      if (u) {
        const d = t[l],
          m = d === void 0 || u(d, l, t);
        if (m !== !0)
          throw new ct(
            "option " + l + " must be " + m,
            ct.ERR_BAD_OPTION_VALUE,
          );
        continue;
      }
      if (n !== !0) throw new ct("Unknown option " + l, ct.ERR_BAD_OPTION);
    }
  }
  const V0 = { assertOptions: EA, validators: zb },
    rl = V0.validators;
  let jf = class {
    constructor(e) {
      ((this.defaults = e || {}),
        (this.interceptors = { request: new LS(), response: new LS() }));
    }
    async request(e, n) {
      try {
        return await this._request(e, n);
      } catch (i) {
        if (i instanceof Error) {
          let a = {};
          Error.captureStackTrace
            ? Error.captureStackTrace(a)
            : (a = new Error());
          const l = a.stack ? a.stack.replace(/^.+\n/, "") : "";
          try {
            i.stack
              ? l &&
                !String(i.stack).endsWith(l.replace(/^.+\n.+\n/, "")) &&
                (i.stack +=
                  `
` + l)
              : (i.stack = l);
          } catch {}
        }
        throw i;
      }
    }
    _request(e, n) {
      (typeof e == "string" ? ((n = n || {}), (n.url = e)) : (n = e || {}),
        (n = Rf(this.defaults, n)));
      const { transitional: i, paramsSerializer: a, headers: l } = n;
      (i !== void 0 &&
        V0.assertOptions(
          i,
          {
            silentJSONParsing: rl.transitional(rl.boolean),
            forcedJSONParsing: rl.transitional(rl.boolean),
            clarifyTimeoutError: rl.transitional(rl.boolean),
          },
          !1,
        ),
        a != null &&
          (ce.isFunction(a)
            ? (n.paramsSerializer = { serialize: a })
            : V0.assertOptions(
                a,
                { encode: rl.function, serialize: rl.function },
                !0,
              )),
        n.allowAbsoluteUrls !== void 0 ||
          (this.defaults.allowAbsoluteUrls !== void 0
            ? (n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls)
            : (n.allowAbsoluteUrls = !0)),
        V0.assertOptions(
          n,
          {
            baseUrl: rl.spelling("baseURL"),
            withXsrfToken: rl.spelling("withXSRFToken"),
          },
          !0,
        ),
        (n.method = (n.method || this.defaults.method || "get").toLowerCase()));
      let u = l && ce.merge(l.common, l[n.method]);
      (l &&
        ce.forEach(
          ["delete", "get", "head", "post", "put", "patch", "common"],
          (T) => {
            delete l[T];
          },
        ),
        (n.headers = $s.concat(u, l)));
      const d = [];
      let m = !0;
      this.interceptors.request.forEach(function (E) {
        (typeof E.runWhen == "function" && E.runWhen(n) === !1) ||
          ((m = m && E.synchronous), d.unshift(E.fulfilled, E.rejected));
      });
      const g = [];
      this.interceptors.response.forEach(function (E) {
        g.push(E.fulfilled, E.rejected);
      });
      let v,
        y = 0,
        w;
      if (!m) {
        const T = [qS.bind(this), void 0];
        for (
          T.unshift(...d), T.push(...g), w = T.length, v = Promise.resolve(n);
          y < w;

        )
          v = v.then(T[y++], T[y++]);
        return v;
      }
      w = d.length;
      let S = n;
      for (; y < w; ) {
        const T = d[y++],
          E = d[y++];
        try {
          S = T(S);
        } catch (j) {
          E.call(this, j);
          break;
        }
      }
      try {
        v = qS.call(this, S);
      } catch (T) {
        return Promise.reject(T);
      }
      for (y = 0, w = g.length; y < w; ) v = v.then(g[y++], g[y++]);
      return v;
    }
    getUri(e) {
      e = Rf(this.defaults, e);
      const n = m2(e.baseURL, e.url, e.allowAbsoluteUrls);
      return u2(n, e.params, e.paramsSerializer);
    }
  };
  ce.forEach(["delete", "get", "head", "options"], function (e) {
    jf.prototype[e] = function (n, i) {
      return this.request(
        Rf(i || {}, { method: e, url: n, data: (i || {}).data }),
      );
    };
  });
  ce.forEach(["post", "put", "patch"], function (e) {
    function n(i) {
      return function (l, u, d) {
        return this.request(
          Rf(d || {}, {
            method: e,
            headers: i ? { "Content-Type": "multipart/form-data" } : {},
            url: l,
            data: u,
          }),
        );
      };
    }
    ((jf.prototype[e] = n()), (jf.prototype[e + "Form"] = n(!0)));
  });
  let CA = class x2 {
    constructor(e) {
      if (typeof e != "function")
        throw new TypeError("executor must be a function.");
      let n;
      this.promise = new Promise(function (l) {
        n = l;
      });
      const i = this;
      (this.promise.then((a) => {
        if (!i._listeners) return;
        let l = i._listeners.length;
        for (; l-- > 0; ) i._listeners[l](a);
        i._listeners = null;
      }),
        (this.promise.then = (a) => {
          let l;
          const u = new Promise((d) => {
            (i.subscribe(d), (l = d));
          }).then(a);
          return (
            (u.cancel = function () {
              i.unsubscribe(l);
            }),
            u
          );
        }),
        e(function (l, u, d) {
          i.reason || ((i.reason = new tp(l, u, d)), n(i.reason));
        }));
    }
    throwIfRequested() {
      if (this.reason) throw this.reason;
    }
    subscribe(e) {
      if (this.reason) {
        e(this.reason);
        return;
      }
      this._listeners ? this._listeners.push(e) : (this._listeners = [e]);
    }
    unsubscribe(e) {
      if (!this._listeners) return;
      const n = this._listeners.indexOf(e);
      n !== -1 && this._listeners.splice(n, 1);
    }
    toAbortSignal() {
      const e = new AbortController(),
        n = (i) => {
          e.abort(i);
        };
      return (
        this.subscribe(n),
        (e.signal.unsubscribe = () => this.unsubscribe(n)),
        e.signal
      );
    }
    static source() {
      let e;
      return {
        token: new x2(function (a) {
          e = a;
        }),
        cancel: e,
      };
    }
  };
  function OA(t) {
    return function (n) {
      return t.apply(null, n);
    };
  }
  function jA(t) {
    return ce.isObject(t) && t.isAxiosError === !0;
  }
  const g_ = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526,
  };
  Object.entries(g_).forEach(([t, e]) => {
    g_[e] = t;
  });
  function _2(t) {
    const e = new jf(t),
      n = KE(jf.prototype.request, e);
    return (
      ce.extend(n, jf.prototype, e, { allOwnKeys: !0 }),
      ce.extend(n, e, null, { allOwnKeys: !0 }),
      (n.create = function (a) {
        return _2(Rf(t, a));
      }),
      n
    );
  }
  const Xe = _2(Qg);
  Xe.Axios = jf;
  Xe.CanceledError = tp;
  Xe.CancelToken = CA;
  Xe.isCancel = h2;
  Xe.VERSION = b2;
  Xe.toFormData = kb;
  Xe.AxiosError = ct;
  Xe.Cancel = Xe.CanceledError;
  Xe.all = function (e) {
    return Promise.all(e);
  };
  Xe.spread = OA;
  Xe.isAxiosError = jA;
  Xe.mergeConfig = Rf;
  Xe.AxiosHeaders = $s;
  Xe.formToJSON = (t) => d2(ce.isHTMLForm(t) ? new FormData(t) : t);
  Xe.getAdapter = y2.getAdapter;
  Xe.HttpStatusCode = g_;
  Xe.default = Xe;
  const {
      Axios: _I,
      AxiosError: wI,
      CanceledError: SI,
      isCancel: TI,
      CancelToken: EI,
      VERSION: CI,
      all: OI,
      Cancel: jI,
      isAxiosError: MI,
      spread: NI,
      toFormData: AI,
      AxiosHeaders: RI,
      HttpStatusCode: LI,
      formToJSON: DI,
      getAdapter: kI,
      mergeConfig: zI,
    } = Xe,
    SITE_TRANSLATIONS = {
      kateqoriyalar: "Kateqoriyalar",
      odenissiz_onlayn_dersler: "Ödənişsiz Onlayn Dərslər",
      derslere_qatil: "Dərslərə qatıl",
      elanlar: "Elanlar",
      xeberler: "Xəbərlər",
      derslik_ve_test_banklari: "Dərsliklər və Test Bankları",
      hamisina_bax: "Hamısına bax",
      elave_melumatlar_form: "Əlavə məlumatlar",
      sualin_var_form_title: "Sualınız var? Bizə müraciət edin",
      your_location: "Bakı",
      gonder_button_basligi: "Göndər",
      muhum_kecidler: "Mühüm keçidlər",
      tehsil_regionlari: "Təhsil regionları",
      partnyorlar: "Partnyorlar",
      haqqimda_bioqrafiya: "Haqqımda və bioqrafiya",
      imtahanlar: "İmtahanlar",
      derslikler: "Dərsliklər",
      xidmetler: "Xidmətlər",
      qalereya: "Qalereya",
      qaydalar_ve_sertler: "Qaydalar və şərtlər",
      xos_geldiniz: "Xoş gəldiniz!",
      qeydiyyat: "Qeydiyyat",
      daxil_ol: "Daxil ol",
      hesabiniza_daxil_olun_veya_qeydiyyatdan_kecin:
        "Hesabınıza daxil olun və ya qeydiyyatdan keçin",
      melumatlarim: "Məlumatlarım",
      abuneliklerim: "Abunəliklərim",
      test_neticelerim: "Test nəticələrim",
      bildirisler: "Bildirişlər",
      yukle: "Yüklə",
      odenissiz_onlayn_derslere_qatil: "Ödənişsiz onlayn dərslərə qatıl",
      onlayn_dersler: "Onlayn dərslər",
      text_onlayn_dersler: "Onlayn dərslər",
      indi_al: "İndi al",
      etrafli_bax: "Ətraflı bax",
      abune_ol: "Abunə ol",
      zehmet_olmasa_gozleyin: "Zəhmət olmasa gözləyin...",
      cixis: "Çıxış",
      tehsil_ana_sehife_meta_title: "Təhsil | Ana səhifə",
      sexsi_kabinet: "Şəxsi kabinet",
      sifreni_unuttum: "Şifrəni unutdum",
      your_email: "info@samireeliyeva.az",
      your_telephone_number: "+994552792127",
      ana_sehife: "Ana səhifə",
      abunelik_paketleri: "Abunəlik paketləri",
      abune_paketleri_ile_tanis_ol: "Abunə paketləri",
      derslik_ve_test_banklari_text:
        "Dərsliklər və test banklarına keçid edin",
      odenissiz_onlayn_derslere_qatil_text:
        "Ödənişsiz dərslərə keçid edin",
      sayti_beyenirsiniz: "Saytı bəyənirsiniz?",
      sayti_beyenirsiniz_text: "Fikirlərinizi bizimlə paylaşın",
      hesabiniza_daxil_olun: "Hesabınıza daxil olun",
      text_hero_kateqoriyalar: "Kateqoriya seçimi edin",
      recruitment: "İşə qəbul",
      input_text: "Mesaj",
    },
    w2 = W.createContext({
      t: (t) => SITE_TRANSLATIONS[t] || t,
      loading: !1,
      error: null,
    }),
    MA = ({ children: t }) => {
      const [e, n] = W.useState(() => {
          try {
            return {
              ...SITE_TRANSLATIONS,
              ...JSON.parse(localStorage.getItem("site_translations_az") || "{}"),
            };
          } catch {
            return SITE_TRANSLATIONS;
          }
        }),
        [i, a] = W.useState(!1),
        [l, u] = W.useState(null);
      W.useEffect(() => {
        Xe.get("https://admin.samireeliyeva.az/api/v1/translations", {
          headers: { "X-Accept-Language": "az", Accept: "application/json" },
        })
          .then((m) => {
            const g = {
              ...SITE_TRANSLATIONS,
              ...m.data,
              your_email:
                m.data?.your_email === "example@gmail.com"
                  ? "info@samireeliyeva.az"
                  : m.data?.your_email || SITE_TRANSLATIONS.your_email,
            };
            n(g);
            localStorage.setItem("site_translations_az", JSON.stringify(g));
          })
          .catch((m) => {
            u("Məlumatlar müvəqqəti yenilənə bilmir.");
            window.dispatchEvent(new CustomEvent("site-api-error"));
          })
          .finally(() => a(!1));
      }, []);
      const d = (m) => e[m] || m;
      return h.jsx(w2.Provider, {
        value: { t: d, loading: i, error: l },
        children: h.jsxs(h.Fragment, {
          children: [
            l &&
              h.jsx("div", {
                className: "api-error-banner",
                role: "alert",
                children: l,
              }),
            t,
          ],
        }),
      });
    },
    Ot = () => W.useContext(w2),
    NA = ({ currentPage: t }) => {
      const { t: e } = Ot();
      return h.jsx("div", {
        className: "breadcrumb-wrapper",
        children: h.jsxs("div", {
          className: "breadcrumb",
          children: [
            h.jsx(_t, {
              to: "/",
              className: "breadcrumb-home-title",
              children: e("ana_sehife"),
            }),
            h.jsx(d_, { className: "right-icon-breadcrumb" }),
            h.jsx("p", { className: "current-page-breadcrumb", children: t }),
          ],
        }),
      });
    };
  function AA(t) {
    return Fi({
      attr: {
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
      },
      child: [
        {
          tag: "path",
          attr: {
            fillRule: "evenodd",
            d: "M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z",
            clipRule: "evenodd",
          },
          child: [],
        },
      ],
    })(t);
  }
  const S2 = () => {
    const t = () => {
      window.scroll({ top: 1e3, left: 0, behavior: "smooth" });
    };
    return h.jsxs("div", {
      className: "get-down-button",
      onClick: t,
      children: [
        h.jsx("button", {
          type: "button",
          className: "down-button",
          children: h.jsx("div", {
            className: "icon-overlay",
            children: h.jsx(AA, { className: "down" }),
          }),
        }),
        h.jsx("span", { className: "bottom-title-btn", children: "Aşağı" }),
      ],
    });
  };
  var Zg = class {
      constructor() {
        ((this.listeners = new Set()),
          (this.subscribe = this.subscribe.bind(this)));
      }
      subscribe(t) {
        return (
          this.listeners.add(t),
          this.onSubscribe(),
          () => {
            (this.listeners.delete(t), this.onUnsubscribe());
          }
        );
      }
      hasListeners() {
        return this.listeners.size > 0;
      }
      onSubscribe() {}
      onUnsubscribe() {}
    },
    RA = {
      setTimeout: (t, e) => setTimeout(t, e),
      clearTimeout: (t) => clearTimeout(t),
      setInterval: (t, e) => setInterval(t, e),
      clearInterval: (t) => clearInterval(t),
    },
    Tc,
    rw,
    xE,
    LA =
      ((xE = class {
        constructor() {
          We(this, Tc, RA);
          We(this, rw, !1);
        }
        setTimeoutProvider(t) {
          Pe(this, Tc, t);
        }
        setTimeout(t, e) {
          return J(this, Tc).setTimeout(t, e);
        }
        clearTimeout(t) {
          J(this, Tc).clearTimeout(t);
        }
        setInterval(t, e) {
          return J(this, Tc).setInterval(t, e);
        }
        clearInterval(t) {
          J(this, Tc).clearInterval(t);
        }
      }),
      (Tc = new WeakMap()),
      (rw = new WeakMap()),
      xE),
    gf = new LA();
  function DA(t) {
    setTimeout(t, 0);
  }
  var Lf = typeof window > "u" || "Deno" in globalThis;
  function Bs() {}
  function kA(t, e) {
    return typeof t == "function" ? t(e) : t;
  }
  function v_(t) {
    return typeof t == "number" && t >= 0 && t !== 1 / 0;
  }
  function T2(t, e) {
    return Math.max(t + (e || 0) - Date.now(), 0);
  }
  function kc(t, e) {
    return typeof t == "function" ? t(e) : t;
  }
  function kr(t, e) {
    return typeof t == "function" ? t(e) : t;
  }
  function GS(t, e) {
    const {
      type: n = "all",
      exact: i,
      fetchStatus: a,
      predicate: l,
      queryKey: u,
      stale: d,
    } = t;
    if (u) {
      if (i) {
        if (e.queryHash !== yw(u, e.options)) return !1;
      } else if (!jg(e.queryKey, u)) return !1;
    }
    if (n !== "all") {
      const m = e.isActive();
      if ((n === "active" && !m) || (n === "inactive" && m)) return !1;
    }
    return !(
      (typeof d == "boolean" && e.isStale() !== d) ||
      (a && a !== e.state.fetchStatus) ||
      (l && !l(e))
    );
  }
  function VS(t, e) {
    const { exact: n, status: i, predicate: a, mutationKey: l } = t;
    if (l) {
      if (!e.options.mutationKey) return !1;
      if (n) {
        if (Og(e.options.mutationKey) !== Og(l)) return !1;
      } else if (!jg(e.options.mutationKey, l)) return !1;
    }
    return !((i && e.state.status !== i) || (a && !a(e)));
  }
  function yw(t, e) {
    return ((e == null ? void 0 : e.queryKeyHashFn) || Og)(t);
  }
  function Og(t) {
    return JSON.stringify(t, (e, n) =>
      b_(n)
        ? Object.keys(n)
            .sort()
            .reduce((i, a) => ((i[a] = n[a]), i), {})
        : n,
    );
  }
  function jg(t, e) {
    return t === e
      ? !0
      : typeof t != typeof e
        ? !1
        : t && e && typeof t == "object" && typeof e == "object"
          ? Object.keys(e).every((n) => jg(t[n], e[n]))
          : !1;
  }
  var zA = Object.prototype.hasOwnProperty;
  function E2(t, e) {
    if (t === e) return t;
    const n = WS(t) && WS(e);
    if (!n && !(b_(t) && b_(e))) return e;
    const a = (n ? t : Object.keys(t)).length,
      l = n ? e : Object.keys(e),
      u = l.length,
      d = n ? new Array(u) : {};
    let m = 0;
    for (let g = 0; g < u; g++) {
      const v = n ? g : l[g],
        y = t[v],
        w = e[v];
      if (y === w) {
        ((d[v] = y), (n ? g < a : zA.call(t, v)) && m++);
        continue;
      }
      if (
        y === null ||
        w === null ||
        typeof y != "object" ||
        typeof w != "object"
      ) {
        d[v] = w;
        continue;
      }
      const S = E2(y, w);
      ((d[v] = S), S === y && m++);
    }
    return a === u && m === a ? t : d;
  }
  function y_(t, e) {
    if (!e || Object.keys(t).length !== Object.keys(e).length) return !1;
    for (const n in t) if (t[n] !== e[n]) return !1;
    return !0;
  }
  function WS(t) {
    return Array.isArray(t) && t.length === Object.keys(t).length;
  }
  function b_(t) {
    if (!XS(t)) return !1;
    const e = t.constructor;
    if (e === void 0) return !0;
    const n = e.prototype;
    return !(
      !XS(n) ||
      !n.hasOwnProperty("isPrototypeOf") ||
      Object.getPrototypeOf(t) !== Object.prototype
    );
  }
  function XS(t) {
    return Object.prototype.toString.call(t) === "[object Object]";
  }
  function PA(t) {
    return new Promise((e) => {
      gf.setTimeout(e, t);
    });
  }
  function x_(t, e, n) {
    return typeof n.structuralSharing == "function"
      ? n.structuralSharing(t, e)
      : n.structuralSharing !== !1
        ? E2(t, e)
        : e;
  }
  function IA(t, e, n = 0) {
    const i = [...t, e];
    return n && i.length > n ? i.slice(1) : i;
  }
  function UA(t, e, n = 0) {
    const i = [e, ...t];
    return n && i.length > n ? i.slice(0, -1) : i;
  }
  var bw = Symbol();
  function C2(t, e) {
    return !t.queryFn && e != null && e.initialPromise
      ? () => e.initialPromise
      : !t.queryFn || t.queryFn === bw
        ? () => Promise.reject(new Error(`Missing queryFn: '${t.queryHash}'`))
        : t.queryFn;
  }
  function FA(t, e) {
    return typeof t == "function" ? t(...e) : !!t;
  }
  function BA(t, e, n) {
    let i = !1,
      a;
    return (
      Object.defineProperty(t, "signal", {
        enumerable: !0,
        get: () => (
          a ?? (a = e()),
          i ||
            ((i = !0),
            a.aborted ? n() : a.addEventListener("abort", n, { once: !0 })),
          a
        ),
      }),
      t
    );
  }
  var bf,
    Ec,
    zh,
    _E,
    HA =
      ((_E = class extends Zg {
        constructor() {
          super();
          We(this, bf);
          We(this, Ec);
          We(this, zh);
          Pe(this, zh, (e) => {
            if (!Lf && window.addEventListener) {
              const n = () => e();
              return (
                window.addEventListener("visibilitychange", n, !1),
                () => {
                  window.removeEventListener("visibilitychange", n);
                }
              );
            }
          });
        }
        onSubscribe() {
          J(this, Ec) || this.setEventListener(J(this, zh));
        }
        onUnsubscribe() {
          var e;
          this.hasListeners() ||
            ((e = J(this, Ec)) == null || e.call(this), Pe(this, Ec, void 0));
        }
        setEventListener(e) {
          var n;
          (Pe(this, zh, e),
            (n = J(this, Ec)) == null || n.call(this),
            Pe(
              this,
              Ec,
              e((i) => {
                typeof i == "boolean" ? this.setFocused(i) : this.onFocus();
              }),
            ));
        }
        setFocused(e) {
          J(this, bf) !== e && (Pe(this, bf, e), this.onFocus());
        }
        onFocus() {
          const e = this.isFocused();
          this.listeners.forEach((n) => {
            n(e);
          });
        }
        isFocused() {
          var e;
          return typeof J(this, bf) == "boolean"
            ? J(this, bf)
            : ((e = globalThis.document) == null
                ? void 0
                : e.visibilityState) !== "hidden";
        }
      }),
      (bf = new WeakMap()),
      (Ec = new WeakMap()),
      (zh = new WeakMap()),
      _E),
    xw = new HA();
  function __() {
    let t, e;
    const n = new Promise((a, l) => {
      ((t = a), (e = l));
    });
    ((n.status = "pending"), n.catch(() => {}));
    function i(a) {
      (Object.assign(n, a), delete n.resolve, delete n.reject);
    }
    return (
      (n.resolve = (a) => {
        (i({ status: "fulfilled", value: a }), t(a));
      }),
      (n.reject = (a) => {
        (i({ status: "rejected", reason: a }), e(a));
      }),
      n
    );
  }
  var YA = DA;
  function qA() {
    let t = [],
      e = 0,
      n = (d) => {
        d();
      },
      i = (d) => {
        d();
      },
      a = YA;
    const l = (d) => {
        e
          ? t.push(d)
          : a(() => {
              n(d);
            });
      },
      u = () => {
        const d = t;
        ((t = []),
          d.length &&
            a(() => {
              i(() => {
                d.forEach((m) => {
                  n(m);
                });
              });
            }));
      };
    return {
      batch: (d) => {
        let m;
        e++;
        try {
          m = d();
        } finally {
          (e--, e || u());
        }
        return m;
      },
      batchCalls:
        (d) =>
        (...m) => {
          l(() => {
            d(...m);
          });
        },
      schedule: l,
      setNotifyFunction: (d) => {
        n = d;
      },
      setBatchNotifyFunction: (d) => {
        i = d;
      },
      setScheduler: (d) => {
        a = d;
      },
    };
  }
  var bi = qA(),
    Ph,
    Cc,
    Ih,
    wE,
    $A =
      ((wE = class extends Zg {
        constructor() {
          super();
          We(this, Ph, !0);
          We(this, Cc);
          We(this, Ih);
          Pe(this, Ih, (e) => {
            if (!Lf && window.addEventListener) {
              const n = () => e(!0),
                i = () => e(!1);
              return (
                window.addEventListener("online", n, !1),
                window.addEventListener("offline", i, !1),
                () => {
                  (window.removeEventListener("online", n),
                    window.removeEventListener("offline", i));
                }
              );
            }
          });
        }
        onSubscribe() {
          J(this, Cc) || this.setEventListener(J(this, Ih));
        }
        onUnsubscribe() {
          var e;
          this.hasListeners() ||
            ((e = J(this, Cc)) == null || e.call(this), Pe(this, Cc, void 0));
        }
        setEventListener(e) {
          var n;
          (Pe(this, Ih, e),
            (n = J(this, Cc)) == null || n.call(this),
            Pe(this, Cc, e(this.setOnline.bind(this))));
        }
        setOnline(e) {
          J(this, Ph) !== e &&
            (Pe(this, Ph, e),
            this.listeners.forEach((i) => {
              i(e);
            }));
        }
        isOnline() {
          return J(this, Ph);
        }
      }),
      (Ph = new WeakMap()),
      (Cc = new WeakMap()),
      (Ih = new WeakMap()),
      wE),
    ab = new $A();
  function GA(t) {
    return Math.min(1e3 * 2 ** t, 3e4);
  }
  function O2(t) {
    return (t ?? "online") === "online" ? ab.isOnline() : !0;
  }
  var w_ = class extends Error {
    constructor(t) {
      (super("CancelledError"),
        (this.revert = t == null ? void 0 : t.revert),
        (this.silent = t == null ? void 0 : t.silent));
    }
  };
  function j2(t) {
    let e = !1,
      n = 0,
      i;
    const a = __(),
      l = () => a.status !== "pending",
      u = (E) => {
        var j;
        if (!l()) {
          const O = new w_(E);
          (w(O), (j = t.onCancel) == null || j.call(t, O));
        }
      },
      d = () => {
        e = !0;
      },
      m = () => {
        e = !1;
      },
      g = () =>
        xw.isFocused() &&
        (t.networkMode === "always" || ab.isOnline()) &&
        t.canRun(),
      v = () => O2(t.networkMode) && t.canRun(),
      y = (E) => {
        l() || (i == null || i(), a.resolve(E));
      },
      w = (E) => {
        l() || (i == null || i(), a.reject(E));
      },
      S = () =>
        new Promise((E) => {
          var j;
          ((i = (O) => {
            (l() || g()) && E(O);
          }),
            (j = t.onPause) == null || j.call(t));
        }).then(() => {
          var E;
          ((i = void 0), l() || (E = t.onContinue) == null || E.call(t));
        }),
      T = () => {
        if (l()) return;
        let E;
        const j = n === 0 ? t.initialPromise : void 0;
        try {
          E = j ?? t.fn();
        } catch (O) {
          E = Promise.reject(O);
        }
        Promise.resolve(E)
          .then(y)
          .catch((O) => {
            var G;
            if (l()) return;
            const M = t.retry ?? (Lf ? 0 : 3),
              N = t.retryDelay ?? GA,
              R = typeof N == "function" ? N(n, O) : N,
              P =
                M === !0 ||
                (typeof M == "number" && n < M) ||
                (typeof M == "function" && M(n, O));
            if (e || !P) {
              w(O);
              return;
            }
            (n++,
              (G = t.onFail) == null || G.call(t, n, O),
              PA(R)
                .then(() => (g() ? void 0 : S()))
                .then(() => {
                  e ? w(O) : T();
                }));
          });
      };
    return {
      promise: a,
      status: () => a.status,
      cancel: u,
      continue: () => (i == null || i(), a),
      cancelRetry: d,
      continueRetry: m,
      canStart: v,
      start: () => (v() ? T() : S().then(T), a),
    };
  }
  var xf,
    SE,
    M2 =
      ((SE = class {
        constructor() {
          We(this, xf);
        }
        destroy() {
          this.clearGcTimeout();
        }
        scheduleGc() {
          (this.clearGcTimeout(),
            v_(this.gcTime) &&
              Pe(
                this,
                xf,
                gf.setTimeout(() => {
                  this.optionalRemove();
                }, this.gcTime),
              ));
        }
        updateGcTime(t) {
          this.gcTime = Math.max(
            this.gcTime || 0,
            t ?? (Lf ? 1 / 0 : 300 * 1e3),
          );
        }
        clearGcTimeout() {
          J(this, xf) && (gf.clearTimeout(J(this, xf)), Pe(this, xf, void 0));
        }
      }),
      (xf = new WeakMap()),
      SE),
    _f,
    Uh,
    Dr,
    wf,
    ui,
    Ug,
    Sf,
    da,
    no,
    TE,
    VA =
      ((TE = class extends M2 {
        constructor(e) {
          super();
          We(this, da);
          We(this, _f);
          We(this, Uh);
          We(this, Dr);
          We(this, wf);
          We(this, ui);
          We(this, Ug);
          We(this, Sf);
          (Pe(this, Sf, !1),
            Pe(this, Ug, e.defaultOptions),
            this.setOptions(e.options),
            (this.observers = []),
            Pe(this, wf, e.client),
            Pe(this, Dr, J(this, wf).getQueryCache()),
            (this.queryKey = e.queryKey),
            (this.queryHash = e.queryHash),
            Pe(this, _f, ZS(this.options)),
            (this.state = e.state ?? J(this, _f)),
            this.scheduleGc());
        }
        get meta() {
          return this.options.meta;
        }
        get promise() {
          var e;
          return (e = J(this, ui)) == null ? void 0 : e.promise;
        }
        setOptions(e) {
          if (
            ((this.options = { ...J(this, Ug), ...e }),
            this.updateGcTime(this.options.gcTime),
            this.state && this.state.data === void 0)
          ) {
            const n = ZS(this.options);
            n.data !== void 0 &&
              (this.setState(QS(n.data, n.dataUpdatedAt)), Pe(this, _f, n));
          }
        }
        optionalRemove() {
          !this.observers.length &&
            this.state.fetchStatus === "idle" &&
            J(this, Dr).remove(this);
        }
        setData(e, n) {
          const i = x_(this.state.data, e, this.options);
          return (
            Mt(this, da, no).call(this, {
              data: i,
              type: "success",
              dataUpdatedAt: n == null ? void 0 : n.updatedAt,
              manual: n == null ? void 0 : n.manual,
            }),
            i
          );
        }
        setState(e, n) {
          Mt(this, da, no).call(this, {
            type: "setState",
            state: e,
            setStateOptions: n,
          });
        }
        cancel(e) {
          var i, a;
          const n = (i = J(this, ui)) == null ? void 0 : i.promise;
          return (
            (a = J(this, ui)) == null || a.cancel(e),
            n ? n.then(Bs).catch(Bs) : Promise.resolve()
          );
        }
        destroy() {
          (super.destroy(), this.cancel({ silent: !0 }));
        }
        reset() {
          (this.destroy(), this.setState(J(this, _f)));
        }
        isActive() {
          return this.observers.some((e) => kr(e.options.enabled, this) !== !1);
        }
        isDisabled() {
          return this.getObserversCount() > 0
            ? !this.isActive()
            : this.options.queryFn === bw ||
                this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
        }
        isStatic() {
          return this.getObserversCount() > 0
            ? this.observers.some(
                (e) => kc(e.options.staleTime, this) === "static",
              )
            : !1;
        }
        isStale() {
          return this.getObserversCount() > 0
            ? this.observers.some((e) => e.getCurrentResult().isStale)
            : this.state.data === void 0 || this.state.isInvalidated;
        }
        isStaleByTime(e = 0) {
          return this.state.data === void 0
            ? !0
            : e === "static"
              ? !1
              : this.state.isInvalidated
                ? !0
                : !T2(this.state.dataUpdatedAt, e);
        }
        onFocus() {
          var n;
          const e = this.observers.find((i) => i.shouldFetchOnWindowFocus());
          (e == null || e.refetch({ cancelRefetch: !1 }),
            (n = J(this, ui)) == null || n.continue());
        }
        onOnline() {
          var n;
          const e = this.observers.find((i) => i.shouldFetchOnReconnect());
          (e == null || e.refetch({ cancelRefetch: !1 }),
            (n = J(this, ui)) == null || n.continue());
        }
        addObserver(e) {
          this.observers.includes(e) ||
            (this.observers.push(e),
            this.clearGcTimeout(),
            J(this, Dr).notify({
              type: "observerAdded",
              query: this,
              observer: e,
            }));
        }
        removeObserver(e) {
          this.observers.includes(e) &&
            ((this.observers = this.observers.filter((n) => n !== e)),
            this.observers.length ||
              (J(this, ui) &&
                (J(this, Sf)
                  ? J(this, ui).cancel({ revert: !0 })
                  : J(this, ui).cancelRetry()),
              this.scheduleGc()),
            J(this, Dr).notify({
              type: "observerRemoved",
              query: this,
              observer: e,
            }));
        }
        getObserversCount() {
          return this.observers.length;
        }
        invalidate() {
          this.state.isInvalidated ||
            Mt(this, da, no).call(this, { type: "invalidate" });
        }
        async fetch(e, n) {
          var m, g, v, y, w, S, T, E, j, O, M, N;
          if (
            this.state.fetchStatus !== "idle" &&
            ((m = J(this, ui)) == null ? void 0 : m.status()) !== "rejected"
          ) {
            if (this.state.data !== void 0 && n != null && n.cancelRefetch)
              this.cancel({ silent: !0 });
            else if (J(this, ui))
              return (J(this, ui).continueRetry(), J(this, ui).promise);
          }
          if ((e && this.setOptions(e), !this.options.queryFn)) {
            const R = this.observers.find((P) => P.options.queryFn);
            R && this.setOptions(R.options);
          }
          const i = new AbortController(),
            a = (R) => {
              Object.defineProperty(R, "signal", {
                enumerable: !0,
                get: () => (Pe(this, Sf, !0), i.signal),
              });
            },
            l = () => {
              const R = C2(this.options, n),
                G = (() => {
                  const Y = {
                    client: J(this, wf),
                    queryKey: this.queryKey,
                    meta: this.meta,
                  };
                  return (a(Y), Y);
                })();
              return (
                Pe(this, Sf, !1),
                this.options.persister
                  ? this.options.persister(R, G, this)
                  : R(G)
              );
            },
            d = (() => {
              const R = {
                fetchOptions: n,
                options: this.options,
                queryKey: this.queryKey,
                client: J(this, wf),
                state: this.state,
                fetchFn: l,
              };
              return (a(R), R);
            })();
          ((g = this.options.behavior) == null || g.onFetch(d, this),
            Pe(this, Uh, this.state),
            (this.state.fetchStatus === "idle" ||
              this.state.fetchMeta !==
                ((v = d.fetchOptions) == null ? void 0 : v.meta)) &&
              Mt(this, da, no).call(this, {
                type: "fetch",
                meta: (y = d.fetchOptions) == null ? void 0 : y.meta,
              }),
            Pe(
              this,
              ui,
              j2({
                initialPromise: n == null ? void 0 : n.initialPromise,
                fn: d.fetchFn,
                onCancel: (R) => {
                  (R instanceof w_ &&
                    R.revert &&
                    this.setState({ ...J(this, Uh), fetchStatus: "idle" }),
                    i.abort());
                },
                onFail: (R, P) => {
                  Mt(this, da, no).call(this, {
                    type: "failed",
                    failureCount: R,
                    error: P,
                  });
                },
                onPause: () => {
                  Mt(this, da, no).call(this, { type: "pause" });
                },
                onContinue: () => {
                  Mt(this, da, no).call(this, { type: "continue" });
                },
                retry: d.options.retry,
                retryDelay: d.options.retryDelay,
                networkMode: d.options.networkMode,
                canRun: () => !0,
              }),
            ));
          try {
            const R = await J(this, ui).start();
            if (R === void 0)
              throw new Error(`${this.queryHash} data is undefined`);
            return (
              this.setData(R),
              (S = (w = J(this, Dr).config).onSuccess) == null ||
                S.call(w, R, this),
              (E = (T = J(this, Dr).config).onSettled) == null ||
                E.call(T, R, this.state.error, this),
              R
            );
          } catch (R) {
            if (R instanceof w_) {
              if (R.silent) return J(this, ui).promise;
              if (R.revert) {
                if (this.state.data === void 0) throw R;
                return this.state.data;
              }
            }
            throw (
              Mt(this, da, no).call(this, { type: "error", error: R }),
              (O = (j = J(this, Dr).config).onError) == null ||
                O.call(j, R, this),
              (N = (M = J(this, Dr).config).onSettled) == null ||
                N.call(M, this.state.data, R, this),
              R
            );
          } finally {
            this.scheduleGc();
          }
        }
      }),
      (_f = new WeakMap()),
      (Uh = new WeakMap()),
      (Dr = new WeakMap()),
      (wf = new WeakMap()),
      (ui = new WeakMap()),
      (Ug = new WeakMap()),
      (Sf = new WeakMap()),
      (da = new WeakSet()),
      (no = function (e) {
        const n = (i) => {
          switch (e.type) {
            case "failed":
              return {
                ...i,
                fetchFailureCount: e.failureCount,
                fetchFailureReason: e.error,
              };
            case "pause":
              return { ...i, fetchStatus: "paused" };
            case "continue":
              return { ...i, fetchStatus: "fetching" };
            case "fetch":
              return {
                ...i,
                ...N2(i.data, this.options),
                fetchMeta: e.meta ?? null,
              };
            case "success":
              const a = {
                ...i,
                ...QS(e.data, e.dataUpdatedAt),
                dataUpdateCount: i.dataUpdateCount + 1,
                ...(!e.manual && {
                  fetchStatus: "idle",
                  fetchFailureCount: 0,
                  fetchFailureReason: null,
                }),
              };
              return (Pe(this, Uh, e.manual ? a : void 0), a);
            case "error":
              const l = e.error;
              return {
                ...i,
                error: l,
                errorUpdateCount: i.errorUpdateCount + 1,
                errorUpdatedAt: Date.now(),
                fetchFailureCount: i.fetchFailureCount + 1,
                fetchFailureReason: l,
                fetchStatus: "idle",
                status: "error",
              };
            case "invalidate":
              return { ...i, isInvalidated: !0 };
            case "setState":
              return { ...i, ...e.state };
          }
        };
        ((this.state = n(this.state)),
          bi.batch(() => {
            (this.observers.forEach((i) => {
              i.onQueryUpdate();
            }),
              J(this, Dr).notify({ query: this, type: "updated", action: e }));
          }));
      }),
      TE);
  function N2(t, e) {
    return {
      fetchFailureCount: 0,
      fetchFailureReason: null,
      fetchStatus: O2(e.networkMode) ? "fetching" : "paused",
      ...(t === void 0 && { error: null, status: "pending" }),
    };
  }
  function QS(t, e) {
    return {
      data: t,
      dataUpdatedAt: e ?? Date.now(),
      error: null,
      isInvalidated: !1,
      status: "success",
    };
  }
  function ZS(t) {
    const e =
        typeof t.initialData == "function" ? t.initialData() : t.initialData,
      n = e !== void 0,
      i = n
        ? typeof t.initialDataUpdatedAt == "function"
          ? t.initialDataUpdatedAt()
          : t.initialDataUpdatedAt
        : 0;
    return {
      data: e,
      dataUpdateCount: 0,
      dataUpdatedAt: n ? (i ?? Date.now()) : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchFailureReason: null,
      fetchMeta: null,
      isInvalidated: !1,
      status: n ? "success" : "pending",
      fetchStatus: "idle",
    };
  }
  var Fs,
    Nt,
    Fg,
    ds,
    Tf,
    Fh,
    ao,
    Oc,
    Bg,
    Bh,
    Hh,
    Ef,
    Cf,
    jc,
    Yh,
    Kt,
    gg,
    S_,
    T_,
    E_,
    C_,
    O_,
    j_,
    M_,
    A2,
    EE,
    WA =
      ((EE = class extends Zg {
        constructor(e, n) {
          super();
          We(this, Kt);
          We(this, Fs);
          We(this, Nt);
          We(this, Fg);
          We(this, ds);
          We(this, Tf);
          We(this, Fh);
          We(this, ao);
          We(this, Oc);
          We(this, Bg);
          We(this, Bh);
          We(this, Hh);
          We(this, Ef);
          We(this, Cf);
          We(this, jc);
          We(this, Yh, new Set());
          ((this.options = n),
            Pe(this, Fs, e),
            Pe(this, Oc, null),
            Pe(this, ao, __()),
            this.bindMethods(),
            this.setOptions(n));
        }
        bindMethods() {
          this.refetch = this.refetch.bind(this);
        }
        onSubscribe() {
          this.listeners.size === 1 &&
            (J(this, Nt).addObserver(this),
            KS(J(this, Nt), this.options)
              ? Mt(this, Kt, gg).call(this)
              : this.updateResult(),
            Mt(this, Kt, C_).call(this));
        }
        onUnsubscribe() {
          this.hasListeners() || this.destroy();
        }
        shouldFetchOnReconnect() {
          return N_(J(this, Nt), this.options, this.options.refetchOnReconnect);
        }
        shouldFetchOnWindowFocus() {
          return N_(
            J(this, Nt),
            this.options,
            this.options.refetchOnWindowFocus,
          );
        }
        destroy() {
          ((this.listeners = new Set()),
            Mt(this, Kt, O_).call(this),
            Mt(this, Kt, j_).call(this),
            J(this, Nt).removeObserver(this));
        }
        setOptions(e) {
          const n = this.options,
            i = J(this, Nt);
          if (
            ((this.options = J(this, Fs).defaultQueryOptions(e)),
            this.options.enabled !== void 0 &&
              typeof this.options.enabled != "boolean" &&
              typeof this.options.enabled != "function" &&
              typeof kr(this.options.enabled, J(this, Nt)) != "boolean")
          )
            throw new Error(
              "Expected enabled to be a boolean or a callback that returns a boolean",
            );
          (Mt(this, Kt, M_).call(this),
            J(this, Nt).setOptions(this.options),
            n._defaulted &&
              !y_(this.options, n) &&
              J(this, Fs)
                .getQueryCache()
                .notify({
                  type: "observerOptionsUpdated",
                  query: J(this, Nt),
                  observer: this,
                }));
          const a = this.hasListeners();
          (a &&
            JS(J(this, Nt), i, this.options, n) &&
            Mt(this, Kt, gg).call(this),
            this.updateResult(),
            a &&
              (J(this, Nt) !== i ||
                kr(this.options.enabled, J(this, Nt)) !==
                  kr(n.enabled, J(this, Nt)) ||
                kc(this.options.staleTime, J(this, Nt)) !==
                  kc(n.staleTime, J(this, Nt))) &&
              Mt(this, Kt, S_).call(this));
          const l = Mt(this, Kt, T_).call(this);
          a &&
            (J(this, Nt) !== i ||
              kr(this.options.enabled, J(this, Nt)) !==
                kr(n.enabled, J(this, Nt)) ||
              l !== J(this, jc)) &&
            Mt(this, Kt, E_).call(this, l);
        }
        getOptimisticResult(e) {
          const n = J(this, Fs).getQueryCache().build(J(this, Fs), e),
            i = this.createResult(n, e);
          return (
            QA(this, i) &&
              (Pe(this, ds, i),
              Pe(this, Fh, this.options),
              Pe(this, Tf, J(this, Nt).state)),
            i
          );
        }
        getCurrentResult() {
          return J(this, ds);
        }
        trackResult(e, n) {
          return new Proxy(e, {
            get: (i, a) => (
              this.trackProp(a),
              n == null || n(a),
              a === "promise" &&
                (this.trackProp("data"),
                !this.options.experimental_prefetchInRender &&
                  J(this, ao).status === "pending" &&
                  J(this, ao).reject(
                    new Error(
                      "experimental_prefetchInRender feature flag is not enabled",
                    ),
                  )),
              Reflect.get(i, a)
            ),
          });
        }
        trackProp(e) {
          J(this, Yh).add(e);
        }
        getCurrentQuery() {
          return J(this, Nt);
        }
        refetch({ ...e } = {}) {
          return this.fetch({ ...e });
        }
        fetchOptimistic(e) {
          const n = J(this, Fs).defaultQueryOptions(e),
            i = J(this, Fs).getQueryCache().build(J(this, Fs), n);
          return i.fetch().then(() => this.createResult(i, n));
        }
        fetch(e) {
          return Mt(this, Kt, gg)
            .call(this, { ...e, cancelRefetch: e.cancelRefetch ?? !0 })
            .then(() => (this.updateResult(), J(this, ds)));
        }
        createResult(e, n) {
          var I;
          const i = J(this, Nt),
            a = this.options,
            l = J(this, ds),
            u = J(this, Tf),
            d = J(this, Fh),
            g = e !== i ? e.state : J(this, Fg),
            { state: v } = e;
          let y = { ...v },
            w = !1,
            S;
          if (n._optimisticResults) {
            const H = this.hasListeners(),
              X = !H && KS(e, n),
              fe = H && JS(e, i, n, a);
            ((X || fe) && (y = { ...y, ...N2(v.data, e.options) }),
              n._optimisticResults === "isRestoring" &&
                (y.fetchStatus = "idle"));
          }
          let { error: T, errorUpdatedAt: E, status: j } = y;
          S = y.data;
          let O = !1;
          if (n.placeholderData !== void 0 && S === void 0 && j === "pending") {
            let H;
            (l != null &&
            l.isPlaceholderData &&
            n.placeholderData === (d == null ? void 0 : d.placeholderData)
              ? ((H = l.data), (O = !0))
              : (H =
                  typeof n.placeholderData == "function"
                    ? n.placeholderData(
                        (I = J(this, Hh)) == null ? void 0 : I.state.data,
                        J(this, Hh),
                      )
                    : n.placeholderData),
              H !== void 0 &&
                ((j = "success"),
                (S = x_(l == null ? void 0 : l.data, H, n)),
                (w = !0)));
          }
          if (n.select && S !== void 0 && !O)
            if (
              l &&
              S === (u == null ? void 0 : u.data) &&
              n.select === J(this, Bg)
            )
              S = J(this, Bh);
            else
              try {
                (Pe(this, Bg, n.select),
                  (S = n.select(S)),
                  (S = x_(l == null ? void 0 : l.data, S, n)),
                  Pe(this, Bh, S),
                  Pe(this, Oc, null));
              } catch (H) {
                Pe(this, Oc, H);
              }
          J(this, Oc) &&
            ((T = J(this, Oc)),
            (S = J(this, Bh)),
            (E = Date.now()),
            (j = "error"));
          const M = y.fetchStatus === "fetching",
            N = j === "pending",
            R = j === "error",
            P = N && M,
            G = S !== void 0,
            B = {
              status: j,
              fetchStatus: y.fetchStatus,
              isPending: N,
              isSuccess: j === "success",
              isError: R,
              isInitialLoading: P,
              isLoading: P,
              data: S,
              dataUpdatedAt: y.dataUpdatedAt,
              error: T,
              errorUpdatedAt: E,
              failureCount: y.fetchFailureCount,
              failureReason: y.fetchFailureReason,
              errorUpdateCount: y.errorUpdateCount,
              isFetched: y.dataUpdateCount > 0 || y.errorUpdateCount > 0,
              isFetchedAfterMount:
                y.dataUpdateCount > g.dataUpdateCount ||
                y.errorUpdateCount > g.errorUpdateCount,
              isFetching: M,
              isRefetching: M && !N,
              isLoadingError: R && !G,
              isPaused: y.fetchStatus === "paused",
              isPlaceholderData: w,
              isRefetchError: R && G,
              isStale: _w(e, n),
              refetch: this.refetch,
              promise: J(this, ao),
              isEnabled: kr(n.enabled, e) !== !1,
            };
          if (this.options.experimental_prefetchInRender) {
            const H = (ve) => {
                B.status === "error"
                  ? ve.reject(B.error)
                  : B.data !== void 0 && ve.resolve(B.data);
              },
              X = () => {
                const ve = Pe(this, ao, (B.promise = __()));
                H(ve);
              },
              fe = J(this, ao);
            switch (fe.status) {
              case "pending":
                e.queryHash === i.queryHash && H(fe);
                break;
              case "fulfilled":
                (B.status === "error" || B.data !== fe.value) && X();
                break;
              case "rejected":
                (B.status !== "error" || B.error !== fe.reason) && X();
                break;
            }
          }
          return B;
        }
        updateResult() {
          const e = J(this, ds),
            n = this.createResult(J(this, Nt), this.options);
          if (
            (Pe(this, Tf, J(this, Nt).state),
            Pe(this, Fh, this.options),
            J(this, Tf).data !== void 0 && Pe(this, Hh, J(this, Nt)),
            y_(n, e))
          )
            return;
          Pe(this, ds, n);
          const i = () => {
            if (!e) return !0;
            const { notifyOnChangeProps: a } = this.options,
              l = typeof a == "function" ? a() : a;
            if (l === "all" || (!l && !J(this, Yh).size)) return !0;
            const u = new Set(l ?? J(this, Yh));
            return (
              this.options.throwOnError && u.add("error"),
              Object.keys(J(this, ds)).some((d) => {
                const m = d;
                return J(this, ds)[m] !== e[m] && u.has(m);
              })
            );
          };
          Mt(this, Kt, A2).call(this, { listeners: i() });
        }
        onQueryUpdate() {
          (this.updateResult(),
            this.hasListeners() && Mt(this, Kt, C_).call(this));
        }
      }),
      (Fs = new WeakMap()),
      (Nt = new WeakMap()),
      (Fg = new WeakMap()),
      (ds = new WeakMap()),
      (Tf = new WeakMap()),
      (Fh = new WeakMap()),
      (ao = new WeakMap()),
      (Oc = new WeakMap()),
      (Bg = new WeakMap()),
      (Bh = new WeakMap()),
      (Hh = new WeakMap()),
      (Ef = new WeakMap()),
      (Cf = new WeakMap()),
      (jc = new WeakMap()),
      (Yh = new WeakMap()),
      (Kt = new WeakSet()),
      (gg = function (e) {
        Mt(this, Kt, M_).call(this);
        let n = J(this, Nt).fetch(this.options, e);
        return ((e != null && e.throwOnError) || (n = n.catch(Bs)), n);
      }),
      (S_ = function () {
        Mt(this, Kt, O_).call(this);
        const e = kc(this.options.staleTime, J(this, Nt));
        if (Lf || J(this, ds).isStale || !v_(e)) return;
        const i = T2(J(this, ds).dataUpdatedAt, e) + 1;
        Pe(
          this,
          Ef,
          gf.setTimeout(() => {
            J(this, ds).isStale || this.updateResult();
          }, i),
        );
      }),
      (T_ = function () {
        return (
          (typeof this.options.refetchInterval == "function"
            ? this.options.refetchInterval(J(this, Nt))
            : this.options.refetchInterval) ?? !1
        );
      }),
      (E_ = function (e) {
        (Mt(this, Kt, j_).call(this),
          Pe(this, jc, e),
          !(
            Lf ||
            kr(this.options.enabled, J(this, Nt)) === !1 ||
            !v_(J(this, jc)) ||
            J(this, jc) === 0
          ) &&
            Pe(
              this,
              Cf,
              gf.setInterval(
                () => {
                  (this.options.refetchIntervalInBackground ||
                    xw.isFocused()) &&
                    Mt(this, Kt, gg).call(this);
                },
                J(this, jc),
              ),
            ));
      }),
      (C_ = function () {
        (Mt(this, Kt, S_).call(this),
          Mt(this, Kt, E_).call(this, Mt(this, Kt, T_).call(this)));
      }),
      (O_ = function () {
        J(this, Ef) && (gf.clearTimeout(J(this, Ef)), Pe(this, Ef, void 0));
      }),
      (j_ = function () {
        J(this, Cf) && (gf.clearInterval(J(this, Cf)), Pe(this, Cf, void 0));
      }),
      (M_ = function () {
        const e = J(this, Fs).getQueryCache().build(J(this, Fs), this.options);
        if (e === J(this, Nt)) return;
        const n = J(this, Nt);
        (Pe(this, Nt, e),
          Pe(this, Fg, e.state),
          this.hasListeners() &&
            (n == null || n.removeObserver(this), e.addObserver(this)));
      }),
      (A2 = function (e) {
        bi.batch(() => {
          (e.listeners &&
            this.listeners.forEach((n) => {
              n(J(this, ds));
            }),
            J(this, Fs)
              .getQueryCache()
              .notify({ query: J(this, Nt), type: "observerResultsUpdated" }));
        });
      }),
      EE);
  function XA(t, e) {
    return (
      kr(e.enabled, t) !== !1 &&
      t.state.data === void 0 &&
      !(t.state.status === "error" && e.retryOnMount === !1)
    );
  }
  function KS(t, e) {
    return XA(t, e) || (t.state.data !== void 0 && N_(t, e, e.refetchOnMount));
  }
  function N_(t, e, n) {
    if (kr(e.enabled, t) !== !1 && kc(e.staleTime, t) !== "static") {
      const i = typeof n == "function" ? n(t) : n;
      return i === "always" || (i !== !1 && _w(t, e));
    }
    return !1;
  }
  function JS(t, e, n, i) {
    return (
      (t !== e || kr(i.enabled, t) === !1) &&
      (!n.suspense || t.state.status !== "error") &&
      _w(t, n)
    );
  }
  function _w(t, e) {
    return kr(e.enabled, t) !== !1 && t.isStaleByTime(kc(e.staleTime, t));
  }
  function QA(t, e) {
    return !y_(t.getCurrentResult(), e);
  }
  function eT(t) {
    return {
      onFetch: (e, n) => {
        var v, y, w, S, T;
        const i = e.options,
          a =
            (w =
              (y = (v = e.fetchOptions) == null ? void 0 : v.meta) == null
                ? void 0
                : y.fetchMore) == null
              ? void 0
              : w.direction,
          l = ((S = e.state.data) == null ? void 0 : S.pages) || [],
          u = ((T = e.state.data) == null ? void 0 : T.pageParams) || [];
        let d = { pages: [], pageParams: [] },
          m = 0;
        const g = async () => {
          let E = !1;
          const j = (N) => {
              BA(
                N,
                () => e.signal,
                () => (E = !0),
              );
            },
            O = C2(e.options, e.fetchOptions),
            M = async (N, R, P) => {
              if (E) return Promise.reject();
              if (R == null && N.pages.length) return Promise.resolve(N);
              const Y = (() => {
                  const X = {
                    client: e.client,
                    queryKey: e.queryKey,
                    pageParam: R,
                    direction: P ? "backward" : "forward",
                    meta: e.options.meta,
                  };
                  return (j(X), X);
                })(),
                B = await O(Y),
                { maxPages: I } = e.options,
                H = P ? UA : IA;
              return {
                pages: H(N.pages, B, I),
                pageParams: H(N.pageParams, R, I),
              };
            };
          if (a && l.length) {
            const N = a === "backward",
              R = N ? ZA : tT,
              P = { pages: l, pageParams: u },
              G = R(i, P);
            d = await M(P, G, N);
          } else {
            const N = t ?? l.length;
            do {
              const R = m === 0 ? (u[0] ?? i.initialPageParam) : tT(i, d);
              if (m > 0 && R == null) break;
              ((d = await M(d, R)), m++);
            } while (m < N);
          }
          return d;
        };
        e.options.persister
          ? (e.fetchFn = () => {
              var E, j;
              return (j = (E = e.options).persister) == null
                ? void 0
                : j.call(
                    E,
                    g,
                    {
                      client: e.client,
                      queryKey: e.queryKey,
                      meta: e.options.meta,
                      signal: e.signal,
                    },
                    n,
                  );
            })
          : (e.fetchFn = g);
      },
    };
  }
  function tT(t, { pages: e, pageParams: n }) {
    const i = e.length - 1;
    return e.length > 0 ? t.getNextPageParam(e[i], e, n[i], n) : void 0;
  }
  function ZA(t, { pages: e, pageParams: n }) {
    var i;
    return e.length > 0
      ? (i = t.getPreviousPageParam) == null
        ? void 0
        : i.call(t, e[0], e, n[0], n)
      : void 0;
  }
  var Hg,
    ol,
    hs,
    Of,
    cl,
    wc,
    CE,
    KA =
      ((CE = class extends M2 {
        constructor(e) {
          super();
          We(this, cl);
          We(this, Hg);
          We(this, ol);
          We(this, hs);
          We(this, Of);
          (Pe(this, Hg, e.client),
            (this.mutationId = e.mutationId),
            Pe(this, hs, e.mutationCache),
            Pe(this, ol, []),
            (this.state = e.state || JA()),
            this.setOptions(e.options),
            this.scheduleGc());
        }
        setOptions(e) {
          ((this.options = e), this.updateGcTime(this.options.gcTime));
        }
        get meta() {
          return this.options.meta;
        }
        addObserver(e) {
          J(this, ol).includes(e) ||
            (J(this, ol).push(e),
            this.clearGcTimeout(),
            J(this, hs).notify({
              type: "observerAdded",
              mutation: this,
              observer: e,
            }));
        }
        removeObserver(e) {
          (Pe(
            this,
            ol,
            J(this, ol).filter((n) => n !== e),
          ),
            this.scheduleGc(),
            J(this, hs).notify({
              type: "observerRemoved",
              mutation: this,
              observer: e,
            }));
        }
        optionalRemove() {
          J(this, ol).length ||
            (this.state.status === "pending"
              ? this.scheduleGc()
              : J(this, hs).remove(this));
        }
        continue() {
          var e;
          return (
            ((e = J(this, Of)) == null ? void 0 : e.continue()) ??
            this.execute(this.state.variables)
          );
        }
        async execute(e) {
          var u, d, m, g, v, y, w, S, T, E, j, O, M, N, R, P, G, Y, B, I;
          const n = () => {
              Mt(this, cl, wc).call(this, { type: "continue" });
            },
            i = {
              client: J(this, Hg),
              meta: this.options.meta,
              mutationKey: this.options.mutationKey,
            };
          Pe(
            this,
            Of,
            j2({
              fn: () =>
                this.options.mutationFn
                  ? this.options.mutationFn(e, i)
                  : Promise.reject(new Error("No mutationFn found")),
              onFail: (H, X) => {
                Mt(this, cl, wc).call(this, {
                  type: "failed",
                  failureCount: H,
                  error: X,
                });
              },
              onPause: () => {
                Mt(this, cl, wc).call(this, { type: "pause" });
              },
              onContinue: n,
              retry: this.options.retry ?? 0,
              retryDelay: this.options.retryDelay,
              networkMode: this.options.networkMode,
              canRun: () => J(this, hs).canRun(this),
            }),
          );
          const a = this.state.status === "pending",
            l = !J(this, Of).canStart();
          try {
            if (a) n();
            else {
              (Mt(this, cl, wc).call(this, {
                type: "pending",
                variables: e,
                isPaused: l,
              }),
                await ((d = (u = J(this, hs).config).onMutate) == null
                  ? void 0
                  : d.call(u, e, this, i)));
              const X = await ((g = (m = this.options).onMutate) == null
                ? void 0
                : g.call(m, e, i));
              X !== this.state.context &&
                Mt(this, cl, wc).call(this, {
                  type: "pending",
                  context: X,
                  variables: e,
                  isPaused: l,
                });
            }
            const H = await J(this, Of).start();
            return (
              await ((y = (v = J(this, hs).config).onSuccess) == null
                ? void 0
                : y.call(v, H, e, this.state.context, this, i)),
              await ((S = (w = this.options).onSuccess) == null
                ? void 0
                : S.call(w, H, e, this.state.context, i)),
              await ((E = (T = J(this, hs).config).onSettled) == null
                ? void 0
                : E.call(
                    T,
                    H,
                    null,
                    this.state.variables,
                    this.state.context,
                    this,
                    i,
                  )),
              await ((O = (j = this.options).onSettled) == null
                ? void 0
                : O.call(j, H, null, e, this.state.context, i)),
              Mt(this, cl, wc).call(this, { type: "success", data: H }),
              H
            );
          } catch (H) {
            try {
              throw (
                await ((N = (M = J(this, hs).config).onError) == null
                  ? void 0
                  : N.call(M, H, e, this.state.context, this, i)),
                await ((P = (R = this.options).onError) == null
                  ? void 0
                  : P.call(R, H, e, this.state.context, i)),
                await ((Y = (G = J(this, hs).config).onSettled) == null
                  ? void 0
                  : Y.call(
                      G,
                      void 0,
                      H,
                      this.state.variables,
                      this.state.context,
                      this,
                      i,
                    )),
                await ((I = (B = this.options).onSettled) == null
                  ? void 0
                  : I.call(B, void 0, H, e, this.state.context, i)),
                H
              );
            } finally {
              Mt(this, cl, wc).call(this, { type: "error", error: H });
            }
          } finally {
            J(this, hs).runNext(this);
          }
        }
      }),
      (Hg = new WeakMap()),
      (ol = new WeakMap()),
      (hs = new WeakMap()),
      (Of = new WeakMap()),
      (cl = new WeakSet()),
      (wc = function (e) {
        const n = (i) => {
          switch (e.type) {
            case "failed":
              return {
                ...i,
                failureCount: e.failureCount,
                failureReason: e.error,
              };
            case "pause":
              return { ...i, isPaused: !0 };
            case "continue":
              return { ...i, isPaused: !1 };
            case "pending":
              return {
                ...i,
                context: e.context,
                data: void 0,
                failureCount: 0,
                failureReason: null,
                error: null,
                isPaused: e.isPaused,
                status: "pending",
                variables: e.variables,
                submittedAt: Date.now(),
              };
            case "success":
              return {
                ...i,
                data: e.data,
                failureCount: 0,
                failureReason: null,
                error: null,
                status: "success",
                isPaused: !1,
              };
            case "error":
              return {
                ...i,
                data: void 0,
                error: e.error,
                failureCount: i.failureCount + 1,
                failureReason: e.error,
                isPaused: !1,
                status: "error",
              };
          }
        };
        ((this.state = n(this.state)),
          bi.batch(() => {
            (J(this, ol).forEach((i) => {
              i.onMutationUpdate(e);
            }),
              J(this, hs).notify({
                mutation: this,
                type: "updated",
                action: e,
              }));
          }));
      }),
      CE);
  function JA() {
    return {
      context: void 0,
      data: void 0,
      error: null,
      failureCount: 0,
      failureReason: null,
      isPaused: !1,
      status: "idle",
      variables: void 0,
      submittedAt: 0,
    };
  }
  var lo,
    ha,
    Yg,
    OE,
    eR =
      ((OE = class extends Zg {
        constructor(e = {}) {
          super();
          We(this, lo);
          We(this, ha);
          We(this, Yg);
          ((this.config = e),
            Pe(this, lo, new Set()),
            Pe(this, ha, new Map()),
            Pe(this, Yg, 0));
        }
        build(e, n, i) {
          const a = new KA({
            client: e,
            mutationCache: this,
            mutationId: ++v0(this, Yg)._,
            options: e.defaultMutationOptions(n),
            state: i,
          });
          return (this.add(a), a);
        }
        add(e) {
          J(this, lo).add(e);
          const n = _0(e);
          if (typeof n == "string") {
            const i = J(this, ha).get(n);
            i ? i.push(e) : J(this, ha).set(n, [e]);
          }
          this.notify({ type: "added", mutation: e });
        }
        remove(e) {
          if (J(this, lo).delete(e)) {
            const n = _0(e);
            if (typeof n == "string") {
              const i = J(this, ha).get(n);
              if (i)
                if (i.length > 1) {
                  const a = i.indexOf(e);
                  a !== -1 && i.splice(a, 1);
                } else i[0] === e && J(this, ha).delete(n);
            }
          }
          this.notify({ type: "removed", mutation: e });
        }
        canRun(e) {
          const n = _0(e);
          if (typeof n == "string") {
            const i = J(this, ha).get(n),
              a =
                i == null
                  ? void 0
                  : i.find((l) => l.state.status === "pending");
            return !a || a === e;
          } else return !0;
        }
        runNext(e) {
          var i;
          const n = _0(e);
          if (typeof n == "string") {
            const a =
              (i = J(this, ha).get(n)) == null
                ? void 0
                : i.find((l) => l !== e && l.state.isPaused);
            return (a == null ? void 0 : a.continue()) ?? Promise.resolve();
          } else return Promise.resolve();
        }
        clear() {
          bi.batch(() => {
            (J(this, lo).forEach((e) => {
              this.notify({ type: "removed", mutation: e });
            }),
              J(this, lo).clear(),
              J(this, ha).clear());
          });
        }
        getAll() {
          return Array.from(J(this, lo));
        }
        find(e) {
          const n = { exact: !0, ...e };
          return this.getAll().find((i) => VS(n, i));
        }
        findAll(e = {}) {
          return this.getAll().filter((n) => VS(e, n));
        }
        notify(e) {
          bi.batch(() => {
            this.listeners.forEach((n) => {
              n(e);
            });
          });
        }
        resumePausedMutations() {
          const e = this.getAll().filter((n) => n.state.isPaused);
          return bi.batch(() =>
            Promise.all(e.map((n) => n.continue().catch(Bs))),
          );
        }
      }),
      (lo = new WeakMap()),
      (ha = new WeakMap()),
      (Yg = new WeakMap()),
      OE);
  function _0(t) {
    var e;
    return (e = t.options.scope) == null ? void 0 : e.id;
  }
  var ul,
    jE,
    tR =
      ((jE = class extends Zg {
        constructor(e = {}) {
          super();
          We(this, ul);
          ((this.config = e), Pe(this, ul, new Map()));
        }
        build(e, n, i) {
          const a = n.queryKey,
            l = n.queryHash ?? yw(a, n);
          let u = this.get(l);
          return (
            u ||
              ((u = new VA({
                client: e,
                queryKey: a,
                queryHash: l,
                options: e.defaultQueryOptions(n),
                state: i,
                defaultOptions: e.getQueryDefaults(a),
              })),
              this.add(u)),
            u
          );
        }
        add(e) {
          J(this, ul).has(e.queryHash) ||
            (J(this, ul).set(e.queryHash, e),
            this.notify({ type: "added", query: e }));
        }
        remove(e) {
          const n = J(this, ul).get(e.queryHash);
          n &&
            (e.destroy(),
            n === e && J(this, ul).delete(e.queryHash),
            this.notify({ type: "removed", query: e }));
        }
        clear() {
          bi.batch(() => {
            this.getAll().forEach((e) => {
              this.remove(e);
            });
          });
        }
        get(e) {
          return J(this, ul).get(e);
        }
        getAll() {
          return [...J(this, ul).values()];
        }
        find(e) {
          const n = { exact: !0, ...e };
          return this.getAll().find((i) => GS(n, i));
        }
        findAll(e = {}) {
          const n = this.getAll();
          return Object.keys(e).length > 0 ? n.filter((i) => GS(e, i)) : n;
        }
        notify(e) {
          bi.batch(() => {
            this.listeners.forEach((n) => {
              n(e);
            });
          });
        }
        onFocus() {
          bi.batch(() => {
            this.getAll().forEach((e) => {
              e.onFocus();
            });
          });
        }
        onOnline() {
          bi.batch(() => {
            this.getAll().forEach((e) => {
              e.onOnline();
            });
          });
        }
      }),
      (ul = new WeakMap()),
      jE),
    Fn,
    Mc,
    Nc,
    qh,
    $h,
    Ac,
    Gh,
    Vh,
    ME,
    nR =
      ((ME = class {
        constructor(t = {}) {
          We(this, Fn);
          We(this, Mc);
          We(this, Nc);
          We(this, qh);
          We(this, $h);
          We(this, Ac);
          We(this, Gh);
          We(this, Vh);
          (Pe(this, Fn, t.queryCache || new tR()),
            Pe(this, Mc, t.mutationCache || new eR()),
            Pe(this, Nc, t.defaultOptions || {}),
            Pe(this, qh, new Map()),
            Pe(this, $h, new Map()),
            Pe(this, Ac, 0));
        }
        mount() {
          (v0(this, Ac)._++,
            J(this, Ac) === 1 &&
              (Pe(
                this,
                Gh,
                xw.subscribe(async (t) => {
                  t &&
                    (await this.resumePausedMutations(), J(this, Fn).onFocus());
                }),
              ),
              Pe(
                this,
                Vh,
                ab.subscribe(async (t) => {
                  t &&
                    (await this.resumePausedMutations(),
                    J(this, Fn).onOnline());
                }),
              )));
        }
        unmount() {
          var t, e;
          (v0(this, Ac)._--,
            J(this, Ac) === 0 &&
              ((t = J(this, Gh)) == null || t.call(this),
              Pe(this, Gh, void 0),
              (e = J(this, Vh)) == null || e.call(this),
              Pe(this, Vh, void 0)));
        }
        isFetching(t) {
          return J(this, Fn).findAll({ ...t, fetchStatus: "fetching" }).length;
        }
        isMutating(t) {
          return J(this, Mc).findAll({ ...t, status: "pending" }).length;
        }
        getQueryData(t) {
          var n;
          const e = this.defaultQueryOptions({ queryKey: t });
          return (n = J(this, Fn).get(e.queryHash)) == null
            ? void 0
            : n.state.data;
        }
        ensureQueryData(t) {
          const e = this.defaultQueryOptions(t),
            n = J(this, Fn).build(this, e),
            i = n.state.data;
          return i === void 0
            ? this.fetchQuery(t)
            : (t.revalidateIfStale &&
                n.isStaleByTime(kc(e.staleTime, n)) &&
                this.prefetchQuery(e),
              Promise.resolve(i));
        }
        getQueriesData(t) {
          return J(this, Fn)
            .findAll(t)
            .map(({ queryKey: e, state: n }) => {
              const i = n.data;
              return [e, i];
            });
        }
        setQueryData(t, e, n) {
          const i = this.defaultQueryOptions({ queryKey: t }),
            a = J(this, Fn).get(i.queryHash),
            l = a == null ? void 0 : a.state.data,
            u = kA(e, l);
          if (u !== void 0)
            return J(this, Fn)
              .build(this, i)
              .setData(u, { ...n, manual: !0 });
        }
        setQueriesData(t, e, n) {
          return bi.batch(() =>
            J(this, Fn)
              .findAll(t)
              .map(({ queryKey: i }) => [i, this.setQueryData(i, e, n)]),
          );
        }
        getQueryState(t) {
          var n;
          const e = this.defaultQueryOptions({ queryKey: t });
          return (n = J(this, Fn).get(e.queryHash)) == null ? void 0 : n.state;
        }
        removeQueries(t) {
          const e = J(this, Fn);
          bi.batch(() => {
            e.findAll(t).forEach((n) => {
              e.remove(n);
            });
          });
        }
        resetQueries(t, e) {
          const n = J(this, Fn);
          return bi.batch(
            () => (
              n.findAll(t).forEach((i) => {
                i.reset();
              }),
              this.refetchQueries({ type: "active", ...t }, e)
            ),
          );
        }
        cancelQueries(t, e = {}) {
          const n = { revert: !0, ...e },
            i = bi.batch(() =>
              J(this, Fn)
                .findAll(t)
                .map((a) => a.cancel(n)),
            );
          return Promise.all(i).then(Bs).catch(Bs);
        }
        invalidateQueries(t, e = {}) {
          return bi.batch(
            () => (
              J(this, Fn)
                .findAll(t)
                .forEach((n) => {
                  n.invalidate();
                }),
              (t == null ? void 0 : t.refetchType) === "none"
                ? Promise.resolve()
                : this.refetchQueries(
                    {
                      ...t,
                      type:
                        (t == null ? void 0 : t.refetchType) ??
                        (t == null ? void 0 : t.type) ??
                        "active",
                    },
                    e,
                  )
            ),
          );
        }
        refetchQueries(t, e = {}) {
          const n = { ...e, cancelRefetch: e.cancelRefetch ?? !0 },
            i = bi.batch(() =>
              J(this, Fn)
                .findAll(t)
                .filter((a) => !a.isDisabled() && !a.isStatic())
                .map((a) => {
                  let l = a.fetch(void 0, n);
                  return (
                    n.throwOnError || (l = l.catch(Bs)),
                    a.state.fetchStatus === "paused" ? Promise.resolve() : l
                  );
                }),
            );
          return Promise.all(i).then(Bs);
        }
        fetchQuery(t) {
          const e = this.defaultQueryOptions(t);
          e.retry === void 0 && (e.retry = !1);
          const n = J(this, Fn).build(this, e);
          return n.isStaleByTime(kc(e.staleTime, n))
            ? n.fetch(e)
            : Promise.resolve(n.state.data);
        }
        prefetchQuery(t) {
          return this.fetchQuery(t).then(Bs).catch(Bs);
        }
        fetchInfiniteQuery(t) {
          return ((t.behavior = eT(t.pages)), this.fetchQuery(t));
        }
        prefetchInfiniteQuery(t) {
          return this.fetchInfiniteQuery(t).then(Bs).catch(Bs);
        }
        ensureInfiniteQueryData(t) {
          return ((t.behavior = eT(t.pages)), this.ensureQueryData(t));
        }
        resumePausedMutations() {
          return ab.isOnline()
            ? J(this, Mc).resumePausedMutations()
            : Promise.resolve();
        }
        getQueryCache() {
          return J(this, Fn);
        }
        getMutationCache() {
          return J(this, Mc);
        }
        getDefaultOptions() {
          return J(this, Nc);
        }
        setDefaultOptions(t) {
          Pe(this, Nc, t);
        }
        setQueryDefaults(t, e) {
          J(this, qh).set(Og(t), { queryKey: t, defaultOptions: e });
        }
        getQueryDefaults(t) {
          const e = [...J(this, qh).values()],
            n = {};
          return (
            e.forEach((i) => {
              jg(t, i.queryKey) && Object.assign(n, i.defaultOptions);
            }),
            n
          );
        }
        setMutationDefaults(t, e) {
          J(this, $h).set(Og(t), { mutationKey: t, defaultOptions: e });
        }
        getMutationDefaults(t) {
          const e = [...J(this, $h).values()],
            n = {};
          return (
            e.forEach((i) => {
              jg(t, i.mutationKey) && Object.assign(n, i.defaultOptions);
            }),
            n
          );
        }
        defaultQueryOptions(t) {
          if (t._defaulted) return t;
          const e = {
            ...J(this, Nc).queries,
            ...this.getQueryDefaults(t.queryKey),
            ...t,
            _defaulted: !0,
          };
          return (
            e.queryHash || (e.queryHash = yw(e.queryKey, e)),
            e.refetchOnReconnect === void 0 &&
              (e.refetchOnReconnect = e.networkMode !== "always"),
            e.throwOnError === void 0 && (e.throwOnError = !!e.suspense),
            !e.networkMode && e.persister && (e.networkMode = "offlineFirst"),
            e.queryFn === bw && (e.enabled = !1),
            e
          );
        }
        defaultMutationOptions(t) {
          return t != null && t._defaulted
            ? t
            : {
                ...J(this, Nc).mutations,
                ...((t == null ? void 0 : t.mutationKey) &&
                  this.getMutationDefaults(t.mutationKey)),
                ...t,
                _defaulted: !0,
              };
        }
        clear() {
          (J(this, Fn).clear(), J(this, Mc).clear());
        }
      }),
      (Fn = new WeakMap()),
      (Mc = new WeakMap()),
      (Nc = new WeakMap()),
      (qh = new WeakMap()),
      ($h = new WeakMap()),
      (Ac = new WeakMap()),
      (Gh = new WeakMap()),
      (Vh = new WeakMap()),
      ME),
    R2 = W.createContext(void 0),
    ww = (t) => {
      const e = W.useContext(R2);
      if (!e)
        throw new Error(
          "No QueryClient set, use QueryClientProvider to set one",
        );
      return e;
    },
    iR = ({ client: t, children: e }) => (
      W.useEffect(
        () => (
          t.mount(),
          () => {
            t.unmount();
          }
        ),
        [t],
      ),
      h.jsx(R2.Provider, { value: t, children: e })
    ),
    L2 = W.createContext(!1),
    sR = () => W.useContext(L2);
  L2.Provider;
  function rR() {
    let t = !1;
    return {
      clearReset: () => {
        t = !1;
      },
      reset: () => {
        t = !0;
      },
      isReset: () => t,
    };
  }
  var aR = W.createContext(rR()),
    lR = () => W.useContext(aR),
    oR = (t, e) => {
      (t.suspense || t.throwOnError || t.experimental_prefetchInRender) &&
        (e.isReset() || (t.retryOnMount = !1));
    },
    cR = (t) => {
      W.useEffect(() => {
        t.clearReset();
      }, [t]);
    },
    uR = ({
      result: t,
      errorResetBoundary: e,
      throwOnError: n,
      query: i,
      suspense: a,
    }) =>
      t.isError &&
      !e.isReset() &&
      !t.isFetching &&
      i &&
      ((a && t.data === void 0) || FA(n, [t.error, i])),
    fR = (t) => {
      if (t.suspense) {
        const n = (a) => (a === "static" ? a : Math.max(a ?? 1e3, 1e3)),
          i = t.staleTime;
        ((t.staleTime = typeof i == "function" ? (...a) => n(i(...a)) : n(i)),
          typeof t.gcTime == "number" && (t.gcTime = Math.max(t.gcTime, 1e3)));
      }
    },
    dR = (t, e) => t.isLoading && t.isFetching && !e,
    hR = (t, e) => (t == null ? void 0 : t.suspense) && e.isPending,
    nT = (t, e, n) =>
      e.fetchOptimistic(t).catch(() => {
        n.clearReset();
      });
  function pR(t, e, n) {
    var y, w, S, T, E;
    const i = sR(),
      a = lR(),
      l = ww(),
      u = l.defaultQueryOptions(t);
    ((w =
      (y = l.getDefaultOptions().queries) == null
        ? void 0
        : y._experimental_beforeQuery) == null || w.call(y, u),
      (u._optimisticResults = i ? "isRestoring" : "optimistic"),
      fR(u),
      oR(u, a),
      cR(a));
    const d = !l.getQueryCache().get(u.queryHash),
      [m] = W.useState(() => new e(l, u)),
      g = m.getOptimisticResult(u),
      v = !i && t.subscribed !== !1;
    if (
      (W.useSyncExternalStore(
        W.useCallback(
          (j) => {
            const O = v ? m.subscribe(bi.batchCalls(j)) : Bs;
            return (m.updateResult(), O);
          },
          [m, v],
        ),
        () => m.getCurrentResult(),
        () => m.getCurrentResult(),
      ),
      W.useEffect(() => {
        m.setOptions(u);
      }, [u, m]),
      hR(u, g))
    )
      throw nT(u, m, a);
    if (
      uR({
        result: g,
        errorResetBoundary: a,
        throwOnError: u.throwOnError,
        query: l.getQueryCache().get(u.queryHash),
        suspense: u.suspense,
      })
    )
      throw g.error;
    if (
      ((T =
        (S = l.getDefaultOptions().queries) == null
          ? void 0
          : S._experimental_afterQuery) == null || T.call(S, u, g),
      u.experimental_prefetchInRender && !Lf && dR(g, i))
    ) {
      const j = d
        ? nT(u, m, a)
        : (E = l.getQueryCache().get(u.queryHash)) == null
          ? void 0
          : E.promise;
      j == null ||
        j.catch(Bs).finally(() => {
          m.updateResult();
        });
    }
    return u.notifyOnChangeProps ? g : m.trackResult(g);
  }
  function D2(t, e) {
    return pR(t, WA);
  }
  var xx = { exports: {} },
    _x = {};
  /**
   * @license React
   * use-sync-external-store-with-selector.production.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var iT;
  function mR() {
    if (iT) return _x;
    iT = 1;
    var t = qg();
    function e(m, g) {
      return (m === g && (m !== 0 || 1 / m === 1 / g)) || (m !== m && g !== g);
    }
    var n = typeof Object.is == "function" ? Object.is : e,
      i = t.useSyncExternalStore,
      a = t.useRef,
      l = t.useEffect,
      u = t.useMemo,
      d = t.useDebugValue;
    return (
      (_x.useSyncExternalStoreWithSelector = function (m, g, v, y, w) {
        var S = a(null);
        if (S.current === null) {
          var T = { hasValue: !1, value: null };
          S.current = T;
        } else T = S.current;
        S = u(
          function () {
            function j(P) {
              if (!O) {
                if (
                  ((O = !0), (M = P), (P = y(P)), w !== void 0 && T.hasValue)
                ) {
                  var G = T.value;
                  if (w(G, P)) return (N = G);
                }
                return (N = P);
              }
              if (((G = N), n(M, P))) return G;
              var Y = y(P);
              return w !== void 0 && w(G, Y)
                ? ((M = P), G)
                : ((M = P), (N = Y));
            }
            var O = !1,
              M,
              N,
              R = v === void 0 ? null : v;
            return [
              function () {
                return j(g());
              },
              R === null
                ? void 0
                : function () {
                    return j(R());
                  },
            ];
          },
          [g, v, y, w],
        );
        var E = i(m, S[0], S[1]);
        return (
          l(
            function () {
              ((T.hasValue = !0), (T.value = E));
            },
            [E],
          ),
          d(E),
          E
        );
      }),
      _x
    );
  }
  var sT;
  function gR() {
    return (sT || ((sT = 1), (xx.exports = mR())), xx.exports);
  }
  var vR = gR();
  function yR(t) {
    t();
  }
  function bR() {
    let t = null,
      e = null;
    return {
      clear() {
        ((t = null), (e = null));
      },
      notify() {
        yR(() => {
          let n = t;
          for (; n; ) (n.callback(), (n = n.next));
        });
      },
      get() {
        const n = [];
        let i = t;
        for (; i; ) (n.push(i), (i = i.next));
        return n;
      },
      subscribe(n) {
        let i = !0;
        const a = (e = { callback: n, next: null, prev: e });
        return (
          a.prev ? (a.prev.next = a) : (t = a),
          function () {
            !i ||
              t === null ||
              ((i = !1),
              a.next ? (a.next.prev = a.prev) : (e = a.prev),
              a.prev ? (a.prev.next = a.next) : (t = a.next));
          }
        );
      },
    };
  }
  var rT = { notify() {}, get: () => [] };
  function xR(t, e) {
    let n,
      i = rT,
      a = 0,
      l = !1;
    function u(E) {
      v();
      const j = i.subscribe(E);
      let O = !1;
      return () => {
        O || ((O = !0), j(), y());
      };
    }
    function d() {
      i.notify();
    }
    function m() {
      T.onStateChange && T.onStateChange();
    }
    function g() {
      return l;
    }
    function v() {
      (a++, n || ((n = t.subscribe(m)), (i = bR())));
    }
    function y() {
      (a--, n && a === 0 && (n(), (n = void 0), i.clear(), (i = rT)));
    }
    function w() {
      l || ((l = !0), v());
    }
    function S() {
      l && ((l = !1), y());
    }
    const T = {
      addNestedSub: u,
      notifyNestedSubs: d,
      handleChangeWrapper: m,
      isSubscribed: g,
      trySubscribe: w,
      tryUnsubscribe: S,
      getListeners: () => i,
    };
    return T;
  }
  var _R = () =>
      typeof window < "u" &&
      typeof window.document < "u" &&
      typeof window.document.createElement < "u",
    wR = _R(),
    SR = () => typeof navigator < "u" && navigator.product === "ReactNative",
    TR = SR(),
    ER = () => (wR || TR ? W.useLayoutEffect : W.useEffect),
    CR = ER(),
    wx = Symbol.for("react-redux-context"),
    Sx = typeof globalThis < "u" ? globalThis : {};
  function OR() {
    if (!W.createContext) return {};
    const t = Sx[wx] ?? (Sx[wx] = new Map());
    let e = t.get(W.createContext);
    return (e || ((e = W.createContext(null)), t.set(W.createContext, e)), e);
  }
  var Uc = OR();
  function jR(t) {
    const { children: e, context: n, serverState: i, store: a } = t,
      l = W.useMemo(() => {
        const m = xR(a);
        return {
          store: a,
          subscription: m,
          getServerState: i ? () => i : void 0,
        };
      }, [a, i]),
      u = W.useMemo(() => a.getState(), [a]);
    CR(() => {
      const { subscription: m } = l;
      return (
        (m.onStateChange = m.notifyNestedSubs),
        m.trySubscribe(),
        u !== a.getState() && m.notifyNestedSubs(),
        () => {
          (m.tryUnsubscribe(), (m.onStateChange = void 0));
        }
      );
    }, [l, u]);
    const d = n || Uc;
    return W.createElement(d.Provider, { value: l }, e);
  }
  var MR = jR;
  function Sw(t = Uc) {
    return function () {
      return W.useContext(t);
    };
  }
  var k2 = Sw();
  function z2(t = Uc) {
    const e = t === Uc ? k2 : Sw(t),
      n = () => {
        const { store: i } = e();
        return i;
      };
    return (Object.assign(n, { withTypes: () => n }), n);
  }
  var NR = z2();
  function AR(t = Uc) {
    const e = t === Uc ? NR : z2(t),
      n = () => e().dispatch;
    return (Object.assign(n, { withTypes: () => n }), n);
  }
  var _a = AR(),
    RR = (t, e) => t === e;
  function LR(t = Uc) {
    const e = t === Uc ? k2 : Sw(t),
      n = (i, a = {}) => {
        const { equalityFn: l = RR } =
            typeof a == "function" ? { equalityFn: a } : a,
          u = e(),
          { store: d, subscription: m, getServerState: g } = u;
        W.useRef(!0);
        const v = W.useCallback(
            {
              [i.name](w) {
                return i(w);
              },
            }[i.name],
            [i],
          ),
          y = vR.useSyncExternalStoreWithSelector(
            m.addNestedSub,
            d.getState,
            g || d.getState,
            v,
            l,
          );
        return (W.useDebugValue(y), y);
      };
    return (Object.assign(n, { withTypes: () => n }), n);
  }
  var nt = LR();
  function P2(t) {
    var e,
      n,
      i = "";
    if (typeof t == "string" || typeof t == "number") i += t;
    else if (typeof t == "object")
      if (Array.isArray(t)) {
        var a = t.length;
        for (e = 0; e < a; e++)
          t[e] && (n = P2(t[e])) && (i && (i += " "), (i += n));
      } else for (n in t) t[n] && (i && (i += " "), (i += n));
    return i;
  }
  function Mf() {
    for (var t, e, n = 0, i = "", a = arguments.length; n < a; n++)
      (t = arguments[n]) && (e = P2(t)) && (i && (i += " "), (i += e));
    return i;
  }
  function DR(t) {
    if (typeof document > "u") return;
    let e = document.head || document.getElementsByTagName("head")[0],
      n = document.createElement("style");
    ((n.type = "text/css"),
      e.firstChild ? e.insertBefore(n, e.firstChild) : e.appendChild(n),
      n.styleSheet
        ? (n.styleSheet.cssText = t)
        : n.appendChild(document.createTextNode(t)));
  }
  DR(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
  var Kg = (t) => typeof t == "number" && !isNaN(t),
    Df = (t) => typeof t == "string",
    vo = (t) => typeof t == "function",
    kR = (t) => Df(t) || Kg(t),
    A_ = (t) => (Df(t) || vo(t) ? t : null),
    zR = (t, e) => (t === !1 || (Kg(t) && t > 0) ? t : e),
    R_ = (t) => W.isValidElement(t) || Df(t) || vo(t) || Kg(t);
  function PR(t, e, n = 300) {
    let { scrollHeight: i, style: a } = t;
    requestAnimationFrame(() => {
      ((a.minHeight = "initial"),
        (a.height = i + "px"),
        (a.transition = `all ${n}ms`),
        requestAnimationFrame(() => {
          ((a.height = "0"),
            (a.padding = "0"),
            (a.margin = "0"),
            setTimeout(e, n));
        }));
    });
  }
  function IR({
    enter: t,
    exit: e,
    appendPosition: n = !1,
    collapse: i = !0,
    collapseDuration: a = 300,
  }) {
    return function ({
      children: l,
      position: u,
      preventExitTransition: d,
      done: m,
      nodeRef: g,
      isIn: v,
      playToast: y,
    }) {
      let w = n ? `${t}--${u}` : t,
        S = n ? `${e}--${u}` : e,
        T = W.useRef(0);
      return (
        W.useLayoutEffect(() => {
          let E = g.current,
            j = w.split(" "),
            O = (M) => {
              M.target === g.current &&
                (y(),
                E.removeEventListener("animationend", O),
                E.removeEventListener("animationcancel", O),
                T.current === 0 &&
                  M.type !== "animationcancel" &&
                  E.classList.remove(...j));
            };
          (E.classList.add(...j),
            E.addEventListener("animationend", O),
            E.addEventListener("animationcancel", O));
        }, []),
        W.useEffect(() => {
          let E = g.current,
            j = () => {
              (E.removeEventListener("animationend", j), i ? PR(E, m, a) : m());
            };
          v ||
            (d
              ? j()
              : ((T.current = 1),
                (E.className += ` ${S}`),
                E.addEventListener("animationend", j)));
        }, [v]),
        U.createElement(U.Fragment, null, l)
      );
    };
  }
  function aT(t, e) {
    return {
      content: I2(t.content, t.props),
      containerId: t.props.containerId,
      id: t.props.toastId,
      theme: t.props.theme,
      type: t.props.type,
      data: t.props.data || {},
      isLoading: t.props.isLoading,
      icon: t.props.icon,
      reason: t.removalReason,
      status: e,
    };
  }
  function I2(t, e, n = !1) {
    return W.isValidElement(t) && !Df(t.type)
      ? W.cloneElement(t, {
          closeToast: e.closeToast,
          toastProps: e,
          data: e.data,
          isPaused: n,
        })
      : vo(t)
        ? t({
            closeToast: e.closeToast,
            toastProps: e,
            data: e.data,
            isPaused: n,
          })
        : t;
  }
  function UR({ closeToast: t, theme: e, ariaLabel: n = "close" }) {
    return U.createElement(
      "button",
      {
        className: `Toastify__close-button Toastify__close-button--${e}`,
        type: "button",
        onClick: (i) => {
          (i.stopPropagation(), t(!0));
        },
        "aria-label": n,
      },
      U.createElement(
        "svg",
        { "aria-hidden": "true", viewBox: "0 0 14 16" },
        U.createElement("path", {
          fillRule: "evenodd",
          d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z",
        }),
      ),
    );
  }
  function FR({
    delay: t,
    isRunning: e,
    closeToast: n,
    type: i = "default",
    hide: a,
    className: l,
    controlledProgress: u,
    progress: d,
    rtl: m,
    isIn: g,
    theme: v,
  }) {
    let y = a || (u && d === 0),
      w = {
        animationDuration: `${t}ms`,
        animationPlayState: e ? "running" : "paused",
      };
    u && (w.transform = `scaleX(${d})`);
    let S = Mf(
        "Toastify__progress-bar",
        u
          ? "Toastify__progress-bar--controlled"
          : "Toastify__progress-bar--animated",
        `Toastify__progress-bar-theme--${v}`,
        `Toastify__progress-bar--${i}`,
        { "Toastify__progress-bar--rtl": m },
      ),
      T = vo(l) ? l({ rtl: m, type: i, defaultClassName: S }) : Mf(S, l),
      E = {
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]:
          u && d < 1
            ? null
            : () => {
                g && n();
              },
      };
    return U.createElement(
      "div",
      { className: "Toastify__progress-bar--wrp", "data-hidden": y },
      U.createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${v} Toastify__progress-bar--${i}`,
      }),
      U.createElement("div", {
        role: "progressbar",
        "aria-hidden": y ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: w,
        ...E,
      }),
    );
  }
  var BR = 1,
    U2 = () => `${BR++}`;
  function HR(t, e, n) {
    let i = 1,
      a = 0,
      l = [],
      u = [],
      d = e,
      m = new Map(),
      g = new Set(),
      v = (M) => (g.add(M), () => g.delete(M)),
      y = () => {
        ((u = Array.from(m.values())), g.forEach((M) => M()));
      },
      w = ({ containerId: M, toastId: N, updateId: R }) => {
        let P = M ? M !== t : t !== 1,
          G = m.has(N) && R == null;
        return P || G;
      },
      S = (M, N) => {
        m.forEach((R) => {
          var P;
          (N == null || N === R.props.toastId) &&
            ((P = R.toggle) == null || P.call(R, M));
        });
      },
      T = (M) => {
        var N, R;
        ((R = (N = M.props) == null ? void 0 : N.onClose) == null ||
          R.call(N, M.removalReason),
          (M.isActive = !1));
      },
      E = (M) => {
        if (M == null) m.forEach(T);
        else {
          let N = m.get(M);
          N && T(N);
        }
        y();
      },
      j = () => {
        ((a -= l.length), (l = []));
      },
      O = (M) => {
        var N, R;
        let { toastId: P, updateId: G } = M.props,
          Y = G == null;
        (M.staleId && m.delete(M.staleId),
          (M.isActive = !0),
          m.set(P, M),
          y(),
          n(aT(M, Y ? "added" : "updated")),
          Y && ((R = (N = M.props).onOpen) == null || R.call(N)));
      };
    return {
      id: t,
      props: d,
      observe: v,
      toggle: S,
      removeToast: E,
      toasts: m,
      clearQueue: j,
      buildToast: (M, N) => {
        if (w(N)) return;
        let { toastId: R, updateId: P, data: G, staleId: Y, delay: B } = N,
          I = P == null;
        I && a++;
        let H = {
          ...d,
          style: d.toastStyle,
          key: i++,
          ...Object.fromEntries(
            Object.entries(N).filter(([fe, ve]) => ve != null),
          ),
          toastId: R,
          updateId: P,
          data: G,
          isIn: !1,
          className: A_(N.className || d.toastClassName),
          progressClassName: A_(N.progressClassName || d.progressClassName),
          autoClose: N.isLoading ? !1 : zR(N.autoClose, d.autoClose),
          closeToast(fe) {
            ((m.get(R).removalReason = fe), E(R));
          },
          deleteToast() {
            let fe = m.get(R);
            if (fe != null) {
              if (
                (n(aT(fe, "removed")),
                m.delete(R),
                a--,
                a < 0 && (a = 0),
                l.length > 0)
              ) {
                O(l.shift());
                return;
              }
              y();
            }
          },
        };
        ((H.closeButton = d.closeButton),
          N.closeButton === !1 || R_(N.closeButton)
            ? (H.closeButton = N.closeButton)
            : N.closeButton === !0 &&
              (H.closeButton = R_(d.closeButton) ? d.closeButton : !0));
        let X = { content: M, props: H, staleId: Y };
        d.limit && d.limit > 0 && a > d.limit && I
          ? l.push(X)
          : Kg(B)
            ? setTimeout(() => {
                O(X);
              }, B)
            : O(X);
      },
      setProps(M) {
        d = M;
      },
      setToggle: (M, N) => {
        let R = m.get(M);
        R && (R.toggle = N);
      },
      isToastActive: (M) => {
        var N;
        return (N = m.get(M)) == null ? void 0 : N.isActive;
      },
      getSnapshot: () => u,
    };
  }
  var ps = new Map(),
    Mg = [],
    L_ = new Set(),
    YR = (t) => L_.forEach((e) => e(t)),
    F2 = () => ps.size > 0;
  function qR() {
    (Mg.forEach((t) => H2(t.content, t.options)), (Mg = []));
  }
  var $R = (t, { containerId: e }) => {
    var n;
    return (n = ps.get(e || 1)) == null ? void 0 : n.toasts.get(t);
  };
  function B2(t, e) {
    var n;
    if (e) return !!((n = ps.get(e)) != null && n.isToastActive(t));
    let i = !1;
    return (
      ps.forEach((a) => {
        a.isToastActive(t) && (i = !0);
      }),
      i
    );
  }
  function GR(t) {
    if (!F2()) {
      Mg = Mg.filter((e) => t != null && e.options.toastId !== t);
      return;
    }
    if (t == null || kR(t))
      ps.forEach((e) => {
        e.removeToast(t);
      });
    else if (t && ("containerId" in t || "id" in t)) {
      let e = ps.get(t.containerId);
      e
        ? e.removeToast(t.id)
        : ps.forEach((n) => {
            n.removeToast(t.id);
          });
    }
  }
  var VR = (t = {}) => {
    ps.forEach((e) => {
      e.props.limit &&
        (!t.containerId || e.id === t.containerId) &&
        e.clearQueue();
    });
  };
  function H2(t, e) {
    R_(t) &&
      (F2() || Mg.push({ content: t, options: e }),
      ps.forEach((n) => {
        n.buildToast(t, e);
      }));
  }
  function WR(t) {
    var e;
    (e = ps.get(t.containerId || 1)) == null || e.setToggle(t.id, t.fn);
  }
  function Y2(t, e) {
    ps.forEach((n) => {
      (e == null ||
        !(e != null && e.containerId) ||
        (e == null ? void 0 : e.containerId) === n.id) &&
        n.toggle(t, e == null ? void 0 : e.id);
    });
  }
  function XR(t) {
    let e = t.containerId || 1;
    return {
      subscribe(n) {
        let i = HR(e, t, YR);
        ps.set(e, i);
        let a = i.observe(n);
        return (
          qR(),
          () => {
            (a(), ps.delete(e));
          }
        );
      },
      setProps(n) {
        var i;
        (i = ps.get(e)) == null || i.setProps(n);
      },
      getSnapshot() {
        var n;
        return (n = ps.get(e)) == null ? void 0 : n.getSnapshot();
      },
    };
  }
  function QR(t) {
    return (
      L_.add(t),
      () => {
        L_.delete(t);
      }
    );
  }
  function ZR(t) {
    return t && (Df(t.toastId) || Kg(t.toastId)) ? t.toastId : U2();
  }
  function Jg(t, e) {
    return (H2(t, e), e.toastId);
  }
  function Pb(t, e) {
    return { ...e, type: (e && e.type) || t, toastId: ZR(e) };
  }
  function Ib(t) {
    return (e, n) => Jg(e, Pb(t, n));
  }
  function xt(t, e) {
    return Jg(t, Pb("default", e));
  }
  xt.loading = (t, e) =>
    Jg(
      t,
      Pb("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e,
      }),
    );
  function KR(t, { pending: e, error: n, success: i }, a) {
    let l;
    e && (l = Df(e) ? xt.loading(e, a) : xt.loading(e.render, { ...a, ...e }));
    let u = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null,
      },
      d = (g, v, y) => {
        if (v == null) {
          xt.dismiss(l);
          return;
        }
        let w = { type: g, ...u, ...a, data: y },
          S = Df(v) ? { render: v } : v;
        return (
          l ? xt.update(l, { ...w, ...S }) : xt(S.render, { ...w, ...S }),
          y
        );
      },
      m = vo(t) ? t() : t;
    return (
      m.then((g) => d("success", i, g)).catch((g) => d("error", n, g)),
      m
    );
  }
  xt.promise = KR;
  xt.success = Ib("success");
  xt.info = Ib("info");
  xt.error = Ib("error");
  xt.warning = Ib("warning");
  xt.warn = xt.warning;
  xt.dark = (t, e) => Jg(t, Pb("default", { theme: "dark", ...e }));
  function JR(t) {
    GR(t);
  }
  xt.dismiss = JR;
  xt.clearWaitingQueue = VR;
  xt.isActive = B2;
  xt.update = (t, e = {}) => {
    let n = $R(t, e);
    if (n) {
      let { props: i, content: a } = n,
        l = { delay: 100, ...i, ...e, toastId: e.toastId || t, updateId: U2() };
      l.toastId !== t && (l.staleId = t);
      let u = l.render || a;
      (delete l.render, Jg(u, l));
    }
  };
  xt.done = (t) => {
    xt.update(t, { progress: 1 });
  };
  xt.onChange = QR;
  xt.play = (t) => Y2(!0, t);
  xt.pause = (t) => Y2(!1, t);
  function eL(t) {
    var e;
    let { subscribe: n, getSnapshot: i, setProps: a } = W.useRef(XR(t)).current;
    a(t);
    let l = (e = W.useSyncExternalStore(n, i, i)) == null ? void 0 : e.slice();
    function u(d) {
      if (!l) return [];
      let m = new Map();
      return (
        t.newestOnTop && l.reverse(),
        l.forEach((g) => {
          let { position: v } = g.props;
          (m.has(v) || m.set(v, []), m.get(v).push(g));
        }),
        Array.from(m, (g) => d(g[0], g[1]))
      );
    }
    return {
      getToastToRender: u,
      isToastActive: B2,
      count: l == null ? void 0 : l.length,
    };
  }
  function tL(t) {
    let [e, n] = W.useState(!1),
      [i, a] = W.useState(!1),
      l = W.useRef(null),
      u = W.useRef({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1,
      }).current,
      {
        autoClose: d,
        pauseOnHover: m,
        closeToast: g,
        onClick: v,
        closeOnClick: y,
      } = t;
    (WR({ id: t.toastId, containerId: t.containerId, fn: n }),
      W.useEffect(() => {
        if (t.pauseOnFocusLoss)
          return (
            w(),
            () => {
              S();
            }
          );
      }, [t.pauseOnFocusLoss]));
    function w() {
      (document.hasFocus() || O(),
        window.addEventListener("focus", j),
        window.addEventListener("blur", O));
    }
    function S() {
      (window.removeEventListener("focus", j),
        window.removeEventListener("blur", O));
    }
    function T(Y) {
      if (t.draggable === !0 || t.draggable === Y.pointerType) {
        M();
        let B = l.current;
        ((u.canCloseOnClick = !0),
          (u.canDrag = !0),
          (B.style.transition = "none"),
          t.draggableDirection === "x"
            ? ((u.start = Y.clientX),
              (u.removalDistance = B.offsetWidth * (t.draggablePercent / 100)))
            : ((u.start = Y.clientY),
              (u.removalDistance =
                (B.offsetHeight *
                  (t.draggablePercent === 80
                    ? t.draggablePercent * 1.5
                    : t.draggablePercent)) /
                100)));
      }
    }
    function E(Y) {
      let {
        top: B,
        bottom: I,
        left: H,
        right: X,
      } = l.current.getBoundingClientRect();
      Y.nativeEvent.type !== "touchend" &&
      t.pauseOnHover &&
      Y.clientX >= H &&
      Y.clientX <= X &&
      Y.clientY >= B &&
      Y.clientY <= I
        ? O()
        : j();
    }
    function j() {
      n(!0);
    }
    function O() {
      n(!1);
    }
    function M() {
      ((u.didMove = !1),
        document.addEventListener("pointermove", R),
        document.addEventListener("pointerup", P));
    }
    function N() {
      (document.removeEventListener("pointermove", R),
        document.removeEventListener("pointerup", P));
    }
    function R(Y) {
      let B = l.current;
      if (u.canDrag && B) {
        ((u.didMove = !0),
          e && O(),
          t.draggableDirection === "x"
            ? (u.delta = Y.clientX - u.start)
            : (u.delta = Y.clientY - u.start),
          u.start !== Y.clientX && (u.canCloseOnClick = !1));
        let I =
          t.draggableDirection === "x"
            ? `${u.delta}px, var(--y)`
            : `0, calc(${u.delta}px + var(--y))`;
        ((B.style.transform = `translate3d(${I},0)`),
          (B.style.opacity = `${1 - Math.abs(u.delta / u.removalDistance)}`));
      }
    }
    function P() {
      N();
      let Y = l.current;
      if (u.canDrag && u.didMove && Y) {
        if (((u.canDrag = !1), Math.abs(u.delta) > u.removalDistance)) {
          (a(!0), t.closeToast(!0), t.collapseAll());
          return;
        }
        ((Y.style.transition = "transform 0.2s, opacity 0.2s"),
          Y.style.removeProperty("transform"),
          Y.style.removeProperty("opacity"));
      }
    }
    let G = { onPointerDown: T, onPointerUp: E };
    return (
      d && m && ((G.onMouseEnter = O), t.stacked || (G.onMouseLeave = j)),
      y &&
        (G.onClick = (Y) => {
          (v && v(Y), u.canCloseOnClick && g(!0));
        }),
      {
        playToast: j,
        pauseToast: O,
        isRunning: e,
        preventExitTransition: i,
        toastRef: l,
        eventHandlers: G,
      }
    );
  }
  var nL = typeof window < "u" ? W.useLayoutEffect : W.useEffect,
    Ub = ({ theme: t, type: e, isLoading: n, ...i }) =>
      U.createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill:
          t === "colored" ? "currentColor" : `var(--toastify-icon-color-${e})`,
        ...i,
      });
  function iL(t) {
    return U.createElement(
      Ub,
      { ...t },
      U.createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z",
      }),
    );
  }
  function sL(t) {
    return U.createElement(
      Ub,
      { ...t },
      U.createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z",
      }),
    );
  }
  function rL(t) {
    return U.createElement(
      Ub,
      { ...t },
      U.createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z",
      }),
    );
  }
  function aL(t) {
    return U.createElement(
      Ub,
      { ...t },
      U.createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z",
      }),
    );
  }
  function lL() {
    return U.createElement("div", { className: "Toastify__spinner" });
  }
  var D_ = { info: sL, warning: iL, success: rL, error: aL, spinner: lL },
    oL = (t) => t in D_;
  function cL({ theme: t, type: e, isLoading: n, icon: i }) {
    let a = null,
      l = { theme: t, type: e };
    return (
      i === !1 ||
        (vo(i)
          ? (a = i({ ...l, isLoading: n }))
          : W.isValidElement(i)
            ? (a = W.cloneElement(i, l))
            : n
              ? (a = D_.spinner())
              : oL(e) && (a = D_[e](l))),
      a
    );
  }
  var uL = (t) => {
      let {
          isRunning: e,
          preventExitTransition: n,
          toastRef: i,
          eventHandlers: a,
          playToast: l,
        } = tL(t),
        {
          closeButton: u,
          children: d,
          autoClose: m,
          onClick: g,
          type: v,
          hideProgressBar: y,
          closeToast: w,
          transition: S,
          position: T,
          className: E,
          style: j,
          progressClassName: O,
          updateId: M,
          role: N,
          progress: R,
          rtl: P,
          toastId: G,
          deleteToast: Y,
          isIn: B,
          isLoading: I,
          closeOnClick: H,
          theme: X,
          ariaLabel: fe,
        } = t,
        ve = Mf(
          "Toastify__toast",
          `Toastify__toast-theme--${X}`,
          `Toastify__toast--${v}`,
          { "Toastify__toast--rtl": P },
          { "Toastify__toast--close-on-click": H },
        ),
        be = vo(E)
          ? E({ rtl: P, position: T, type: v, defaultClassName: ve })
          : Mf(ve, E),
        Oe = cL(t),
        V = !!R || !m,
        pe = { closeToast: w, type: v, theme: X },
        de = null;
      return (
        u === !1 ||
          (vo(u)
            ? (de = u(pe))
            : W.isValidElement(u)
              ? (de = W.cloneElement(u, pe))
              : (de = UR(pe))),
        U.createElement(
          S,
          {
            isIn: B,
            done: Y,
            position: T,
            preventExitTransition: n,
            nodeRef: i,
            playToast: l,
          },
          U.createElement(
            "div",
            {
              id: G,
              tabIndex: 0,
              onClick: g,
              "data-in": B,
              className: be,
              ...a,
              style: j,
              ref: i,
              ...(B && { role: N, "aria-label": fe }),
            },
            Oe != null &&
              U.createElement(
                "div",
                {
                  className: Mf("Toastify__toast-icon", {
                    "Toastify--animate-icon Toastify__zoom-enter": !I,
                  }),
                },
                Oe,
              ),
            I2(d, t, !e),
            de,
            !t.customProgressBar &&
              U.createElement(FR, {
                ...(M && !V ? { key: `p-${M}` } : {}),
                rtl: P,
                theme: X,
                delay: m,
                isRunning: e,
                isIn: B,
                closeToast: w,
                hide: y,
                type: v,
                className: O,
                controlledProgress: V,
                progress: R || 0,
              }),
          ),
        )
      );
    },
    fL = (t, e = !1) => ({
      enter: `Toastify--animate Toastify__${t}-enter`,
      exit: `Toastify--animate Toastify__${t}-exit`,
      appendPosition: e,
    }),
    dL = IR(fL("bounce", !0)),
    hL = {
      position: "top-right",
      transition: dL,
      autoClose: 5e3,
      closeButton: !0,
      pauseOnHover: !0,
      pauseOnFocusLoss: !0,
      draggable: "touch",
      draggablePercent: 80,
      draggableDirection: "x",
      role: "alert",
      theme: "light",
      "aria-label": "Notifications Alt+T",
      hotKeys: (t) => t.altKey && t.code === "KeyT",
    };
  function pL(t) {
    let e = { ...hL, ...t },
      n = t.stacked,
      [i, a] = W.useState(!0),
      l = W.useRef(null),
      { getToastToRender: u, isToastActive: d, count: m } = eL(e),
      { className: g, style: v, rtl: y, containerId: w, hotKeys: S } = e;
    function T(j) {
      let O = Mf(
        "Toastify__toast-container",
        `Toastify__toast-container--${j}`,
        { "Toastify__toast-container--rtl": y },
      );
      return vo(g)
        ? g({ position: j, rtl: y, defaultClassName: O })
        : Mf(O, A_(g));
    }
    function E() {
      n && (a(!0), xt.play());
    }
    return (
      nL(() => {
        var j;
        if (n) {
          let O = l.current.querySelectorAll('[data-in="true"]'),
            M = 12,
            N = (j = e.position) == null ? void 0 : j.includes("top"),
            R = 0,
            P = 0;
          Array.from(O)
            .reverse()
            .forEach((G, Y) => {
              let B = G;
              (B.classList.add("Toastify__toast--stacked"),
                Y > 0 && (B.dataset.collapsed = `${i}`),
                B.dataset.pos || (B.dataset.pos = N ? "top" : "bot"));
              let I = R * (i ? 0.2 : 1) + (i ? 0 : M * Y);
              (B.style.setProperty("--y", `${N ? I : I * -1}px`),
                B.style.setProperty("--g", `${M}`),
                B.style.setProperty("--s", `${1 - (i ? P : 0)}`),
                (R += B.offsetHeight),
                (P += 0.025));
            });
        }
      }, [i, m, n]),
      W.useEffect(() => {
        function j(O) {
          var M;
          let N = l.current;
          (S(O) &&
            ((M = N.querySelector('[tabIndex="0"]')) == null || M.focus(),
            a(!1),
            xt.pause()),
            O.key === "Escape" &&
              (document.activeElement === N ||
                (N != null && N.contains(document.activeElement))) &&
              (a(!0), xt.play()));
        }
        return (
          document.addEventListener("keydown", j),
          () => {
            document.removeEventListener("keydown", j);
          }
        );
      }, [S]),
      U.createElement(
        "section",
        {
          ref: l,
          className: "Toastify",
          id: w,
          onMouseEnter: () => {
            n && (a(!1), xt.pause());
          },
          onMouseLeave: E,
          "aria-live": "polite",
          "aria-atomic": "false",
          "aria-relevant": "additions text",
          "aria-label": e["aria-label"],
        },
        u((j, O) => {
          let M = O.length ? { ...v } : { ...v, pointerEvents: "none" };
          return U.createElement(
            "div",
            {
              tabIndex: -1,
              className: T(j),
              "data-stacked": n,
              style: M,
              key: `c-${j}`,
            },
            O.map(({ content: N, props: R }) =>
              U.createElement(
                uL,
                {
                  ...R,
                  stacked: n,
                  collapseAll: E,
                  isIn: d(R.toastId, R.containerId),
                  key: `t-${R.key}`,
                },
                N,
              ),
            ),
          );
        }),
      )
    );
  }
  const Ii = "https://admin.samireeliyeva.az/api/v1/",
    si = () => {
      const t = nt((n) => n.selectedLanguage.selectedLanguage),
        e = Xe.create({
          baseURL: Ii,
          headers: {
            "Accept-Language": t,
            Authorization: `Bearer ${localStorage.getItem("tkn_education")}`,
          },
        });
      return (
        e.interceptors.response.use(
          (n) => n,
          async (n) => {
            var l, u, d, m, g, v, y, w;
            const i = n.config,
              a =
                ((l = i == null ? void 0 : i.url) == null
                  ? void 0
                  : l.includes("/login")) ||
                ((u = i == null ? void 0 : i.url) == null
                  ? void 0
                  : u.includes("/register")) ||
                ((d = i == null ? void 0 : i.url) == null
                  ? void 0
                  : d.includes("/refresh-token"));
            if (
              ((m = n.response) == null ? void 0 : m.status) === 401 &&
              !i._retry &&
              !a
            ) {
              i._retry = !0;
              try {
                const S = localStorage.getItem("rft_education");
                if (!S) throw new Error("Refresh token not found");
                const T = await Xe.post(`${Ii}refresh-token`, { token: S }),
                  E =
                    (v = (g = T.data) == null ? void 0 : g.data) == null
                      ? void 0
                      : v.token,
                  j =
                    (w = (y = T.data) == null ? void 0 : y.data) == null
                      ? void 0
                      : w.refresh_token;
                if (!E) throw new Error("New access token missing");
                return (
                  localStorage.setItem("tkn_education", E),
                  localStorage.setItem("rft_education", j),
                  (i.headers = i.headers || {}),
                  (i.headers.Authorization = `Bearer ${E}`),
                  (e.defaults.headers.common.Authorization = `Bearer ${E}`),
                  e(i)
                );
              } catch (S) {
                return (
                  localStorage.removeItem("tkn_education"),
                  localStorage.removeItem("rft_education"),
                  localStorage.removeItem("usr_education"),
                  xt("Xahiş edirik yenidən daxil olun.", {
                    position: "top-right",
                    autoClose: 4e3,
                  }),
                  setTimeout(() => {
                    window.location.href = "/daxil-ol";
                  }, 3e3),
                  Promise.reject(S)
                );
              }
            }
            return Promise.reject(n);
          },
        ),
        { instance: e, base: Ii }
      );
    };
  function Et(t, e, n, i) {
    const { instance: a } = si(),
      l = localStorage.getItem("tkn_education"),
      u = nt((T) => T.selectedLanguage.selectedLanguage),
      d = ww(),
      m = async () => {
        try {
          return (
            await a.get(`${t}`, {
              headers: {
                "Accept-Language": u,
                Authorization: n ? `Bearer ${l}` : "",
              },
            })
          ).data;
        } catch (T) {
          window.dispatchEvent(new CustomEvent("site-api-error"));
          throw T;
        }
      },
      {
        data: g,
        isLoading: v,
        isError: y,
      } = D2({ queryKey: [e, u], queryFn: m, enabled: !0 }),
      w = d.getQueryData([e, u]);
    return {
      innerData: g ?? null,
      cachedData: w ?? null,
      dataLoading: v,
      dataError: y,
      hasInvalidateQuery: (T) => d.invalidateQueries({ queryKey: [T] }),
    };
  }
  const ze = ({ style: t, styleLoader: e }) =>
      h.jsx("div", {
        className: "loader-container",
        style: t,
        children: h.jsx("div", {
          className: "loader",
          style: e,
          children: h.jsx("div", {
            className: "justify-content-center jimu-primary-loading",
          }),
        }),
      }),
    mL = () => {
      var i;
      const { innerData: t, dataLoading: e } = Et(
          "textbook-banner",
          "textbook_hero_key",
        ),
        n =
          t &&
          t != null &&
          t.data &&
          ((i = Object.keys(t == null ? void 0 : t.data)) == null
            ? void 0
            : i.length) > 0
            ? t == null
              ? void 0
              : t.data
            : null;
      return e
        ? h.jsx(ze, {})
        : h.jsx("section", {
            className: "hero-test-bank-wrapper",
            children:
              n &&
              h.jsxs("div", {
                className: "hero-test-bank",
                children: [
                  h.jsxs("div", {
                    className: "left",
                    children: [
                      h.jsxs("div", {
                        className: "title-top",
                        children: [
                          h.jsx("h1", {
                            children: n == null ? void 0 : n.title,
                          }),
                          (n == null ? void 0 : n.description) &&
                            h.jsx("div", {
                              dangerouslySetInnerHTML: {
                                __html: ip.sanitize(
                                  (n == null ? void 0 : n.description) || "",
                                ),
                              },
                            }),
                        ],
                      }),
                      h.jsx(S2, {}),
                    ],
                  }),
                  h.jsx("div", {
                    className: "right",
                    children: h.jsx("img", {
                      style: {
                        maxWidth: "565",
                        maxHeight: "379px",
                        objectFit: "contain",
                      },
                      src: (n == null ? void 0 : n.image) || "/scene.svg",
                      alt: "image-hero",
                    }),
                  }),
                ],
              }),
          });
    },
    Ct = ({
      style: t,
      isButton: e = !1,
      href: n,
      title: i,
      icon: a,
      pStyle: l,
      class_name: u,
      target: d,
      onClickFunc: m,
      buttonType: g,
      disabled: v = !1,
    }) =>
      e
        ? h.jsxs("button", {
            disabled: v,
            onClick: m && m,
            className: `button-component-ui ${u || ""}`,
            style: t,
            type: g || "button",
            children: [
              h.jsx("p", { style: l, children: i }),
              a && h.jsx("img", { src: a }),
            ],
          })
        : h.jsxs(_t, {
            target: d,
            className: `button-component-ui ${u || ""}`,
            style: t,
            to: n || "",
            children: [
              h.jsx("p", { style: l, children: i }),
              a && h.jsx("img", { src: a }),
            ],
          }),
    q2 = ({ data: t, wpNumber: e }) => {
      const { t: n } = Ot(),
        i = nt((a) => a.selectedLanguage.selectedLanguage);
      return h.jsxs("article", {
        className: "testbankcard-ui",
        children: [
          h.jsx("div", {
            className: "image-content",
            children: h.jsx("img", {
              src: t == null ? void 0 : t.image,
              alt: t == null ? void 0 : t.title,
            }),
          }),
          h.jsxs("div", {
            className: "description",
            children: [
              h.jsx("div", {
                className: "top-title",
                children: h.jsx("h2", {
                  children: t == null ? void 0 : t.title,
                }),
              }),
              h.jsxs("div", {
                className: "buttons",
                children: [
                  h.jsx(Ct, {
                    title: n("indi_al"),
                    target: "_blank",
                    href: `https://wa.me/${e || n("your_telephone_number")}`,
                    style: { width: "100%" },
                    pStyle: { fontSize: "13px", color: "white" },
                  }),
                  h.jsx(Ct, {
                    title: n("etrafli_bax"),
                    href: `/derslikler-ve-test-banklari/${i}/${t == null ? void 0 : t.slug[i]}`,
                    style: {
                      backgroundColor: "transparent",
                      border: "2px solid #407DF266",
                      width: "100%",
                    },
                    pStyle: { color: "#407DF2", fontSize: "13px" },
                  }),
                ],
              }),
            ],
          }),
        ],
      });
    },
    np = ({
      title: t,
      counterValue: e,
      customStyle: n,
      dataLength: i,
      setNext: a,
      next: l,
    }) => {
      const u = () => {
        a((d) => d + e);
      };
      return i && l && i >= l
        ? h.jsx("div", {
            className: "ShowMorePagination-wrapper",
            children: h.jsx("button", {
              type: "button",
              className: "button",
              style: n,
              onClick: u,
              children: t,
            }),
          })
        : null;
    },
    gL = () => {
      const { instance: t } = si(),
        [e, n] = U.useState([]),
        [i, a] = U.useState(!1),
        [l, u] = U.useState(!1),
        [d, m] = U.useState(1);
      return {
        fetchLessons: async (v) => {
          var y, w;
          v === 1 ? a(!0) : u(!0);
          try {
            const S = await t.get(`textbooks?page=${v}`);
            S.data &&
              (n((T) => (v === 1 ? S.data.data : [...T, ...S.data.data])),
              m(
                ((w = (y = S.data) == null ? void 0 : y.meta) == null
                  ? void 0
                  : w.last_page) || 1,
              ));
          } catch (S) {
            console.log(S);
          } finally {
            (a(!1), u(!1));
          }
        },
        lessons: e,
        lastPage: d,
        isInitialLoading: i,
        isLoadingMore: l,
      };
    };
  function yi(t) {
    return `Minified Redux error #${t}; visit https://redux.js.org/Errors?code=${t} for the full message or use the non-minified dev environment for full errors. `;
  }
  var vL = (typeof Symbol == "function" && Symbol.observable) || "@@observable",
    lT = vL,
    Tx = () => Math.random().toString(36).substring(7).split("").join("."),
    yL = {
      INIT: `@@redux/INIT${Tx()}`,
      REPLACE: `@@redux/REPLACE${Tx()}`,
      PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${Tx()}`,
    },
    lb = yL;
  function Tw(t) {
    if (typeof t != "object" || t === null) return !1;
    let e = t;
    for (; Object.getPrototypeOf(e) !== null; ) e = Object.getPrototypeOf(e);
    return Object.getPrototypeOf(t) === e || Object.getPrototypeOf(t) === null;
  }
  function $2(t, e, n) {
    if (typeof t != "function") throw new Error(yi(2));
    if (
      (typeof e == "function" && typeof n == "function") ||
      (typeof n == "function" && typeof arguments[3] == "function")
    )
      throw new Error(yi(0));
    if (
      (typeof e == "function" && typeof n > "u" && ((n = e), (e = void 0)),
      typeof n < "u")
    ) {
      if (typeof n != "function") throw new Error(yi(1));
      return n($2)(t, e);
    }
    let i = t,
      a = e,
      l = new Map(),
      u = l,
      d = 0,
      m = !1;
    function g() {
      u === l &&
        ((u = new Map()),
        l.forEach((j, O) => {
          u.set(O, j);
        }));
    }
    function v() {
      if (m) throw new Error(yi(3));
      return a;
    }
    function y(j) {
      if (typeof j != "function") throw new Error(yi(4));
      if (m) throw new Error(yi(5));
      let O = !0;
      g();
      const M = d++;
      return (
        u.set(M, j),
        function () {
          if (O) {
            if (m) throw new Error(yi(6));
            ((O = !1), g(), u.delete(M), (l = null));
          }
        }
      );
    }
    function w(j) {
      if (!Tw(j)) throw new Error(yi(7));
      if (typeof j.type > "u") throw new Error(yi(8));
      if (typeof j.type != "string") throw new Error(yi(17));
      if (m) throw new Error(yi(9));
      try {
        ((m = !0), (a = i(a, j)));
      } finally {
        m = !1;
      }
      return (
        (l = u).forEach((M) => {
          M();
        }),
        j
      );
    }
    function S(j) {
      if (typeof j != "function") throw new Error(yi(10));
      ((i = j), w({ type: lb.REPLACE }));
    }
    function T() {
      const j = y;
      return {
        subscribe(O) {
          if (typeof O != "object" || O === null) throw new Error(yi(11));
          function M() {
            const R = O;
            R.next && R.next(v());
          }
          return (M(), { unsubscribe: j(M) });
        },
        [lT]() {
          return this;
        },
      };
    }
    return (
      w({ type: lb.INIT }),
      { dispatch: w, subscribe: y, getState: v, replaceReducer: S, [lT]: T }
    );
  }
  function bL(t) {
    Object.keys(t).forEach((e) => {
      const n = t[e];
      if (typeof n(void 0, { type: lb.INIT }) > "u") throw new Error(yi(12));
      if (typeof n(void 0, { type: lb.PROBE_UNKNOWN_ACTION() }) > "u")
        throw new Error(yi(13));
    });
  }
  function xL(t) {
    const e = Object.keys(t),
      n = {};
    for (let l = 0; l < e.length; l++) {
      const u = e[l];
      typeof t[u] == "function" && (n[u] = t[u]);
    }
    const i = Object.keys(n);
    let a;
    try {
      bL(n);
    } catch (l) {
      a = l;
    }
    return function (u = {}, d) {
      if (a) throw a;
      let m = !1;
      const g = {};
      for (let v = 0; v < i.length; v++) {
        const y = i[v],
          w = n[y],
          S = u[y],
          T = w(S, d);
        if (typeof T > "u") throw (d && d.type, new Error(yi(14)));
        ((g[y] = T), (m = m || T !== S));
      }
      return ((m = m || i.length !== Object.keys(u).length), m ? g : u);
    };
  }
  function ob(...t) {
    return t.length === 0
      ? (e) => e
      : t.length === 1
        ? t[0]
        : t.reduce(
            (e, n) =>
              (...i) =>
                e(n(...i)),
          );
  }
  function _L(...t) {
    return (e) => (n, i) => {
      const a = e(n, i);
      let l = () => {
        throw new Error(yi(15));
      };
      const u = { getState: a.getState, dispatch: (m, ...g) => l(m, ...g) },
        d = t.map((m) => m(u));
      return ((l = ob(...d)(a.dispatch)), { ...a, dispatch: l });
    };
  }
  function wL(t) {
    return Tw(t) && "type" in t && typeof t.type == "string";
  }
  var G2 = Symbol.for("immer-nothing"),
    oT = Symbol.for("immer-draftable"),
    ms = Symbol.for("immer-state");
  function pa(t, ...e) {
    throw new Error(
      `[Immer] minified error nr: ${t}. Full error at: https://bit.ly/3cXEKWf`,
    );
  }
  var hr = Object,
    Xh = hr.getPrototypeOf,
    cb = "constructor",
    Fb = "prototype",
    k_ = "configurable",
    ub = "enumerable",
    W0 = "writable",
    Ng = "value",
    yo = (t) => !!t && !!t[ms];
  function ga(t) {
    var e;
    return t
      ? V2(t) ||
          Bb(t) ||
          !!t[oT] ||
          !!((e = t[cb]) != null && e[oT]) ||
          Hb(t) ||
          Yb(t)
      : !1;
  }
  var SL = hr[Fb][cb].toString(),
    cT = new WeakMap();
  function V2(t) {
    if (!t || !Ew(t)) return !1;
    const e = Xh(t);
    if (e === null || e === hr[Fb]) return !0;
    const n = hr.hasOwnProperty.call(e, cb) && e[cb];
    if (n === Object) return !0;
    if (!Mh(n)) return !1;
    let i = cT.get(n);
    return (
      i === void 0 && ((i = Function.toString.call(n)), cT.set(n, i)),
      i === SL
    );
  }
  function ev(t, e, n = !0) {
    tv(t) === 0
      ? (n ? Reflect.ownKeys(t) : hr.keys(t)).forEach((a) => {
          e(a, t[a], t);
        })
      : t.forEach((i, a) => e(a, i, t));
  }
  function tv(t) {
    const e = t[ms];
    return e ? e.type_ : Bb(t) ? 1 : Hb(t) ? 2 : Yb(t) ? 3 : 0;
  }
  var uT = (t, e, n = tv(t)) =>
      n === 2 ? t.has(e) : hr[Fb].hasOwnProperty.call(t, e),
    z_ = (t, e, n = tv(t)) => (n === 2 ? t.get(e) : t[e]),
    fb = (t, e, n, i = tv(t)) => {
      i === 2 ? t.set(e, n) : i === 3 ? t.add(n) : (t[e] = n);
    };
  function TL(t, e) {
    return t === e ? t !== 0 || 1 / t === 1 / e : t !== t && e !== e;
  }
  var Bb = Array.isArray,
    Hb = (t) => t instanceof Map,
    Yb = (t) => t instanceof Set,
    Ew = (t) => typeof t == "object",
    Mh = (t) => typeof t == "function",
    Ex = (t) => typeof t == "boolean";
  function EL(t) {
    const e = +t;
    return Number.isInteger(e) && String(e) === t;
  }
  var ro = (t) => t.copy_ || t.base_,
    Cw = (t) => (t.modified_ ? t.copy_ : t.base_);
  function P_(t, e) {
    if (Hb(t)) return new Map(t);
    if (Yb(t)) return new Set(t);
    if (Bb(t)) return Array[Fb].slice.call(t);
    const n = V2(t);
    if (e === !0 || (e === "class_only" && !n)) {
      const i = hr.getOwnPropertyDescriptors(t);
      delete i[ms];
      let a = Reflect.ownKeys(i);
      for (let l = 0; l < a.length; l++) {
        const u = a[l],
          d = i[u];
        (d[W0] === !1 && ((d[W0] = !0), (d[k_] = !0)),
          (d.get || d.set) &&
            (i[u] = { [k_]: !0, [W0]: !0, [ub]: d[ub], [Ng]: t[u] }));
      }
      return hr.create(Xh(t), i);
    } else {
      const i = Xh(t);
      if (i !== null && n) return { ...t };
      const a = hr.create(i);
      return hr.assign(a, t);
    }
  }
  function Ow(t, e = !1) {
    return (
      qb(t) ||
        yo(t) ||
        !ga(t) ||
        (tv(t) > 1 &&
          hr.defineProperties(t, { set: w0, add: w0, clear: w0, delete: w0 }),
        hr.freeze(t),
        e &&
          ev(
            t,
            (n, i) => {
              Ow(i, !0);
            },
            !1,
          )),
      t
    );
  }
  function CL() {
    pa(2);
  }
  var w0 = { [Ng]: CL };
  function qb(t) {
    return t === null || !Ew(t) ? !0 : hr.isFrozen(t);
  }
  var db = "MapSet",
    I_ = "Patches",
    fT = "ArrayMethods",
    W2 = {};
  function kf(t) {
    const e = W2[t];
    return (e || pa(0, t), e);
  }
  var dT = (t) => !!W2[t],
    Ag,
    X2 = () => Ag,
    OL = (t, e) => ({
      drafts_: [],
      parent_: t,
      immer_: e,
      canAutoFreeze_: !0,
      unfinalizedDrafts_: 0,
      handledSet_: new Set(),
      processedForPatches_: new Set(),
      mapSetPlugin_: dT(db) ? kf(db) : void 0,
      arrayMethodsPlugin_: dT(fT) ? kf(fT) : void 0,
    });
  function hT(t, e) {
    e &&
      ((t.patchPlugin_ = kf(I_)),
      (t.patches_ = []),
      (t.inversePatches_ = []),
      (t.patchListener_ = e));
  }
  function U_(t) {
    (F_(t), t.drafts_.forEach(jL), (t.drafts_ = null));
  }
  function F_(t) {
    t === Ag && (Ag = t.parent_);
  }
  var pT = (t) => (Ag = OL(Ag, t));
  function jL(t) {
    const e = t[ms];
    e.type_ === 0 || e.type_ === 1 ? e.revoke_() : (e.revoked_ = !0);
  }
  function mT(t, e) {
    e.unfinalizedDrafts_ = e.drafts_.length;
    const n = e.drafts_[0];
    if (t !== void 0 && t !== n) {
      (n[ms].modified_ && (U_(e), pa(4)), ga(t) && (t = gT(e, t)));
      const { patchPlugin_: a } = e;
      a && a.generateReplacementPatches_(n[ms].base_, t, e);
    } else t = gT(e, n);
    return (
      ML(e, t, !0),
      U_(e),
      e.patches_ && e.patchListener_(e.patches_, e.inversePatches_),
      t !== G2 ? t : void 0
    );
  }
  function gT(t, e) {
    if (qb(e)) return e;
    const n = e[ms];
    if (!n) return jw(e, t.handledSet_, t);
    if (!$b(n, t)) return e;
    if (!n.modified_) return n.base_;
    if (!n.finalized_) {
      const { callbacks_: i } = n;
      if (i) for (; i.length > 0; ) i.pop()(t);
      K2(n, t);
    }
    return n.copy_;
  }
  function ML(t, e, n = !1) {
    !t.parent_ && t.immer_.autoFreeze_ && t.canAutoFreeze_ && Ow(e, n);
  }
  function Q2(t) {
    ((t.finalized_ = !0), t.scope_.unfinalizedDrafts_--);
  }
  var $b = (t, e) => t.scope_ === e,
    NL = [];
  function Z2(t, e, n, i) {
    const a = ro(t),
      l = t.type_;
    if (i !== void 0 && z_(a, i, l) === e) {
      fb(a, i, n, l);
      return;
    }
    if (!t.draftLocations_) {
      const d = (t.draftLocations_ = new Map());
      ev(a, (m, g) => {
        if (yo(g)) {
          const v = d.get(g) || [];
          (v.push(m), d.set(g, v));
        }
      });
    }
    const u = t.draftLocations_.get(e) ?? NL;
    for (const d of u) fb(a, d, n, l);
  }
  function AL(t, e, n) {
    t.callbacks_.push(function (a) {
      var d;
      const l = e;
      if (!l || !$b(l, a)) return;
      (d = a.mapSetPlugin_) == null || d.fixSetContents(l);
      const u = Cw(l);
      (Z2(t, l.draft_ ?? l, u, n), K2(l, a));
    });
  }
  function K2(t, e) {
    var i;
    if (
      t.modified_ &&
      !t.finalized_ &&
      (t.type_ === 3 ||
        (t.type_ === 1 && t.allIndicesReassigned_) ||
        (((i = t.assigned_) == null ? void 0 : i.size) ?? 0) > 0)
    ) {
      const { patchPlugin_: a } = e;
      if (a) {
        const l = a.getPath(t);
        l && a.generatePatches_(t, l, e);
      }
      Q2(t);
    }
  }
  function RL(t, e, n) {
    const { scope_: i } = t;
    if (yo(n)) {
      const a = n[ms];
      $b(a, i) &&
        a.callbacks_.push(function () {
          X0(t);
          const u = Cw(a);
          Z2(t, n, u, e);
        });
    } else
      ga(n) &&
        t.callbacks_.push(function () {
          const l = ro(t);
          z_(l, e, t.type_) === n &&
            i.drafts_.length > 1 &&
            (t.assigned_.get(e) ?? !1) === !0 &&
            t.copy_ &&
            jw(z_(t.copy_, e, t.type_), i.handledSet_, i);
        });
  }
  function jw(t, e, n) {
    return (
      (!n.immer_.autoFreeze_ && n.unfinalizedDrafts_ < 1) ||
        yo(t) ||
        e.has(t) ||
        !ga(t) ||
        qb(t) ||
        (e.add(t),
        ev(t, (i, a) => {
          if (yo(a)) {
            const l = a[ms];
            if ($b(l, n)) {
              const u = Cw(l);
              (fb(t, i, u, t.type_), Q2(l));
            }
          } else ga(a) && jw(a, e, n);
        })),
      t
    );
  }
  function LL(t, e) {
    const n = Bb(t),
      i = {
        type_: n ? 1 : 0,
        scope_: e ? e.scope_ : X2(),
        modified_: !1,
        finalized_: !1,
        assigned_: void 0,
        parent_: e,
        base_: t,
        draft_: null,
        copy_: null,
        revoke_: null,
        isManual_: !1,
        callbacks_: void 0,
      };
    let a = i,
      l = Mw;
    n && ((a = [i]), (l = Rg));
    const { revoke: u, proxy: d } = Proxy.revocable(a, l);
    return ((i.draft_ = d), (i.revoke_ = u), [d, i]);
  }
  var Mw = {
      get(t, e) {
        if (e === ms) return t;
        let n = t.scope_.arrayMethodsPlugin_;
        const i = t.type_ === 1 && typeof e == "string";
        if (i && n != null && n.isArrayOperationMethod(e))
          return n.createMethodInterceptor(t, e);
        const a = ro(t);
        if (!uT(a, e, t.type_)) return DL(t, a, e);
        const l = a[e];
        if (
          t.finalized_ ||
          !ga(l) ||
          (i &&
            t.operationMethod &&
            n != null &&
            n.isMutatingArrayMethod(t.operationMethod) &&
            EL(e))
        )
          return l;
        if (l === Cx(t.base_, e)) {
          X0(t);
          const u = t.type_ === 1 ? +e : e,
            d = H_(t.scope_, l, t, u);
          return (t.copy_[u] = d);
        }
        return l;
      },
      has(t, e) {
        return e in ro(t);
      },
      ownKeys(t) {
        return Reflect.ownKeys(ro(t));
      },
      set(t, e, n) {
        const i = J2(ro(t), e);
        if (i != null && i.set) return (i.set.call(t.draft_, n), !0);
        if (!t.modified_) {
          const a = Cx(ro(t), e),
            l = a == null ? void 0 : a[ms];
          if (l && l.base_ === n)
            return ((t.copy_[e] = n), t.assigned_.set(e, !1), !0);
          if (TL(n, a) && (n !== void 0 || uT(t.base_, e, t.type_))) return !0;
          (X0(t), B_(t));
        }
        return (
          (t.copy_[e] === n && (n !== void 0 || e in t.copy_)) ||
            (Number.isNaN(n) && Number.isNaN(t.copy_[e])) ||
            ((t.copy_[e] = n), t.assigned_.set(e, !0), RL(t, e, n)),
          !0
        );
      },
      deleteProperty(t, e) {
        return (
          X0(t),
          Cx(t.base_, e) !== void 0 || e in t.base_
            ? (t.assigned_.set(e, !1), B_(t))
            : t.assigned_.delete(e),
          t.copy_ && delete t.copy_[e],
          !0
        );
      },
      getOwnPropertyDescriptor(t, e) {
        const n = ro(t),
          i = Reflect.getOwnPropertyDescriptor(n, e);
        return (
          i && {
            [W0]: !0,
            [k_]: t.type_ !== 1 || e !== "length",
            [ub]: i[ub],
            [Ng]: n[e],
          }
        );
      },
      defineProperty() {
        pa(11);
      },
      getPrototypeOf(t) {
        return Xh(t.base_);
      },
      setPrototypeOf() {
        pa(12);
      },
    },
    Rg = {};
  ev(Mw, (t, e) => {
    Rg[t] = function () {
      const n = arguments;
      return ((n[0] = n[0][0]), e.apply(this, n));
    };
  });
  Rg.deleteProperty = function (t, e) {
    return Rg.set.call(this, t, e, void 0);
  };
  Rg.set = function (t, e, n) {
    return Mw.set.call(this, t[0], e, n, t[0]);
  };
  function Cx(t, e) {
    const n = t[ms];
    return (n ? ro(n) : t)[e];
  }
  function DL(t, e, n) {
    var a;
    const i = J2(e, n);
    return i
      ? Ng in i
        ? i[Ng]
        : (a = i.get) == null
          ? void 0
          : a.call(t.draft_)
      : void 0;
  }
  function J2(t, e) {
    if (!(e in t)) return;
    let n = Xh(t);
    for (; n; ) {
      const i = Object.getOwnPropertyDescriptor(n, e);
      if (i) return i;
      n = Xh(n);
    }
  }
  function B_(t) {
    t.modified_ || ((t.modified_ = !0), t.parent_ && B_(t.parent_));
  }
  function X0(t) {
    t.copy_ ||
      ((t.assigned_ = new Map()),
      (t.copy_ = P_(t.base_, t.scope_.immer_.useStrictShallowCopy_)));
  }
  var kL = class {
    constructor(t) {
      ((this.autoFreeze_ = !0),
        (this.useStrictShallowCopy_ = !1),
        (this.useStrictIteration_ = !1),
        (this.produce = (e, n, i) => {
          if (Mh(e) && !Mh(n)) {
            const l = n;
            n = e;
            const u = this;
            return function (m = l, ...g) {
              return u.produce(m, (v) => n.call(this, v, ...g));
            };
          }
          (Mh(n) || pa(6), i !== void 0 && !Mh(i) && pa(7));
          let a;
          if (ga(e)) {
            const l = pT(this),
              u = H_(l, e, void 0);
            let d = !0;
            try {
              ((a = n(u)), (d = !1));
            } finally {
              d ? U_(l) : F_(l);
            }
            return (hT(l, i), mT(a, l));
          } else if (!e || !Ew(e)) {
            if (
              ((a = n(e)),
              a === void 0 && (a = e),
              a === G2 && (a = void 0),
              this.autoFreeze_ && Ow(a, !0),
              i)
            ) {
              const l = [],
                u = [];
              (kf(I_).generateReplacementPatches_(e, a, {
                patches_: l,
                inversePatches_: u,
              }),
                i(l, u));
            }
            return a;
          } else pa(1, e);
        }),
        (this.produceWithPatches = (e, n) => {
          if (Mh(e))
            return (u, ...d) => this.produceWithPatches(u, (m) => e(m, ...d));
          let i, a;
          return [
            this.produce(e, n, (u, d) => {
              ((i = u), (a = d));
            }),
            i,
            a,
          ];
        }),
        Ex(t == null ? void 0 : t.autoFreeze) &&
          this.setAutoFreeze(t.autoFreeze),
        Ex(t == null ? void 0 : t.useStrictShallowCopy) &&
          this.setUseStrictShallowCopy(t.useStrictShallowCopy),
        Ex(t == null ? void 0 : t.useStrictIteration) &&
          this.setUseStrictIteration(t.useStrictIteration));
    }
    createDraft(t) {
      (ga(t) || pa(8), yo(t) && (t = zL(t)));
      const e = pT(this),
        n = H_(e, t, void 0);
      return ((n[ms].isManual_ = !0), F_(e), n);
    }
    finishDraft(t, e) {
      const n = t && t[ms];
      (!n || !n.isManual_) && pa(9);
      const { scope_: i } = n;
      return (hT(i, e), mT(void 0, i));
    }
    setAutoFreeze(t) {
      this.autoFreeze_ = t;
    }
    setUseStrictShallowCopy(t) {
      this.useStrictShallowCopy_ = t;
    }
    setUseStrictIteration(t) {
      this.useStrictIteration_ = t;
    }
    shouldUseStrictIteration() {
      return this.useStrictIteration_;
    }
    applyPatches(t, e) {
      let n;
      for (n = e.length - 1; n >= 0; n--) {
        const a = e[n];
        if (a.path.length === 0 && a.op === "replace") {
          t = a.value;
          break;
        }
      }
      n > -1 && (e = e.slice(n + 1));
      const i = kf(I_).applyPatches_;
      return yo(t) ? i(t, e) : this.produce(t, (a) => i(a, e));
    }
  };
  function H_(t, e, n, i) {
    const [a, l] = Hb(e)
      ? kf(db).proxyMap_(e, n)
      : Yb(e)
        ? kf(db).proxySet_(e, n)
        : LL(e, n);
    return (
      ((n == null ? void 0 : n.scope_) ?? X2()).drafts_.push(a),
      (l.callbacks_ = (n == null ? void 0 : n.callbacks_) ?? []),
      (l.key_ = i),
      n && i !== void 0
        ? AL(n, l, i)
        : l.callbacks_.push(function (m) {
            var v;
            (v = m.mapSetPlugin_) == null || v.fixSetContents(l);
            const { patchPlugin_: g } = m;
            l.modified_ && g && g.generatePatches_(l, [], m);
          }),
      a
    );
  }
  function zL(t) {
    return (yo(t) || pa(10, t), eC(t));
  }
  function eC(t) {
    if (!ga(t) || qb(t)) return t;
    const e = t[ms];
    let n,
      i = !0;
    if (e) {
      if (!e.modified_) return e.base_;
      ((e.finalized_ = !0),
        (n = P_(t, e.scope_.immer_.useStrictShallowCopy_)),
        (i = e.scope_.immer_.shouldUseStrictIteration()));
    } else n = P_(t, !0);
    return (
      ev(
        n,
        (a, l) => {
          fb(n, a, eC(l));
        },
        i,
      ),
      e && (e.finalized_ = !1),
      n
    );
  }
  var PL = new kL(),
    tC = PL.produce;
  function nC(t) {
    return ({ dispatch: n, getState: i }) =>
      (a) =>
      (l) =>
        typeof l == "function" ? l(n, i, t) : a(l);
  }
  var IL = nC(),
    UL = nC,
    FL =
      typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        : function () {
            if (arguments.length !== 0)
              return typeof arguments[0] == "object"
                ? ob
                : ob.apply(null, arguments);
          };
  function vT(t, e) {
    function n(...i) {
      if (e) {
        let a = e(...i);
        if (!a) throw new Error(ho(0));
        return {
          type: t,
          payload: a.payload,
          ...("meta" in a && { meta: a.meta }),
          ...("error" in a && { error: a.error }),
        };
      }
      return { type: t, payload: i[0] };
    }
    return (
      (n.toString = () => `${t}`),
      (n.type = t),
      (n.match = (i) => wL(i) && i.type === t),
      n
    );
  }
  var iC = class vg extends Array {
    constructor(...e) {
      (super(...e), Object.setPrototypeOf(this, vg.prototype));
    }
    static get [Symbol.species]() {
      return vg;
    }
    concat(...e) {
      return super.concat.apply(this, e);
    }
    prepend(...e) {
      return e.length === 1 && Array.isArray(e[0])
        ? new vg(...e[0].concat(this))
        : new vg(...e.concat(this));
    }
  };
  function yT(t) {
    return ga(t) ? tC(t, () => {}) : t;
  }
  function S0(t, e, n) {
    return t.has(e) ? t.get(e) : t.set(e, n(e)).get(e);
  }
  function BL(t) {
    return typeof t == "boolean";
  }
  var HL = () =>
      function (e) {
        const {
          thunk: n = !0,
          immutableCheck: i = !0,
          serializableCheck: a = !0,
          actionCreatorCheck: l = !0,
        } = e ?? {};
        let u = new iC();
        return (n && (BL(n) ? u.push(IL) : u.push(UL(n.extraArgument))), u);
      },
    YL = "RTK_autoBatch",
    bT = (t) => (e) => {
      setTimeout(e, t);
    },
    qL =
      (t = { type: "raf" }) =>
      (e) =>
      (...n) => {
        const i = e(...n);
        let a = !0,
          l = !1,
          u = !1;
        const d = new Set(),
          m =
            t.type === "tick"
              ? queueMicrotask
              : t.type === "raf"
                ? typeof window < "u" && window.requestAnimationFrame
                  ? window.requestAnimationFrame
                  : bT(10)
                : t.type === "callback"
                  ? t.queueNotification
                  : bT(t.timeout),
          g = () => {
            ((u = !1), l && ((l = !1), d.forEach((v) => v())));
          };
        return Object.assign({}, i, {
          subscribe(v) {
            const y = () => a && v(),
              w = i.subscribe(y);
            return (
              d.add(v),
              () => {
                (w(), d.delete(v));
              }
            );
          },
          dispatch(v) {
            var y;
            try {
              return (
                (a = !((y = v == null ? void 0 : v.meta) != null && y[YL])),
                (l = !a),
                l && (u || ((u = !0), m(g))),
                i.dispatch(v)
              );
            } finally {
              a = !0;
            }
          },
        });
      },
    $L = (t) =>
      function (n) {
        const { autoBatch: i = !0 } = n ?? {};
        let a = new iC(t);
        return (i && a.push(qL(typeof i == "object" ? i : void 0)), a);
      };
  function GL(t) {
    const e = HL(),
      {
        reducer: n = void 0,
        middleware: i,
        devTools: a = !0,
        preloadedState: l = void 0,
        enhancers: u = void 0,
      } = t || {};
    let d;
    if (typeof n == "function") d = n;
    else if (Tw(n)) d = xL(n);
    else throw new Error(ho(1));
    let m;
    typeof i == "function" ? (m = i(e)) : (m = e());
    let g = ob;
    a && (g = FL({ trace: !1, ...(typeof a == "object" && a) }));
    const v = _L(...m),
      y = $L(v);
    let w = typeof u == "function" ? u(y) : y();
    const S = g(...w);
    return $2(d, l, S);
  }
  function sC(t) {
    const e = {},
      n = [];
    let i;
    const a = {
      addCase(l, u) {
        const d = typeof l == "string" ? l : l.type;
        if (!d) throw new Error(ho(28));
        if (d in e) throw new Error(ho(29));
        return ((e[d] = u), a);
      },
      addAsyncThunk(l, u) {
        return (
          u.pending && (e[l.pending.type] = u.pending),
          u.rejected && (e[l.rejected.type] = u.rejected),
          u.fulfilled && (e[l.fulfilled.type] = u.fulfilled),
          u.settled && n.push({ matcher: l.settled, reducer: u.settled }),
          a
        );
      },
      addMatcher(l, u) {
        return (n.push({ matcher: l, reducer: u }), a);
      },
      addDefaultCase(l) {
        return ((i = l), a);
      },
    };
    return (t(a), [e, n, i]);
  }
  function VL(t) {
    return typeof t == "function";
  }
  function WL(t, e) {
    let [n, i, a] = sC(e),
      l;
    if (VL(t)) l = () => yT(t());
    else {
      const d = yT(t);
      l = () => d;
    }
    function u(d = l(), m) {
      let g = [
        n[m.type],
        ...i.filter(({ matcher: v }) => v(m)).map(({ reducer: v }) => v),
      ];
      return (
        g.filter((v) => !!v).length === 0 && (g = [a]),
        g.reduce((v, y) => {
          if (y)
            if (yo(v)) {
              const S = y(v, m);
              return S === void 0 ? v : S;
            } else {
              if (ga(v)) return tC(v, (w) => y(w, m));
              {
                const w = y(v, m);
                if (w === void 0) {
                  if (v === null) return v;
                  throw Error(
                    "A case reducer on a non-draftable value must not return undefined",
                  );
                }
                return w;
              }
            }
          return v;
        }, d)
      );
    }
    return ((u.getInitialState = l), u);
  }
  var XL = Symbol.for("rtk-slice-createasyncthunk");
  function QL(t, e) {
    return `${t}/${e}`;
  }
  function ZL({ creators: t } = {}) {
    var n;
    const e = (n = t == null ? void 0 : t.asyncThunk) == null ? void 0 : n[XL];
    return function (a) {
      const { name: l, reducerPath: u = l } = a;
      if (!l) throw new Error(ho(11));
      const d =
          (typeof a.reducers == "function" ? a.reducers(JL()) : a.reducers) ||
          {},
        m = Object.keys(d),
        g = {
          sliceCaseReducersByName: {},
          sliceCaseReducersByType: {},
          actionCreators: {},
          sliceMatchers: [],
        },
        v = {
          addCase(R, P) {
            const G = typeof R == "string" ? R : R.type;
            if (!G) throw new Error(ho(12));
            if (G in g.sliceCaseReducersByType) throw new Error(ho(13));
            return ((g.sliceCaseReducersByType[G] = P), v);
          },
          addMatcher(R, P) {
            return (g.sliceMatchers.push({ matcher: R, reducer: P }), v);
          },
          exposeAction(R, P) {
            return ((g.actionCreators[R] = P), v);
          },
          exposeCaseReducer(R, P) {
            return ((g.sliceCaseReducersByName[R] = P), v);
          },
        };
      m.forEach((R) => {
        const P = d[R],
          G = {
            reducerName: R,
            type: QL(l, R),
            createNotation: typeof a.reducers == "function",
          };
        t3(P) ? i3(G, P, v, e) : e3(G, P, v);
      });
      function y() {
        const [R = {}, P = [], G = void 0] =
            typeof a.extraReducers == "function"
              ? sC(a.extraReducers)
              : [a.extraReducers],
          Y = { ...R, ...g.sliceCaseReducersByType };
        return WL(a.initialState, (B) => {
          for (let I in Y) B.addCase(I, Y[I]);
          for (let I of g.sliceMatchers) B.addMatcher(I.matcher, I.reducer);
          for (let I of P) B.addMatcher(I.matcher, I.reducer);
          G && B.addDefaultCase(G);
        });
      }
      const w = (R) => R,
        S = new Map(),
        T = new WeakMap();
      let E;
      function j(R, P) {
        return (E || (E = y()), E(R, P));
      }
      function O() {
        return (E || (E = y()), E.getInitialState());
      }
      function M(R, P = !1) {
        function G(B) {
          let I = B[R];
          return (typeof I > "u" && P && (I = S0(T, G, O)), I);
        }
        function Y(B = w) {
          const I = S0(S, P, () => new WeakMap());
          return S0(I, B, () => {
            const H = {};
            for (const [X, fe] of Object.entries(a.selectors ?? {}))
              H[X] = KL(fe, B, () => S0(T, B, O), P);
            return H;
          });
        }
        return {
          reducerPath: R,
          getSelectors: Y,
          get selectors() {
            return Y(G);
          },
          selectSlice: G,
        };
      }
      const N = {
        name: l,
        reducer: j,
        actions: g.actionCreators,
        caseReducers: g.sliceCaseReducersByName,
        getInitialState: O,
        ...M(u),
        injectInto(R, { reducerPath: P, ...G } = {}) {
          const Y = P ?? u;
          return (
            R.inject({ reducerPath: Y, reducer: j }, G),
            { ...N, ...M(Y, !0) }
          );
        },
      };
      return N;
    };
  }
  function KL(t, e, n, i) {
    function a(l, ...u) {
      let d = e(l);
      return (typeof d > "u" && i && (d = n()), t(d, ...u));
    }
    return ((a.unwrapped = t), a);
  }
  var nv = ZL();
  function JL() {
    function t(e, n) {
      return { _reducerDefinitionType: "asyncThunk", payloadCreator: e, ...n };
    }
    return (
      (t.withTypes = () => t),
      {
        reducer(e) {
          return Object.assign(
            {
              [e.name](...n) {
                return e(...n);
              },
            }[e.name],
            { _reducerDefinitionType: "reducer" },
          );
        },
        preparedReducer(e, n) {
          return {
            _reducerDefinitionType: "reducerWithPrepare",
            prepare: e,
            reducer: n,
          };
        },
        asyncThunk: t,
      }
    );
  }
  function e3({ type: t, reducerName: e, createNotation: n }, i, a) {
    let l, u;
    if ("reducer" in i) {
      if (n && !n3(i)) throw new Error(ho(17));
      ((l = i.reducer), (u = i.prepare));
    } else l = i;
    a.addCase(t, l)
      .exposeCaseReducer(e, l)
      .exposeAction(e, u ? vT(t, u) : vT(t));
  }
  function t3(t) {
    return t._reducerDefinitionType === "asyncThunk";
  }
  function n3(t) {
    return t._reducerDefinitionType === "reducerWithPrepare";
  }
  function i3({ type: t, reducerName: e }, n, i, a) {
    if (!a) throw new Error(ho(18));
    const {
        payloadCreator: l,
        fulfilled: u,
        pending: d,
        rejected: m,
        settled: g,
        options: v,
      } = n,
      y = a(t, l, v);
    (i.exposeAction(e, y),
      u && i.addCase(y.fulfilled, u),
      d && i.addCase(y.pending, d),
      m && i.addCase(y.rejected, m),
      g && i.addMatcher(y.settled, g),
      i.exposeCaseReducer(e, {
        fulfilled: u || T0,
        pending: d || T0,
        rejected: m || T0,
        settled: g || T0,
      }));
  }
  function T0() {}
  function ho(t) {
    return `Minified Redux Toolkit error #${t}; visit https://redux-toolkit.js.org/Errors?code=${t} for the full message or use the non-minified dev environment for full errors. `;
  }
  const s3 = { wpNumber: "" },
    rC = nv({
      name: "wpNumberState",
      initialState: s3,
      reducers: {
        setWpNumber: (t, e) => {
          t.wpNumber = e.payload;
        },
      },
    }),
    { setWpNumber: aC } = rC.actions,
    r3 = rC.reducer,
    a3 = () => {
      const { innerData: t } = Et("home-textbooks", "home_textbooks_key"),
        e = _a();
      U.useEffect(() => {
        t &&
          t.whatsapp_textbook_number &&
          e(aC((t == null ? void 0 : t.whatsapp_textbook_number) || ""));
      }, [t]);
      const {
          fetchLessons: n,
          isInitialLoading: i,
          isLoadingMore: a,
          lastPage: l,
          lessons: u,
        } = gL(),
        [d, m] = U.useState(1),
        g = () => {
          d < l && m((v) => v + 1);
        };
      return (
        U.useEffect(() => {
          n(d);
        }, [d]),
        i
          ? h.jsx(ze, {})
          : h.jsxs("section", {
              className: "banks-grid",
              children: [
                h.jsxs("p", {
                  children: [u == null ? void 0 : u.length, " Kitab"],
                }),
                h.jsx("div", {
                  className: "grid",
                  children:
                    u == null
                      ? void 0
                      : u.map((v) =>
                          h.jsx(q2, { data: v }, v == null ? void 0 : v.id),
                        ),
                }),
                h.jsx(np, {
                  title: a ? "Yüklənir..." : "Daha çox",
                  initialValue: 12,
                  counterValue: 12,
                  dataLength: u == null ? void 0 : u.length,
                  setNext: g,
                  next: d,
                }),
              ],
            })
      );
    },
    l3 = () =>
      h.jsxs("main", {
        className: "test-banks-wrapper",
        children: [
          h.jsx("title", { children: "Dərsliklər və Test Bankları" }),
          h.jsxs("div", {
            className: "test-banks",
            children: [h.jsx(mL, {}), h.jsx(a3, {})],
          }),
        ],
      });
  function xT(t) {
    return (
      t !== null &&
      typeof t == "object" &&
      "constructor" in t &&
      t.constructor === Object
    );
  }
  function Nw(t, e) {
    (t === void 0 && (t = {}), e === void 0 && (e = {}));
    const n = ["__proto__", "constructor", "prototype"];
    Object.keys(e)
      .filter((i) => n.indexOf(i) < 0)
      .forEach((i) => {
        typeof t[i] > "u"
          ? (t[i] = e[i])
          : xT(e[i]) &&
            xT(t[i]) &&
            Object.keys(e[i]).length > 0 &&
            Nw(t[i], e[i]);
      });
  }
  const lC = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: { blur() {}, nodeName: "" },
    querySelector() {
      return null;
    },
    querySelectorAll() {
      return [];
    },
    getElementById() {
      return null;
    },
    createEvent() {
      return { initEvent() {} };
    },
    createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute() {},
        getElementsByTagName() {
          return [];
        },
      };
    },
    createElementNS() {
      return {};
    },
    importNode() {
      return null;
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
  };
  function ml() {
    const t = typeof document < "u" ? document : {};
    return (Nw(t, lC), t);
  }
  const o3 = {
    document: lC,
    navigator: { userAgent: "" },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
    CustomEvent: function () {
      return this;
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle() {
      return {
        getPropertyValue() {
          return "";
        },
      };
    },
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia() {
      return {};
    },
    requestAnimationFrame(t) {
      return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
    },
    cancelAnimationFrame(t) {
      typeof setTimeout > "u" || clearTimeout(t);
    },
  };
  function bs() {
    const t = typeof window < "u" ? window : {};
    return (Nw(t, o3), t);
  }
  function c3(t) {
    return (
      t === void 0 && (t = ""),
      t
        .trim()
        .split(" ")
        .filter((e) => !!e.trim())
    );
  }
  function u3(t) {
    const e = t;
    Object.keys(e).forEach((n) => {
      try {
        e[n] = null;
      } catch {}
      try {
        delete e[n];
      } catch {}
    });
  }
  function oC(t, e) {
    return (e === void 0 && (e = 0), setTimeout(t, e));
  }
  function hb() {
    return Date.now();
  }
  function f3(t) {
    const e = bs();
    let n;
    return (
      e.getComputedStyle && (n = e.getComputedStyle(t, null)),
      !n && t.currentStyle && (n = t.currentStyle),
      n || (n = t.style),
      n
    );
  }
  function d3(t, e) {
    e === void 0 && (e = "x");
    const n = bs();
    let i, a, l;
    const u = f3(t);
    return (
      n.WebKitCSSMatrix
        ? ((a = u.transform || u.webkitTransform),
          a.split(",").length > 6 &&
            (a = a
              .split(", ")
              .map((d) => d.replace(",", "."))
              .join(", ")),
          (l = new n.WebKitCSSMatrix(a === "none" ? "" : a)))
        : ((l =
            u.MozTransform ||
            u.OTransform ||
            u.MsTransform ||
            u.msTransform ||
            u.transform ||
            u
              .getPropertyValue("transform")
              .replace("translate(", "matrix(1, 0, 0, 1,")),
          (i = l.toString().split(","))),
      e === "x" &&
        (n.WebKitCSSMatrix
          ? (a = l.m41)
          : i.length === 16
            ? (a = parseFloat(i[12]))
            : (a = parseFloat(i[4]))),
      e === "y" &&
        (n.WebKitCSSMatrix
          ? (a = l.m42)
          : i.length === 16
            ? (a = parseFloat(i[13]))
            : (a = parseFloat(i[5]))),
      a || 0
    );
  }
  function E0(t) {
    return (
      typeof t == "object" &&
      t !== null &&
      t.constructor &&
      Object.prototype.toString.call(t).slice(8, -1) === "Object"
    );
  }
  function h3(t) {
    return typeof window < "u" && typeof window.HTMLElement < "u"
      ? t instanceof HTMLElement
      : t && (t.nodeType === 1 || t.nodeType === 11);
  }
  function dr() {
    const t = Object(arguments.length <= 0 ? void 0 : arguments[0]),
      e = ["__proto__", "constructor", "prototype"];
    for (let n = 1; n < arguments.length; n += 1) {
      const i = n < 0 || arguments.length <= n ? void 0 : arguments[n];
      if (i != null && !h3(i)) {
        const a = Object.keys(Object(i)).filter((l) => e.indexOf(l) < 0);
        for (let l = 0, u = a.length; l < u; l += 1) {
          const d = a[l],
            m = Object.getOwnPropertyDescriptor(i, d);
          m !== void 0 &&
            m.enumerable &&
            (E0(t[d]) && E0(i[d])
              ? i[d].__swiper__
                ? (t[d] = i[d])
                : dr(t[d], i[d])
              : !E0(t[d]) && E0(i[d])
                ? ((t[d] = {}),
                  i[d].__swiper__ ? (t[d] = i[d]) : dr(t[d], i[d]))
                : (t[d] = i[d]));
        }
      }
    }
    return t;
  }
  function C0(t, e, n) {
    t.style.setProperty(e, n);
  }
  function cC(t) {
    let { swiper: e, targetPosition: n, side: i } = t;
    const a = bs(),
      l = -e.translate;
    let u = null,
      d;
    const m = e.params.speed;
    ((e.wrapperEl.style.scrollSnapType = "none"),
      a.cancelAnimationFrame(e.cssModeFrameID));
    const g = n > l ? "next" : "prev",
      v = (w, S) => (g === "next" && w >= S) || (g === "prev" && w <= S),
      y = () => {
        ((d = new Date().getTime()), u === null && (u = d));
        const w = Math.max(Math.min((d - u) / m, 1), 0),
          S = 0.5 - Math.cos(w * Math.PI) / 2;
        let T = l + S * (n - l);
        if ((v(T, n) && (T = n), e.wrapperEl.scrollTo({ [i]: T }), v(T, n))) {
          ((e.wrapperEl.style.overflow = "hidden"),
            (e.wrapperEl.style.scrollSnapType = ""),
            setTimeout(() => {
              ((e.wrapperEl.style.overflow = ""),
                e.wrapperEl.scrollTo({ [i]: T }));
            }),
            a.cancelAnimationFrame(e.cssModeFrameID));
          return;
        }
        e.cssModeFrameID = a.requestAnimationFrame(y);
      };
    y();
  }
  function dl(t, e) {
    e === void 0 && (e = "");
    const n = bs(),
      i = [...t.children];
    return (
      n.HTMLSlotElement &&
        t instanceof HTMLSlotElement &&
        i.push(...t.assignedElements()),
      e ? i.filter((a) => a.matches(e)) : i
    );
  }
  function p3(t, e) {
    const n = [e];
    for (; n.length > 0; ) {
      const i = n.shift();
      if (t === i) return !0;
      n.push(
        ...i.children,
        ...(i.shadowRoot ? i.shadowRoot.children : []),
        ...(i.assignedElements ? i.assignedElements() : []),
      );
    }
  }
  function m3(t, e) {
    const n = bs();
    let i = e.contains(t);
    return (
      !i &&
        n.HTMLSlotElement &&
        e instanceof HTMLSlotElement &&
        ((i = [...e.assignedElements()].includes(t)), i || (i = p3(t, e))),
      i
    );
  }
  function pb(t) {
    try {
      console.warn(t);
      return;
    } catch {}
  }
  function mb(t, e) {
    e === void 0 && (e = []);
    const n = document.createElement(t);
    return (n.classList.add(...(Array.isArray(e) ? e : c3(e))), n);
  }
  function g3(t, e) {
    const n = [];
    for (; t.previousElementSibling; ) {
      const i = t.previousElementSibling;
      (e ? i.matches(e) && n.push(i) : n.push(i), (t = i));
    }
    return n;
  }
  function v3(t, e) {
    const n = [];
    for (; t.nextElementSibling; ) {
      const i = t.nextElementSibling;
      (e ? i.matches(e) && n.push(i) : n.push(i), (t = i));
    }
    return n;
  }
  function Rc(t, e) {
    return bs().getComputedStyle(t, null).getPropertyValue(e);
  }
  function gb(t) {
    let e = t,
      n;
    if (e) {
      for (n = 0; (e = e.previousSibling) !== null; )
        e.nodeType === 1 && (n += 1);
      return n;
    }
  }
  function uC(t, e) {
    const n = [];
    let i = t.parentElement;
    for (; i; )
      (e ? i.matches(e) && n.push(i) : n.push(i), (i = i.parentElement));
    return n;
  }
  function Y_(t, e, n) {
    const i = bs();
    return (
      t[e === "width" ? "offsetWidth" : "offsetHeight"] +
      parseFloat(
        i
          .getComputedStyle(t, null)
          .getPropertyValue(e === "width" ? "margin-right" : "margin-top"),
      ) +
      parseFloat(
        i
          .getComputedStyle(t, null)
          .getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"),
      )
    );
  }
  function Kl(t) {
    return (Array.isArray(t) ? t : [t]).filter((e) => !!e);
  }
  function vb(t, e) {
    (e === void 0 && (e = ""),
      typeof trustedTypes < "u"
        ? (t.innerHTML = trustedTypes
            .createPolicy("html", { createHTML: (n) => n })
            .createHTML(e))
        : (t.innerHTML = e));
  }
  let Ox;
  function y3() {
    const t = bs(),
      e = ml();
    return {
      smoothScroll:
        e.documentElement &&
        e.documentElement.style &&
        "scrollBehavior" in e.documentElement.style,
      touch: !!(
        "ontouchstart" in t ||
        (t.DocumentTouch && e instanceof t.DocumentTouch)
      ),
    };
  }
  function fC() {
    return (Ox || (Ox = y3()), Ox);
  }
  let jx;
  function b3(t) {
    let { userAgent: e } = t === void 0 ? {} : t;
    const n = fC(),
      i = bs(),
      a = i.navigator.platform,
      l = e || i.navigator.userAgent,
      u = { ios: !1, android: !1 },
      d = i.screen.width,
      m = i.screen.height,
      g = l.match(/(Android);?[\s\/]+([\d.]+)?/);
    let v = l.match(/(iPad).*OS\s([\d_]+)/);
    const y = l.match(/(iPod)(.*OS\s([\d_]+))?/),
      w = !v && l.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
      S = a === "Win32";
    let T = a === "MacIntel";
    const E = [
      "1024x1366",
      "1366x1024",
      "834x1194",
      "1194x834",
      "834x1112",
      "1112x834",
      "768x1024",
      "1024x768",
      "820x1180",
      "1180x820",
      "810x1080",
      "1080x810",
    ];
    return (
      !v &&
        T &&
        n.touch &&
        E.indexOf(`${d}x${m}`) >= 0 &&
        ((v = l.match(/(Version)\/([\d.]+)/)),
        v || (v = [0, 1, "13_0_0"]),
        (T = !1)),
      g && !S && ((u.os = "android"), (u.android = !0)),
      (v || w || y) && ((u.os = "ios"), (u.ios = !0)),
      u
    );
  }
  function dC(t) {
    return (t === void 0 && (t = {}), jx || (jx = b3(t)), jx);
  }
  let Mx;
  function x3() {
    const t = bs(),
      e = dC();
    let n = !1;
    function i() {
      const d = t.navigator.userAgent.toLowerCase();
      return (
        d.indexOf("safari") >= 0 &&
        d.indexOf("chrome") < 0 &&
        d.indexOf("android") < 0
      );
    }
    if (i()) {
      const d = String(t.navigator.userAgent);
      if (d.includes("Version/")) {
        const [m, g] = d
          .split("Version/")[1]
          .split(" ")[0]
          .split(".")
          .map((v) => Number(v));
        n = m < 16 || (m === 16 && g < 2);
      }
    }
    const a = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
        t.navigator.userAgent,
      ),
      l = i(),
      u = l || (a && e.ios);
    return {
      isSafari: n || l,
      needPerspectiveFix: n,
      need3dFix: u,
      isWebView: a,
    };
  }
  function hC() {
    return (Mx || (Mx = x3()), Mx);
  }
  function _3(t) {
    let { swiper: e, on: n, emit: i } = t;
    const a = bs();
    let l = null,
      u = null;
    const d = () => {
        !e || e.destroyed || !e.initialized || (i("beforeResize"), i("resize"));
      },
      m = () => {
        !e ||
          e.destroyed ||
          !e.initialized ||
          ((l = new ResizeObserver((y) => {
            u = a.requestAnimationFrame(() => {
              const { width: w, height: S } = e;
              let T = w,
                E = S;
              (y.forEach((j) => {
                let { contentBoxSize: O, contentRect: M, target: N } = j;
                (N && N !== e.el) ||
                  ((T = M ? M.width : (O[0] || O).inlineSize),
                  (E = M ? M.height : (O[0] || O).blockSize));
              }),
                (T !== w || E !== S) && d());
            });
          })),
          l.observe(e.el));
      },
      g = () => {
        (u && a.cancelAnimationFrame(u),
          l && l.unobserve && e.el && (l.unobserve(e.el), (l = null)));
      },
      v = () => {
        !e || e.destroyed || !e.initialized || i("orientationchange");
      };
    (n("init", () => {
      if (e.params.resizeObserver && typeof a.ResizeObserver < "u") {
        m();
        return;
      }
      (a.addEventListener("resize", d),
        a.addEventListener("orientationchange", v));
    }),
      n("destroy", () => {
        (g(),
          a.removeEventListener("resize", d),
          a.removeEventListener("orientationchange", v));
      }));
  }
  function w3(t) {
    let { swiper: e, extendParams: n, on: i, emit: a } = t;
    const l = [],
      u = bs(),
      d = function (v, y) {
        y === void 0 && (y = {});
        const w = u.MutationObserver || u.WebkitMutationObserver,
          S = new w((T) => {
            if (e.__preventObserver__) return;
            if (T.length === 1) {
              a("observerUpdate", T[0]);
              return;
            }
            const E = function () {
              a("observerUpdate", T[0]);
            };
            u.requestAnimationFrame
              ? u.requestAnimationFrame(E)
              : u.setTimeout(E, 0);
          });
        (S.observe(v, {
          attributes: typeof y.attributes > "u" ? !0 : y.attributes,
          childList:
            e.isElement || (typeof y.childList > "u" ? !0 : y).childList,
          characterData: typeof y.characterData > "u" ? !0 : y.characterData,
        }),
          l.push(S));
      },
      m = () => {
        if (e.params.observer) {
          if (e.params.observeParents) {
            const v = uC(e.hostEl);
            for (let y = 0; y < v.length; y += 1) d(v[y]);
          }
          (d(e.hostEl, { childList: e.params.observeSlideChildren }),
            d(e.wrapperEl, { attributes: !1 }));
        }
      },
      g = () => {
        (l.forEach((v) => {
          v.disconnect();
        }),
          l.splice(0, l.length));
      };
    (n({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
      i("init", m),
      i("destroy", g));
  }
  var S3 = {
    on(t, e, n) {
      const i = this;
      if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
      const a = n ? "unshift" : "push";
      return (
        t.split(" ").forEach((l) => {
          (i.eventsListeners[l] || (i.eventsListeners[l] = []),
            i.eventsListeners[l][a](e));
        }),
        i
      );
    },
    once(t, e, n) {
      const i = this;
      if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
      function a() {
        (i.off(t, a), a.__emitterProxy && delete a.__emitterProxy);
        for (var l = arguments.length, u = new Array(l), d = 0; d < l; d++)
          u[d] = arguments[d];
        e.apply(i, u);
      }
      return ((a.__emitterProxy = e), i.on(t, a, n));
    },
    onAny(t, e) {
      const n = this;
      if (!n.eventsListeners || n.destroyed || typeof t != "function") return n;
      const i = e ? "unshift" : "push";
      return (
        n.eventsAnyListeners.indexOf(t) < 0 && n.eventsAnyListeners[i](t),
        n
      );
    },
    offAny(t) {
      const e = this;
      if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
      const n = e.eventsAnyListeners.indexOf(t);
      return (n >= 0 && e.eventsAnyListeners.splice(n, 1), e);
    },
    off(t, e) {
      const n = this;
      return (
        !n.eventsListeners ||
          n.destroyed ||
          !n.eventsListeners ||
          t.split(" ").forEach((i) => {
            typeof e > "u"
              ? (n.eventsListeners[i] = [])
              : n.eventsListeners[i] &&
                n.eventsListeners[i].forEach((a, l) => {
                  (a === e || (a.__emitterProxy && a.__emitterProxy === e)) &&
                    n.eventsListeners[i].splice(l, 1);
                });
          }),
        n
      );
    },
    emit() {
      const t = this;
      if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
      let e, n, i;
      for (var a = arguments.length, l = new Array(a), u = 0; u < a; u++)
        l[u] = arguments[u];
      return (
        typeof l[0] == "string" || Array.isArray(l[0])
          ? ((e = l[0]), (n = l.slice(1, l.length)), (i = t))
          : ((e = l[0].events), (n = l[0].data), (i = l[0].context || t)),
        n.unshift(i),
        (Array.isArray(e) ? e : e.split(" ")).forEach((m) => {
          (t.eventsAnyListeners &&
            t.eventsAnyListeners.length &&
            t.eventsAnyListeners.forEach((g) => {
              g.apply(i, [m, ...n]);
            }),
            t.eventsListeners &&
              t.eventsListeners[m] &&
              t.eventsListeners[m].forEach((g) => {
                g.apply(i, n);
              }));
        }),
        t
      );
    },
  };
  function T3() {
    const t = this;
    let e, n;
    const i = t.el;
    (typeof t.params.width < "u" && t.params.width !== null
      ? (e = t.params.width)
      : (e = i.clientWidth),
      typeof t.params.height < "u" && t.params.height !== null
        ? (n = t.params.height)
        : (n = i.clientHeight),
      !((e === 0 && t.isHorizontal()) || (n === 0 && t.isVertical())) &&
        ((e =
          e -
          parseInt(Rc(i, "padding-left") || 0, 10) -
          parseInt(Rc(i, "padding-right") || 0, 10)),
        (n =
          n -
          parseInt(Rc(i, "padding-top") || 0, 10) -
          parseInt(Rc(i, "padding-bottom") || 0, 10)),
        Number.isNaN(e) && (e = 0),
        Number.isNaN(n) && (n = 0),
        Object.assign(t, {
          width: e,
          height: n,
          size: t.isHorizontal() ? e : n,
        })));
  }
  function E3() {
    const t = this;
    function e(H, X) {
      return parseFloat(H.getPropertyValue(t.getDirectionLabel(X)) || 0);
    }
    const n = t.params,
      { wrapperEl: i, slidesEl: a, size: l, rtlTranslate: u, wrongRTL: d } = t,
      m = t.virtual && n.virtual.enabled,
      g = m ? t.virtual.slides.length : t.slides.length,
      v = dl(a, `.${t.params.slideClass}, swiper-slide`),
      y = m ? t.virtual.slides.length : v.length;
    let w = [];
    const S = [],
      T = [];
    let E = n.slidesOffsetBefore;
    typeof E == "function" && (E = n.slidesOffsetBefore.call(t));
    let j = n.slidesOffsetAfter;
    typeof j == "function" && (j = n.slidesOffsetAfter.call(t));
    const O = t.snapGrid.length,
      M = t.slidesGrid.length;
    let N = n.spaceBetween,
      R = -E,
      P = 0,
      G = 0;
    if (typeof l > "u") return;
    (typeof N == "string" && N.indexOf("%") >= 0
      ? (N = (parseFloat(N.replace("%", "")) / 100) * l)
      : typeof N == "string" && (N = parseFloat(N)),
      (t.virtualSize = -N),
      v.forEach((H) => {
        (u ? (H.style.marginLeft = "") : (H.style.marginRight = ""),
          (H.style.marginBottom = ""),
          (H.style.marginTop = ""));
      }),
      n.centeredSlides &&
        n.cssMode &&
        (C0(i, "--swiper-centered-offset-before", ""),
        C0(i, "--swiper-centered-offset-after", "")));
    const Y = n.grid && n.grid.rows > 1 && t.grid;
    Y ? t.grid.initSlides(v) : t.grid && t.grid.unsetSlides();
    let B;
    const I =
      n.slidesPerView === "auto" &&
      n.breakpoints &&
      Object.keys(n.breakpoints).filter(
        (H) => typeof n.breakpoints[H].slidesPerView < "u",
      ).length > 0;
    for (let H = 0; H < y; H += 1) {
      B = 0;
      let X;
      if (
        (v[H] && (X = v[H]),
        Y && t.grid.updateSlide(H, X, v),
        !(v[H] && Rc(X, "display") === "none"))
      ) {
        if (n.slidesPerView === "auto") {
          I && (v[H].style[t.getDirectionLabel("width")] = "");
          const fe = getComputedStyle(X),
            ve = X.style.transform,
            be = X.style.webkitTransform;
          if (
            (ve && (X.style.transform = "none"),
            be && (X.style.webkitTransform = "none"),
            n.roundLengths)
          )
            B = t.isHorizontal() ? Y_(X, "width") : Y_(X, "height");
          else {
            const Oe = e(fe, "width"),
              V = e(fe, "padding-left"),
              pe = e(fe, "padding-right"),
              de = e(fe, "margin-left"),
              he = e(fe, "margin-right"),
              Te = fe.getPropertyValue("box-sizing");
            if (Te && Te === "border-box") B = Oe + de + he;
            else {
              const { clientWidth: F, offsetWidth: ae } = X;
              B = Oe + V + pe + de + he + (ae - F);
            }
          }
          (ve && (X.style.transform = ve),
            be && (X.style.webkitTransform = be),
            n.roundLengths && (B = Math.floor(B)));
        } else
          ((B = (l - (n.slidesPerView - 1) * N) / n.slidesPerView),
            n.roundLengths && (B = Math.floor(B)),
            v[H] && (v[H].style[t.getDirectionLabel("width")] = `${B}px`));
        (v[H] && (v[H].swiperSlideSize = B),
          T.push(B),
          n.centeredSlides
            ? ((R = R + B / 2 + P / 2 + N),
              P === 0 && H !== 0 && (R = R - l / 2 - N),
              H === 0 && (R = R - l / 2 - N),
              Math.abs(R) < 1 / 1e3 && (R = 0),
              n.roundLengths && (R = Math.floor(R)),
              G % n.slidesPerGroup === 0 && w.push(R),
              S.push(R))
            : (n.roundLengths && (R = Math.floor(R)),
              (G - Math.min(t.params.slidesPerGroupSkip, G)) %
                t.params.slidesPerGroup ===
                0 && w.push(R),
              S.push(R),
              (R = R + B + N)),
          (t.virtualSize += B + N),
          (P = B),
          (G += 1));
      }
    }
    if (
      ((t.virtualSize = Math.max(t.virtualSize, l) + j),
      u &&
        d &&
        (n.effect === "slide" || n.effect === "coverflow") &&
        (i.style.width = `${t.virtualSize + N}px`),
      n.setWrapperSize &&
        (i.style[t.getDirectionLabel("width")] = `${t.virtualSize + N}px`),
      Y && t.grid.updateWrapperSize(B, w),
      !n.centeredSlides)
    ) {
      const H = [];
      for (let X = 0; X < w.length; X += 1) {
        let fe = w[X];
        (n.roundLengths && (fe = Math.floor(fe)),
          w[X] <= t.virtualSize - l && H.push(fe));
      }
      ((w = H),
        Math.floor(t.virtualSize - l) - Math.floor(w[w.length - 1]) > 1 &&
          w.push(t.virtualSize - l));
    }
    if (m && n.loop) {
      const H = T[0] + N;
      if (n.slidesPerGroup > 1) {
        const X = Math.ceil(
            (t.virtual.slidesBefore + t.virtual.slidesAfter) / n.slidesPerGroup,
          ),
          fe = H * n.slidesPerGroup;
        for (let ve = 0; ve < X; ve += 1) w.push(w[w.length - 1] + fe);
      }
      for (
        let X = 0;
        X < t.virtual.slidesBefore + t.virtual.slidesAfter;
        X += 1
      )
        (n.slidesPerGroup === 1 && w.push(w[w.length - 1] + H),
          S.push(S[S.length - 1] + H),
          (t.virtualSize += H));
    }
    if ((w.length === 0 && (w = [0]), N !== 0)) {
      const H =
        t.isHorizontal() && u
          ? "marginLeft"
          : t.getDirectionLabel("marginRight");
      v.filter((X, fe) =>
        !n.cssMode || n.loop ? !0 : fe !== v.length - 1,
      ).forEach((X) => {
        X.style[H] = `${N}px`;
      });
    }
    if (n.centeredSlides && n.centeredSlidesBounds) {
      let H = 0;
      (T.forEach((fe) => {
        H += fe + (N || 0);
      }),
        (H -= N));
      const X = H > l ? H - l : 0;
      w = w.map((fe) => (fe <= 0 ? -E : fe > X ? X + j : fe));
    }
    if (n.centerInsufficientSlides) {
      let H = 0;
      (T.forEach((fe) => {
        H += fe + (N || 0);
      }),
        (H -= N));
      const X = (n.slidesOffsetBefore || 0) + (n.slidesOffsetAfter || 0);
      if (H + X < l) {
        const fe = (l - H - X) / 2;
        (w.forEach((ve, be) => {
          w[be] = ve - fe;
        }),
          S.forEach((ve, be) => {
            S[be] = ve + fe;
          }));
      }
    }
    if (
      (Object.assign(t, {
        slides: v,
        snapGrid: w,
        slidesGrid: S,
        slidesSizesGrid: T,
      }),
      n.centeredSlides && n.cssMode && !n.centeredSlidesBounds)
    ) {
      (C0(i, "--swiper-centered-offset-before", `${-w[0]}px`),
        C0(
          i,
          "--swiper-centered-offset-after",
          `${t.size / 2 - T[T.length - 1] / 2}px`,
        ));
      const H = -t.snapGrid[0],
        X = -t.slidesGrid[0];
      ((t.snapGrid = t.snapGrid.map((fe) => fe + H)),
        (t.slidesGrid = t.slidesGrid.map((fe) => fe + X)));
    }
    if (
      (y !== g && t.emit("slidesLengthChange"),
      w.length !== O &&
        (t.params.watchOverflow && t.checkOverflow(),
        t.emit("snapGridLengthChange")),
      S.length !== M && t.emit("slidesGridLengthChange"),
      n.watchSlidesProgress && t.updateSlidesOffset(),
      t.emit("slidesUpdated"),
      !m && !n.cssMode && (n.effect === "slide" || n.effect === "fade"))
    ) {
      const H = `${n.containerModifierClass}backface-hidden`,
        X = t.el.classList.contains(H);
      y <= n.maxBackfaceHiddenSlides
        ? X || t.el.classList.add(H)
        : X && t.el.classList.remove(H);
    }
  }
  function C3(t) {
    const e = this,
      n = [],
      i = e.virtual && e.params.virtual.enabled;
    let a = 0,
      l;
    typeof t == "number"
      ? e.setTransition(t)
      : t === !0 && e.setTransition(e.params.speed);
    const u = (d) => (i ? e.slides[e.getSlideIndexByData(d)] : e.slides[d]);
    if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
      if (e.params.centeredSlides)
        (e.visibleSlides || []).forEach((d) => {
          n.push(d);
        });
      else
        for (l = 0; l < Math.ceil(e.params.slidesPerView); l += 1) {
          const d = e.activeIndex + l;
          if (d > e.slides.length && !i) break;
          n.push(u(d));
        }
    else n.push(u(e.activeIndex));
    for (l = 0; l < n.length; l += 1)
      if (typeof n[l] < "u") {
        const d = n[l].offsetHeight;
        a = d > a ? d : a;
      }
    (a || a === 0) && (e.wrapperEl.style.height = `${a}px`);
  }
  function O3() {
    const t = this,
      e = t.slides,
      n = t.isElement
        ? t.isHorizontal()
          ? t.wrapperEl.offsetLeft
          : t.wrapperEl.offsetTop
        : 0;
    for (let i = 0; i < e.length; i += 1)
      e[i].swiperSlideOffset =
        (t.isHorizontal() ? e[i].offsetLeft : e[i].offsetTop) -
        n -
        t.cssOverflowAdjustment();
  }
  const _T = (t, e, n) => {
    e && !t.classList.contains(n)
      ? t.classList.add(n)
      : !e && t.classList.contains(n) && t.classList.remove(n);
  };
  function j3(t) {
    t === void 0 && (t = (this && this.translate) || 0);
    const e = this,
      n = e.params,
      { slides: i, rtlTranslate: a, snapGrid: l } = e;
    if (i.length === 0) return;
    typeof i[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
    let u = -t;
    (a && (u = t), (e.visibleSlidesIndexes = []), (e.visibleSlides = []));
    let d = n.spaceBetween;
    typeof d == "string" && d.indexOf("%") >= 0
      ? (d = (parseFloat(d.replace("%", "")) / 100) * e.size)
      : typeof d == "string" && (d = parseFloat(d));
    for (let m = 0; m < i.length; m += 1) {
      const g = i[m];
      let v = g.swiperSlideOffset;
      n.cssMode && n.centeredSlides && (v -= i[0].swiperSlideOffset);
      const y =
          (u + (n.centeredSlides ? e.minTranslate() : 0) - v) /
          (g.swiperSlideSize + d),
        w =
          (u - l[0] + (n.centeredSlides ? e.minTranslate() : 0) - v) /
          (g.swiperSlideSize + d),
        S = -(u - v),
        T = S + e.slidesSizesGrid[m],
        E = S >= 0 && S <= e.size - e.slidesSizesGrid[m],
        j =
          (S >= 0 && S < e.size - 1) ||
          (T > 1 && T <= e.size) ||
          (S <= 0 && T >= e.size);
      (j && (e.visibleSlides.push(g), e.visibleSlidesIndexes.push(m)),
        _T(g, j, n.slideVisibleClass),
        _T(g, E, n.slideFullyVisibleClass),
        (g.progress = a ? -y : y),
        (g.originalProgress = a ? -w : w));
    }
  }
  function M3(t) {
    const e = this;
    if (typeof t > "u") {
      const v = e.rtlTranslate ? -1 : 1;
      t = (e && e.translate && e.translate * v) || 0;
    }
    const n = e.params,
      i = e.maxTranslate() - e.minTranslate();
    let { progress: a, isBeginning: l, isEnd: u, progressLoop: d } = e;
    const m = l,
      g = u;
    if (i === 0) ((a = 0), (l = !0), (u = !0));
    else {
      a = (t - e.minTranslate()) / i;
      const v = Math.abs(t - e.minTranslate()) < 1,
        y = Math.abs(t - e.maxTranslate()) < 1;
      ((l = v || a <= 0), (u = y || a >= 1), v && (a = 0), y && (a = 1));
    }
    if (n.loop) {
      const v = e.getSlideIndexByData(0),
        y = e.getSlideIndexByData(e.slides.length - 1),
        w = e.slidesGrid[v],
        S = e.slidesGrid[y],
        T = e.slidesGrid[e.slidesGrid.length - 1],
        E = Math.abs(t);
      (E >= w ? (d = (E - w) / T) : (d = (E + T - S) / T), d > 1 && (d -= 1));
    }
    (Object.assign(e, {
      progress: a,
      progressLoop: d,
      isBeginning: l,
      isEnd: u,
    }),
      (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) &&
        e.updateSlidesProgress(t),
      l && !m && e.emit("reachBeginning toEdge"),
      u && !g && e.emit("reachEnd toEdge"),
      ((m && !l) || (g && !u)) && e.emit("fromEdge"),
      e.emit("progress", a));
  }
  const Nx = (t, e, n) => {
    e && !t.classList.contains(n)
      ? t.classList.add(n)
      : !e && t.classList.contains(n) && t.classList.remove(n);
  };
  function N3() {
    const t = this,
      { slides: e, params: n, slidesEl: i, activeIndex: a } = t,
      l = t.virtual && n.virtual.enabled,
      u = t.grid && n.grid && n.grid.rows > 1,
      d = (y) => dl(i, `.${n.slideClass}${y}, swiper-slide${y}`)[0];
    let m, g, v;
    if (l)
      if (n.loop) {
        let y = a - t.virtual.slidesBefore;
        (y < 0 && (y = t.virtual.slides.length + y),
          y >= t.virtual.slides.length && (y -= t.virtual.slides.length),
          (m = d(`[data-swiper-slide-index="${y}"]`)));
      } else m = d(`[data-swiper-slide-index="${a}"]`);
    else
      u
        ? ((m = e.find((y) => y.column === a)),
          (v = e.find((y) => y.column === a + 1)),
          (g = e.find((y) => y.column === a - 1)))
        : (m = e[a]);
    (m &&
      (u ||
        ((v = v3(m, `.${n.slideClass}, swiper-slide`)[0]),
        n.loop && !v && (v = e[0]),
        (g = g3(m, `.${n.slideClass}, swiper-slide`)[0]),
        n.loop && !g === 0 && (g = e[e.length - 1]))),
      e.forEach((y) => {
        (Nx(y, y === m, n.slideActiveClass),
          Nx(y, y === v, n.slideNextClass),
          Nx(y, y === g, n.slidePrevClass));
      }),
      t.emitSlidesClasses());
  }
  const Q0 = (t, e) => {
      if (!t || t.destroyed || !t.params) return;
      const n = () =>
          t.isElement ? "swiper-slide" : `.${t.params.slideClass}`,
        i = e.closest(n());
      if (i) {
        let a = i.querySelector(`.${t.params.lazyPreloaderClass}`);
        (!a &&
          t.isElement &&
          (i.shadowRoot
            ? (a = i.shadowRoot.querySelector(
                `.${t.params.lazyPreloaderClass}`,
              ))
            : requestAnimationFrame(() => {
                i.shadowRoot &&
                  ((a = i.shadowRoot.querySelector(
                    `.${t.params.lazyPreloaderClass}`,
                  )),
                  a && a.remove());
              })),
          a && a.remove());
      }
    },
    Ax = (t, e) => {
      if (!t.slides[e]) return;
      const n = t.slides[e].querySelector('[loading="lazy"]');
      n && n.removeAttribute("loading");
    },
    q_ = (t) => {
      if (!t || t.destroyed || !t.params) return;
      let e = t.params.lazyPreloadPrevNext;
      const n = t.slides.length;
      if (!n || !e || e < 0) return;
      e = Math.min(e, n);
      const i =
          t.params.slidesPerView === "auto"
            ? t.slidesPerViewDynamic()
            : Math.ceil(t.params.slidesPerView),
        a = t.activeIndex;
      if (t.params.grid && t.params.grid.rows > 1) {
        const u = a,
          d = [u - e];
        (d.push(...Array.from({ length: e }).map((m, g) => u + i + g)),
          t.slides.forEach((m, g) => {
            d.includes(m.column) && Ax(t, g);
          }));
        return;
      }
      const l = a + i - 1;
      if (t.params.rewind || t.params.loop)
        for (let u = a - e; u <= l + e; u += 1) {
          const d = ((u % n) + n) % n;
          (d < a || d > l) && Ax(t, d);
        }
      else
        for (let u = Math.max(a - e, 0); u <= Math.min(l + e, n - 1); u += 1)
          u !== a && (u > l || u < a) && Ax(t, u);
    };
  function A3(t) {
    const { slidesGrid: e, params: n } = t,
      i = t.rtlTranslate ? t.translate : -t.translate;
    let a;
    for (let l = 0; l < e.length; l += 1)
      typeof e[l + 1] < "u"
        ? i >= e[l] && i < e[l + 1] - (e[l + 1] - e[l]) / 2
          ? (a = l)
          : i >= e[l] && i < e[l + 1] && (a = l + 1)
        : i >= e[l] && (a = l);
    return (n.normalizeSlideIndex && (a < 0 || typeof a > "u") && (a = 0), a);
  }
  function R3(t) {
    const e = this,
      n = e.rtlTranslate ? e.translate : -e.translate,
      {
        snapGrid: i,
        params: a,
        activeIndex: l,
        realIndex: u,
        snapIndex: d,
      } = e;
    let m = t,
      g;
    const v = (S) => {
      let T = S - e.virtual.slidesBefore;
      return (
        T < 0 && (T = e.virtual.slides.length + T),
        T >= e.virtual.slides.length && (T -= e.virtual.slides.length),
        T
      );
    };
    if ((typeof m > "u" && (m = A3(e)), i.indexOf(n) >= 0)) g = i.indexOf(n);
    else {
      const S = Math.min(a.slidesPerGroupSkip, m);
      g = S + Math.floor((m - S) / a.slidesPerGroup);
    }
    if ((g >= i.length && (g = i.length - 1), m === l && !e.params.loop)) {
      g !== d && ((e.snapIndex = g), e.emit("snapIndexChange"));
      return;
    }
    if (m === l && e.params.loop && e.virtual && e.params.virtual.enabled) {
      e.realIndex = v(m);
      return;
    }
    const y = e.grid && a.grid && a.grid.rows > 1;
    let w;
    if (e.virtual && a.virtual.enabled && a.loop) w = v(m);
    else if (y) {
      const S = e.slides.find((E) => E.column === m);
      let T = parseInt(S.getAttribute("data-swiper-slide-index"), 10);
      (Number.isNaN(T) && (T = Math.max(e.slides.indexOf(S), 0)),
        (w = Math.floor(T / a.grid.rows)));
    } else if (e.slides[m]) {
      const S = e.slides[m].getAttribute("data-swiper-slide-index");
      S ? (w = parseInt(S, 10)) : (w = m);
    } else w = m;
    (Object.assign(e, {
      previousSnapIndex: d,
      snapIndex: g,
      previousRealIndex: u,
      realIndex: w,
      previousIndex: l,
      activeIndex: m,
    }),
      e.initialized && q_(e),
      e.emit("activeIndexChange"),
      e.emit("snapIndexChange"),
      (e.initialized || e.params.runCallbacksOnInit) &&
        (u !== w && e.emit("realIndexChange"), e.emit("slideChange")));
  }
  function L3(t, e) {
    const n = this,
      i = n.params;
    let a = t.closest(`.${i.slideClass}, swiper-slide`);
    !a &&
      n.isElement &&
      e &&
      e.length > 1 &&
      e.includes(t) &&
      [...e.slice(e.indexOf(t) + 1, e.length)].forEach((d) => {
        !a &&
          d.matches &&
          d.matches(`.${i.slideClass}, swiper-slide`) &&
          (a = d);
      });
    let l = !1,
      u;
    if (a) {
      for (let d = 0; d < n.slides.length; d += 1)
        if (n.slides[d] === a) {
          ((l = !0), (u = d));
          break;
        }
    }
    if (a && l)
      ((n.clickedSlide = a),
        n.virtual && n.params.virtual.enabled
          ? (n.clickedIndex = parseInt(
              a.getAttribute("data-swiper-slide-index"),
              10,
            ))
          : (n.clickedIndex = u));
    else {
      ((n.clickedSlide = void 0), (n.clickedIndex = void 0));
      return;
    }
    i.slideToClickedSlide &&
      n.clickedIndex !== void 0 &&
      n.clickedIndex !== n.activeIndex &&
      n.slideToClickedSlide();
  }
  var D3 = {
    updateSize: T3,
    updateSlides: E3,
    updateAutoHeight: C3,
    updateSlidesOffset: O3,
    updateSlidesProgress: j3,
    updateProgress: M3,
    updateSlidesClasses: N3,
    updateActiveIndex: R3,
    updateClickedSlide: L3,
  };
  function k3(t) {
    t === void 0 && (t = this.isHorizontal() ? "x" : "y");
    const e = this,
      { params: n, rtlTranslate: i, translate: a, wrapperEl: l } = e;
    if (n.virtualTranslate) return i ? -a : a;
    if (n.cssMode) return a;
    let u = d3(l, t);
    return ((u += e.cssOverflowAdjustment()), i && (u = -u), u || 0);
  }
  function z3(t, e) {
    const n = this,
      { rtlTranslate: i, params: a, wrapperEl: l, progress: u } = n;
    let d = 0,
      m = 0;
    const g = 0;
    (n.isHorizontal() ? (d = i ? -t : t) : (m = t),
      a.roundLengths && ((d = Math.floor(d)), (m = Math.floor(m))),
      (n.previousTranslate = n.translate),
      (n.translate = n.isHorizontal() ? d : m),
      a.cssMode
        ? (l[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal()
            ? -d
            : -m)
        : a.virtualTranslate ||
          (n.isHorizontal()
            ? (d -= n.cssOverflowAdjustment())
            : (m -= n.cssOverflowAdjustment()),
          (l.style.transform = `translate3d(${d}px, ${m}px, ${g}px)`)));
    let v;
    const y = n.maxTranslate() - n.minTranslate();
    (y === 0 ? (v = 0) : (v = (t - n.minTranslate()) / y),
      v !== u && n.updateProgress(t),
      n.emit("setTranslate", n.translate, e));
  }
  function P3() {
    return -this.snapGrid[0];
  }
  function I3() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }
  function U3(t, e, n, i, a) {
    (t === void 0 && (t = 0),
      e === void 0 && (e = this.params.speed),
      n === void 0 && (n = !0),
      i === void 0 && (i = !0));
    const l = this,
      { params: u, wrapperEl: d } = l;
    if (l.animating && u.preventInteractionOnTransition) return !1;
    const m = l.minTranslate(),
      g = l.maxTranslate();
    let v;
    if (
      (i && t > m ? (v = m) : i && t < g ? (v = g) : (v = t),
      l.updateProgress(v),
      u.cssMode)
    ) {
      const y = l.isHorizontal();
      if (e === 0) d[y ? "scrollLeft" : "scrollTop"] = -v;
      else {
        if (!l.support.smoothScroll)
          return (
            cC({ swiper: l, targetPosition: -v, side: y ? "left" : "top" }),
            !0
          );
        d.scrollTo({ [y ? "left" : "top"]: -v, behavior: "smooth" });
      }
      return !0;
    }
    return (
      e === 0
        ? (l.setTransition(0),
          l.setTranslate(v),
          n && (l.emit("beforeTransitionStart", e, a), l.emit("transitionEnd")))
        : (l.setTransition(e),
          l.setTranslate(v),
          n &&
            (l.emit("beforeTransitionStart", e, a), l.emit("transitionStart")),
          l.animating ||
            ((l.animating = !0),
            l.onTranslateToWrapperTransitionEnd ||
              (l.onTranslateToWrapperTransitionEnd = function (w) {
                !l ||
                  l.destroyed ||
                  (w.target === this &&
                    (l.wrapperEl.removeEventListener(
                      "transitionend",
                      l.onTranslateToWrapperTransitionEnd,
                    ),
                    (l.onTranslateToWrapperTransitionEnd = null),
                    delete l.onTranslateToWrapperTransitionEnd,
                    (l.animating = !1),
                    n && l.emit("transitionEnd")));
              }),
            l.wrapperEl.addEventListener(
              "transitionend",
              l.onTranslateToWrapperTransitionEnd,
            ))),
      !0
    );
  }
  var F3 = {
    getTranslate: k3,
    setTranslate: z3,
    minTranslate: P3,
    maxTranslate: I3,
    translateTo: U3,
  };
  function B3(t, e) {
    const n = this;
    (n.params.cssMode ||
      ((n.wrapperEl.style.transitionDuration = `${t}ms`),
      (n.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : "")),
      n.emit("setTransition", t, e));
  }
  function pC(t) {
    let { swiper: e, runCallbacks: n, direction: i, step: a } = t;
    const { activeIndex: l, previousIndex: u } = e;
    let d = i;
    (d || (l > u ? (d = "next") : l < u ? (d = "prev") : (d = "reset")),
      e.emit(`transition${a}`),
      n && d === "reset"
        ? e.emit(`slideResetTransition${a}`)
        : n &&
          l !== u &&
          (e.emit(`slideChangeTransition${a}`),
          d === "next"
            ? e.emit(`slideNextTransition${a}`)
            : e.emit(`slidePrevTransition${a}`)));
  }
  function H3(t, e) {
    t === void 0 && (t = !0);
    const n = this,
      { params: i } = n;
    i.cssMode ||
      (i.autoHeight && n.updateAutoHeight(),
      pC({ swiper: n, runCallbacks: t, direction: e, step: "Start" }));
  }
  function Y3(t, e) {
    t === void 0 && (t = !0);
    const n = this,
      { params: i } = n;
    ((n.animating = !1),
      !i.cssMode &&
        (n.setTransition(0),
        pC({ swiper: n, runCallbacks: t, direction: e, step: "End" })));
  }
  var q3 = { setTransition: B3, transitionStart: H3, transitionEnd: Y3 };
  function $3(t, e, n, i, a) {
    (t === void 0 && (t = 0),
      n === void 0 && (n = !0),
      typeof t == "string" && (t = parseInt(t, 10)));
    const l = this;
    let u = t;
    u < 0 && (u = 0);
    const {
      params: d,
      snapGrid: m,
      slidesGrid: g,
      previousIndex: v,
      activeIndex: y,
      rtlTranslate: w,
      wrapperEl: S,
      enabled: T,
    } = l;
    if (
      (!T && !i && !a) ||
      l.destroyed ||
      (l.animating && d.preventInteractionOnTransition)
    )
      return !1;
    typeof e > "u" && (e = l.params.speed);
    const E = Math.min(l.params.slidesPerGroupSkip, u);
    let j = E + Math.floor((u - E) / l.params.slidesPerGroup);
    j >= m.length && (j = m.length - 1);
    const O = -m[j];
    if (d.normalizeSlideIndex)
      for (let Y = 0; Y < g.length; Y += 1) {
        const B = -Math.floor(O * 100),
          I = Math.floor(g[Y] * 100),
          H = Math.floor(g[Y + 1] * 100);
        typeof g[Y + 1] < "u"
          ? B >= I && B < H - (H - I) / 2
            ? (u = Y)
            : B >= I && B < H && (u = Y + 1)
          : B >= I && (u = Y);
      }
    if (
      l.initialized &&
      u !== y &&
      ((!l.allowSlideNext &&
        (w
          ? O > l.translate && O > l.minTranslate()
          : O < l.translate && O < l.minTranslate())) ||
        (!l.allowSlidePrev &&
          O > l.translate &&
          O > l.maxTranslate() &&
          (y || 0) !== u))
    )
      return !1;
    (u !== (v || 0) && n && l.emit("beforeSlideChangeStart"),
      l.updateProgress(O));
    let M;
    u > y ? (M = "next") : u < y ? (M = "prev") : (M = "reset");
    const N = l.virtual && l.params.virtual.enabled;
    if (!(N && a) && ((w && -O === l.translate) || (!w && O === l.translate)))
      return (
        l.updateActiveIndex(u),
        d.autoHeight && l.updateAutoHeight(),
        l.updateSlidesClasses(),
        d.effect !== "slide" && l.setTranslate(O),
        M !== "reset" && (l.transitionStart(n, M), l.transitionEnd(n, M)),
        !1
      );
    if (d.cssMode) {
      const Y = l.isHorizontal(),
        B = w ? O : -O;
      if (e === 0)
        (N &&
          ((l.wrapperEl.style.scrollSnapType = "none"),
          (l._immediateVirtual = !0)),
          N && !l._cssModeVirtualInitialSet && l.params.initialSlide > 0
            ? ((l._cssModeVirtualInitialSet = !0),
              requestAnimationFrame(() => {
                S[Y ? "scrollLeft" : "scrollTop"] = B;
              }))
            : (S[Y ? "scrollLeft" : "scrollTop"] = B),
          N &&
            requestAnimationFrame(() => {
              ((l.wrapperEl.style.scrollSnapType = ""),
                (l._immediateVirtual = !1));
            }));
      else {
        if (!l.support.smoothScroll)
          return (
            cC({ swiper: l, targetPosition: B, side: Y ? "left" : "top" }),
            !0
          );
        S.scrollTo({ [Y ? "left" : "top"]: B, behavior: "smooth" });
      }
      return !0;
    }
    const G = hC().isSafari;
    return (
      N && !a && G && l.isElement && l.virtual.update(!1, !1, u),
      l.setTransition(e),
      l.setTranslate(O),
      l.updateActiveIndex(u),
      l.updateSlidesClasses(),
      l.emit("beforeTransitionStart", e, i),
      l.transitionStart(n, M),
      e === 0
        ? l.transitionEnd(n, M)
        : l.animating ||
          ((l.animating = !0),
          l.onSlideToWrapperTransitionEnd ||
            (l.onSlideToWrapperTransitionEnd = function (B) {
              !l ||
                l.destroyed ||
                (B.target === this &&
                  (l.wrapperEl.removeEventListener(
                    "transitionend",
                    l.onSlideToWrapperTransitionEnd,
                  ),
                  (l.onSlideToWrapperTransitionEnd = null),
                  delete l.onSlideToWrapperTransitionEnd,
                  l.transitionEnd(n, M)));
            }),
          l.wrapperEl.addEventListener(
            "transitionend",
            l.onSlideToWrapperTransitionEnd,
          )),
      !0
    );
  }
  function G3(t, e, n, i) {
    (t === void 0 && (t = 0),
      n === void 0 && (n = !0),
      typeof t == "string" && (t = parseInt(t, 10)));
    const a = this;
    if (a.destroyed) return;
    typeof e > "u" && (e = a.params.speed);
    const l = a.grid && a.params.grid && a.params.grid.rows > 1;
    let u = t;
    if (a.params.loop)
      if (a.virtual && a.params.virtual.enabled) u = u + a.virtual.slidesBefore;
      else {
        let d;
        if (l) {
          const w = u * a.params.grid.rows;
          d = a.slides.find(
            (S) => S.getAttribute("data-swiper-slide-index") * 1 === w,
          ).column;
        } else d = a.getSlideIndexByData(u);
        const m = l
            ? Math.ceil(a.slides.length / a.params.grid.rows)
            : a.slides.length,
          { centeredSlides: g } = a.params;
        let v = a.params.slidesPerView;
        v === "auto"
          ? (v = a.slidesPerViewDynamic())
          : ((v = Math.ceil(parseFloat(a.params.slidesPerView, 10))),
            g && v % 2 === 0 && (v = v + 1));
        let y = m - d < v;
        if (
          (g && (y = y || d < Math.ceil(v / 2)),
          i && g && a.params.slidesPerView !== "auto" && !l && (y = !1),
          y)
        ) {
          const w = g
            ? d < a.activeIndex
              ? "prev"
              : "next"
            : d - a.activeIndex - 1 < a.params.slidesPerView
              ? "next"
              : "prev";
          a.loopFix({
            direction: w,
            slideTo: !0,
            activeSlideIndex: w === "next" ? d + 1 : d - m + 1,
            slideRealIndex: w === "next" ? a.realIndex : void 0,
          });
        }
        if (l) {
          const w = u * a.params.grid.rows;
          u = a.slides.find(
            (S) => S.getAttribute("data-swiper-slide-index") * 1 === w,
          ).column;
        } else u = a.getSlideIndexByData(u);
      }
    return (
      requestAnimationFrame(() => {
        a.slideTo(u, e, n, i);
      }),
      a
    );
  }
  function V3(t, e, n) {
    e === void 0 && (e = !0);
    const i = this,
      { enabled: a, params: l, animating: u } = i;
    if (!a || i.destroyed) return i;
    typeof t > "u" && (t = i.params.speed);
    let d = l.slidesPerGroup;
    l.slidesPerView === "auto" &&
      l.slidesPerGroup === 1 &&
      l.slidesPerGroupAuto &&
      (d = Math.max(i.slidesPerViewDynamic("current", !0), 1));
    const m = i.activeIndex < l.slidesPerGroupSkip ? 1 : d,
      g = i.virtual && l.virtual.enabled;
    if (l.loop) {
      if (u && !g && l.loopPreventsSliding) return !1;
      if (
        (i.loopFix({ direction: "next" }),
        (i._clientLeft = i.wrapperEl.clientLeft),
        i.activeIndex === i.slides.length - 1 && l.cssMode)
      )
        return (
          requestAnimationFrame(() => {
            i.slideTo(i.activeIndex + m, t, e, n);
          }),
          !0
        );
    }
    return l.rewind && i.isEnd
      ? i.slideTo(0, t, e, n)
      : i.slideTo(i.activeIndex + m, t, e, n);
  }
  function W3(t, e, n) {
    e === void 0 && (e = !0);
    const i = this,
      {
        params: a,
        snapGrid: l,
        slidesGrid: u,
        rtlTranslate: d,
        enabled: m,
        animating: g,
      } = i;
    if (!m || i.destroyed) return i;
    typeof t > "u" && (t = i.params.speed);
    const v = i.virtual && a.virtual.enabled;
    if (a.loop) {
      if (g && !v && a.loopPreventsSliding) return !1;
      (i.loopFix({ direction: "prev" }),
        (i._clientLeft = i.wrapperEl.clientLeft));
    }
    const y = d ? i.translate : -i.translate;
    function w(M) {
      return M < 0 ? -Math.floor(Math.abs(M)) : Math.floor(M);
    }
    const S = w(y),
      T = l.map((M) => w(M)),
      E = a.freeMode && a.freeMode.enabled;
    let j = l[T.indexOf(S) - 1];
    if (typeof j > "u" && (a.cssMode || E)) {
      let M;
      (l.forEach((N, R) => {
        S >= N && (M = R);
      }),
        typeof M < "u" && (j = E ? l[M] : l[M > 0 ? M - 1 : M]));
    }
    let O = 0;
    if (
      (typeof j < "u" &&
        ((O = u.indexOf(j)),
        O < 0 && (O = i.activeIndex - 1),
        a.slidesPerView === "auto" &&
          a.slidesPerGroup === 1 &&
          a.slidesPerGroupAuto &&
          ((O = O - i.slidesPerViewDynamic("previous", !0) + 1),
          (O = Math.max(O, 0)))),
      a.rewind && i.isBeginning)
    ) {
      const M =
        i.params.virtual && i.params.virtual.enabled && i.virtual
          ? i.virtual.slides.length - 1
          : i.slides.length - 1;
      return i.slideTo(M, t, e, n);
    } else if (a.loop && i.activeIndex === 0 && a.cssMode)
      return (
        requestAnimationFrame(() => {
          i.slideTo(O, t, e, n);
        }),
        !0
      );
    return i.slideTo(O, t, e, n);
  }
  function X3(t, e, n) {
    e === void 0 && (e = !0);
    const i = this;
    if (!i.destroyed)
      return (
        typeof t > "u" && (t = i.params.speed),
        i.slideTo(i.activeIndex, t, e, n)
      );
  }
  function Q3(t, e, n, i) {
    (e === void 0 && (e = !0), i === void 0 && (i = 0.5));
    const a = this;
    if (a.destroyed) return;
    typeof t > "u" && (t = a.params.speed);
    let l = a.activeIndex;
    const u = Math.min(a.params.slidesPerGroupSkip, l),
      d = u + Math.floor((l - u) / a.params.slidesPerGroup),
      m = a.rtlTranslate ? a.translate : -a.translate;
    if (m >= a.snapGrid[d]) {
      const g = a.snapGrid[d],
        v = a.snapGrid[d + 1];
      m - g > (v - g) * i && (l += a.params.slidesPerGroup);
    } else {
      const g = a.snapGrid[d - 1],
        v = a.snapGrid[d];
      m - g <= (v - g) * i && (l -= a.params.slidesPerGroup);
    }
    return (
      (l = Math.max(l, 0)),
      (l = Math.min(l, a.slidesGrid.length - 1)),
      a.slideTo(l, t, e, n)
    );
  }
  function Z3() {
    const t = this;
    if (t.destroyed) return;
    const { params: e, slidesEl: n } = t,
      i =
        e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
    let a = t.getSlideIndexWhenGrid(t.clickedIndex),
      l;
    const u = t.isElement ? "swiper-slide" : `.${e.slideClass}`,
      d = t.grid && t.params.grid && t.params.grid.rows > 1;
    if (e.loop) {
      if (t.animating) return;
      ((l = parseInt(
        t.clickedSlide.getAttribute("data-swiper-slide-index"),
        10,
      )),
        e.centeredSlides
          ? t.slideToLoop(l)
          : a >
              (d
                ? (t.slides.length - i) / 2 - (t.params.grid.rows - 1)
                : t.slides.length - i)
            ? (t.loopFix(),
              (a = t.getSlideIndex(
                dl(n, `${u}[data-swiper-slide-index="${l}"]`)[0],
              )),
              oC(() => {
                t.slideTo(a);
              }))
            : t.slideTo(a));
    } else t.slideTo(a);
  }
  var K3 = {
    slideTo: $3,
    slideToLoop: G3,
    slideNext: V3,
    slidePrev: W3,
    slideReset: X3,
    slideToClosest: Q3,
    slideToClickedSlide: Z3,
  };
  function J3(t, e) {
    const n = this,
      { params: i, slidesEl: a } = n;
    if (!i.loop || (n.virtual && n.params.virtual.enabled)) return;
    const l = () => {
        dl(a, `.${i.slideClass}, swiper-slide`).forEach((S, T) => {
          S.setAttribute("data-swiper-slide-index", T);
        });
      },
      u = () => {
        const w = dl(a, `.${i.slideBlankClass}`);
        (w.forEach((S) => {
          S.remove();
        }),
          w.length > 0 && (n.recalcSlides(), n.updateSlides()));
      },
      d = n.grid && i.grid && i.grid.rows > 1;
    i.loopAddBlankSlides && (i.slidesPerGroup > 1 || d) && u();
    const m = i.slidesPerGroup * (d ? i.grid.rows : 1),
      g = n.slides.length % m !== 0,
      v = d && n.slides.length % i.grid.rows !== 0,
      y = (w) => {
        for (let S = 0; S < w; S += 1) {
          const T = n.isElement
            ? mb("swiper-slide", [i.slideBlankClass])
            : mb("div", [i.slideClass, i.slideBlankClass]);
          n.slidesEl.append(T);
        }
      };
    if (g) {
      if (i.loopAddBlankSlides) {
        const w = m - (n.slides.length % m);
        (y(w), n.recalcSlides(), n.updateSlides());
      } else
        pb(
          "Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)",
        );
      l();
    } else if (v) {
      if (i.loopAddBlankSlides) {
        const w = i.grid.rows - (n.slides.length % i.grid.rows);
        (y(w), n.recalcSlides(), n.updateSlides());
      } else
        pb(
          "Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)",
        );
      l();
    } else l();
    n.loopFix({
      slideRealIndex: t,
      direction: i.centeredSlides ? void 0 : "next",
      initial: e,
    });
  }
  function eD(t) {
    let {
      slideRealIndex: e,
      slideTo: n = !0,
      direction: i,
      setTranslate: a,
      activeSlideIndex: l,
      initial: u,
      byController: d,
      byMousewheel: m,
    } = t === void 0 ? {} : t;
    const g = this;
    if (!g.params.loop) return;
    g.emit("beforeLoopFix");
    const {
        slides: v,
        allowSlidePrev: y,
        allowSlideNext: w,
        slidesEl: S,
        params: T,
      } = g,
      { centeredSlides: E, initialSlide: j } = T;
    if (
      ((g.allowSlidePrev = !0),
      (g.allowSlideNext = !0),
      g.virtual && T.virtual.enabled)
    ) {
      (n &&
        (!T.centeredSlides && g.snapIndex === 0
          ? g.slideTo(g.virtual.slides.length, 0, !1, !0)
          : T.centeredSlides && g.snapIndex < T.slidesPerView
            ? g.slideTo(g.virtual.slides.length + g.snapIndex, 0, !1, !0)
            : g.snapIndex === g.snapGrid.length - 1 &&
              g.slideTo(g.virtual.slidesBefore, 0, !1, !0)),
        (g.allowSlidePrev = y),
        (g.allowSlideNext = w),
        g.emit("loopFix"));
      return;
    }
    let O = T.slidesPerView;
    O === "auto"
      ? (O = g.slidesPerViewDynamic())
      : ((O = Math.ceil(parseFloat(T.slidesPerView, 10))),
        E && O % 2 === 0 && (O = O + 1));
    const M = T.slidesPerGroupAuto ? O : T.slidesPerGroup;
    let N = E ? Math.max(M, Math.ceil(O / 2)) : M;
    (N % M !== 0 && (N += M - (N % M)),
      (N += T.loopAdditionalSlides),
      (g.loopedSlides = N));
    const R = g.grid && T.grid && T.grid.rows > 1;
    v.length < O + N || (g.params.effect === "cards" && v.length < O + N * 2)
      ? pb(
          "Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters",
        )
      : R &&
        T.grid.fill === "row" &&
        pb(
          "Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`",
        );
    const P = [],
      G = [],
      Y = R ? Math.ceil(v.length / T.grid.rows) : v.length,
      B = u && Y - j < O && !E;
    let I = B ? j : g.activeIndex;
    typeof l > "u"
      ? (l = g.getSlideIndex(
          v.find((V) => V.classList.contains(T.slideActiveClass)),
        ))
      : (I = l);
    const H = i === "next" || !i,
      X = i === "prev" || !i;
    let fe = 0,
      ve = 0;
    const Oe = (R ? v[l].column : l) + (E && typeof a > "u" ? -O / 2 + 0.5 : 0);
    if (Oe < N) {
      fe = Math.max(N - Oe, M);
      for (let V = 0; V < N - Oe; V += 1) {
        const pe = V - Math.floor(V / Y) * Y;
        if (R) {
          const de = Y - pe - 1;
          for (let he = v.length - 1; he >= 0; he -= 1)
            v[he].column === de && P.push(he);
        } else P.push(Y - pe - 1);
      }
    } else if (Oe + O > Y - N) {
      ((ve = Math.max(Oe - (Y - N * 2), M)),
        B && (ve = Math.max(ve, O - Y + j + 1)));
      for (let V = 0; V < ve; V += 1) {
        const pe = V - Math.floor(V / Y) * Y;
        R
          ? v.forEach((de, he) => {
              de.column === pe && G.push(he);
            })
          : G.push(pe);
      }
    }
    if (
      ((g.__preventObserver__ = !0),
      requestAnimationFrame(() => {
        g.__preventObserver__ = !1;
      }),
      g.params.effect === "cards" &&
        v.length < O + N * 2 &&
        (G.includes(l) && G.splice(G.indexOf(l), 1),
        P.includes(l) && P.splice(P.indexOf(l), 1)),
      X &&
        P.forEach((V) => {
          ((v[V].swiperLoopMoveDOM = !0),
            S.prepend(v[V]),
            (v[V].swiperLoopMoveDOM = !1));
        }),
      H &&
        G.forEach((V) => {
          ((v[V].swiperLoopMoveDOM = !0),
            S.append(v[V]),
            (v[V].swiperLoopMoveDOM = !1));
        }),
      g.recalcSlides(),
      T.slidesPerView === "auto"
        ? g.updateSlides()
        : R &&
          ((P.length > 0 && X) || (G.length > 0 && H)) &&
          g.slides.forEach((V, pe) => {
            g.grid.updateSlide(pe, V, g.slides);
          }),
      T.watchSlidesProgress && g.updateSlidesOffset(),
      n)
    ) {
      if (P.length > 0 && X) {
        if (typeof e > "u") {
          const V = g.slidesGrid[I],
            de = g.slidesGrid[I + fe] - V;
          m
            ? g.setTranslate(g.translate - de)
            : (g.slideTo(I + Math.ceil(fe), 0, !1, !0),
              a &&
                ((g.touchEventsData.startTranslate =
                  g.touchEventsData.startTranslate - de),
                (g.touchEventsData.currentTranslate =
                  g.touchEventsData.currentTranslate - de)));
        } else if (a) {
          const V = R ? P.length / T.grid.rows : P.length;
          (g.slideTo(g.activeIndex + V, 0, !1, !0),
            (g.touchEventsData.currentTranslate = g.translate));
        }
      } else if (G.length > 0 && H)
        if (typeof e > "u") {
          const V = g.slidesGrid[I],
            de = g.slidesGrid[I - ve] - V;
          m
            ? g.setTranslate(g.translate - de)
            : (g.slideTo(I - ve, 0, !1, !0),
              a &&
                ((g.touchEventsData.startTranslate =
                  g.touchEventsData.startTranslate - de),
                (g.touchEventsData.currentTranslate =
                  g.touchEventsData.currentTranslate - de)));
        } else {
          const V = R ? G.length / T.grid.rows : G.length;
          g.slideTo(g.activeIndex - V, 0, !1, !0);
        }
    }
    if (
      ((g.allowSlidePrev = y),
      (g.allowSlideNext = w),
      g.controller && g.controller.control && !d)
    ) {
      const V = {
        slideRealIndex: e,
        direction: i,
        setTranslate: a,
        activeSlideIndex: l,
        byController: !0,
      };
      Array.isArray(g.controller.control)
        ? g.controller.control.forEach((pe) => {
            !pe.destroyed &&
              pe.params.loop &&
              pe.loopFix({
                ...V,
                slideTo: pe.params.slidesPerView === T.slidesPerView ? n : !1,
              });
          })
        : g.controller.control instanceof g.constructor &&
          g.controller.control.params.loop &&
          g.controller.control.loopFix({
            ...V,
            slideTo:
              g.controller.control.params.slidesPerView === T.slidesPerView
                ? n
                : !1,
          });
    }
    g.emit("loopFix");
  }
  function tD() {
    const t = this,
      { params: e, slidesEl: n } = t;
    if (!e.loop || !n || (t.virtual && t.params.virtual.enabled)) return;
    t.recalcSlides();
    const i = [];
    (t.slides.forEach((a) => {
      const l =
        typeof a.swiperSlideIndex > "u"
          ? a.getAttribute("data-swiper-slide-index") * 1
          : a.swiperSlideIndex;
      i[l] = a;
    }),
      t.slides.forEach((a) => {
        a.removeAttribute("data-swiper-slide-index");
      }),
      i.forEach((a) => {
        n.append(a);
      }),
      t.recalcSlides(),
      t.slideTo(t.realIndex, 0));
  }
  var nD = { loopCreate: J3, loopFix: eD, loopDestroy: tD };
  function iD(t) {
    const e = this;
    if (
      !e.params.simulateTouch ||
      (e.params.watchOverflow && e.isLocked) ||
      e.params.cssMode
    )
      return;
    const n = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
    (e.isElement && (e.__preventObserver__ = !0),
      (n.style.cursor = "move"),
      (n.style.cursor = t ? "grabbing" : "grab"),
      e.isElement &&
        requestAnimationFrame(() => {
          e.__preventObserver__ = !1;
        }));
  }
  function sD() {
    const t = this;
    (t.params.watchOverflow && t.isLocked) ||
      t.params.cssMode ||
      (t.isElement && (t.__preventObserver__ = !0),
      (t[
        t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"
      ].style.cursor = ""),
      t.isElement &&
        requestAnimationFrame(() => {
          t.__preventObserver__ = !1;
        }));
  }
  var rD = { setGrabCursor: iD, unsetGrabCursor: sD };
  function aD(t, e) {
    e === void 0 && (e = this);
    function n(i) {
      if (!i || i === ml() || i === bs()) return null;
      i.assignedSlot && (i = i.assignedSlot);
      const a = i.closest(t);
      return !a && !i.getRootNode ? null : a || n(i.getRootNode().host);
    }
    return n(e);
  }
  function wT(t, e, n) {
    const i = bs(),
      { params: a } = t,
      l = a.edgeSwipeDetection,
      u = a.edgeSwipeThreshold;
    return l && (n <= u || n >= i.innerWidth - u)
      ? l === "prevent"
        ? (e.preventDefault(), !0)
        : !1
      : !0;
  }
  function lD(t) {
    const e = this,
      n = ml();
    let i = t;
    i.originalEvent && (i = i.originalEvent);
    const a = e.touchEventsData;
    if (i.type === "pointerdown") {
      if (a.pointerId !== null && a.pointerId !== i.pointerId) return;
      a.pointerId = i.pointerId;
    } else
      i.type === "touchstart" &&
        i.targetTouches.length === 1 &&
        (a.touchId = i.targetTouches[0].identifier);
    if (i.type === "touchstart") {
      wT(e, i, i.targetTouches[0].pageX);
      return;
    }
    const { params: l, touches: u, enabled: d } = e;
    if (
      !d ||
      (!l.simulateTouch && i.pointerType === "mouse") ||
      (e.animating && l.preventInteractionOnTransition)
    )
      return;
    !e.animating && l.cssMode && l.loop && e.loopFix();
    let m = i.target;
    if (
      (l.touchEventsTarget === "wrapper" && !m3(m, e.wrapperEl)) ||
      ("which" in i && i.which === 3) ||
      ("button" in i && i.button > 0) ||
      (a.isTouched && a.isMoved)
    )
      return;
    const g = !!l.noSwipingClass && l.noSwipingClass !== "",
      v = i.composedPath ? i.composedPath() : i.path;
    g && i.target && i.target.shadowRoot && v && (m = v[0]);
    const y = l.noSwipingSelector
        ? l.noSwipingSelector
        : `.${l.noSwipingClass}`,
      w = !!(i.target && i.target.shadowRoot);
    if (l.noSwiping && (w ? aD(y, m) : m.closest(y))) {
      e.allowClick = !0;
      return;
    }
    if (l.swipeHandler && !m.closest(l.swipeHandler)) return;
    ((u.currentX = i.pageX), (u.currentY = i.pageY));
    const S = u.currentX,
      T = u.currentY;
    if (!wT(e, i, S)) return;
    (Object.assign(a, {
      isTouched: !0,
      isMoved: !1,
      allowTouchCallbacks: !0,
      isScrolling: void 0,
      startMoving: void 0,
    }),
      (u.startX = S),
      (u.startY = T),
      (a.touchStartTime = hb()),
      (e.allowClick = !0),
      e.updateSize(),
      (e.swipeDirection = void 0),
      l.threshold > 0 && (a.allowThresholdMove = !1));
    let E = !0;
    (m.matches(a.focusableElements) &&
      ((E = !1), m.nodeName === "SELECT" && (a.isTouched = !1)),
      n.activeElement &&
        n.activeElement.matches(a.focusableElements) &&
        n.activeElement !== m &&
        (i.pointerType === "mouse" ||
          (i.pointerType !== "mouse" && !m.matches(a.focusableElements))) &&
        n.activeElement.blur());
    const j = E && e.allowTouchMove && l.touchStartPreventDefault;
    ((l.touchStartForcePreventDefault || j) &&
      !m.isContentEditable &&
      i.preventDefault(),
      l.freeMode &&
        l.freeMode.enabled &&
        e.freeMode &&
        e.animating &&
        !l.cssMode &&
        e.freeMode.onTouchStart(),
      e.emit("touchStart", i));
  }
  function oD(t) {
    const e = ml(),
      n = this,
      i = n.touchEventsData,
      { params: a, touches: l, rtlTranslate: u, enabled: d } = n;
    if (!d || (!a.simulateTouch && t.pointerType === "mouse")) return;
    let m = t;
    if (
      (m.originalEvent && (m = m.originalEvent),
      m.type === "pointermove" &&
        (i.touchId !== null || m.pointerId !== i.pointerId))
    )
      return;
    let g;
    if (m.type === "touchmove") {
      if (
        ((g = [...m.changedTouches].find((P) => P.identifier === i.touchId)),
        !g || g.identifier !== i.touchId)
      )
        return;
    } else g = m;
    if (!i.isTouched) {
      i.startMoving && i.isScrolling && n.emit("touchMoveOpposite", m);
      return;
    }
    const v = g.pageX,
      y = g.pageY;
    if (m.preventedByNestedSwiper) {
      ((l.startX = v), (l.startY = y));
      return;
    }
    if (!n.allowTouchMove) {
      (m.target.matches(i.focusableElements) || (n.allowClick = !1),
        i.isTouched &&
          (Object.assign(l, { startX: v, startY: y, currentX: v, currentY: y }),
          (i.touchStartTime = hb())));
      return;
    }
    if (a.touchReleaseOnEdges && !a.loop)
      if (n.isVertical()) {
        if (
          (y < l.startY && n.translate <= n.maxTranslate()) ||
          (y > l.startY && n.translate >= n.minTranslate())
        ) {
          ((i.isTouched = !1), (i.isMoved = !1));
          return;
        }
      } else {
        if (
          u &&
          ((v > l.startX && -n.translate <= n.maxTranslate()) ||
            (v < l.startX && -n.translate >= n.minTranslate()))
        )
          return;
        if (
          !u &&
          ((v < l.startX && n.translate <= n.maxTranslate()) ||
            (v > l.startX && n.translate >= n.minTranslate()))
        )
          return;
      }
    if (
      (e.activeElement &&
        e.activeElement.matches(i.focusableElements) &&
        e.activeElement !== m.target &&
        m.pointerType !== "mouse" &&
        e.activeElement.blur(),
      e.activeElement &&
        m.target === e.activeElement &&
        m.target.matches(i.focusableElements))
    ) {
      ((i.isMoved = !0), (n.allowClick = !1));
      return;
    }
    (i.allowTouchCallbacks && n.emit("touchMove", m),
      (l.previousX = l.currentX),
      (l.previousY = l.currentY),
      (l.currentX = v),
      (l.currentY = y));
    const w = l.currentX - l.startX,
      S = l.currentY - l.startY;
    if (n.params.threshold && Math.sqrt(w ** 2 + S ** 2) < n.params.threshold)
      return;
    if (typeof i.isScrolling > "u") {
      let P;
      (n.isHorizontal() && l.currentY === l.startY) ||
      (n.isVertical() && l.currentX === l.startX)
        ? (i.isScrolling = !1)
        : w * w + S * S >= 25 &&
          ((P = (Math.atan2(Math.abs(S), Math.abs(w)) * 180) / Math.PI),
          (i.isScrolling = n.isHorizontal()
            ? P > a.touchAngle
            : 90 - P > a.touchAngle));
    }
    if (
      (i.isScrolling && n.emit("touchMoveOpposite", m),
      typeof i.startMoving > "u" &&
        (l.currentX !== l.startX || l.currentY !== l.startY) &&
        (i.startMoving = !0),
      i.isScrolling ||
        (m.type === "touchmove" && i.preventTouchMoveFromPointerMove))
    ) {
      i.isTouched = !1;
      return;
    }
    if (!i.startMoving) return;
    ((n.allowClick = !1),
      !a.cssMode && m.cancelable && m.preventDefault(),
      a.touchMoveStopPropagation && !a.nested && m.stopPropagation());
    let T = n.isHorizontal() ? w : S,
      E = n.isHorizontal()
        ? l.currentX - l.previousX
        : l.currentY - l.previousY;
    (a.oneWayMovement &&
      ((T = Math.abs(T) * (u ? 1 : -1)), (E = Math.abs(E) * (u ? 1 : -1))),
      (l.diff = T),
      (T *= a.touchRatio),
      u && ((T = -T), (E = -E)));
    const j = n.touchesDirection;
    ((n.swipeDirection = T > 0 ? "prev" : "next"),
      (n.touchesDirection = E > 0 ? "prev" : "next"));
    const O = n.params.loop && !a.cssMode,
      M =
        (n.touchesDirection === "next" && n.allowSlideNext) ||
        (n.touchesDirection === "prev" && n.allowSlidePrev);
    if (!i.isMoved) {
      if (
        (O && M && n.loopFix({ direction: n.swipeDirection }),
        (i.startTranslate = n.getTranslate()),
        n.setTransition(0),
        n.animating)
      ) {
        const P = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0,
          detail: { bySwiperTouchMove: !0 },
        });
        n.wrapperEl.dispatchEvent(P);
      }
      ((i.allowMomentumBounce = !1),
        a.grabCursor &&
          (n.allowSlideNext === !0 || n.allowSlidePrev === !0) &&
          n.setGrabCursor(!0),
        n.emit("sliderFirstMove", m));
    }
    if (
      (new Date().getTime(),
      a._loopSwapReset !== !1 &&
        i.isMoved &&
        i.allowThresholdMove &&
        j !== n.touchesDirection &&
        O &&
        M &&
        Math.abs(T) >= 1)
    ) {
      (Object.assign(l, {
        startX: v,
        startY: y,
        currentX: v,
        currentY: y,
        startTranslate: i.currentTranslate,
      }),
        (i.loopSwapReset = !0),
        (i.startTranslate = i.currentTranslate));
      return;
    }
    (n.emit("sliderMove", m),
      (i.isMoved = !0),
      (i.currentTranslate = T + i.startTranslate));
    let N = !0,
      R = a.resistanceRatio;
    if (
      (a.touchReleaseOnEdges && (R = 0),
      T > 0
        ? (O &&
            M &&
            i.allowThresholdMove &&
            i.currentTranslate >
              (a.centeredSlides
                ? n.minTranslate() -
                  n.slidesSizesGrid[n.activeIndex + 1] -
                  (a.slidesPerView !== "auto" &&
                  n.slides.length - a.slidesPerView >= 2
                    ? n.slidesSizesGrid[n.activeIndex + 1] +
                      n.params.spaceBetween
                    : 0) -
                  n.params.spaceBetween
                : n.minTranslate()) &&
            n.loopFix({
              direction: "prev",
              setTranslate: !0,
              activeSlideIndex: 0,
            }),
          i.currentTranslate > n.minTranslate() &&
            ((N = !1),
            a.resistance &&
              (i.currentTranslate =
                n.minTranslate() -
                1 +
                (-n.minTranslate() + i.startTranslate + T) ** R)))
        : T < 0 &&
          (O &&
            M &&
            i.allowThresholdMove &&
            i.currentTranslate <
              (a.centeredSlides
                ? n.maxTranslate() +
                  n.slidesSizesGrid[n.slidesSizesGrid.length - 1] +
                  n.params.spaceBetween +
                  (a.slidesPerView !== "auto" &&
                  n.slides.length - a.slidesPerView >= 2
                    ? n.slidesSizesGrid[n.slidesSizesGrid.length - 1] +
                      n.params.spaceBetween
                    : 0)
                : n.maxTranslate()) &&
            n.loopFix({
              direction: "next",
              setTranslate: !0,
              activeSlideIndex:
                n.slides.length -
                (a.slidesPerView === "auto"
                  ? n.slidesPerViewDynamic()
                  : Math.ceil(parseFloat(a.slidesPerView, 10))),
            }),
          i.currentTranslate < n.maxTranslate() &&
            ((N = !1),
            a.resistance &&
              (i.currentTranslate =
                n.maxTranslate() +
                1 -
                (n.maxTranslate() - i.startTranslate - T) ** R))),
      N && (m.preventedByNestedSwiper = !0),
      !n.allowSlideNext &&
        n.swipeDirection === "next" &&
        i.currentTranslate < i.startTranslate &&
        (i.currentTranslate = i.startTranslate),
      !n.allowSlidePrev &&
        n.swipeDirection === "prev" &&
        i.currentTranslate > i.startTranslate &&
        (i.currentTranslate = i.startTranslate),
      !n.allowSlidePrev &&
        !n.allowSlideNext &&
        (i.currentTranslate = i.startTranslate),
      a.threshold > 0)
    )
      if (Math.abs(T) > a.threshold || i.allowThresholdMove) {
        if (!i.allowThresholdMove) {
          ((i.allowThresholdMove = !0),
            (l.startX = l.currentX),
            (l.startY = l.currentY),
            (i.currentTranslate = i.startTranslate),
            (l.diff = n.isHorizontal()
              ? l.currentX - l.startX
              : l.currentY - l.startY));
          return;
        }
      } else {
        i.currentTranslate = i.startTranslate;
        return;
      }
    !a.followFinger ||
      a.cssMode ||
      (((a.freeMode && a.freeMode.enabled && n.freeMode) ||
        a.watchSlidesProgress) &&
        (n.updateActiveIndex(), n.updateSlidesClasses()),
      a.freeMode &&
        a.freeMode.enabled &&
        n.freeMode &&
        n.freeMode.onTouchMove(),
      n.updateProgress(i.currentTranslate),
      n.setTranslate(i.currentTranslate));
  }
  function cD(t) {
    const e = this,
      n = e.touchEventsData;
    let i = t;
    i.originalEvent && (i = i.originalEvent);
    let a;
    if (i.type === "touchend" || i.type === "touchcancel") {
      if (
        ((a = [...i.changedTouches].find((P) => P.identifier === n.touchId)),
        !a || a.identifier !== n.touchId)
      )
        return;
    } else {
      if (n.touchId !== null || i.pointerId !== n.pointerId) return;
      a = i;
    }
    if (
      ["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(
        i.type,
      ) &&
      !(
        ["pointercancel", "contextmenu"].includes(i.type) &&
        (e.browser.isSafari || e.browser.isWebView)
      )
    )
      return;
    ((n.pointerId = null), (n.touchId = null));
    const {
      params: u,
      touches: d,
      rtlTranslate: m,
      slidesGrid: g,
      enabled: v,
    } = e;
    if (!v || (!u.simulateTouch && i.pointerType === "mouse")) return;
    if (
      (n.allowTouchCallbacks && e.emit("touchEnd", i),
      (n.allowTouchCallbacks = !1),
      !n.isTouched)
    ) {
      (n.isMoved && u.grabCursor && e.setGrabCursor(!1),
        (n.isMoved = !1),
        (n.startMoving = !1));
      return;
    }
    u.grabCursor &&
      n.isMoved &&
      n.isTouched &&
      (e.allowSlideNext === !0 || e.allowSlidePrev === !0) &&
      e.setGrabCursor(!1);
    const y = hb(),
      w = y - n.touchStartTime;
    if (e.allowClick) {
      const P = i.path || (i.composedPath && i.composedPath());
      (e.updateClickedSlide((P && P[0]) || i.target, P),
        e.emit("tap click", i),
        w < 300 &&
          y - n.lastClickTime < 300 &&
          e.emit("doubleTap doubleClick", i));
    }
    if (
      ((n.lastClickTime = hb()),
      oC(() => {
        e.destroyed || (e.allowClick = !0);
      }),
      !n.isTouched ||
        !n.isMoved ||
        !e.swipeDirection ||
        (d.diff === 0 && !n.loopSwapReset) ||
        (n.currentTranslate === n.startTranslate && !n.loopSwapReset))
    ) {
      ((n.isTouched = !1), (n.isMoved = !1), (n.startMoving = !1));
      return;
    }
    ((n.isTouched = !1), (n.isMoved = !1), (n.startMoving = !1));
    let S;
    if (
      (u.followFinger
        ? (S = m ? e.translate : -e.translate)
        : (S = -n.currentTranslate),
      u.cssMode)
    )
      return;
    if (u.freeMode && u.freeMode.enabled) {
      e.freeMode.onTouchEnd({ currentPos: S });
      return;
    }
    const T = S >= -e.maxTranslate() && !e.params.loop;
    let E = 0,
      j = e.slidesSizesGrid[0];
    for (
      let P = 0;
      P < g.length;
      P += P < u.slidesPerGroupSkip ? 1 : u.slidesPerGroup
    ) {
      const G = P < u.slidesPerGroupSkip - 1 ? 1 : u.slidesPerGroup;
      typeof g[P + G] < "u"
        ? (T || (S >= g[P] && S < g[P + G])) && ((E = P), (j = g[P + G] - g[P]))
        : (T || S >= g[P]) &&
          ((E = P), (j = g[g.length - 1] - g[g.length - 2]));
    }
    let O = null,
      M = null;
    u.rewind &&
      (e.isBeginning
        ? (M =
            u.virtual && u.virtual.enabled && e.virtual
              ? e.virtual.slides.length - 1
              : e.slides.length - 1)
        : e.isEnd && (O = 0));
    const N = (S - g[E]) / j,
      R = E < u.slidesPerGroupSkip - 1 ? 1 : u.slidesPerGroup;
    if (w > u.longSwipesMs) {
      if (!u.longSwipes) {
        e.slideTo(e.activeIndex);
        return;
      }
      (e.swipeDirection === "next" &&
        (N >= u.longSwipesRatio
          ? e.slideTo(u.rewind && e.isEnd ? O : E + R)
          : e.slideTo(E)),
        e.swipeDirection === "prev" &&
          (N > 1 - u.longSwipesRatio
            ? e.slideTo(E + R)
            : M !== null && N < 0 && Math.abs(N) > u.longSwipesRatio
              ? e.slideTo(M)
              : e.slideTo(E)));
    } else {
      if (!u.shortSwipes) {
        e.slideTo(e.activeIndex);
        return;
      }
      e.navigation &&
      (i.target === e.navigation.nextEl || i.target === e.navigation.prevEl)
        ? i.target === e.navigation.nextEl
          ? e.slideTo(E + R)
          : e.slideTo(E)
        : (e.swipeDirection === "next" && e.slideTo(O !== null ? O : E + R),
          e.swipeDirection === "prev" && e.slideTo(M !== null ? M : E));
    }
  }
  function ST() {
    const t = this,
      { params: e, el: n } = t;
    if (n && n.offsetWidth === 0) return;
    e.breakpoints && t.setBreakpoint();
    const { allowSlideNext: i, allowSlidePrev: a, snapGrid: l } = t,
      u = t.virtual && t.params.virtual.enabled;
    ((t.allowSlideNext = !0),
      (t.allowSlidePrev = !0),
      t.updateSize(),
      t.updateSlides(),
      t.updateSlidesClasses());
    const d = u && e.loop;
    ((e.slidesPerView === "auto" || e.slidesPerView > 1) &&
    t.isEnd &&
    !t.isBeginning &&
    !t.params.centeredSlides &&
    !d
      ? t.slideTo(t.slides.length - 1, 0, !1, !0)
      : t.params.loop && !u
        ? t.slideToLoop(t.realIndex, 0, !1, !0)
        : t.slideTo(t.activeIndex, 0, !1, !0),
      t.autoplay &&
        t.autoplay.running &&
        t.autoplay.paused &&
        (clearTimeout(t.autoplay.resizeTimeout),
        (t.autoplay.resizeTimeout = setTimeout(() => {
          t.autoplay &&
            t.autoplay.running &&
            t.autoplay.paused &&
            t.autoplay.resume();
        }, 500))),
      (t.allowSlidePrev = a),
      (t.allowSlideNext = i),
      t.params.watchOverflow && l !== t.snapGrid && t.checkOverflow());
  }
  function uD(t) {
    const e = this;
    e.enabled &&
      (e.allowClick ||
        (e.params.preventClicks && t.preventDefault(),
        e.params.preventClicksPropagation &&
          e.animating &&
          (t.stopPropagation(), t.stopImmediatePropagation())));
  }
  function fD() {
    const t = this,
      { wrapperEl: e, rtlTranslate: n, enabled: i } = t;
    if (!i) return;
    ((t.previousTranslate = t.translate),
      t.isHorizontal()
        ? (t.translate = -e.scrollLeft)
        : (t.translate = -e.scrollTop),
      t.translate === 0 && (t.translate = 0),
      t.updateActiveIndex(),
      t.updateSlidesClasses());
    let a;
    const l = t.maxTranslate() - t.minTranslate();
    (l === 0 ? (a = 0) : (a = (t.translate - t.minTranslate()) / l),
      a !== t.progress && t.updateProgress(n ? -t.translate : t.translate),
      t.emit("setTranslate", t.translate, !1));
  }
  function dD(t) {
    const e = this;
    (Q0(e, t.target),
      !(
        e.params.cssMode ||
        (e.params.slidesPerView !== "auto" && !e.params.autoHeight)
      ) && e.update());
  }
  function hD() {
    const t = this;
    t.documentTouchHandlerProceeded ||
      ((t.documentTouchHandlerProceeded = !0),
      t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
  }
  const mC = (t, e) => {
    const n = ml(),
      { params: i, el: a, wrapperEl: l, device: u } = t,
      d = !!i.nested,
      m = e === "on" ? "addEventListener" : "removeEventListener",
      g = e;
    !a ||
      typeof a == "string" ||
      (n[m]("touchstart", t.onDocumentTouchStart, { passive: !1, capture: d }),
      a[m]("touchstart", t.onTouchStart, { passive: !1 }),
      a[m]("pointerdown", t.onTouchStart, { passive: !1 }),
      n[m]("touchmove", t.onTouchMove, { passive: !1, capture: d }),
      n[m]("pointermove", t.onTouchMove, { passive: !1, capture: d }),
      n[m]("touchend", t.onTouchEnd, { passive: !0 }),
      n[m]("pointerup", t.onTouchEnd, { passive: !0 }),
      n[m]("pointercancel", t.onTouchEnd, { passive: !0 }),
      n[m]("touchcancel", t.onTouchEnd, { passive: !0 }),
      n[m]("pointerout", t.onTouchEnd, { passive: !0 }),
      n[m]("pointerleave", t.onTouchEnd, { passive: !0 }),
      n[m]("contextmenu", t.onTouchEnd, { passive: !0 }),
      (i.preventClicks || i.preventClicksPropagation) &&
        a[m]("click", t.onClick, !0),
      i.cssMode && l[m]("scroll", t.onScroll),
      i.updateOnWindowResize
        ? t[g](
            u.ios || u.android
              ? "resize orientationchange observerUpdate"
              : "resize observerUpdate",
            ST,
            !0,
          )
        : t[g]("observerUpdate", ST, !0),
      a[m]("load", t.onLoad, { capture: !0 }));
  };
  function pD() {
    const t = this,
      { params: e } = t;
    ((t.onTouchStart = lD.bind(t)),
      (t.onTouchMove = oD.bind(t)),
      (t.onTouchEnd = cD.bind(t)),
      (t.onDocumentTouchStart = hD.bind(t)),
      e.cssMode && (t.onScroll = fD.bind(t)),
      (t.onClick = uD.bind(t)),
      (t.onLoad = dD.bind(t)),
      mC(t, "on"));
  }
  function mD() {
    mC(this, "off");
  }
  var gD = { attachEvents: pD, detachEvents: mD };
  const TT = (t, e) => t.grid && e.grid && e.grid.rows > 1;
  function vD() {
    const t = this,
      { realIndex: e, initialized: n, params: i, el: a } = t,
      l = i.breakpoints;
    if (!l || (l && Object.keys(l).length === 0)) return;
    const u = ml(),
      d =
        i.breakpointsBase === "window" || !i.breakpointsBase
          ? i.breakpointsBase
          : "container",
      m =
        ["window", "container"].includes(i.breakpointsBase) ||
        !i.breakpointsBase
          ? t.el
          : u.querySelector(i.breakpointsBase),
      g = t.getBreakpoint(l, d, m);
    if (!g || t.currentBreakpoint === g) return;
    const y = (g in l ? l[g] : void 0) || t.originalParams,
      w = TT(t, i),
      S = TT(t, y),
      T = t.params.grabCursor,
      E = y.grabCursor,
      j = i.enabled;
    (w && !S
      ? (a.classList.remove(
          `${i.containerModifierClass}grid`,
          `${i.containerModifierClass}grid-column`,
        ),
        t.emitContainerClasses())
      : !w &&
        S &&
        (a.classList.add(`${i.containerModifierClass}grid`),
        ((y.grid.fill && y.grid.fill === "column") ||
          (!y.grid.fill && i.grid.fill === "column")) &&
          a.classList.add(`${i.containerModifierClass}grid-column`),
        t.emitContainerClasses()),
      T && !E ? t.unsetGrabCursor() : !T && E && t.setGrabCursor(),
      ["navigation", "pagination", "scrollbar"].forEach((G) => {
        if (typeof y[G] > "u") return;
        const Y = i[G] && i[G].enabled,
          B = y[G] && y[G].enabled;
        (Y && !B && t[G].disable(), !Y && B && t[G].enable());
      }));
    const O = y.direction && y.direction !== i.direction,
      M = i.loop && (y.slidesPerView !== i.slidesPerView || O),
      N = i.loop;
    (O && n && t.changeDirection(), dr(t.params, y));
    const R = t.params.enabled,
      P = t.params.loop;
    (Object.assign(t, {
      allowTouchMove: t.params.allowTouchMove,
      allowSlideNext: t.params.allowSlideNext,
      allowSlidePrev: t.params.allowSlidePrev,
    }),
      j && !R ? t.disable() : !j && R && t.enable(),
      (t.currentBreakpoint = g),
      t.emit("_beforeBreakpoint", y),
      n &&
        (M
          ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides())
          : !N && P
            ? (t.loopCreate(e), t.updateSlides())
            : N && !P && t.loopDestroy()),
      t.emit("breakpoint", y));
  }
  function yD(t, e, n) {
    if ((e === void 0 && (e = "window"), !t || (e === "container" && !n)))
      return;
    let i = !1;
    const a = bs(),
      l = e === "window" ? a.innerHeight : n.clientHeight,
      u = Object.keys(t).map((d) => {
        if (typeof d == "string" && d.indexOf("@") === 0) {
          const m = parseFloat(d.substr(1));
          return { value: l * m, point: d };
        }
        return { value: d, point: d };
      });
    u.sort((d, m) => parseInt(d.value, 10) - parseInt(m.value, 10));
    for (let d = 0; d < u.length; d += 1) {
      const { point: m, value: g } = u[d];
      e === "window"
        ? a.matchMedia(`(min-width: ${g}px)`).matches && (i = m)
        : g <= n.clientWidth && (i = m);
    }
    return i || "max";
  }
  var bD = { setBreakpoint: vD, getBreakpoint: yD };
  function xD(t, e) {
    const n = [];
    return (
      t.forEach((i) => {
        typeof i == "object"
          ? Object.keys(i).forEach((a) => {
              i[a] && n.push(e + a);
            })
          : typeof i == "string" && n.push(e + i);
      }),
      n
    );
  }
  function _D() {
    const t = this,
      { classNames: e, params: n, rtl: i, el: a, device: l } = t,
      u = xD(
        [
          "initialized",
          n.direction,
          { "free-mode": t.params.freeMode && n.freeMode.enabled },
          { autoheight: n.autoHeight },
          { rtl: i },
          { grid: n.grid && n.grid.rows > 1 },
          {
            "grid-column":
              n.grid && n.grid.rows > 1 && n.grid.fill === "column",
          },
          { android: l.android },
          { ios: l.ios },
          { "css-mode": n.cssMode },
          { centered: n.cssMode && n.centeredSlides },
          { "watch-progress": n.watchSlidesProgress },
        ],
        n.containerModifierClass,
      );
    (e.push(...u), a.classList.add(...e), t.emitContainerClasses());
  }
  function wD() {
    const t = this,
      { el: e, classNames: n } = t;
    !e ||
      typeof e == "string" ||
      (e.classList.remove(...n), t.emitContainerClasses());
  }
  var SD = { addClasses: _D, removeClasses: wD };
  function TD() {
    const t = this,
      { isLocked: e, params: n } = t,
      { slidesOffsetBefore: i } = n;
    if (i) {
      const a = t.slides.length - 1,
        l = t.slidesGrid[a] + t.slidesSizesGrid[a] + i * 2;
      t.isLocked = t.size > l;
    } else t.isLocked = t.snapGrid.length === 1;
    (n.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked),
      n.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked),
      e && e !== t.isLocked && (t.isEnd = !1),
      e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock"));
  }
  var ED = { checkOverflow: TD },
    $_ = {
      init: !0,
      direction: "horizontal",
      oneWayMovement: !1,
      swiperElementNodeName: "SWIPER-CONTAINER",
      touchEventsTarget: "wrapper",
      initialSlide: 0,
      speed: 300,
      cssMode: !1,
      updateOnWindowResize: !0,
      resizeObserver: !0,
      nested: !1,
      createElements: !1,
      eventsPrefix: "swiper",
      enabled: !0,
      focusableElements:
        "input, select, option, textarea, button, video, label",
      width: null,
      height: null,
      preventInteractionOnTransition: !1,
      userAgent: null,
      url: null,
      edgeSwipeDetection: !1,
      edgeSwipeThreshold: 20,
      autoHeight: !1,
      setWrapperSize: !1,
      virtualTranslate: !1,
      effect: "slide",
      breakpoints: void 0,
      breakpointsBase: "window",
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      slidesPerGroupAuto: !1,
      centeredSlides: !1,
      centeredSlidesBounds: !1,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      normalizeSlideIndex: !0,
      centerInsufficientSlides: !1,
      watchOverflow: !0,
      roundLengths: !1,
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: !0,
      shortSwipes: !0,
      longSwipes: !0,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: !0,
      allowTouchMove: !0,
      threshold: 5,
      touchMoveStopPropagation: !1,
      touchStartPreventDefault: !0,
      touchStartForcePreventDefault: !1,
      touchReleaseOnEdges: !1,
      uniqueNavElements: !0,
      resistance: !0,
      resistanceRatio: 0.85,
      watchSlidesProgress: !1,
      grabCursor: !1,
      preventClicks: !0,
      preventClicksPropagation: !0,
      slideToClickedSlide: !1,
      loop: !1,
      loopAddBlankSlides: !0,
      loopAdditionalSlides: 0,
      loopPreventsSliding: !0,
      rewind: !1,
      allowSlidePrev: !0,
      allowSlideNext: !0,
      swipeHandler: null,
      noSwiping: !0,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: null,
      passiveListeners: !0,
      maxBackfaceHiddenSlides: 10,
      containerModifierClass: "swiper-",
      slideClass: "swiper-slide",
      slideBlankClass: "swiper-slide-blank",
      slideActiveClass: "swiper-slide-active",
      slideVisibleClass: "swiper-slide-visible",
      slideFullyVisibleClass: "swiper-slide-fully-visible",
      slideNextClass: "swiper-slide-next",
      slidePrevClass: "swiper-slide-prev",
      wrapperClass: "swiper-wrapper",
      lazyPreloaderClass: "swiper-lazy-preloader",
      lazyPreloadPrevNext: 0,
      runCallbacksOnInit: !0,
      _emitClasses: !1,
    };
  function CD(t, e) {
    return function (i) {
      i === void 0 && (i = {});
      const a = Object.keys(i)[0],
        l = i[a];
      if (typeof l != "object" || l === null) {
        dr(e, i);
        return;
      }
      if (
        (t[a] === !0 && (t[a] = { enabled: !0 }),
        a === "navigation" &&
          t[a] &&
          t[a].enabled &&
          !t[a].prevEl &&
          !t[a].nextEl &&
          (t[a].auto = !0),
        ["pagination", "scrollbar"].indexOf(a) >= 0 &&
          t[a] &&
          t[a].enabled &&
          !t[a].el &&
          (t[a].auto = !0),
        !(a in t && "enabled" in l))
      ) {
        dr(e, i);
        return;
      }
      (typeof t[a] == "object" && !("enabled" in t[a]) && (t[a].enabled = !0),
        t[a] || (t[a] = { enabled: !1 }),
        dr(e, i));
    };
  }
  const Rx = {
      eventsEmitter: S3,
      update: D3,
      translate: F3,
      transition: q3,
      slide: K3,
      loop: nD,
      grabCursor: rD,
      events: gD,
      breakpoints: bD,
      checkOverflow: ED,
      classes: SD,
    },
    Lx = {};
  let Aw = class io {
    constructor() {
      let e, n;
      for (var i = arguments.length, a = new Array(i), l = 0; l < i; l++)
        a[l] = arguments[l];
      (a.length === 1 &&
      a[0].constructor &&
      Object.prototype.toString.call(a[0]).slice(8, -1) === "Object"
        ? (n = a[0])
        : ([e, n] = a),
        n || (n = {}),
        (n = dr({}, n)),
        e && !n.el && (n.el = e));
      const u = ml();
      if (
        n.el &&
        typeof n.el == "string" &&
        u.querySelectorAll(n.el).length > 1
      ) {
        const v = [];
        return (
          u.querySelectorAll(n.el).forEach((y) => {
            const w = dr({}, n, { el: y });
            v.push(new io(w));
          }),
          v
        );
      }
      const d = this;
      ((d.__swiper__ = !0),
        (d.support = fC()),
        (d.device = dC({ userAgent: n.userAgent })),
        (d.browser = hC()),
        (d.eventsListeners = {}),
        (d.eventsAnyListeners = []),
        (d.modules = [...d.__modules__]),
        n.modules && Array.isArray(n.modules) && d.modules.push(...n.modules));
      const m = {};
      d.modules.forEach((v) => {
        v({
          params: n,
          swiper: d,
          extendParams: CD(n, m),
          on: d.on.bind(d),
          once: d.once.bind(d),
          off: d.off.bind(d),
          emit: d.emit.bind(d),
        });
      });
      const g = dr({}, $_, m);
      return (
        (d.params = dr({}, g, Lx, n)),
        (d.originalParams = dr({}, d.params)),
        (d.passedParams = dr({}, n)),
        d.params &&
          d.params.on &&
          Object.keys(d.params.on).forEach((v) => {
            d.on(v, d.params.on[v]);
          }),
        d.params && d.params.onAny && d.onAny(d.params.onAny),
        Object.assign(d, {
          enabled: d.params.enabled,
          el: e,
          classNames: [],
          slides: [],
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal() {
            return d.params.direction === "horizontal";
          },
          isVertical() {
            return d.params.direction === "vertical";
          },
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          cssOverflowAdjustment() {
            return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
          },
          allowSlideNext: d.params.allowSlideNext,
          allowSlidePrev: d.params.allowSlidePrev,
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            focusableElements: d.params.focusableElements,
            lastClickTime: 0,
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            startMoving: void 0,
            pointerId: null,
            touchId: null,
          },
          allowClick: !0,
          allowTouchMove: d.params.allowTouchMove,
          touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
          imagesToLoad: [],
          imagesLoaded: 0,
        }),
        d.emit("_swiper"),
        d.params.init && d.init(),
        d
      );
    }
    getDirectionLabel(e) {
      return this.isHorizontal()
        ? e
        : {
            width: "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            marginRight: "marginBottom",
          }[e];
    }
    getSlideIndex(e) {
      const { slidesEl: n, params: i } = this,
        a = dl(n, `.${i.slideClass}, swiper-slide`),
        l = gb(a[0]);
      return gb(e) - l;
    }
    getSlideIndexByData(e) {
      return this.getSlideIndex(
        this.slides.find(
          (n) => n.getAttribute("data-swiper-slide-index") * 1 === e,
        ),
      );
    }
    getSlideIndexWhenGrid(e) {
      return (
        this.grid &&
          this.params.grid &&
          this.params.grid.rows > 1 &&
          (this.params.grid.fill === "column"
            ? (e = Math.floor(e / this.params.grid.rows))
            : this.params.grid.fill === "row" &&
              (e = e % Math.ceil(this.slides.length / this.params.grid.rows))),
        e
      );
    }
    recalcSlides() {
      const e = this,
        { slidesEl: n, params: i } = e;
      e.slides = dl(n, `.${i.slideClass}, swiper-slide`);
    }
    enable() {
      const e = this;
      e.enabled ||
        ((e.enabled = !0),
        e.params.grabCursor && e.setGrabCursor(),
        e.emit("enable"));
    }
    disable() {
      const e = this;
      e.enabled &&
        ((e.enabled = !1),
        e.params.grabCursor && e.unsetGrabCursor(),
        e.emit("disable"));
    }
    setProgress(e, n) {
      const i = this;
      e = Math.min(Math.max(e, 0), 1);
      const a = i.minTranslate(),
        u = (i.maxTranslate() - a) * e + a;
      (i.translateTo(u, typeof n > "u" ? 0 : n),
        i.updateActiveIndex(),
        i.updateSlidesClasses());
    }
    emitContainerClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const n = e.el.className
        .split(" ")
        .filter(
          (i) =>
            i.indexOf("swiper") === 0 ||
            i.indexOf(e.params.containerModifierClass) === 0,
        );
      e.emit("_containerClasses", n.join(" "));
    }
    getSlideClasses(e) {
      const n = this;
      return n.destroyed
        ? ""
        : e.className
            .split(" ")
            .filter(
              (i) =>
                i.indexOf("swiper-slide") === 0 ||
                i.indexOf(n.params.slideClass) === 0,
            )
            .join(" ");
    }
    emitSlidesClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const n = [];
      (e.slides.forEach((i) => {
        const a = e.getSlideClasses(i);
        (n.push({ slideEl: i, classNames: a }), e.emit("_slideClass", i, a));
      }),
        e.emit("_slideClasses", n));
    }
    slidesPerViewDynamic(e, n) {
      (e === void 0 && (e = "current"), n === void 0 && (n = !1));
      const i = this,
        {
          params: a,
          slides: l,
          slidesGrid: u,
          slidesSizesGrid: d,
          size: m,
          activeIndex: g,
        } = i;
      let v = 1;
      if (typeof a.slidesPerView == "number") return a.slidesPerView;
      if (a.centeredSlides) {
        let y = l[g] ? Math.ceil(l[g].swiperSlideSize) : 0,
          w;
        for (let S = g + 1; S < l.length; S += 1)
          l[S] &&
            !w &&
            ((y += Math.ceil(l[S].swiperSlideSize)),
            (v += 1),
            y > m && (w = !0));
        for (let S = g - 1; S >= 0; S -= 1)
          l[S] &&
            !w &&
            ((y += l[S].swiperSlideSize), (v += 1), y > m && (w = !0));
      } else if (e === "current")
        for (let y = g + 1; y < l.length; y += 1)
          (n ? u[y] + d[y] - u[g] < m : u[y] - u[g] < m) && (v += 1);
      else for (let y = g - 1; y >= 0; y -= 1) u[g] - u[y] < m && (v += 1);
      return v;
    }
    update() {
      const e = this;
      if (!e || e.destroyed) return;
      const { snapGrid: n, params: i } = e;
      (i.breakpoints && e.setBreakpoint(),
        [...e.el.querySelectorAll('[loading="lazy"]')].forEach((u) => {
          u.complete && Q0(e, u);
        }),
        e.updateSize(),
        e.updateSlides(),
        e.updateProgress(),
        e.updateSlidesClasses());
      function a() {
        const u = e.rtlTranslate ? e.translate * -1 : e.translate,
          d = Math.min(Math.max(u, e.maxTranslate()), e.minTranslate());
        (e.setTranslate(d), e.updateActiveIndex(), e.updateSlidesClasses());
      }
      let l;
      if (i.freeMode && i.freeMode.enabled && !i.cssMode)
        (a(), i.autoHeight && e.updateAutoHeight());
      else {
        if (
          (i.slidesPerView === "auto" || i.slidesPerView > 1) &&
          e.isEnd &&
          !i.centeredSlides
        ) {
          const u =
            e.virtual && i.virtual.enabled ? e.virtual.slides : e.slides;
          l = e.slideTo(u.length - 1, 0, !1, !0);
        } else l = e.slideTo(e.activeIndex, 0, !1, !0);
        l || a();
      }
      (i.watchOverflow && n !== e.snapGrid && e.checkOverflow(),
        e.emit("update"));
    }
    changeDirection(e, n) {
      n === void 0 && (n = !0);
      const i = this,
        a = i.params.direction;
      return (
        e || (e = a === "horizontal" ? "vertical" : "horizontal"),
        e === a ||
          (e !== "horizontal" && e !== "vertical") ||
          (i.el.classList.remove(`${i.params.containerModifierClass}${a}`),
          i.el.classList.add(`${i.params.containerModifierClass}${e}`),
          i.emitContainerClasses(),
          (i.params.direction = e),
          i.slides.forEach((l) => {
            e === "vertical" ? (l.style.width = "") : (l.style.height = "");
          }),
          i.emit("changeDirection"),
          n && i.update()),
        i
      );
    }
    changeLanguageDirection(e) {
      const n = this;
      (n.rtl && e === "rtl") ||
        (!n.rtl && e === "ltr") ||
        ((n.rtl = e === "rtl"),
        (n.rtlTranslate = n.params.direction === "horizontal" && n.rtl),
        n.rtl
          ? (n.el.classList.add(`${n.params.containerModifierClass}rtl`),
            (n.el.dir = "rtl"))
          : (n.el.classList.remove(`${n.params.containerModifierClass}rtl`),
            (n.el.dir = "ltr")),
        n.update());
    }
    mount(e) {
      const n = this;
      if (n.mounted) return !0;
      let i = e || n.params.el;
      if ((typeof i == "string" && (i = document.querySelector(i)), !i))
        return !1;
      ((i.swiper = n),
        i.parentNode &&
          i.parentNode.host &&
          i.parentNode.host.nodeName ===
            n.params.swiperElementNodeName.toUpperCase() &&
          (n.isElement = !0));
      const a = () =>
        `.${(n.params.wrapperClass || "").trim().split(" ").join(".")}`;
      let u =
        i && i.shadowRoot && i.shadowRoot.querySelector
          ? i.shadowRoot.querySelector(a())
          : dl(i, a())[0];
      return (
        !u &&
          n.params.createElements &&
          ((u = mb("div", n.params.wrapperClass)),
          i.append(u),
          dl(i, `.${n.params.slideClass}`).forEach((d) => {
            u.append(d);
          })),
        Object.assign(n, {
          el: i,
          wrapperEl: u,
          slidesEl:
            n.isElement && !i.parentNode.host.slideSlots
              ? i.parentNode.host
              : u,
          hostEl: n.isElement ? i.parentNode.host : i,
          mounted: !0,
          rtl: i.dir.toLowerCase() === "rtl" || Rc(i, "direction") === "rtl",
          rtlTranslate:
            n.params.direction === "horizontal" &&
            (i.dir.toLowerCase() === "rtl" || Rc(i, "direction") === "rtl"),
          wrongRTL: Rc(u, "display") === "-webkit-box",
        }),
        !0
      );
    }
    init(e) {
      const n = this;
      if (n.initialized || n.mount(e) === !1) return n;
      (n.emit("beforeInit"),
        n.params.breakpoints && n.setBreakpoint(),
        n.addClasses(),
        n.updateSize(),
        n.updateSlides(),
        n.params.watchOverflow && n.checkOverflow(),
        n.params.grabCursor && n.enabled && n.setGrabCursor(),
        n.params.loop && n.virtual && n.params.virtual.enabled
          ? n.slideTo(
              n.params.initialSlide + n.virtual.slidesBefore,
              0,
              n.params.runCallbacksOnInit,
              !1,
              !0,
            )
          : n.slideTo(
              n.params.initialSlide,
              0,
              n.params.runCallbacksOnInit,
              !1,
              !0,
            ),
        n.params.loop && n.loopCreate(void 0, !0),
        n.attachEvents());
      const a = [...n.el.querySelectorAll('[loading="lazy"]')];
      return (
        n.isElement && a.push(...n.hostEl.querySelectorAll('[loading="lazy"]')),
        a.forEach((l) => {
          l.complete
            ? Q0(n, l)
            : l.addEventListener("load", (u) => {
                Q0(n, u.target);
              });
        }),
        q_(n),
        (n.initialized = !0),
        q_(n),
        n.emit("init"),
        n.emit("afterInit"),
        n
      );
    }
    destroy(e, n) {
      (e === void 0 && (e = !0), n === void 0 && (n = !0));
      const i = this,
        { params: a, el: l, wrapperEl: u, slides: d } = i;
      return (
        typeof i.params > "u" ||
          i.destroyed ||
          (i.emit("beforeDestroy"),
          (i.initialized = !1),
          i.detachEvents(),
          a.loop && i.loopDestroy(),
          n &&
            (i.removeClasses(),
            l && typeof l != "string" && l.removeAttribute("style"),
            u && u.removeAttribute("style"),
            d &&
              d.length &&
              d.forEach((m) => {
                (m.classList.remove(
                  a.slideVisibleClass,
                  a.slideFullyVisibleClass,
                  a.slideActiveClass,
                  a.slideNextClass,
                  a.slidePrevClass,
                ),
                  m.removeAttribute("style"),
                  m.removeAttribute("data-swiper-slide-index"));
              })),
          i.emit("destroy"),
          Object.keys(i.eventsListeners).forEach((m) => {
            i.off(m);
          }),
          e !== !1 &&
            (i.el && typeof i.el != "string" && (i.el.swiper = null), u3(i)),
          (i.destroyed = !0)),
        null
      );
    }
    static extendDefaults(e) {
      dr(Lx, e);
    }
    static get extendedDefaults() {
      return Lx;
    }
    static get defaults() {
      return $_;
    }
    static installModule(e) {
      io.prototype.__modules__ || (io.prototype.__modules__ = []);
      const n = io.prototype.__modules__;
      typeof e == "function" && n.indexOf(e) < 0 && n.push(e);
    }
    static use(e) {
      return Array.isArray(e)
        ? (e.forEach((n) => io.installModule(n)), io)
        : (io.installModule(e), io);
    }
  };
  Object.keys(Rx).forEach((t) => {
    Object.keys(Rx[t]).forEach((e) => {
      Aw.prototype[e] = Rx[t][e];
    });
  });
  Aw.use([_3, w3]);
  const gC = [
    "eventsPrefix",
    "injectStyles",
    "injectStylesUrls",
    "modules",
    "init",
    "_direction",
    "oneWayMovement",
    "swiperElementNodeName",
    "touchEventsTarget",
    "initialSlide",
    "_speed",
    "cssMode",
    "updateOnWindowResize",
    "resizeObserver",
    "nested",
    "focusableElements",
    "_enabled",
    "_width",
    "_height",
    "preventInteractionOnTransition",
    "userAgent",
    "url",
    "_edgeSwipeDetection",
    "_edgeSwipeThreshold",
    "_freeMode",
    "_autoHeight",
    "setWrapperSize",
    "virtualTranslate",
    "_effect",
    "breakpoints",
    "breakpointsBase",
    "_spaceBetween",
    "_slidesPerView",
    "maxBackfaceHiddenSlides",
    "_grid",
    "_slidesPerGroup",
    "_slidesPerGroupSkip",
    "_slidesPerGroupAuto",
    "_centeredSlides",
    "_centeredSlidesBounds",
    "_slidesOffsetBefore",
    "_slidesOffsetAfter",
    "normalizeSlideIndex",
    "_centerInsufficientSlides",
    "_watchOverflow",
    "roundLengths",
    "touchRatio",
    "touchAngle",
    "simulateTouch",
    "_shortSwipes",
    "_longSwipes",
    "longSwipesRatio",
    "longSwipesMs",
    "_followFinger",
    "allowTouchMove",
    "_threshold",
    "touchMoveStopPropagation",
    "touchStartPreventDefault",
    "touchStartForcePreventDefault",
    "touchReleaseOnEdges",
    "uniqueNavElements",
    "_resistance",
    "_resistanceRatio",
    "_watchSlidesProgress",
    "_grabCursor",
    "preventClicks",
    "preventClicksPropagation",
    "_slideToClickedSlide",
    "_loop",
    "loopAdditionalSlides",
    "loopAddBlankSlides",
    "loopPreventsSliding",
    "_rewind",
    "_allowSlidePrev",
    "_allowSlideNext",
    "_swipeHandler",
    "_noSwiping",
    "noSwipingClass",
    "noSwipingSelector",
    "passiveListeners",
    "containerModifierClass",
    "slideClass",
    "slideActiveClass",
    "slideVisibleClass",
    "slideFullyVisibleClass",
    "slideNextClass",
    "slidePrevClass",
    "slideBlankClass",
    "wrapperClass",
    "lazyPreloaderClass",
    "lazyPreloadPrevNext",
    "runCallbacksOnInit",
    "observer",
    "observeParents",
    "observeSlideChildren",
    "a11y",
    "_autoplay",
    "_controller",
    "coverflowEffect",
    "cubeEffect",
    "fadeEffect",
    "flipEffect",
    "creativeEffect",
    "cardsEffect",
    "hashNavigation",
    "history",
    "keyboard",
    "mousewheel",
    "_navigation",
    "_pagination",
    "parallax",
    "_scrollbar",
    "_thumbs",
    "virtual",
    "zoom",
    "control",
  ];
  function zf(t) {
    return (
      typeof t == "object" &&
      t !== null &&
      t.constructor &&
      Object.prototype.toString.call(t).slice(8, -1) === "Object" &&
      !t.__swiper__
    );
  }
  function Rh(t, e) {
    const n = ["__proto__", "constructor", "prototype"];
    Object.keys(e)
      .filter((i) => n.indexOf(i) < 0)
      .forEach((i) => {
        typeof t[i] > "u"
          ? (t[i] = e[i])
          : zf(e[i]) && zf(t[i]) && Object.keys(e[i]).length > 0
            ? e[i].__swiper__
              ? (t[i] = e[i])
              : Rh(t[i], e[i])
            : (t[i] = e[i]);
      });
  }
  function vC(t) {
    return (
      t === void 0 && (t = {}),
      t.navigation &&
        typeof t.navigation.nextEl > "u" &&
        typeof t.navigation.prevEl > "u"
    );
  }
  function yC(t) {
    return (
      t === void 0 && (t = {}),
      t.pagination && typeof t.pagination.el > "u"
    );
  }
  function bC(t) {
    return (
      t === void 0 && (t = {}),
      t.scrollbar && typeof t.scrollbar.el > "u"
    );
  }
  function xC(t) {
    t === void 0 && (t = "");
    const e = t
        .split(" ")
        .map((i) => i.trim())
        .filter((i) => !!i),
      n = [];
    return (
      e.forEach((i) => {
        n.indexOf(i) < 0 && n.push(i);
      }),
      n.join(" ")
    );
  }
  function OD(t) {
    return (
      t === void 0 && (t = ""),
      t
        ? t.includes("swiper-wrapper")
          ? t
          : `swiper-wrapper ${t}`
        : "swiper-wrapper"
    );
  }
  function jD(t) {
    let {
      swiper: e,
      slides: n,
      passedParams: i,
      changedParams: a,
      nextEl: l,
      prevEl: u,
      scrollbarEl: d,
      paginationEl: m,
    } = t;
    const g = a.filter(
        (I) => I !== "children" && I !== "direction" && I !== "wrapperClass",
      ),
      {
        params: v,
        pagination: y,
        navigation: w,
        scrollbar: S,
        virtual: T,
        thumbs: E,
      } = e;
    let j, O, M, N, R, P, G, Y;
    (a.includes("thumbs") &&
      i.thumbs &&
      i.thumbs.swiper &&
      !i.thumbs.swiper.destroyed &&
      v.thumbs &&
      (!v.thumbs.swiper || v.thumbs.swiper.destroyed) &&
      (j = !0),
      a.includes("controller") &&
        i.controller &&
        i.controller.control &&
        v.controller &&
        !v.controller.control &&
        (O = !0),
      a.includes("pagination") &&
        i.pagination &&
        (i.pagination.el || m) &&
        (v.pagination || v.pagination === !1) &&
        y &&
        !y.el &&
        (M = !0),
      a.includes("scrollbar") &&
        i.scrollbar &&
        (i.scrollbar.el || d) &&
        (v.scrollbar || v.scrollbar === !1) &&
        S &&
        !S.el &&
        (N = !0),
      a.includes("navigation") &&
        i.navigation &&
        (i.navigation.prevEl || u) &&
        (i.navigation.nextEl || l) &&
        (v.navigation || v.navigation === !1) &&
        w &&
        !w.prevEl &&
        !w.nextEl &&
        (R = !0));
    const B = (I) => {
      e[I] &&
        (e[I].destroy(),
        I === "navigation"
          ? (e.isElement && (e[I].prevEl.remove(), e[I].nextEl.remove()),
            (v[I].prevEl = void 0),
            (v[I].nextEl = void 0),
            (e[I].prevEl = void 0),
            (e[I].nextEl = void 0))
          : (e.isElement && e[I].el.remove(),
            (v[I].el = void 0),
            (e[I].el = void 0)));
    };
    (a.includes("loop") &&
      e.isElement &&
      (v.loop && !i.loop ? (P = !0) : !v.loop && i.loop ? (G = !0) : (Y = !0)),
      g.forEach((I) => {
        if (zf(v[I]) && zf(i[I]))
          (Object.assign(v[I], i[I]),
            (I === "navigation" || I === "pagination" || I === "scrollbar") &&
              "enabled" in i[I] &&
              !i[I].enabled &&
              B(I));
        else {
          const H = i[I];
          (H === !0 || H === !1) &&
          (I === "navigation" || I === "pagination" || I === "scrollbar")
            ? H === !1 && B(I)
            : (v[I] = i[I]);
        }
      }),
      g.includes("controller") &&
        !O &&
        e.controller &&
        e.controller.control &&
        v.controller &&
        v.controller.control &&
        (e.controller.control = v.controller.control),
      a.includes("children") && n && T && v.virtual.enabled
        ? ((T.slides = n), T.update(!0))
        : a.includes("virtual") &&
          T &&
          v.virtual.enabled &&
          (n && (T.slides = n), T.update(!0)),
      a.includes("children") && n && v.loop && (Y = !0),
      j && E.init() && E.update(!0),
      O && (e.controller.control = v.controller.control),
      M &&
        (e.isElement &&
          (!m || typeof m == "string") &&
          ((m = document.createElement("div")),
          m.classList.add("swiper-pagination"),
          m.part.add("pagination"),
          e.el.appendChild(m)),
        m && (v.pagination.el = m),
        y.init(),
        y.render(),
        y.update()),
      N &&
        (e.isElement &&
          (!d || typeof d == "string") &&
          ((d = document.createElement("div")),
          d.classList.add("swiper-scrollbar"),
          d.part.add("scrollbar"),
          e.el.appendChild(d)),
        d && (v.scrollbar.el = d),
        S.init(),
        S.updateSize(),
        S.setTranslate()),
      R &&
        (e.isElement &&
          ((!l || typeof l == "string") &&
            ((l = document.createElement("div")),
            l.classList.add("swiper-button-next"),
            vb(l, e.hostEl.constructor.nextButtonSvg),
            l.part.add("button-next"),
            e.el.appendChild(l)),
          (!u || typeof u == "string") &&
            ((u = document.createElement("div")),
            u.classList.add("swiper-button-prev"),
            vb(u, e.hostEl.constructor.prevButtonSvg),
            u.part.add("button-prev"),
            e.el.appendChild(u))),
        l && (v.navigation.nextEl = l),
        u && (v.navigation.prevEl = u),
        w.init(),
        w.update()),
      a.includes("allowSlideNext") && (e.allowSlideNext = i.allowSlideNext),
      a.includes("allowSlidePrev") && (e.allowSlidePrev = i.allowSlidePrev),
      a.includes("direction") && e.changeDirection(i.direction, !1),
      (P || Y) && e.loopDestroy(),
      (G || Y) && e.loopCreate(),
      e.update());
  }
  function MD(t, e) {
    (t === void 0 && (t = {}), e === void 0 && (e = !0));
    const n = { on: {} },
      i = {},
      a = {};
    (Rh(n, $_), (n._emitClasses = !0), (n.init = !1));
    const l = {},
      u = gC.map((m) => m.replace(/_/, "")),
      d = Object.assign({}, t);
    return (
      Object.keys(d).forEach((m) => {
        typeof t[m] > "u" ||
          (u.indexOf(m) >= 0
            ? zf(t[m])
              ? ((n[m] = {}), (a[m] = {}), Rh(n[m], t[m]), Rh(a[m], t[m]))
              : ((n[m] = t[m]), (a[m] = t[m]))
            : m.search(/on[A-Z]/) === 0 && typeof t[m] == "function"
              ? e
                ? (i[`${m[2].toLowerCase()}${m.substr(3)}`] = t[m])
                : (n.on[`${m[2].toLowerCase()}${m.substr(3)}`] = t[m])
              : (l[m] = t[m]));
      }),
      ["navigation", "pagination", "scrollbar"].forEach((m) => {
        (n[m] === !0 && (n[m] = {}), n[m] === !1 && delete n[m]);
      }),
      { params: n, passedParams: a, rest: l, events: i }
    );
  }
  function ND(t, e) {
    let {
      el: n,
      nextEl: i,
      prevEl: a,
      paginationEl: l,
      scrollbarEl: u,
      swiper: d,
    } = t;
    (vC(e) &&
      i &&
      a &&
      ((d.params.navigation.nextEl = i),
      (d.originalParams.navigation.nextEl = i),
      (d.params.navigation.prevEl = a),
      (d.originalParams.navigation.prevEl = a)),
      yC(e) &&
        l &&
        ((d.params.pagination.el = l), (d.originalParams.pagination.el = l)),
      bC(e) &&
        u &&
        ((d.params.scrollbar.el = u), (d.originalParams.scrollbar.el = u)),
      d.init(n));
  }
  function AD(t, e, n, i, a) {
    const l = [];
    if (!e) return l;
    const u = (m) => {
      l.indexOf(m) < 0 && l.push(m);
    };
    if (n && i) {
      const m = i.map(a),
        g = n.map(a);
      (m.join("") !== g.join("") && u("children"),
        i.length !== n.length && u("children"));
    }
    return (
      gC
        .filter((m) => m[0] === "_")
        .map((m) => m.replace(/_/, ""))
        .forEach((m) => {
          if (m in t && m in e)
            if (zf(t[m]) && zf(e[m])) {
              const g = Object.keys(t[m]),
                v = Object.keys(e[m]);
              g.length !== v.length
                ? u(m)
                : (g.forEach((y) => {
                    t[m][y] !== e[m][y] && u(m);
                  }),
                  v.forEach((y) => {
                    t[m][y] !== e[m][y] && u(m);
                  }));
            } else t[m] !== e[m] && u(m);
        }),
      l
    );
  }
  const RD = (t) => {
    !t ||
      t.destroyed ||
      !t.params.virtual ||
      (t.params.virtual && !t.params.virtual.enabled) ||
      (t.updateSlides(),
      t.updateProgress(),
      t.updateSlidesClasses(),
      t.emit("_virtualUpdated"),
      t.parallax &&
        t.params.parallax &&
        t.params.parallax.enabled &&
        t.parallax.setTranslate());
  };
  function yb() {
    return (
      (yb = Object.assign
        ? Object.assign.bind()
        : function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = arguments[e];
              for (var i in n)
                Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
            }
            return t;
          }),
      yb.apply(this, arguments)
    );
  }
  function _C(t) {
    return (
      t.type && t.type.displayName && t.type.displayName.includes("SwiperSlide")
    );
  }
  function wC(t) {
    const e = [];
    return (
      U.Children.toArray(t).forEach((n) => {
        _C(n)
          ? e.push(n)
          : n.props &&
            n.props.children &&
            wC(n.props.children).forEach((i) => e.push(i));
      }),
      e
    );
  }
  function LD(t) {
    const e = [],
      n = {
        "container-start": [],
        "container-end": [],
        "wrapper-start": [],
        "wrapper-end": [],
      };
    return (
      U.Children.toArray(t).forEach((i) => {
        if (_C(i)) e.push(i);
        else if (i.props && i.props.slot && n[i.props.slot])
          n[i.props.slot].push(i);
        else if (i.props && i.props.children) {
          const a = wC(i.props.children);
          a.length > 0
            ? a.forEach((l) => e.push(l))
            : n["container-end"].push(i);
        } else n["container-end"].push(i);
      }),
      { slides: e, slots: n }
    );
  }
  function DD(t, e, n) {
    if (!n) return null;
    const i = (v) => {
        let y = v;
        return (
          v < 0 ? (y = e.length + v) : y >= e.length && (y = y - e.length),
          y
        );
      },
      a = t.isHorizontal()
        ? { [t.rtlTranslate ? "right" : "left"]: `${n.offset}px` }
        : { top: `${n.offset}px` },
      { from: l, to: u } = n,
      d = t.params.loop ? -e.length : 0,
      m = t.params.loop ? e.length * 2 : e.length,
      g = [];
    for (let v = d; v < m; v += 1) v >= l && v <= u && g.push(e[i(v)]);
    return g.map((v, y) =>
      U.cloneElement(v, {
        swiper: t,
        style: a,
        key: v.props.virtualIndex || v.key || `slide-${y}`,
      }),
    );
  }
  function _g(t, e) {
    return typeof window > "u" ? W.useEffect(t, e) : W.useLayoutEffect(t, e);
  }
  const ET = W.createContext(null),
    kD = W.createContext(null),
    zc = W.forwardRef(function (t, e) {
      let {
          className: n,
          tag: i = "div",
          wrapperTag: a = "div",
          children: l,
          onSwiper: u,
          ...d
        } = t === void 0 ? {} : t,
        m = !1;
      const [g, v] = W.useState("swiper"),
        [y, w] = W.useState(null),
        [S, T] = W.useState(!1),
        E = W.useRef(!1),
        j = W.useRef(null),
        O = W.useRef(null),
        M = W.useRef(null),
        N = W.useRef(null),
        R = W.useRef(null),
        P = W.useRef(null),
        G = W.useRef(null),
        Y = W.useRef(null),
        { params: B, passedParams: I, rest: H, events: X } = MD(d),
        { slides: fe, slots: ve } = LD(l),
        be = () => {
          T(!S);
        };
      Object.assign(B.on, {
        _containerClasses(he, Te) {
          v(Te);
        },
      });
      const Oe = () => {
        (Object.assign(B.on, X), (m = !0));
        const he = { ...B };
        if (
          (delete he.wrapperClass,
          (O.current = new Aw(he)),
          O.current.virtual && O.current.params.virtual.enabled)
        ) {
          O.current.virtual.slides = fe;
          const Te = {
            cache: !1,
            slides: fe,
            renderExternal: w,
            renderExternalUpdate: !1,
          };
          (Rh(O.current.params.virtual, Te),
            Rh(O.current.originalParams.virtual, Te));
        }
      };
      (j.current || Oe(), O.current && O.current.on("_beforeBreakpoint", be));
      const V = () => {
          m ||
            !X ||
            !O.current ||
            Object.keys(X).forEach((he) => {
              O.current.on(he, X[he]);
            });
        },
        pe = () => {
          !X ||
            !O.current ||
            Object.keys(X).forEach((he) => {
              O.current.off(he, X[he]);
            });
        };
      (W.useEffect(() => () => {
        O.current && O.current.off("_beforeBreakpoint", be);
      }),
        W.useEffect(() => {
          !E.current &&
            O.current &&
            (O.current.emitSlidesClasses(), (E.current = !0));
        }),
        _g(() => {
          if ((e && (e.current = j.current), !!j.current))
            return (
              O.current.destroyed && Oe(),
              ND(
                {
                  el: j.current,
                  nextEl: R.current,
                  prevEl: P.current,
                  paginationEl: G.current,
                  scrollbarEl: Y.current,
                  swiper: O.current,
                },
                B,
              ),
              u && !O.current.destroyed && u(O.current),
              () => {
                O.current && !O.current.destroyed && O.current.destroy(!0, !1);
              }
            );
        }, []),
        _g(() => {
          V();
          const he = AD(I, M.current, fe, N.current, (Te) => Te.key);
          return (
            (M.current = I),
            (N.current = fe),
            he.length &&
              O.current &&
              !O.current.destroyed &&
              jD({
                swiper: O.current,
                slides: fe,
                passedParams: I,
                changedParams: he,
                nextEl: R.current,
                prevEl: P.current,
                scrollbarEl: Y.current,
                paginationEl: G.current,
              }),
            () => {
              pe();
            }
          );
        }),
        _g(() => {
          RD(O.current);
        }, [y]));
      function de() {
        return B.virtual
          ? DD(O.current, fe, y)
          : fe.map((he, Te) =>
              U.cloneElement(he, { swiper: O.current, swiperSlideIndex: Te }),
            );
      }
      return U.createElement(
        i,
        yb({ ref: j, className: xC(`${g}${n ? ` ${n}` : ""}`) }, H),
        U.createElement(
          kD.Provider,
          { value: O.current },
          ve["container-start"],
          U.createElement(
            a,
            { className: OD(B.wrapperClass) },
            ve["wrapper-start"],
            de(),
            ve["wrapper-end"],
          ),
          vC(B) &&
            U.createElement(
              U.Fragment,
              null,
              U.createElement("div", {
                ref: P,
                className: "swiper-button-prev",
              }),
              U.createElement("div", {
                ref: R,
                className: "swiper-button-next",
              }),
            ),
          bC(B) &&
            U.createElement("div", { ref: Y, className: "swiper-scrollbar" }),
          yC(B) &&
            U.createElement("div", { ref: G, className: "swiper-pagination" }),
          ve["container-end"],
        ),
      );
    });
  zc.displayName = "Swiper";
  const Pc = W.forwardRef(function (t, e) {
    let {
      tag: n = "div",
      children: i,
      className: a = "",
      swiper: l,
      zoom: u,
      lazy: d,
      virtualIndex: m,
      swiperSlideIndex: g,
      ...v
    } = t === void 0 ? {} : t;
    const y = W.useRef(null),
      [w, S] = W.useState("swiper-slide"),
      [T, E] = W.useState(!1);
    function j(R, P, G) {
      P === y.current && S(G);
    }
    (_g(() => {
      if (
        (typeof g < "u" && (y.current.swiperSlideIndex = g),
        e && (e.current = y.current),
        !(!y.current || !l))
      ) {
        if (l.destroyed) {
          w !== "swiper-slide" && S("swiper-slide");
          return;
        }
        return (
          l.on("_slideClass", j),
          () => {
            l && l.off("_slideClass", j);
          }
        );
      }
    }),
      _g(() => {
        l && y.current && !l.destroyed && S(l.getSlideClasses(y.current));
      }, [l]));
    const O = {
        isActive: w.indexOf("swiper-slide-active") >= 0,
        isVisible: w.indexOf("swiper-slide-visible") >= 0,
        isPrev: w.indexOf("swiper-slide-prev") >= 0,
        isNext: w.indexOf("swiper-slide-next") >= 0,
      },
      M = () => (typeof i == "function" ? i(O) : i),
      N = () => {
        E(!0);
      };
    return U.createElement(
      n,
      yb(
        {
          ref: y,
          className: xC(`${w}${a ? ` ${a}` : ""}`),
          "data-swiper-slide-index": m,
          onLoad: N,
        },
        v,
      ),
      u &&
        U.createElement(
          ET.Provider,
          { value: O },
          U.createElement(
            "div",
            {
              className: "swiper-zoom-container",
              "data-swiper-zoom": typeof u == "number" ? u : void 0,
            },
            M(),
            d &&
              !T &&
              U.createElement("div", { className: "swiper-lazy-preloader" }),
          ),
        ),
      !u &&
        U.createElement(
          ET.Provider,
          { value: O },
          M(),
          d &&
            !T &&
            U.createElement("div", { className: "swiper-lazy-preloader" }),
        ),
    );
  });
  Pc.displayName = "SwiperSlide";
  function zD(t) {
    return Fi({
      attr: { viewBox: "0 0 320 512" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z",
          },
          child: [],
        },
      ],
    })(t);
  }
  function PD(t) {
    return Fi({
      attr: { viewBox: "0 0 320 512" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z",
          },
          child: [],
        },
      ],
    })(t);
  }
  const ID = ({ finded: t }) => {
    var v, y, w, S, T, E;
    const { t: e } = Ot(),
      [n, i] = U.useState(0),
      [a, l] = U.useState(null),
      u = (j) => {
        (i(j), a == null || a.slideTo(j));
      },
      d = () => (a == null ? void 0 : a.slidePrev()),
      m = () => (a == null ? void 0 : a.slideNext()),
      g = nt((j) => j.wpNumberState.wpNumber);
    return h.jsx("section", {
      className: "hero-inner-wrap",
      children: h.jsxs("div", {
        className: "hero-inner",
        children: [
          h.jsxs("div", {
            className: "left-carousel",
            children: [
              h.jsx("section", {
                className: "mini-images",
                children:
                  (t == null ? void 0 : t.media) &&
                  ((v = t == null ? void 0 : t.media) == null
                    ? void 0
                    : v.length) > 0 &&
                  ((y = t == null ? void 0 : t.media) == null
                    ? void 0
                    : y.map((j, O) =>
                        h.jsx(
                          "div",
                          {
                            onClick: () => u(O),
                            className: `image-container ${n === O ? "active" : ""}`,
                            children: h.jsx("img", {
                              src: j == null ? void 0 : j.image,
                              alt: j == null ? void 0 : j.image,
                              title: t == null ? void 0 : t.title,
                            }),
                          },
                          j == null ? void 0 : j.id,
                        ),
                      )),
              }),
              h.jsxs("section", {
                className: "carousel",
                children: [
                  h.jsxs("div", {
                    className: "custom-buttons",
                    children: [
                      h.jsx("button", {
                        type: "button",
                        onClick: d,
                        children: h.jsx(zD, { className: "icon" }),
                      }),
                      h.jsx("button", {
                        type: "button",
                        onClick: m,
                        children: h.jsx(PD, { className: "icon" }),
                      }),
                    ],
                  }),
                  h.jsx(zc, {
                    onSwiper: l,
                    onSlideChange: (j) => i(j.activeIndex),
                    spaceBetween: 12,
                    slidesPerView: 1,
                    children:
                      (t == null ? void 0 : t.media) &&
                      ((w = t == null ? void 0 : t.media) == null
                        ? void 0
                        : w.length) > 0 &&
                      ((S = t == null ? void 0 : t.media) == null
                        ? void 0
                        : S.map((j) =>
                            h.jsx(
                              Pc,
                              {
                                children: h.jsx("img", {
                                  src: j == null ? void 0 : j.image,
                                  alt: j == null ? void 0 : j.image,
                                  title: t == null ? void 0 : t.title,
                                }),
                              },
                              j == null ? void 0 : j.id,
                            ),
                          )),
                  }),
                ],
              }),
            ],
          }),
          h.jsxs("div", {
            className: "right-content",
            children: [
              h.jsx("h1", { children: t == null ? void 0 : t.title }),
              h.jsx("div", {
                className: "specifications",
                children:
                  t != null &&
                  t.attributes &&
                  ((T = t == null ? void 0 : t.attributes) == null
                    ? void 0
                    : T.length) > 0
                    ? (E = t == null ? void 0 : t.attributes) == null
                      ? void 0
                      : E.map((j) =>
                          h.jsxs(
                            "div",
                            {
                              className: "item-specification",
                              children: [
                                h.jsx("h3", {
                                  className: "property",
                                  children: j == null ? void 0 : j.key,
                                }),
                                h.jsx("p", {
                                  className: "value-text",
                                  children: j == null ? void 0 : j.value,
                                }),
                              ],
                            },
                            j == null ? void 0 : j.id,
                          ),
                        )
                    : null,
              }),
              h.jsx("div", {
                className: "get-contact-button",
                children: h.jsxs(_t, {
                  to: `https://wa.me/${g || e("your_telephone_number")}`,
                  className: "link",
                  rel: "noopener noreferrer",
                  target: "_blank",
                  children: [
                    h.jsx("img", {
                      src: "/wpp.svg",
                      alt: "Whatsapp",
                      title: "Get Whatsapp",
                    }),
                    h.jsx("p", { children: "Müraciət et" }),
                  ],
                }),
              }),
            ],
          }),
        ],
      }),
    });
  };
  /*! @license DOMPurify 3.3.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.3.1/LICENSE */ const {
    entries: SC,
    setPrototypeOf: CT,
    isFrozen: UD,
    getPrototypeOf: FD,
    getOwnPropertyDescriptor: BD,
  } = Object;
  let { freeze: gs, seal: Pr, create: G_ } = Object,
    { apply: V_, construct: W_ } = typeof Reflect < "u" && Reflect;
  gs ||
    (gs = function (e) {
      return e;
    });
  Pr ||
    (Pr = function (e) {
      return e;
    });
  V_ ||
    (V_ = function (e, n) {
      for (
        var i = arguments.length, a = new Array(i > 2 ? i - 2 : 0), l = 2;
        l < i;
        l++
      )
        a[l - 2] = arguments[l];
      return e.apply(n, a);
    });
  W_ ||
    (W_ = function (e) {
      for (
        var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), a = 1;
        a < n;
        a++
      )
        i[a - 1] = arguments[a];
      return new e(...i);
    });
  const O0 = vs(Array.prototype.forEach),
    HD = vs(Array.prototype.lastIndexOf),
    OT = vs(Array.prototype.pop),
    rg = vs(Array.prototype.push),
    YD = vs(Array.prototype.splice),
    Z0 = vs(String.prototype.toLowerCase),
    Dx = vs(String.prototype.toString),
    kx = vs(String.prototype.match),
    ag = vs(String.prototype.replace),
    qD = vs(String.prototype.indexOf),
    $D = vs(String.prototype.trim),
    fa = vs(Object.prototype.hasOwnProperty),
    fs = vs(RegExp.prototype.test),
    lg = GD(TypeError);
  function vs(t) {
    return function (e) {
      e instanceof RegExp && (e.lastIndex = 0);
      for (
        var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), a = 1;
        a < n;
        a++
      )
        i[a - 1] = arguments[a];
      return V_(t, e, i);
    };
  }
  function GD(t) {
    return function () {
      for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++)
        n[i] = arguments[i];
      return W_(t, n);
    };
  }
  function bt(t, e) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Z0;
    CT && CT(t, null);
    let i = e.length;
    for (; i--; ) {
      let a = e[i];
      if (typeof a == "string") {
        const l = n(a);
        l !== a && (UD(e) || (e[i] = l), (a = l));
      }
      t[a] = !0;
    }
    return t;
  }
  function VD(t) {
    for (let e = 0; e < t.length; e++) fa(t, e) || (t[e] = null);
    return t;
  }
  function ll(t) {
    const e = G_(null);
    for (const [n, i] of SC(t))
      fa(t, n) &&
        (Array.isArray(i)
          ? (e[n] = VD(i))
          : i && typeof i == "object" && i.constructor === Object
            ? (e[n] = ll(i))
            : (e[n] = i));
    return e;
  }
  function og(t, e) {
    for (; t !== null; ) {
      const i = BD(t, e);
      if (i) {
        if (i.get) return vs(i.get);
        if (typeof i.value == "function") return vs(i.value);
      }
      t = FD(t);
    }
    function n() {
      return null;
    }
    return n;
  }
  const jT = gs([
      "a",
      "abbr",
      "acronym",
      "address",
      "area",
      "article",
      "aside",
      "audio",
      "b",
      "bdi",
      "bdo",
      "big",
      "blink",
      "blockquote",
      "body",
      "br",
      "button",
      "canvas",
      "caption",
      "center",
      "cite",
      "code",
      "col",
      "colgroup",
      "content",
      "data",
      "datalist",
      "dd",
      "decorator",
      "del",
      "details",
      "dfn",
      "dialog",
      "dir",
      "div",
      "dl",
      "dt",
      "element",
      "em",
      "fieldset",
      "figcaption",
      "figure",
      "font",
      "footer",
      "form",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "head",
      "header",
      "hgroup",
      "hr",
      "html",
      "i",
      "img",
      "input",
      "ins",
      "kbd",
      "label",
      "legend",
      "li",
      "main",
      "map",
      "mark",
      "marquee",
      "menu",
      "menuitem",
      "meter",
      "nav",
      "nobr",
      "ol",
      "optgroup",
      "option",
      "output",
      "p",
      "picture",
      "pre",
      "progress",
      "q",
      "rp",
      "rt",
      "ruby",
      "s",
      "samp",
      "search",
      "section",
      "select",
      "shadow",
      "slot",
      "small",
      "source",
      "spacer",
      "span",
      "strike",
      "strong",
      "style",
      "sub",
      "summary",
      "sup",
      "table",
      "tbody",
      "td",
      "template",
      "textarea",
      "tfoot",
      "th",
      "thead",
      "time",
      "tr",
      "track",
      "tt",
      "u",
      "ul",
      "var",
      "video",
      "wbr",
    ]),
    zx = gs([
      "svg",
      "a",
      "altglyph",
      "altglyphdef",
      "altglyphitem",
      "animatecolor",
      "animatemotion",
      "animatetransform",
      "circle",
      "clippath",
      "defs",
      "desc",
      "ellipse",
      "enterkeyhint",
      "exportparts",
      "filter",
      "font",
      "g",
      "glyph",
      "glyphref",
      "hkern",
      "image",
      "inputmode",
      "line",
      "lineargradient",
      "marker",
      "mask",
      "metadata",
      "mpath",
      "part",
      "path",
      "pattern",
      "polygon",
      "polyline",
      "radialgradient",
      "rect",
      "stop",
      "style",
      "switch",
      "symbol",
      "text",
      "textpath",
      "title",
      "tref",
      "tspan",
      "view",
      "vkern",
    ]),
    Px = gs([
      "feBlend",
      "feColorMatrix",
      "feComponentTransfer",
      "feComposite",
      "feConvolveMatrix",
      "feDiffuseLighting",
      "feDisplacementMap",
      "feDistantLight",
      "feDropShadow",
      "feFlood",
      "feFuncA",
      "feFuncB",
      "feFuncG",
      "feFuncR",
      "feGaussianBlur",
      "feImage",
      "feMerge",
      "feMergeNode",
      "feMorphology",
      "feOffset",
      "fePointLight",
      "feSpecularLighting",
      "feSpotLight",
      "feTile",
      "feTurbulence",
    ]),
    WD = gs([
      "animate",
      "color-profile",
      "cursor",
      "discard",
      "font-face",
      "font-face-format",
      "font-face-name",
      "font-face-src",
      "font-face-uri",
      "foreignobject",
      "hatch",
      "hatchpath",
      "mesh",
      "meshgradient",
      "meshpatch",
      "meshrow",
      "missing-glyph",
      "script",
      "set",
      "solidcolor",
      "unknown",
      "use",
    ]),
    Ix = gs([
      "math",
      "menclose",
      "merror",
      "mfenced",
      "mfrac",
      "mglyph",
      "mi",
      "mlabeledtr",
      "mmultiscripts",
      "mn",
      "mo",
      "mover",
      "mpadded",
      "mphantom",
      "mroot",
      "mrow",
      "ms",
      "mspace",
      "msqrt",
      "mstyle",
      "msub",
      "msup",
      "msubsup",
      "mtable",
      "mtd",
      "mtext",
      "mtr",
      "munder",
      "munderover",
      "mprescripts",
    ]),
    XD = gs([
      "maction",
      "maligngroup",
      "malignmark",
      "mlongdiv",
      "mscarries",
      "mscarry",
      "msgroup",
      "mstack",
      "msline",
      "msrow",
      "semantics",
      "annotation",
      "annotation-xml",
      "mprescripts",
      "none",
    ]),
    MT = gs(["#text"]),
    NT = gs([
      "accept",
      "action",
      "align",
      "alt",
      "autocapitalize",
      "autocomplete",
      "autopictureinpicture",
      "autoplay",
      "background",
      "bgcolor",
      "border",
      "capture",
      "cellpadding",
      "cellspacing",
      "checked",
      "cite",
      "class",
      "clear",
      "color",
      "cols",
      "colspan",
      "controls",
      "controlslist",
      "coords",
      "crossorigin",
      "datetime",
      "decoding",
      "default",
      "dir",
      "disabled",
      "disablepictureinpicture",
      "disableremoteplayback",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "exportparts",
      "face",
      "for",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "id",
      "inert",
      "inputmode",
      "integrity",
      "ismap",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "loop",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "multiple",
      "muted",
      "name",
      "nonce",
      "noshade",
      "novalidate",
      "nowrap",
      "open",
      "optimum",
      "part",
      "pattern",
      "placeholder",
      "playsinline",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "pubdate",
      "radiogroup",
      "readonly",
      "rel",
      "required",
      "rev",
      "reversed",
      "role",
      "rows",
      "rowspan",
      "spellcheck",
      "scope",
      "selected",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "srclang",
      "start",
      "src",
      "srcset",
      "step",
      "style",
      "summary",
      "tabindex",
      "title",
      "translate",
      "type",
      "usemap",
      "valign",
      "value",
      "width",
      "wrap",
      "xmlns",
      "slot",
    ]),
    Ux = gs([
      "accent-height",
      "accumulate",
      "additive",
      "alignment-baseline",
      "amplitude",
      "ascent",
      "attributename",
      "attributetype",
      "azimuth",
      "basefrequency",
      "baseline-shift",
      "begin",
      "bias",
      "by",
      "class",
      "clip",
      "clippathunits",
      "clip-path",
      "clip-rule",
      "color",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "cx",
      "cy",
      "d",
      "dx",
      "dy",
      "diffuseconstant",
      "direction",
      "display",
      "divisor",
      "dur",
      "edgemode",
      "elevation",
      "end",
      "exponent",
      "fill",
      "fill-opacity",
      "fill-rule",
      "filter",
      "filterunits",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "fx",
      "fy",
      "g1",
      "g2",
      "glyph-name",
      "glyphref",
      "gradientunits",
      "gradienttransform",
      "height",
      "href",
      "id",
      "image-rendering",
      "in",
      "in2",
      "intercept",
      "k",
      "k1",
      "k2",
      "k3",
      "k4",
      "kerning",
      "keypoints",
      "keysplines",
      "keytimes",
      "lang",
      "lengthadjust",
      "letter-spacing",
      "kernelmatrix",
      "kernelunitlength",
      "lighting-color",
      "local",
      "marker-end",
      "marker-mid",
      "marker-start",
      "markerheight",
      "markerunits",
      "markerwidth",
      "maskcontentunits",
      "maskunits",
      "max",
      "mask",
      "mask-type",
      "media",
      "method",
      "mode",
      "min",
      "name",
      "numoctaves",
      "offset",
      "operator",
      "opacity",
      "order",
      "orient",
      "orientation",
      "origin",
      "overflow",
      "paint-order",
      "path",
      "pathlength",
      "patterncontentunits",
      "patterntransform",
      "patternunits",
      "points",
      "preservealpha",
      "preserveaspectratio",
      "primitiveunits",
      "r",
      "rx",
      "ry",
      "radius",
      "refx",
      "refy",
      "repeatcount",
      "repeatdur",
      "restart",
      "result",
      "rotate",
      "scale",
      "seed",
      "shape-rendering",
      "slope",
      "specularconstant",
      "specularexponent",
      "spreadmethod",
      "startoffset",
      "stddeviation",
      "stitchtiles",
      "stop-color",
      "stop-opacity",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke",
      "stroke-width",
      "style",
      "surfacescale",
      "systemlanguage",
      "tabindex",
      "tablevalues",
      "targetx",
      "targety",
      "transform",
      "transform-origin",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "textlength",
      "type",
      "u1",
      "u2",
      "unicode",
      "values",
      "viewbox",
      "visibility",
      "version",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "width",
      "word-spacing",
      "wrap",
      "writing-mode",
      "xchannelselector",
      "ychannelselector",
      "x",
      "x1",
      "x2",
      "xmlns",
      "y",
      "y1",
      "y2",
      "z",
      "zoomandpan",
    ]),
    AT = gs([
      "accent",
      "accentunder",
      "align",
      "bevelled",
      "close",
      "columnsalign",
      "columnlines",
      "columnspan",
      "denomalign",
      "depth",
      "dir",
      "display",
      "displaystyle",
      "encoding",
      "fence",
      "frame",
      "height",
      "href",
      "id",
      "largeop",
      "length",
      "linethickness",
      "lspace",
      "lquote",
      "mathbackground",
      "mathcolor",
      "mathsize",
      "mathvariant",
      "maxsize",
      "minsize",
      "movablelimits",
      "notation",
      "numalign",
      "open",
      "rowalign",
      "rowlines",
      "rowspacing",
      "rowspan",
      "rspace",
      "rquote",
      "scriptlevel",
      "scriptminsize",
      "scriptsizemultiplier",
      "selection",
      "separator",
      "separators",
      "stretchy",
      "subscriptshift",
      "supscriptshift",
      "symmetric",
      "voffset",
      "width",
      "xmlns",
    ]),
    j0 = gs([
      "xlink:href",
      "xml:id",
      "xlink:title",
      "xml:space",
      "xmlns:xlink",
    ]),
    QD = Pr(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
    ZD = Pr(/<%[\w\W]*|[\w\W]*%>/gm),
    KD = Pr(/\$\{[\w\W]*/gm),
    JD = Pr(/^data-[\-\w.\u00B7-\uFFFF]+$/),
    e5 = Pr(/^aria-[\-\w]+$/),
    TC = Pr(
      /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    ),
    t5 = Pr(/^(?:\w+script|data):/i),
    n5 = Pr(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
    EC = Pr(/^html$/i),
    i5 = Pr(/^[a-z][.\w]*(-[.\w]+)+$/i);
  var RT = Object.freeze({
    __proto__: null,
    ARIA_ATTR: e5,
    ATTR_WHITESPACE: n5,
    CUSTOM_ELEMENT: i5,
    DATA_ATTR: JD,
    DOCTYPE_NAME: EC,
    ERB_EXPR: ZD,
    IS_ALLOWED_URI: TC,
    IS_SCRIPT_OR_DATA: t5,
    MUSTACHE_EXPR: QD,
    TMPLIT_EXPR: KD,
  });
  const cg = {
      element: 1,
      text: 3,
      progressingInstruction: 7,
      comment: 8,
      document: 9,
    },
    s5 = function () {
      return typeof window > "u" ? null : window;
    },
    r5 = function (e, n) {
      if (typeof e != "object" || typeof e.createPolicy != "function")
        return null;
      let i = null;
      const a = "data-tt-policy-suffix";
      n && n.hasAttribute(a) && (i = n.getAttribute(a));
      const l = "dompurify" + (i ? "#" + i : "");
      try {
        return e.createPolicy(l, {
          createHTML(u) {
            return u;
          },
          createScriptURL(u) {
            return u;
          },
        });
      } catch {
        return (
          console.warn("TrustedTypes policy " + l + " could not be created."),
          null
        );
      }
    },
    LT = function () {
      return {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: [],
      };
    };
  function CC() {
    let t =
      arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : s5();
    const e = (Fe) => CC(Fe);
    if (
      ((e.version = "3.3.1"),
      (e.removed = []),
      !t || !t.document || t.document.nodeType !== cg.document || !t.Element)
    )
      return ((e.isSupported = !1), e);
    let { document: n } = t;
    const i = n,
      a = i.currentScript,
      {
        DocumentFragment: l,
        HTMLTemplateElement: u,
        Node: d,
        Element: m,
        NodeFilter: g,
        NamedNodeMap: v = t.NamedNodeMap || t.MozNamedAttrMap,
        HTMLFormElement: y,
        DOMParser: w,
        trustedTypes: S,
      } = t,
      T = m.prototype,
      E = og(T, "cloneNode"),
      j = og(T, "remove"),
      O = og(T, "nextSibling"),
      M = og(T, "childNodes"),
      N = og(T, "parentNode");
    if (typeof u == "function") {
      const Fe = n.createElement("template");
      Fe.content && Fe.content.ownerDocument && (n = Fe.content.ownerDocument);
    }
    let R,
      P = "";
    const {
        implementation: G,
        createNodeIterator: Y,
        createDocumentFragment: B,
        getElementsByTagName: I,
      } = n,
      { importNode: H } = i;
    let X = LT();
    e.isSupported =
      typeof SC == "function" &&
      typeof N == "function" &&
      G &&
      G.createHTMLDocument !== void 0;
    const {
      MUSTACHE_EXPR: fe,
      ERB_EXPR: ve,
      TMPLIT_EXPR: be,
      DATA_ATTR: Oe,
      ARIA_ATTR: V,
      IS_SCRIPT_OR_DATA: pe,
      ATTR_WHITESPACE: de,
      CUSTOM_ELEMENT: he,
    } = RT;
    let { IS_ALLOWED_URI: Te } = RT,
      F = null;
    const ae = bt({}, [...jT, ...zx, ...Px, ...Ix, ...MT]);
    let xe = null;
    const Me = bt({}, [...NT, ...Ux, ...AT, ...j0]);
    let le = Object.seal(
        G_(null, {
          tagNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null,
          },
          attributeNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null,
          },
          allowCustomizedBuiltInElements: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: !1,
          },
        }),
      ),
      Re = null,
      Je = null;
    const ut = Object.seal(
      G_(null, {
        tagCheck: {
          writable: !0,
          configurable: !1,
          enumerable: !0,
          value: null,
        },
        attributeCheck: {
          writable: !0,
          configurable: !1,
          enumerable: !0,
          value: null,
        },
      }),
    );
    let ot = !0,
      di = !0,
      ri = !1,
      Bi = !0,
      Cn = !1,
      Gt = !0,
      An = !1,
      bl = !1,
      Hi = !1,
      vr = !1,
      Ca = !1,
      xs = !1,
      ai = !0,
      Oa = !1;
    const wo = "user-content-";
    let Xn = !0,
      Gs = !1,
      Br = {},
      Qn = null;
    const Yi = bt({}, [
      "annotation-xml",
      "audio",
      "colgroup",
      "desc",
      "foreignobject",
      "head",
      "iframe",
      "math",
      "mi",
      "mn",
      "mo",
      "ms",
      "mtext",
      "noembed",
      "noframes",
      "noscript",
      "plaintext",
      "script",
      "style",
      "svg",
      "template",
      "thead",
      "title",
      "video",
      "xmp",
    ]);
    let So = null;
    const xl = bt({}, ["audio", "video", "img", "source", "image", "track"]);
    let _l = null;
    const To = bt({}, [
        "alt",
        "class",
        "for",
        "id",
        "label",
        "name",
        "pattern",
        "placeholder",
        "role",
        "summary",
        "title",
        "value",
        "style",
        "xmlns",
      ]),
      _s = "http://www.w3.org/1998/Math/MathML",
      Rn = "http://www.w3.org/2000/svg",
      Ln = "http://www.w3.org/1999/xhtml";
    let bn = Ln,
      wl = !1,
      Hc = null;
    const lp = bt({}, [_s, Rn, Ln], Dx);
    let Hr = bt({}, ["mi", "mo", "mn", "ms", "mtext"]),
      yr = bt({}, ["annotation-xml"]);
    const Sl = bt({}, ["title", "style", "font", "a", "script"]);
    let qi = null;
    const Eo = ["application/xhtml+xml", "text/html"],
      Tl = "text/html";
    let On = null,
      br = null;
    const Yc = n.createElement("form"),
      ja = function (Z) {
        return Z instanceof RegExp || Z instanceof Function;
      },
      qc = function () {
        let Z =
          arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (!(br && br === Z)) {
          if (
            ((!Z || typeof Z != "object") && (Z = {}),
            (Z = ll(Z)),
            (qi =
              Eo.indexOf(Z.PARSER_MEDIA_TYPE) === -1
                ? Tl
                : Z.PARSER_MEDIA_TYPE),
            (On = qi === "application/xhtml+xml" ? Dx : Z0),
            (F = fa(Z, "ALLOWED_TAGS") ? bt({}, Z.ALLOWED_TAGS, On) : ae),
            (xe = fa(Z, "ALLOWED_ATTR") ? bt({}, Z.ALLOWED_ATTR, On) : Me),
            (Hc = fa(Z, "ALLOWED_NAMESPACES")
              ? bt({}, Z.ALLOWED_NAMESPACES, Dx)
              : lp),
            (_l = fa(Z, "ADD_URI_SAFE_ATTR")
              ? bt(ll(To), Z.ADD_URI_SAFE_ATTR, On)
              : To),
            (So = fa(Z, "ADD_DATA_URI_TAGS")
              ? bt(ll(xl), Z.ADD_DATA_URI_TAGS, On)
              : xl),
            (Qn = fa(Z, "FORBID_CONTENTS")
              ? bt({}, Z.FORBID_CONTENTS, On)
              : Yi),
            (Re = fa(Z, "FORBID_TAGS") ? bt({}, Z.FORBID_TAGS, On) : ll({})),
            (Je = fa(Z, "FORBID_ATTR") ? bt({}, Z.FORBID_ATTR, On) : ll({})),
            (Br = fa(Z, "USE_PROFILES") ? Z.USE_PROFILES : !1),
            (ot = Z.ALLOW_ARIA_ATTR !== !1),
            (di = Z.ALLOW_DATA_ATTR !== !1),
            (ri = Z.ALLOW_UNKNOWN_PROTOCOLS || !1),
            (Bi = Z.ALLOW_SELF_CLOSE_IN_ATTR !== !1),
            (Cn = Z.SAFE_FOR_TEMPLATES || !1),
            (Gt = Z.SAFE_FOR_XML !== !1),
            (An = Z.WHOLE_DOCUMENT || !1),
            (vr = Z.RETURN_DOM || !1),
            (Ca = Z.RETURN_DOM_FRAGMENT || !1),
            (xs = Z.RETURN_TRUSTED_TYPE || !1),
            (Hi = Z.FORCE_BODY || !1),
            (ai = Z.SANITIZE_DOM !== !1),
            (Oa = Z.SANITIZE_NAMED_PROPS || !1),
            (Xn = Z.KEEP_CONTENT !== !1),
            (Gs = Z.IN_PLACE || !1),
            (Te = Z.ALLOWED_URI_REGEXP || TC),
            (bn = Z.NAMESPACE || Ln),
            (Hr = Z.MATHML_TEXT_INTEGRATION_POINTS || Hr),
            (yr = Z.HTML_INTEGRATION_POINTS || yr),
            (le = Z.CUSTOM_ELEMENT_HANDLING || {}),
            Z.CUSTOM_ELEMENT_HANDLING &&
              ja(Z.CUSTOM_ELEMENT_HANDLING.tagNameCheck) &&
              (le.tagNameCheck = Z.CUSTOM_ELEMENT_HANDLING.tagNameCheck),
            Z.CUSTOM_ELEMENT_HANDLING &&
              ja(Z.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) &&
              (le.attributeNameCheck =
                Z.CUSTOM_ELEMENT_HANDLING.attributeNameCheck),
            Z.CUSTOM_ELEMENT_HANDLING &&
              typeof Z.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements ==
                "boolean" &&
              (le.allowCustomizedBuiltInElements =
                Z.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements),
            Cn && (di = !1),
            Ca && (vr = !0),
            Br &&
              ((F = bt({}, MT)),
              (xe = []),
              Br.html === !0 && (bt(F, jT), bt(xe, NT)),
              Br.svg === !0 && (bt(F, zx), bt(xe, Ux), bt(xe, j0)),
              Br.svgFilters === !0 && (bt(F, Px), bt(xe, Ux), bt(xe, j0)),
              Br.mathMl === !0 && (bt(F, Ix), bt(xe, AT), bt(xe, j0))),
            Z.ADD_TAGS &&
              (typeof Z.ADD_TAGS == "function"
                ? (ut.tagCheck = Z.ADD_TAGS)
                : (F === ae && (F = ll(F)), bt(F, Z.ADD_TAGS, On))),
            Z.ADD_ATTR &&
              (typeof Z.ADD_ATTR == "function"
                ? (ut.attributeCheck = Z.ADD_ATTR)
                : (xe === Me && (xe = ll(xe)), bt(xe, Z.ADD_ATTR, On))),
            Z.ADD_URI_SAFE_ATTR && bt(_l, Z.ADD_URI_SAFE_ATTR, On),
            Z.FORBID_CONTENTS &&
              (Qn === Yi && (Qn = ll(Qn)), bt(Qn, Z.FORBID_CONTENTS, On)),
            Z.ADD_FORBID_CONTENTS &&
              (Qn === Yi && (Qn = ll(Qn)), bt(Qn, Z.ADD_FORBID_CONTENTS, On)),
            Xn && (F["#text"] = !0),
            An && bt(F, ["html", "head", "body"]),
            F.table && (bt(F, ["tbody"]), delete Re.tbody),
            Z.TRUSTED_TYPES_POLICY)
          ) {
            if (typeof Z.TRUSTED_TYPES_POLICY.createHTML != "function")
              throw lg(
                'TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.',
              );
            if (typeof Z.TRUSTED_TYPES_POLICY.createScriptURL != "function")
              throw lg(
                'TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.',
              );
            ((R = Z.TRUSTED_TYPES_POLICY), (P = R.createHTML("")));
          } else
            (R === void 0 && (R = r5(S, a)),
              R !== null && typeof P == "string" && (P = R.createHTML("")));
          (gs && gs(Z), (br = Z));
        }
      },
      El = bt({}, [...zx, ...Px, ...WD]),
      $c = bt({}, [...Ix, ...XD]),
      Co = function (Z) {
        let Ce = N(Z);
        (!Ce || !Ce.tagName) &&
          (Ce = { namespaceURI: bn, tagName: "template" });
        const Le = Z0(Z.tagName),
          zt = Z0(Ce.tagName);
        return Hc[Z.namespaceURI]
          ? Z.namespaceURI === Rn
            ? Ce.namespaceURI === Ln
              ? Le === "svg"
              : Ce.namespaceURI === _s
                ? Le === "svg" && (zt === "annotation-xml" || Hr[zt])
                : !!El[Le]
            : Z.namespaceURI === _s
              ? Ce.namespaceURI === Ln
                ? Le === "math"
                : Ce.namespaceURI === Rn
                  ? Le === "math" && yr[zt]
                  : !!$c[Le]
              : Z.namespaceURI === Ln
                ? (Ce.namespaceURI === Rn && !yr[zt]) ||
                  (Ce.namespaceURI === _s && !Hr[zt])
                  ? !1
                  : !$c[Le] && (Sl[Le] || !El[Le])
                : !!(qi === "application/xhtml+xml" && Hc[Z.namespaceURI])
          : !1;
      },
      _i = function (Z) {
        rg(e.removed, { element: Z });
        try {
          N(Z).removeChild(Z);
        } catch {
          j(Z);
        }
      },
      Vs = function (Z, Ce) {
        try {
          rg(e.removed, { attribute: Ce.getAttributeNode(Z), from: Ce });
        } catch {
          rg(e.removed, { attribute: null, from: Ce });
        }
        if ((Ce.removeAttribute(Z), Z === "is"))
          if (vr || Ca)
            try {
              _i(Ce);
            } catch {}
          else
            try {
              Ce.setAttribute(Z, "");
            } catch {}
      },
      Gc = function (Z) {
        let Ce = null,
          Le = null;
        if (Hi) Z = "<remove></remove>" + Z;
        else {
          const ft = kx(Z, /^[\r\n\t ]+/);
          Le = ft && ft[0];
        }
        qi === "application/xhtml+xml" &&
          bn === Ln &&
          (Z =
            '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' +
            Z +
            "</body></html>");
        const zt = R ? R.createHTML(Z) : Z;
        if (bn === Ln)
          try {
            Ce = new w().parseFromString(zt, qi);
          } catch {}
        if (!Ce || !Ce.documentElement) {
          Ce = G.createDocument(bn, "template", null);
          try {
            Ce.documentElement.innerHTML = wl ? P : zt;
          } catch {}
        }
        const nn = Ce.body || Ce.documentElement;
        return (
          Z &&
            Le &&
            nn.insertBefore(n.createTextNode(Le), nn.childNodes[0] || null),
          bn === Ln
            ? I.call(Ce, An ? "html" : "body")[0]
            : An
              ? Ce.documentElement
              : nn
        );
      },
      Vc = function (Z) {
        return Y.call(
          Z.ownerDocument || Z,
          Z,
          g.SHOW_ELEMENT |
            g.SHOW_COMMENT |
            g.SHOW_TEXT |
            g.SHOW_PROCESSING_INSTRUCTION |
            g.SHOW_CDATA_SECTION,
          null,
        );
      },
      ws = function (Z) {
        return (
          Z instanceof y &&
          (typeof Z.nodeName != "string" ||
            typeof Z.textContent != "string" ||
            typeof Z.removeChild != "function" ||
            !(Z.attributes instanceof v) ||
            typeof Z.removeAttribute != "function" ||
            typeof Z.setAttribute != "function" ||
            typeof Z.namespaceURI != "string" ||
            typeof Z.insertBefore != "function" ||
            typeof Z.hasChildNodes != "function")
        );
      },
      Dn = function (Z) {
        return typeof d == "function" && Z instanceof d;
      };
    function on(Fe, Z, Ce) {
      O0(Fe, (Le) => {
        Le.call(e, Z, Ce, br);
      });
    }
    const Yr = function (Z) {
        let Ce = null;
        if ((on(X.beforeSanitizeElements, Z, null), ws(Z))) return (_i(Z), !0);
        const Le = On(Z.nodeName);
        if (
          (on(X.uponSanitizeElement, Z, { tagName: Le, allowedTags: F }),
          (Gt &&
            Z.hasChildNodes() &&
            !Dn(Z.firstElementChild) &&
            fs(/<[/\w!]/g, Z.innerHTML) &&
            fs(/<[/\w!]/g, Z.textContent)) ||
            Z.nodeType === cg.progressingInstruction ||
            (Gt && Z.nodeType === cg.comment && fs(/<[/\w]/g, Z.data)))
        )
          return (_i(Z), !0);
        if (
          !(ut.tagCheck instanceof Function && ut.tagCheck(Le)) &&
          (!F[Le] || Re[Le])
        ) {
          if (
            !Re[Le] &&
            Uf(Le) &&
            ((le.tagNameCheck instanceof RegExp && fs(le.tagNameCheck, Le)) ||
              (le.tagNameCheck instanceof Function && le.tagNameCheck(Le)))
          )
            return !1;
          if (Xn && !Qn[Le]) {
            const zt = N(Z) || Z.parentNode,
              nn = M(Z) || Z.childNodes;
            if (nn && zt) {
              const ft = nn.length;
              for (let Zn = ft - 1; Zn >= 0; --Zn) {
                const Ss = E(nn[Zn], !0);
                ((Ss.__removalCount = (Z.__removalCount || 0) + 1),
                  zt.insertBefore(Ss, O(Z)));
              }
            }
          }
          return (_i(Z), !0);
        }
        return (Z instanceof m && !Co(Z)) ||
          ((Le === "noscript" || Le === "noembed" || Le === "noframes") &&
            fs(/<\/no(script|embed|frames)/i, Z.innerHTML))
          ? (_i(Z), !0)
          : (Cn &&
              Z.nodeType === cg.text &&
              ((Ce = Z.textContent),
              O0([fe, ve, be], (zt) => {
                Ce = ag(Ce, zt, " ");
              }),
              Z.textContent !== Ce &&
                (rg(e.removed, { element: Z.cloneNode() }),
                (Z.textContent = Ce))),
            on(X.afterSanitizeElements, Z, null),
            !1);
      },
      Cl = function (Z, Ce, Le) {
        if (ai && (Ce === "id" || Ce === "name") && (Le in n || Le in Yc))
          return !1;
        if (!(di && !Je[Ce] && fs(Oe, Ce))) {
          if (!(ot && fs(V, Ce))) {
            if (
              !(
                ut.attributeCheck instanceof Function &&
                ut.attributeCheck(Ce, Z)
              )
            ) {
              if (!xe[Ce] || Je[Ce]) {
                if (
                  !(
                    (Uf(Z) &&
                      ((le.tagNameCheck instanceof RegExp &&
                        fs(le.tagNameCheck, Z)) ||
                        (le.tagNameCheck instanceof Function &&
                          le.tagNameCheck(Z))) &&
                      ((le.attributeNameCheck instanceof RegExp &&
                        fs(le.attributeNameCheck, Ce)) ||
                        (le.attributeNameCheck instanceof Function &&
                          le.attributeNameCheck(Ce, Z)))) ||
                    (Ce === "is" &&
                      le.allowCustomizedBuiltInElements &&
                      ((le.tagNameCheck instanceof RegExp &&
                        fs(le.tagNameCheck, Le)) ||
                        (le.tagNameCheck instanceof Function &&
                          le.tagNameCheck(Le))))
                  )
                )
                  return !1;
              } else if (!_l[Ce]) {
                if (!fs(Te, ag(Le, de, ""))) {
                  if (
                    !(
                      (Ce === "src" || Ce === "xlink:href" || Ce === "href") &&
                      Z !== "script" &&
                      qD(Le, "data:") === 0 &&
                      So[Z]
                    )
                  ) {
                    if (!(ri && !fs(pe, ag(Le, de, "")))) {
                      if (Le) return !1;
                    }
                  }
                }
              }
            }
          }
        }
        return !0;
      },
      Uf = function (Z) {
        return Z !== "annotation-xml" && kx(Z, he);
      },
      Ff = function (Z) {
        on(X.beforeSanitizeAttributes, Z, null);
        const { attributes: Ce } = Z;
        if (!Ce || ws(Z)) return;
        const Le = {
          attrName: "",
          attrValue: "",
          keepAttr: !0,
          allowedAttributes: xe,
          forceKeepAttr: void 0,
        };
        let zt = Ce.length;
        for (; zt--; ) {
          const nn = Ce[zt],
            { name: ft, namespaceURI: Zn, value: Ss } = nn,
            hi = On(ft),
            Ws = Ss;
          let kn = ft === "value" ? Ws : $D(Ws);
          if (
            ((Le.attrName = hi),
            (Le.attrValue = kn),
            (Le.keepAttr = !0),
            (Le.forceKeepAttr = void 0),
            on(X.uponSanitizeAttribute, Z, Le),
            (kn = Le.attrValue),
            Oa && (hi === "id" || hi === "name") && (Vs(ft, Z), (kn = wo + kn)),
            Gt && fs(/((--!?|])>)|<\/(style|title|textarea)/i, kn))
          ) {
            Vs(ft, Z);
            continue;
          }
          if (hi === "attributename" && kx(kn, "href")) {
            Vs(ft, Z);
            continue;
          }
          if (Le.forceKeepAttr) continue;
          if (!Le.keepAttr) {
            Vs(ft, Z);
            continue;
          }
          if (!Bi && fs(/\/>/i, kn)) {
            Vs(ft, Z);
            continue;
          }
          Cn &&
            O0([fe, ve, be], (Xc) => {
              kn = ag(kn, Xc, " ");
            });
          const Wc = On(Z.nodeName);
          if (!Cl(Wc, hi, kn)) {
            Vs(ft, Z);
            continue;
          }
          if (
            R &&
            typeof S == "object" &&
            typeof S.getAttributeType == "function" &&
            !Zn
          )
            switch (S.getAttributeType(Wc, hi)) {
              case "TrustedHTML": {
                kn = R.createHTML(kn);
                break;
              }
              case "TrustedScriptURL": {
                kn = R.createScriptURL(kn);
                break;
              }
            }
          if (kn !== Ws)
            try {
              (Zn ? Z.setAttributeNS(Zn, ft, kn) : Z.setAttribute(ft, kn),
                ws(Z) ? _i(Z) : OT(e.removed));
            } catch {
              Vs(ft, Z);
            }
        }
        on(X.afterSanitizeAttributes, Z, null);
      },
      Bf = function Fe(Z) {
        let Ce = null;
        const Le = Vc(Z);
        for (on(X.beforeSanitizeShadowDOM, Z, null); (Ce = Le.nextNode()); )
          (on(X.uponSanitizeShadowNode, Ce, null),
            Yr(Ce),
            Ff(Ce),
            Ce.content instanceof l && Fe(Ce.content));
        on(X.afterSanitizeShadowDOM, Z, null);
      };
    return (
      (e.sanitize = function (Fe) {
        let Z =
            arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
          Ce = null,
          Le = null,
          zt = null,
          nn = null;
        if (
          ((wl = !Fe), wl && (Fe = "<!-->"), typeof Fe != "string" && !Dn(Fe))
        )
          if (typeof Fe.toString == "function") {
            if (((Fe = Fe.toString()), typeof Fe != "string"))
              throw lg("dirty is not a string, aborting");
          } else throw lg("toString is not a function");
        if (!e.isSupported) return Fe;
        if (
          (bl || qc(Z),
          (e.removed = []),
          typeof Fe == "string" && (Gs = !1),
          Gs)
        ) {
          if (Fe.nodeName) {
            const Ss = On(Fe.nodeName);
            if (!F[Ss] || Re[Ss])
              throw lg(
                "root node is forbidden and cannot be sanitized in-place",
              );
          }
        } else if (Fe instanceof d)
          ((Ce = Gc("<!---->")),
            (Le = Ce.ownerDocument.importNode(Fe, !0)),
            (Le.nodeType === cg.element && Le.nodeName === "BODY") ||
            Le.nodeName === "HTML"
              ? (Ce = Le)
              : Ce.appendChild(Le));
        else {
          if (!vr && !Cn && !An && Fe.indexOf("<") === -1)
            return R && xs ? R.createHTML(Fe) : Fe;
          if (((Ce = Gc(Fe)), !Ce)) return vr ? null : xs ? P : "";
        }
        Ce && Hi && _i(Ce.firstChild);
        const ft = Vc(Gs ? Fe : Ce);
        for (; (zt = ft.nextNode()); )
          (Yr(zt), Ff(zt), zt.content instanceof l && Bf(zt.content));
        if (Gs) return Fe;
        if (vr) {
          if (Ca)
            for (nn = B.call(Ce.ownerDocument); Ce.firstChild; )
              nn.appendChild(Ce.firstChild);
          else nn = Ce;
          return (
            (xe.shadowroot || xe.shadowrootmode) && (nn = H.call(i, nn, !0)),
            nn
          );
        }
        let Zn = An ? Ce.outerHTML : Ce.innerHTML;
        return (
          An &&
            F["!doctype"] &&
            Ce.ownerDocument &&
            Ce.ownerDocument.doctype &&
            Ce.ownerDocument.doctype.name &&
            fs(EC, Ce.ownerDocument.doctype.name) &&
            (Zn =
              "<!DOCTYPE " +
              Ce.ownerDocument.doctype.name +
              `>
` +
              Zn),
          Cn &&
            O0([fe, ve, be], (Ss) => {
              Zn = ag(Zn, Ss, " ");
            }),
          R && xs ? R.createHTML(Zn) : Zn
        );
      }),
      (e.setConfig = function () {
        let Fe =
          arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (qc(Fe), (bl = !0));
      }),
      (e.clearConfig = function () {
        ((br = null), (bl = !1));
      }),
      (e.isValidAttribute = function (Fe, Z, Ce) {
        br || qc({});
        const Le = On(Fe),
          zt = On(Z);
        return Cl(Le, zt, Ce);
      }),
      (e.addHook = function (Fe, Z) {
        typeof Z == "function" && rg(X[Fe], Z);
      }),
      (e.removeHook = function (Fe, Z) {
        if (Z !== void 0) {
          const Ce = HD(X[Fe], Z);
          return Ce === -1 ? void 0 : YD(X[Fe], Ce, 1)[0];
        }
        return OT(X[Fe]);
      }),
      (e.removeHooks = function (Fe) {
        X[Fe] = [];
      }),
      (e.removeAllHooks = function () {
        X = LT();
      }),
      e
    );
  }
  var ip = CC();
  const a5 = ({ finded: t }) =>
      h.jsx("article", {
        className: "about-for-book",
        children: t
          ? h.jsx("div", {
              className: "description-testbankinner",
              dangerouslySetInnerHTML: {
                __html: ip.sanitize((t == null ? void 0 : t.description) || ""),
              },
            })
          : null,
      }),
    l5 = () => {
      var d;
      const t = `${window.location.origin}${window.location.pathname}`,
        { innerData: e, dataLoading: n } = Et(
          "share-links",
          "share_links_data_key",
        ),
        i =
          e &&
          e != null &&
          e.data &&
          ((d = e == null ? void 0 : e.data) == null ? void 0 : d.length) > 0
            ? e == null
              ? void 0
              : e.data
            : [],
        [a, l] = U.useState(void 0),
        u = async (m) => {
          try {
            (await navigator.clipboard.writeText(m),
              xt.success("Link kopyalandı", { position: "top-right" }),
              l(!0),
              setTimeout(() => l(void 0), 2e3));
          } catch (g) {
            (xt.error("Link kopyalanmada problem oldu", {
              position: "top-right",
            }),
              console.error("err:", g),
              l(!1));
          }
        };
      return n
        ? h.jsx(ze, {})
        : h.jsxs("section", {
            className: "share-area",
            children: [
              h.jsx("p", { children: "Paylaş:" }),
              h.jsxs("div", {
                className: "content-inner",
                children: [
                  h.jsx("div", {
                    className: "socials",
                    children:
                      i == null
                        ? void 0
                        : i.map((m) =>
                            h.jsx(
                              _t,
                              {
                                target: "_blank",
                                to: `${m == null ? void 0 : m.url}${t}` || "",
                                className: "share-item",
                                children: h.jsx("img", {
                                  src: m == null ? void 0 : m.icon,
                                  alt: m == null ? void 0 : m.title,
                                  title:
                                    (m == null ? void 0 : m.title) +
                                    "da paylaş",
                                }),
                              },
                              m == null ? void 0 : m.id,
                            ),
                          ),
                  }),
                  h.jsxs("div", {
                    className: `copy-url ${a === !0 ? "copy-success" : ""}`,
                    title: "Linki kopyala",
                    onClick: () =>
                      u(`${window.location.origin}${window.location.pathname}`),
                    children: [
                      h.jsx("img", {
                        src: "/link.svg",
                        className: "linkicon",
                        alt: "link icon",
                      }),
                      h.jsxs("p", {
                        children: [
                          window.location.origin,
                          window.location.pathname,
                        ],
                      }),
                      h.jsx("img", {
                        src: "/Copy.svg",
                        className: "copyicon",
                        alt: "copy",
                      }),
                    ],
                  }),
                ],
              }),
            ],
          });
    },
    o5 = () => {
      const { slug: t } = Ir(),
        { instance: e } = si(),
        n = sn(),
        i = nt((m) => m.selectedLanguage.selectedLanguage),
        [a, l] = U.useState(null),
        [u, d] = U.useState(!0);
      return (
        U.useEffect(() => {
          t &&
            (async () => {
              var g;
              try {
                d(!0);
                const v = await e.get(`textbooks/${t}`);
                v.data
                  ? l((g = v.data) == null ? void 0 : g.data)
                  : console.log(v.status);
              } catch (v) {
                console.log("Error:", v);
              } finally {
                d(!1);
              }
            })();
        }, [t]),
        U.useEffect(() => {
          if (a) {
            const m = a.slug[i];
            n(`/derslikler-ve-test-banklari/${i}/${m}`, { replace: !0 });
          }
        }, [i, a]),
        u
          ? h.jsx(ze, { style: { height: "100vh" } })
          : h.jsxs("main", {
              className: "test-banks-inner-wrapper",
              children: [
                h.jsx("title", { children: t ?? "Test bankları" }),
                h.jsxs("div", {
                  className: "test-banks-inner",
                  children: [
                    h.jsx(ID, { finded: a }),
                    h.jsx(a5, { finded: a }),
                    h.jsx(l5, {}),
                  ],
                }),
              ],
            })
      );
    },
    xi = ({ customStyle: t, title: e, mutation: n = !1 }) =>
      n
        ? h.jsx("h1", {
            className: "title-component-ui",
            style: t,
            children: e,
          })
        : h.jsx("h2", {
            className: "title-component-ui",
            style: t,
            children: e,
          });
  var ug = {},
    yg = { exports: {} },
    c5 = yg.exports,
    DT;
  function u5() {
    return (
      DT ||
        ((DT = 1),
        (function (t, e) {
          (function (n, i) {
            i(e);
          })(c5, function (n) {
            var i = function () {
                return (
                  (i =
                    Object.assign ||
                    function (l) {
                      for (var u, d = 1, m = arguments.length; d < m; d++)
                        for (var g in (u = arguments[d]))
                          Object.prototype.hasOwnProperty.call(u, g) &&
                            (l[g] = u[g]);
                      return l;
                    }),
                  i.apply(this, arguments)
                );
              },
              a = (function () {
                function l(u, d, m) {
                  var g = this;
                  ((this.endVal = d),
                    (this.options = m),
                    (this.version = "2.9.0"),
                    (this.defaults = {
                      startVal: 0,
                      decimalPlaces: 0,
                      duration: 2,
                      useEasing: !0,
                      useGrouping: !0,
                      useIndianSeparators: !1,
                      smartEasingThreshold: 999,
                      smartEasingAmount: 333,
                      separator: ",",
                      decimal: ".",
                      prefix: "",
                      suffix: "",
                      enableScrollSpy: !1,
                      scrollSpyDelay: 200,
                      scrollSpyOnce: !1,
                    }),
                    (this.finalEndVal = null),
                    (this.useEasing = !0),
                    (this.countDown = !1),
                    (this.error = ""),
                    (this.startVal = 0),
                    (this.paused = !0),
                    (this.once = !1),
                    (this.count = function (v) {
                      g.startTime || (g.startTime = v);
                      var y = v - g.startTime;
                      ((g.remaining = g.duration - y),
                        g.useEasing
                          ? g.countDown
                            ? (g.frameVal =
                                g.startVal -
                                g.easingFn(
                                  y,
                                  0,
                                  g.startVal - g.endVal,
                                  g.duration,
                                ))
                            : (g.frameVal = g.easingFn(
                                y,
                                g.startVal,
                                g.endVal - g.startVal,
                                g.duration,
                              ))
                          : (g.frameVal =
                              g.startVal +
                              (g.endVal - g.startVal) * (y / g.duration)));
                      var w = g.countDown
                        ? g.frameVal < g.endVal
                        : g.frameVal > g.endVal;
                      ((g.frameVal = w ? g.endVal : g.frameVal),
                        (g.frameVal = Number(
                          g.frameVal.toFixed(g.options.decimalPlaces),
                        )),
                        g.printValue(g.frameVal),
                        y < g.duration
                          ? (g.rAF = requestAnimationFrame(g.count))
                          : g.finalEndVal !== null
                            ? g.update(g.finalEndVal)
                            : g.options.onCompleteCallback &&
                              g.options.onCompleteCallback());
                    }),
                    (this.formatNumber = function (v) {
                      var y,
                        w,
                        S,
                        T,
                        E = v < 0 ? "-" : "";
                      y = Math.abs(v).toFixed(g.options.decimalPlaces);
                      var j = (y += "").split(".");
                      if (
                        ((w = j[0]),
                        (S = j.length > 1 ? g.options.decimal + j[1] : ""),
                        g.options.useGrouping)
                      ) {
                        T = "";
                        for (var O = 3, M = 0, N = 0, R = w.length; N < R; ++N)
                          (g.options.useIndianSeparators &&
                            N === 4 &&
                            ((O = 2), (M = 1)),
                            N !== 0 &&
                              M % O == 0 &&
                              (T = g.options.separator + T),
                            M++,
                            (T = w[R - N - 1] + T));
                        w = T;
                      }
                      return (
                        g.options.numerals &&
                          g.options.numerals.length &&
                          ((w = w.replace(/[0-9]/g, function (P) {
                            return g.options.numerals[+P];
                          })),
                          (S = S.replace(/[0-9]/g, function (P) {
                            return g.options.numerals[+P];
                          }))),
                        E + g.options.prefix + w + S + g.options.suffix
                      );
                    }),
                    (this.easeOutExpo = function (v, y, w, S) {
                      return (
                        (w * (1 - Math.pow(2, (-10 * v) / S)) * 1024) / 1023 + y
                      );
                    }),
                    (this.options = i(i({}, this.defaults), m)),
                    (this.formattingFn = this.options.formattingFn
                      ? this.options.formattingFn
                      : this.formatNumber),
                    (this.easingFn = this.options.easingFn
                      ? this.options.easingFn
                      : this.easeOutExpo),
                    (this.el =
                      typeof u == "string" ? document.getElementById(u) : u),
                    (d = d ?? this.parse(this.el.innerHTML)),
                    (this.startVal = this.validateValue(this.options.startVal)),
                    (this.frameVal = this.startVal),
                    (this.endVal = this.validateValue(d)),
                    (this.options.decimalPlaces = Math.max(
                      this.options.decimalPlaces,
                    )),
                    this.resetDuration(),
                    (this.options.separator = String(this.options.separator)),
                    (this.useEasing = this.options.useEasing),
                    this.options.separator === "" &&
                      (this.options.useGrouping = !1),
                    this.el
                      ? this.printValue(this.startVal)
                      : (this.error = "[CountUp] target is null or undefined"),
                    typeof window < "u" &&
                      this.options.enableScrollSpy &&
                      (this.error
                        ? console.error(this.error, u)
                        : ((window.onScrollFns = window.onScrollFns || []),
                          window.onScrollFns.push(function () {
                            return g.handleScroll(g);
                          }),
                          (window.onscroll = function () {
                            window.onScrollFns.forEach(function (v) {
                              return v();
                            });
                          }),
                          this.handleScroll(this))));
                }
                return (
                  (l.prototype.handleScroll = function (u) {
                    if (u && window && !u.once) {
                      var d = window.innerHeight + window.scrollY,
                        m = u.el.getBoundingClientRect(),
                        g = m.top + window.pageYOffset,
                        v = m.top + m.height + window.pageYOffset;
                      v < d && v > window.scrollY && u.paused
                        ? ((u.paused = !1),
                          setTimeout(function () {
                            return u.start();
                          }, u.options.scrollSpyDelay),
                          u.options.scrollSpyOnce && (u.once = !0))
                        : (window.scrollY > v || g > d) &&
                          !u.paused &&
                          u.reset();
                    }
                  }),
                  (l.prototype.determineDirectionAndSmartEasing = function () {
                    var u = this.finalEndVal ? this.finalEndVal : this.endVal;
                    this.countDown = this.startVal > u;
                    var d = u - this.startVal;
                    if (
                      Math.abs(d) > this.options.smartEasingThreshold &&
                      this.options.useEasing
                    ) {
                      this.finalEndVal = u;
                      var m = this.countDown ? 1 : -1;
                      ((this.endVal = u + m * this.options.smartEasingAmount),
                        (this.duration = this.duration / 2));
                    } else ((this.endVal = u), (this.finalEndVal = null));
                    this.finalEndVal !== null
                      ? (this.useEasing = !1)
                      : (this.useEasing = this.options.useEasing);
                  }),
                  (l.prototype.start = function (u) {
                    this.error ||
                      (this.options.onStartCallback &&
                        this.options.onStartCallback(),
                      u && (this.options.onCompleteCallback = u),
                      this.duration > 0
                        ? (this.determineDirectionAndSmartEasing(),
                          (this.paused = !1),
                          (this.rAF = requestAnimationFrame(this.count)))
                        : this.printValue(this.endVal));
                  }),
                  (l.prototype.pauseResume = function () {
                    (this.paused
                      ? ((this.startTime = null),
                        (this.duration = this.remaining),
                        (this.startVal = this.frameVal),
                        this.determineDirectionAndSmartEasing(),
                        (this.rAF = requestAnimationFrame(this.count)))
                      : cancelAnimationFrame(this.rAF),
                      (this.paused = !this.paused));
                  }),
                  (l.prototype.reset = function () {
                    (cancelAnimationFrame(this.rAF),
                      (this.paused = !0),
                      this.resetDuration(),
                      (this.startVal = this.validateValue(
                        this.options.startVal,
                      )),
                      (this.frameVal = this.startVal),
                      this.printValue(this.startVal));
                  }),
                  (l.prototype.update = function (u) {
                    (cancelAnimationFrame(this.rAF),
                      (this.startTime = null),
                      (this.endVal = this.validateValue(u)),
                      this.endVal !== this.frameVal &&
                        ((this.startVal = this.frameVal),
                        this.finalEndVal == null && this.resetDuration(),
                        (this.finalEndVal = null),
                        this.determineDirectionAndSmartEasing(),
                        (this.rAF = requestAnimationFrame(this.count))));
                  }),
                  (l.prototype.printValue = function (u) {
                    var d;
                    if (this.el) {
                      var m = this.formattingFn(u);
                      !((d = this.options.plugin) === null || d === void 0) &&
                      d.render
                        ? this.options.plugin.render(this.el, m)
                        : this.el.tagName === "INPUT"
                          ? (this.el.value = m)
                          : this.el.tagName === "text" ||
                              this.el.tagName === "tspan"
                            ? (this.el.textContent = m)
                            : (this.el.innerHTML = m);
                    }
                  }),
                  (l.prototype.ensureNumber = function (u) {
                    return typeof u == "number" && !isNaN(u);
                  }),
                  (l.prototype.validateValue = function (u) {
                    var d = Number(u);
                    return this.ensureNumber(d)
                      ? d
                      : ((this.error =
                          "[CountUp] invalid start or end value: ".concat(u)),
                        null);
                  }),
                  (l.prototype.resetDuration = function () {
                    ((this.startTime = null),
                      (this.duration = 1e3 * Number(this.options.duration)),
                      (this.remaining = this.duration));
                  }),
                  (l.prototype.parse = function (u) {
                    var d = function (y) {
                        return y.replace(/([.,'  ])/g, "\\$1");
                      },
                      m = d(this.options.separator),
                      g = d(this.options.decimal),
                      v = u
                        .replace(new RegExp(m, "g"), "")
                        .replace(new RegExp(g, "g"), ".");
                    return parseFloat(v);
                  }),
                  l
                );
              })();
            n.CountUp = a;
          });
        })(yg, yg.exports)),
      yg.exports
    );
  }
  var kT;
  function f5() {
    if (kT) return ug;
    ((kT = 1), Object.defineProperty(ug, "__esModule", { value: !0 }));
    var t = qg(),
      e = u5();
    function n(B, I) {
      var H =
        B == null
          ? null
          : (typeof Symbol < "u" && B[Symbol.iterator]) || B["@@iterator"];
      if (H != null) {
        var X,
          fe,
          ve,
          be,
          Oe = [],
          V = !0,
          pe = !1;
        try {
          if (((ve = (H = H.call(B)).next), I !== 0))
            for (
              ;
              !(V = (X = ve.call(H)).done) &&
              (Oe.push(X.value), Oe.length !== I);
              V = !0
            );
        } catch (de) {
          ((pe = !0), (fe = de));
        } finally {
          try {
            if (
              !V &&
              H.return != null &&
              ((be = H.return()), Object(be) !== be)
            )
              return;
          } finally {
            if (pe) throw fe;
          }
        }
        return Oe;
      }
    }
    function i(B, I) {
      var H = Object.keys(B);
      if (Object.getOwnPropertySymbols) {
        var X = Object.getOwnPropertySymbols(B);
        (I &&
          (X = X.filter(function (fe) {
            return Object.getOwnPropertyDescriptor(B, fe).enumerable;
          })),
          H.push.apply(H, X));
      }
      return H;
    }
    function a(B) {
      for (var I = 1; I < arguments.length; I++) {
        var H = arguments[I] != null ? arguments[I] : {};
        I % 2
          ? i(Object(H), !0).forEach(function (X) {
              d(B, X, H[X]);
            })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(B, Object.getOwnPropertyDescriptors(H))
            : i(Object(H)).forEach(function (X) {
                Object.defineProperty(
                  B,
                  X,
                  Object.getOwnPropertyDescriptor(H, X),
                );
              });
      }
      return B;
    }
    function l(B, I) {
      if (typeof B != "object" || !B) return B;
      var H = B[Symbol.toPrimitive];
      if (H !== void 0) {
        var X = H.call(B, I);
        if (typeof X != "object") return X;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (I === "string" ? String : Number)(B);
    }
    function u(B) {
      var I = l(B, "string");
      return typeof I == "symbol" ? I : String(I);
    }
    function d(B, I, H) {
      return (
        (I = u(I)),
        I in B
          ? Object.defineProperty(B, I, {
              value: H,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (B[I] = H),
        B
      );
    }
    function m() {
      return (
        (m = Object.assign
          ? Object.assign.bind()
          : function (B) {
              for (var I = 1; I < arguments.length; I++) {
                var H = arguments[I];
                for (var X in H)
                  Object.prototype.hasOwnProperty.call(H, X) && (B[X] = H[X]);
              }
              return B;
            }),
        m.apply(this, arguments)
      );
    }
    function g(B, I) {
      if (B == null) return {};
      var H = {},
        X = Object.keys(B),
        fe,
        ve;
      for (ve = 0; ve < X.length; ve++)
        ((fe = X[ve]), !(I.indexOf(fe) >= 0) && (H[fe] = B[fe]));
      return H;
    }
    function v(B, I) {
      if (B == null) return {};
      var H = g(B, I),
        X,
        fe;
      if (Object.getOwnPropertySymbols) {
        var ve = Object.getOwnPropertySymbols(B);
        for (fe = 0; fe < ve.length; fe++)
          ((X = ve[fe]),
            !(I.indexOf(X) >= 0) &&
              Object.prototype.propertyIsEnumerable.call(B, X) &&
              (H[X] = B[X]));
      }
      return H;
    }
    function y(B, I) {
      return w(B) || n(B, I) || S(B, I) || E();
    }
    function w(B) {
      if (Array.isArray(B)) return B;
    }
    function S(B, I) {
      if (B) {
        if (typeof B == "string") return T(B, I);
        var H = Object.prototype.toString.call(B).slice(8, -1);
        if (
          (H === "Object" && B.constructor && (H = B.constructor.name),
          H === "Map" || H === "Set")
        )
          return Array.from(B);
        if (
          H === "Arguments" ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(H)
        )
          return T(B, I);
      }
    }
    function T(B, I) {
      (I == null || I > B.length) && (I = B.length);
      for (var H = 0, X = new Array(I); H < I; H++) X[H] = B[H];
      return X;
    }
    function E() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var j =
      typeof window < "u" &&
      typeof window.document < "u" &&
      typeof window.document.createElement < "u"
        ? t.useLayoutEffect
        : t.useEffect;
    function O(B) {
      var I = t.useRef(B);
      return (
        j(function () {
          I.current = B;
        }),
        t.useCallback(function () {
          for (var H = arguments.length, X = new Array(H), fe = 0; fe < H; fe++)
            X[fe] = arguments[fe];
          return I.current.apply(void 0, X);
        }, [])
      );
    }
    var M = function (I, H) {
        var X = H.decimal,
          fe = H.decimals,
          ve = H.duration,
          be = H.easingFn,
          Oe = H.end,
          V = H.formattingFn,
          pe = H.numerals,
          de = H.prefix,
          he = H.separator,
          Te = H.start,
          F = H.suffix,
          ae = H.useEasing,
          xe = H.useGrouping,
          Me = H.useIndianSeparators,
          le = H.enableScrollSpy,
          Re = H.scrollSpyDelay,
          Je = H.scrollSpyOnce,
          ut = H.plugin;
        return new e.CountUp(I, Oe, {
          startVal: Te,
          duration: ve,
          decimal: X,
          decimalPlaces: fe,
          easingFn: be,
          formattingFn: V,
          numerals: pe,
          separator: he,
          prefix: de,
          suffix: F,
          plugin: ut,
          useEasing: ae,
          useIndianSeparators: Me,
          useGrouping: xe,
          enableScrollSpy: le,
          scrollSpyDelay: Re,
          scrollSpyOnce: Je,
        });
      },
      N = [
        "ref",
        "startOnMount",
        "enableReinitialize",
        "delay",
        "onEnd",
        "onStart",
        "onPauseResume",
        "onReset",
        "onUpdate",
      ],
      R = {
        decimal: ".",
        separator: ",",
        delay: null,
        prefix: "",
        suffix: "",
        duration: 2,
        start: 0,
        decimals: 0,
        startOnMount: !0,
        enableReinitialize: !0,
        useEasing: !0,
        useGrouping: !0,
        useIndianSeparators: !1,
      },
      P = function (I) {
        var H = Object.fromEntries(
            Object.entries(I).filter(function (Cn) {
              var Gt = y(Cn, 2),
                An = Gt[1];
              return An !== void 0;
            }),
          ),
          X = t.useMemo(
            function () {
              return a(a({}, R), H);
            },
            [I],
          ),
          fe = X.ref,
          ve = X.startOnMount,
          be = X.enableReinitialize,
          Oe = X.delay,
          V = X.onEnd,
          pe = X.onStart,
          de = X.onPauseResume,
          he = X.onReset,
          Te = X.onUpdate,
          F = v(X, N),
          ae = t.useRef(),
          xe = t.useRef(),
          Me = t.useRef(!1),
          le = O(function () {
            return M(typeof fe == "string" ? fe : fe.current, F);
          }),
          Re = O(function (Cn) {
            var Gt = ae.current;
            if (Gt && !Cn) return Gt;
            var An = le();
            return ((ae.current = An), An);
          }),
          Je = O(function () {
            var Cn = function () {
              return Re(!0).start(function () {
                V == null ||
                  V({ pauseResume: ut, reset: ot, start: ri, update: di });
              });
            };
            (Oe && Oe > 0 ? (xe.current = setTimeout(Cn, Oe * 1e3)) : Cn(),
              pe == null || pe({ pauseResume: ut, reset: ot, update: di }));
          }),
          ut = O(function () {
            (Re().pauseResume(),
              de == null || de({ reset: ot, start: ri, update: di }));
          }),
          ot = O(function () {
            Re().el &&
              (xe.current && clearTimeout(xe.current),
              Re().reset(),
              he == null || he({ pauseResume: ut, start: ri, update: di }));
          }),
          di = O(function (Cn) {
            (Re().update(Cn),
              Te == null || Te({ pauseResume: ut, reset: ot, start: ri }));
          }),
          ri = O(function () {
            (ot(), Je());
          }),
          Bi = O(function (Cn) {
            ve && (Cn && ot(), Je());
          });
        return (
          t.useEffect(
            function () {
              Me.current ? be && Bi(!0) : ((Me.current = !0), Bi());
            },
            [
              be,
              Me,
              Bi,
              Oe,
              I.start,
              I.suffix,
              I.prefix,
              I.duration,
              I.separator,
              I.decimals,
              I.decimal,
              I.formattingFn,
            ],
          ),
          t.useEffect(
            function () {
              return function () {
                ot();
              };
            },
            [ot],
          ),
          { start: ri, pauseResume: ut, reset: ot, update: di, getCountUp: Re }
        );
      },
      G = ["className", "redraw", "containerProps", "children", "style"],
      Y = function (I) {
        var H = I.className,
          X = I.redraw,
          fe = I.containerProps,
          ve = I.children,
          be = I.style,
          Oe = v(I, G),
          V = t.useRef(null),
          pe = t.useRef(!1),
          de = P(
            a(
              a({}, Oe),
              {},
              {
                ref: V,
                startOnMount: typeof ve != "function" || I.delay === 0,
                enableReinitialize: !1,
              },
            ),
          ),
          he = de.start,
          Te = de.reset,
          F = de.update,
          ae = de.pauseResume,
          xe = de.getCountUp,
          Me = O(function () {
            he();
          }),
          le = O(function (ut) {
            (I.preserveValue || Te(), F(ut));
          }),
          Re = O(function () {
            if (
              typeof I.children == "function" &&
              !(V.current instanceof Element)
            ) {
              console.error(
                `Couldn't find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.`,
              );
              return;
            }
            xe();
          });
        (t.useEffect(
          function () {
            Re();
          },
          [Re],
        ),
          t.useEffect(
            function () {
              pe.current && le(I.end);
            },
            [I.end, le],
          ));
        var Je = X && I;
        return (
          t.useEffect(
            function () {
              X && pe.current && Me();
            },
            [Me, X, Je],
          ),
          t.useEffect(
            function () {
              !X && pe.current && Me();
            },
            [
              Me,
              X,
              I.start,
              I.suffix,
              I.prefix,
              I.duration,
              I.separator,
              I.decimals,
              I.decimal,
              I.className,
              I.formattingFn,
            ],
          ),
          t.useEffect(function () {
            pe.current = !0;
          }, []),
          typeof ve == "function"
            ? ve({
                countUpRef: V,
                start: he,
                reset: Te,
                update: F,
                pauseResume: ae,
                getCountUp: xe,
              })
            : t.createElement(
                "span",
                m({ className: H, ref: V, style: be }, fe),
                typeof I.start < "u" ? xe().formattingFn(I.start) : "",
              )
        );
      };
    return ((ug.default = Y), (ug.useCountUp = P), ug);
  }
  var d5 = f5();
  const h5 = aw(d5),
    p5 = ({
      certificates_count: t,
      published_books_count: e,
      years_in_profession: n,
    }) => {
      const i = [
        { id: 1, count: e || 0, title: "Nəşr olunmuş kitab" },
        { id: 2, count: t || 0, title: "Sertifikat" },
        { id: 3, count: n || 0, title: "İl peşə fəaliyyəti" },
      ];
      return h.jsx("section", {
        className: "statistics-wrapper",
        children: h.jsx("div", {
          className: "statistics",
          children:
            i == null
              ? void 0
              : i.map((a) =>
                  h.jsxs(
                    "div",
                    {
                      className: "statistic-item",
                      children: [
                        h.jsx("h3", {
                          children: h.jsx(h5, {
                            end: a.count,
                            duration: 48,
                            suffix: "+",
                          }),
                        }),
                        h.jsx("p", { children: a == null ? void 0 : a.title }),
                      ],
                    },
                    a == null ? void 0 : a.id,
                  ),
                ),
        }),
      });
    },
    m5 = () => {
      const { t } = Ot();
      return h.jsxs("section", {
        className: "online-lessons-card",
        children: [
          h.jsxs("svg", {
            className: "gradient-two",
            width: "434",
            height: "207",
            viewBox: "0 0 434 207",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              h.jsx("path", {
                d: "M-135.271 603.668C-146.671 749.282 -271.03 788.194 -331.784 789.448L-353.659 799.421L-556.406 700.019C-332.231 367.153 118.017 -297.616 125.608 -293.774C133.199 -289.933 334.117 -158.777 433.628 -93.6788C410.916 -66.1563 344.945 -3.86307 262.76 25.1288C160.028 61.3686 192.246 260.142 66.3088 321.148C-59.628 382.153 -121.02 421.652 -135.271 603.668Z",
                fill: "url(#paint0_linear_491_1697)",
                "fill-opacity": "0.08",
                stroke: "url(#paint1_linear_491_1697)",
                "stroke-opacity": "0.2",
                "stroke-width": "0.5",
              }),
              h.jsxs("defs", {
                children: [
                  h.jsxs("linearGradient", {
                    id: "paint0_linear_491_1697",
                    x1: "173.802",
                    y1: "471.307",
                    x2: "-178.708",
                    y2: "219.791",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                      h.jsx("stop", { "stop-color": "white" }),
                      h.jsx("stop", {
                        offset: "0.593941",
                        "stop-color": "#809DFF",
                      }),
                      h.jsx("stop", { offset: "1", "stop-color": "#062151" }),
                    ],
                  }),
                  h.jsxs("linearGradient", {
                    id: "paint1_linear_491_1697",
                    x1: "-425.811",
                    y1: "793.199",
                    x2: "283.439",
                    y2: "-200.839",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                      h.jsx("stop", {
                        "stop-color": "white",
                        "stop-opacity": "0.72",
                      }),
                      h.jsx("stop", {
                        offset: "1",
                        "stop-color": "white",
                        "stop-opacity": "0.46",
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
          h.jsxs("svg", {
            className: "gradient",
            width: "813",
            height: "207",
            viewBox: "0 0 813 207",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              h.jsx("path", {
                d: "M805.568 1.20606C875.595 -126.971 1004.98 -111.549 1060.92 -87.8156L1084.96 -87.9567L1229.23 85.7511C888.41 297.635 205.43 719.748 200.078 713.135C194.725 706.522 65.1295 504.593 1.00048 404.456C32.9914 388.647 118.686 358.829 205.536 366.033C314.099 375.037 366.101 180.5 505.976 176.412C645.851 172.324 718.034 161.428 805.568 1.20606Z",
                fill: "url(#paint0_linear_491_1696)",
                fillOpacity: "0.08",
                stroke: "url(#paint1_linear_491_1696)",
                strokeOpacity: "0.2",
                strokeWidth: "0.5",
              }),
              h.jsxs("defs", {
                children: [
                  h.jsxs("linearGradient", {
                    id: "paint0_linear_491_1696",
                    x1: "469.396",
                    y1: "-4.59778",
                    x2: "688.006",
                    y2: "369.212",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                      h.jsx("stop", { stopColor: "white" }),
                      h.jsx("stop", {
                        offset: "0.593941",
                        stopColor: "#809DFF",
                      }),
                      h.jsx("stop", { offset: "1", stopColor: "#062151" }),
                    ],
                  }),
                  h.jsxs("linearGradient", {
                    id: "paint1_linear_491_1696",
                    x1: "1148.24",
                    y1: "-52.7357",
                    x2: "94.1409",
                    y2: "563.72",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                      h.jsx("stop", {
                        stopColor: "white",
                        stopOpacity: "0.72",
                      }),
                      h.jsx("stop", {
                        offset: "1",
                        stopColor: "white",
                        stopOpacity: "0.46",
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
          h.jsxs("div", {
            className: "left-title",
            children: [
              h.jsx("h5", { children: t("odenissiz_onlayn_derslere_qatil") }),
              h.jsx("p", {
                children: t("odenissiz_onlayn_derslere_qatil_text"),
              }),
            ],
          }),
          h.jsx(Ct, {
            icon: "/doubleright.svg",
            title: t("derslere_qatil"),
            href: "/imtahanlar",
            style: { border: "none", background: "#FFFFFF" },
            pStyle: { color: "#407DF2", fontSize: "20px" },
          }),
        ],
      });
    },
    g5 = () => {
      var l;
      const { t } = Ot(),
        { innerData: e, dataLoading: n } = Et("about", "about_data_key"),
        i = e && e != null && e.data ? (e == null ? void 0 : e.data) : null,
        a = () => {
          const u = document.createElement("a");
          ((u.href = (i == null ? void 0 : i.pdf) || ""),
            (u.target = "_blank"),
            (u.download = (i == null ? void 0 : i.pdf) || ""),
            document.body.appendChild(u),
            u.click(),
            document.body.removeChild(u));
        };
      return n
        ? h.jsx(ze, {})
        : h.jsxs("main", {
            className: "about-page-wrapper",
            children: [
              h.jsx("title", {
                children: (i == null ? void 0 : i.title) ?? "",
              }),
              h.jsx("meta", {
                name: "description",
                content: (i == null ? void 0 : i.seo_description) ?? "",
              }),
              h.jsx("meta", {
                property: "og:title",
                content: (i == null ? void 0 : i.title) ?? "",
              }),
              i
                ? h.jsxs("div", {
                    className: "about-page",
                    children: [
                      h.jsx(xi, {
                        title: i == null ? void 0 : i.title,
                        customStyle: { width: "100%", textAlign: "center" },
                      }),
                      h.jsxs("div", {
                        className: "container-hero",
                        children: [
                          h.jsxs("section", {
                            className: "left-section",
                            children: [
                              h.jsxs("div", {
                                className: "top-description",
                                children: [
                                  h.jsx("h1", {
                                    children: i == null ? void 0 : i.title,
                                  }),
                                  (i == null ? void 0 : i.description) &&
                                    h.jsx("div", {
                                      dangerouslySetInnerHTML: {
                                        __html: ip.sanitize(
                                          (i == null
                                            ? void 0
                                            : i.description) || "",
                                        ),
                                      },
                                    }),
                                ],
                              }),
                              h.jsxs("div", {
                                className: "download-cv",
                                children: [
                                  h.jsxs("div", {
                                    className: "left-content",
                                    children: [
                                      h.jsx("img", {
                                        src: "/pdficon.svg",
                                        alt: "pdficon",
                                      }),
                                      h.jsx("p", {
                                        children:
                                          ((l = i == null ? void 0 : i.pdf) ==
                                          null
                                            ? void 0
                                            : l.toString()) || "",
                                      }),
                                    ],
                                  }),
                                  h.jsx(Ct, {
                                    style: { flexDirection: "row-reverse" },
                                    title: t("yukle"),
                                    icon: "/doün.svg",
                                    isButton: !0,
                                    onClickFunc: a,
                                  }),
                                ],
                              }),
                            ],
                          }),
                          h.jsxs("section", {
                            className: "right-section",
                            children: [
                              h.jsx("div", {
                                className: "profile-wrapper",
                                children: h.jsx("img", {
                                  src:
                                    (i == null ? void 0 : i.image) || "/me.webp",
                                  alt: "",
                                }),
                              }),
                              h.jsxs("div", {
                                className: "name-surname",
                                children: [
                                  h.jsx("p", {
                                    children: i == null ? void 0 : i.name,
                                  }),
                                  (i == null ? void 0 : i.position) &&
                                    h.jsx("span", {
                                      children: i == null ? void 0 : i.position,
                                    }),
                                ],
                              }),
                            ],
                          }),
                        ],
                      }),
                      h.jsxs("div", {
                        className: "biography",
                        children: [
                          h.jsx("div", {
                            className: "title-content",
                            children: h.jsx("h2", {
                              children: i == null ? void 0 : i.biography_title,
                            }),
                          }),
                          (i == null ? void 0 : i.biography_content) &&
                            h.jsx("div", {
                              dangerouslySetInnerHTML: {
                                __html: ip.sanitize(
                                  (i == null ? void 0 : i.biography_content) ||
                                    "",
                                ),
                              },
                            }),
                        ],
                      }),
                      h.jsx(p5, {
                        certificates_count:
                          (i == null ? void 0 : i.certificates_count) || 0,
                        published_books_count:
                          (i == null ? void 0 : i.published_books_count) || 0,
                        years_in_profession:
                          (i == null ? void 0 : i.years_in_profession) || 0,
                      }),
                      h.jsx(m5, {}),
                    ],
                  })
                : null,
            ],
          });
    },
    OC = ({ title: t, customStyle: e }) =>
      h.jsxs("div", {
        className: "section-exam-count-information",
        children: [
          h.jsxs("div", {
            className: "profiles-for-info",
            children: [
              h.jsx("img", { src: "/user1.webp", alt: "" }),
              h.jsx("img", { src: "/user2.webp", alt: "" }),
              h.jsx("img", { src: "/user3.webp", alt: "" }),
            ],
          }),
          h.jsx("p", { style: e, className: "info", children: t }),
        ],
      }),
    v5 = ({ hasExamBanner: t }) =>
      t
        ? h.jsxs("section", {
            className: "hero-exams",
            children: [
              h.jsxs("div", {
                className: "left-hero-exams",
                children: [
                  h.jsx("div", {
                    className: "top-information",
                    children: h.jsxs("div", {
                      className: "users",
                      children: [
                        h.jsx(OC, {
                          title: `${t == null ? void 0 : t.subscriptionsCount} istifadəçi`,
                        }),
                        h.jsxs("div", {
                          className: "right",
                          children: [
                            h.jsx("div", {
                              className: "icon-profile",
                              children: h.jsx("img", {
                                src: "/category.svg",
                                alt: "",
                              }),
                            }),
                            h.jsxs("p", {
                              children: [
                                t == null ? void 0 : t.categoryCount,
                                " Kateqoriya",
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
                  }),
                  h.jsxs("div", {
                    className: "title-content",
                    children: [
                      h.jsx("h1", { children: t == null ? void 0 : t.title }),
                      (t == null ? void 0 : t.description) &&
                        h.jsx("div", {
                          dangerouslySetInnerHTML: {
                            __html:
                              ip.sanitize(t == null ? void 0 : t.description) ||
                              "",
                          },
                        }),
                    ],
                  }),
                ],
              }),
              h.jsx("div", {
                className: "right",
                children: h.jsx("img", {
                  src: (t == null ? void 0 : t.image) || "",
                  alt: "picture",
                }),
              }),
            ],
          })
        : h.jsx(ze, {}),
    y5 = ({ hasExamCategories: t }) => {
      const { t: e } = Ot(),
        n = nt((i) => i.selectedLanguage.selectedLanguage);
      return t
        ? h.jsxs("section", {
            className: "exams",
            children: [
              h.jsx("p", { children: e("kateqoriyalar") }),
              h.jsx("div", {
                className: "grid-exam-categories",
                children:
                  t == null
                    ? void 0
                    : t.map((i) =>
                        h.jsxs(
                          _t,
                          {
                            to: `/imtahanlar/${n}/${i.slug[n]}`,
                            className: "exam-category",
                            children: [
                              h.jsxs("div", {
                                className: "left-title",
                                children: [
                                  h.jsx("div", {
                                    className: "icon",
                                    children: h.jsx("img", {
                                      src: (i == null ? void 0 : i.image) || "",
                                      alt: i == null ? void 0 : i.title,
                                    }),
                                  }),
                                  h.jsx("p", {
                                    children: i == null ? void 0 : i.title,
                                  }),
                                ],
                              }),
                              h.jsx("div", {
                                className: "right-icon",
                                children: h.jsx(Ab, { className: "right" }),
                              }),
                            ],
                          },
                          i == null ? void 0 : i.id,
                        ),
                      ),
              }),
            ],
          })
        : h.jsx(ze, {});
    },
    b5 = ({ hasExamBanner: t }) => {
      var i;
      const { t: e, loading: n } = Ot();
      return !t || n
        ? h.jsx(ze, {})
        : h.jsxs("section", {
            className: "exam-bottom-section",
            children: [
              h.jsxs("div", {
                className: "left-title-content",
                children: [
                  h.jsx("h2", {
                    children: t == null ? void 0 : t.exam_online_title,
                  }),
                  h.jsxs("div", {
                    className: "buttons-content",
                    children: [
                      h.jsx(Ct, {
                        style: { backgroundColor: "#FFFFFF" },
                        pStyle: { color: "#407DF2" },
                        href: "/qeydiyyat",
                        title: e("qeydiyyat"),
                      }),
                      h.jsx(Ct, {
                        style: { border: "1px solid #FFFFFF" },
                        pStyle: { color: "#FFFFFF" },
                        href: "/daxil-ol",
                        title: e("daxil_ol"),
                      }),
                    ],
                  }),
                ],
              }),
              h.jsx("img", {
                src:
                  t != null &&
                  t.exam_online_image &&
                  ((i = t == null ? void 0 : t.exam_online_image) == null
                    ? void 0
                    : i.length) > 0
                    ? t == null
                      ? void 0
                      : t.exam_online_image
                    : "/low.webp",
                alt: "lowerpicture",
              }),
            ],
          });
    },
    Fc = (t) => {
      const e = nt((j) => j.selectedLanguage.selectedLanguage) || "az",
        n = localStorage.getItem("tkn_education") || "",
        { innerData: i, dataLoading: a } = Et("categories", ["categories_key"]),
        l = i != null && i.data && i.data.length > 0 ? i.data : [],
        { innerData: u, dataLoading: d } = Et("exam-banner", [
          "exam_banner_key",
        ]),
        m =
          u != null && u.data && Object.keys(u.data).length > 0 ? u.data : null,
        g = async (j) =>
          (
            await Xe.get(`${Ii}category/${j}/subcategories`, {
              headers: { "Accept-Language": e, Authorization: `Bearer ${n}` },
            })
          ).data,
        v =
          typeof t == "string" && t.trim() !== "" && t !== "abunelik-paketleri",
        { data: y, isLoading: w } = D2({
          queryKey: ["exam_sub_categories_key", t],
          queryFn: () => g(t),
          enabled: v,
        }),
        [S, T] = U.useState(null);
      return {
        hasExamCategories: l,
        ExamCategoriesLoading: a,
        ExamSubCategories: y,
        SubCatLoading: w,
        getAltCategories: async (j) => {
          var M, N;
          if (!j || j === "abunelik-paketleri") return null;
          const O = await Xe.get(`${Ii}subcategory/${j}`, {
            headers: { "Accept-Language": e, Authorization: `Bearer ${n}` },
          });
          return (
            T((M = O.data) == null ? void 0 : M.data),
            (N = O.data) == null ? void 0 : N.data
          );
        },
        altCategoryData: S,
        hasExamBanner: m,
        ExamBannerLoading: d,
      };
    },
    x5 = () => {
      const {
        ExamCategoriesLoading: t,
        hasExamBanner: e,
        ExamBannerLoading: n,
        hasExamCategories: i,
      } = Fc();
      return t || n
        ? h.jsx(ze, {})
        : h.jsxs("div", {
            className: "exams-page-wrapper",
            children: [
              h.jsx("title", {
                children: (e == null ? void 0 : e.title) ?? "",
              }),
              h.jsx("meta", {
                name: "description",
                content: (e == null ? void 0 : e.seo_description) ?? "",
              }),
              h.jsxs("div", {
                className: "exams-page",
                children: [
                  h.jsx(v5, { hasExamBanner: e }),
                  h.jsx(y5, { hasExamCategories: i }),
                  h.jsx(b5, { hasExamBanner: e }),
                ],
              }),
            ],
          });
    },
    wa = () => ({
      showError: () =>
        xt.error("500 Internal Server Error", { position: "top-right" }),
      showServerErrorMsg: (i) => {
        i &&
          xt.error(i == null ? void 0 : i.toString(), {
            position: "top-right",
          });
      },
      showServerSuccessMsg: (i) => {
        i &&
          xt.success(i == null ? void 0 : i.toString(), {
            position: "top-right",
          });
      },
    }),
    jC = U.createContext(void 0),
    _5 = ({ children: t }) => {
      const {
          showServerErrorMsg: e,
          showError: n,
          showServerSuccessMsg: i,
        } = wa(),
        [a, l] = U.useState(!0),
        [u, d] = U.useState(null),
        [m, g] = U.useState(!1);
      U.useEffect(() => {
        (() => {
          const j = localStorage.getItem("tkn_education"),
            O = localStorage.getItem("usr_education");
          if (j && O) {
            try {
              (g(!0), d(JSON.parse(O)));
            } catch {
              (localStorage.removeItem("tkn_education"),
                localStorage.removeItem("rft_education"),
                localStorage.removeItem("usr_education"));
            }
          }
          l(!1);
        })();
      }, []);
      U.useEffect(() => {
        const j = () => {
            if (document.getElementById("subscription-expired-modal")) return;
            const E = document.createElement("div");
            ((E.id = "subscription-expired-modal"),
              (E.style.cssText =
                "position:fixed;inset:0;z-index:99999;background:rgba(15,23,42,.55);display:flex;align-items:center;justify-content:center;padding:16px"));
            ((E.innerHTML = `<div style="width:min(440px,100%);background:#fff;border-radius:16px;box-shadow:0 24px 80px rgba(15,23,42,.28);padding:24px;font-family:inherit;color:#0f172a"><div style="display:flex;align-items:flex-start;justify-content:space-between;gap:16px"><div><h3 style="margin:0 0 8px;font-size:22px;font-weight:700">Abunəliyiniz bitib</h3><p style="margin:0;color:#475569;line-height:1.5">Son abunə olduğunuz paketin müddəti bitib. Davam etmək üçün yeni paket seçin.</p></div><button type="button" aria-label="Bağla" data-subscription-modal-close style="border:0;background:#f1f5f9;color:#0f172a;width:34px;height:34px;border-radius:999px;font-size:22px;line-height:1;cursor:pointer">×</button></div><div style="display:flex;gap:10px;justify-content:flex-end;margin-top:22px"><button type="button" data-subscription-modal-close style="border:1px solid #cbd5e1;background:#fff;color:#334155;border-radius:10px;padding:10px 14px;cursor:pointer">Bağla</button><button type="button" data-subscription-modal-packages style="border:0;background:#1d5fc4;color:#fff;border-radius:10px;padding:10px 16px;cursor:pointer;font-weight:600">Paketlərə keç</button></div></div>`),
              document.body.appendChild(E),
              E.querySelectorAll("[data-subscription-modal-close]").forEach(
                (M) =>
                  M.addEventListener("click", () => {
                    E.remove();
                  }),
              ),
              E.querySelector(
                "[data-subscription-modal-packages]",
              ).addEventListener("click", () => {
                window.location.href = "/imtahanlar/az/abunelik-paketleri";
              }));
          },
          O = (T) => {
            Array.isArray(T) &&
              T.length &&
              !T.find((E) => E.active === !0) &&
              j();
          },
          M = async () => {
            try {
              const T = localStorage.getItem("tkn_education");
              if (!T) return;
              const E = await Xe.get(`${Ii}user/subscriptions`, {
                headers: { Authorization: `Bearer ${T}` },
              });
              O(E.data && E.data.data);
            } catch (T) {}
          };
        M();
        const N = setInterval(M, 3e5);
        return () => clearInterval(N);
      }, []);
      const v = (E, j, O) => {
          (localStorage.setItem("tkn_education", j),
            localStorage.setItem("rft_education", O),
            localStorage.setItem("usr_education", JSON.stringify(E)),
            g(!0),
            d(E));
        },
        [y, w] = U.useState(!1),
        S = async () => {
          var E, j;
          w(!0);
          try {
            const O = await Xe.post(`${Ii}logout`, void 0, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("tkn_education")}`,
              },
            });
            O.data
              ? i(
                  ((E = O.data) == null ? void 0 : E.message) ||
                    "From account successfully logout",
                )
              : console.log(O.status);
          } catch (O) {
            if ((console.log(O), Xe.isAxiosError(O))) {
              const M =
                (j = O == null ? void 0 : O.response) == null ? void 0 : j.data;
              M.message ? e(M.message || "") : n();
            } else n();
          } finally {
            w(!1);
          }
        },
        T = async () => {
          (await S(),
            localStorage.removeItem("tkn_education"),
            localStorage.removeItem("rft_education"),
            localStorage.removeItem("usr_education"),
            g(!1),
            d(null));
        };
      return h.jsx(jC.Provider, {
        value: {
          isAuth: m,
          user: u,
          login: v,
          logout: T,
          loading: a,
          load: y,
          setUser: d,
        },
        children: t,
      });
    },
    Sa = () => {
      const t = U.useContext(jC);
      if (!t) throw new Error("useAuth must be used within an AuthProvider");
      return t;
    },
    iv = () => {
      const {
          showError: t,
          showServerErrorMsg: e,
          showServerSuccessMsg: n,
        } = wa(),
        { innerData: i, dataLoading: a } = Et(
          "user/subscriptions",
          "subs_key",
          !0,
        ),
        l = i == null ? void 0 : i.data,
        u = Array.isArray(l) ? l : [],
        d = !Array.isArray(l) && (l == null ? void 0 : l.is_premium) === !0,
        m = Array.isArray(u) ? u.find((w) => w.active === !0) : null,
        [g, v] = U.useState(null);
      U.useEffect(() => {
        const S = (T) => {
          Array.isArray(T) &&
            T.length &&
            !T.find((E) => E.active === !0) &&
            !sessionStorage.getItem("subscriptionExpiredPopupShown") &&
            (sessionStorage.setItem("subscriptionExpiredPopupShown", "1"),
            xt.warning(
              "Abuneliyiniz bitib. Davam etmek ucun yeniden abune olun.",
              { position: "top-right" },
            ));
        };
        S(u);
      }, [u, m]);
      return {
        hasSubscribtions: u,
        isPremium: d,
        activeSubscription: m,
        SubscribtionsDataLoading: a,
        handleSubscribtion: async (w, S) => {
          var T, E;
          v(S);
          try {
            const j = await Xe.post(`${Ii}azericard/create-payment`, w, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("tkn_education")}`,
              },
            });
            if (j.data && j.data.success) {
              n(j.data.message);
              if (j.data.data && j.data.data.free) return;
              const O = document.createElement("form");
              ((O.method = "POST"), (O.action = j.data.data.gateway_url));
              const M = j.data.data.payment_data;
              (Object.keys(M).forEach((N) => {
                const R = document.createElement("input");
                ((R.type = "hidden"),
                  (R.name = N),
                  (R.value = M[N]),
                  O.appendChild(R));
              }),
                document.body.appendChild(O),
                O.submit());
            }
          } catch (j) {
            Xe.isAxiosError(j)
              ? e(
                  ((E = (T = j.response) == null ? void 0 : T.data) == null
                    ? void 0
                    : E.message) || "Xəta baş verdi",
                )
              : t();
          } finally {
            v(null);
          }
        },
        loading: g,
      };
    },
    w5 = ({ finded: t }) => {
      var d, m;
      const e = sn(),
        { isAuth: n } = Sa(),
        i = nt((g) => g.selectedLanguage.selectedLanguage) || "",
        a =
          t &&
          ((d = t == null ? void 0 : t.subcategories) == null
            ? void 0
            : d.length) > 0
            ? t == null
              ? void 0
              : t.subcategories
            : void 0,
        { isPremium: l, activeSubscription: u } = iv();
      return h.jsxs("section", {
        className: `hero-inner-exam ${a !== void 0 && (a == null ? void 0 : a.length) > 0 ? "" : "non-subcategories"}`,
        children: [
          h.jsxs("svg", {
            className: "gradient",
            width: "493",
            height: "454",
            viewBox: "0 0 493 454",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              h.jsx("path", {
                d: "M10.8647 379.287C1.21951 502.479 -103.99 535.399 -155.389 536.46L-173.896 544.897L-345.423 460.801C-155.767 179.192 225.151 -383.215 231.572 -379.965C237.994 -376.715 407.975 -265.754 492.163 -210.681C472.948 -187.396 417.135 -134.695 347.605 -110.167C260.693 -79.5077 287.949 88.6582 181.404 140.27C74.8596 191.881 22.9212 225.298 10.8647 379.287Z",
                fill: "url(#paint0_linear_580_7561)",
                fillOpacity: "0.08",
                stroke: "url(#paint1_linear_580_7561)",
                strokeOpacity: "0.2",
                strokeWidth: "0.5",
              }),
              h.jsxs("defs", {
                children: [
                  h.jsxs("linearGradient", {
                    id: "paint0_linear_580_7561",
                    x1: "272.345",
                    y1: "267.307",
                    x2: "-25.8841",
                    y2: "54.52",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                      h.jsx("stop", { stopColor: "white" }),
                      h.jsx("stop", {
                        offset: "0.593941",
                        stopColor: "#809DFF",
                      }),
                      h.jsx("stop", { offset: "1", stopColor: "#062151" }),
                    ],
                  }),
                  h.jsxs("linearGradient", {
                    id: "paint1_linear_580_7561",
                    x1: "-234.937",
                    y1: "539.634",
                    x2: "365.1",
                    y2: "-301.34",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                      h.jsx("stop", {
                        stopColor: "white",
                        stopOpacity: "0.72",
                      }),
                      h.jsx("stop", {
                        offset: "1",
                        stopColor: "white",
                        stopOpacity: "0.46",
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
          h.jsxs("svg", {
            className: "gradient-two",
            width: "448",
            height: "454",
            viewBox: "0 0 448 454",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              h.jsx("path", {
                d: "M482.298 -31.994C491.943 -155.185 597.153 -188.106 648.552 -189.167L667.059 -197.604L838.586 -113.508C648.93 168.102 268.012 730.508 261.59 727.258C255.169 724.008 85.1878 613.048 1.00011 557.974C20.2152 534.689 76.0279 481.988 145.558 457.46C232.47 426.801 205.214 258.635 311.759 207.023C418.303 155.412 470.242 121.995 482.298 -31.994Z",
                fill: "url(#paint0_linear_580_7562)",
                fillOpacity: "0.08",
                stroke: "url(#paint1_linear_580_7562)",
                strokeOpacity: "0.2",
                strokeWidth: "0.5",
              }),
              h.jsxs("defs", {
                children: [
                  h.jsxs("linearGradient", {
                    id: "paint0_linear_580_7562",
                    x1: "220.817",
                    y1: "79.9857",
                    x2: "519.047",
                    y2: "292.773",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                      h.jsx("stop", { stopColor: "white" }),
                      h.jsx("stop", {
                        offset: "0.593941",
                        stopColor: "#809DFF",
                      }),
                      h.jsx("stop", { offset: "1", stopColor: "#062151" }),
                    ],
                  }),
                  h.jsxs("linearGradient", {
                    id: "paint1_linear_580_7562",
                    x1: "728.1",
                    y1: "-192.34",
                    x2: "128.063",
                    y2: "648.633",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                      h.jsx("stop", {
                        stopColor: "white",
                        stopOpacity: "0.72",
                      }),
                      h.jsx("stop", {
                        offset: "1",
                        stopColor: "white",
                        stopOpacity: "0.46",
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
          h.jsxs("div", {
            className: "left-title-content",
            children: [
              h.jsxs("div", {
                className: "top",
                children: [
                  h.jsx("h1", { children: t == null ? void 0 : t.title }),
                  (t == null ? void 0 : t.description) &&
                    h.jsx("div", {
                      dangerouslySetInnerHTML: {
                        __html: ip.sanitize(
                          (t == null ? void 0 : t.description) || "",
                        ),
                      },
                    }),
                ],
              }),
              h.jsx(S2, {}),
            ],
          }),
          (t == null ? void 0 : t.subcategories) &&
            (t == null ? void 0 : t.subcategories.length) > 0 &&
            h.jsxs("div", {
              className: "right-categories-content",
              children: [
                h.jsx("span", { children: "Alt kateqoriya" }),
                h.jsx("div", {
                  className: "categories",
                  children:
                    (m = t == null ? void 0 : t.subcategories) == null
                      ? void 0
                      : m.map((g) =>
                          h.jsxs(
                            "div",
                            {
                              className: "category-item",
                              onClick: () => {
                                if (!n) {
                                  e("/daxil-ol");
                                  return;
                                }
                                if (l) {
                                  e(
                                    `/imtahanlar/kateqoriyalar/${i}/${g.slug[i]}`,
                                  );
                                  return;
                                }
                                if (u) {
                                  e(
                                    `/imtahanlar/kateqoriyalar/${i}/${g.slug[i]}`,
                                  );
                                  return;
                                }
                                e(`/imtahanlar/${i}/abunelik-paketleri`);
                              },
                              children: [
                                h.jsx("p", {
                                  children: g == null ? void 0 : g.title,
                                }),
                                h.jsx("div", {
                                  className: "right-inner-icon-wrapper",
                                  children: h.jsx(Ab, {
                                    className: "right-inner-icon",
                                  }),
                                }),
                              ],
                            },
                            g == null ? void 0 : g.id,
                          ),
                        ),
                }),
              ],
            }),
        ],
      });
    },
    MC = () => ({
      getAvailableIcons: (e) =>
        [
          { has: e.hasTopic, icon: e.topicIcon, title: "Mövzu" },
          { has: e.hasVideo, icon: e.videoIcon, title: "Video" },
          { has: e.hasExam, icon: e.examIcon, title: "İmtahan" },
          {
            has: e.hasEssayExample,
            icon: e.essayExampleIcon,
            title: "Esse nümunəsi",
          },
          {
            has: e.hasInterviewPreparation,
            icon: e.interviewPreparationIcon,
            title: "Müsahibə hazırlığı",
          },
          {
            has: e.hasCriticalReading,
            icon: e.criticalReadingIcon,
            title: "Tənqidi oxu",
          },
        ]
          .filter((i) => !!i.has && !!i.icon)
          .map((i) => ({ icon: i.icon, title: i.title })),
    }),
    S5 = ({ finded: t }) => {
      var v;
      const { t: e } = Ot(),
        { isAuth: n } = Sa(),
        { getAvailableIcons: i } = MC(),
        a = sn(),
        {
          SubscribtionsDataLoading: l,
          isPremium: u,
          activeSubscription: d,
        } = iv(),
        m = nt((y) => y.selectedLanguage.selectedLanguage),
        { hasExamBanner: g } = Fc();
      return l
        ? h.jsx(ze, {})
        : h.jsx("section", {
            className: "exam-categories",
            children:
              (v = t == null ? void 0 : t.subcategories) == null
                ? void 0
                : v.map((y) => {
                    const w = i(y);
                    return h.jsxs(
                      "div",
                      {
                        className: "category",
                        children: [
                          h.jsx("h2", {
                            className: "category-main-title",
                            children: y.title,
                          }),
                          h.jsxs("div", {
                            className: "category-inner-content-subject",
                            children: [
                              w.map((S, T) =>
                                h.jsxs(
                                  "div",
                                  {
                                    className: "item-subject",
                                    children: [
                                      h.jsx("div", {
                                        className: "icon-subject",
                                        children: h.jsx("img", {
                                          src: S.icon,
                                          alt: S.title,
                                        }),
                                      }),
                                      h.jsx("p", { children: S.title }),
                                    ],
                                  },
                                  T,
                                ),
                              ),
                              h.jsx(OC, {
                                customStyle: { color: "#000000CC" },
                                title: `${g == null ? void 0 : g.subscriptionsCount} + abunə`,
                              }),
                            ],
                          }),
                          h.jsxs("div", {
                            className: "mini-description",
                            children: [
                              h.jsx("span", {
                                className: "mini-title",
                                children: "Qısa məlumat",
                              }),
                              y.description &&
                                h.jsx("div", {
                                  className: "description-content",
                                  dangerouslySetInnerHTML: {
                                    __html: ip.sanitize(y.description || ""),
                                  },
                                }),
                            ],
                          }),
                          h.jsx("div", {
                            className: "button-container",
                            children: h.jsx(Ct, {
                              isButton: !0,
                              onClickFunc: () => {
                                if (!n) {
                                  a("/daxil-ol");
                                  return;
                                }
                                if (u) {
                                  a(
                                    `/imtahanlar/kateqoriyalar/${m}/${y.slug[m]}`,
                                  );
                                  return;
                                }
                                if (d) {
                                  a(
                                    `/imtahanlar/kateqoriyalar/${m}/${y.slug[m]}`,
                                  );
                                  return;
                                }
                                a(`/imtahanlar/${m}/abunelik-paketleri`);
                              },
                              style: {
                                border: "2px solid #407DF23D",
                                backgroundColor: u || d ? "transparent" : "",
                              },
                              pStyle: { color: u || d ? "#407DF2" : "#FFFFFF" },
                              title: e(u || d ? "etrafli_bax" : "abune_ol"),
                              icon:
                                u || d ? "/blueright.svg" : "/whiteright.svg",
                            }),
                          }),
                        ],
                      },
                      y.id,
                    );
                  }),
          });
    },
    T5 = () => {
      var g;
      const t = ww(),
        { lang: e, slug: n } = Ir(),
        { SubCatLoading: i, ExamSubCategories: a } = Fc(n),
        l =
          a &&
          a != null &&
          a.data &&
          (g = a == null ? void 0 : a.data) != null &&
          g.subcategories
            ? a.data
            : null,
        u = sn(),
        d = nt((v) => v.selectedLanguage.selectedLanguage),
        m = (l == null ? void 0 : l.slug[e]) === n ? l : null;
      return (
        U.useEffect(() => {
          m && u(`/imtahanlar/${d}/${m.slug[d]}`, { replace: !0 });
        }, [d, u, m, n]),
        U.useEffect(() => {
          t.invalidateQueries({ queryKey: ["exam_sub_categories_key"] });
        }, []),
        i
          ? h.jsx(ze, {})
          : m
            ? h.jsxs("main", {
                className: "exams-inner-page-wrapper",
                children: [
                  h.jsx("title", {
                    children: (m == null ? void 0 : m.title) ?? "",
                  }),
                  h.jsx("meta", {
                    name: "description",
                    content: (m == null ? void 0 : m.seo_description) ?? "",
                  }),
                  h.jsxs("div", {
                    className: "exams-inner-page",
                    children: [
                      h.jsx(w5, { finded: m }),
                      h.jsx(S5, { finded: m }),
                    ],
                  }),
                ],
              })
            : h.jsx(h.Fragment, {})
      );
    },
    E5 = ({ finded: t }) => {
      const { hasSubscribtions: e, isPremium: n } = iv(),
        i = Array.isArray(e) ? e : [],
        a = W.useMemo(
          () =>
            n
              ? "Limitsiz"
              : i.length
                ? Math.max(...i.map((d) => d.duration_months || 0))
                : 0,
          [i, n],
        ),
        { getAvailableIcons: l } = MC(),
        u = l(t);
      return h.jsxs("section", {
        className: "hero-exam-category-inner-page",
        children: [
          (n || i.length > 0) &&
            h.jsxs("div", {
              className: "premium-flag",
              children: [
                h.jsx("img", { src: "/stars.svg", alt: "Premium" }),
                h.jsx("h6", {
                  children: n
                    ? "Limitsiz Premium Paket"
                    : `${a} aylıq premium paket`,
                }),
              ],
            }),
          (u == null ? void 0 : u.length) > 0 &&
            h.jsx("div", {
              className: "inners-category",
              children: u.map((d, m) =>
                h.jsxs(
                  "div",
                  {
                    className: "item-subject",
                    children: [
                      h.jsx("div", {
                        className: "icon-subject",
                        children: h.jsx("img", { src: d.icon, alt: d.title }),
                      }),
                      h.jsx("p", { children: d.title }),
                    ],
                  },
                  m,
                ),
              ),
            }),
          h.jsx("div", {
            className: "title-content-hero",
            children: h.jsx("h1", {
              className: "titlemain",
              children: t.title,
            }),
          }),
        ],
      });
    },
    C5 = (t) => {
      var a;
      const { innerData: e, dataLoading: n } = Et(
        `subcategory/${t}/topic`,
        ["topic_key", t],
        !0,
      );
      return {
        hasTopicData:
          e != null &&
          e.data &&
          ((a = Object.keys(e == null ? void 0 : e.data)) == null
            ? void 0
            : a.length) > 0
            ? e == null
              ? void 0
              : e.data
            : null,
        TopicLoading: n,
      };
    },
    O5 = ({ finded: t }) => {
      var w;
      const [e, n] = U.useState(!1),
        [i, a] = U.useState(null),
        l = nt((S) => S.selectedLanguage.selectedLanguage),
        { hasTopicData: u, TopicLoading: d } = C5(
          t == null ? void 0 : t.slug[l],
        ),
        m = (u == null ? void 0 : u.topic_items) || [],
        [g, v] = U.useState(null),
        y =
          ((w = m.find((S) => S.type === g)) == null ? void 0 : w.items) || [];
      return (
        U.useEffect(() => {
          var S;
          u &&
            u.topic_items &&
            ((S = u.topic_items) == null ? void 0 : S.length) > 0 &&
            g === null &&
            v(u.topic_items[0].type);
        }, [u, g]),
        !t || d
          ? h.jsx(ze, {})
          : h.jsxs(h.Fragment, {
              children: [
                e &&
                  h.jsx("div", {
                    className: "pdf-modal-overlay",
                    onClick: () => n(!1),
                    children: h.jsxs("div", {
                      className: "pdf-modal",
                      onClick: (S) => S.stopPropagation(),
                      children: [
                        h.jsx("button", {
                          className: "close-btn",
                          onClick: () => n(!1),
                          children: "✕",
                        }),
                        h.jsx("iframe", {
                          src: `https://docs.google.com/viewer?url=${encodeURIComponent(i)}&embedded=true`,
                          style: { border: "none" },
                        }),
                      ],
                    }),
                  }),
                h.jsxs("section", {
                  className: "topic",
                  children: [
                    u &&
                      h.jsxs("div", {
                        className: "top-title-main",
                        children: [
                          h.jsx("h2", {
                            className: "content-name",
                            children: "Mövzu",
                          }),
                          h.jsx("div", {
                            className: "right-category",
                            children: m.map((S) =>
                              h.jsx(
                                "p",
                                {
                                  className: `category-title ${g === S.type ? "active-category" : ""}`,
                                  onClick: () => v(S.type),
                                  style: {
                                    color: g === S.type ? "#062151" : "",
                                  },
                                  children: S.type_name,
                                },
                                S.type,
                              ),
                            ),
                          }),
                        ],
                      }),
                    h.jsxs("div", {
                      className: "container-for-content",
                      children: [
                        h.jsxs("div", {
                          className: "top-area",
                          children: [
                            h.jsxs("div", {
                              className: "top",
                              children: [
                                h.jsxs("div", {
                                  className: "icon-content",
                                  children: [
                                    h.jsx("img", {
                                      src: (u == null ? void 0 : u.icon) || "",
                                      alt: u == null ? void 0 : u.title,
                                    }),
                                    h.jsx("span", {
                                      children: u == null ? void 0 : u.title,
                                    }),
                                  ],
                                }),
                                h.jsx("h3", {
                                  children: u == null ? void 0 : u.subtitle,
                                }),
                              ],
                            }),
                            h.jsx("div", {
                              dangerouslySetInnerHTML: {
                                __html: ip.sanitize(
                                  (u == null ? void 0 : u.subcontent) || "",
                                ),
                              },
                            }),
                          ],
                        }),
                        y.map((S) => {
                          var T, E;
                          return h.jsx(
                            "div",
                            {
                              className: "container-for-content_inner",
                              children: h.jsxs("div", {
                                className: "container-for-content_inner_item",
                                children: [
                                  h.jsx("h5", {
                                    children: S == null ? void 0 : S.title,
                                  }),
                                  h.jsx("div", {
                                    className: "files",
                                    children:
                                      S != null &&
                                      S.files &&
                                      ((T = S == null ? void 0 : S.files) ==
                                      null
                                        ? void 0
                                        : T.length) > 0
                                        ? (E = S == null ? void 0 : S.files) ==
                                          null
                                          ? void 0
                                          : E.map((j) =>
                                              h.jsxs(
                                                "div",
                                                {
                                                  className: "file",
                                                  children: [
                                                    h.jsxs("article", {
                                                      className:
                                                        "left-descript",
                                                      children: [
                                                        h.jsx("div", {
                                                          className: "icon",
                                                          children: h.jsx(
                                                            "img",
                                                            {
                                                              src:
                                                                j.file_type ===
                                                                "pdf"
                                                                  ? "/pdfIcon2.svg"
                                                                  : "/fileicon.svg",
                                                              alt: "",
                                                            },
                                                          ),
                                                        }),
                                                        h.jsx("h4", {
                                                          children:
                                                            j == null
                                                              ? void 0
                                                              : j.title,
                                                        }),
                                                      ],
                                                    }),
                                                    j.file_type === "pdf"
                                                      ? h.jsxs("button", {
                                                          className:
                                                            "button-component-ui show-file",
                                                          onClick: () => {
                                                            (a(j.file_path),
                                                              n(!0));
                                                          },
                                                          children: [
                                                            h.jsx("p", {
                                                              children: "Bax",
                                                            }),
                                                            h.jsx("img", {
                                                              src: "/eye.svg",
                                                              alt: "",
                                                            }),
                                                          ],
                                                        })
                                                      : h.jsx(Ct, {
                                                          title: "Bax",
                                                          icon: "/eye.svg",
                                                          class_name:
                                                            "show-file",
                                                          target: "_blank",
                                                          href:
                                                            j == null
                                                              ? void 0
                                                              : j.file_path,
                                                        }),
                                                  ],
                                                },
                                                j == null ? void 0 : j.id,
                                              ),
                                            )
                                        : null,
                                  }),
                                ],
                              }),
                            },
                            S.id,
                          );
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            })
      );
    },
    j5 = (t) => {
      const {
        innerData: e,
        dataLoading: n,
        hasInvalidateQuery: i,
      } = Et(`subcategory/${t}/video`, ["video_lessons_key", t], !0);
      return {
        hasVideoLessons: e && (e == null ? void 0 : e.length) > 0 ? e : [],
        VideoLessonsLoading: n,
        InvalidateVideoLessons: i,
      };
    },
    M5 = { isVideo: null },
    NC = nv({
      name: "videoState",
      initialState: M5,
      reducers: {
        setVideo: (t, e) => {
          t.isVideo = e.payload;
        },
      },
    }),
    { setVideo: Qh } = NC.actions,
    N5 = NC.reducer;
  function A5(t) {
    return Fi({
      attr: { viewBox: "0 0 512 512" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm52.7 283.3L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3l52.7-52.7-52.7-52.7c-3.1-3.1-4.7-7.2-4.7-11.3 0-4.1 1.6-8.2 4.7-11.3 6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6-6.2 6.3-16.4 6.3-22.6 0z",
          },
          child: [],
        },
      ],
    })(t);
  }
  const AC = ({ videoUrl: t, videoType: e = "iframe" }) => {
      const n = _a(),
        i = U.useRef(null),
        a = (l) => {
          var u;
          i.current &&
            !((u = i.current) != null && u.contains(l.target)) &&
            n(Qh(null));
        };
      return (
        U.useEffect(
          () => (
            document.addEventListener("mousedown", a),
            () => document.removeEventListener("mousedown", a)
          ),
          [],
        ),
        h.jsxs("div", {
          className: "videomodal-overlay",
          children: [
            h.jsx(A5, { className: "close-icon", onClick: () => n(Qh(null)) }),
            h.jsx("div", {
              className: "videomodal",
              ref: i,
              children:
                t &&
                (e === "iframe"
                  ? h.jsx("iframe", {
                      width: "100%",
                      height: "100%",
                      src: t.replace("watch?v=", "embed/"),
                      title: "Video",
                      allow:
                        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                      allowFullScreen: !0,
                    })
                  : h.jsxs("video", {
                      controls: !0,
                      width: "100%",
                      height: "100%",
                      children: [
                        h.jsx("source", { src: t, type: "video/mp4" }),
                        "Your browser does not support the video tag.",
                      ],
                    })),
            }),
          ],
        })
      );
    },
    R5 = ({ finded: t }) => {
      var E;
      const e = nt((j) => j.selectedLanguage.selectedLanguage),
        {
          hasVideoLessons: n,
          VideoLessonsLoading: i,
          InvalidateVideoLessons: a,
        } = j5(t == null ? void 0 : t.slug[e]),
        [l, u] = U.useState(null),
        d = n == null ? void 0 : n.find((j) => l === j.type),
        m =
          d &&
          d != null &&
          d.items &&
          ((E = d == null ? void 0 : d.items) == null ? void 0 : E.length) > 0
            ? d == null
              ? void 0
              : d.items
            : [],
        [g, v] = U.useState(null),
        y =
          m == null ? void 0 : m.find((j) => g === (j == null ? void 0 : j.id)),
        w = U.useRef(null);
      (U.useEffect(() => {
        n && n.length > 0 && l === null && u(n[0].type);
      }, [n, l]),
        U.useEffect(() => {
          d != null && d.items && d.items.length > 0 && v(d.items[0].id);
        }, [d]),
        U.useEffect(() => {
          w.current &&
            g !== null &&
            w.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }, [g]));
      const S = _a(),
        T = nt((j) => j.videoState.isVideo);
      return (
        U.useEffect(() => {
          S(Qh(null));
        }, [l, g]),
        U.useEffect(() => {
          a("video_lessons_key");
        }, []),
        !t || i
          ? h.jsx(ze, {})
          : h.jsxs("section", {
              className: "videolessons",
              children: [
                T === (y == null ? void 0 : y.id) &&
                  h.jsx(AC, {
                    videoUrl: (y == null ? void 0 : y.video_url) || "",
                    videoType: (y == null ? void 0 : y.video_type) ?? "iframe",
                  }),
                h.jsxs("div", {
                  className: "top-title-main",
                  children: [
                    h.jsx("h2", {
                      className: "content-name",
                      children: "Video dərslər",
                    }),
                    h.jsx("div", {
                      className: "right-category",
                      children:
                        n == null
                          ? void 0
                          : n.map((j) =>
                              h.jsx(
                                "p",
                                {
                                  className: `category-title ${l === j.type ? "active-category" : ""}`,
                                  onClick: () => u(j.type),
                                  style: {
                                    color: l === j.type ? "#062151" : "",
                                  },
                                  children: j.type_name,
                                },
                                j.type,
                              ),
                            ),
                    }),
                  ],
                }),
                h.jsxs("div", {
                  className: "container-for-content_video",
                  children: [
                    h.jsxs("div", {
                      className: "left",
                      children: [
                        h.jsxs("h6", {
                          className: "cat-title",
                          children: [
                            (d == null ? void 0 : d.type_name) || "",
                            " üzrə",
                          ],
                        }),
                        h.jsx("div", {
                          className: "video-titles",
                          children:
                            m == null
                              ? void 0
                              : m.map((j) =>
                                  h.jsx(
                                    "span",
                                    {
                                      onClick: () =>
                                        v(j == null ? void 0 : j.id),
                                      className: `item-title ${g === j.id ? "selected" : ""}`,
                                      children: j == null ? void 0 : j.title,
                                    },
                                    j == null ? void 0 : j.id,
                                  ),
                                ),
                        }),
                      ],
                    }),
                    h.jsx("div", {
                      className: "right",
                      ref: w,
                      children:
                        y &&
                        h.jsxs("div", {
                          className: "top-video-area",
                          children: [
                            h.jsxs("div", {
                              className: "video-area",
                              children: [
                                h.jsx("img", {
                                  src: (y == null ? void 0 : y.thumbnail) || "",
                                  className: "thumbnail",
                                  alt: y.title,
                                }),
                                h.jsx("button", {
                                  type: "button",
                                  className: "play-video-btn",
                                  onClick: () =>
                                    S(Qh(y == null ? void 0 : y.id)),
                                  children: h.jsx("img", {
                                    className: "play-btn",
                                    role: "button",
                                    src: "/play_circle.svg",
                                    alt: "play-button",
                                  }),
                                }),
                                T === (y == null ? void 0 : y.id) &&
                                  h.jsx("div", {
                                    className: "video-wrapper",
                                    children:
                                      y.video_type === "iframe"
                                        ? h.jsx("iframe", {
                                            src: y.video_url,
                                            title: y.title,
                                            width: "100%",
                                            height: "100%",
                                            allowFullScreen: !0,
                                          })
                                        : h.jsxs("video", {
                                            controls: !0,
                                            width: "100%",
                                            height: "100%",
                                            children: [
                                              h.jsx("source", {
                                                src: y.video_url,
                                                type: "video/mp4",
                                              }),
                                              "Your browser does not support the video tag.",
                                            ],
                                          }),
                                  }),
                              ],
                            }),
                            h.jsxs("div", {
                              className: "description-section",
                              children: [
                                h.jsx("span", {
                                  className: "date",
                                  children: y == null ? void 0 : y.date,
                                }),
                                h.jsx("p", {
                                  className: "title",
                                  children: y == null ? void 0 : y.title,
                                }),
                              ],
                            }),
                            h.jsx("div", {
                              className: "descrp",
                              dangerouslySetInnerHTML: {
                                __html: ip.sanitize(
                                  (y == null ? void 0 : y.description) || "",
                                ),
                              },
                            }),
                          ],
                        }),
                    }),
                  ],
                }),
              ],
            })
      );
    },
    L5 = (t) => {
      var l;
      const {
        innerData: e,
        dataLoading: n,
        hasInvalidateQuery: i,
      } = Et(`subcategory/${t}/littleVideoRolics`, ["video_rolics_key", t], !0);
      return {
        hasVideoRolics:
          e != null &&
          e.data &&
          ((l = e == null ? void 0 : e.data) == null ? void 0 : l.length) > 0
            ? e == null
              ? void 0
              : e.data
            : [],
        VideoRolicsLoading: n,
        InvalidateVideoRolicData: i,
      };
    },
    D5 = ({ finded: t }) => {
      const e = _a(),
        n = nt((v) => v.selectedLanguage.selectedLanguage),
        i = nt((v) => v.videoState.isVideo),
        {
          VideoRolicsLoading: a,
          hasVideoRolics: l,
          InvalidateVideoRolicData: u,
        } = L5(t == null ? void 0 : t.slug[n]),
        [d, m] = U.useState(null),
        g =
          l == null ? void 0 : l.find((v) => (v == null ? void 0 : v.id) === d);
      if (
        (U.useEffect(() => {
          if (l && l.length > 0 && d === null) {
            const v = l[0].id;
            m(v);
          }
        }, [l, d]),
        U.useEffect(
          () => () => {
            e(Qh(null));
          },
          [e],
        ),
        U.useEffect(() => {
          u("video_rolics_key");
        }, []),
        !t || a)
      )
        return h.jsx(ze, {});
      if (l && l.length > 0)
        return h.jsxs("section", {
          className: "videolessons",
          children: [
            i === (g == null ? void 0 : g.id) &&
              h.jsx(AC, {
                videoUrl: (g == null ? void 0 : g.video_url) || "",
                videoType: (g == null ? void 0 : g.video_type) ?? "iframe",
              }),
            h.jsx("div", {
              className: "top-title-main",
              children: h.jsx("h2", {
                className: "content-name",
                children: "Qısa video roliklər",
              }),
            }),
            h.jsxs("div", {
              className: "container-for-content_video",
              children: [
                h.jsx("div", {
                  className: "left",
                  children: h.jsx("div", {
                    className: "video-titles",
                    children:
                      l == null
                        ? void 0
                        : l.map((v) =>
                            h.jsx(
                              "span",
                              {
                                onClick: () => m(v == null ? void 0 : v.id),
                                className: `item-title ${d === v.id ? "selected" : ""}`,
                                children: v == null ? void 0 : v.title,
                              },
                              v == null ? void 0 : v.id,
                            ),
                          ),
                  }),
                }),
                h.jsx("div", {
                  className: "right",
                  children:
                    g &&
                    h.jsxs("div", {
                      className: "top-video-area",
                      children: [
                        h.jsxs("div", {
                          className: "video-area",
                          children: [
                            h.jsx("img", {
                              src: (g == null ? void 0 : g.thumbnail) || "",
                              className: "thumbnail",
                              alt: g == null ? void 0 : g.title,
                            }),
                            h.jsx("button", {
                              type: "button",
                              className: "play-video-btn",
                              onClick: () => e(Qh(g == null ? void 0 : g.id)),
                              children: h.jsx("img", {
                                className: "play-btn",
                                role: "button",
                                src: "/play_circle.svg",
                                alt: "play-button",
                              }),
                            }),
                            i === (g == null ? void 0 : g.id) &&
                              h.jsx("div", {
                                className: "video-wrapper",
                                children:
                                  g.video_type === "iframe"
                                    ? h.jsx("iframe", {
                                        src: g.video_url,
                                        title: g.title,
                                        width: "100%",
                                        height: "100%",
                                        allowFullScreen: !0,
                                      })
                                    : h.jsxs("video", {
                                        controls: !0,
                                        width: "100%",
                                        height: "100%",
                                        children: [
                                          h.jsx("source", {
                                            src: g.video_url,
                                            type: "video/mp4",
                                          }),
                                          "Your browser does not support the video tag.",
                                        ],
                                      }),
                              }),
                          ],
                        }),
                        h.jsxs("div", {
                          className: "description-section",
                          children: [
                            h.jsx("span", {
                              className: "date",
                              children: g == null ? void 0 : g.date,
                            }),
                            h.jsx("p", {
                              className: "title",
                              children: g == null ? void 0 : g.title,
                            }),
                          ],
                        }),
                        h.jsx("div", {
                          className: "descrp",
                          dangerouslySetInnerHTML: {
                            __html: ip.sanitize(
                              (g == null ? void 0 : g.description) || "",
                            ),
                          },
                        }),
                      ],
                    }),
                }),
              ],
            }),
          ],
        });
    },
    Bc = (t, e) => {
      var R;
      const n = sn(),
        { instance: i } = si(),
        { showError: a, showServerSuccessMsg: l, showServerErrorMsg: u } = wa(),
        d = nt((P) => P.selectedLanguage.selectedLanguage),
        {
          innerData: m,
          dataLoading: g,
          hasInvalidateQuery: v,
        } = Et(`subcategory/${t}/tests`, ["tests_maincontent_key", t], !0),
        y = m && (m == null ? void 0 : m.length) > 0 ? m : [],
        {
          innerData: w,
          dataLoading: S,
          hasInvalidateQuery: T,
        } = Et(
          `subcategory/${t}/exams/${e}`,
          ["tests_inner_key", t, e ?? ""],
          !0,
        ),
        E =
          w && ((R = Object.keys(w)) == null ? void 0 : R.length) > 0
            ? w
            : null,
        [j, O] = U.useState("");
      return {
        hasTestsData: y,
        TestsLoading: g,
        InvalidateTests: v,
        InvalidateTestsInner: T,
        hasTestInner: E,
        TestInnerLoading: S,
        StartTest: async (P, G) => {
          var Y, B;
          O("start");
          try {
            const I = `subcategory/${P}/exams/${G}/start`,
              H = await i.post(I);
            H.data
              ? (l((Y = H.data) == null ? void 0 : Y.message),
                n(
                  `/imtahanlar/kateqoriyalar/${d}/${P}/teste-basla/${G}/suallar`,
                ))
              : console.log(H.status);
          } catch (I) {
            if (Xe.isAxiosError(I)) {
              const H =
                (B = I == null ? void 0 : I.response) == null ? void 0 : B.data;
              H.message ? u(H.message) : a();
            } else (a(), console.log(I));
          } finally {
            O("");
          }
        },
        EndTest: async (P, G, Y) => {
          var B, I;
          O("end");
          try {
            const H = `subcategory/${P}/exams/${G}`,
              X = await i.post(H, { questions: Y });
            X.data
              ? (l((B = X.data) == null ? void 0 : B.message),
                n(
                  `/imtahanlar/kateqoriyalar/${d}/${P}/teste-basla/${G}/suallar/neticeler`,
                ))
              : console.log(X.status);
          } catch (H) {
            if (Xe.isAxiosError(H)) {
              const X =
                (I = H == null ? void 0 : H.response) == null ? void 0 : I.data;
              X.message ? u(X.message) : a();
            } else (a(), console.log(H));
          } finally {
            O("");
          }
        },
        loadingTest: j,
      };
    },
    Lg = (t) => {
      const e = Math.floor(t / 3600),
        n = Math.floor((t % 3600) / 60),
        i = t % 60,
        a = [];
      return (
        e > 0 && a.push(`${e} saat`),
        n > 0 && a.push(`${n} dəqiqə`),
        (i > 0 || a.length === 0) && a.push(`${i} saniyə`),
        a.join(" ")
      );
    },
    k5 = ({ finded: t }) => {
      var w, S, T;
      const e = nt((E) => E.selectedLanguage.selectedLanguage),
        {
          TestsLoading: n,
          hasTestsData: i,
          InvalidateTests: a,
        } = Bc(t == null ? void 0 : t.slug[e]),
        [l, u] = U.useState(null);
      U.useEffect(() => {
        a("tests_maincontent_key");
      }, []);
      const d = U.useMemo(
          () => (i == null ? void 0 : i.find((E) => E.type === l)) || null,
          [i, l],
        ),
        m =
          d != null &&
          d.categories &&
          ((w = d == null ? void 0 : d.categories) == null
            ? void 0
            : w.length) > 0
            ? d == null
              ? void 0
              : d.categories
            : [],
        [g, v] = U.useState(null);
      U.useEffect(() => {
        var E, j;
        if (i && i.length > 0 && g === null && l === null) {
          const O = i[0];
          (u((O == null ? void 0 : O.type) || 0),
            v(
              ((j =
                (E = O == null ? void 0 : O.categories) == null
                  ? void 0
                  : E[0]) == null
                ? void 0
                : j.category_id) || 0,
            ));
        }
      }, [i]);
      const y = U.useMemo(
        () => (!d || !g ? null : d.categories.find((E) => E.category_id === g)),
        [d, g],
      );
      return !t || n
        ? h.jsx(ze, {})
        : h.jsxs("section", {
            className: "tests",
            children: [
              h.jsxs("div", {
                className: "top-title-main",
                children: [
                  h.jsx("h2", {
                    className: "content-name",
                    children: "Testlər",
                  }),
                  h.jsx("div", {
                    className: "right-category",
                    children:
                      i == null
                        ? void 0
                        : i.map((E) =>
                            h.jsx(
                              "p",
                              {
                                className: `category-title ${l === E.type ? "active-category" : ""}`,
                                onClick: () => u(E == null ? void 0 : E.type),
                                style: {
                                  color:
                                    l === (E == null ? void 0 : E.type)
                                      ? "#062151"
                                      : "",
                                },
                                children: E.type_name,
                              },
                              E.type,
                            ),
                          ),
                  }),
                ],
              }),
              h.jsxs("div", {
                className: "container-for-content_video",
                children: [
                  h.jsxs("div", {
                    className: "left",
                    children: [
                      h.jsxs("h6", {
                        className: "cat-title",
                        children: [
                          (d == null ? void 0 : d.type_name) || "",
                          " üzrə",
                        ],
                      }),
                      h.jsx("div", {
                        className: "video-titles",
                        children:
                          m == null
                            ? void 0
                            : m.map((E) =>
                                h.jsx(
                                  "span",
                                  {
                                    onClick: () =>
                                      v(E == null ? void 0 : E.category_id),
                                    className: `item-title ${g === (E == null ? void 0 : E.category_id) ? "selected" : ""}`,
                                    children:
                                      E == null ? void 0 : E.category_title,
                                  },
                                  E == null ? void 0 : E.category_id,
                                ),
                              ),
                      }),
                    ],
                  }),
                  h.jsx("div", {
                    className: "right-test-content",
                    children:
                      y &&
                      y != null &&
                      y.items &&
                      ((S = y == null ? void 0 : y.items) == null
                        ? void 0
                        : S.length) > 0
                        ? (T = y == null ? void 0 : y.items) == null
                          ? void 0
                          : T.map((E) =>
                              h.jsxs(
                                "div",
                                {
                                  className: "item-test",
                                  children: [
                                    h.jsxs("div", {
                                      className: "top-article",
                                      children: [
                                        h.jsx("span", {
                                          children:
                                            E == null ? void 0 : E.title,
                                        }),
                                        h.jsxs("div", {
                                          className: "article",
                                          children: [
                                            (E == null ? void 0 : E.subtitle) &&
                                              h.jsx("h2", {
                                                children:
                                                  E == null
                                                    ? void 0
                                                    : E.subtitle,
                                              }),
                                            (E == null
                                              ? void 0
                                              : E.megasubtitle) &&
                                              h.jsx("p", {
                                                children:
                                                  E == null
                                                    ? void 0
                                                    : E.megasubtitle,
                                              }),
                                          ],
                                        }),
                                      ],
                                    }),
                                    h.jsxs("div", {
                                      className: "question-count-and-time",
                                      children: [
                                        h.jsxs("div", {
                                          className: "item-tag",
                                          children: [
                                            h.jsx("img", {
                                              src: "/ggg.svg",
                                              alt: "question",
                                            }),
                                            h.jsxs("p", {
                                              children: [
                                                "Sual sayı: ",
                                                (E == null
                                                  ? void 0
                                                  : E.questions_count) || 0,
                                              ],
                                            }),
                                          ],
                                        }),
                                        h.jsxs("div", {
                                          className: "item-tag",
                                          children: [
                                            h.jsx("img", {
                                              src: "/fff.svg",
                                              alt: "question",
                                            }),
                                            Lg(E == null ? void 0 : E.duration),
                                          ],
                                        }),
                                      ],
                                    }),
                                    h.jsx(Ct, {
                                      title: "İndi başla",
                                      icon: "/doble.svg",
                                      href: `/imtahanlar/kateqoriyalar/${e}/${t == null ? void 0 : t.slug[e]}/teste-basla/${E == null ? void 0 : E.slug[e]}`,
                                      style: { width: "100%" },
                                    }),
                                  ],
                                },
                                E == null ? void 0 : E.id,
                              ),
                            )
                        : null,
                  }),
                ],
              }),
            ],
          });
    },
    z5 = (t) => {
      const {
          innerData: e,
          dataLoading: n,
          hasInvalidateQuery: i,
        } = Et(
          `subcategory/${t}/interviewPreparations`,
          ["interview_prep_key", t],
          !0,
        ),
        a = U.useMemo(() => {
          var u;
          return (
            (e &&
              (e == null ? void 0 : e.length) > 0 &&
              ((u =
                e == null
                  ? void 0
                  : e.find((d) => (d == null ? void 0 : d.type) === 1)) == null
                ? void 0
                : u.items)) ||
            []
          );
        }, [e]),
        l = U.useMemo(() => {
          var u;
          return (
            (e &&
              (e == null ? void 0 : e.length) > 0 &&
              ((u =
                e == null
                  ? void 0
                  : e.find((d) => (d == null ? void 0 : d.type) === 2)) == null
                ? void 0
                : u.items[0])) ||
            []
          );
        }, [e]);
      return {
        InterviewPrepLoading: n,
        InvalidateIntPrep: i,
        videos: a,
        InterviewPrepData: e,
        files: l,
      };
    },
    P5 = ({ finded: t }) => {
      const e = nt((y) => y.selectedLanguage.selectedLanguage),
        {
          InterviewPrepLoading: n,
          InterviewPrepData: i,
          files: a,
          videos: l,
          InvalidateIntPrep: u,
        } = z5(t == null ? void 0 : t.slug[e]),
        [d, m] = U.useState(null);
      if (
        (U.useEffect(() => {
          var y;
          i &&
            Array.isArray(i) &&
            (i == null ? void 0 : i.length) > 0 &&
            m(((y = i[0]) == null ? void 0 : y.type) || 1);
        }, [i]),
        U.useEffect(() => {
          u("interview_prep_key");
        }, []),
        n)
      )
        return h.jsx(ze, {});
      const g = () => {
          var y;
          return h.jsx("div", {
            className: "files",
            children:
              (y = a == null ? void 0 : a.files) == null
                ? void 0
                : y.map((w) =>
                    h.jsxs(
                      "div",
                      {
                        className: "file",
                        children: [
                          h.jsxs("article", {
                            className: "left-descript",
                            children: [
                              h.jsx("div", {
                                className: "icon",
                                children: h.jsx("img", {
                                  src: "/fileicon.svg",
                                  alt: "",
                                }),
                              }),
                              h.jsx("h4", {
                                children: w == null ? void 0 : w.title,
                              }),
                            ],
                          }),
                          h.jsx(Ct, {
                            title: "Bax",
                            icon: "/eye.svg",
                            class_name: "show-file",
                            target: "_blank",
                            href: w == null ? void 0 : w.file_url,
                          }),
                        ],
                      },
                      w.id,
                    ),
                  ),
          });
        },
        v = () =>
          h.jsx("div", {
            className: "video-grid",
            children:
              l == null
                ? void 0
                : l.map((y) => {
                    if (y.video_type === "iframe") {
                      let w = y.video_url;
                      return h.jsxs(
                        "div",
                        {
                          className: "item-grid",
                          children: [
                            h.jsx("div", {
                              className: "top-video",
                              children: h.jsx("iframe", {
                                width: "100%",
                                height: "315",
                                src: w,
                                title: y.title,
                                allow:
                                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                allowFullScreen: !0,
                              }),
                            }),
                            h.jsx("div", {
                              className: "title-area",
                              children: h.jsx("h4", { children: y.title }),
                            }),
                          ],
                        },
                        y.id,
                      );
                    } else
                      return h.jsxs(
                        "div",
                        {
                          className: "item-grid",
                          children: [
                            h.jsx("div", {
                              className: "top-video",
                              children: h.jsxs("video", {
                                controls: !0,
                                width: "100%",
                                height: "315",
                                children: [
                                  h.jsx("source", {
                                    src: y.video_url,
                                    type: "video/mp4",
                                  }),
                                  "Your browser does not support the video tag.",
                                ],
                              }),
                            }),
                            h.jsx("div", {
                              className: "title-area",
                              children: h.jsx("h4", { children: y.title }),
                            }),
                          ],
                        },
                        y.id,
                      );
                  }),
          });
      return h.jsxs("section", {
        className: "interview-preparations",
        children: [
          h.jsxs("div", {
            className: "top-title-main",
            children: [
              h.jsx("h2", {
                className: "content-name",
                children: "Müsahibəyə hazırlıq",
              }),
              h.jsx("div", {
                className: "right-category",
                children:
                  i == null
                    ? void 0
                    : i.map((y) =>
                        h.jsx(
                          "p",
                          {
                            className: `category-title ${d === (y == null ? void 0 : y.type) ? "active-category" : ""}`,
                            onClick: () => m(y == null ? void 0 : y.type),
                            style: {
                              color:
                                d === (y == null ? void 0 : y.type)
                                  ? "#062151"
                                  : "",
                            },
                            children: y == null ? void 0 : y.type_name,
                          },
                          y == null ? void 0 : y.type,
                        ),
                      ),
              }),
            ],
          }),
          h.jsxs("div", {
            className: "bottom-main",
            children: [
              h.jsx("div", {
                className: "top-title-content",
                style: { display: d === 1 ? "none" : "" },
                children: h.jsxs("div", {
                  className: "top",
                  children: [
                    h.jsxs("div", {
                      className: "logo",
                      children: [
                        h.jsx("img", { src: "/ddd.svg", alt: "" }),
                        h.jsx("span", { children: "Müsahibəyə hazırlıq" }),
                      ],
                    }),
                    h.jsx("h2", {
                      children: (a == null ? void 0 : a.title) || "",
                    }),
                  ],
                }),
              }),
              d === 1 ? h.jsx(v, {}) : d === 2 ? h.jsx(g, {}) : null,
            ],
          }),
        ],
      });
    },
    I5 = (t) => {
      const {
          innerData: e,
          dataLoading: n,
          hasInvalidateQuery: i,
        } = Et(`subcategory/${t}/essayExamples`, ["esse_example_key", t], !0),
        a = U.useMemo(() => {
          var u;
          return (
            (e &&
              (e == null ? void 0 : e.length) > 0 &&
              ((u =
                e == null
                  ? void 0
                  : e.find((d) => (d == null ? void 0 : d.type) === 1)) == null
                ? void 0
                : u.items)) ||
            []
          );
        }, [e]),
        l = U.useMemo(() => {
          var u;
          return (
            (e &&
              (e == null ? void 0 : e.length) > 0 &&
              ((u =
                e == null
                  ? void 0
                  : e.find((d) => (d == null ? void 0 : d.type) === 2)) == null
                ? void 0
                : u.items[0])) ||
            []
          );
        }, [e]);
      return {
        EsseDataLoading: n,
        InvalidateEsseData: i,
        videos: a,
        EsseData: e,
        files: l,
      };
    },
    U5 = ({ finded: t }) => {
      const e = nt((y) => y.selectedLanguage.selectedLanguage),
        {
          EsseDataLoading: n,
          EsseData: i,
          files: a,
          videos: l,
          InvalidateEsseData: u,
        } = I5(t == null ? void 0 : t.slug[e]),
        [d, m] = U.useState(null);
      if (
        (U.useEffect(() => {
          var y;
          i &&
            Array.isArray(i) &&
            (i == null ? void 0 : i.length) > 0 &&
            m(((y = i[0]) == null ? void 0 : y.type) || 1);
        }, [i]),
        U.useEffect(() => {
          u("esse_example_key");
        }, []),
        n)
      )
        return h.jsx(ze, {});
      const g = () => {
          var y;
          return h.jsx("div", {
            className: "files",
            children:
              (y = a == null ? void 0 : a.files) == null
                ? void 0
                : y.map((w) =>
                    h.jsxs(
                      "div",
                      {
                        className: "file",
                        children: [
                          h.jsxs("article", {
                            className: "left-descript",
                            children: [
                              h.jsx("div", {
                                className: "icon",
                                children: h.jsx("img", {
                                  src: "/fileicon.svg",
                                  alt: "",
                                }),
                              }),
                              h.jsx("h4", {
                                children: w == null ? void 0 : w.title,
                              }),
                            ],
                          }),
                          h.jsx(Ct, {
                            title: "Bax",
                            icon: "/eye.svg",
                            class_name: "show-file",
                            target: "_blank",
                            href: w == null ? void 0 : w.file_url,
                          }),
                        ],
                      },
                      w.id,
                    ),
                  ),
          });
        },
        v = () =>
          h.jsx("div", {
            className: "video-grid",
            children:
              l == null
                ? void 0
                : l.map((y) => {
                    if (y.video_type === "iframe") {
                      let w = y.video_url;
                      return h.jsxs(
                        "div",
                        {
                          className: "item-grid",
                          children: [
                            h.jsx("div", {
                              className: "top-video",
                              children: h.jsx("iframe", {
                                width: "100%",
                                height: "315",
                                src: w,
                                title: y.title,
                                frameBorder: "0",
                                allow:
                                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                allowFullScreen: !0,
                              }),
                            }),
                            h.jsx("div", {
                              className: "title-area",
                              children: h.jsx("h4", { children: y.title }),
                            }),
                          ],
                        },
                        y.id,
                      );
                    } else
                      return h.jsxs(
                        "div",
                        {
                          className: "item-grid",
                          children: [
                            h.jsx("div", {
                              className: "top-video",
                              children: h.jsxs("video", {
                                controls: !0,
                                width: "100%",
                                height: "315",
                                children: [
                                  h.jsx("source", {
                                    src: y.video_url,
                                    type: "video/mp4",
                                  }),
                                  "Your browser does not support the video tag.",
                                ],
                              }),
                            }),
                            h.jsx("div", {
                              className: "title-area",
                              children: h.jsx("h4", { children: y.title }),
                            }),
                          ],
                        },
                        y.id,
                      );
                  }),
          });
      return h.jsxs("section", {
        className: "interview-preparations",
        children: [
          h.jsxs("div", {
            className: "top-title-main",
            children: [
              h.jsx("h2", {
                className: "content-name",
                children: "Esse nümunələri",
              }),
              h.jsx("div", {
                className: "right-category",
                children:
                  i == null
                    ? void 0
                    : i.map((y) =>
                        h.jsx(
                          "p",
                          {
                            className: `category-title ${d === (y == null ? void 0 : y.type) ? "active-category" : ""}`,
                            onClick: () => m(y == null ? void 0 : y.type),
                            style: {
                              color:
                                d === (y == null ? void 0 : y.type)
                                  ? "#062151"
                                  : "",
                            },
                            children: y == null ? void 0 : y.type_name,
                          },
                          y == null ? void 0 : y.type,
                        ),
                      ),
              }),
            ],
          }),
          h.jsxs("div", {
            className: "bottom-main",
            children: [
              h.jsx("div", {
                className: "top-title-content",
                style: { display: d === 1 ? "none" : "" },
                children: h.jsxs("div", {
                  className: "top",
                  children: [
                    h.jsxs("div", {
                      className: "logo",
                      children: [
                        h.jsx("img", { src: "/essee.svg", alt: "" }),
                        h.jsx("span", { children: "Esse nümunələri" }),
                      ],
                    }),
                    h.jsx("h2", {
                      children: (a == null ? void 0 : a.title) || "",
                    }),
                  ],
                }),
              }),
              d === 1 ? h.jsx(v, {}) : d === 2 ? h.jsx(g, {}) : null,
            ],
          }),
        ],
      });
    },
    F5 = (t) => {
      const {
          innerData: e,
          dataLoading: n,
          hasInvalidateQuery: i,
        } = Et(
          `subcategory/${t}/criticalReadings`,
          ["critical_readings_key", t],
          !0,
        ),
        a = U.useMemo(() => {
          var u;
          return (
            (e &&
              (e == null ? void 0 : e.length) > 0 &&
              ((u =
                e == null
                  ? void 0
                  : e.find((d) => (d == null ? void 0 : d.type) === 1)) == null
                ? void 0
                : u.items)) ||
            []
          );
        }, [e]),
        l = U.useMemo(() => {
          var u;
          return (
            (e &&
              (e == null ? void 0 : e.length) > 0 &&
              ((u =
                e == null
                  ? void 0
                  : e.find((d) => (d == null ? void 0 : d.type) === 2)) == null
                ? void 0
                : u.items[0])) ||
            []
          );
        }, [e]);
      return {
        CriticalReadingsLoading: n,
        InvalidateCriticalReadingsData: i,
        videos: a,
        CriticalReadingsData: e,
        files: l,
      };
    },
    B5 = ({ finded: t }) => {
      const e = nt((y) => y.selectedLanguage.selectedLanguage),
        {
          CriticalReadingsLoading: n,
          CriticalReadingsData: i,
          files: a,
          videos: l,
          InvalidateCriticalReadingsData: u,
        } = F5(t == null ? void 0 : t.slug[e]),
        [d, m] = U.useState(null);
      if (
        (U.useEffect(() => {
          var y;
          i &&
            Array.isArray(i) &&
            (i == null ? void 0 : i.length) > 0 &&
            m(((y = i[0]) == null ? void 0 : y.type) || 1);
        }, [i]),
        U.useEffect(() => {
          u("critical_readings_key");
        }, []),
        n)
      )
        return h.jsx(ze, {});
      const g = () => {
          var y;
          return h.jsx("div", {
            className: "files",
            children:
              (y = a == null ? void 0 : a.files) == null
                ? void 0
                : y.map((w) =>
                    h.jsxs(
                      "div",
                      {
                        className: "file",
                        children: [
                          h.jsxs("article", {
                            className: "left-descript",
                            children: [
                              h.jsx("div", {
                                className: "icon",
                                children: h.jsx("img", {
                                  src: "/fileicon.svg",
                                  alt: "",
                                }),
                              }),
                              h.jsx("h4", {
                                children: w == null ? void 0 : w.title,
                              }),
                            ],
                          }),
                          h.jsx(Ct, {
                            title: "Bax",
                            icon: "/eye.svg",
                            class_name: "show-file",
                            target: "_blank",
                            href: w == null ? void 0 : w.file_url,
                          }),
                        ],
                      },
                      w.id,
                    ),
                  ),
          });
        },
        v = () =>
          h.jsx("div", {
            className: "video-grid",
            children:
              l == null
                ? void 0
                : l.map((y) => {
                    if (y.video_type === "iframe") {
                      let w = y.video_url;
                      return h.jsxs(
                        "div",
                        {
                          className: "item-grid",
                          children: [
                            h.jsx("div", {
                              className: "top-video",
                              children: h.jsx("iframe", {
                                width: "100%",
                                height: "315",
                                src: w,
                                title: y.title,
                                allow:
                                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                allowFullScreen: !0,
                              }),
                            }),
                            h.jsx("div", {
                              className: "title-area",
                              children: h.jsx("h4", { children: y.title }),
                            }),
                          ],
                        },
                        y.id,
                      );
                    } else
                      return h.jsxs(
                        "div",
                        {
                          className: "item-grid",
                          children: [
                            h.jsx("div", {
                              className: "top-video",
                              children: h.jsxs("video", {
                                controls: !0,
                                width: "100%",
                                height: "315",
                                children: [
                                  h.jsx("source", {
                                    src: y.video_url,
                                    type: "video/mp4",
                                  }),
                                  "Your browser does not support the video tag.",
                                ],
                              }),
                            }),
                            h.jsx("div", {
                              className: "title-area",
                              children: h.jsx("h4", { children: y.title }),
                            }),
                          ],
                        },
                        y.id,
                      );
                  }),
          });
      return h.jsxs("section", {
        className: "interview-preparations",
        children: [
          h.jsxs("div", {
            className: "top-title-main",
            children: [
              h.jsx("h2", {
                className: "content-name",
                children: "Tənqidi oxu",
              }),
              h.jsx("div", {
                className: "right-category",
                children:
                  i == null
                    ? void 0
                    : i.map((y) =>
                        h.jsx(
                          "p",
                          {
                            className: `category-title ${d === (y == null ? void 0 : y.type) ? "active-category" : ""}`,
                            onClick: () => m(y == null ? void 0 : y.type),
                            style: {
                              color:
                                d === (y == null ? void 0 : y.type)
                                  ? "#062151"
                                  : "",
                            },
                            children: y == null ? void 0 : y.type_name,
                          },
                          y == null ? void 0 : y.type,
                        ),
                      ),
              }),
            ],
          }),
          h.jsxs("div", {
            className: "bottom-main",
            children: [
              h.jsx("div", {
                className: "top-title-content",
                style: { display: d === 1 ? "none" : "" },
                children: h.jsxs("div", {
                  className: "top",
                  children: [
                    h.jsxs("div", {
                      className: "logo",
                      children: [
                        h.jsx("img", { src: "/tenqidioxuu.svg", alt: "" }),
                        h.jsx("span", { children: "Tənqidi oxu" }),
                      ],
                    }),
                    h.jsx("h2", {
                      children: (a == null ? void 0 : a.title) || "",
                    }),
                  ],
                }),
              }),
              d === 1 ? h.jsx(v, {}) : d === 2 ? h.jsx(g, {}) : null,
            ],
          }),
        ],
      });
    },
    H5 = (t) => {
      var l;
      const {
        innerData: e,
        dataLoading: n,
        hasInvalidateQuery: i,
      } = Et(
        `subcategory/${t}/pastExamQuestions`,
        ["past_exam_question_key", t],
        !0,
      );
      return {
        hasQuestionExam:
          e != null &&
          e.data &&
          ((l = e == null ? void 0 : e.data) == null ? void 0 : l.length) > 0
            ? e == null
              ? void 0
              : e.data
            : [],
        QuestionsExamLoading: n,
        InvalidateQuestionsExamData: i,
      };
    },
    Y5 = ({ finded: t }) => {
      const e = nt((l) => l.selectedLanguage.selectedLanguage),
        {
          InvalidateQuestionsExamData: n,
          QuestionsExamLoading: i,
          hasQuestionExam: a,
        } = H5(t == null ? void 0 : t.slug[e]);
      if (
        (U.useEffect(() => {
          n("past_exam_question_key");
        }, []),
        i)
      )
        return h.jsx(ze, {});
      if (a && a.length > 0)
        return h.jsxs("section", {
          className: "QuestionsExam",
          children: [
            h.jsx("h2", { children: "Əvvəlki illərdə imtahana düşən suallar" }),
            h.jsx("div", {
              className: "content-grid",
              children:
                a == null
                  ? void 0
                  : a.map((l) => {
                      var u, d;
                      return h.jsxs(
                        "div",
                        {
                          className: "content",
                          children: [
                            h.jsxs("div", {
                              className: "title-content",
                              children: [
                                h.jsx("h3", {
                                  children: l == null ? void 0 : l.title,
                                }),
                                h.jsx("p", {
                                  children: l == null ? void 0 : l.subtitle,
                                }),
                              ],
                            }),
                            h.jsx("div", {
                              className: "files",
                              children:
                                l != null &&
                                l.files &&
                                ((u = l == null ? void 0 : l.files) == null
                                  ? void 0
                                  : u.length) > 0
                                  ? (d = l == null ? void 0 : l.files) == null
                                    ? void 0
                                    : d.map((m) =>
                                        h.jsxs(
                                          "div",
                                          {
                                            className: "file",
                                            children: [
                                              h.jsxs("article", {
                                                className: "left-descript",
                                                children: [
                                                  h.jsx("div", {
                                                    className: "icon",
                                                    children: h.jsx("img", {
                                                      src: "/fileicon.svg",
                                                      alt:
                                                        m == null
                                                          ? void 0
                                                          : m.title,
                                                    }),
                                                  }),
                                                  h.jsx("h4", {
                                                    children:
                                                      m == null
                                                        ? void 0
                                                        : m.title,
                                                  }),
                                                ],
                                              }),
                                              h.jsx(Ct, {
                                                title: "Bax",
                                                icon: "/eye.svg",
                                                class_name: "show-file",
                                                target: "_blank",
                                                href:
                                                  m == null
                                                    ? void 0
                                                    : m.filePath,
                                              }),
                                            ],
                                          },
                                          m == null ? void 0 : m.id,
                                        ),
                                      )
                                  : null,
                            }),
                          ],
                        },
                        l == null ? void 0 : l.id,
                      );
                    }),
            }),
          ],
        });
    },
    q5 = ({ finded: t }) => {
      const e = [
        { key: "hasTopic", component: O5 },
        { key: "hasVideo", component: R5 },
        { key: "hasExam", component: k5 },
        { key: "hasEssayExample", component: U5 },
        { key: "hasInterviewPreparation", component: P5 },
        { key: "hasCriticalReading", component: B5 },
        { key: "hasVideo", component: D5 },
        { key: "hasExam", component: Y5 },
      ];
      return t
        ? h.jsx("section", {
            className: "main-contents-wrapper",
            children: e.map(({ key: n, component: i }, a) => {
              const l = t[n];
              return l != null &&
                l !== !1 &&
                (Array.isArray(l) ? l.length > 0 : !0)
                ? h.jsx(
                    "div",
                    { className: "content", children: h.jsx(i, { finded: t }) },
                    a,
                  )
                : null;
            }),
          })
        : null;
    },
    $5 = () => {
      const { lang: t, slug: e } = Ir(),
        { getAltCategories: n, altCategoryData: i } = Fc(e);
      U.useEffect(() => {
        e && n(e);
      }, [t, e]);
      const a = sn(),
        l = nt((d) => d.selectedLanguage.selectedLanguage),
        u = W.useMemo(() => {
          var d;
          if (i && ((d = Object.keys(i)) == null ? void 0 : d.length) > 0)
            return (i == null ? void 0 : i.slug[t]) === e ? i : null;
        }, [t, e, i]);
      return (
        U.useEffect(() => {
          u &&
            a(`/imtahanlar/kateqoriyalar/${l}/${u.slug[l]}`, { replace: !0 });
        }, [l, a, u, e]),
        i
          ? u
            ? h.jsxs("main", {
                className: "exam-category-inner-page-wrapper",
                children: [
                  h.jsx("title", {
                    children: (u == null ? void 0 : u.title) ?? "",
                  }),
                  h.jsx("meta", {
                    name: "description",
                    content: (u == null ? void 0 : u.title) ?? "",
                  }),
                  h.jsxs("div", {
                    className: "exam-category-inner-page",
                    children: [
                      h.jsx(E5, { finded: u }),
                      h.jsx(q5, { finded: u }),
                    ],
                  }),
                ],
              })
            : null
          : h.jsx(ze, {})
      );
    };
  function G5(t) {
    return Fi({
      attr: { viewBox: "0 0 512 512" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M400 145.49 366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49z",
          },
          child: [],
        },
      ],
    })(t);
  }
  function V5(t) {
    return Fi({
      attr: { viewBox: "0 0 512 512" },
      child: [
        {
          tag: "path",
          attr: {
            d: "m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34z",
          },
          child: [],
        },
      ],
    })(t);
  }
  const W5 = { modal: !1 },
    RC = nv({
      name: "startTestModalState",
      initialState: W5,
      reducers: {
        setModal: (t, e) => {
          t.modal = e.payload;
        },
      },
    }),
    { setModal: Dg } = RC.actions,
    X5 = RC.reducer,
    Q5 = "temporary",
    Z5 = "indefinitely",
    LC = ({ duration: t, testSlug: e, altSlug: n }) => {
      const i = _a(),
        { StartTest: a, loadingTest: l } = Bc(n, e),
        u = U.useRef(null),
        d = (m) => {
          u.current && !u.current.contains(m.target) && i(Dg(!1));
        };
      return (
        U.useEffect(
          () => (
            window.addEventListener("mousedown", d),
            () => window.removeEventListener("mousedown", d)
          ),
          [],
        ),
        h.jsx("div", {
          className: "start-test-modal-overlay",
          children: h.jsx("div", {
            className: "start-test-modal",
            ref: u,
            children:
              l === "start"
                ? h.jsx(ze, {})
                : h.jsxs(U.Fragment, {
                    children: [
                      h.jsx(G5, {
                        className: "close-icon",
                        onClick: () => i(Dg(!1)),
                      }),
                      h.jsx("div", {
                        className: "title-content",
                        children: h.jsx("h3", {
                          children: "Müddət növünü seçin",
                        }),
                      }),
                      h.jsxs("div", {
                        className: "buttons",
                        children: [
                          h.jsx(Ct, {
                            title: `Müddətli - ${Lg(t)}`,
                            style: { width: "100%" },
                            isButton: !0,
                            onClickFunc: () => {
                              n !== "" &&
                                e !== "" &&
                                (a(n, e),
                                localStorage.setItem("isDuration", Q5));
                            },
                          }),
                          h.jsx(Ct, {
                            title: "Müddətsiz",
                            class_name: "no-duration",
                            style: { width: "100%" },
                            isButton: !0,
                            onClickFunc: () => {
                              n !== "" &&
                                e !== "" &&
                                (a(n, e),
                                localStorage.setItem("isDuration", Z5));
                            },
                          }),
                        ],
                      }),
                    ],
                  }),
          }),
        })
      );
    },
    K5 = () => {
      var j, O, M;
      const { lang: t, slug: e, testSlug: n } = Ir(),
        i = nt((N) => N.selectedLanguage.selectedLanguage),
        a = sn(),
        { getAltCategories: l, altCategoryData: u } = Fc(e),
        {
          TestsLoading: d,
          hasTestsData: m,
          TestInnerLoading: g,
          loadingTest: v,
        } = Bc(e || "", n || "");
      W.useEffect(() => {
        e && l(e);
      }, [e]);
      const y =
        u && ((j = u == null ? void 0 : u.slug) == null ? void 0 : j[t]) === e
          ? u
          : null;
      let w = null;
      (m &&
        m.length > 0 &&
        (w =
          m
            .flatMap((R) => R.categories || [])
            .flatMap((R) => R.items || [])
            .find((R) => {
              var P;
              return (
                ((P = R == null ? void 0 : R.slug) == null ? void 0 : P[t]) ===
                n
              );
            }) || null),
        W.useEffect(() => {
          if (y && w) {
            const N = `/imtahanlar/kateqoriyalar/${i}/${y == null ? void 0 : y.slug[i]}/teste-basla/${w == null ? void 0 : w.slug[i]}`;
            a(N, { replace: !0 });
          }
        }, [y, w, i, e, n, a, t]));
      const S = _a(),
        T = nt((N) => N.startTestModalState.modal),
        E = () => {
          S(Dg(!0));
        };
      return d || g
        ? h.jsx(ze, {})
        : h.jsxs("main", {
            className: "start-test-page-wrapper",
            children: [
              h.jsx("title", {
                children: (w == null ? void 0 : w.title) ?? "",
              }),
              h.jsx("meta", {
                name: "description",
                content: (w == null ? void 0 : w.subtitle) ?? "",
              }),
              T &&
                h.jsx(LC, {
                  duration: (w == null ? void 0 : w.duration) || 0,
                  altSlug: e || "",
                  testSlug: n || "",
                }),
              h.jsxs("div", {
                className: "start-test-page",
                children: [
                  h.jsx(xi, {
                    title: "Test imtahanı",
                    customStyle: { justifyContent: "flex-start" },
                  }),
                  h.jsx("div", {
                    className: "container-testpage",
                    children: h.jsxs("div", {
                      className: "content",
                      children: [
                        h.jsx("img", {
                          src: "/handraw.webp",
                          className: "image-vector",
                          alt: "vector",
                        }),
                        h.jsxs("article", {
                          className: "text-content",
                          children: [
                            (w == null ? void 0 : w.title) &&
                              h.jsx("h2", {
                                children: w == null ? void 0 : w.title,
                              }),
                            (w == null ? void 0 : w.subtitle) &&
                              h.jsx("p", {
                                children: w == null ? void 0 : w.subtitle,
                              }),
                            (w == null ? void 0 : w.duration) &&
                              h.jsx("h2", {
                                children: Lg(
                                  (w == null ? void 0 : w.duration) || "",
                                ),
                              }),
                          ],
                        }),
                        v === "start"
                          ? h.jsx(ze, {
                              style: {
                                height: "20px",
                                marginTop: "50px",
                                overflow: "hidden",
                              },
                              styleLoader: {
                                height: "20px",
                                overflow: "hidden",
                              },
                            })
                          : h.jsx(Ct, {
                              title: "Testə başla",
                              isButton: !0,
                              onClickFunc: () => E(),
                              href: `/imtahanlar/kateqoriyalar/${i}/${(O = y == null ? void 0 : y.slug) == null ? void 0 : O[i]}/teste-basla/${(M = w == null ? void 0 : w.slug) == null ? void 0 : M[i]}/suallar`,
                              class_name: "button-start-test",
                            }),
                      ],
                    }),
                  }),
                ],
              }),
            ],
          });
    },
    J5 = (t) => {
      const e = t.match(/(\d+)\s*saat/),
        n = t.match(/(\d+)\s*(dəqiqə|minut)/),
        i = t.match(/(\d+)\s*saniyə/),
        a = e ? parseInt(e[1]) : 0,
        l = n ? parseInt(n[1]) : 0,
        u = i ? parseInt(i[1]) : 0;
      return a * 3600 + l * 60 + u;
    },
    e4 = (t) => {
      const e = Math.floor(t / 3600),
        n = Math.floor((t % 3600) / 60),
        i = t % 60,
        a = e > 0 ? `${e} saat ` : "",
        l = n > 0 ? `${n} dəqiqə ` : "",
        u = `${i} saniyə`;
      return `${a}${l}${u}`;
    },
    t4 = ({ time: t, onFinish: e, testId: n }) => {
      const i = J5(t),
        a = `test-timer-${n}`,
        [l, u] = W.useState(i);
      return (
        W.useEffect(() => {
          const d = localStorage.getItem(a);
          let m;
          d
            ? (m = parseInt(d, 10))
            : ((m = Date.now()), localStorage.setItem(a, m.toString()));
          const g = setInterval(() => {
            const v = Date.now(),
              y = Math.floor((v - m) / 1e3),
              w = i - y;
            w <= 0
              ? (u(0), clearInterval(g), localStorage.removeItem(a), e && e())
              : u(w);
          }, 1e3);
          return () => clearInterval(g);
        }, [i, a, e]),
        h.jsx("section", {
          className: "test-time-counter-ui time-is-started",
          children: h.jsx("p", { className: "time-title", children: e4(l) }),
        })
      );
    },
    n4 = ({ data: t }) => {
      const e = localStorage.getItem("isDuration"),
        [n, i] = U.useState(!1);
      U.useEffect(() => {
        i(e !== "indefinitely");
      }, [e]);
      const a = () => {
          var u, d, m, g, v;
          return h.jsxs("section", {
            className: "hero-test-inner",
            children: [
              h.jsxs("div", {
                className: "left-content-inner",
                children: [
                  h.jsxs("div", {
                    className: "top-time-and-question-count",
                    children: [
                      h.jsxs("div", {
                        className: "time",
                        children: [
                          h.jsx("img", { src: "/time.svg", alt: "time-icon" }),
                          h.jsxs("span", {
                            children: [
                              "Müddətli - ",
                              Lg(
                                (u = t == null ? void 0 : t.exam) == null
                                  ? void 0
                                  : u.duration,
                              ),
                            ],
                          }),
                        ],
                      }),
                      h.jsxs("div", {
                        className: "question-count",
                        children: [
                          h.jsx("img", {
                            src: "/question.svg",
                            alt: "question-icon",
                          }),
                          h.jsxs("span", {
                            children: [
                              "Sual sayı: ",
                              (d = t == null ? void 0 : t.exam) == null
                                ? void 0
                                : d.questions_count,
                            ],
                          }),
                        ],
                      }),
                    ],
                  }),
                  h.jsx("h1", {
                    className: "data-main-title",
                    children:
                      (m = t == null ? void 0 : t.exam) == null
                        ? void 0
                        : m.title,
                  }),
                ],
              }),
              h.jsx(t4, {
                time: Lg(
                  (g = t == null ? void 0 : t.exam) == null
                    ? void 0
                    : g.duration,
                ),
                testId:
                  (v = t == null ? void 0 : t.exam) == null ? void 0 : v.id,
              }),
            ],
          });
        },
        l = () => {
          var u, d;
          return h.jsx("section", {
            className: "hero-test-inner",
            children: h.jsxs("div", {
              className: "left-content-inner",
              children: [
                h.jsxs("div", {
                  className: "top-time-and-question-count",
                  children: [
                    h.jsxs("div", {
                      className: "time",
                      children: [
                        h.jsx("img", { src: "/time.svg", alt: "time-icon" }),
                        h.jsx("span", { children: "Müddətsiz" }),
                      ],
                    }),
                    h.jsxs("div", {
                      className: "question-count",
                      children: [
                        h.jsx("img", {
                          src: "/question.svg",
                          alt: "question-icon",
                        }),
                        h.jsxs("span", {
                          children: [
                            "Sual sayı: ",
                            (u = t == null ? void 0 : t.exam) == null
                              ? void 0
                              : u.questions_count,
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
                h.jsx("h1", {
                  className: "data-main-title",
                  children:
                    (d = t == null ? void 0 : t.exam) == null
                      ? void 0
                      : d.title,
                }),
              ],
            }),
          });
        };
      return n ? h.jsx(a, {}) : h.jsx(l, {});
    },
    i4 = ({ data: t, slug: e, testSlug: n }) => {
      var T;
      const {
          EndTest: i,
          loadingTest: a,
          InvalidateTests: l,
          InvalidateTestsInner: u,
        } = Bc(e, n),
        [d, m] = U.useState({}),
        [g, v] = U.useState({}),
        y = (E, j) => {
          m((O) => ({ ...O, [E]: O[E] === j ? null : j }));
        },
        w =
          t != null &&
          t.questions &&
          ((T = t == null ? void 0 : t.questions) == null ? void 0 : T.length) >
            0
            ? t == null
              ? void 0
              : t.questions
            : [],
        S = () => {
          const E = t.questions.map((j) =>
            j.type === 2
              ? { question_id: j.id, answer: g[j.id] }
              : { question_id: j.id, answer_id: d[j.id] },
          );
          i(e, n, E);
        };
      return (
        U.useEffect(() => {
          (l("tests_maincontent_key"), u("tests_inner_key"));
        }, []),
        h.jsxs("div", {
          className: "questions-container",
          children: [
            w == null
              ? void 0
              : w.map((E, j) => {
                  var O;
                  return h.jsxs(
                    "div",
                    {
                      className: "question-item",
                      children: [
                        h.jsxs("div", {
                          className: "top-title-question",
                          children: [
                            h.jsxs("span", {
                              className: "title-question-counter",
                              children: ["Sual ", j + 1, "."],
                            }),
                            h.jsx("h3", {
                              className: "title-question",
                              children: E == null ? void 0 : E.title,
                            }),
                          ],
                        }),
                        h.jsx("div", {
                          className: `options-questions ${(E == null ? void 0 : E.type) === 2 ? "opentype" : ""}`,
                          children:
                            (E == null ? void 0 : E.type) === 2
                              ? h.jsx("div", {
                                  className: "item-option-opentype",
                                  children: h.jsx("textarea", {
                                    name: `open_question_${E.id}`,
                                    required: !0,
                                    placeholder: "Cavabınızı yazın...",
                                    value: g[E.id] || "",
                                    onChange: (M) => {
                                      v((N) => ({
                                        ...N,
                                        [E.id]: M.target.value,
                                      }));
                                    },
                                  }),
                                })
                              : (O = E == null ? void 0 : E.variants) == null
                                ? void 0
                                : O.map((M, N) =>
                                    h.jsxs(
                                      "div",
                                      {
                                        className: `item-option ${d[E == null ? void 0 : E.id] === (M == null ? void 0 : M.id) ? "selected" : ""}`,
                                        onClick: () =>
                                          y(
                                            E == null ? void 0 : E.id,
                                            M == null ? void 0 : M.id,
                                          ),
                                        children: [
                                          h.jsxs("div", {
                                            className: "left-texts",
                                            children: [
                                              h.jsx("span", {
                                                className: "count-with-letter",
                                                children: String.fromCharCode(
                                                  65 + N,
                                                ),
                                              }),
                                              h.jsx("p", {
                                                children:
                                                  M == null ? void 0 : M.title,
                                              }),
                                            ],
                                          }),
                                          h.jsx("input", {
                                            type: "radio",
                                            checked:
                                              d[E == null ? void 0 : E.id] ===
                                              (M == null ? void 0 : M.id),
                                            name: `selected_question_option_${E == null ? void 0 : E.id}`,
                                            required: !0,
                                            className: "radio-option",
                                            onChange: () =>
                                              y(
                                                E == null ? void 0 : E.id,
                                                M == null ? void 0 : M.id,
                                              ),
                                          }),
                                        ],
                                      },
                                      M == null ? void 0 : M.id,
                                    ),
                                  ),
                        }),
                      ],
                    },
                    E == null ? void 0 : E.id,
                  );
                }),
            h.jsx("div", {
              className: "stop-exam",
              children:
                a === "end"
                  ? h.jsx(ze, {
                      style: {
                        transform: "scale(0.6)",
                        willChange: "contents",
                      },
                    })
                  : h.jsx(Ct, {
                      isButton: !0,
                      title: "İmtahanı bitir",
                      class_name: "stop-exam-btn",
                      onClickFunc: () => S(),
                    }),
            }),
          ],
        })
      );
    },
    s4 = () => {
      var w;
      const { lang: t, slug: e, testSlug: n } = Ir(),
        i = nt((S) => S.selectedLanguage.selectedLanguage),
        a = sn(),
        { getAltCategories: l, altCategoryData: u } = Fc(e),
        {
          hasTestInner: d,
          TestInnerLoading: m,
          hasTestsData: g,
        } = Bc(e || "", n || "");
      U.useEffect(() => {
        e && l(e);
      }, [e]);
      const v =
        u && ((w = u == null ? void 0 : u.slug) == null ? void 0 : w[t]) === e
          ? u
          : null;
      let y = null;
      return (
        g &&
          g.length > 0 &&
          (y =
            g
              .flatMap((T) => T.categories || [])
              .flatMap((T) => T.items || [])
              .find((T) => {
                var E;
                return (
                  ((E = T == null ? void 0 : T.slug) == null
                    ? void 0
                    : E[t]) === n
                );
              }) || null),
        U.useEffect(() => {
          var S, T;
          if (v && y) {
            const E = (S = v == null ? void 0 : v.slug) == null ? void 0 : S[i],
              j = (T = y == null ? void 0 : y.slug) == null ? void 0 : T[i];
            if (e !== E || n !== j || t !== i) {
              const O = `/imtahanlar/kateqoriyalar/${i}/${E}/teste-basla/${j}/suallar`;
              a(O, { replace: !0 });
            }
          }
        }, [v, y, i, e, n, t, a]),
        m
          ? h.jsx(ze, {})
          : h.jsxs("main", {
              className: "test-inner-wrapper",
              children: [
                h.jsx("title", { children: n ?? "" }),
                h.jsx("meta", {
                  name: "description",
                  content: (v == null ? void 0 : v.title) ?? "",
                }),
                h.jsxs("div", {
                  className: "test-inner",
                  children: [
                    h.jsx(n4, { data: d }),
                    h.jsx(i4, { data: d, slug: e || "", testSlug: n || "" }),
                  ],
                }),
              ],
            })
      );
    },
    Rw = (t, e) => {
      const {
          innerData: n,
          dataLoading: i,
          hasInvalidateQuery: a,
        } = Et(
          `subcategory/${t}/exams/${e}/results`,
          ["showing_results_key", t],
          !0,
        ),
        {
          innerData: l,
          dataLoading: u,
          hasInvalidateQuery: d,
        } = Et(`subcategory/${t}/exams/${e}/card`, ["results_key", t], !0);
      return {
        ShowingResultsLoading: i,
        ResultsLoading: u,
        InvalidateResult: d,
        resultData: l,
        showingData: n,
        ShowingResultsInvalidate: a,
      };
    },
    DC = () => {
      const t = localStorage.getItem("isDuration");
      return {
        WritingDuration: (n) =>
          n === "indefinitely"
            ? "Müddətsiz"
            : n === "temporary"
              ? "Müddətli"
              : "Bilinmir",
        isDuration: t,
      };
    },
    r4 = () => {
      var H, X, fe, ve, be, Oe, V, pe, de, he, Te, F, ae, xe, Me;
      const t = _a(),
        e = nt((le) => le.startTestModalState.modal),
        { lang: n, slug: i, testSlug: a } = Ir(),
        l = nt((le) => le.selectedLanguage.selectedLanguage),
        u = sn(),
        { getAltCategories: d, altCategoryData: m } = Fc(i),
        { TestInnerLoading: g, hasTestsData: v } = Bc(i || "", a || "");
      U.useEffect(() => {
        i && d(i);
      }, [i]);
      const y =
        m && ((H = m == null ? void 0 : m.slug) == null ? void 0 : H[n]) === i
          ? m
          : null;
      let w = null;
      (v &&
        v.length > 0 &&
        (w =
          v
            .flatMap((Re) => Re.categories || [])
            .flatMap((Re) => Re.items || [])
            .find((Re) => {
              var Je;
              return (
                ((Je = Re == null ? void 0 : Re.slug) == null
                  ? void 0
                  : Je[n]) === a
              );
            }) || null),
        U.useEffect(() => {
          var le, Re;
          if (y && w) {
            const Je =
                (le = y == null ? void 0 : y.slug) == null ? void 0 : le[l],
              ut = (Re = w == null ? void 0 : w.slug) == null ? void 0 : Re[l];
            if (i !== Je || a !== ut || n !== l) {
              const ot = `/imtahanlar/kateqoriyalar/${l}/${Je}/teste-basla/${ut}/suallar`;
              u(ot, { replace: !0 });
            }
          }
        }, [y, w, l, i, a, n, u]));
      const {
          ResultsLoading: S,
          resultData: T,
          InvalidateResult: E,
        } = Rw(i || "", a || ""),
        j = [
          { id: 1, icon: "/successblack.svg", title: "Düz cavab" },
          { id: 2, icon: "/closeblack.svg", title: "Səhv cavab" },
          { id: 3, icon: "/radiusblack.svg", title: "Cavabsız" },
          { id: 4, icon: "/percen.svg", title: "Ümumi nəticə faizi" },
        ],
        O = [
          {
            id: 1,
            count:
              ((X = T == null ? void 0 : T.results) == null
                ? void 0
                : X.correctOptionsCount) || 0,
            icon: "/success.svg",
            title: "düz",
            color: "#0DB02B",
          },
          {
            id: 2,
            count:
              ((fe = T == null ? void 0 : T.results) == null
                ? void 0
                : fe.unCorrectOptionsCount) || 0,
            icon: "/close.svg",
            title: "səhv",
            color: "#FF2327",
          },
          {
            id: 3,
            count:
              ((ve = T == null ? void 0 : T.results) == null
                ? void 0
                : ve.notAnswersCount) || 0,
            icon: "/radius.svg",
            title: "cavabsız",
            color: "#000000",
          },
          {
            id: 4,
            count:
              String(
                (be = T == null ? void 0 : T.results) == null
                  ? void 0
                  : be.resultPercentage,
              ) || "",
            icon: "/clipboard.svg",
            title:
              (V =
                (Oe = T == null ? void 0 : T.results) == null
                  ? void 0
                  : Oe.resultPercentage) != null && V.endsWith("%")
                ? ""
                : "%",
            color: "#407DF2",
          },
        ];
      U.useEffect(() => {
        E("results_key");
      }, []);
      const M =
          T && ((pe = Object.keys(T)) == null ? void 0 : pe.length) > 0
            ? T
            : null,
        N =
          M != null &&
          M.user &&
          ((de = Object.keys(M == null ? void 0 : M.user)) == null
            ? void 0
            : de.length) > 0
            ? M == null
              ? void 0
              : M.user
            : null,
        R =
          M != null &&
          M.answers &&
          ((he = Object.keys(M == null ? void 0 : M.answers)) == null
            ? void 0
            : he.length) > 0
            ? M == null
              ? void 0
              : M.answers
            : null,
        P =
          R != null &&
          R.user_answers &&
          ((Te = R == null ? void 0 : R.user_answers) == null
            ? void 0
            : Te.length) > 0
            ? R == null
              ? void 0
              : R.user_answers
            : [],
        G =
          R != null &&
          R.system &&
          ((F = R == null ? void 0 : R.system) == null ? void 0 : F.length) > 0
            ? R == null
              ? void 0
              : R.system
            : [],
        Y =
          R != null &&
          R.correct_answers &&
          ((ae = R == null ? void 0 : R.correct_answers) == null
            ? void 0
            : ae.length) > 0
            ? R == null
              ? void 0
              : R.correct_answers
            : [],
        { WritingDuration: B, isDuration: I } = DC();
      return (
        U.useEffect(() => {
          t(Dg(!1));
        }, []),
        g
          ? h.jsx(ze, {})
          : h.jsxs("div", {
              className: "answers-wrapper",
              children: [
                h.jsx("title", {
                  children: (w == null ? void 0 : w.title) ?? "",
                }),
                h.jsx("meta", {
                  name: "description",
                  content: (w == null ? void 0 : w.subtitle) ?? "",
                }),
                e &&
                  h.jsx(LC, {
                    duration: (w == null ? void 0 : w.duration) || 0,
                    altSlug: i || "",
                    testSlug: a || "",
                  }),
                S
                  ? h.jsx(ze, {})
                  : h.jsxs("div", {
                      className: "answers",
                      children: [
                        h.jsxs("h1", {
                          className: "title-main",
                          children: [
                            "Test nəticəsi - ",
                            h.jsx("span", {
                              style: {
                                color:
                                  ((xe = M == null ? void 0 : M.results) == null
                                    ? void 0
                                    : xe.resultPercentage) === "0%"
                                    ? "red"
                                    : "",
                              },
                              children:
                                (Me = M == null ? void 0 : M.results) == null
                                  ? void 0
                                  : Me.resultPercentage,
                            }),
                          ],
                        }),
                        h.jsxs("div", {
                          className: "information-box",
                          children: [
                            h.jsxs("div", {
                              className: "item-field",
                              children: [
                                h.jsx("span", { children: "Adı:" }),
                                h.jsx("p", {
                                  children: N == null ? void 0 : N.name,
                                }),
                              ],
                            }),
                            (N == null ? void 0 : N.surname) !== null &&
                              h.jsxs("div", {
                                className: "item-field",
                                children: [
                                  h.jsx("span", { children: "Soyadı:" }),
                                  h.jsx("p", {
                                    children: N == null ? void 0 : N.surname,
                                  }),
                                ],
                              }),
                            h.jsxs("div", {
                              className: "item-field",
                              children: [
                                h.jsx("span", { children: "Mövzu:" }),
                                h.jsx("p", {
                                  children: N == null ? void 0 : N.topic,
                                }),
                              ],
                            }),
                            h.jsxs("div", {
                              className: "item-field",
                              children: [
                                h.jsx("span", { children: "Başlama Tarix:" }),
                                h.jsx("p", {
                                  children: N == null ? void 0 : N.start_date,
                                }),
                              ],
                            }),
                            h.jsxs("div", {
                              className: "item-field",
                              children: [
                                h.jsx("span", { children: "Başlama Tarix:" }),
                                h.jsx("p", {
                                  children: N == null ? void 0 : N.end_date,
                                }),
                              ],
                            }),
                            (I == null ? void 0 : I.length) !== 0 &&
                              h.jsxs("div", {
                                className: "item-field",
                                children: [
                                  h.jsx("span", { children: "Bitirmə vaxtı:" }),
                                  h.jsx("p", { children: B(I) }),
                                ],
                              }),
                          ],
                        }),
                        h.jsxs("div", {
                          className: "answer-card",
                          children: [
                            h.jsx("span", { children: "Cavab kartı" }),
                            h.jsxs("div", {
                              className: "table-content",
                              children: [
                                h.jsxs("div", {
                                  className: "left-table",
                                  children: [
                                    h.jsxs("table", {
                                      children: [
                                        h.jsx("thead", {
                                          children: h.jsx("tr", {
                                            children:
                                              G == null
                                                ? void 0
                                                : G.map((le, Re) =>
                                                    h.jsx(
                                                      "th",
                                                      { children: Re + 1 },
                                                      le == null
                                                        ? void 0
                                                        : le.id,
                                                    ),
                                                  ),
                                          }),
                                        }),
                                        h.jsxs("tbody", {
                                          children: [
                                            h.jsx("tr", {
                                              children:
                                                P == null
                                                  ? void 0
                                                  : P.map((le) =>
                                                      h.jsx(
                                                        "td",
                                                        {
                                                          children:
                                                            le == null
                                                              ? void 0
                                                              : le.variant,
                                                        },
                                                        le == null
                                                          ? void 0
                                                          : le.id,
                                                      ),
                                                    ),
                                            }),
                                            h.jsx("tr", {
                                              children:
                                                G == null
                                                  ? void 0
                                                  : G.map((le) =>
                                                      h.jsx(
                                                        "td",
                                                        {
                                                          children:
                                                            le == null
                                                              ? void 0
                                                              : le.variant,
                                                        },
                                                        le == null
                                                          ? void 0
                                                          : le.id,
                                                      ),
                                                    ),
                                            }),
                                            h.jsx("tr", {
                                              children:
                                                Y == null
                                                  ? void 0
                                                  : Y.map((le) =>
                                                      h.jsx(
                                                        "td",
                                                        {
                                                          children:
                                                            le == null
                                                              ? void 0
                                                              : le.value,
                                                        },
                                                        le == null
                                                          ? void 0
                                                          : le.id,
                                                      ),
                                                    ),
                                            }),
                                          ],
                                        }),
                                      ],
                                    }),
                                    h.jsx("div", {
                                      className: "bottom-information-mini",
                                      children:
                                        j == null
                                          ? void 0
                                          : j.map((le) =>
                                              h.jsxs(
                                                "div",
                                                {
                                                  className:
                                                    "general-info-item",
                                                  children: [
                                                    h.jsx("img", {
                                                      src:
                                                        le == null
                                                          ? void 0
                                                          : le.icon,
                                                      alt:
                                                        le == null
                                                          ? void 0
                                                          : le.title,
                                                    }),
                                                    h.jsx("p", {
                                                      children:
                                                        le == null
                                                          ? void 0
                                                          : le.title,
                                                    }),
                                                  ],
                                                },
                                                le == null ? void 0 : le.id,
                                              ),
                                            ),
                                    }),
                                    h.jsxs("div", {
                                      className: "other-buttons",
                                      children: [
                                        h.jsx(Ct, {
                                          href: `/imtahanlar/kateqoriyalar/${n}/${i || ""}/teste-basla/${a || ""}/suallar/neticeler/suallara-bax`,
                                          title: "Suallara bax",
                                          class_name: "show_questions",
                                        }),
                                        h.jsx(Ct, {
                                          icon: "/Refresh.svg",
                                          title: "Yenidən başla",
                                          class_name: "start_new",
                                          isButton: !0,
                                          onClickFunc: () => {
                                            const le = `test-timer-${w == null ? void 0 : w.id}`;
                                            (t(Dg(!0)),
                                              localStorage.removeItem(le));
                                          },
                                        }),
                                      ],
                                    }),
                                  ],
                                }),
                                h.jsxs("div", {
                                  className: "right-item",
                                  children: [
                                    h.jsx("span", {
                                      className: "result-title",
                                      children: "Nəticə",
                                    }),
                                    h.jsx("div", {
                                      className: "result-info",
                                      children:
                                        O == null
                                          ? void 0
                                          : O.map((le) =>
                                              h.jsxs(
                                                "div",
                                                {
                                                  className: "result-info-item",
                                                  children: [
                                                    h.jsx("img", {
                                                      src:
                                                        le == null
                                                          ? void 0
                                                          : le.icon,
                                                      alt:
                                                        le == null
                                                          ? void 0
                                                          : le.title,
                                                    }),
                                                    h.jsxs("p", {
                                                      style: {
                                                        color:
                                                          le == null
                                                            ? void 0
                                                            : le.color,
                                                      },
                                                      children: [
                                                        le == null
                                                          ? void 0
                                                          : le.count,
                                                        " ",
                                                        le == null
                                                          ? void 0
                                                          : le.title,
                                                      ],
                                                    }),
                                                  ],
                                                },
                                                le == null ? void 0 : le.id,
                                              ),
                                            ),
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
              ],
            })
      );
    },
    a4 = ({ data: t, slug: e, testSlug: n }) => {
      var g, v, y, w, S, T;
      const { WritingDuration: i, isDuration: a } = DC(),
        { ResultsLoading: l, resultData: u, InvalidateResult: d } = Rw(e, n),
        m =
          u &&
          ((g = Object.keys(u)) == null ? void 0 : g.length) > 0 &&
          ((y =
            (v = u == null ? void 0 : u.results) == null
              ? void 0
              : v.resultPercentage) == null
            ? void 0
            : y.length) > 0
            ? (w = u == null ? void 0 : u.results) == null
              ? void 0
              : w.resultPercentage
            : "";
      return (
        U.useEffect(() => {
          d("results_key");
        }, []),
        l
          ? h.jsx(ze, {})
          : h.jsxs("section", {
              className: "hero-test-inner",
              children: [
                h.jsxs("div", {
                  className: "left-content-inner",
                  children: [
                    h.jsxs("div", {
                      className: "top-time-and-question-count",
                      children: [
                        h.jsxs("div", {
                          className: "time",
                          children: [
                            h.jsx("img", {
                              src: "/time.svg",
                              alt: "time-icon",
                            }),
                            h.jsx("span", { children: i(a) }),
                          ],
                        }),
                        h.jsxs("div", {
                          className: "question-count",
                          children: [
                            h.jsx("img", {
                              src: "/question.svg",
                              alt: "question-icon",
                            }),
                            h.jsxs("span", {
                              children: [
                                "Sual sayı: ",
                                (S = t == null ? void 0 : t.exam) == null
                                  ? void 0
                                  : S.questions_count,
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
                    h.jsx("h1", {
                      className: "data-main-title",
                      children:
                        (T = t == null ? void 0 : t.exam) == null
                          ? void 0
                          : T.title,
                    }),
                  ],
                }),
                h.jsxs("div", {
                  className: "right-content-inner-show-questions",
                  children: [
                    h.jsx("h3", { children: m || "" }),
                    h.jsx("p", { children: "Test nəticəsi" }),
                  ],
                }),
              ],
            })
      );
    },
    l4 = ({ slug: t, testSlug: e }) => {
      const { InvalidateTests: n, InvalidateTestsInner: i } = Bc(t, e),
        [a, l] = U.useState({}),
        [u, d] = U.useState({}),
        m = (T, E) => {
          l((j) => ({ ...j, [T]: j[T] === E ? null : E }));
        },
        g = (T, E, j) => {
          if (j) {
            if ((T && E) || (T && !E)) return "green_ans";
            if (!T && E) return "red_ans";
          }
          return "not_selecteds";
        },
        {
          showingData: v,
          ShowingResultsLoading: y,
          ShowingResultsInvalidate: w,
        } = Rw(t, e),
        S = (v == null ? void 0 : v.questions) || [];
      return (
        U.useEffect(() => {
          (n("tests_maincontent_key"),
            i("tests_inner_key"),
            w("showing_results_key"));
        }, []),
        y
          ? h.jsx(ze, {})
          : h.jsx("div", {
              className: "questions-container",
              children:
                S == null
                  ? void 0
                  : S.map((T, E) => {
                      var j;
                      return h.jsxs(
                        "div",
                        {
                          className: "question-item",
                          children: [
                            h.jsxs("div", {
                              className: "top-title-question",
                              children: [
                                h.jsxs("span", {
                                  className: "title-question-counter",
                                  children: ["Sual ", E + 1, "."],
                                }),
                                h.jsx("h3", {
                                  className: "title-question",
                                  children: T == null ? void 0 : T.title,
                                }),
                              ],
                            }),
                            h.jsx("div", {
                              className: `options-questions ${(T == null ? void 0 : T.type) === 2 ? "opentype" : ""}`,
                              children:
                                (T == null ? void 0 : T.type) === 2
                                  ? h.jsx("div", {
                                      className:
                                        "item-option-opentype-for-show-questions",
                                      children: h.jsx("textarea", {
                                        name: `open_question_${T.id}`,
                                        required: !0,
                                        id: "show-question-textarea",
                                        value:
                                          u[T.id] ||
                                          (T == null ? void 0 : T.answer),
                                        onChange: (O) => {
                                          d((M) => ({
                                            ...M,
                                            [T.id]: O.target.value,
                                          }));
                                        },
                                      }),
                                    })
                                  : (j = T == null ? void 0 : T.variants) ==
                                      null
                                    ? void 0
                                    : j.map((O, M) =>
                                        h.jsxs(
                                          "div",
                                          {
                                            className: `item-option-for-show-questions ${g(O == null ? void 0 : O.isCorrect, O == null ? void 0 : O.userSelected, T == null ? void 0 : T.checkUserAnswer)}`,
                                            onClick: () =>
                                              m(
                                                T == null ? void 0 : T.id,
                                                O == null ? void 0 : O.id,
                                              ),
                                            children: [
                                              h.jsxs("div", {
                                                className: "left-texts",
                                                children: [
                                                  h.jsx("span", {
                                                    className:
                                                      "count-with-letter",
                                                    children:
                                                      String.fromCharCode(
                                                        65 + M,
                                                      ),
                                                  }),
                                                  h.jsx("p", {
                                                    children:
                                                      O == null
                                                        ? void 0
                                                        : O.title,
                                                  }),
                                                ],
                                              }),
                                              h.jsx("input", {
                                                type: "radio",
                                                checked:
                                                  a[
                                                    T == null ? void 0 : T.id
                                                  ] ===
                                                  (O == null ? void 0 : O.id),
                                                name: `selected_question_option_${T == null ? void 0 : T.id}`,
                                                required: !0,
                                                className: "radio-option",
                                                onChange: () =>
                                                  m(
                                                    T == null ? void 0 : T.id,
                                                    O == null ? void 0 : O.id,
                                                  ),
                                              }),
                                            ],
                                          },
                                          O == null ? void 0 : O.id,
                                        ),
                                      ),
                            }),
                          ],
                        },
                        T == null ? void 0 : T.id,
                      );
                    }),
            })
      );
    },
    o4 = () => {
      var w;
      const { lang: t, slug: e, testSlug: n } = Ir(),
        i = nt((S) => S.selectedLanguage.selectedLanguage),
        a = sn(),
        { getAltCategories: l, altCategoryData: u } = Fc(e),
        {
          TestInnerLoading: d,
          hasTestsData: m,
          hasTestInner: g,
        } = Bc(e || "", n || "");
      U.useEffect(() => {
        e && l(e);
      }, [e]);
      const v =
        u && ((w = u == null ? void 0 : u.slug) == null ? void 0 : w[t]) === e
          ? u
          : null;
      let y = null;
      return (
        m &&
          m.length > 0 &&
          (y =
            m
              .flatMap((T) => T.categories || [])
              .flatMap((T) => T.items || [])
              .find((T) => {
                var E;
                return (
                  ((E = T == null ? void 0 : T.slug) == null
                    ? void 0
                    : E[t]) === n
                );
              }) || null),
        U.useEffect(() => {
          var S, T;
          if (v && y) {
            const E = (S = v == null ? void 0 : v.slug) == null ? void 0 : S[i],
              j = (T = y == null ? void 0 : y.slug) == null ? void 0 : T[i];
            if (e !== E || n !== j || t !== i) {
              const O = `/imtahanlar/kateqoriyalar/${i}/${E}/teste-basla/${j}/suallar`;
              a(O, { replace: !0 });
            }
          }
        }, [v, y, i, e, n, t, a]),
        d
          ? h.jsx(ze, {})
          : h.jsxs("div", {
              className: "show-questions-wrapper",
              children: [
                h.jsx("title", { children: n ?? "" }),
                h.jsx("meta", { name: "description", content: n ?? "" }),
                h.jsxs("div", {
                  className: "show-questions",
                  children: [
                    h.jsx(a4, { data: g, slug: e || "", testSlug: n || "" }),
                    h.jsx(l4, { data: g, slug: e || "", testSlug: n || "" }),
                  ],
                }),
              ],
            })
      );
    };
  function c4(t) {
    return Fi({
      attr: { fill: "currentColor", viewBox: "0 0 16 16" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z",
          },
          child: [],
        },
      ],
    })(t);
  }
  function u4(t) {
    return Fi({
      attr: { fill: "currentColor", viewBox: "0 0 16 16" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z",
          },
          child: [],
        },
      ],
    })(t);
  }
  const f4 = ({ data: t }) => {
      const e = sn(),
        n = nt((i) => i.selectedLanguage.selectedLanguage);
      return h.jsxs("article", {
        onClick: () =>
          e(`/qalereya/videolar/${n}/${t == null ? void 0 : t.slug[n]}`),
        className: "video-card-ui",
        children: [
          h.jsxs("div", {
            className: "video-content-card",
            children: [
              h.jsx(c4, { className: "play-circle" }),
              h.jsxs("div", {
                className: "length-mini-card",
                children: [
                  h.jsx("img", {
                    src: "/minimg.svg",
                    alt: "minimg",
                    className: "icon",
                  }),
                  h.jsx("span", {
                    children: (t == null ? void 0 : t.media_count) || 0,
                  }),
                ],
              }),
              h.jsx("img", { src: (t == null ? void 0 : t.image) || "" }),
            ],
          }),
          h.jsx("div", {
            className: "text",
            children: h.jsx("h2", { children: t == null ? void 0 : t.title }),
          }),
        ],
      });
    },
    d4 = () => {
      const { instance: t } = si(),
        [e, n] = U.useState([]),
        [i, a] = U.useState(!1),
        [l, u] = U.useState(!1),
        [d, m] = U.useState(1);
      return {
        fetchVideos: async (v) => {
          var y, w;
          v === 1 ? a(!0) : u(!0);
          try {
            const S = await t.get(`gallery-videos?page=${v}`);
            S.data &&
              (n((T) => (v === 1 ? S.data.data : [...T, ...S.data.data])),
              m(
                ((w = (y = S.data) == null ? void 0 : y.meta) == null
                  ? void 0
                  : w.last_page) || 1,
              ));
          } catch (S) {
            console.log(S);
          } finally {
            (a(!1), u(!1));
          }
        },
        videosData: e,
        lastPage: d,
        isInitialLoading: i,
        isLoadingMore: l,
      };
    },
    h4 = () => {
      const {
          fetchVideos: t,
          isInitialLoading: e,
          videosData: n,
          isLoadingMore: i,
          lastPage: a,
        } = d4(),
        [l, u] = U.useState(1),
        d = () => {
          l < a && u((m) => m + 1);
        };
      return (
        U.useEffect(() => {
          t(l);
        }, [l]),
        e
          ? h.jsx(ze, {})
          : h.jsxs("section", {
              className: "rendered-container",
              children: [
                h.jsxs("p", {
                  className: "title-for-length",
                  children: [
                    "Bu səhifədə ",
                    (n == null ? void 0 : n.length) || 0,
                    " Video",
                  ],
                }),
                h.jsx("div", {
                  className: "grid-content",
                  children:
                    n == null
                      ? void 0
                      : n.map((m) =>
                          h.jsx(f4, { data: m }, m == null ? void 0 : m.id),
                        ),
                }),
                h.jsx(np, {
                  counterValue: 12,
                  dataLength: n == null ? void 0 : n.length,
                  initialValue: 12,
                  next: l,
                  setNext: d,
                  title: i ? "Yüklənir..." : "Daha çox",
                }),
              ],
            })
      );
    },
    p4 = ({ data: t }) => {
      var i;
      const e = sn(),
        n = nt((a) => a.selectedLanguage.selectedLanguage);
      return h.jsxs("article", {
        onClick: () =>
          e(`/qalereya/sekiller/${n}/${t == null ? void 0 : t.slug[n]}`),
        className: "image-card-ui",
        children: [
          h.jsxs("div", {
            className: "image-content-card",
            children: [
              h.jsxs("div", {
                className: "length-mini-card",
                children: [
                  h.jsx("img", {
                    src: "/minimg.svg",
                    alt: "minimg",
                    className: "icon",
                  }),
                  h.jsx("span", {
                    children:
                      ((i = t == null ? void 0 : t.media) == null
                        ? void 0
                        : i.length) || 0,
                  }),
                ],
              }),
              h.jsx("img", {
                src: t == null ? void 0 : t.image,
                alt: t == null ? void 0 : t.title,
              }),
            ],
          }),
          h.jsxs("div", {
            className: "text",
            children: [
              h.jsx("span", { children: t == null ? void 0 : t.date }),
              h.jsx("h2", { children: t == null ? void 0 : t.title }),
            ],
          }),
        ],
      });
    },
    m4 = () => {
      const { instance: t } = si(),
        [e, n] = U.useState([]),
        [i, a] = U.useState(!1),
        [l, u] = U.useState(!1),
        [d, m] = U.useState(1);
      return {
        fetchImages: async (v) => {
          var y, w;
          v === 1 ? a(!0) : u(!0);
          try {
            const S = await t.get(`gallery-photos?page=${v}`);
            S.data &&
              (n((T) => (v === 1 ? S.data.data : [...T, ...S.data.data])),
              m(
                ((w = (y = S.data) == null ? void 0 : y.meta) == null
                  ? void 0
                  : w.last_page) || 1,
              ));
          } catch (S) {
            console.log(S);
          } finally {
            (a(!1), u(!1));
          }
        },
        imagesData: e,
        lastPage: d,
        isInitialLoading: i,
        isLoadingMore: l,
      };
    },
    g4 = () => {
      const {
          fetchImages: t,
          isInitialLoading: e,
          imagesData: n,
          isLoadingMore: i,
          lastPage: a,
        } = m4(),
        [l, u] = U.useState(1),
        d = () => {
          l < a && u((m) => m + 1);
        };
      return (
        U.useEffect(() => {
          t(l);
        }, [l]),
        e
          ? h.jsx(ze, {})
          : h.jsxs("section", {
              className: "rendered-container",
              children: [
                h.jsxs("p", {
                  className: "title-for-length",
                  children: [
                    "Bu səhifədə ",
                    (n == null ? void 0 : n.length) || 0,
                    " Şəkil",
                  ],
                }),
                h.jsx("div", {
                  className: "grid-content",
                  children:
                    n == null
                      ? void 0
                      : n.map((m) =>
                          h.jsx(p4, { data: m }, m == null ? void 0 : m.id),
                        ),
                }),
                h.jsx(np, {
                  counterValue: 12,
                  dataLength: n == null ? void 0 : n.length,
                  initialValue: 20,
                  next: l,
                  setNext: d,
                  title: i ? "Yüklənir" : "Daha çox",
                }),
              ],
            })
      );
    },
    _h = [
      { id: 1, renderedComponent: h.jsx(g4, {}), title: "Fotolar" },
      { id: 2, renderedComponent: h.jsx(h4, {}), title: "Videolar" },
    ],
    v4 = () => {
      var a;
      const [t, e] = U.useState(1),
        n = (l) => {
          e(l);
        },
        i =
          (a =
            _h == null
              ? void 0
              : _h.find((l) => t === (l == null ? void 0 : l.id))) == null
            ? void 0
            : a.renderedComponent;
      return h.jsxs("main", {
        className: "gallery-page-wrapper",
        children: [
          h.jsx("title", { children: "Qalereya" }),
          h.jsxs("div", {
            className: "gallery-page",
            children: [
              h.jsxs("div", {
                className: "top-title-component",
                children: [
                  h.jsx(xi, { title: "Qalereya" }),
                  h.jsx("div", {
                    className: "right-content",
                    children:
                      _h == null
                        ? void 0
                        : _h.map((l) =>
                            h.jsx(
                              "div",
                              {
                                onClick: () => n(l == null ? void 0 : l.id),
                                className: `right-nav-item ${t === (l == null ? void 0 : l.id) ? "active" : ""}`,
                                children: h.jsx("p", {
                                  children: l == null ? void 0 : l.title,
                                }),
                              },
                              l == null ? void 0 : l.id,
                            ),
                          ),
                  }),
                ],
              }),
              h.jsx("div", { className: "container-for-grid", children: i }),
            ],
          }),
        ],
      });
    },
    Ne = (t, e = 1e4) => (
      (t = parseFloat(t + "") || 0),
      Math.round((t + Number.EPSILON) * e) / e
    ),
    X_ = function (t) {
      if (!(t && t instanceof Element && t.offsetParent)) return !1;
      const e = t.scrollHeight > t.clientHeight,
        n = window.getComputedStyle(t).overflowY,
        i = n.indexOf("hidden") !== -1,
        a = n.indexOf("visible") !== -1;
      return e && !i && !a;
    },
    bb = function (t, e = void 0) {
      return (
        !(!t || t === document.body || (e && t === e)) &&
        (X_(t) ? t : bb(t.parentElement, e))
      );
    },
    hl = function (t) {
      var e = new DOMParser().parseFromString(t, "text/html").body;
      if (e.childElementCount > 1) {
        for (var n = document.createElement("div"); e.firstChild; )
          n.appendChild(e.firstChild);
        return n;
      }
      return e.firstChild;
    },
    Lw = (t) => `${t || ""}`.split(" ").filter((e) => !!e),
    pl = (t, e, n) => {
      t &&
        Lw(e).forEach((i) => {
          t.classList.toggle(i, n || !1);
        });
    };
  class wh {
    constructor(e) {
      (Object.defineProperty(this, "pageX", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0,
      }),
        Object.defineProperty(this, "pageY", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "clientX", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "clientY", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "id", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "time", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "nativePointer", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        (this.nativePointer = e),
        (this.pageX = e.pageX),
        (this.pageY = e.pageY),
        (this.clientX = e.clientX),
        (this.clientY = e.clientY),
        (this.id = self.Touch && e instanceof Touch ? e.identifier : -1),
        (this.time = Date.now()));
    }
  }
  const Sh = { passive: !1 };
  class y4 {
    constructor(
      e,
      { start: n = () => !0, move: i = () => {}, end: a = () => {} },
    ) {
      (Object.defineProperty(this, "element", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0,
      }),
        Object.defineProperty(this, "startCallback", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "moveCallback", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "endCallback", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "currentPointers", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: [],
        }),
        Object.defineProperty(this, "startPointers", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: [],
        }),
        (this.element = e),
        (this.startCallback = n),
        (this.moveCallback = i),
        (this.endCallback = a));
      for (const l of [
        "onPointerStart",
        "onTouchStart",
        "onMove",
        "onTouchEnd",
        "onPointerEnd",
        "onWindowBlur",
      ])
        this[l] = this[l].bind(this);
      (this.element.addEventListener("mousedown", this.onPointerStart, Sh),
        this.element.addEventListener("touchstart", this.onTouchStart, Sh),
        this.element.addEventListener("touchmove", this.onMove, Sh),
        this.element.addEventListener("touchend", this.onTouchEnd),
        this.element.addEventListener("touchcancel", this.onTouchEnd));
    }
    onPointerStart(e) {
      if (!e.buttons || e.button !== 0) return;
      const n = new wh(e);
      this.currentPointers.some((i) => i.id === n.id) ||
        (this.triggerPointerStart(n, e) &&
          (window.addEventListener("mousemove", this.onMove),
          window.addEventListener("mouseup", this.onPointerEnd),
          window.addEventListener("blur", this.onWindowBlur)));
    }
    onTouchStart(e) {
      for (const n of Array.from(e.changedTouches || []))
        this.triggerPointerStart(new wh(n), e);
      window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(e) {
      const n = this.currentPointers.slice(),
        i =
          "changedTouches" in e
            ? Array.from(e.changedTouches || []).map((l) => new wh(l))
            : [new wh(e)],
        a = [];
      for (const l of i) {
        const u = this.currentPointers.findIndex((d) => d.id === l.id);
        u < 0 || (a.push(l), (this.currentPointers[u] = l));
      }
      a.length && this.moveCallback(e, this.currentPointers.slice(), n);
    }
    onPointerEnd(e) {
      (e.buttons > 0 && e.button !== 0) ||
        (this.triggerPointerEnd(e, new wh(e)),
        window.removeEventListener("mousemove", this.onMove),
        window.removeEventListener("mouseup", this.onPointerEnd),
        window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(e) {
      for (const n of Array.from(e.changedTouches || []))
        this.triggerPointerEnd(e, new wh(n));
    }
    triggerPointerStart(e, n) {
      return (
        !!this.startCallback(n, e, this.currentPointers.slice()) &&
        (this.currentPointers.push(e), this.startPointers.push(e), !0)
      );
    }
    triggerPointerEnd(e, n) {
      const i = this.currentPointers.findIndex((a) => a.id === n.id);
      i < 0 ||
        (this.currentPointers.splice(i, 1),
        this.startPointers.splice(i, 1),
        this.endCallback(e, n, this.currentPointers.slice()));
    }
    onWindowBlur() {
      this.clear();
    }
    clear() {
      for (; this.currentPointers.length; ) {
        const e = this.currentPointers[this.currentPointers.length - 1];
        (this.currentPointers.splice(this.currentPointers.length - 1, 1),
          this.startPointers.splice(this.currentPointers.length - 1, 1),
          this.endCallback(
            new Event("touchend", {
              bubbles: !0,
              cancelable: !0,
              clientX: e.clientX,
              clientY: e.clientY,
            }),
            e,
            this.currentPointers.slice(),
          ));
      }
    }
    stop() {
      (this.element.removeEventListener("mousedown", this.onPointerStart, Sh),
        this.element.removeEventListener("touchstart", this.onTouchStart, Sh),
        this.element.removeEventListener("touchmove", this.onMove, Sh),
        this.element.removeEventListener("touchend", this.onTouchEnd),
        this.element.removeEventListener("touchcancel", this.onTouchEnd),
        window.removeEventListener("mousemove", this.onMove),
        window.removeEventListener("mouseup", this.onPointerEnd),
        window.removeEventListener("blur", this.onWindowBlur));
    }
  }
  function zT(t, e) {
    return e
      ? Math.sqrt(
          Math.pow(e.clientX - t.clientX, 2) +
            Math.pow(e.clientY - t.clientY, 2),
        )
      : 0;
  }
  function PT(t, e) {
    return e
      ? {
          clientX: (t.clientX + e.clientX) / 2,
          clientY: (t.clientY + e.clientY) / 2,
        }
      : t;
  }
  const Q_ = (t) =>
      typeof t == "object" &&
      t !== null &&
      t.constructor === Object &&
      Object.prototype.toString.call(t) === "[object Object]",
    Ys = (t, ...e) => {
      const n = e.length;
      for (let i = 0; i < n; i++) {
        const a = e[i] || {};
        Object.entries(a).forEach(([l, u]) => {
          const d = Array.isArray(u) ? [] : {};
          (t[l] || Object.assign(t, { [l]: d }),
            Q_(u)
              ? Object.assign(t[l], Ys(d, u))
              : Array.isArray(u)
                ? Object.assign(t, { [l]: [...u] })
                : Object.assign(t, { [l]: u }));
        });
      }
      return t;
    },
    Fx = function (t, e) {
      return t
        .split(".")
        .reduce((n, i) => (typeof n == "object" ? n[i] : void 0), e);
    };
  class xb {
    constructor(e = {}) {
      (Object.defineProperty(this, "options", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e,
      }),
        Object.defineProperty(this, "events", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: new Map(),
        }),
        this.setOptions(e));
      for (const n of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))
        n.startsWith("on") &&
          typeof this[n] == "function" &&
          (this[n] = this[n].bind(this));
    }
    setOptions(e) {
      this.options = e ? Ys({}, this.constructor.defaults, e) : {};
      for (const [n, i] of Object.entries(this.option("on") || {}))
        this.on(n, i);
    }
    option(e, ...n) {
      let i = Fx(e, this.options);
      return (i && typeof i == "function" && (i = i.call(this, this, ...n)), i);
    }
    optionFor(e, n, i, ...a) {
      let l = Fx(n, e);
      var u;
      (typeof (u = l) != "string" ||
        isNaN(u) ||
        isNaN(parseFloat(u)) ||
        (l = parseFloat(l)),
        l === "true" && (l = !0),
        l === "false" && (l = !1),
        l && typeof l == "function" && (l = l.call(this, this, e, ...a)));
      let d = Fx(n, this.options);
      return (
        d && typeof d == "function"
          ? (l = d.call(this, this, e, ...a, l))
          : l === void 0 && (l = d),
        l === void 0 ? i : l
      );
    }
    cn(e) {
      const n = this.options.classes;
      return (n && n[e]) || "";
    }
    localize(e, n = []) {
      e = String(e).replace(/\{\{(\w+).?(\w+)?\}\}/g, (i, a, l) => {
        let u = "";
        return (
          l
            ? (u = this.option(
                `${a[0] + a.toLowerCase().substring(1)}.l10n.${l}`,
              ))
            : a && (u = this.option(`l10n.${a}`)),
          u || (u = i),
          u
        );
      });
      for (let i = 0; i < n.length; i++) e = e.split(n[i][0]).join(n[i][1]);
      return (e = e.replace(/\{\{(.*?)\}\}/g, (i, a) => a));
    }
    on(e, n) {
      let i = [];
      (typeof e == "string" ? (i = e.split(" ")) : Array.isArray(e) && (i = e),
        this.events || (this.events = new Map()),
        i.forEach((a) => {
          let l = this.events.get(a);
          (l || (this.events.set(a, []), (l = [])),
            l.includes(n) || l.push(n),
            this.events.set(a, l));
        }));
    }
    off(e, n) {
      let i = [];
      (typeof e == "string" ? (i = e.split(" ")) : Array.isArray(e) && (i = e),
        i.forEach((a) => {
          const l = this.events.get(a);
          if (Array.isArray(l)) {
            const u = l.indexOf(n);
            u > -1 && l.splice(u, 1);
          }
        }));
    }
    emit(e, ...n) {
      ([...(this.events.get(e) || [])].forEach((i) => i(this, ...n)),
        e !== "*" && this.emit("*", e, ...n));
    }
  }
  (Object.defineProperty(xb, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36",
  }),
    Object.defineProperty(xb, "defaults", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: {},
    }));
  class Dw extends xb {
    constructor(e = {}) {
      (super(e),
        Object.defineProperty(this, "plugins", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {},
        }));
    }
    attachPlugins(e = {}) {
      const n = new Map();
      for (const [i, a] of Object.entries(e)) {
        const l = this.option(i),
          u = this.plugins[i];
        u || l === !1
          ? u && l === !1 && (u.detach(), delete this.plugins[i])
          : n.set(i, new a(this, l || {}));
      }
      for (const [i, a] of n) ((this.plugins[i] = a), a.attach());
    }
    detachPlugins(e) {
      e = e || Object.keys(this.plugins);
      for (const n of e) {
        const i = this.plugins[n];
        (i && i.detach(), delete this.plugins[n]);
      }
      return (this.emit("detachPlugins"), this);
    }
  }
  var Zt;
  (function (t) {
    ((t[(t.Init = 0)] = "Init"),
      (t[(t.Error = 1)] = "Error"),
      (t[(t.Ready = 2)] = "Ready"),
      (t[(t.Panning = 3)] = "Panning"),
      (t[(t.Mousemove = 4)] = "Mousemove"),
      (t[(t.Destroy = 5)] = "Destroy"));
  })(Zt || (Zt = {}));
  const Jl = ["a", "b", "c", "d", "e", "f"],
    kC = {
      PANUP: "Move up",
      PANDOWN: "Move down",
      PANLEFT: "Move left",
      PANRIGHT: "Move right",
      ZOOMIN: "Zoom in",
      ZOOMOUT: "Zoom out",
      TOGGLEZOOM: "Toggle zoom level",
      TOGGLE1TO1: "Toggle zoom level",
      ITERATEZOOM: "Toggle zoom level",
      ROTATECCW: "Rotate counterclockwise",
      ROTATECW: "Rotate clockwise",
      FLIPX: "Flip horizontally",
      FLIPY: "Flip vertically",
      FITX: "Fit horizontally",
      FITY: "Fit vertically",
      RESET: "Reset",
      TOGGLEFS: "Toggle fullscreen",
    },
    b4 = {
      content: null,
      width: "auto",
      height: "auto",
      panMode: "drag",
      touch: !0,
      dragMinThreshold: 3,
      lockAxis: !1,
      mouseMoveFactor: 1,
      mouseMoveFriction: 0.12,
      zoom: !0,
      pinchToZoom: !0,
      panOnlyZoomed: "auto",
      minScale: 1,
      maxScale: 2,
      friction: 0.25,
      dragFriction: 0.35,
      decelFriction: 0.05,
      click: "toggleZoom",
      dblClick: !1,
      wheel: "zoom",
      wheelLimit: 7,
      spinner: !0,
      bounds: "auto",
      infinite: !1,
      rubberband: !0,
      bounce: !0,
      maxVelocity: 75,
      transformParent: !1,
      classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen",
      },
      l10n: kC,
    },
    IT = '<circle cx="25" cy="25" r="20"></circle>',
    kw =
      '<div class="f-spinner"><svg viewBox="0 0 50 50">' +
      IT +
      IT +
      "</svg></div>",
    Hs = (t) => t && t !== null && t instanceof Element && "nodeType" in t,
    $t = (t, e) => {
      t &&
        Lw(e).forEach((n) => {
          t.classList.remove(n);
        });
    },
    Ye = (t, e) => {
      t &&
        Lw(e).forEach((n) => {
          t.classList.add(n);
        });
    },
    M0 = { a: 1, b: 0, c: 0, d: 1, e: 0, f: 0 },
    x4 = 1e5,
    N0 = 1e4,
    Nr = "mousemove",
    UT = "drag",
    FT = "content",
    Ar = "auto";
  let Bx = null,
    Hx = null;
  class Pf extends Dw {
    get fits() {
      return (
        this.contentRect.width - this.contentRect.fitWidth < 1 &&
        this.contentRect.height - this.contentRect.fitHeight < 1
      );
    }
    get isTouchDevice() {
      return (
        Hx === null && (Hx = window.matchMedia("(hover: none)").matches),
        Hx
      );
    }
    get isMobile() {
      return (
        Bx === null &&
          (Bx = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)),
        Bx
      );
    }
    get panMode() {
      return this.options.panMode !== Nr || this.isTouchDevice ? UT : Nr;
    }
    get panOnlyZoomed() {
      const e = this.options.panOnlyZoomed;
      return e === Ar ? this.isTouchDevice : e;
    }
    get isInfinite() {
      return this.option("infinite");
    }
    get angle() {
      return (180 * Math.atan2(this.current.b, this.current.a)) / Math.PI || 0;
    }
    get targetAngle() {
      return (180 * Math.atan2(this.target.b, this.target.a)) / Math.PI || 0;
    }
    get scale() {
      const { a: e, b: n } = this.current;
      return Math.sqrt(e * e + n * n) || 1;
    }
    get targetScale() {
      const { a: e, b: n } = this.target;
      return Math.sqrt(e * e + n * n) || 1;
    }
    get minScale() {
      return this.option("minScale") || 1;
    }
    get fullScale() {
      const { contentRect: e } = this;
      return e.fullWidth / e.fitWidth || 1;
    }
    get maxScale() {
      return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
      const { containerRect: e, contentRect: n } = this,
        i = Math.max(e.height / n.fitHeight, e.width / n.fitWidth) || 1;
      return Math.min(this.fullScale, i);
    }
    get isScaling() {
      return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
      const e = this.content;
      return !!(e && e instanceof HTMLImageElement) && !e.complete;
    }
    get isResting() {
      if (this.isBouncingX || this.isBouncingY) return !1;
      for (const e of Jl) {
        const n = e == "e" || e === "f" ? 1e-4 : 1e-5;
        if (Math.abs(this.target[e] - this.current[e]) > n) return !1;
      }
      return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(e, n = {}, i = {}) {
      var a;
      if (
        (super(n),
        Object.defineProperty(this, "pointerTracker", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "resizeObserver", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "updateTimer", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "clickTimer", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "rAF", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "isTicking", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, "ignoreBounds", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, "isBouncingX", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, "isBouncingY", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, "clicks", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "trackingPoints", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: [],
        }),
        Object.defineProperty(this, "pwt", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "cwd", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "pmme", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "friction", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "state", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: Zt.Init,
        }),
        Object.defineProperty(this, "isDragging", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, "container", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "content", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "spinner", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "containerRect", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: { width: 0, height: 0, innerWidth: 0, innerHeight: 0 },
        }),
        Object.defineProperty(this, "contentRect", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            fullWidth: 0,
            fullHeight: 0,
            fitWidth: 0,
            fitHeight: 0,
            width: 0,
            height: 0,
          },
        }),
        Object.defineProperty(this, "dragStart", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: { x: 0, y: 0, top: 0, left: 0, time: 0 },
        }),
        Object.defineProperty(this, "dragOffset", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: { x: 0, y: 0, time: 0 },
        }),
        Object.defineProperty(this, "current", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: Object.assign({}, M0),
        }),
        Object.defineProperty(this, "target", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: Object.assign({}, M0),
        }),
        Object.defineProperty(this, "velocity", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: { a: 0, b: 0, c: 0, d: 0, e: 0, f: 0 },
        }),
        Object.defineProperty(this, "lockedAxis", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        !e)
      )
        throw new Error("Container Element Not Found");
      ((this.container = e),
        this.initContent(),
        this.attachPlugins(Object.assign(Object.assign({}, Pf.Plugins), i)),
        this.emit("attachPlugins"),
        this.emit("init"));
      const l = this.content;
      if (
        (l.addEventListener("load", this.onLoad),
        l.addEventListener("error", this.onError),
        this.isContentLoading)
      ) {
        if (this.option("spinner")) {
          e.classList.add(this.cn("isLoading"));
          const u = hl(kw);
          !e.contains(l) || l.parentElement instanceof HTMLPictureElement
            ? (this.spinner = e.appendChild(u))
            : (this.spinner =
                ((a = l.parentElement) === null || a === void 0
                  ? void 0
                  : a.insertBefore(u, l)) || null);
        }
        this.emit("beforeLoad");
      } else
        queueMicrotask(() => {
          this.enable();
        });
    }
    initContent() {
      const { container: e } = this,
        n = this.cn(FT);
      let i = this.option(FT) || e.querySelector(`.${n}`);
      if (
        (i ||
          ((i = e.querySelector("img,picture") || e.firstElementChild),
          i && Ye(i, n)),
        i instanceof HTMLPictureElement && (i = i.querySelector("img")),
        !i)
      )
        throw new Error("No content found");
      this.content = i;
    }
    onLoad() {
      const { spinner: e, container: n, state: i } = this;
      (e && (e.remove(), (this.spinner = null)),
        this.option("spinner") && n.classList.remove(this.cn("isLoading")),
        this.emit("afterLoad"),
        i === Zt.Init ? this.enable() : this.updateMetrics());
    }
    onError() {
      this.state !== Zt.Destroy &&
        (this.spinner && (this.spinner.remove(), (this.spinner = null)),
        this.stop(),
        this.detachEvents(),
        (this.state = Zt.Error),
        this.emit("error"));
    }
    getNextScale(e) {
      const {
        fullScale: n,
        targetScale: i,
        coverScale: a,
        maxScale: l,
        minScale: u,
      } = this;
      let d = u;
      switch (e) {
        case "toggleMax":
          d = i - u < 0.5 * (l - u) ? l : u;
          break;
        case "toggleCover":
          d = i - u < 0.5 * (a - u) ? a : u;
          break;
        case "toggleZoom":
          d = i - u < 0.5 * (n - u) ? n : u;
          break;
        case "iterateZoom":
          let m = [1, n, l].sort((v, y) => v - y),
            g = m.findIndex((v) => v > i + 1e-5);
          d = m[g] || 1;
      }
      return d;
    }
    attachObserver() {
      var e;
      const n = () => {
        const { container: i, containerRect: a } = this;
        return (
          Math.abs(a.width - i.getBoundingClientRect().width) > 0.1 ||
          Math.abs(a.height - i.getBoundingClientRect().height) > 0.1
        );
      };
      (this.resizeObserver ||
        window.ResizeObserver === void 0 ||
        (this.resizeObserver = new ResizeObserver(() => {
          this.updateTimer ||
            (n()
              ? (this.onResize(),
                this.isMobile &&
                  (this.updateTimer = setTimeout(() => {
                    (n() && this.onResize(), (this.updateTimer = null));
                  }, 500)))
              : this.updateTimer &&
                (clearTimeout(this.updateTimer), (this.updateTimer = null)));
        })),
        (e = this.resizeObserver) === null ||
          e === void 0 ||
          e.observe(this.container));
    }
    detachObserver() {
      var e;
      (e = this.resizeObserver) === null || e === void 0 || e.disconnect();
    }
    attachEvents() {
      const { container: e } = this;
      (e.addEventListener("click", this.onClick, { passive: !1, capture: !1 }),
        e.addEventListener("wheel", this.onWheel, { passive: !1 }),
        (this.pointerTracker = new y4(e, {
          start: this.onPointerDown,
          move: this.onPointerMove,
          end: this.onPointerUp,
        })),
        document.addEventListener(Nr, this.onMouseMove));
    }
    detachEvents() {
      var e;
      const { container: n } = this;
      (n.removeEventListener("click", this.onClick, {
        passive: !1,
        capture: !1,
      }),
        n.removeEventListener("wheel", this.onWheel, { passive: !1 }),
        (e = this.pointerTracker) === null || e === void 0 || e.stop(),
        (this.pointerTracker = null),
        document.removeEventListener(Nr, this.onMouseMove),
        document.removeEventListener("keydown", this.onKeydown, !0),
        this.clickTimer &&
          (clearTimeout(this.clickTimer), (this.clickTimer = null)),
        this.updateTimer &&
          (clearTimeout(this.updateTimer), (this.updateTimer = null)));
    }
    animate() {
      this.setTargetForce();
      const e = this.friction,
        n = this.option("maxVelocity");
      for (const i of Jl)
        e
          ? ((this.velocity[i] *= 1 - e),
            n &&
              !this.isScaling &&
              (this.velocity[i] = Math.max(
                Math.min(this.velocity[i], n),
                -1 * n,
              )),
            (this.current[i] += this.velocity[i]))
          : (this.current[i] = this.target[i]);
      (this.setTransform(),
        this.setEdgeForce(),
        !this.isResting || this.isDragging
          ? (this.rAF = requestAnimationFrame(() => this.animate()))
          : this.stop("current"));
    }
    setTargetForce() {
      for (const e of Jl)
        (e === "e" && this.isBouncingX) ||
          (e === "f" && this.isBouncingY) ||
          (this.velocity[e] =
            (1 / (1 - this.friction) - 1) * (this.target[e] - this.current[e]));
    }
    checkBounds(e = 0, n = 0) {
      const { current: i } = this,
        a = i.e + e,
        l = i.f + n,
        u = this.getBounds(),
        { x: d, y: m } = u,
        g = d.min,
        v = d.max,
        y = m.min,
        w = m.max;
      let S = 0,
        T = 0;
      return (
        g !== 1 / 0 && a < g
          ? (S = g - a)
          : v !== 1 / 0 && a > v && (S = v - a),
        y !== 1 / 0 && l < y
          ? (T = y - l)
          : w !== 1 / 0 && l > w && (T = w - l),
        Math.abs(S) < 1e-4 && (S = 0),
        Math.abs(T) < 1e-4 && (T = 0),
        Object.assign(Object.assign({}, u), {
          xDiff: S,
          yDiff: T,
          inBounds: !S && !T,
        })
      );
    }
    clampTargetBounds() {
      const { target: e } = this,
        { x: n, y: i } = this.getBounds();
      (n.min !== 1 / 0 && (e.e = Math.max(e.e, n.min)),
        n.max !== 1 / 0 && (e.e = Math.min(e.e, n.max)),
        i.min !== 1 / 0 && (e.f = Math.max(e.f, i.min)),
        i.max !== 1 / 0 && (e.f = Math.min(e.f, i.max)));
    }
    calculateContentDim(e = this.current) {
      const { content: n, contentRect: i } = this,
        { fitWidth: a, fitHeight: l, fullWidth: u, fullHeight: d } = i;
      let m = u,
        g = d;
      if (this.option("zoom") || this.angle !== 0) {
        const v =
            !(n instanceof HTMLImageElement) &&
            (window.getComputedStyle(n).maxWidth === "none" ||
              window.getComputedStyle(n).maxHeight === "none"),
          y = v ? u : a,
          w = v ? d : l,
          S = this.getMatrix(e),
          T = new DOMPoint(0, 0).matrixTransform(S),
          E = new DOMPoint(0 + y, 0).matrixTransform(S),
          j = new DOMPoint(0 + y, 0 + w).matrixTransform(S),
          O = new DOMPoint(0, 0 + w).matrixTransform(S),
          M = Math.abs(j.x - T.x),
          N = Math.abs(j.y - T.y),
          R = Math.abs(O.x - E.x),
          P = Math.abs(O.y - E.y);
        ((m = Math.max(M, R)), (g = Math.max(N, P)));
      }
      return { contentWidth: m, contentHeight: g };
    }
    setEdgeForce() {
      if (
        this.ignoreBounds ||
        this.isDragging ||
        this.panMode === Nr ||
        this.targetScale < this.scale
      )
        return ((this.isBouncingX = !1), void (this.isBouncingY = !1));
      const { target: e } = this,
        { x: n, y: i, xDiff: a, yDiff: l } = this.checkBounds(),
        u = this.option("maxVelocity");
      let d = this.velocity.e,
        m = this.velocity.f;
      (a !== 0
        ? ((this.isBouncingX = !0),
          a * d <= 0
            ? (d += 0.14 * a)
            : ((d = 0.14 * a),
              n.min !== 1 / 0 && (this.target.e = Math.max(e.e, n.min)),
              n.max !== 1 / 0 && (this.target.e = Math.min(e.e, n.max))),
          u && (d = Math.max(Math.min(d, u), -1 * u)))
        : (this.isBouncingX = !1),
        l !== 0
          ? ((this.isBouncingY = !0),
            l * m <= 0
              ? (m += 0.14 * l)
              : ((m = 0.14 * l),
                i.min !== 1 / 0 && (this.target.f = Math.max(e.f, i.min)),
                i.max !== 1 / 0 && (this.target.f = Math.min(e.f, i.max))),
            u && (m = Math.max(Math.min(m, u), -1 * u)))
          : (this.isBouncingY = !1),
        this.isBouncingX && (this.velocity.e = d),
        this.isBouncingY && (this.velocity.f = m));
    }
    enable() {
      const { content: e } = this,
        n = new DOMMatrixReadOnly(window.getComputedStyle(e).transform);
      for (const i of Jl) this.current[i] = this.target[i] = n[i];
      (this.updateMetrics(),
        this.attachObserver(),
        this.attachEvents(),
        (this.state = Zt.Ready),
        this.emit("ready"));
    }
    onClick(e) {
      var n;
      (e.type === "click" &&
        e.detail === 0 &&
        ((this.dragOffset.x = 0), (this.dragOffset.y = 0)),
        this.isDragging &&
          ((n = this.pointerTracker) === null || n === void 0 || n.clear(),
          (this.trackingPoints = []),
          this.startDecelAnim()));
      const i = e.target;
      if (!i || e.defaultPrevented) return;
      if (i.hasAttribute("disabled"))
        return (e.preventDefault(), void e.stopPropagation());
      if (
        (() => {
          const S = window.getSelection();
          return S && S.type === "Range";
        })() &&
        !i.closest("button")
      )
        return;
      const a = i.closest("[data-panzoom-action]"),
        l = i.closest("[data-panzoom-change]"),
        u = a || l,
        d = u && Hs(u) ? u.dataset : null;
      if (d) {
        const S = d.panzoomChange,
          T = d.panzoomAction;
        if (((S || T) && e.preventDefault(), S)) {
          let E = {};
          try {
            E = JSON.parse(S);
          } catch {
            console && console.warn("The given data was not valid JSON");
          }
          return void this.applyChange(E);
        }
        if (T) return void (this[T] && this[T]());
      }
      if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3)
        return (e.preventDefault(), void e.stopPropagation());
      if (i.closest("[data-fancybox]")) return;
      const m = this.content.getBoundingClientRect(),
        g = this.dragStart;
      if (
        g.time &&
        !this.canZoomOut() &&
        (Math.abs(m.x - g.x) > 2 || Math.abs(m.y - g.y) > 2)
      )
        return;
      this.dragStart.time = 0;
      const v = (S) => {
          this.option("zoom", e) &&
            S &&
            typeof S == "string" &&
            /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(
              S,
            ) &&
            typeof this[S] == "function" &&
            (e.preventDefault(), this[S]({ event: e }));
        },
        y = this.option("click", e),
        w = this.option("dblClick", e);
      w
        ? (this.clicks++,
          this.clicks == 1 &&
            (this.clickTimer = setTimeout(() => {
              (this.clicks === 1
                ? (this.emit("click", e), !e.defaultPrevented && y && v(y))
                : (this.emit("dblClick", e), e.defaultPrevented || v(w)),
                (this.clicks = 0),
                (this.clickTimer = null));
            }, 350)))
        : (this.emit("click", e), !e.defaultPrevented && y && v(y));
    }
    addTrackingPoint(e) {
      const n = this.trackingPoints.filter((i) => i.time > Date.now() - 100);
      (n.push(e), (this.trackingPoints = n));
    }
    onPointerDown(e, n, i) {
      var a;
      if (this.option("touch", e) === !1) return !1;
      ((this.pwt = 0),
        (this.dragOffset = { x: 0, y: 0, time: 0 }),
        (this.trackingPoints = []));
      const l = this.content.getBoundingClientRect();
      if (
        ((this.dragStart = {
          x: l.x,
          y: l.y,
          top: l.top,
          left: l.left,
          time: Date.now(),
        }),
        this.clickTimer)
      )
        return !1;
      if (this.panMode === Nr && this.targetScale > 1)
        return (e.preventDefault(), e.stopPropagation(), !1);
      const u = e.composedPath()[0];
      if (!i.length) {
        if (
          ["TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO", "IFRAME"].includes(
            u.nodeName,
          ) ||
          u.closest(
            "[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]",
          )
        )
          return !1;
        (a = window.getSelection()) === null ||
          a === void 0 ||
          a.removeAllRanges();
      }
      if (e.type === "mousedown")
        ["A", "BUTTON"].includes(u.nodeName) || e.preventDefault();
      else if (Math.abs(this.velocity.a) > 0.3) return !1;
      return (
        (this.target.e = this.current.e),
        (this.target.f = this.current.f),
        this.stop(),
        this.isDragging ||
          ((this.isDragging = !0),
          this.addTrackingPoint(n),
          this.emit("touchStart", e)),
        !0
      );
    }
    onPointerMove(e, n, i) {
      if (
        this.option("touch", e) === !1 ||
        !this.isDragging ||
        (n.length < 2 &&
          this.panOnlyZoomed &&
          Ne(this.targetScale) <= Ne(this.minScale)) ||
        (this.emit("touchMove", e), e.defaultPrevented)
      )
        return;
      this.addTrackingPoint(n[0]);
      const { content: a } = this,
        l = PT(i[0], i[1]),
        u = PT(n[0], n[1]);
      let d = 0,
        m = 0;
      if (n.length > 1) {
        const N = a.getBoundingClientRect();
        ((d = l.clientX - N.left - 0.5 * N.width),
          (m = l.clientY - N.top - 0.5 * N.height));
      }
      const g = zT(i[0], i[1]),
        v = zT(n[0], n[1]);
      let y = g ? v / g : 1,
        w = u.clientX - l.clientX,
        S = u.clientY - l.clientY;
      ((this.dragOffset.x += w),
        (this.dragOffset.y += S),
        (this.dragOffset.time = Date.now() - this.dragStart.time));
      let T =
        Ne(this.targetScale) === Ne(this.minScale) && this.option("lockAxis");
      if (T && !this.lockedAxis)
        if (T === "xy" || T === "y" || e.type === "touchmove") {
          if (
            Math.abs(this.dragOffset.x) < 6 &&
            Math.abs(this.dragOffset.y) < 6
          )
            return void e.preventDefault();
          const N = Math.abs(
            (180 * Math.atan2(this.dragOffset.y, this.dragOffset.x)) / Math.PI,
          );
          ((this.lockedAxis = N > 45 && N < 135 ? "y" : "x"),
            (this.dragOffset.x = 0),
            (this.dragOffset.y = 0),
            (w = 0),
            (S = 0));
        } else this.lockedAxis = T;
      if (
        (bb(e.target, this.content) && ((T = "x"), (this.dragOffset.y = 0)),
        T &&
          T !== "xy" &&
          this.lockedAxis !== T &&
          Ne(this.targetScale) === Ne(this.minScale))
      )
        return;
      (e.cancelable && e.preventDefault(),
        this.container.classList.add(this.cn("isDragging")));
      const E = this.checkBounds(w, S);
      this.option("rubberband")
        ? (this.isInfinite !== "x" &&
            ((E.xDiff > 0 && w < 0) || (E.xDiff < 0 && w > 0)) &&
            (w *= Math.max(
              0,
              0.5 - Math.abs((0.75 / this.contentRect.fitWidth) * E.xDiff),
            )),
          this.isInfinite !== "y" &&
            ((E.yDiff > 0 && S < 0) || (E.yDiff < 0 && S > 0)) &&
            (S *= Math.max(
              0,
              0.5 - Math.abs((0.75 / this.contentRect.fitHeight) * E.yDiff),
            )))
        : (E.xDiff && (w = 0), E.yDiff && (S = 0));
      const j = this.targetScale,
        O = this.minScale,
        M = this.maxScale;
      (j < 0.5 * O && (y = Math.max(y, O)),
        j > 1.5 * M && (y = Math.min(y, M)),
        this.lockedAxis === "y" && Ne(j) === Ne(O) && (w = 0),
        this.lockedAxis === "x" && Ne(j) === Ne(O) && (S = 0),
        this.applyChange({
          originX: d,
          originY: m,
          panX: w,
          panY: S,
          scale: y,
          friction: this.option("dragFriction"),
          ignoreBounds: !0,
        }));
    }
    onPointerUp(e, n, i) {
      if (i.length)
        return (
          (this.dragOffset.x = 0),
          (this.dragOffset.y = 0),
          void (this.trackingPoints = [])
        );
      (this.container.classList.remove(this.cn("isDragging")),
        this.isDragging &&
          (this.addTrackingPoint(n),
          this.panOnlyZoomed &&
            this.contentRect.width - this.contentRect.fitWidth < 1 &&
            this.contentRect.height - this.contentRect.fitHeight < 1 &&
            (this.trackingPoints = []),
          bb(e.target, this.content) &&
            this.lockedAxis === "y" &&
            (this.trackingPoints = []),
          this.emit("touchEnd", e),
          (this.isDragging = !1),
          (this.lockedAxis = !1),
          this.state !== Zt.Destroy &&
            (e.defaultPrevented || this.startDecelAnim())));
    }
    startDecelAnim() {
      var e;
      const n = this.isScaling;
      (this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)),
        (this.isBouncingX = !1),
        (this.isBouncingY = !1));
      for (const N of Jl) this.velocity[N] = 0;
      ((this.target.e = this.current.e),
        (this.target.f = this.current.f),
        $t(this.container, "is-scaling"),
        $t(this.container, "is-animating"),
        (this.isTicking = !1));
      const { trackingPoints: i } = this,
        a = i[0],
        l = i[i.length - 1];
      let u = 0,
        d = 0,
        m = 0;
      l &&
        a &&
        ((u = l.clientX - a.clientX),
        (d = l.clientY - a.clientY),
        (m = l.time - a.time));
      const g =
        ((e = window.visualViewport) === null || e === void 0
          ? void 0
          : e.scale) || 1;
      g !== 1 && ((u *= g), (d *= g));
      let v = 0,
        y = 0,
        w = 0,
        S = 0,
        T = this.option("decelFriction");
      const E = this.targetScale;
      if (m > 0) {
        ((w = Math.abs(u) > 3 ? u / (m / 30) : 0),
          (S = Math.abs(d) > 3 ? d / (m / 30) : 0));
        const N = this.option("maxVelocity");
        N &&
          ((w = Math.max(Math.min(w, N), -1 * N)),
          (S = Math.max(Math.min(S, N), -1 * N)));
      }
      (w && (v = w / (1 / (1 - T) - 1)),
        S && (y = S / (1 / (1 - T) - 1)),
        (this.option("lockAxis") === "y" ||
          (this.option("lockAxis") === "xy" &&
            this.lockedAxis === "y" &&
            Ne(E) === this.minScale)) &&
          (v = w = 0),
        (this.option("lockAxis") === "x" ||
          (this.option("lockAxis") === "xy" &&
            this.lockedAxis === "x" &&
            Ne(E) === this.minScale)) &&
          (y = S = 0));
      const j = this.dragOffset.x,
        O = this.dragOffset.y,
        M = this.option("dragMinThreshold") || 0;
      (Math.abs(j) < M && Math.abs(O) < M && ((v = y = 0), (w = S = 0)),
        ((this.option("zoom") &&
          (E < this.minScale - 1e-5 || E > this.maxScale + 1e-5)) ||
          (n && !v && !y)) &&
          (T = 0.35),
        this.applyChange({ panX: v, panY: y, friction: T }),
        this.emit("decel", w, S, j, O));
    }
    onWheel(e) {
      var n = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(
        function (l, u) {
          return Math.abs(u) > Math.abs(l) ? u : l;
        },
      );
      const i = Math.max(-1, Math.min(1, n));
      if ((this.emit("wheel", e, i), this.panMode === Nr || e.defaultPrevented))
        return;
      const a = this.option("wheel");
      a === "pan"
        ? (e.preventDefault(),
          (this.panOnlyZoomed && !this.canZoomOut()) ||
            this.applyChange({
              panX: 2 * -e.deltaX,
              panY: 2 * -e.deltaY,
              bounce: !1,
            }))
        : a === "zoom" && this.option("zoom") !== !1 && this.zoomWithWheel(e);
    }
    onMouseMove(e) {
      this.panWithMouse(e);
    }
    onKeydown(e) {
      e.key === "Escape" && this.toggleFS();
    }
    onResize() {
      (this.updateMetrics(), this.checkBounds().inBounds || this.requestTick());
    }
    setTransform() {
      this.emit("beforeTransform");
      const { current: e, target: n, content: i, contentRect: a } = this,
        l = Object.assign({}, M0);
      for (const j of Jl) {
        const O = j == "e" || j === "f" ? N0 : x4;
        ((l[j] = Ne(e[j], O)),
          Math.abs(n[j] - e[j]) < (j == "e" || j === "f" ? 0.51 : 0.001) &&
            (e[j] = n[j]));
      }
      let { a: u, b: d, c: m, d: g, e: v, f: y } = l,
        w = `matrix(${u}, ${d}, ${m}, ${g}, ${v}, ${y})`,
        S = i.parentElement instanceof HTMLPictureElement ? i.parentElement : i;
      if (
        (this.option("transformParent") && (S = S.parentElement || S),
        S.style.transform === w)
      )
        return;
      S.style.transform = w;
      const { contentWidth: T, contentHeight: E } = this.calculateContentDim();
      ((a.width = T), (a.height = E), this.emit("afterTransform"));
    }
    updateMetrics(e = !1) {
      var n;
      if (!this || this.state === Zt.Destroy || this.isContentLoading) return;
      const i = Math.max(
          1,
          ((n = window.visualViewport) === null || n === void 0
            ? void 0
            : n.scale) || 1,
        ),
        { container: a, content: l } = this,
        u = l instanceof HTMLImageElement,
        d = a.getBoundingClientRect(),
        m = getComputedStyle(this.container);
      let g = d.width * i,
        v = d.height * i;
      const y = parseFloat(m.paddingTop) + parseFloat(m.paddingBottom),
        w = g - (parseFloat(m.paddingLeft) + parseFloat(m.paddingRight)),
        S = v - y;
      this.containerRect = {
        width: g,
        height: v,
        innerWidth: w,
        innerHeight: S,
      };
      const T =
          parseFloat(l.dataset.width || "") ||
          ((ve) => {
            let be = 0;
            return (
              (be =
                ve instanceof HTMLImageElement
                  ? ve.naturalWidth
                  : ve instanceof SVGElement
                    ? ve.width.baseVal.value
                    : Math.max(ve.offsetWidth, ve.scrollWidth)),
              be || 0
            );
          })(l),
        E =
          parseFloat(l.dataset.height || "") ||
          ((ve) => {
            let be = 0;
            return (
              (be =
                ve instanceof HTMLImageElement
                  ? ve.naturalHeight
                  : ve instanceof SVGElement
                    ? ve.height.baseVal.value
                    : Math.max(ve.offsetHeight, ve.scrollHeight)),
              be || 0
            );
          })(l);
      let j = this.option("width", T) || Ar,
        O = this.option("height", E) || Ar;
      const M = j === Ar,
        N = O === Ar;
      (typeof j != "number" && (j = T),
        typeof O != "number" && (O = E),
        M && (j = T * (O / E)),
        N && (O = E / (T / j)));
      let R =
        l.parentElement instanceof HTMLPictureElement ? l.parentElement : l;
      this.option("transformParent") && (R = R.parentElement || R);
      const P = R.getAttribute("style") || "";
      (R.style.setProperty("transform", "none", "important"),
        u && ((R.style.width = ""), (R.style.height = "")),
        R.offsetHeight);
      const G = l.getBoundingClientRect();
      let Y = G.width * i,
        B = G.height * i,
        I = Y,
        H = B;
      ((Y = Math.min(Y, j)),
        (B = Math.min(B, O)),
        u
          ? ({ width: Y, height: B } = ((ve, be, Oe, V) => {
              const pe = Oe / ve,
                de = V / be,
                he = Math.min(pe, de);
              return { width: (ve *= he), height: (be *= he) };
            })(j, O, Y, B))
          : ((Y = Math.min(Y, j)), (B = Math.min(B, O))));
      let X = 0.5 * (H - B),
        fe = 0.5 * (I - Y);
      ((this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
        top: G.top - d.top + X,
        bottom: d.bottom - G.bottom + X,
        left: G.left - d.left + fe,
        right: d.right - G.right + fe,
        fitWidth: Y,
        fitHeight: B,
        width: Y,
        height: B,
        fullWidth: j,
        fullHeight: O,
      })),
        (R.style.cssText = P),
        u && ((R.style.width = `${Y}px`), (R.style.height = `${B}px`)),
        this.setTransform(),
        e !== !0 && this.emit("refresh"),
        this.ignoreBounds ||
          (Ne(this.targetScale) < Ne(this.minScale)
            ? this.zoomTo(this.minScale, { friction: 0 })
            : this.targetScale > this.maxScale
              ? this.zoomTo(this.maxScale, { friction: 0 })
              : this.state === Zt.Init ||
                this.checkBounds().inBounds ||
                this.requestTick()),
        this.updateControls());
    }
    calculateBounds() {
      const { contentWidth: e, contentHeight: n } = this.calculateContentDim(
          this.target,
        ),
        { targetScale: i, lockedAxis: a } = this,
        { fitWidth: l, fitHeight: u } = this.contentRect;
      let d = 0,
        m = 0,
        g = 0,
        v = 0;
      const y = this.option("infinite");
      if (y === !0 || (a && y === a))
        ((d = -1 / 0), (g = 1 / 0), (m = -1 / 0), (v = 1 / 0));
      else {
        let { containerRect: w, contentRect: S } = this,
          T = Ne(l * i, N0),
          E = Ne(u * i, N0),
          { innerWidth: j, innerHeight: O } = w;
        if (
          (w.width === T && (j = w.width),
          w.width === E && (O = w.height),
          e > j)
        ) {
          ((g = 0.5 * (e - j)), (d = -1 * g));
          let M = 0.5 * (S.right - S.left);
          ((d += M), (g += M));
        }
        if (
          (l > j && e < j && ((d -= 0.5 * (l - j)), (g -= 0.5 * (l - j))),
          n > O)
        ) {
          ((v = 0.5 * (n - O)), (m = -1 * v));
          let M = 0.5 * (S.bottom - S.top);
          ((m += M), (v += M));
        }
        u > O && n < O && ((d -= 0.5 * (u - O)), (g -= 0.5 * (u - O)));
      }
      return { x: { min: d, max: g }, y: { min: m, max: v } };
    }
    getBounds() {
      const e = this.option("bounds");
      return e !== Ar ? e : this.calculateBounds();
    }
    updateControls() {
      const e = this,
        n = e.container,
        { panMode: i, contentRect: a, targetScale: l, minScale: u } = e;
      let d = u,
        m = e.option("click") || !1;
      m && (d = e.getNextScale(m));
      let g = e.canZoomIn(),
        v = e.canZoomOut(),
        y = i === UT && !!this.option("touch"),
        w = v && y;
      if (
        (y &&
          (Ne(l) < Ne(u) && !this.panOnlyZoomed && (w = !0),
          (Ne(a.width, 1) > Ne(a.fitWidth, 1) ||
            Ne(a.height, 1) > Ne(a.fitHeight, 1)) &&
            (w = !0)),
        Ne(a.width * l, 1) < Ne(a.fitWidth, 1) && (w = !1),
        i === Nr && (w = !1),
        pl(n, this.cn("isDraggable"), w),
        !this.option("zoom"))
      )
        return;
      let S = g && Ne(d) > Ne(l),
        T = !S && !w && v && Ne(d) < Ne(l);
      (pl(n, this.cn("canZoomIn"), S), pl(n, this.cn("canZoomOut"), T));
      for (const E of n.querySelectorAll("[data-panzoom-action]")) {
        let j = !1,
          O = !1;
        switch (E.dataset.panzoomAction) {
          case "zoomIn":
            g ? (j = !0) : (O = !0);
            break;
          case "zoomOut":
            v ? (j = !0) : (O = !0);
            break;
          case "toggleZoom":
          case "iterateZoom":
            g || v ? (j = !0) : (O = !0);
            const M = E.querySelector("g");
            M && (M.style.display = g ? "" : "none");
        }
        j
          ? (E.removeAttribute("disabled"), E.removeAttribute("tabindex"))
          : O &&
            (E.setAttribute("disabled", ""), E.setAttribute("tabindex", "-1"));
      }
    }
    panTo({
      x: e = this.target.e,
      y: n = this.target.f,
      scale: i = this.targetScale,
      friction: a = this.option("friction"),
      angle: l = 0,
      originX: u = 0,
      originY: d = 0,
      flipX: m = !1,
      flipY: g = !1,
      ignoreBounds: v = !1,
    }) {
      this.state !== Zt.Destroy &&
        this.applyChange({
          panX: e - this.target.e,
          panY: n - this.target.f,
          scale: i / this.targetScale,
          angle: l,
          originX: u,
          originY: d,
          friction: a,
          flipX: m,
          flipY: g,
          ignoreBounds: v,
        });
    }
    applyChange({
      panX: e = 0,
      panY: n = 0,
      scale: i = 1,
      angle: a = 0,
      originX: l = -this.current.e,
      originY: u = -this.current.f,
      friction: d = this.option("friction"),
      flipX: m = !1,
      flipY: g = !1,
      ignoreBounds: v = !1,
      bounce: y = this.option("bounce"),
    }) {
      const w = this.state;
      if (w === Zt.Destroy) return;
      (this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)),
        (this.friction = d || 0),
        (this.ignoreBounds = v));
      const { current: S } = this,
        T = S.e,
        E = S.f,
        j = this.getMatrix(this.target);
      let O = new DOMMatrix().translate(T, E).translate(l, u).translate(e, n);
      if (this.option("zoom")) {
        if (!v) {
          const M = this.targetScale,
            N = this.minScale,
            R = this.maxScale;
          (M * i < N && (i = N / M), M * i > R && (i = R / M));
        }
        O = O.scale(i);
      }
      ((O = O.translate(-l, -u).translate(-T, -E).multiply(j)),
        a && (O = O.rotate(a)),
        m && (O = O.scale(-1, 1)),
        g && (O = O.scale(1, -1)));
      for (const M of Jl)
        M !== "e" &&
        M !== "f" &&
        (O[M] > this.minScale + 1e-5 || O[M] < this.minScale - 1e-5)
          ? (this.target[M] = O[M])
          : (this.target[M] = Ne(O[M], N0));
      ((this.targetScale < this.scale ||
        Math.abs(i - 1) > 0.1 ||
        this.panMode === Nr ||
        y === !1) &&
        !v &&
        this.clampTargetBounds(),
        w === Zt.Init
          ? this.animate()
          : this.isResting || ((this.state = Zt.Panning), this.requestTick()));
    }
    stop(e = !1) {
      if (this.state === Zt.Init || this.state === Zt.Destroy) return;
      const n = this.isTicking;
      (this.rAF && (cancelAnimationFrame(this.rAF), (this.rAF = null)),
        (this.isBouncingX = !1),
        (this.isBouncingY = !1));
      for (const i of Jl)
        ((this.velocity[i] = 0),
          e === "current"
            ? (this.current[i] = this.target[i])
            : e === "target" && (this.target[i] = this.current[i]));
      (this.setTransform(),
        $t(this.container, "is-scaling"),
        $t(this.container, "is-animating"),
        (this.isTicking = !1),
        (this.state = Zt.Ready),
        n && (this.emit("endAnimation"), this.updateControls()));
    }
    requestTick() {
      (this.isTicking ||
        (this.emit("startAnimation"),
        this.updateControls(),
        Ye(this.container, "is-animating"),
        this.isScaling && Ye(this.container, "is-scaling")),
        (this.isTicking = !0),
        this.rAF || (this.rAF = requestAnimationFrame(() => this.animate())));
    }
    panWithMouse(e, n = this.option("mouseMoveFriction")) {
      if (
        ((this.pmme = e),
        this.panMode !== Nr || !e || Ne(this.targetScale) <= Ne(this.minScale))
      )
        return;
      this.emit("mouseMove", e);
      const { container: i, containerRect: a, contentRect: l } = this,
        u = a.width,
        d = a.height,
        m = i.getBoundingClientRect(),
        g = (e.clientX || 0) - m.left,
        v = (e.clientY || 0) - m.top;
      let { contentWidth: y, contentHeight: w } = this.calculateContentDim(
        this.target,
      );
      const S = this.option("mouseMoveFactor");
      S > 1 && (y !== u && (y *= S), w !== d && (w *= S));
      let T = 0.5 * (y - u) - (((g / u) * 100) / 100) * (y - u);
      T += 0.5 * (l.right - l.left);
      let E = 0.5 * (w - d) - (((v / d) * 100) / 100) * (w - d);
      ((E += 0.5 * (l.bottom - l.top)),
        this.applyChange({
          panX: T - this.target.e,
          panY: E - this.target.f,
          friction: n,
        }));
    }
    zoomWithWheel(e) {
      if (this.state === Zt.Destroy || this.state === Zt.Init) return;
      const n = Date.now();
      if (n - this.pwt < 45) return void e.preventDefault();
      this.pwt = n;
      var i = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(
        function (g, v) {
          return Math.abs(v) > Math.abs(g) ? v : g;
        },
      );
      const a = Math.max(-1, Math.min(1, i)),
        { targetScale: l, maxScale: u, minScale: d } = this;
      let m = (l * (100 + 45 * a)) / 100;
      (Ne(m) < Ne(d) && Ne(l) <= Ne(d)
        ? ((this.cwd += Math.abs(a)), (m = d))
        : Ne(m) > Ne(u) && Ne(l) >= Ne(u)
          ? ((this.cwd += Math.abs(a)), (m = u))
          : ((this.cwd = 0), (m = Math.max(Math.min(m, u), d))),
        this.cwd > this.option("wheelLimit") ||
          (e.preventDefault(),
          Ne(m) !== Ne(l) && this.zoomTo(m, { event: e })));
    }
    canZoomIn() {
      return (
        this.option("zoom") &&
        (Ne(this.contentRect.width, 1) < Ne(this.contentRect.fitWidth, 1) ||
          Ne(this.targetScale) < Ne(this.maxScale))
      );
    }
    canZoomOut() {
      return this.option("zoom") && Ne(this.targetScale) > Ne(this.minScale);
    }
    zoomIn(e = 1.25, n) {
      this.zoomTo(this.targetScale * e, n);
    }
    zoomOut(e = 0.8, n) {
      this.zoomTo(this.targetScale * e, n);
    }
    zoomToFit(e) {
      this.zoomTo("fit", e);
    }
    zoomToCover(e) {
      this.zoomTo("cover", e);
    }
    zoomToFull(e) {
      this.zoomTo("full", e);
    }
    zoomToMax(e) {
      this.zoomTo("max", e);
    }
    toggleZoom(e) {
      this.zoomTo(this.getNextScale("toggleZoom"), e);
    }
    toggleMax(e) {
      this.zoomTo(this.getNextScale("toggleMax"), e);
    }
    toggleCover(e) {
      this.zoomTo(this.getNextScale("toggleCover"), e);
    }
    iterateZoom(e) {
      this.zoomTo("next", e);
    }
    zoomTo(
      e = 1,
      { friction: n = Ar, originX: i = Ar, originY: a = Ar, event: l } = {},
    ) {
      if (this.isContentLoading || this.state === Zt.Destroy) return;
      const { targetScale: u, fullScale: d, maxScale: m, coverScale: g } = this;
      if (
        (this.stop(),
        this.panMode === Nr && (l = this.pmme || l),
        l || i === Ar || a === Ar)
      ) {
        const y = this.content.getBoundingClientRect(),
          w = this.container.getBoundingClientRect(),
          S = l ? l.clientX : w.left + 0.5 * w.width,
          T = l ? l.clientY : w.top + 0.5 * w.height;
        ((i = S - y.left - 0.5 * y.width), (a = T - y.top - 0.5 * y.height));
      }
      let v = 1;
      (typeof e == "number"
        ? (v = e)
        : e === "full"
          ? (v = d)
          : e === "cover"
            ? (v = g)
            : e === "max"
              ? (v = m)
              : e === "fit"
                ? (v = 1)
                : e === "next" && (v = this.getNextScale("iterateZoom")),
        (v = v / u || 1),
        (n = n === Ar ? (v > 1 ? 0.15 : 0.25) : n),
        this.applyChange({ scale: v, originX: i, originY: a, friction: n }),
        l && this.panMode === Nr && this.panWithMouse(l, n));
    }
    rotateCCW() {
      this.applyChange({ angle: -90 });
    }
    rotateCW() {
      this.applyChange({ angle: 90 });
    }
    flipX() {
      this.applyChange({ flipX: !0 });
    }
    flipY() {
      this.applyChange({ flipY: !0 });
    }
    fitX() {
      this.stop("target");
      const { containerRect: e, contentRect: n, target: i } = this;
      this.applyChange({
        panX: 0.5 * e.width - (n.left + 0.5 * n.fitWidth) - i.e,
        panY: 0.5 * e.height - (n.top + 0.5 * n.fitHeight) - i.f,
        scale: e.width / n.fitWidth / this.targetScale,
        originX: 0,
        originY: 0,
        ignoreBounds: !0,
      });
    }
    fitY() {
      this.stop("target");
      const { containerRect: e, contentRect: n, target: i } = this;
      this.applyChange({
        panX: 0.5 * e.width - (n.left + 0.5 * n.fitWidth) - i.e,
        panY: 0.5 * e.innerHeight - (n.top + 0.5 * n.fitHeight) - i.f,
        scale: e.height / n.fitHeight / this.targetScale,
        originX: 0,
        originY: 0,
        ignoreBounds: !0,
      });
    }
    toggleFS() {
      const { container: e } = this,
        n = this.cn("inFullscreen"),
        i = this.cn("htmlHasFullscreen");
      e.classList.toggle(n);
      const a = e.classList.contains(n);
      (a
        ? (document.documentElement.classList.add(i),
          document.addEventListener("keydown", this.onKeydown, !0))
        : (document.documentElement.classList.remove(i),
          document.removeEventListener("keydown", this.onKeydown, !0)),
        this.updateMetrics(),
        this.emit(a ? "enterFS" : "exitFS"));
    }
    getMatrix(e = this.current) {
      const { a: n, b: i, c: a, d: l, e: u, f: d } = e;
      return new DOMMatrix([n, i, a, l, u, d]);
    }
    reset(e) {
      if (this.state !== Zt.Init && this.state !== Zt.Destroy) {
        this.stop("current");
        for (const n of Jl) this.target[n] = M0[n];
        ((this.target.a = this.minScale),
          (this.target.d = this.minScale),
          this.clampTargetBounds(),
          this.isResting ||
            ((this.friction = e === void 0 ? this.option("friction") : e),
            (this.state = Zt.Panning),
            this.requestTick()));
      }
    }
    destroy() {
      (this.stop(),
        (this.state = Zt.Destroy),
        this.detachEvents(),
        this.detachObserver());
      const { container: e, content: n } = this,
        i = this.option("classes") || {};
      for (const a of Object.values(i)) e.classList.remove(a + "");
      (n &&
        (n.removeEventListener("load", this.onLoad),
        n.removeEventListener("error", this.onError)),
        this.detachPlugins());
    }
  }
  (Object.defineProperty(Pf, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: b4,
  }),
    Object.defineProperty(Pf, "Plugins", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: {},
    }));
  const BT = function (t, e) {
      let n = !0;
      return (...i) => {
        n &&
          ((n = !1),
          t(...i),
          setTimeout(() => {
            n = !0;
          }, e));
      };
    },
    HT = (t, e) => {
      let n = [];
      return (
        t.childNodes.forEach((i) => {
          i.nodeType !== Node.ELEMENT_NODE || (e && !i.matches(e)) || n.push(i);
        }),
        n
      );
    },
    _4 = {
      viewport: null,
      track: null,
      enabled: !0,
      slides: [],
      axis: "x",
      transition: "fade",
      preload: 1,
      slidesPerPage: "auto",
      initialPage: 0,
      friction: 0.12,
      Panzoom: { decelFriction: 0.12 },
      center: !0,
      infinite: !0,
      fill: !0,
      dragFree: !1,
      adaptiveHeight: !1,
      direction: "ltr",
      classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected",
      },
      l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d",
      },
    };
  var Wn;
  (function (t) {
    ((t[(t.Init = 0)] = "Init"),
      (t[(t.Ready = 1)] = "Ready"),
      (t[(t.Destroy = 2)] = "Destroy"));
  })(Wn || (Wn = {}));
  const Yx = (t) => {
      if (typeof t == "string" || t instanceof HTMLElement) t = { html: t };
      else {
        const e = t.thumb;
        e !== void 0 &&
          (typeof e == "string" && (t.thumbSrc = e),
          e instanceof HTMLImageElement &&
            ((t.thumbEl = e), (t.thumbElSrc = e.src), (t.thumbSrc = e.src)),
          delete t.thumb);
      }
      return Object.assign(
        {
          html: "",
          el: null,
          isDom: !1,
          class: "",
          customClass: "",
          index: -1,
          dim: 0,
          gap: 0,
          pos: 0,
          transition: !1,
        },
        t,
      );
    },
    w4 = (t = {}) =>
      Object.assign({ index: -1, slides: [], dim: 0, pos: -1 }, t);
  let Ta = class extends xb {
    constructor(e, n) {
      (super(n),
        Object.defineProperty(this, "instance", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: e,
        }));
    }
    attach() {}
    detach() {}
  };
  const S4 = {
    classes: {
      list: "f-carousel__dots",
      isDynamic: "is-dynamic",
      hasDots: "has-dots",
      dot: "f-carousel__dot",
      isBeforePrev: "is-before-prev",
      isPrev: "is-prev",
      isCurrent: "is-current",
      isNext: "is-next",
      isAfterNext: "is-after-next",
    },
    dotTpl:
      '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2,
  };
  class zC extends Ta {
    constructor() {
      (super(...arguments),
        Object.defineProperty(this, "isDynamic", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, "list", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }));
    }
    onRefresh() {
      this.refresh();
    }
    build() {
      let e = this.list;
      if (!e) {
        ((e = document.createElement("ul")),
          Ye(e, this.cn("list")),
          e.setAttribute("role", "tablist"));
        const n = this.instance.container;
        (n.appendChild(e), Ye(n, this.cn("hasDots")), (this.list = e));
      }
      return e;
    }
    refresh() {
      var e;
      const n = this.instance.pages.length,
        i = Math.min(2, this.option("minCount")),
        a = Math.max(2e3, this.option("maxCount")),
        l = this.option("dynamicFrom");
      if (n < i || n > a) return void this.cleanup();
      const u = typeof l == "number" && n > 5 && n >= l,
        d =
          !this.list || this.isDynamic !== u || this.list.children.length !== n;
      d && this.cleanup();
      const m = this.build();
      if ((pl(m, this.cn("isDynamic"), !!u), d))
        for (let y = 0; y < n; y++) m.append(this.createItem(y));
      let g,
        v = 0;
      for (const y of [...m.children]) {
        const w = v === this.instance.page;
        (w && (g = y),
          pl(y, this.cn("isCurrent"), w),
          (e = y.children[0]) === null ||
            e === void 0 ||
            e.setAttribute("aria-selected", w ? "true" : "false"));
        for (const S of ["isBeforePrev", "isPrev", "isNext", "isAfterNext"])
          $t(y, this.cn(S));
        v++;
      }
      if (((g = g || m.firstChild), u && g)) {
        const y = g.previousElementSibling,
          w = y && y.previousElementSibling;
        (Ye(y, this.cn("isPrev")), Ye(w, this.cn("isBeforePrev")));
        const S = g.nextElementSibling,
          T = S && S.nextElementSibling;
        (Ye(S, this.cn("isNext")), Ye(T, this.cn("isAfterNext")));
      }
      this.isDynamic = u;
    }
    createItem(e = 0) {
      var n;
      const i = document.createElement("li");
      i.setAttribute("role", "presentation");
      const a = hl(
        this.instance
          .localize(this.option("dotTpl"), [["%d", e + 1]])
          .replace(/\%i/g, e + ""),
      );
      return (
        i.appendChild(a),
        (n = i.children[0]) === null ||
          n === void 0 ||
          n.setAttribute("role", "tab"),
        i
      );
    }
    cleanup() {
      (this.list && (this.list.remove(), (this.list = null)),
        (this.isDynamic = !1),
        $t(this.instance.container, this.cn("hasDots")));
    }
    attach() {
      this.instance.on(["refresh", "change"], this.onRefresh);
    }
    detach() {
      (this.instance.off(["refresh", "change"], this.onRefresh),
        this.cleanup());
    }
  }
  Object.defineProperty(zC, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: S4,
  });
  const A0 = "disabled",
    R0 = "next",
    YT = "prev";
  class PC extends Ta {
    constructor() {
      (super(...arguments),
        Object.defineProperty(this, "container", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "prev", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "next", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "isDom", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }));
    }
    onRefresh() {
      const e = this.instance,
        n = e.pages.length,
        i = e.page;
      if (n < 2) return void this.cleanup();
      this.build();
      let a = this.prev,
        l = this.next;
      a &&
        l &&
        (a.removeAttribute(A0),
        l.removeAttribute(A0),
        e.isInfinite ||
          (i <= 0 && a.setAttribute(A0, ""),
          i >= n - 1 && l.setAttribute(A0, "")));
    }
    addBtn(e) {
      var n;
      const i = this.instance,
        a = document.createElement("button");
      (a.setAttribute("tabindex", "0"),
        a.setAttribute("title", i.localize(`{{${e.toUpperCase()}}}`)),
        Ye(
          a,
          this.cn("button") + " " + this.cn(e === R0 ? "isNext" : "isPrev"),
        ));
      const l = i.isRTL ? (e === R0 ? YT : R0) : e;
      var u;
      return (
        (a.innerHTML = i.localize(this.option(`${l}Tpl`))),
        (a.dataset[
          `carousel${((u = e), u ? (u.match("^[a-z]") ? u.charAt(0).toUpperCase() + u.substring(1) : u) : "")}`
        ] = "true"),
        (n = this.container) === null || n === void 0 || n.appendChild(a),
        a
      );
    }
    build() {
      const e = this.instance.container,
        n = this.cn("container");
      let { container: i, prev: a, next: l } = this;
      (i || ((i = e.querySelector("." + n)), (this.isDom = !!i)),
        i || ((i = document.createElement("div")), Ye(i, n), e.appendChild(i)),
        (this.container = i),
        l || (l = i.querySelector("[data-carousel-next]")),
        l || (l = this.addBtn(R0)),
        (this.next = l),
        a || (a = i.querySelector("[data-carousel-prev]")),
        a || (a = this.addBtn(YT)),
        (this.prev = a));
    }
    cleanup() {
      (this.isDom ||
        (this.prev && this.prev.remove(),
        this.next && this.next.remove(),
        this.container && this.container.remove()),
        (this.prev = null),
        (this.next = null),
        (this.container = null),
        (this.isDom = !1));
    }
    attach() {
      this.instance.on(["refresh", "change"], this.onRefresh);
    }
    detach() {
      (this.instance.off(["refresh", "change"], this.onRefresh),
        this.cleanup());
    }
  }
  Object.defineProperty(PC, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
      classes: {
        container: "f-carousel__nav",
        button: "f-button",
        isNext: "is-next",
        isPrev: "is-prev",
      },
      nextTpl:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
      prevTpl:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>',
    },
  });
  class IC extends Ta {
    constructor() {
      (super(...arguments),
        Object.defineProperty(this, "selectedIndex", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "target", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "nav", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }));
    }
    addAsTargetFor(e) {
      ((this.target = this.instance), (this.nav = e), this.attachEvents());
    }
    addAsNavFor(e) {
      ((this.nav = this.instance), (this.target = e), this.attachEvents());
    }
    attachEvents() {
      const { nav: e, target: n } = this;
      e &&
        n &&
        ((e.options.initialSlide = n.options.initialPage),
        e.state === Wn.Ready
          ? this.onNavReady(e)
          : e.on("ready", this.onNavReady),
        n.state === Wn.Ready
          ? this.onTargetReady(n)
          : n.on("ready", this.onTargetReady));
    }
    onNavReady(e) {
      (e.on("createSlide", this.onNavCreateSlide),
        e.on("Panzoom.click", this.onNavClick),
        e.on("Panzoom.touchEnd", this.onNavTouch),
        this.onTargetChange());
    }
    onTargetReady(e) {
      (e.on("change", this.onTargetChange),
        e.on("Panzoom.refresh", this.onTargetChange),
        this.onTargetChange());
    }
    onNavClick(e, n, i) {
      this.onNavTouch(e, e.panzoom, i);
    }
    onNavTouch(e, n, i) {
      var a, l;
      if (Math.abs(n.dragOffset.x) > 3 || Math.abs(n.dragOffset.y) > 3) return;
      const u = i.target,
        { nav: d, target: m } = this;
      if (!d || !m || !u) return;
      const g = u.closest("[data-index]");
      if ((i.stopPropagation(), i.preventDefault(), !g)) return;
      const v = parseInt(g.dataset.index || "", 10) || 0,
        y = m.getPageForSlide(v),
        w = d.getPageForSlide(v);
      (d.slideTo(w),
        m.slideTo(y, {
          friction:
            ((l =
              (a = this.nav) === null || a === void 0 ? void 0 : a.plugins) ===
              null || l === void 0
              ? void 0
              : l.Sync.option("friction")) || 0,
        }),
        this.markSelectedSlide(v));
    }
    onNavCreateSlide(e, n) {
      n.index === this.selectedIndex && this.markSelectedSlide(n.index);
    }
    onTargetChange() {
      var e, n;
      const { target: i, nav: a } = this;
      if (!i || !a || a.state !== Wn.Ready || i.state !== Wn.Ready) return;
      const l =
          (n =
            (e = i.pages[i.page]) === null || e === void 0
              ? void 0
              : e.slides[0]) === null || n === void 0
            ? void 0
            : n.index,
        u = a.getPageForSlide(l);
      (this.markSelectedSlide(l),
        a.slideTo(
          u,
          a.prevPage === null && i.prevPage === null ? { friction: 0 } : void 0,
        ));
    }
    markSelectedSlide(e) {
      const n = this.nav;
      n &&
        n.state === Wn.Ready &&
        ((this.selectedIndex = e),
        [...n.slides].map((i) => {
          i.el &&
            i.el.classList[i.index === e ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
      const e = this;
      let n = e.options.target,
        i = e.options.nav;
      n ? e.addAsNavFor(n) : i && e.addAsTargetFor(i);
    }
    detach() {
      const e = this,
        n = e.nav,
        i = e.target;
      (n &&
        (n.off("ready", e.onNavReady),
        n.off("createSlide", e.onNavCreateSlide),
        n.off("Panzoom.click", e.onNavClick),
        n.off("Panzoom.touchEnd", e.onNavTouch)),
        (e.nav = null),
        i &&
          (i.off("ready", e.onTargetReady),
          i.off("refresh", e.onTargetChange),
          i.off("change", e.onTargetChange)),
        (e.target = null));
    }
  }
  Object.defineProperty(IC, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: { friction: 0.35 },
  });
  const T4 = { Navigation: PC, Dots: zC, Sync: IC },
    L0 = "animationend",
    qT = "isSelected",
    D0 = "slide";
  class Nf extends Dw {
    get axis() {
      return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
      return this.state === Wn.Ready;
    }
    get isInfinite() {
      let e = !1;
      const { contentDim: n, viewportDim: i, pages: a, slides: l } = this,
        u = l[0];
      return (
        a.length >= 2 && u && n + u.dim >= i && (e = this.option("infinite")),
        e
      );
    }
    get isRTL() {
      return this.option("direction") === "rtl";
    }
    get isHorizontal() {
      return this.option("axis") === "x";
    }
    constructor(e, n = {}, i = {}) {
      if (
        (super(),
        Object.defineProperty(this, "bp", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: "",
        }),
        Object.defineProperty(this, "lp", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "userOptions", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {},
        }),
        Object.defineProperty(this, "userPlugins", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {},
        }),
        Object.defineProperty(this, "state", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: Wn.Init,
        }),
        Object.defineProperty(this, "page", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "prevPage", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "container", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Object.defineProperty(this, "viewport", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "track", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "slides", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: [],
        }),
        Object.defineProperty(this, "pages", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: [],
        }),
        Object.defineProperty(this, "panzoom", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "inTransition", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: new Set(),
        }),
        Object.defineProperty(this, "contentDim", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "viewportDim", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        typeof e == "string" && (e = document.querySelector(e)),
        !e || !Hs(e))
      )
        throw new Error("No Element found");
      ((this.container = e),
        (this.slideNext = BT(this.slideNext.bind(this), 150)),
        (this.slidePrev = BT(this.slidePrev.bind(this), 150)),
        (this.userOptions = n),
        (this.userPlugins = i),
        queueMicrotask(() => {
          this.processOptions();
        }));
    }
    processOptions() {
      var e, n;
      const i = Ys({}, Nf.defaults, this.userOptions);
      let a = "";
      const l = i.breakpoints;
      if (l && Q_(l))
        for (const [u, d] of Object.entries(l))
          window.matchMedia(u).matches && Q_(d) && ((a += u), Ys(i, d));
      (a === this.bp && this.state !== Wn.Init) ||
        ((this.bp = a),
        this.state === Wn.Ready &&
          (i.initialSlide =
            ((n =
              (e = this.pages[this.page]) === null || e === void 0
                ? void 0
                : e.slides[0]) === null || n === void 0
              ? void 0
              : n.index) || 0),
        this.state !== Wn.Init && this.destroy(),
        super.setOptions(i),
        this.option("enabled") === !1
          ? this.attachEvents()
          : setTimeout(() => {
              this.init();
            }, 0));
    }
    init() {
      ((this.state = Wn.Init),
        this.emit("init"),
        this.attachPlugins(
          Object.assign(Object.assign({}, Nf.Plugins), this.userPlugins),
        ),
        this.emit("attachPlugins"),
        this.initLayout(),
        this.initSlides(),
        this.updateMetrics(),
        this.setInitialPosition(),
        this.initPanzoom(),
        this.attachEvents(),
        (this.state = Wn.Ready),
        this.emit("ready"));
    }
    initLayout() {
      const { container: e } = this,
        n = this.option("classes");
      (Ye(e, this.cn("container")),
        pl(e, n.isLTR, !this.isRTL),
        pl(e, n.isRTL, this.isRTL),
        pl(e, n.isVertical, !this.isHorizontal),
        pl(e, n.isHorizontal, this.isHorizontal));
      let i = this.option("viewport") || e.querySelector(`.${n.viewport}`);
      (i ||
        ((i = document.createElement("div")),
        Ye(i, n.viewport),
        i.append(...HT(e, `.${n.slide}`)),
        e.prepend(i)),
        i.addEventListener("scroll", this.onScroll));
      let a = this.option("track") || e.querySelector(`.${n.track}`);
      (a ||
        ((a = document.createElement("div")),
        Ye(a, n.track),
        a.append(...Array.from(i.childNodes))),
        a.setAttribute("aria-live", "polite"),
        i.contains(a) || i.prepend(a),
        (this.viewport = i),
        (this.track = a),
        this.emit("initLayout"));
    }
    initSlides() {
      const { track: e } = this;
      if (!e) return;
      const n = [...this.slides],
        i = [];
      [...HT(e, `.${this.cn(D0)}`)].forEach((a) => {
        if (Hs(a)) {
          const l = Yx({ el: a, isDom: !0, index: this.slides.length });
          i.push(l);
        }
      });
      for (let a of [...(this.option("slides", []) || []), ...n]) i.push(Yx(a));
      this.slides = i;
      for (let a = 0; a < this.slides.length; a++) this.slides[a].index = a;
      for (const a of i)
        (this.emit("beforeInitSlide", a, a.index),
          this.emit("initSlide", a, a.index));
      this.emit("initSlides");
    }
    setInitialPage() {
      const e = this.option("initialSlide");
      this.page =
        typeof e == "number"
          ? this.getPageForSlide(e)
          : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
      const { track: e, pages: n, isHorizontal: i } = this;
      if (!e || !n.length) return;
      let a = this.page;
      n[a] || (this.page = a = 0);
      const l = (n[a].pos || 0) * (this.isRTL && i ? 1 : -1),
        u = i ? `${l}px` : "0",
        d = i ? "0" : `${l}px`;
      ((e.style.transform = `translate3d(${u}, ${d}, 0) scale(1)`),
        this.option("adaptiveHeight") && this.setViewportHeight());
    }
    initPanzoom() {
      this.panzoom && (this.panzoom.destroy(), (this.panzoom = null));
      const e = this.option("Panzoom") || {};
      ((this.panzoom = new Pf(
        this.viewport,
        Ys(
          {},
          {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (n) => !(this.pages.length < 2 && !n.options.infinite),
            bounds: () => this.getBounds(),
            maxVelocity: (n) =>
              Math.abs(n.target[this.axis] - n.current[this.axis]) <
              2 * this.viewportDim
                ? 100
                : 0,
          },
          e,
        ),
      )),
        this.panzoom.on("*", (n, i, ...a) => {
          this.emit(`Panzoom.${i}`, n, ...a);
        }),
        this.panzoom.on("decel", this.onDecel),
        this.panzoom.on("refresh", this.onRefresh),
        this.panzoom.on("beforeTransform", this.onBeforeTransform),
        this.panzoom.on("endAnimation", this.onEndAnimation));
    }
    attachEvents() {
      const e = this.container;
      (e &&
        (e.addEventListener("click", this.onClick, {
          passive: !1,
          capture: !1,
        }),
        e.addEventListener("slideTo", this.onSlideTo)),
        window.addEventListener("resize", this.onResize));
    }
    createPages() {
      let e = [];
      const { contentDim: n, viewportDim: i } = this;
      let a = this.option("slidesPerPage");
      a =
        (a === "auto" || n <= i) && this.option("fill") !== !1
          ? 1 / 0
          : parseFloat(a + "");
      let l = 0,
        u = 0,
        d = 0;
      for (const m of this.slides)
        ((!e.length || u + m.dim - i > 0.05 || d >= a) &&
          (e.push(w4()), (l = e.length - 1), (u = 0), (d = 0)),
          e[l].slides.push(m),
          (u += m.dim + m.gap),
          d++);
      return e;
    }
    processPages() {
      const e = this.pages,
        { contentDim: n, viewportDim: i, isInfinite: a } = this,
        l = this.option("center"),
        u = this.option("fill"),
        d = u && l && n > i && !a;
      if (
        (e.forEach((v, y) => {
          var w;
          ((v.index = y),
            (v.pos =
              ((w = v.slides[0]) === null || w === void 0 ? void 0 : w.pos) ||
              0),
            (v.dim = 0));
          for (const [S, T] of v.slides.entries())
            ((v.dim += T.dim), S < v.slides.length - 1 && (v.dim += T.gap));
          d && v.pos + 0.5 * v.dim < 0.5 * i
            ? (v.pos = 0)
            : d && v.pos + 0.5 * v.dim >= n - 0.5 * i
              ? (v.pos = n - i)
              : l && (v.pos += -0.5 * (i - v.dim));
        }),
        e.forEach((v) => {
          (u &&
            !a &&
            n > i &&
            ((v.pos = Math.max(v.pos, 0)), (v.pos = Math.min(v.pos, n - i))),
            (v.pos = Ne(v.pos, 1e3)),
            (v.dim = Ne(v.dim, 1e3)),
            Math.abs(v.pos) <= 0.1 && (v.pos = 0));
        }),
        a)
      )
        return e;
      const m = [];
      let g;
      return (
        e.forEach((v) => {
          const y = Object.assign({}, v);
          g && y.pos === g.pos
            ? ((g.dim += y.dim), (g.slides = [...g.slides, ...y.slides]))
            : ((y.index = m.length), (g = y), m.push(y));
        }),
        m
      );
    }
    getPageFromIndex(e = 0) {
      const n = this.pages.length;
      let i;
      return (
        (e = parseInt((e || 0).toString()) || 0),
        (i = this.isInfinite
          ? ((e % n) + n) % n
          : Math.max(Math.min(e, n - 1), 0)),
        i
      );
    }
    getSlideMetrics(e) {
      var n, i;
      const a = this.isHorizontal ? "width" : "height";
      let l = 0,
        u = 0,
        d = e.el;
      const m = !(!d || d.parentNode);
      if (
        (d
          ? (l = parseFloat(d.dataset[a] || "") || 0)
          : ((d = document.createElement("div")),
            (d.style.visibility = "hidden"),
            (this.track || document.body).prepend(d)),
        Ye(d, this.cn(D0) + " " + e.class + " " + e.customClass),
        l)
      )
        ((d.style[a] = `${l}px`),
          (d.style[a === "width" ? "height" : "width"] = ""));
      else {
        (m && (this.track || document.body).prepend(d),
          (l =
            d.getBoundingClientRect()[a] *
            Math.max(
              1,
              ((n = window.visualViewport) === null || n === void 0
                ? void 0
                : n.scale) || 1,
            )));
        let v = d[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
        v - 1 > l && (l = v);
      }
      const g = getComputedStyle(d);
      return (
        g.boxSizing === "content-box" &&
          (this.isHorizontal
            ? ((l += parseFloat(g.paddingLeft) || 0),
              (l += parseFloat(g.paddingRight) || 0))
            : ((l += parseFloat(g.paddingTop) || 0),
              (l += parseFloat(g.paddingBottom) || 0))),
        (u =
          parseFloat(g[this.isHorizontal ? "marginRight" : "marginBottom"]) ||
          0),
        m
          ? (i = d.parentElement) === null || i === void 0 || i.removeChild(d)
          : e.el || d.remove(),
        { dim: Ne(l, 1e3), gap: Ne(u, 1e3) }
      );
    }
    getBounds() {
      const { isInfinite: e, isRTL: n, isHorizontal: i, pages: a } = this;
      let l = { min: 0, max: 0 };
      if (e) l = { min: -1 / 0, max: 1 / 0 };
      else if (a.length) {
        const u = a[0].pos,
          d = a[a.length - 1].pos;
        l = n && i ? { min: u, max: d } : { min: -1 * d, max: -1 * u };
      }
      return { x: i ? l : { min: 0, max: 0 }, y: i ? { min: 0, max: 0 } : l };
    }
    repositionSlides() {
      let e,
        {
          isHorizontal: n,
          isRTL: i,
          isInfinite: a,
          viewport: l,
          viewportDim: u,
          contentDim: d,
          page: m,
          pages: g,
          slides: v,
          panzoom: y,
        } = this,
        w = 0,
        S = 0,
        T = 0,
        E = 0;
      (y ? (E = -1 * y.current[this.axis]) : g[m] && (E = g[m].pos || 0),
        (e = n ? (i ? "right" : "left") : "top"),
        i && n && (E *= -1));
      for (const N of v) {
        const R = N.el;
        R
          ? (e === "top"
              ? ((R.style.right = ""), (R.style.left = ""))
              : (R.style.top = ""),
            N.index !== w
              ? (R.style[e] = S === 0 ? "" : `${Ne(S, 1e3)}px`)
              : (R.style[e] = ""),
            (T += N.dim + N.gap),
            w++)
          : (S += N.dim + N.gap);
      }
      if (a && T && l) {
        let N = getComputedStyle(l),
          R = "padding",
          P = n ? "Right" : "Bottom",
          G = parseFloat(N[R + (n ? "Left" : "Top")]);
        ((E -= G), (u += G), (u += parseFloat(N[R + P])));
        for (const Y of v)
          Y.el &&
            (Ne(Y.pos) < Ne(u) &&
              Ne(Y.pos + Y.dim + Y.gap) < Ne(E) &&
              Ne(E) > Ne(d - u) &&
              (Y.el.style[e] = `${Ne(S + T, 1e3)}px`),
            Ne(Y.pos + Y.gap) >= Ne(d - u) &&
              Ne(Y.pos) > Ne(E + u) &&
              Ne(E) < Ne(u) &&
              (Y.el.style[e] = `-${Ne(T, 1e3)}px`));
      }
      let j,
        O,
        M = [...this.inTransition];
      if ((M.length > 1 && ((j = g[M[0]]), (O = g[M[1]])), j && O)) {
        let N = 0;
        for (const R of v)
          R.el
            ? this.inTransition.has(R.index) &&
              j.slides.indexOf(R) < 0 &&
              (R.el.style[e] = `${Ne(N + (j.pos - O.pos), 1e3)}px`)
            : (N += R.dim + R.gap);
      }
    }
    createSlideEl(e) {
      const { track: n, slides: i } = this;
      if (!n || !e || (e.el && e.el.parentNode)) return;
      const a = e.el || document.createElement("div");
      (Ye(a, this.cn(D0)), Ye(a, e.class), Ye(a, e.customClass));
      const l = e.html;
      l &&
        (l instanceof HTMLElement
          ? a.appendChild(l)
          : (a.innerHTML = e.html + ""));
      const u = [];
      i.forEach((v, y) => {
        v.el && u.push(y);
      });
      const d = e.index;
      let m = null;
      u.length &&
        (m =
          i[u.reduce((v, y) => (Math.abs(y - d) < Math.abs(v - d) ? y : v))]);
      const g =
        m && m.el && m.el.parentNode
          ? m.index < e.index
            ? m.el.nextSibling
            : m.el
          : null;
      (n.insertBefore(a, n.contains(g) ? g : null),
        (e.el = a),
        this.emit("createSlide", e));
    }
    removeSlideEl(e, n = !1) {
      const i = e == null ? void 0 : e.el;
      if (!i || !i.parentNode) return;
      const a = this.cn(qT);
      if (
        (i.classList.contains(a) && ($t(i, a), this.emit("unselectSlide", e)),
        e.isDom && !n)
      )
        return (
          i.removeAttribute("aria-hidden"),
          i.removeAttribute("data-index"),
          void (i.style.left = "")
        );
      this.emit("removeSlide", e);
      const l = new CustomEvent(L0);
      (i.dispatchEvent(l), e.el && (e.el.remove(), (e.el = null)));
    }
    transitionTo(e = 0, n = this.option("transition")) {
      var i, a, l, u;
      if (!n) return !1;
      const d = this.page,
        { pages: m, panzoom: g } = this;
      e = parseInt((e || 0).toString()) || 0;
      const v = this.getPageFromIndex(e);
      if (
        !g ||
        !m[v] ||
        m.length < 2 ||
        Math.abs(
          (((a = (i = m[d]) === null || i === void 0 ? void 0 : i.slides[0]) ===
            null || a === void 0
            ? void 0
            : a.dim) || 0) - this.viewportDim,
        ) > 1
      )
        return !1;
      let y = e > d ? 1 : -1;
      this.isInfinite &&
        (d === 0 && e === m.length - 1 && (y = -1),
        d === m.length - 1 && e === 0 && (y = 1));
      const w = m[v].pos * (this.isRTL ? 1 : -1);
      if (d === v && Math.abs(w - g.target[this.axis]) < 1) return !1;
      this.clearTransitions();
      const S = g.isResting;
      Ye(this.container, this.cn("inTransition"));
      const T =
          ((l = m[d]) === null || l === void 0 ? void 0 : l.slides[0]) || null,
        E =
          ((u = m[v]) === null || u === void 0 ? void 0 : u.slides[0]) || null;
      (this.inTransition.add(E.index), this.createSlideEl(E));
      let j = T.el,
        O = E.el;
      S || n === D0 || ((n = "fadeFast"), (j = null));
      const M = this.isRTL ? "next" : "prev",
        N = this.isRTL ? "prev" : "next";
      return (
        j &&
          (this.inTransition.add(T.index),
          (T.transition = n),
          j.addEventListener(L0, this.onAnimationEnd),
          j.classList.add(`f-${n}Out`, `to-${y > 0 ? N : M}`)),
        O &&
          ((E.transition = n),
          O.addEventListener(L0, this.onAnimationEnd),
          O.classList.add(`f-${n}In`, `from-${y > 0 ? M : N}`)),
        (g.current[this.axis] = w),
        (g.target[this.axis] = w),
        g.requestTick(),
        this.onChange(v),
        !0
      );
    }
    manageSlideVisiblity() {
      const e = new Set(),
        n = new Set(),
        i = this.getVisibleSlides(
          parseFloat(this.option("preload", 0) + "") || 0,
        );
      for (const a of this.slides) i.has(a) ? e.add(a) : n.add(a);
      for (const a of this.inTransition) e.add(this.slides[a]);
      for (const a of e) (this.createSlideEl(a), this.lazyLoadSlide(a));
      for (const a of n) e.has(a) || this.removeSlideEl(a);
      (this.markSelectedSlides(), this.repositionSlides());
    }
    markSelectedSlides() {
      if (!this.pages[this.page] || !this.pages[this.page].slides) return;
      const e = "aria-hidden";
      let n = this.cn(qT);
      if (n)
        for (const i of this.slides) {
          const a = i.el;
          a &&
            ((a.dataset.index = `${i.index}`),
            a.classList.contains("f-thumbs__slide")
              ? this.getVisibleSlides(0).has(i)
                ? a.removeAttribute(e)
                : a.setAttribute(e, "true")
              : this.pages[this.page].slides.includes(i)
                ? (a.classList.contains(n) ||
                    (Ye(a, n), this.emit("selectSlide", i)),
                  a.removeAttribute(e))
                : (a.classList.contains(n) &&
                    ($t(a, n), this.emit("unselectSlide", i)),
                  a.setAttribute(e, "true")));
        }
    }
    flipInfiniteTrack() {
      const {
          axis: e,
          isHorizontal: n,
          isInfinite: i,
          isRTL: a,
          viewportDim: l,
          contentDim: u,
        } = this,
        d = this.panzoom;
      if (!d || !i) return;
      let m = d.current[e],
        g = d.target[e] - m,
        v = 0,
        y = 0.5 * l;
      (a && n
        ? (m < -y && ((v = -1), (m += u)), m > u - y && ((v = 1), (m -= u)))
        : (m > y && ((v = 1), (m -= u)), m < -u + y && ((v = -1), (m += u))),
        v && ((d.current[e] = m), (d.target[e] = m + g)));
    }
    lazyLoadImg(e, n) {
      const i = this,
        a = "f-fadeIn",
        l = "is-preloading";
      let u = !1,
        d = null;
      const m = () => {
        u ||
          ((u = !0),
          d && (d.remove(), (d = null)),
          $t(n, l),
          n.complete &&
            (Ye(n, a),
            setTimeout(() => {
              $t(n, a);
            }, 350)),
          this.option("adaptiveHeight") &&
            e.el &&
            this.pages[this.page].slides.indexOf(e) > -1 &&
            (i.updateMetrics(), i.setViewportHeight()),
          this.emit("load", e));
      };
      (Ye(n, l),
        (n.src = n.dataset.lazySrcset || n.dataset.lazySrc || ""),
        delete n.dataset.lazySrc,
        delete n.dataset.lazySrcset,
        n.addEventListener("error", () => {
          m();
        }),
        n.addEventListener("load", () => {
          m();
        }),
        setTimeout(() => {
          const g = n.parentNode;
          g &&
            e.el &&
            (n.complete ? m() : u || ((d = hl(kw)), g.insertBefore(d, n)));
        }, 300));
    }
    lazyLoadSlide(e) {
      const n = e && e.el;
      if (!n) return;
      const i = new Set();
      let a = Array.from(
        n.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"),
      );
      (n.dataset.lazySrc && a.push(n),
        a.map((l) => {
          l instanceof HTMLImageElement
            ? i.add(l)
            : l instanceof HTMLElement &&
              l.dataset.lazySrc &&
              ((l.style.backgroundImage = `url('${l.dataset.lazySrc}')`),
              delete l.dataset.lazySrc);
        }));
      for (const l of i) this.lazyLoadImg(e, l);
    }
    onAnimationEnd(e) {
      var n;
      const i = e.target,
        a = i ? parseInt(i.dataset.index || "", 10) || 0 : -1,
        l = this.slides[a],
        u = e.animationName;
      if (!i || !l || !u) return;
      const d = !!this.inTransition.has(a) && l.transition;
      (d &&
        u.substring(0, d.length + 2) === `f-${d}` &&
        this.inTransition.delete(a),
        this.inTransition.size || this.clearTransitions(),
        a === this.page &&
          !((n = this.panzoom) === null || n === void 0) &&
          n.isResting &&
          this.emit("settle"));
    }
    onDecel(e, n = 0, i = 0, a = 0, l = 0) {
      if (this.option("dragFree")) return void this.setPageFromPosition();
      const { isRTL: u, isHorizontal: d, axis: m, pages: g } = this,
        v = g.length,
        y = Math.abs(Math.atan2(i, n) / (Math.PI / 180));
      let w = 0;
      if (((w = y > 45 && y < 135 ? (d ? 0 : i) : d ? n : 0), !v)) return;
      let S = this.page,
        T = u && d ? 1 : -1;
      const E = e.current[m] * T;
      let { pageIndex: j } = this.getPageFromPosition(E);
      (Math.abs(w) > 5
        ? (g[S].dim <
            document.documentElement[
              "client" + (this.isHorizontal ? "Width" : "Height")
            ] -
              1 && (S = j),
          (S = u && d ? (w < 0 ? S - 1 : S + 1) : w < 0 ? S + 1 : S - 1))
        : (S = a === 0 && l === 0 ? S : j),
        this.slideTo(S, {
          transition: !1,
          friction: e.option("decelFriction"),
        }));
    }
    onClick(e) {
      const n = e.target,
        i = n && Hs(n) ? n.dataset : null;
      let a, l;
      (i &&
        (i.carouselPage !== void 0
          ? ((l = "slideTo"), (a = i.carouselPage))
          : i.carouselNext !== void 0
            ? (l = "slideNext")
            : i.carouselPrev !== void 0 && (l = "slidePrev")),
        l
          ? (e.preventDefault(),
            e.stopPropagation(),
            n && !n.hasAttribute("disabled") && this[l](a))
          : this.emit("click", e));
    }
    onSlideTo(e) {
      const n = e.detail || 0;
      this.slideTo(this.getPageForSlide(n), { friction: 0 });
    }
    onChange(e, n = 0) {
      const i = this.page;
      ((this.prevPage = i),
        (this.page = e),
        this.option("adaptiveHeight") && this.setViewportHeight(),
        e !== i && (this.markSelectedSlides(), this.emit("change", e, i, n)));
    }
    onRefresh() {
      let e = this.contentDim,
        n = this.viewportDim;
      (this.updateMetrics(),
        (this.contentDim === e && this.viewportDim === n) ||
          this.slideTo(this.page, { friction: 0, transition: !1 }));
    }
    onScroll() {
      var e;
      (e = this.viewport) === null || e === void 0 || e.scroll(0, 0);
    }
    onResize() {
      this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(e) {
      (this.lp !== e.current[this.axis] &&
        (this.flipInfiniteTrack(), this.manageSlideVisiblity()),
        (this.lp = e.current.e));
    }
    onEndAnimation() {
      this.inTransition.size || this.emit("settle");
    }
    reInit(e = null, n = null) {
      (this.destroy(),
        (this.state = Wn.Init),
        (this.prevPage = null),
        (this.userOptions = e || this.userOptions),
        (this.userPlugins = n || this.userPlugins),
        this.processOptions());
    }
    slideTo(
      e = 0,
      {
        friction: n = this.option("friction"),
        transition: i = this.option("transition"),
      } = {},
    ) {
      if (this.state === Wn.Destroy) return;
      e = parseInt((e || 0).toString()) || 0;
      const a = this.getPageFromIndex(e),
        { axis: l, isHorizontal: u, isRTL: d, pages: m, panzoom: g } = this,
        v = m.length,
        y = d && u ? 1 : -1;
      if (!g || !v) return;
      if (this.page !== a) {
        const S = new Event("beforeChange", { bubbles: !0, cancelable: !0 });
        if ((this.emit("beforeChange", S, e), S.defaultPrevented)) return;
      }
      if (this.transitionTo(e, i)) return;
      let w = m[a].pos;
      if (this.isInfinite) {
        const S = this.contentDim,
          T = g.target[l] * y;
        v === 2
          ? (w += S * Math.floor(parseFloat(e + "") / 2))
          : (w = [w, w - S, w + S].reduce(function (E, j) {
              return Math.abs(j - T) < Math.abs(E - T) ? j : E;
            }));
      }
      ((w *= y),
        Math.abs(g.target[l] - w) < 1 ||
          (g.panTo({ x: u ? w : 0, y: u ? 0 : w, friction: n }),
          this.onChange(a)));
    }
    slideToClosest(e) {
      if (this.panzoom) {
        const { pageIndex: n } = this.getPageFromPosition();
        this.slideTo(n, e);
      }
    }
    slideNext() {
      this.slideTo(this.page + 1);
    }
    slidePrev() {
      this.slideTo(this.page - 1);
    }
    clearTransitions() {
      (this.inTransition.clear(), $t(this.container, this.cn("inTransition")));
      const e = ["to-prev", "to-next", "from-prev", "from-next"];
      for (const n of this.slides) {
        const i = n.el;
        if (i) {
          (i.removeEventListener(L0, this.onAnimationEnd),
            i.classList.remove(...e));
          const a = n.transition;
          a && i.classList.remove(`f-${a}Out`, `f-${a}In`);
        }
      }
      this.manageSlideVisiblity();
    }
    addSlide(e, n) {
      var i, a, l, u;
      const d = this.panzoom,
        m =
          ((i = this.pages[this.page]) === null || i === void 0
            ? void 0
            : i.pos) || 0,
        g =
          ((a = this.pages[this.page]) === null || a === void 0
            ? void 0
            : a.dim) || 0,
        v = this.contentDim < this.viewportDim;
      let y = Array.isArray(n) ? n : [n];
      const w = [];
      for (const S of y) w.push(Yx(S));
      this.slides.splice(e, 0, ...w);
      for (let S = 0; S < this.slides.length; S++) this.slides[S].index = S;
      for (const S of w) this.emit("beforeInitSlide", S, S.index);
      if (
        (this.page >= e && (this.page += w.length), this.updateMetrics(), d)
      ) {
        const S =
            ((l = this.pages[this.page]) === null || l === void 0
              ? void 0
              : l.pos) || 0,
          T =
            ((u = this.pages[this.page]) === null || u === void 0
              ? void 0
              : u.dim) || 0,
          E = this.pages.length || 1,
          j = this.isRTL ? g - T : T - g,
          O = this.isRTL ? m - S : S - m;
        v && E === 1
          ? (e <= this.page &&
              ((d.current[this.axis] -= j), (d.target[this.axis] -= j)),
            d.panTo({ [this.isHorizontal ? "x" : "y"]: -1 * S }))
          : O &&
            e <= this.page &&
            ((d.target[this.axis] -= O),
            (d.current[this.axis] -= O),
            d.requestTick());
      }
      for (const S of w) this.emit("initSlide", S, S.index);
    }
    prependSlide(e) {
      this.addSlide(0, e);
    }
    appendSlide(e) {
      this.addSlide(this.slides.length, e);
    }
    removeSlide(e) {
      const n = this.slides.length;
      e = ((e % n) + n) % n;
      const i = this.slides[e];
      if (i) {
        (this.removeSlideEl(i, !0), this.slides.splice(e, 1));
        for (let a = 0; a < this.slides.length; a++) this.slides[a].index = a;
        (this.updateMetrics(),
          this.slideTo(this.page, { friction: 0, transition: !1 }),
          this.emit("destroySlide", i));
      }
    }
    updateMetrics() {
      const {
        panzoom: e,
        viewport: n,
        track: i,
        slides: a,
        isHorizontal: l,
        isInfinite: u,
      } = this;
      if (!i) return;
      const d = l ? "width" : "height",
        m = l ? "offsetWidth" : "offsetHeight";
      if (n) {
        let y = Math.max(n[m], Ne(n.getBoundingClientRect()[d], 1e3)),
          w = getComputedStyle(n),
          S = "padding",
          T = l ? "Right" : "Bottom";
        ((y -= parseFloat(w[S + (l ? "Left" : "Top")]) + parseFloat(w[S + T])),
          (this.viewportDim = y));
      }
      let g,
        v = 0;
      for (const [y, w] of a.entries()) {
        let S = 0,
          T = 0;
        (!w.el && g
          ? ((S = g.dim), (T = g.gap))
          : (({ dim: S, gap: T } = this.getSlideMetrics(w)), (g = w)),
          (S = Ne(S, 1e3)),
          (T = Ne(T, 1e3)),
          (w.dim = S),
          (w.gap = T),
          (w.pos = v),
          (v += S),
          (u || y < a.length - 1) && (v += T));
      }
      ((v = Ne(v, 1e3)),
        (this.contentDim = v),
        e &&
          ((e.contentRect[d] = v),
          (e.contentRect[l ? "fullWidth" : "fullHeight"] = v)),
        (this.pages = this.createPages()),
        (this.pages = this.processPages()),
        this.state === Wn.Init && this.setInitialPage(),
        (this.page = Math.max(0, Math.min(this.page, this.pages.length - 1))),
        this.manageSlideVisiblity(),
        this.emit("refresh"));
    }
    getProgress(e, n = !1, i = !1) {
      e === void 0 && (e = this.page);
      const a = this,
        l = a.panzoom,
        u = a.contentDim,
        d = a.pages[e] || 0;
      if (!d || !l) return e > this.page ? -1 : 1;
      let m = -1 * l.current.e,
        g = Ne((m - d.pos) / (1 * d.dim), 1e3),
        v = g,
        y = g;
      this.isInfinite &&
        i !== !0 &&
        ((v = Ne((m - d.pos + u) / (1 * d.dim), 1e3)),
        (y = Ne((m - d.pos - u) / (1 * d.dim), 1e3)));
      let w = [g, v, y].reduce(function (S, T) {
        return Math.abs(T) < Math.abs(S) ? T : S;
      });
      return n ? w : w > 1 ? 1 : w < -1 ? -1 : w;
    }
    setViewportHeight() {
      const { page: e, pages: n, viewport: i, isHorizontal: a } = this;
      if (!i || !n[e]) return;
      let l = 0;
      (a &&
        this.track &&
        ((this.track.style.height = "auto"),
        n[e].slides.forEach((u) => {
          u.el && (l = Math.max(l, u.el.offsetHeight));
        })),
        (i.style.height = l ? `${l}px` : ""));
    }
    getPageForSlide(e) {
      for (const n of this.pages)
        for (const i of n.slides) if (i.index === e) return n.index;
      return -1;
    }
    getVisibleSlides(e = 0) {
      var n;
      const i = new Set();
      let {
        panzoom: a,
        contentDim: l,
        viewportDim: u,
        pages: d,
        page: m,
      } = this;
      if (u) {
        l =
          l +
            ((n = this.slides[this.slides.length - 1]) === null || n === void 0
              ? void 0
              : n.gap) || 0;
        let g = 0;
        ((g =
          a && a.state !== Zt.Init && a.state !== Zt.Destroy
            ? -1 * a.current[this.axis]
            : (d[m] && d[m].pos) || 0),
          this.isInfinite && (g -= Math.floor(g / l) * l),
          this.isRTL && this.isHorizontal && (g *= -1));
        const v = g - u * e,
          y = g + u * (e + 1),
          w = this.isInfinite ? [-1, 0, 1] : [0];
        for (const S of this.slides)
          for (const T of w) {
            const E = S.pos + T * l,
              j = E + S.dim + S.gap;
            E < y && j > v && i.add(S);
          }
      }
      return i;
    }
    getPageFromPosition(e) {
      const {
          viewportDim: n,
          contentDim: i,
          slides: a,
          pages: l,
          panzoom: u,
        } = this,
        d = l.length,
        m = a.length,
        g = a[0],
        v = a[m - 1],
        y = this.option("center");
      let w = 0,
        S = 0,
        T = 0,
        E =
          e === void 0
            ? -1 * ((u == null ? void 0 : u.target[this.axis]) || 0)
            : e;
      (y && (E += 0.5 * n),
        this.isInfinite
          ? (E < g.pos - 0.5 * v.gap && ((E -= i), (T = -1)),
            E > v.pos + v.dim + 0.5 * v.gap && ((E -= i), (T = 1)))
          : (E = Math.max(g.pos || 0, Math.min(E, v.pos))));
      let j = v,
        O = a.find((M) => {
          const N = M.pos - 0.5 * j.gap,
            R = M.pos + M.dim + 0.5 * M.gap;
          return ((j = M), E >= N && E < R);
        });
      return (
        O || (O = v),
        (S = this.getPageForSlide(O.index)),
        (w = S + T * d),
        { page: w, pageIndex: S }
      );
    }
    setPageFromPosition() {
      const { pageIndex: e } = this.getPageFromPosition();
      this.onChange(e);
    }
    destroy() {
      if ([Wn.Destroy].includes(this.state)) return;
      this.state = Wn.Destroy;
      const {
          container: e,
          viewport: n,
          track: i,
          slides: a,
          panzoom: l,
        } = this,
        u = this.option("classes");
      (e.removeEventListener("click", this.onClick, {
        passive: !1,
        capture: !1,
      }),
        e.removeEventListener("slideTo", this.onSlideTo),
        window.removeEventListener("resize", this.onResize),
        l && (l.destroy(), (this.panzoom = null)),
        a &&
          a.forEach((m) => {
            this.removeSlideEl(m);
          }),
        this.detachPlugins(),
        n &&
          (n.removeEventListener("scroll", this.onScroll),
          n.offsetParent &&
            i &&
            i.offsetParent &&
            n.replaceWith(...i.childNodes)));
      for (const [m, g] of Object.entries(u))
        m !== "container" && g && e.classList.remove(g);
      ((this.track = null),
        (this.viewport = null),
        (this.page = 0),
        (this.slides = []));
      const d = this.events.get("ready");
      ((this.events = new Map()), d && this.events.set("ready", d));
    }
  }
  (Object.defineProperty(Nf, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: Pf,
  }),
    Object.defineProperty(Nf, "defaults", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: _4,
    }),
    Object.defineProperty(Nf, "Plugins", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: T4,
    }));
  const UC = function (t) {
      if (!Hs(t)) return 0;
      const e = window.scrollY,
        n = window.innerHeight,
        i = e + n,
        a = t.getBoundingClientRect(),
        l = a.y + e,
        u = a.height,
        d = l + u;
      if (e > d || i < l) return 0;
      if ((e < l && i > d) || (l < e && d > i)) return 100;
      let m = u;
      (l < e && (m -= e - l), d > i && (m -= d - i));
      const g = (m / n) * 100;
      return Math.round(g);
    },
    wg = !(
      typeof window > "u" ||
      !window.document ||
      !window.document.createElement
    );
  let qx;
  const $x = [
      "a[href]",
      "area[href]",
      'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
      "select:not([disabled]):not([aria-hidden])",
      "textarea:not([disabled]):not([aria-hidden])",
      "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
      "iframe",
      "object",
      "embed",
      "video",
      "audio",
      "[contenteditable]",
      '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])',
    ].join(","),
    $T = (t) => {
      if (t && wg) {
        qx === void 0 &&
          document.createElement("div").focus({
            get preventScroll() {
              return ((qx = !0), !1);
            },
          });
        try {
          if (qx) t.focus({ preventScroll: !0 });
          else {
            const e = window.scrollY || document.body.scrollTop,
              n = window.scrollX || document.body.scrollLeft;
            (t.focus(),
              document.body.scrollTo({ top: e, left: n, behavior: "auto" }));
          }
        } catch {}
      }
    },
    FC = () => {
      const t = document;
      let e,
        n = "",
        i = "",
        a = "";
      return (
        t.fullscreenEnabled
          ? ((n = "requestFullscreen"),
            (i = "exitFullscreen"),
            (a = "fullscreenElement"))
          : t.webkitFullscreenEnabled &&
            ((n = "webkitRequestFullscreen"),
            (i = "webkitExitFullscreen"),
            (a = "webkitFullscreenElement")),
        n &&
          (e = {
            request: function (l = t.documentElement) {
              return n === "webkitRequestFullscreen"
                ? l[n](Element.ALLOW_KEYBOARD_INPUT)
                : l[n]();
            },
            exit: function () {
              return t[a] && t[i]();
            },
            isFullscreen: function () {
              return t[a];
            },
          }),
        e
      );
    },
    Z_ = {
      animated: !0,
      autoFocus: !0,
      backdropClick: "close",
      Carousel: {
        classes: {
          container: "fancybox__carousel",
          viewport: "fancybox__viewport",
          track: "fancybox__track",
          slide: "fancybox__slide",
        },
      },
      closeButton: "auto",
      closeExisting: !1,
      commonCaption: !1,
      compact: () =>
        window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
      contentClick: "toggleZoom",
      contentDblClick: !1,
      defaultType: "image",
      defaultDisplay: "flex",
      dragToClose: !0,
      Fullscreen: { autoStart: !1 },
      groupAll: !1,
      groupAttr: "data-fancybox",
      hideClass: "f-fadeOut",
      hideScrollbar: !0,
      idle: 3500,
      keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev",
      },
      l10n: Object.assign(Object.assign({}, kC), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download",
      }),
      parentEl: null,
      placeFocusBack: !0,
      showClass: "f-zoomInUp",
      startIndex: 0,
      tpl: {
        closeButton:
          '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: `<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">
    <div class="fancybox__backdrop"></div>
    <div class="fancybox__carousel"></div>
    <div class="fancybox__footer"></div>
  </div>`,
      },
      trapFocus: !0,
      wheel: "zoom",
    };
  var fi, zi;
  ((function (t) {
    ((t[(t.Init = 0)] = "Init"),
      (t[(t.Ready = 1)] = "Ready"),
      (t[(t.Closing = 2)] = "Closing"),
      (t[(t.CustomClosing = 3)] = "CustomClosing"),
      (t[(t.Destroy = 4)] = "Destroy"));
  })(fi || (fi = {})),
    (function (t) {
      ((t[(t.Loading = 0)] = "Loading"),
        (t[(t.Opening = 1)] = "Opening"),
        (t[(t.Ready = 2)] = "Ready"),
        (t[(t.Closing = 3)] = "Closing"));
    })(zi || (zi = {})));
  let GT = "",
    bg = !1,
    k0 = !1,
    pf = null;
  const BC = () => {
      let t = "",
        e = "";
      const n = At.getInstance();
      if (n) {
        const i = n.carousel,
          a = n.getSlide();
        if (i && a) {
          let l = a.slug || void 0,
            u = a.triggerEl || void 0;
          ((e = l || n.option("slug") || ""),
            !e && u && u.dataset && (e = u.dataset.fancybox || ""),
            e &&
              e !== "true" &&
              (t =
                "#" +
                e +
                (!l && i.slides.length > 1 ? "-" + (a.index + 1) : "")));
        }
      }
      return { hash: t, slug: e, index: 1 };
    },
    _b = () => {
      const t = new URL(document.URL).hash,
        e = t.slice(1).split("-"),
        n = e[e.length - 1],
        i = (n && /^\+?\d+$/.test(n) && parseInt(e.pop() || "1", 10)) || 1;
      return { hash: t, slug: e.join("-"), index: i };
    },
    HC = () => {
      const { slug: t, index: e } = _b();
      if (!t) return;
      let n = document.querySelector(`[data-slug="${t}"]`);
      if (
        (n &&
          n.dispatchEvent(
            new CustomEvent("click", { bubbles: !0, cancelable: !0 }),
          ),
        At.getInstance())
      )
        return;
      const i = document.querySelectorAll(`[data-fancybox="${t}"]`);
      i.length &&
        ((n = i[e - 1]),
        n &&
          n.dispatchEvent(
            new CustomEvent("click", { bubbles: !0, cancelable: !0 }),
          ));
    },
    YC = () => {
      if (At.defaults.Hash === !1) return;
      const t = At.getInstance();
      if ((t == null ? void 0 : t.options.Hash) === !1) return;
      const { slug: e, index: n } = _b(),
        { slug: i } = BC();
      (t && (e === i ? t.jumpTo(n - 1) : ((bg = !0), t.close())), HC());
    },
    qC = () => {
      (pf && clearTimeout(pf),
        queueMicrotask(() => {
          YC();
        }));
    },
    VT = () => {
      (window.addEventListener("hashchange", qC, !1),
        setTimeout(() => {
          YC();
        }, 500));
    };
  wg &&
    (/complete|interactive|loaded/.test(document.readyState)
      ? VT()
      : document.addEventListener("DOMContentLoaded", VT));
  const z0 = "is-zooming-in";
  class $C extends Ta {
    onCreateSlide(e, n, i) {
      const a = this.instance.optionFor(i, "src") || "";
      i.el && i.type === "image" && typeof a == "string" && this.setImage(i, a);
    }
    onRemoveSlide(e, n, i) {
      (i.panzoom && i.panzoom.destroy(),
        (i.panzoom = void 0),
        (i.imageEl = void 0));
    }
    onChange(e, n, i, a) {
      $t(this.instance.container, z0);
      for (const l of n.slides) {
        const u = l.panzoom;
        u && l.index !== i && u.reset(0.35);
      }
    }
    onClose() {
      var e;
      const n = this.instance,
        i = n.container,
        a = n.getSlide();
      if (!i || !i.parentElement || !a) return;
      const { el: l, contentEl: u, panzoom: d, thumbElSrc: m } = a;
      if (
        !l ||
        !m ||
        !u ||
        !d ||
        d.isContentLoading ||
        d.state === Zt.Init ||
        d.state === Zt.Destroy
      )
        return;
      d.updateMetrics();
      let g = this.getZoomInfo(a);
      if (!g) return;
      ((this.instance.state = fi.CustomClosing),
        i.classList.remove(z0),
        i.classList.add("is-zooming-out"),
        (u.style.backgroundImage = `url('${m}')`));
      const v = i.getBoundingClientRect();
      (((e = window.visualViewport) === null || e === void 0
        ? void 0
        : e.scale) || 1) === 1 &&
        Object.assign(i.style, {
          position: "absolute",
          top: `${i.offsetTop + window.scrollY}px`,
          left: `${i.offsetLeft + window.scrollX}px`,
          bottom: "auto",
          right: "auto",
          width: `${v.width}px`,
          height: `${v.height}px`,
          overflow: "hidden",
        });
      const { x: y, y: w, scale: S, opacity: T } = g;
      if (T) {
        const E = ((j, O, M, N) => {
          const R = O - j,
            P = N - M;
          return (G) => M + (((G - j) / R) * P || 0);
        })(d.scale, S, 1, 0);
        d.on("afterTransform", () => {
          u.style.opacity = E(d.scale) + "";
        });
      }
      (d.on("endAnimation", () => {
        n.destroy();
      }),
        (d.target.a = S),
        (d.target.b = 0),
        (d.target.c = 0),
        (d.target.d = S),
        d.panTo({
          x: y,
          y: w,
          scale: S,
          friction: T ? 0.2 : 0.33,
          ignoreBounds: !0,
        }),
        d.isResting && n.destroy());
    }
    setImage(e, n) {
      const i = this.instance;
      ((e.src = n),
        this.process(e, n).then(
          (a) => {
            const { contentEl: l, imageEl: u, thumbElSrc: d, el: m } = e;
            if (i.isClosing() || !l || !u) return;
            l.offsetHeight;
            const g = !!i.isOpeningSlide(e) && this.getZoomInfo(e);
            if (this.option("protected") && m) {
              m.addEventListener("contextmenu", (w) => {
                w.preventDefault();
              });
              const y = document.createElement("div");
              (Ye(y, "fancybox-protected"), l.appendChild(y));
            }
            if (d && g) {
              const y = a.contentRect,
                w = Math.max(y.fullWidth, y.fullHeight);
              let S = null;
              !g.opacity &&
                w > 1200 &&
                ((S = document.createElement("img")),
                Ye(S, "fancybox-ghost"),
                (S.src = d),
                l.appendChild(S));
              const T = () => {
                S &&
                  (Ye(S, "f-fadeFastOut"),
                  setTimeout(() => {
                    S && (S.remove(), (S = null));
                  }, 200));
              };
              ((v = d),
              new Promise((E, j) => {
                const O = new Image();
                ((O.onload = E), (O.onerror = j), (O.src = v));
              })).then(
                () => {
                  (i.hideLoading(e),
                    (e.state = zi.Opening),
                    this.instance.emit("reveal", e),
                    this.zoomIn(e).then(
                      () => {
                        (T(), this.instance.done(e));
                      },
                      () => {},
                    ),
                    S &&
                      setTimeout(
                        () => {
                          T();
                        },
                        w > 2500 ? 800 : 200,
                      ));
                },
                () => {
                  (i.hideLoading(e), i.revealContent(e));
                },
              );
            } else {
              const y = this.optionFor(e, "initialSize"),
                w = this.optionFor(e, "zoom"),
                S = {
                  event: i.prevMouseMoveEvent || i.options.event,
                  friction: w ? 0.12 : 0,
                };
              let T = i.optionFor(e, "showClass") || void 0,
                E = !0;
              (i.isOpeningSlide(e) &&
                (y === "full"
                  ? a.zoomToFull(S)
                  : y === "cover"
                    ? a.zoomToCover(S)
                    : y === "max"
                      ? a.zoomToMax(S)
                      : (E = !1),
                a.stop("current")),
                E && T && (T = a.isDragging ? "f-fadeIn" : ""),
                i.hideLoading(e),
                i.revealContent(e, T));
            }
            var v;
          },
          () => {
            i.setError(e, "{{IMAGE_ERROR}}");
          },
        ));
    }
    process(e, n) {
      return new Promise((i, a) => {
        var l;
        const u = this.instance,
          d = e.el;
        (u.clearContent(e), u.showLoading(e));
        let m = this.optionFor(e, "content");
        if ((typeof m == "string" && (m = hl(m)), !m || !Hs(m))) {
          if (
            ((m = document.createElement("img")), m instanceof HTMLImageElement)
          ) {
            let g = "",
              v = e.caption;
            ((g =
              typeof v == "string" && v
                ? v.replace(/<[^>]+>/gi, "").substring(0, 1e3)
                : `Image ${e.index + 1} of ${((l = u.carousel) === null || l === void 0 ? void 0 : l.pages.length) || 1}`),
              (m.src = n || ""),
              (m.alt = g),
              (m.draggable = !1),
              e.srcset && m.setAttribute("srcset", e.srcset),
              this.instance.isOpeningSlide(e) && (m.fetchPriority = "high"));
          }
          e.sizes && m.setAttribute("sizes", e.sizes);
        }
        (Ye(m, "fancybox-image"),
          (e.imageEl = m),
          u.setContent(e, m, !1),
          (e.panzoom = new Pf(
            d,
            Ys({ transformParent: !0 }, this.option("Panzoom") || {}, {
              content: m,
              width: (g, v) => u.optionFor(e, "width", "auto", v) || "auto",
              height: (g, v) => u.optionFor(e, "height", "auto", v) || "auto",
              wheel: () => {
                const g = u.option("wheel");
                return (g === "zoom" || g == "pan") && g;
              },
              click: (g, v) => {
                var y, w;
                if (
                  u.isCompact ||
                  u.isClosing() ||
                  e.index !==
                    ((y = u.getSlide()) === null || y === void 0
                      ? void 0
                      : y.index)
                )
                  return !1;
                if (v) {
                  const T = v.composedPath()[0];
                  if (
                    [
                      "A",
                      "BUTTON",
                      "TEXTAREA",
                      "OPTION",
                      "INPUT",
                      "SELECT",
                      "VIDEO",
                    ].includes(T.nodeName)
                  )
                    return !1;
                }
                let S =
                  !v ||
                  (v.target &&
                    ((w = e.contentEl) === null || w === void 0
                      ? void 0
                      : w.contains(v.target)));
                return u.option(S ? "contentClick" : "backdropClick") || !1;
              },
              dblClick: () =>
                u.isCompact ? "toggleZoom" : u.option("contentDblClick") || !1,
              spinner: !1,
              panOnlyZoomed: !0,
              wheelLimit: 1 / 0,
              on: {
                ready: (g) => {
                  i(g);
                },
                error: () => {
                  a();
                },
                destroy: () => {
                  a();
                },
              },
            }),
          )));
      });
    }
    zoomIn(e) {
      return new Promise((n, i) => {
        const a = this.instance,
          l = a.container,
          { panzoom: u, contentEl: d, el: m } = e;
        u && u.updateMetrics();
        const g = this.getZoomInfo(e);
        if (!(g && m && d && u && l)) return void i();
        const { x: v, y, scale: w, opacity: S } = g,
          T = () => {
            e.state !== zi.Closing &&
              (S &&
                (d.style.opacity =
                  Math.max(Math.min(1, 1 - (1 - u.scale) / (1 - w)), 0) + ""),
              u.scale >= 1 && u.scale > u.targetScale - 0.1 && n(u));
          },
          E = (M) => {
            ((M.scale < 0.99 || M.scale > 1.01) && !M.isDragging) ||
              ($t(l, z0),
              (d.style.opacity = ""),
              M.off("endAnimation", E),
              M.off("touchStart", E),
              M.off("afterTransform", T),
              n(M));
          };
        (u.on("endAnimation", E),
          u.on("touchStart", E),
          u.on("afterTransform", T),
          u.on(["error", "destroy"], () => {
            i();
          }),
          u.panTo({ x: v, y, scale: w, friction: 0, ignoreBounds: !0 }),
          u.stop("current"));
        const j = {
            event:
              u.panMode === "mousemove"
                ? a.prevMouseMoveEvent || a.options.event
                : void 0,
          },
          O = this.optionFor(e, "initialSize");
        (Ye(l, z0),
          a.hideLoading(e),
          O === "full"
            ? u.zoomToFull(j)
            : O === "cover"
              ? u.zoomToCover(j)
              : O === "max"
                ? u.zoomToMax(j)
                : u.reset(0.172));
      });
    }
    getZoomInfo(e) {
      const { el: n, imageEl: i, thumbEl: a, panzoom: l } = e,
        u = this.instance,
        d = u.container;
      if (
        !n ||
        !i ||
        !a ||
        !l ||
        UC(a) < 3 ||
        !this.optionFor(e, "zoom") ||
        !d ||
        u.state === fi.Destroy ||
        getComputedStyle(d).getPropertyValue("--f-images-zoom") === "0"
      )
        return !1;
      const m = window.visualViewport || null;
      if ((m ? m.scale : 1) !== 1) return !1;
      let { top: g, left: v, width: y, height: w } = a.getBoundingClientRect(),
        { top: S, left: T, fitWidth: E, fitHeight: j } = l.contentRect;
      if (!(y && w && E && j)) return !1;
      const O = l.container.getBoundingClientRect();
      ((T += O.left), (S += O.top));
      const M = -1 * (T + 0.5 * E - (v + 0.5 * y)),
        N = -1 * (S + 0.5 * j - (g + 0.5 * w)),
        R = y / E;
      let P = this.option("zoomOpacity") || !1;
      return (
        P === "auto" && (P = Math.abs(y / w - E / j) > 0.1),
        { x: M, y: N, scale: R, opacity: P }
      );
    }
    attach() {
      const e = this,
        n = e.instance;
      (n.on("Carousel.change", e.onChange),
        n.on("Carousel.createSlide", e.onCreateSlide),
        n.on("Carousel.removeSlide", e.onRemoveSlide),
        n.on("close", e.onClose));
    }
    detach() {
      const e = this,
        n = e.instance;
      (n.off("Carousel.change", e.onChange),
        n.off("Carousel.createSlide", e.onCreateSlide),
        n.off("Carousel.removeSlide", e.onRemoveSlide),
        n.off("close", e.onClose));
    }
  }
  (Object.defineProperty($C, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
      initialSize: "fit",
      Panzoom: { maxScale: 1 },
      protected: !1,
      zoom: !0,
      zoomOpacity: "auto",
    },
  }),
    typeof SuppressedError == "function" && SuppressedError);
  const Gx = "html",
    WT = "image",
    Vx = "map",
    eo = "youtube",
    cf = "vimeo",
    fg = "html5video",
    XT = (t, e = {}) => {
      const n = new URL(t),
        i = new URLSearchParams(n.search),
        a = new URLSearchParams();
      for (const [d, m] of [...i, ...Object.entries(e)]) {
        let g = m + "";
        if (d === "t") {
          let v = g.match(/((\d*)m)?(\d*)s?/);
          v &&
            a.set(
              "start",
              60 * parseInt(v[2] || "0") + parseInt(v[3] || "0") + "",
            );
        } else a.set(d, g);
      }
      let l = a + "",
        u = t.match(/#t=((.*)?\d+s)/);
      return (u && (l += `#t=${u[1]}`), l);
    },
    E4 = {
      ajax: null,
      autoSize: !0,
      iframeAttr: { allow: "autoplay; fullscreen", scrolling: "auto" },
      preload: !0,
      videoAutoplay: !0,
      videoRatio: 16 / 9,
      videoTpl: `<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">
  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn't support embedded videos.</video>`,
      videoFormat: "",
      vimeo: { byline: 1, color: "00adef", controls: 1, dnt: 1, muted: 0 },
      youtube: { controls: 1, enablejsapi: 1, nocookie: 1, rel: 0, fs: 1 },
    },
    C4 = [
      "image",
      "html",
      "ajax",
      "inline",
      "clone",
      "iframe",
      "map",
      "pdf",
      "html5video",
      "youtube",
      "vimeo",
    ];
  class GC extends Ta {
    onBeforeInitSlide(e, n, i) {
      this.processType(i);
    }
    onCreateSlide(e, n, i) {
      this.setContent(i);
    }
    onClearContent(e, n) {
      n.xhr && (n.xhr.abort(), (n.xhr = null));
      const i = n.iframeEl;
      i &&
        ((i.onload = i.onerror = null),
        (i.src = "//about:blank"),
        (n.iframeEl = null));
      const a = n.contentEl,
        l = n.placeholderEl;
      if (n.type === "inline" && a && l)
        (a.classList.remove("fancybox__content"),
          getComputedStyle(a).getPropertyValue("display") !== "none" &&
            (a.style.display = "none"),
          setTimeout(() => {
            l &&
              (a && l.parentNode && l.parentNode.insertBefore(a, l),
              l.remove());
          }, 0),
          (n.contentEl = void 0),
          (n.placeholderEl = void 0));
      else for (; n.el && n.el.firstChild; ) n.el.removeChild(n.el.firstChild);
    }
    onSelectSlide(e, n, i) {
      i.state === zi.Ready && this.playVideo();
    }
    onUnselectSlide(e, n, i) {
      var a, l;
      if (i.type === fg) {
        try {
          (l =
            (a = i.el) === null || a === void 0
              ? void 0
              : a.querySelector("video")) === null ||
            l === void 0 ||
            l.pause();
        } catch {}
        return;
      }
      let u;
      (i.type === cf
        ? (u = { method: "pause", value: "true" })
        : i.type === eo && (u = { event: "command", func: "pauseVideo" }),
        u &&
          i.iframeEl &&
          i.iframeEl.contentWindow &&
          i.iframeEl.contentWindow.postMessage(JSON.stringify(u), "*"),
        i.poller && clearTimeout(i.poller));
    }
    onDone(e, n) {
      e.isCurrentSlide(n) && !e.isClosing() && this.playVideo();
    }
    onRefresh(e, n) {
      n.slides.forEach((i) => {
        i.el && (this.resizeIframe(i), this.setAspectRatio(i));
      });
    }
    onMessage(e) {
      try {
        let n = JSON.parse(e.data);
        if (e.origin === "https://player.vimeo.com") {
          if (n.event === "ready")
            for (let i of Array.from(
              document.getElementsByClassName("fancybox__iframe"),
            ))
              i instanceof HTMLIFrameElement &&
                i.contentWindow === e.source &&
                (i.dataset.ready = "true");
        } else if (
          e.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) &&
          n.event === "onReady"
        ) {
          const i = document.getElementById(n.id);
          i && (i.dataset.ready = "true");
        }
      } catch {}
    }
    loadAjaxContent(e) {
      const n = this.instance.optionFor(e, "src") || "";
      this.instance.showLoading(e);
      const i = this.instance,
        a = new XMLHttpRequest();
      (i.showLoading(e),
        (a.onreadystatechange = function () {
          a.readyState === XMLHttpRequest.DONE &&
            i.state === fi.Ready &&
            (i.hideLoading(e),
            a.status === 200
              ? i.setContent(e, a.responseText)
              : i.setError(
                  e,
                  a.status === 404
                    ? "{{AJAX_NOT_FOUND}}"
                    : "{{AJAX_FORBIDDEN}}",
                ));
        }));
      const l = e.ajax || null;
      (a.open(l ? "POST" : "GET", n + ""),
        a.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"),
        a.setRequestHeader("X-Requested-With", "XMLHttpRequest"),
        a.send(l),
        (e.xhr = a));
    }
    setInlineContent(e) {
      let n = null;
      if (Hs(e.src)) n = e.src;
      else if (typeof e.src == "string") {
        const i = e.src.split("#", 2).pop();
        n = i ? document.getElementById(i) : null;
      }
      if (n) {
        if (e.type === "clone" || n.closest(".fancybox__slide")) {
          n = n.cloneNode(!0);
          const i = n.dataset.animationName;
          i && (n.classList.remove(i), delete n.dataset.animationName);
          let a = n.getAttribute("id");
          ((a = a ? `${a}--clone` : `clone-${this.instance.id}-${e.index}`),
            n.setAttribute("id", a));
        } else if (n.parentNode) {
          const i = document.createElement("div");
          (i.classList.add("fancybox-placeholder"),
            n.parentNode.insertBefore(i, n),
            (e.placeholderEl = i));
        }
        this.instance.setContent(e, n);
      } else this.instance.setError(e, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(e) {
      const { src: n, el: i } = e;
      if (!n || typeof n != "string" || !i) return;
      i.classList.add("is-loading");
      const a = this.instance,
        l = document.createElement("iframe");
      ((l.className = "fancybox__iframe"),
        l.setAttribute("id", `fancybox__iframe_${a.id}_${e.index}`));
      for (const [d, m] of Object.entries(
        this.optionFor(e, "iframeAttr") || {},
      ))
        l.setAttribute(d, m);
      ((l.onerror = () => {
        a.setError(e, "{{IFRAME_ERROR}}");
      }),
        (e.iframeEl = l));
      const u = this.optionFor(e, "preload");
      if (e.type !== "iframe" || u === !1)
        return (
          l.setAttribute("src", e.src + ""),
          a.setContent(e, l, !1),
          this.resizeIframe(e),
          void a.revealContent(e)
        );
      (a.showLoading(e),
        (l.onload = () => {
          if (!l.src.length) return;
          const d = l.dataset.ready !== "true";
          ((l.dataset.ready = "true"),
            this.resizeIframe(e),
            d ? a.revealContent(e) : a.hideLoading(e));
        }),
        l.setAttribute("src", n),
        a.setContent(e, l, !1));
    }
    resizeIframe(e) {
      const { type: n, iframeEl: i } = e;
      if (n === eo || n === cf) return;
      const a = i == null ? void 0 : i.parentElement;
      if (!i || !a) return;
      let l = e.autoSize;
      l === void 0 && (l = this.optionFor(e, "autoSize"));
      let u = e.width || 0,
        d = e.height || 0;
      u && d && (l = !1);
      const m = a && a.style;
      if (e.preload !== !1 && l !== !1 && m)
        try {
          const g = window.getComputedStyle(a),
            v = parseFloat(g.paddingLeft) + parseFloat(g.paddingRight),
            y = parseFloat(g.paddingTop) + parseFloat(g.paddingBottom),
            w = i.contentWindow;
          if (w) {
            const S = w.document,
              T = S.getElementsByTagName(Gx)[0],
              E = S.body;
            ((m.width = ""),
              (E.style.overflow = "hidden"),
              (u = u || T.scrollWidth + v),
              (m.width = `${u}px`),
              (E.style.overflow = ""),
              (m.flex = "0 0 auto"),
              (m.height = `${E.scrollHeight}px`),
              (d = T.scrollHeight + y));
          }
        } catch {}
      if (u || d) {
        const g = { flex: "0 1 auto", width: "", height: "" };
        (u && u !== "auto" && (g.width = `${u}px`),
          d && d !== "auto" && (g.height = `${d}px`),
          Object.assign(m, g));
      }
    }
    playVideo() {
      const e = this.instance.getSlide();
      if (!e) return;
      const { el: n } = e;
      if (!n || !n.offsetParent || !this.optionFor(e, "videoAutoplay")) return;
      if (e.type === fg)
        try {
          const a = n.querySelector("video");
          if (a) {
            const l = a.play();
            l !== void 0 &&
              l
                .then(() => {})
                .catch((u) => {
                  ((a.muted = !0), a.play());
                });
          }
        } catch {}
      if (e.type !== eo && e.type !== cf) return;
      const i = () => {
        if (e.iframeEl && e.iframeEl.contentWindow) {
          let a;
          if (e.iframeEl.dataset.ready === "true")
            return (
              (a =
                e.type === eo
                  ? { event: "command", func: "playVideo" }
                  : { method: "play", value: "true" }),
              a && e.iframeEl.contentWindow.postMessage(JSON.stringify(a), "*"),
              void (e.poller = void 0)
            );
          e.type === eo &&
            ((a = { event: "listening", id: e.iframeEl.getAttribute("id") }),
            e.iframeEl.contentWindow.postMessage(JSON.stringify(a), "*"));
        }
        e.poller = setTimeout(i, 250);
      };
      i();
    }
    processType(e) {
      if (e.html) return ((e.type = Gx), (e.src = e.html), void (e.html = ""));
      const n = this.instance.optionFor(e, "src", "");
      if (!n || typeof n != "string") return;
      let i = e.type,
        a = null;
      if (
        (a = n.match(
          /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i,
        ))
      ) {
        const l = this.optionFor(e, eo),
          { nocookie: u } = l,
          d = (function (y, w) {
            var S = {};
            for (var T in y)
              Object.prototype.hasOwnProperty.call(y, T) &&
                w.indexOf(T) < 0 &&
                (S[T] = y[T]);
            if (
              y != null &&
              typeof Object.getOwnPropertySymbols == "function"
            ) {
              var E = 0;
              for (T = Object.getOwnPropertySymbols(y); E < T.length; E++)
                w.indexOf(T[E]) < 0 &&
                  Object.prototype.propertyIsEnumerable.call(y, T[E]) &&
                  (S[T[E]] = y[T[E]]);
            }
            return S;
          })(l, ["nocookie"]),
          m = `www.youtube${u ? "-nocookie" : ""}.com`,
          g = XT(n, d),
          v = encodeURIComponent(a[2]);
        ((e.videoId = v),
          (e.src = `https://${m}/embed/${v}?${g}`),
          (e.thumbSrc =
            e.thumbSrc || `https://i.ytimg.com/vi/${v}/mqdefault.jpg`),
          (i = eo));
      } else if (
        (a = n.match(
          /^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/,
        ))
      ) {
        const l = XT(n, this.optionFor(e, cf)),
          u = encodeURIComponent(a[1]),
          d = a[4] || "";
        ((e.videoId = u),
          (e.src = `https://player.vimeo.com/video/${u}?${d ? `h=${d}${l ? "&" : ""}` : ""}${l}`),
          (i = cf));
      }
      if (!i && e.triggerEl) {
        const l = e.triggerEl.dataset.type;
        C4.includes(l) && (i = l);
      }
      (i ||
        (typeof n == "string" &&
          (n.charAt(0) === "#"
            ? (i = "inline")
            : (a = n.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
              ? ((i = fg),
                (e.videoFormat =
                  e.videoFormat || "video/" + (a[1] === "ogv" ? "ogg" : a[1])))
              : n.match(
                    /(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i,
                  )
                ? (i = WT)
                : n.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf"))),
        (a = n.match(
          /(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i,
        ))
          ? ((e.src = `https://maps.google.${a[1]}/?ll=${(a[2] ? a[2] + "&z=" + Math.floor(parseFloat(a[3])) + (a[4] ? a[4].replace(/^\//, "&") : "") : a[4] + "").replace(/\?/, "&")}&output=${a[4] && a[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`),
            (i = Vx))
          : (a = n.match(
              /(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i,
            )) &&
            ((e.src = `https://maps.google.${a[1]}/maps?q=${a[2].replace("query=", "q=").replace("api=1", "")}&output=embed`),
            (i = Vx)),
        (i = i || this.instance.option("defaultType")),
        (e.type = i),
        i === WT && (e.thumbSrc = e.thumbSrc || e.src));
    }
    setContent(e) {
      const n = this.instance.optionFor(e, "src") || "";
      if (e && e.type && n) {
        switch (e.type) {
          case Gx:
            this.instance.setContent(e, n);
            break;
          case fg:
            const i = this.option("videoTpl");
            i &&
              this.instance.setContent(
                e,
                i
                  .replace(/\{\{src\}\}/gi, n + "")
                  .replace(
                    /\{\{format\}\}/gi,
                    this.optionFor(e, "videoFormat") || "",
                  )
                  .replace(/\{\{poster\}\}/gi, e.poster || e.thumbSrc || ""),
              );
            break;
          case "inline":
          case "clone":
            this.setInlineContent(e);
            break;
          case "ajax":
            this.loadAjaxContent(e);
            break;
          case "pdf":
          case Vx:
          case eo:
          case cf:
            e.preload = !1;
          case "iframe":
            this.setIframeContent(e);
        }
        this.setAspectRatio(e);
      }
    }
    setAspectRatio(e) {
      const n = e.contentEl;
      if (!(e.el && n && e.type && [eo, cf, fg].includes(e.type))) return;
      let i,
        a = e.width || "auto",
        l = e.height || "auto";
      if (a === "auto" || l === "auto") {
        i = this.optionFor(e, "videoRatio");
        const g = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
        i =
          g && g.length > 2
            ? parseFloat(g[1]) / parseFloat(g[2])
            : parseFloat(i + "");
      } else a && l && (i = a / l);
      if (!i) return;
      ((n.style.aspectRatio = ""),
        (n.style.width = ""),
        (n.style.height = ""),
        n.offsetHeight);
      const u = n.getBoundingClientRect(),
        d = u.width || 1,
        m = u.height || 1;
      ((n.style.aspectRatio = i + ""),
        i < d / m
          ? ((l = l === "auto" ? m : Math.min(m, l)),
            (n.style.width = "auto"),
            (n.style.height = `${l}px`))
          : ((a = a === "auto" ? d : Math.min(d, a)),
            (n.style.width = `${a}px`),
            (n.style.height = "auto")));
    }
    attach() {
      const e = this,
        n = e.instance;
      (n.on("Carousel.beforeInitSlide", e.onBeforeInitSlide),
        n.on("Carousel.createSlide", e.onCreateSlide),
        n.on("Carousel.selectSlide", e.onSelectSlide),
        n.on("Carousel.unselectSlide", e.onUnselectSlide),
        n.on("Carousel.Panzoom.refresh", e.onRefresh),
        n.on("done", e.onDone),
        n.on("clearContent", e.onClearContent),
        window.addEventListener("message", e.onMessage));
    }
    detach() {
      const e = this,
        n = e.instance;
      (n.off("Carousel.beforeInitSlide", e.onBeforeInitSlide),
        n.off("Carousel.createSlide", e.onCreateSlide),
        n.off("Carousel.selectSlide", e.onSelectSlide),
        n.off("Carousel.unselectSlide", e.onUnselectSlide),
        n.off("Carousel.Panzoom.refresh", e.onRefresh),
        n.off("done", e.onDone),
        n.off("clearContent", e.onClearContent),
        window.removeEventListener("message", e.onMessage));
    }
  }
  Object.defineProperty(GC, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: E4,
  });
  const P0 = "play",
    I0 = "pause",
    dg = "ready";
  class VC extends Ta {
    constructor() {
      (super(...arguments),
        Object.defineProperty(this, "state", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: dg,
        }),
        Object.defineProperty(this, "inHover", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, "timer", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "progressBar", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }));
    }
    get isActive() {
      return this.state !== dg;
    }
    onReady(e) {
      this.option("autoStart") &&
        (e.isInfinite || e.page < e.pages.length - 1) &&
        this.start();
    }
    onChange() {
      (this.removeProgressBar(), this.pause());
    }
    onSettle() {
      this.resume();
    }
    onVisibilityChange() {
      document.visibilityState === "visible" ? this.resume() : this.pause();
    }
    onMouseEnter() {
      ((this.inHover = !0), this.pause());
    }
    onMouseLeave() {
      var e;
      ((this.inHover = !1),
        !((e = this.instance.panzoom) === null || e === void 0) &&
          e.isResting &&
          this.resume());
    }
    onTimerEnd() {
      const e = this.instance;
      this.state === "play" &&
        (e.isInfinite || e.page !== e.pages.length - 1
          ? e.slideNext()
          : e.slideTo(0));
    }
    removeProgressBar() {
      this.progressBar &&
        (this.progressBar.remove(), (this.progressBar = null));
    }
    createProgressBar() {
      var e;
      if (!this.option("showProgress")) return null;
      this.removeProgressBar();
      const n = this.instance,
        i =
          ((e = n.pages[n.page]) === null || e === void 0
            ? void 0
            : e.slides) || [];
      let a = this.option("progressParentEl");
      if ((a || (a = (i.length === 1 ? i[0].el : null) || n.viewport), !a))
        return null;
      const l = document.createElement("div");
      return (
        Ye(l, "f-progress"),
        a.prepend(l),
        (this.progressBar = l),
        l.offsetHeight,
        l
      );
    }
    set() {
      const e = this,
        n = e.instance;
      if (n.pages.length < 2 || e.timer) return;
      const i = e.option("timeout");
      ((e.state = P0), Ye(n.container, "has-autoplay"));
      let a = e.createProgressBar();
      (a &&
        ((a.style.transitionDuration = `${i}ms`),
        (a.style.transform = "scaleX(1)")),
        (e.timer = setTimeout(() => {
          ((e.timer = null), e.inHover || e.onTimerEnd());
        }, i)),
        e.emit("set"));
    }
    clear() {
      const e = this;
      (e.timer && (clearTimeout(e.timer), (e.timer = null)),
        e.removeProgressBar());
    }
    start() {
      const e = this;
      if ((e.set(), e.state !== dg)) {
        if (e.option("pauseOnHover")) {
          const n = e.instance.container;
          (n.addEventListener("mouseenter", e.onMouseEnter, !1),
            n.addEventListener("mouseleave", e.onMouseLeave, !1));
        }
        (document.addEventListener(
          "visibilitychange",
          e.onVisibilityChange,
          !1,
        ),
          e.emit("start"));
      }
    }
    stop() {
      const e = this,
        n = e.state,
        i = e.instance.container;
      (e.clear(),
        (e.state = dg),
        i.removeEventListener("mouseenter", e.onMouseEnter, !1),
        i.removeEventListener("mouseleave", e.onMouseLeave, !1),
        document.removeEventListener(
          "visibilitychange",
          e.onVisibilityChange,
          !1,
        ),
        $t(i, "has-autoplay"),
        n !== dg && e.emit("stop"));
    }
    pause() {
      const e = this;
      e.state === P0 && ((e.state = I0), e.clear(), e.emit(I0));
    }
    resume() {
      const e = this,
        n = e.instance;
      if (n.isInfinite || n.page !== n.pages.length - 1)
        if (e.state !== P0) {
          if (e.state === I0 && !e.inHover) {
            const i = new Event("resume", { bubbles: !0, cancelable: !0 });
            (e.emit("resume", i), i.defaultPrevented || e.set());
          }
        } else e.set();
      else e.stop();
    }
    toggle() {
      this.state === P0 || this.state === I0 ? this.stop() : this.start();
    }
    attach() {
      const e = this,
        n = e.instance;
      (n.on("ready", e.onReady),
        n.on("Panzoom.startAnimation", e.onChange),
        n.on("Panzoom.endAnimation", e.onSettle),
        n.on("Panzoom.touchMove", e.onChange));
    }
    detach() {
      const e = this,
        n = e.instance;
      (n.off("ready", e.onReady),
        n.off("Panzoom.startAnimation", e.onChange),
        n.off("Panzoom.endAnimation", e.onSettle),
        n.off("Panzoom.touchMove", e.onChange),
        e.stop());
    }
  }
  Object.defineProperty(VC, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
      autoStart: !0,
      pauseOnHover: !0,
      progressParentEl: null,
      showProgress: !0,
      timeout: 3e3,
    },
  });
  class WC extends Ta {
    constructor() {
      (super(...arguments),
        Object.defineProperty(this, "ref", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }));
    }
    onPrepare(e) {
      const n = e.carousel;
      if (!n) return;
      const i = e.container;
      i &&
        ((n.options.Autoplay = Ys(
          { autoStart: !1 },
          this.option("Autoplay") || {},
          {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: () => this.option("progressParentEl") || null,
            on: {
              start: () => {
                e.emit("startSlideshow");
              },
              set: (a) => {
                var l;
                (i.classList.add("has-slideshow"),
                  ((l = e.getSlide()) === null || l === void 0
                    ? void 0
                    : l.state) !== zi.Ready && a.pause());
              },
              stop: () => {
                (i.classList.remove("has-slideshow"),
                  e.isCompact || e.endIdle(),
                  e.emit("endSlideshow"));
              },
              resume: (a, l) => {
                var u, d, m;
                !l ||
                  !l.cancelable ||
                  (((u = e.getSlide()) === null || u === void 0
                    ? void 0
                    : u.state) === zi.Ready &&
                    !(
                      (m =
                        (d = e.carousel) === null || d === void 0
                          ? void 0
                          : d.panzoom) === null || m === void 0
                    ) &&
                    m.isResting) ||
                  l.preventDefault();
              },
            },
          },
        )),
        n.attachPlugins({ Autoplay: VC }),
        (this.ref = n.plugins.Autoplay));
    }
    onReady(e) {
      const n = e.carousel,
        i = this.ref;
      i &&
        n &&
        this.option("playOnStart") &&
        (n.isInfinite || n.page < n.pages.length - 1) &&
        i.start();
    }
    onDone(e, n) {
      const i = this.ref,
        a = e.carousel;
      if (!i || !a) return;
      const l = n.panzoom;
      (l &&
        l.on("startAnimation", () => {
          e.isCurrentSlide(n) && i.stop();
        }),
        e.isCurrentSlide(n) && i.resume());
    }
    onKeydown(e, n) {
      var i;
      const a = this.ref;
      a &&
        n === this.option("key") &&
        ((i = document.activeElement) === null || i === void 0
          ? void 0
          : i.nodeName) !== "BUTTON" &&
        a.toggle();
    }
    attach() {
      const e = this,
        n = e.instance;
      (n.on("Carousel.init", e.onPrepare),
        n.on("Carousel.ready", e.onReady),
        n.on("done", e.onDone),
        n.on("keydown", e.onKeydown));
    }
    detach() {
      const e = this,
        n = e.instance;
      (n.off("Carousel.init", e.onPrepare),
        n.off("Carousel.ready", e.onReady),
        n.off("done", e.onDone),
        n.off("keydown", e.onKeydown));
    }
  }
  Object.defineProperty(WC, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
      key: " ",
      playOnStart: !1,
      progressParentEl: (t) => {
        var e;
        return (
          ((e = t.instance.container) === null || e === void 0
            ? void 0
            : e.querySelector(
                ".fancybox__toolbar [data-fancybox-toggle-slideshow]",
              )) || t.instance.container
        );
      },
      timeout: 3e3,
    },
  });
  const XC = {
    classes: {
      container: "f-thumbs f-carousel__thumbs",
      viewport: "f-thumbs__viewport",
      track: "f-thumbs__track",
      slide: "f-thumbs__slide",
      isResting: "is-resting",
      isSelected: "is-selected",
      isLoading: "is-loading",
      hasThumbs: "has-thumbs",
    },
    minCount: 2,
    parentEl: null,
    thumbTpl:
      '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern",
  };
  var oo;
  (function (t) {
    ((t[(t.Init = 0)] = "Init"),
      (t[(t.Ready = 1)] = "Ready"),
      (t[(t.Hidden = 2)] = "Hidden"));
  })(oo || (oo = {}));
  const QT = "isResting",
    U0 = "thumbWidth",
    Th = "thumbHeight",
    al = "thumbClipWidth";
  let QC = class extends Ta {
    constructor() {
      (super(...arguments),
        Object.defineProperty(this, "type", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: "modern",
        }),
        Object.defineProperty(this, "container", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "track", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "carousel", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "thumbWidth", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "thumbClipWidth", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "thumbHeight", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "thumbGap", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "thumbExtraGap", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "state", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: oo.Init,
        }));
    }
    get isModern() {
      return this.type === "modern";
    }
    onInitSlide(t, e) {
      const n = e.el ? e.el.dataset : void 0;
      (n &&
        ((e.thumbSrc = n.thumbSrc || e.thumbSrc || ""),
        (e[al] = parseFloat(n[al] || "") || e[al] || 0),
        (e[Th] = parseFloat(n.thumbHeight || "") || e[Th] || 0)),
        this.addSlide(e));
    }
    onInitSlides() {
      this.build();
    }
    onChange() {
      var t;
      if (!this.isModern) return;
      const e = this.container,
        n = this.instance,
        i = n.panzoom,
        a = this.carousel,
        l = a ? a.panzoom : null,
        u = n.page;
      if (i && a && l) {
        if (i.isDragging) {
          $t(e, this.cn(QT));
          let d =
            ((t = a.pages[u]) === null || t === void 0 ? void 0 : t.pos) || 0;
          d += n.getProgress(u) * (this[al] + this.thumbGap);
          let m = l.getBounds();
          -1 * d > m.x.min &&
            -1 * d < m.x.max &&
            l.panTo({ x: -1 * d, friction: 0.12 });
        } else pl(e, this.cn(QT), i.isResting);
        this.shiftModern();
      }
    }
    onRefresh() {
      this.updateProps();
      for (const t of this.instance.slides || []) this.resizeModernSlide(t);
      this.shiftModern();
    }
    isDisabled() {
      const t = this.option("minCount") || 0;
      if (t) {
        const n = this.instance;
        let i = 0;
        for (const a of n.slides || []) a.thumbSrc && i++;
        if (i < t) return !0;
      }
      const e = this.option("type");
      return ["modern", "classic"].indexOf(e) < 0;
    }
    getThumb(t) {
      const e = this.option("thumbTpl") || "";
      return {
        html: this.instance.localize(e, [
          ["%i", t.index],
          ["%d", t.index + 1],
          [
            "%s",
            t.thumbSrc ||
              "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
          ],
        ]),
      };
    }
    addSlide(t) {
      const e = this.carousel;
      e && e.addSlide(t.index, this.getThumb(t));
    }
    getSlides() {
      const t = [];
      for (const e of this.instance.slides || []) t.push(this.getThumb(e));
      return t;
    }
    resizeModernSlide(t) {
      this.isModern &&
        (t[U0] =
          t[al] && t[Th] ? Math.round(this[Th] * (t[al] / t[Th])) : this[U0]);
    }
    updateProps() {
      const t = this.container;
      if (!t) return;
      const e = (n) =>
        parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-" + n)) || 0;
      ((this.thumbGap = e("gap")),
        (this.thumbExtraGap = e("extra-gap")),
        (this[U0] = e("width") || 40),
        (this[al] = e("clip-width") || 40),
        (this[Th] = e("height") || 40));
    }
    build() {
      const t = this;
      if (t.state !== oo.Init) return;
      if (t.isDisabled()) return void t.emit("disabled");
      const e = t.instance,
        n = e.container,
        i = t.getSlides(),
        a = t.option("type");
      t.type = a;
      const l = t.option("parentEl"),
        u = t.cn("container"),
        d = t.cn("track");
      let m = l == null ? void 0 : l.querySelector("." + u);
      (m ||
        ((m = document.createElement("div")),
        Ye(m, u),
        l ? l.appendChild(m) : n.after(m)),
        Ye(m, `is-${a}`),
        Ye(n, t.cn("hasThumbs")),
        (t.container = m),
        t.updateProps());
      let g = m.querySelector("." + d);
      (g ||
        ((g = document.createElement("div")),
        Ye(g, t.cn("track")),
        m.appendChild(g)),
        (t.track = g));
      const v = Ys(
          {},
          {
            track: g,
            infinite: !1,
            center: !0,
            fill: a === "classic",
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            preload: 0.25,
            friction: 0.12,
            Panzoom: { maxVelocity: 0 },
            Dots: !1,
            Navigation: !1,
            classes: {
              container: "f-thumbs",
              viewport: "f-thumbs__viewport",
              track: "f-thumbs__track",
              slide: "f-thumbs__slide",
            },
          },
          t.option("Carousel") || {},
          { Sync: { target: e }, slides: i },
        ),
        y = new e.constructor(m, v);
      (y.on("createSlide", (w, S) => {
        (t.setProps(S.index), t.emit("createSlide", S, S.el));
      }),
        y.on("ready", () => {
          (t.shiftModern(), t.emit("ready"));
        }),
        y.on("refresh", () => {
          t.shiftModern();
        }),
        y.on("Panzoom.click", (w, S, T) => {
          t.onClick(T);
        }),
        (t.carousel = y),
        (t.state = oo.Ready));
    }
    onClick(t) {
      (t.preventDefault(), t.stopPropagation());
      const e = this.instance,
        { pages: n, page: i } = e,
        a = (E) => {
          if (E) {
            const j = E.closest("[data-carousel-index]");
            if (j) return [parseInt(j.dataset.carouselIndex || "", 10) || 0, j];
          }
          return [-1, void 0];
        },
        l = (E, j) => {
          const O = document.elementFromPoint(E, j);
          return O ? a(O) : [-1, void 0];
        };
      let [u, d] = a(t.target);
      if (u > -1) return;
      const m = this[al],
        g = t.clientX,
        v = t.clientY;
      let [y, w] = l(g - m, v),
        [S, T] = l(g + m, v);
      (w && T
        ? ((u =
            Math.abs(g - w.getBoundingClientRect().right) <
            Math.abs(g - T.getBoundingClientRect().left)
              ? y
              : S),
          u === i && (u = u === y ? S : y))
        : w
          ? (u = y)
          : T && (u = S),
        u > -1 && n[u] && e.slideTo(u));
    }
    getShift(t) {
      var e;
      const n = this,
        { instance: i } = n,
        a = n.carousel;
      if (!i || !a) return 0;
      const l = n[U0],
        u = n[al],
        d = n.thumbGap,
        m = n.thumbExtraGap;
      if (!(!((e = a.slides[t]) === null || e === void 0) && e.el)) return 0;
      const g = 0.5 * (l - u),
        v = i.pages.length - 1;
      let y = i.getProgress(0),
        w = i.getProgress(v),
        S = i.getProgress(t, !1, !0),
        T = 0,
        E = g + m + d;
      const j = y < 0 && y > -1,
        O = w > 0 && w < 1;
      return (
        t === 0
          ? ((T = E * Math.abs(y)), O && y === 1 && (T -= E * Math.abs(w)))
          : t === v
            ? ((T = E * Math.abs(w) * -1),
              j && w === -1 && (T += E * Math.abs(y)))
            : j || O
              ? ((T = -1 * E),
                (T += E * Math.abs(y)),
                (T += E * (1 - Math.abs(w))))
              : (T = E * S),
        T
      );
    }
    setProps(t) {
      var e;
      const n = this;
      if (!n.isModern) return;
      const { instance: i } = n,
        a = n.carousel;
      if (i && a) {
        const l = (e = a.slides[t]) === null || e === void 0 ? void 0 : e.el;
        if (l && l.childNodes.length) {
          let u = Ne(1 - Math.abs(i.getProgress(t))),
            d = Ne(n.getShift(t));
          (l.style.setProperty("--progress", u ? u + "" : ""),
            l.style.setProperty("--shift", d + ""));
        }
      }
    }
    shiftModern() {
      const t = this;
      if (!t.isModern) return;
      const { instance: e, track: n } = t,
        i = e.panzoom,
        a = t.carousel;
      if (!(e && n && i && a) || i.state === Zt.Init || i.state === Zt.Destroy)
        return;
      for (const u of e.slides) t.setProps(u.index);
      let l = (t[al] + t.thumbGap) * (a.slides.length || 0);
      n.style.setProperty("--width", l + "");
    }
    cleanup() {
      const t = this;
      (t.carousel && t.carousel.destroy(),
        (t.carousel = null),
        t.container && t.container.remove(),
        (t.container = null),
        t.track && t.track.remove(),
        (t.track = null),
        (t.state = oo.Init),
        $t(t.instance.container, t.cn("hasThumbs")));
    }
    attach() {
      const t = this,
        e = t.instance;
      (e.on("initSlide", t.onInitSlide),
        e.state === Wn.Init
          ? e.on("initSlides", t.onInitSlides)
          : t.onInitSlides(),
        e.on(["change", "Panzoom.afterTransform"], t.onChange),
        e.on("Panzoom.refresh", t.onRefresh));
    }
    detach() {
      const t = this,
        e = t.instance;
      (e.off("initSlide", t.onInitSlide),
        e.off("initSlides", t.onInitSlides),
        e.off(["change", "Panzoom.afterTransform"], t.onChange),
        e.off("Panzoom.refresh", t.onRefresh),
        t.cleanup());
    }
  };
  Object.defineProperty(QC, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: XC,
  });
  const O4 = Object.assign(Object.assign({}, XC), {
      key: "t",
      showOnStart: !0,
      parentEl: null,
    }),
    ZT = "is-masked",
    KT = "aria-hidden";
  class ZC extends Ta {
    constructor() {
      (super(...arguments),
        Object.defineProperty(this, "ref", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "hidden", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }));
    }
    get isEnabled() {
      const e = this.ref;
      return e && !e.isDisabled();
    }
    get isHidden() {
      return this.hidden;
    }
    onClick(e, n) {
      n.stopPropagation();
    }
    onCreateSlide(e, n) {
      var i, a, l;
      const u =
          ((l =
            (a =
              (i = this.instance) === null || i === void 0
                ? void 0
                : i.carousel) === null || a === void 0
              ? void 0
              : a.slides[n.index]) === null || l === void 0
            ? void 0
            : l.type) || "",
        d = n.el;
      if (d && u) {
        let m = `for-${u}`;
        (["video", "youtube", "vimeo", "html5video"].includes(u) &&
          (m += " for-video"),
          Ye(d, m));
      }
    }
    onInit() {
      var e;
      const n = this,
        i = n.instance,
        a = i.carousel;
      if (n.ref || !a) return;
      const l = n.option("parentEl") || i.footer || i.container;
      if (!l) return;
      const u = Ys({}, n.options, {
        parentEl: l,
        classes: { container: "f-thumbs fancybox__thumbs" },
        Carousel: { Sync: { friction: i.option("Carousel.friction") || 0 } },
        on: {
          ready: (d) => {
            const m = d.container;
            m &&
              this.hidden &&
              (n.refresh(),
              (m.style.transition = "none"),
              n.hide(),
              m.offsetHeight,
              queueMicrotask(() => {
                ((m.style.transition = ""), n.show());
              }));
          },
        },
      });
      ((u.Carousel = u.Carousel || {}),
        (u.Carousel.on = Ys(
          ((e = n.options.Carousel) === null || e === void 0 ? void 0 : e.on) ||
            {},
          { click: this.onClick, createSlide: this.onCreateSlide },
        )),
        (a.options.Thumbs = u),
        a.attachPlugins({ Thumbs: QC }),
        (n.ref = a.plugins.Thumbs),
        n.option("showOnStart") ||
          ((n.ref.state = oo.Hidden), (n.hidden = !0)));
    }
    onResize() {
      var e;
      const n = (e = this.ref) === null || e === void 0 ? void 0 : e.container;
      n && (n.style.maxHeight = "");
    }
    onKeydown(e, n) {
      const i = this.option("key");
      i && i === n && this.toggle();
    }
    toggle() {
      const e = this.ref;
      if (e && !e.isDisabled())
        return e.state === oo.Hidden
          ? ((e.state = oo.Init), void e.build())
          : void (this.hidden ? this.show() : this.hide());
    }
    show() {
      const e = this.ref;
      if (!e || e.isDisabled()) return;
      const n = e.container;
      n &&
        (this.refresh(),
        n.offsetHeight,
        n.removeAttribute(KT),
        n.classList.remove(ZT),
        (this.hidden = !1));
    }
    hide() {
      const e = this.ref,
        n = e && e.container;
      (n &&
        (this.refresh(),
        n.offsetHeight,
        n.classList.add(ZT),
        n.setAttribute(KT, "true")),
        (this.hidden = !0));
    }
    refresh() {
      const e = this.ref;
      if (!e || !e.state) return;
      const n = e.container,
        i = (n == null ? void 0 : n.firstChild) || null;
      n &&
        i &&
        i.childNodes.length &&
        (n.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
      const e = this,
        n = e.instance;
      (n.state === fi.Init ? n.on("Carousel.init", e.onInit) : e.onInit(),
        n.on("resize", e.onResize),
        n.on("keydown", e.onKeydown));
    }
    detach() {
      var e;
      const n = this,
        i = n.instance;
      (i.off("Carousel.init", n.onInit),
        i.off("resize", n.onResize),
        i.off("keydown", n.onKeydown),
        (e = i.carousel) === null ||
          e === void 0 ||
          e.detachPlugins(["Thumbs"]),
        (n.ref = null));
    }
  }
  Object.defineProperty(ZC, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: O4,
  });
  const Wx = {
    panLeft: {
      icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
      change: { panX: -100 },
    },
    panRight: {
      icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
      change: { panX: 100 },
    },
    panUp: {
      icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
      change: { panY: -100 },
    },
    panDown: {
      icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
      change: { panY: 100 },
    },
    zoomIn: {
      icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
      action: "zoomIn",
    },
    zoomOut: {
      icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
      action: "zoomOut",
    },
    toggle1to1: {
      icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
      action: "toggleZoom",
    },
    toggleZoom: {
      icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
      action: "toggleZoom",
    },
    iterateZoom: {
      icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
      action: "iterateZoom",
    },
    rotateCCW: {
      icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
      action: "rotateCCW",
    },
    rotateCW: {
      icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
      action: "rotateCW",
    },
    flipX: {
      icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
      action: "flipX",
    },
    flipY: {
      icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
      action: "flipY",
    },
    fitX: {
      icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
      action: "fitX",
    },
    fitY: {
      icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
      action: "fitY",
    },
    reset: {
      icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
      action: "reset",
    },
    toggleFS: {
      icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
      action: "toggleFS",
    },
  };
  var vf;
  (function (t) {
    ((t[(t.Init = 0)] = "Init"),
      (t[(t.Ready = 1)] = "Ready"),
      (t[(t.Disabled = 2)] = "Disabled"));
  })(vf || (vf = {}));
  const j4 = {
      absolute: "auto",
      display: {
        left: ["infobar"],
        middle: [],
        right: ["iterateZoom", "slideshow", "fullscreen", "thumbs", "close"],
      },
      enabled: "auto",
      items: {
        infobar: {
          tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>',
        },
        download: {
          tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>',
        },
        prev: {
          tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>',
        },
        next: {
          tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>',
        },
        slideshow: {
          tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>',
        },
        fullscreen: {
          tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>',
        },
        thumbs: {
          tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>',
        },
        close: {
          tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>',
        },
      },
      parentEl: null,
    },
    M4 = {
      tabindex: "-1",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
    },
    JT = "has-toolbar",
    Xx = "fancybox__toolbar";
  class KC extends Ta {
    constructor() {
      (super(...arguments),
        Object.defineProperty(this, "state", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: vf.Init,
        }),
        Object.defineProperty(this, "container", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }));
    }
    onReady(e) {
      var n;
      if (!e.carousel) return;
      let i = this.option("display"),
        a = this.option("absolute"),
        l = this.option("enabled");
      if (l === "auto") {
        const g = this.instance.carousel;
        let v = 0;
        if (g)
          for (const y of g.slides) (y.panzoom || y.type === "image") && v++;
        v || (l = !1);
      }
      l || (i = void 0);
      let u = 0;
      const d = { left: [], middle: [], right: [] };
      if (i)
        for (const g of ["left", "middle", "right"])
          for (const v of i[g]) {
            const y = this.createEl(v);
            y && ((n = d[g]) === null || n === void 0 || n.push(y), u++);
          }
      let m = null;
      if ((u && (m = this.createContainer()), m)) {
        for (const [g, v] of Object.entries(d)) {
          const y = document.createElement("div");
          Ye(y, Xx + "__column is-" + g);
          for (const w of v) y.appendChild(w);
          (a !== "auto" || g !== "middle" || v.length || (a = !0),
            m.appendChild(y));
        }
        (a === !0 && Ye(m, "is-absolute"),
          (this.state = vf.Ready),
          this.onRefresh());
      } else this.state = vf.Disabled;
    }
    onClick(e) {
      var n, i;
      const a = this.instance,
        l = a.getSlide(),
        u = l == null ? void 0 : l.panzoom,
        d = e.target,
        m = d && Hs(d) ? d.dataset : null;
      if (!m) return;
      if (m.fancyboxToggleThumbs !== void 0)
        return (
          e.preventDefault(),
          e.stopPropagation(),
          void ((n = a.plugins.Thumbs) === null || n === void 0 || n.toggle())
        );
      if (m.fancyboxToggleFullscreen !== void 0)
        return (
          e.preventDefault(),
          e.stopPropagation(),
          void this.instance.toggleFullscreen()
        );
      if (m.fancyboxToggleSlideshow !== void 0) {
        (e.preventDefault(), e.stopPropagation());
        const y =
          (i = a.carousel) === null || i === void 0
            ? void 0
            : i.plugins.Autoplay;
        let w = y.isActive;
        return (
          u && u.panMode === "mousemove" && !w && u.reset(),
          void (w ? y.stop() : y.start())
        );
      }
      const g = m.panzoomAction,
        v = m.panzoomChange;
      if (((v || g) && (e.preventDefault(), e.stopPropagation()), v)) {
        let y = {};
        try {
          y = JSON.parse(v);
        } catch {}
        u && u.applyChange(y);
      } else g && u && u[g] && u[g]();
    }
    onChange() {
      this.onRefresh();
    }
    onRefresh() {
      if (this.instance.isClosing()) return;
      const e = this.container;
      if (!e) return;
      const n = this.instance.getSlide();
      if (!n || n.state !== zi.Ready) return;
      const i = n && !n.error && n.panzoom;
      for (const u of e.querySelectorAll("[data-panzoom-action]"))
        i
          ? (u.removeAttribute("disabled"), u.removeAttribute("tabindex"))
          : (u.setAttribute("disabled", ""), u.setAttribute("tabindex", "-1"));
      let a = i && i.canZoomIn(),
        l = i && i.canZoomOut();
      for (const u of e.querySelectorAll('[data-panzoom-action="zoomIn"]'))
        a
          ? (u.removeAttribute("disabled"), u.removeAttribute("tabindex"))
          : (u.setAttribute("disabled", ""), u.setAttribute("tabindex", "-1"));
      for (const u of e.querySelectorAll('[data-panzoom-action="zoomOut"]'))
        l
          ? (u.removeAttribute("disabled"), u.removeAttribute("tabindex"))
          : (u.setAttribute("disabled", ""), u.setAttribute("tabindex", "-1"));
      for (const u of e.querySelectorAll(
        '[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]',
      )) {
        l || a
          ? (u.removeAttribute("disabled"), u.removeAttribute("tabindex"))
          : (u.setAttribute("disabled", ""), u.setAttribute("tabindex", "-1"));
        const d = u.querySelector("g");
        d && (d.style.display = a ? "" : "none");
      }
    }
    onDone(e, n) {
      var i;
      ((i = n.panzoom) === null ||
        i === void 0 ||
        i.on("afterTransform", () => {
          this.instance.isCurrentSlide(n) && this.onRefresh();
        }),
        this.instance.isCurrentSlide(n) && this.onRefresh());
    }
    createContainer() {
      const e = this.instance.container;
      if (!e) return null;
      const n = this.option("parentEl") || e;
      let i = n.querySelector("." + Xx);
      return (
        i || ((i = document.createElement("div")), Ye(i, Xx), n.prepend(i)),
        i.addEventListener("click", this.onClick, { passive: !1, capture: !0 }),
        e && Ye(e, JT),
        (this.container = i),
        i
      );
    }
    createEl(e) {
      const n = this.instance,
        i = n.carousel;
      if (!i || e === "toggleFS" || (e === "fullscreen" && !FC())) return null;
      let a = null;
      const l = i.slides.length || 0;
      let u = 0,
        d = 0;
      for (const g of i.slides)
        ((g.panzoom || g.type === "image") && u++,
          (g.type === "image" || g.downloadSrc) && d++);
      if (l < 2 && ["infobar", "prev", "next"].includes(e)) return a;
      if ((Wx[e] !== void 0 && !u) || (e === "download" && !d)) return null;
      if (e === "thumbs") {
        const g = n.plugins.Thumbs;
        if (!g || !g.isEnabled) return null;
      }
      if (e === "slideshow" && (!i.plugins.Autoplay || l < 2)) return null;
      if (Wx[e] !== void 0) {
        const g = Wx[e];
        ((a = document.createElement("button")),
          a.setAttribute(
            "title",
            this.instance.localize(`{{${e.toUpperCase()}}}`),
          ),
          Ye(a, "f-button"),
          g.action && (a.dataset.panzoomAction = g.action),
          g.change && (a.dataset.panzoomChange = JSON.stringify(g.change)),
          a.appendChild(hl(this.instance.localize(g.icon))));
      } else {
        const g = (this.option("items") || [])[e];
        g &&
          ((a = hl(this.instance.localize(g.tpl))),
          typeof g.click == "function" &&
            a.addEventListener("click", (v) => {
              (v.preventDefault(),
                v.stopPropagation(),
                typeof g.click == "function" && g.click.call(this, this, v));
            }));
      }
      const m = a == null ? void 0 : a.querySelector("svg");
      if (m)
        for (const [g, v] of Object.entries(M4))
          m.getAttribute(g) || m.setAttribute(g, String(v));
      return a;
    }
    removeContainer() {
      const e = this.container;
      (e && e.remove(), (this.container = null), (this.state = vf.Disabled));
      const n = this.instance.container;
      n && $t(n, JT);
    }
    attach() {
      const e = this,
        n = e.instance;
      (n.on("Carousel.initSlides", e.onReady),
        n.on("done", e.onDone),
        n.on(["reveal", "Carousel.change"], e.onChange),
        e.onReady(e.instance));
    }
    detach() {
      const e = this,
        n = e.instance;
      (n.off("Carousel.initSlides", e.onReady),
        n.off("done", e.onDone),
        n.off(["reveal", "Carousel.change"], e.onChange),
        e.removeContainer());
    }
  }
  Object.defineProperty(KC, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: j4,
  });
  const N4 = {
      Hash: class extends Ta {
        onReady() {
          bg = !1;
        }
        onChange(t) {
          pf && clearTimeout(pf);
          const { hash: e } = BC(),
            { hash: n } = _b(),
            i = t.isOpeningSlide(t.getSlide());
          (i && (GT = n === e ? "" : n),
            e &&
              e !== n &&
              (pf = setTimeout(() => {
                try {
                  if (t.state === fi.Ready) {
                    let a = "replaceState";
                    (i && !k0 && ((a = "pushState"), (k0 = !0)),
                      window.history[a](
                        {},
                        document.title,
                        window.location.pathname + window.location.search + e,
                      ));
                  }
                } catch {}
              }, 300)));
        }
        onClose(t) {
          if ((pf && clearTimeout(pf), !bg && k0))
            return ((k0 = !1), (bg = !1), void window.history.back());
          if (!bg)
            try {
              window.history.replaceState(
                {},
                document.title,
                window.location.pathname + window.location.search + (GT || ""),
              );
            } catch {}
        }
        attach() {
          const t = this.instance;
          (t.on("ready", this.onReady),
            t.on(["Carousel.ready", "Carousel.change"], this.onChange),
            t.on("close", this.onClose));
        }
        detach() {
          const t = this.instance;
          (t.off("ready", this.onReady),
            t.off(["Carousel.ready", "Carousel.change"], this.onChange),
            t.off("close", this.onClose));
        }
        static parseURL() {
          return _b();
        }
        static startFromUrl() {
          HC();
        }
        static destroy() {
          window.removeEventListener("hashchange", qC, !1);
        }
      },
      Html: GC,
      Images: $C,
      Slideshow: WC,
      Thumbs: ZC,
      Toolbar: KC,
    },
    eE = "with-fancybox",
    Qx = "hide-scrollbar",
    tE = "--fancybox-scrollbar-compensate",
    nE = "--fancybox-body-margin",
    Zx = "aria-hidden",
    Kx = "is-using-tab",
    Jx = "is-animated",
    iE = "is-compact",
    sE = "is-loading",
    e_ = "is-opening",
    F0 = "has-caption",
    Eh = "disabled",
    uf = "tabindex",
    rE = "download",
    t_ = "href",
    Ch = "src",
    _c = (t) => typeof t == "string",
    aE = function () {
      var t = window.getSelection();
      return !!t && t.type === "Range";
    };
  let Rr,
    Lr = null,
    ff = null,
    lE = 0,
    oE = 0,
    cE = 0,
    uE = 0;
  const Oh = new Map();
  let A4 = 0;
  class At extends Dw {
    get isIdle() {
      return this.idle;
    }
    get isCompact() {
      return this.option("compact");
    }
    constructor(e = [], n = {}, i = {}) {
      (super(n),
        Object.defineProperty(this, "userSlides", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: [],
        }),
        Object.defineProperty(this, "userPlugins", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: {},
        }),
        Object.defineProperty(this, "idle", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, "idleTimer", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "clickTimer", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "pwt", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "ignoreFocusChange", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, "startedFs", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: !1,
        }),
        Object.defineProperty(this, "state", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: fi.Init,
        }),
        Object.defineProperty(this, "id", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: 0,
        }),
        Object.defineProperty(this, "container", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "caption", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "footer", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "carousel", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "lastFocus", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: null,
        }),
        Object.defineProperty(this, "prevMouseMoveEvent", {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: void 0,
        }),
        Rr || (Rr = FC()),
        (this.id = n.id || ++A4),
        Oh.set(this.id, this),
        (this.userSlides = e),
        (this.userPlugins = i),
        queueMicrotask(() => {
          this.init();
        }));
    }
    init() {
      if (this.state === fi.Destroy) return;
      ((this.state = fi.Init),
        this.attachPlugins(
          Object.assign(Object.assign({}, At.Plugins), this.userPlugins),
        ),
        this.emit("init"),
        this.emit("attachPlugins"),
        this.option("hideScrollbar") === !0 &&
          (() => {
            if (!wg) return;
            const n = document,
              i = n.body,
              a = n.documentElement;
            if (i.classList.contains(Qx)) return;
            let l = window.innerWidth - a.getBoundingClientRect().width;
            const u = parseFloat(window.getComputedStyle(i).marginRight);
            (l < 0 && (l = 0),
              a.style.setProperty(tE, `${l}px`),
              u && i.style.setProperty(nE, `${u}px`),
              i.classList.add(Qx));
          })(),
        this.initLayout(),
        this.scale());
      const e = () => {
        (this.initCarousel(this.userSlides),
          (this.state = fi.Ready),
          this.attachEvents(),
          this.emit("ready"),
          setTimeout(() => {
            this.container && this.container.setAttribute(Zx, "false");
          }, 16));
      };
      this.option("Fullscreen.autoStart") && Rr && !Rr.isFullscreen()
        ? Rr.request()
            .then(() => {
              ((this.startedFs = !0), e());
            })
            .catch(() => e())
        : e();
    }
    initLayout() {
      var e, n;
      const i = this.option("parentEl") || document.body,
        a = hl(this.localize(this.option("tpl.main") || ""));
      if (a) {
        if (
          (a.setAttribute("id", `fancybox-${this.id}`),
          a.setAttribute("aria-label", this.localize("{{MODAL}}")),
          a.classList.toggle(iE, this.isCompact),
          Ye(a, this.option("mainClass") || ""),
          Ye(a, e_),
          (this.container = a),
          (this.footer = a.querySelector(".fancybox__footer")),
          i.appendChild(a),
          Ye(document.documentElement, eE),
          (Lr && ff) ||
            ((Lr = document.createElement("span")),
            Ye(Lr, "fancybox-focus-guard"),
            Lr.setAttribute(uf, "0"),
            Lr.setAttribute(Zx, "true"),
            Lr.setAttribute("aria-label", "Focus guard"),
            (ff = Lr.cloneNode()),
            (e = a.parentElement) === null ||
              e === void 0 ||
              e.insertBefore(Lr, a),
            (n = a.parentElement) === null || n === void 0 || n.append(ff)),
          a.addEventListener("mousedown", (l) => {
            ((lE = l.pageX), (oE = l.pageY), $t(a, Kx));
          }),
          this.option("closeExisting"))
        )
          for (const l of Oh.values()) l.id !== this.id && l.close();
        else
          this.option("animated") &&
            (Ye(a, Jx),
            setTimeout(() => {
              this.isClosing() || $t(a, Jx);
            }, 350));
        this.emit("initLayout");
      }
    }
    initCarousel(e) {
      const n = this.container;
      if (!n) return;
      const i = n.querySelector(".fancybox__carousel");
      if (!i) return;
      const a = (this.carousel = new Nf(
        i,
        Ys(
          {},
          {
            slides: e,
            transition: "fade",
            Panzoom: {
              lockAxis: this.option("dragToClose") ? "xy" : "x",
              infinite: !!this.option("dragToClose") && "y",
            },
            Dots: !1,
            Navigation: {
              classes: {
                container: "fancybox__nav",
                button: "f-button",
                isNext: "is-next",
                isPrev: "is-prev",
              },
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n"),
          },
          this.option("Carousel") || {},
        ),
      ));
      (a.on("*", (l, u, ...d) => {
        this.emit(`Carousel.${u}`, l, ...d);
      }),
        a.on(["ready", "change"], () => {
          this.manageCaption();
        }),
        this.on("Carousel.removeSlide", (l, u, d) => {
          (this.clearContent(d), (d.state = void 0));
        }),
        a.on("Panzoom.touchStart", () => {
          var l, u;
          (this.isCompact || this.endIdle(),
            !((l = document.activeElement) === null || l === void 0) &&
              l.closest(".f-thumbs") &&
              ((u = this.container) === null || u === void 0 || u.focus()));
        }),
        a.on("settle", () => {
          (this.idleTimer ||
            this.isCompact ||
            !this.option("idle") ||
            this.setIdle(),
            this.option("autoFocus") && !this.isClosing && this.checkFocus());
        }),
        this.option("dragToClose") &&
          (a.on("Panzoom.afterTransform", (l, u) => {
            const d = this.getSlide();
            if (d && X_(d.el)) return;
            const m = this.container;
            if (m) {
              const g = Math.abs(u.current.f),
                v =
                  g < 1
                    ? ""
                    : Math.max(
                        0.5,
                        Math.min(1, 1 - (g / u.contentRect.fitHeight) * 1.5),
                      );
              (m.style.setProperty("--fancybox-ts", v ? "0s" : ""),
                m.style.setProperty("--fancybox-opacity", v + ""));
            }
          }),
          a.on("Panzoom.touchEnd", (l, u, d) => {
            var m;
            const g = this.getSlide();
            if (
              (g && X_(g.el)) ||
              (u.isMobile &&
                document.activeElement &&
                ["TEXTAREA", "INPUT"].indexOf(
                  (m = document.activeElement) === null || m === void 0
                    ? void 0
                    : m.nodeName,
                ) !== -1)
            )
              return;
            const v = Math.abs(u.dragOffset.y);
            u.lockedAxis === "y" &&
              (v >= 200 || (v >= 50 && u.dragOffset.time < 300)) &&
              (d && d.cancelable && d.preventDefault(),
              this.close(d, "f-throwOut" + (u.current.f < 0 ? "Up" : "Down")));
          })),
        a.on("change", (l) => {
          var u;
          let d =
            (u = this.getSlide()) === null || u === void 0
              ? void 0
              : u.triggerEl;
          if (d) {
            const m = new CustomEvent("slideTo", {
              bubbles: !0,
              cancelable: !0,
              detail: l.page,
            });
            d.dispatchEvent(m);
          }
        }),
        a.on(["refresh", "change"], (l) => {
          const u = this.container;
          if (!u) return;
          for (const g of u.querySelectorAll("[data-fancybox-current-index]"))
            g.innerHTML = l.page + 1;
          for (const g of u.querySelectorAll("[data-fancybox-count]"))
            g.innerHTML = l.pages.length;
          if (!l.isInfinite) {
            for (const g of u.querySelectorAll("[data-fancybox-next]"))
              l.page < l.pages.length - 1
                ? (g.removeAttribute(Eh), g.removeAttribute(uf))
                : (g.setAttribute(Eh, ""), g.setAttribute(uf, "-1"));
            for (const g of u.querySelectorAll("[data-fancybox-prev]"))
              l.page > 0
                ? (g.removeAttribute(Eh), g.removeAttribute(uf))
                : (g.setAttribute(Eh, ""), g.setAttribute(uf, "-1"));
          }
          const d = this.getSlide();
          if (!d) return;
          let m = d.downloadSrc || "";
          m || d.type !== "image" || d.error || !_c(d[Ch]) || (m = d[Ch]);
          for (const g of u.querySelectorAll("[data-fancybox-download]")) {
            const v = d.downloadFilename;
            m
              ? (g.removeAttribute(Eh),
                g.removeAttribute(uf),
                g.setAttribute(t_, m),
                g.setAttribute(rE, v || m),
                g.setAttribute("target", "_blank"))
              : (g.setAttribute(Eh, ""),
                g.setAttribute(uf, "-1"),
                g.removeAttribute(t_),
                g.removeAttribute(rE));
          }
        }),
        this.emit("initCarousel"));
    }
    attachEvents() {
      const e = this,
        n = e.container;
      if (!n) return;
      (n.addEventListener("click", e.onClick, { passive: !1, capture: !1 }),
        n.addEventListener("wheel", e.onWheel, { passive: !1, capture: !1 }),
        document.addEventListener("keydown", e.onKeydown, {
          passive: !1,
          capture: !0,
        }),
        document.addEventListener("visibilitychange", e.onVisibilityChange, !1),
        document.addEventListener("mousemove", e.onMousemove),
        e.option("trapFocus") &&
          document.addEventListener("focus", e.onFocus, !0),
        window.addEventListener("resize", e.onResize));
      const i = window.visualViewport;
      i &&
        (i.addEventListener("scroll", e.onResize),
        i.addEventListener("resize", e.onResize));
    }
    detachEvents() {
      const e = this,
        n = e.container;
      if (!n) return;
      (document.removeEventListener("keydown", e.onKeydown, {
        passive: !1,
        capture: !0,
      }),
        n.removeEventListener("wheel", e.onWheel, { passive: !1, capture: !1 }),
        n.removeEventListener("click", e.onClick, { passive: !1, capture: !1 }),
        document.removeEventListener("mousemove", e.onMousemove),
        window.removeEventListener("resize", e.onResize));
      const i = window.visualViewport;
      (i &&
        (i.removeEventListener("resize", e.onResize),
        i.removeEventListener("scroll", e.onResize)),
        document.removeEventListener(
          "visibilitychange",
          e.onVisibilityChange,
          !1,
        ),
        document.removeEventListener("focus", e.onFocus, !0));
    }
    scale() {
      const e = this.container;
      if (!e) return;
      const n = window.visualViewport,
        i = Math.max(1, (n == null ? void 0 : n.scale) || 1);
      let a = "",
        l = "",
        u = "";
      if (n && i > 1) {
        let d = `${n.offsetLeft}px`,
          m = `${n.offsetTop}px`;
        ((a = n.width * i + "px"),
          (l = n.height * i + "px"),
          (u = `translate3d(${d}, ${m}, 0) scale(${1 / i})`));
      }
      ((e.style.transform = u), (e.style.width = a), (e.style.height = l));
    }
    onClick(e) {
      var n;
      const { container: i, isCompact: a } = this;
      if (!i || this.isClosing()) return;
      !a && this.option("idle") && this.resetIdle();
      const l = e.composedPath()[0];
      if (l.closest(".fancybox-spinner") || l.closest("[data-fancybox-close]"))
        return (e.preventDefault(), void this.close(e));
      if (l.closest("[data-fancybox-prev]"))
        return (e.preventDefault(), void this.prev());
      if (l.closest("[data-fancybox-next]"))
        return (e.preventDefault(), void this.next());
      if (
        (e.type === "click" && e.detail === 0) ||
        Math.abs(e.pageX - lE) > 30 ||
        Math.abs(e.pageY - oE) > 30
      )
        return;
      const u = document.activeElement;
      if (aE() && u && i.contains(u)) return;
      if (
        a &&
        ((n = this.getSlide()) === null || n === void 0 ? void 0 : n.type) ===
          "image"
      )
        return void (this.clickTimer
          ? (clearTimeout(this.clickTimer), (this.clickTimer = null))
          : (this.clickTimer = setTimeout(() => {
              (this.toggleIdle(), (this.clickTimer = null));
            }, 350)));
      if ((this.emit("click", e), e.defaultPrevented)) return;
      let d = !1;
      if (l.closest(".fancybox__content")) {
        if (u) {
          if (u.closest("[contenteditable]")) return;
          l.matches($x) || u.blur();
        }
        if (aE()) return;
        d = this.option("contentClick");
      } else
        l.closest(".fancybox__carousel") &&
          !l.matches($x) &&
          (d = this.option("backdropClick"));
      d === "close"
        ? (e.preventDefault(), this.close(e))
        : d === "next"
          ? (e.preventDefault(), this.next())
          : d === "prev" && (e.preventDefault(), this.prev());
    }
    onWheel(e) {
      const n = e.target;
      let i = this.option("wheel", e);
      n.closest(".fancybox__thumbs") && (i = "slide");
      const a = i === "slide",
        l = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(
          function (m, g) {
            return Math.abs(g) > Math.abs(m) ? g : m;
          },
        ),
        u = Math.max(-1, Math.min(1, l)),
        d = Date.now();
      this.pwt && d - this.pwt < 300
        ? a && e.preventDefault()
        : ((this.pwt = d),
          this.emit("wheel", e, u),
          e.defaultPrevented ||
            (i === "close"
              ? (e.preventDefault(), this.close(e))
              : i === "slide" &&
                (bb(n) ||
                  (e.preventDefault(), this[u > 0 ? "prev" : "next"]()))));
    }
    onScroll() {
      window.scrollTo(cE, uE);
    }
    onKeydown(e) {
      if (!this.isTopmost()) return;
      this.isCompact ||
        !this.option("idle") ||
        this.isClosing() ||
        this.resetIdle();
      const n = e.key,
        i = this.option("keyboard");
      if (!i) return;
      const a = e.composedPath()[0],
        l = document.activeElement && document.activeElement.classList,
        u =
          (l && l.contains("f-button")) ||
          a.dataset.carouselPage ||
          a.dataset.carouselIndex;
      if (
        (n !== "Escape" &&
          !u &&
          Hs(a) &&
          (a.isContentEditable ||
            ["TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].indexOf(
              a.nodeName,
            ) !== -1)) ||
        (e.key === "Tab" ? Ye(this.container, Kx) : $t(this.container, Kx),
        e.ctrlKey || e.altKey || e.shiftKey)
      )
        return;
      this.emit("keydown", n, e);
      const d = i[n];
      d && typeof this[d] == "function" && (e.preventDefault(), this[d]());
    }
    onResize() {
      const e = this.container;
      if (!e) return;
      const n = this.isCompact;
      (e.classList.toggle(iE, n),
        this.manageCaption(this.getSlide()),
        this.isCompact ? this.clearIdle() : this.endIdle(),
        this.scale(),
        this.emit("resize"));
    }
    onFocus(e) {
      this.isTopmost() && this.checkFocus(e);
    }
    onMousemove(e) {
      ((this.prevMouseMoveEvent = e),
        !this.isCompact && this.option("idle") && this.resetIdle());
    }
    onVisibilityChange() {
      document.visibilityState === "visible"
        ? this.checkFocus()
        : this.endIdle();
    }
    manageCloseBtn(e) {
      const n = this.optionFor(e, "closeButton") || !1;
      if (n === "auto") {
        const a = this.plugins.Toolbar;
        if (a && a.state === vf.Ready) return;
      }
      if (!n || !e.contentEl || e.closeBtnEl) return;
      const i = this.option("tpl.closeButton");
      if (i) {
        const a = hl(this.localize(i));
        ((e.closeBtnEl = e.contentEl.appendChild(a)),
          e.el && Ye(e.el, "has-close-btn"));
      }
    }
    manageCaption(e = void 0) {
      var n, i;
      const a = "fancybox__caption",
        l = this.container;
      if (!l) return;
      $t(l, F0);
      const u = this.isCompact || this.option("commonCaption"),
        d = !u;
      if (
        (this.caption && this.stop(this.caption),
        d && this.caption && (this.caption.remove(), (this.caption = null)),
        u && !this.caption)
      )
        for (const y of ((n = this.carousel) === null || n === void 0
          ? void 0
          : n.slides) || [])
          y.captionEl &&
            (y.captionEl.remove(),
            (y.captionEl = void 0),
            $t(y.el, F0),
            (i = y.el) === null ||
              i === void 0 ||
              i.removeAttribute("aria-labelledby"));
      if ((e || (e = this.getSlide()), !e || (u && !this.isCurrentSlide(e))))
        return;
      const m = e.el;
      let g = this.optionFor(e, "caption", "");
      if (!g)
        return void (
          u &&
          this.caption &&
          this.animate(this.caption, "f-fadeOut", () => {
            this.caption && (this.caption.innerHTML = "");
          })
        );
      let v = null;
      if (d) {
        if (((v = e.captionEl || null), m && !v)) {
          const y = a + `_${this.id}_${e.index}`;
          ((v = document.createElement("div")),
            Ye(v, a),
            v.setAttribute("id", y),
            (e.captionEl = m.appendChild(v)),
            Ye(m, F0),
            m.setAttribute("aria-labelledby", y));
        }
      } else
        ((v = this.caption),
          v || (v = l.querySelector("." + a)),
          !v &&
            ((v = document.createElement("div")),
            (v.dataset.fancyboxCaption = ""),
            Ye(v, a),
            (this.footer || l).prepend(v)),
          Ye(l, F0),
          (this.caption = v));
      v &&
        ((v.innerHTML = ""),
        _c(g) || typeof g == "number"
          ? (v.innerHTML = g + "")
          : g instanceof HTMLElement && v.appendChild(g));
    }
    checkFocus(e) {
      this.focus(e);
    }
    focus(e) {
      var n;
      if (this.ignoreFocusChange) return;
      const i = document.activeElement || null,
        a = (e == null ? void 0 : e.target) || null,
        l = this.container,
        u = (n = this.carousel) === null || n === void 0 ? void 0 : n.viewport;
      if (!l || !u || (!e && i && l.contains(i))) return;
      const d = this.getSlide(),
        m = d && d.state === zi.Ready ? d.el : null;
      if (!m || m.contains(i) || l === i) return;
      (e && e.cancelable && e.preventDefault(), (this.ignoreFocusChange = !0));
      const g = Array.from(l.querySelectorAll($x));
      let v = [],
        y = null;
      for (let S of g) {
        const T = !S.offsetParent || !!S.closest('[aria-hidden="true"]'),
          E = m && m.contains(S),
          j = !u.contains(S);
        if (S === l || ((E || j) && !T)) {
          v.push(S);
          const O = S.dataset.origTabindex;
          (O !== void 0 && O && (S.tabIndex = parseFloat(O)),
            S.removeAttribute("data-orig-tabindex"),
            (!S.hasAttribute("autoFocus") && y) || (y = S));
        } else {
          const O =
            S.dataset.origTabindex === void 0
              ? S.getAttribute("tabindex") || ""
              : S.dataset.origTabindex;
          (O && (S.dataset.origTabindex = O), (S.tabIndex = -1));
        }
      }
      let w = null;
      (e
        ? (!a || v.indexOf(a) < 0) &&
          ((w = y || l),
          v.length &&
            (i === ff
              ? (w = v[0])
              : (this.lastFocus !== l && i !== Lr) || (w = v[v.length - 1])))
        : (w = d && d.type === "image" ? l : y || l),
        w && $T(w),
        (this.lastFocus = document.activeElement),
        (this.ignoreFocusChange = !1));
    }
    next() {
      const e = this.carousel;
      e && e.pages.length > 1 && e.slideNext();
    }
    prev() {
      const e = this.carousel;
      e && e.pages.length > 1 && e.slidePrev();
    }
    jumpTo(...e) {
      this.carousel && this.carousel.slideTo(...e);
    }
    isTopmost() {
      var e;
      return (
        ((e = At.getInstance()) === null || e === void 0 ? void 0 : e.id) ==
        this.id
      );
    }
    animate(e = null, n = "", i) {
      if (!e || !n) return void (i && i());
      this.stop(e);
      const a = (l) => {
        l.target === e &&
          e.dataset.animationName &&
          (e.removeEventListener("animationend", a),
          delete e.dataset.animationName,
          i && i(),
          $t(e, n));
      };
      ((e.dataset.animationName = n),
        e.addEventListener("animationend", a),
        Ye(e, n));
    }
    stop(e) {
      e &&
        e.dispatchEvent(
          new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: e,
          }),
        );
    }
    setContent(e, n = "", i = !0) {
      if (this.isClosing()) return;
      const a = e.el;
      if (!a) return;
      let l = null;
      if (
        (Hs(n)
          ? (l = n)
          : ((l = hl(n + "")),
            Hs(l) ||
              ((l = document.createElement("div")), (l.innerHTML = n + ""))),
        ["img", "picture", "iframe", "video", "audio"].includes(
          l.nodeName.toLowerCase(),
        ))
      ) {
        const u = document.createElement("div");
        (u.appendChild(l), (l = u));
      }
      (Hs(l) && e.filter && !e.error && (l = l.querySelector(e.filter)),
        l && Hs(l)
          ? (Ye(l, "fancybox__content"),
            e.id && l.setAttribute("id", e.id),
            a.classList.add(`has-${e.error ? "error" : e.type || "unknown"}`),
            a.prepend(l),
            l.style.display === "none" && (l.style.display = ""),
            getComputedStyle(l).getPropertyValue("display") === "none" &&
              (l.style.display =
                e.display || this.option("defaultDisplay") || "flex"),
            (e.contentEl = l),
            i && this.revealContent(e),
            this.manageCloseBtn(e),
            this.manageCaption(e))
          : this.setError(e, "{{ELEMENT_NOT_FOUND}}"));
    }
    revealContent(e, n) {
      const i = e.el,
        a = e.contentEl;
      i &&
        a &&
        (this.emit("reveal", e),
        this.hideLoading(e),
        (e.state = zi.Opening),
        (n = this.isOpeningSlide(e)
          ? n === void 0
            ? this.optionFor(e, "showClass")
            : n
          : "f-fadeIn")
          ? this.animate(a, n, () => {
              this.done(e);
            })
          : this.done(e));
    }
    done(e) {
      this.isClosing() ||
        ((e.state = zi.Ready),
        this.emit("done", e),
        Ye(e.el, "is-done"),
        this.isCurrentSlide(e) &&
          this.option("autoFocus") &&
          queueMicrotask(() => {
            var n;
            ((n = e.panzoom) === null || n === void 0 || n.updateControls(),
              this.option("autoFocus") && this.focus());
          }),
        this.isOpeningSlide(e) &&
          ($t(this.container, e_),
          !this.isCompact && this.option("idle") && this.setIdle()));
    }
    isCurrentSlide(e) {
      const n = this.getSlide();
      return !(!e || !n) && n.index === e.index;
    }
    isOpeningSlide(e) {
      var n, i;
      return (
        ((n = this.carousel) === null || n === void 0 ? void 0 : n.prevPage) ===
          null &&
        e &&
        e.index ===
          ((i = this.getSlide()) === null || i === void 0 ? void 0 : i.index)
      );
    }
    showLoading(e) {
      e.state = zi.Loading;
      const n = e.el;
      n &&
        (Ye(n, sE),
        this.emit("loading", e),
        e.spinnerEl ||
          setTimeout(() => {
            if (!this.isClosing() && !e.spinnerEl && e.state === zi.Loading) {
              let i = hl(kw);
              (Ye(i, "fancybox-spinner"),
                (e.spinnerEl = i),
                n.prepend(i),
                this.animate(i, "f-fadeIn"));
            }
          }, 250));
    }
    hideLoading(e) {
      const n = e.el;
      if (!n) return;
      const i = e.spinnerEl;
      this.isClosing()
        ? i == null || i.remove()
        : ($t(n, sE),
          i &&
            this.animate(i, "f-fadeOut", () => {
              i.remove();
            }),
          e.state === zi.Loading &&
            (this.emit("loaded", e), (e.state = zi.Ready)));
    }
    setError(e, n) {
      if (this.isClosing()) return;
      const i = new Event("error", { bubbles: !0, cancelable: !0 });
      if ((this.emit("error", i, e), i.defaultPrevented)) return;
      ((e.error = n), this.hideLoading(e), this.clearContent(e));
      const a = document.createElement("div");
      (a.classList.add("fancybox-error"),
        (a.innerHTML = this.localize(n || "<p>{{ERROR}}</p>")),
        this.setContent(e, a));
    }
    clearContent(e) {
      if (e.state === void 0) return;
      (this.emit("clearContent", e),
        e.contentEl && (e.contentEl.remove(), (e.contentEl = void 0)));
      const n = e.el;
      (n &&
        ($t(n, "has-error"),
        $t(n, "has-unknown"),
        $t(n, `has-${e.type || "unknown"}`)),
        e.closeBtnEl && e.closeBtnEl.remove(),
        (e.closeBtnEl = void 0),
        e.captionEl && e.captionEl.remove(),
        (e.captionEl = void 0),
        e.spinnerEl && e.spinnerEl.remove(),
        (e.spinnerEl = void 0));
    }
    getSlide() {
      var e;
      const n = this.carousel;
      return (
        ((e = n == null ? void 0 : n.pages[n == null ? void 0 : n.page]) ===
          null || e === void 0
          ? void 0
          : e.slides[0]) || void 0
      );
    }
    close(e, n) {
      if (this.isClosing()) return;
      const i = new Event("shouldClose", { bubbles: !0, cancelable: !0 });
      if ((this.emit("shouldClose", i, e), i.defaultPrevented)) return;
      e && e.cancelable && (e.preventDefault(), e.stopPropagation());
      const a = () => {
        this.proceedClose(e, n);
      };
      this.startedFs && Rr && Rr.isFullscreen()
        ? Promise.resolve(Rr.exit()).then(() => a())
        : a();
    }
    clearIdle() {
      (this.idleTimer && clearTimeout(this.idleTimer), (this.idleTimer = null));
    }
    setIdle(e = !1) {
      const n = () => {
        (this.clearIdle(),
          (this.idle = !0),
          Ye(this.container, "is-idle"),
          this.emit("setIdle"));
      };
      if ((this.clearIdle(), !this.isClosing()))
        if (e) n();
        else {
          const i = this.option("idle");
          i && (this.idleTimer = setTimeout(n, i));
        }
    }
    endIdle() {
      (this.clearIdle(),
        this.idle &&
          !this.isClosing() &&
          ((this.idle = !1),
          $t(this.container, "is-idle"),
          this.emit("endIdle")));
    }
    resetIdle() {
      (this.endIdle(), this.setIdle());
    }
    toggleIdle() {
      this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
      Rr &&
        (Rr.isFullscreen()
          ? Rr.exit()
          : Rr.request().then(() => {
              this.startedFs = !0;
            }));
    }
    isClosing() {
      return [fi.Closing, fi.CustomClosing, fi.Destroy].includes(this.state);
    }
    proceedClose(e, n) {
      var i, a;
      ((this.state = fi.Closing), this.clearIdle(), this.detachEvents());
      const l = this.container,
        u = this.carousel,
        d = this.getSlide(),
        m =
          d && this.option("placeFocusBack")
            ? d.triggerEl || this.option("triggerEl")
            : null;
      if (
        (m && (UC(m) ? $T(m) : m.focus()),
        l &&
          ($t(l, e_),
          Ye(l, "is-closing"),
          l.setAttribute(Zx, "true"),
          this.option("animated") && Ye(l, Jx),
          (l.style.pointerEvents = "none")),
        u)
      ) {
        (u.clearTransitions(),
          (i = u.panzoom) === null || i === void 0 || i.destroy(),
          (a = u.plugins.Navigation) === null || a === void 0 || a.detach());
        for (const g of u.slides) {
          ((g.state = zi.Closing), this.hideLoading(g));
          const v = g.contentEl;
          v && this.stop(v);
          const y = g == null ? void 0 : g.panzoom;
          (y && (y.stop(), y.detachEvents(), y.detachObserver()),
            this.isCurrentSlide(g) || u.emit("removeSlide", g));
        }
      }
      ((cE = window.scrollX),
        (uE = window.scrollY),
        window.addEventListener("scroll", this.onScroll),
        this.emit("close", e),
        this.state !== fi.CustomClosing
          ? (n === void 0 && d && (n = this.optionFor(d, "hideClass")),
            n && d
              ? (this.animate(d.contentEl, n, () => {
                  u && u.emit("removeSlide", d);
                }),
                setTimeout(() => {
                  this.destroy();
                }, 500))
              : this.destroy())
          : setTimeout(() => {
              this.destroy();
            }, 500));
    }
    destroy() {
      var e;
      if (this.state === fi.Destroy) return;
      (window.removeEventListener("scroll", this.onScroll),
        (this.state = fi.Destroy),
        (e = this.carousel) === null || e === void 0 || e.destroy());
      const n = this.container;
      (n && n.remove(), Oh.delete(this.id));
      const i = At.getInstance();
      i
        ? i.focus()
        : (Lr && (Lr.remove(), (Lr = null)),
          ff && (ff.remove(), (ff = null)),
          $t(document.documentElement, eE),
          (() => {
            if (!wg) return;
            const a = document,
              l = a.body;
            (l.classList.remove(Qx),
              l.style.setProperty(nE, ""),
              a.documentElement.style.setProperty(tE, ""));
          })(),
          this.emit("destroy"));
    }
    static bind(e, n, i) {
      if (!wg) return;
      let a,
        l = "",
        u = {};
      if (
        (e === void 0
          ? (a = document.body)
          : _c(e)
            ? ((a = document.body),
              (l = e),
              typeof n == "object" && (u = n || {}))
            : ((a = e),
              _c(n) && (l = n),
              typeof i == "object" && (u = i || {})),
        !a || !Hs(a))
      )
        return;
      l = l || "[data-fancybox]";
      const d = At.openers.get(a) || new Map();
      (d.set(l, u),
        At.openers.set(a, d),
        d.size === 1 && a.addEventListener("click", At.fromEvent));
    }
    static unbind(e, n) {
      let i,
        a = "";
      if (
        (_c(e) ? ((i = document.body), (a = e)) : ((i = e), _c(n) && (a = n)),
        !i)
      )
        return;
      const l = At.openers.get(i);
      (l && a && l.delete(a),
        (a && l) ||
          (At.openers.delete(i), i.removeEventListener("click", At.fromEvent)));
    }
    static destroy() {
      let e;
      for (; (e = At.getInstance()); ) e.destroy();
      for (const n of At.openers.keys())
        n.removeEventListener("click", At.fromEvent);
      At.openers = new Map();
    }
    static fromEvent(e) {
      if (
        e.defaultPrevented ||
        (e.button && e.button !== 0) ||
        e.ctrlKey ||
        e.metaKey ||
        e.shiftKey
      )
        return;
      let n = e.composedPath()[0];
      const i = n.closest("[data-fancybox-trigger]");
      if (i) {
        const T = i.dataset.fancyboxTrigger || "",
          E = document.querySelectorAll(`[data-fancybox="${T}"]`),
          j = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
        n = E[j] || n;
      }
      if (!(n && n instanceof Element)) return;
      let a, l, u, d;
      if (
        ([...At.openers].reverse().find(
          ([T, E]) =>
            !(
              !T.contains(n) ||
              ![...E].reverse().find(([j, O]) => {
                let M = n.closest(j);
                return !!M && ((a = T), (l = j), (u = M), (d = O), !0);
              })
            ),
        ),
        !a || !l || !u)
      )
        return;
      ((d = d || {}), e.preventDefault(), (n = u));
      let m = [],
        g = Ys({}, Z_, d);
      ((g.event = e), (g.triggerEl = n), (g.delegate = i));
      const v = g.groupAll,
        y = g.groupAttr,
        w = y && n ? n.getAttribute(`${y}`) : "";
      if (
        ((!n || w || v) && (m = [].slice.call(a.querySelectorAll(l))),
        n &&
          !v &&
          (m = w ? m.filter((T) => T.getAttribute(`${y}`) === w) : [n]),
        !m.length)
      )
        return;
      const S = At.getInstance();
      return S && S.options.triggerEl && m.indexOf(S.options.triggerEl) > -1
        ? void 0
        : (n && (g.startIndex = m.indexOf(n)), At.fromNodes(m, g));
    }
    static fromSelector(e, n, i) {
      let a = null,
        l = "",
        u = {};
      if (
        (_c(e)
          ? ((a = document.body),
            (l = e),
            typeof n == "object" && (u = n || {}))
          : e instanceof HTMLElement &&
            _c(n) &&
            ((a = e), (l = n), typeof i == "object" && (u = i || {})),
        !a || !l)
      )
        return !1;
      const d = At.openers.get(a);
      return (
        !!d &&
        ((u = Ys({}, d.get(l) || {}, u)),
        !!u && At.fromNodes(Array.from(a.querySelectorAll(l)), u))
      );
    }
    static fromNodes(e, n) {
      n = Ys({}, Z_, n || {});
      const i = [];
      for (const a of e) {
        const l = a.dataset || {},
          u =
            l[Ch] ||
            a.getAttribute(t_) ||
            a.getAttribute("currentSrc") ||
            a.getAttribute(Ch) ||
            void 0;
        let d;
        const m = n.delegate;
        let g;
        (m &&
          i.length === n.startIndex &&
          (d =
            m instanceof HTMLImageElement
              ? m
              : m.querySelector("img:not([aria-hidden])")),
          d ||
            (d =
              a instanceof HTMLImageElement
                ? a
                : a.querySelector("img:not([aria-hidden])")),
          d &&
            ((g = d.currentSrc || d[Ch] || void 0),
            !g &&
              d.dataset &&
              (g = d.dataset.lazySrc || d.dataset[Ch] || void 0)));
        const v = {
          src: u,
          triggerEl: a,
          thumbEl: d,
          thumbElSrc: g,
          thumbSrc: g,
        };
        for (const y in l) {
          let w = l[y] + "";
          ((w = w !== "false" && (w === "true" || w)), (v[y] = w));
        }
        i.push(v);
      }
      return new At(i, n);
    }
    static getInstance(e) {
      return e
        ? Oh.get(e)
        : Array.from(Oh.values())
            .reverse()
            .find((n) => !n.isClosing() && n) || null;
    }
    static getSlide() {
      var e;
      return (
        ((e = At.getInstance()) === null || e === void 0
          ? void 0
          : e.getSlide()) || null
      );
    }
    static show(e = [], n = {}) {
      return new At(e, n);
    }
    static next() {
      const e = At.getInstance();
      e && e.next();
    }
    static prev() {
      const e = At.getInstance();
      e && e.prev();
    }
    static close(e = !0, ...n) {
      if (e) for (const i of Oh.values()) i.close(...n);
      else {
        const i = At.getInstance();
        i && i.close(...n);
      }
    }
  }
  (Object.defineProperty(At, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36",
  }),
    Object.defineProperty(At, "defaults", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: Z_,
    }),
    Object.defineProperty(At, "Plugins", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: N4,
    }),
    Object.defineProperty(At, "openers", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: new Map(),
    }));
  const R4 = () => {
      var m;
      const { slug: t } = Ir(),
        { instance: e } = si(),
        n = sn(),
        i = nt((g) => g.selectedLanguage.selectedLanguage),
        [a, l] = U.useState(null),
        [u, d] = U.useState(!0);
      return (
        U.useEffect(() => {
          t &&
            (async () => {
              var v;
              try {
                d(!0);
                const y = await e.get(`gallery-photos/${t}`);
                y.data
                  ? l((v = y.data) == null ? void 0 : v.data)
                  : console.log(y.status);
              } catch (y) {
                console.log("Error:", y);
              } finally {
                d(!1);
              }
            })();
        }, [t]),
        U.useEffect(() => {
          if (a) {
            const g = a.slug[i];
            n(`/qalereya/sekiller/${i}/${g}`, { replace: !0 });
          }
        }, [i, a]),
        U.useEffect(
          () => (
            At.bind("[data-fancybox='gallery']", {}),
            () => {
              At.destroy();
            }
          ),
          [a],
        ),
        u
          ? h.jsx(ze, { style: { height: "100vh" } })
          : h.jsxs("main", {
              className: "gallery-inner-page-wrapper",
              children: [
                h.jsx("title", {
                  children: (a == null ? void 0 : a.title) || t || "Qalereya",
                }),
                h.jsx("meta", {
                  name: "description",
                  content: (a == null ? void 0 : a.seo_description) ?? "",
                }),
                h.jsxs("div", {
                  className: "gallery-inner-page",
                  children: [
                    h.jsxs("article", {
                      className: "title-main",
                      children: [
                        h.jsx("p", { children: a == null ? void 0 : a.date }),
                        h.jsx("h1", { children: a == null ? void 0 : a.title }),
                      ],
                    }),
                    h.jsx("div", {
                      className: "inner-images",
                      children:
                        (m = a == null ? void 0 : a.media) == null
                          ? void 0
                          : m.map((g) =>
                              h.jsx(
                                "div",
                                {
                                  className: "image",
                                  children: h.jsx("a", {
                                    "data-fancybox": "gallery",
                                    href: g == null ? void 0 : g.image,
                                    children: h.jsx("img", {
                                      src: g == null ? void 0 : g.image,
                                      alt: `Gallery image ${g.id}`,
                                    }),
                                  }),
                                },
                                g == null ? void 0 : g.id,
                              ),
                            ),
                    }),
                  ],
                }),
              ],
            })
      );
    },
    L4 = () => {
      var w;
      const { slug: t } = Ir(),
        { instance: e } = si(),
        n = sn(),
        i = nt((S) => S.selectedLanguage.selectedLanguage),
        [a, l] = U.useState(null),
        [u, d] = U.useState(!0);
      (U.useEffect(() => {
        t &&
          (async () => {
            var T;
            try {
              d(!0);
              const E = await e.get(`gallery-videos/${t}`);
              E.data
                ? l((T = E.data) == null ? void 0 : T.data)
                : console.log(E.status);
            } catch (E) {
              console.log("Error:", E);
            } finally {
              d(!1);
            }
          })();
      }, [t]),
        U.useEffect(() => {
          if (a) {
            const S = a.slug[i];
            n(`/qalereya/videolar/${i}/${S}`, { replace: !0 });
          }
        }, [i, a]));
      const m = U.useRef({}),
        [g, v] = U.useState(null),
        y = (S) => {
          var T, E;
          (g !== null &&
            m.current[g] &&
            ((T = m.current[g]) == null || T.pause()),
            m.current[S] && (v(S), (E = m.current[S]) == null || E.play()));
        };
      return u
        ? h.jsx(ze, {})
        : h.jsxs("main", {
            className: "gallery-inner-page-wrapper",
            children: [
              h.jsx("title", {
                children: (a == null ? void 0 : a.title) || t || "Videolar",
              }),
              h.jsx("meta", {
                name: "description",
                content: (a == null ? void 0 : a.seo_description) ?? "",
              }),
              h.jsxs("div", {
                className: "gallery-inner-page",
                children: [
                  h.jsx("article", {
                    className: "title-main",
                    children: h.jsx("h1", {
                      children: a == null ? void 0 : a.title,
                    }),
                  }),
                  h.jsx("div", {
                    className: "inner-videos",
                    children:
                      (w = a == null ? void 0 : a.media) == null
                        ? void 0
                        : w.map((S) =>
                            h.jsxs(
                              "div",
                              {
                                className: "video",
                                children: [
                                  h.jsx(u4, {
                                    onClick: () => y(S == null ? void 0 : S.id),
                                    className: "play-circle",
                                    style: {
                                      display:
                                        g === (S == null ? void 0 : S.id)
                                          ? "none"
                                          : "",
                                    },
                                  }),
                                  h.jsx("video", {
                                    controls: g === (S == null ? void 0 : S.id),
                                    muted: !0,
                                    ref: (T) => (m.current[S.id] = T),
                                    src: S == null ? void 0 : S.image,
                                    onPause: () => v(null),
                                  }),
                                ],
                              },
                              S == null ? void 0 : S.id,
                            ),
                          ),
                  }),
                ],
              }),
            ],
          });
    },
    JC = ({ title: t, customStyle: e, href: n }) =>
      h.jsxs(_t, {
        to: n || "",
        style: e,
        className: "for-more-button-ui",
        children: [
          h.jsx("p", { children: t }),
          h.jsx("div", {
            className: "wrap",
            children: h.jsx("img", { src: "/right.svg", alt: "right-arrow" }),
          }),
        ],
      }),
    tOThumbnail = (t) => {
      try {
        const e = new URL(t),
          n = e.hostname.includes("youtu.be")
            ? e.pathname.split("/").filter(Boolean)[0]
            : e.pathname.includes("/embed/")
              ? e.pathname.split("/embed/")[1].split("/")[0]
              : e.searchParams.get("v");
        return n ? "/video-placeholder.svg" : "/video-placeholder.svg";
      } catch {
        return "/video-placeholder.svg";
      }
    },
    eO = ({ data: t, customStyle: e }) => {
      const n = sn(),
        i = nt((a) => a.selectedLanguage.selectedLanguage);
      return h.jsxs("article", {
        onClick: () => n(`/elanlar/${i}/${t == null ? void 0 : t.slug[i]}`),
        className: "announcement-card",
        style: e,
        children: [
          h.jsx("div", {
            className: "image-announcement",
            children:
              (t == null ? void 0 : t.file_type) === "image"
                ? h.jsx("img", {
                    src: t == null ? void 0 : t.image,
                    alt: t == null ? void 0 : t.title,
                  })
                : h.jsxs("a", {
                    className: "lite-video-embed",
                    href: t == null ? void 0 : t.image,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "aria-label": "Videonu YouTube-da aç",
                    children: [
                      h.jsx("img", {
                        src: tOThumbnail(t == null ? void 0 : t.image),
                        alt: t == null ? void 0 : t.title,
                      }),
                      h.jsx("span", { "aria-hidden": "true", children: "▶" }),
                    ],
                  }),
          }),
          h.jsxs("div", {
            className: "right",
            children: [
              h.jsxs("div", {
                className: "top-desc",
                children: [
                  h.jsxs("div", {
                    className: "top-viewed",
                    children: [
                      h.jsxs("div", {
                        className: "left-view",
                        children: [
                          h.jsx("img", { src: "/view.svg", alt: "" }),
                          h.jsx("p", { children: t == null ? void 0 : t.view }),
                        ],
                      }),
                      h.jsx("p", {
                        className: "time",
                        children: t == null ? void 0 : t.date,
                      }),
                    ],
                  }),
                  h.jsx("h2", { children: t == null ? void 0 : t.title }),
                  h.jsx("p", { children: t == null ? void 0 : t.subtitle }),
                ],
              }),
              h.jsx(JC, { title: "Daha ətraflı", href: "/" }),
            ],
          }),
        ],
      });
    },
    D4 = () => {
      const { instance: t } = si(),
        [e, n] = U.useState([]),
        [i, a] = U.useState(!1),
        [l, u] = U.useState(!1),
        [d, m] = U.useState(1);
      return {
        fetchAnnouncements: async (v) => {
          var y, w;
          v === 1 ? a(!0) : u(!0);
          try {
            const S = await t.get(`advertisements?page=${v}`);
            S.data &&
              (n((T) => (v === 1 ? S.data.data : [...T, ...S.data.data])),
              m(
                ((w = (y = S.data) == null ? void 0 : y.meta) == null
                  ? void 0
                  : w.last_page) || 1,
              ));
          } catch (S) {
            console.log(S);
          } finally {
            (a(!1), u(!1));
          }
        },
        ann: e,
        lastPage: d,
        isInitialLoading: i,
        isLoadingMore: l,
      };
    },
    k4 = () => {
      const [t, e] = U.useState(1),
        {
          ann: n,
          fetchAnnouncements: i,
          isInitialLoading: a,
          isLoadingMore: l,
          lastPage: u,
        } = D4();
      console.log(n);
      const d = () => {
        t < u && e((m) => m + 1);
      };
      return (
        U.useEffect(() => {
          i(t);
        }, [t]),
        a
          ? h.jsx(ze, {})
          : h.jsxs("main", {
              className: "announcement-page-wrapper",
              children: [
                h.jsx("title", { children: "Elanlar" }),
                h.jsxs("div", {
                  className: "announcement-page",
                  children: [
                    h.jsx(xi, { mutation: !0, title: "Elanlar" }),
                    h.jsx("div", {
                      className: "grid-announcements",
                      children:
                        n == null
                          ? void 0
                          : n.map((m) =>
                              h.jsx(
                                eO,
                                {
                                  customStyle: { backgroundColor: "#F5F5F5" },
                                  data: m,
                                },
                                m == null ? void 0 : m.id,
                              ),
                            ),
                    }),
                    h.jsx(np, {
                      initialValue: 12,
                      next: t,
                      counterValue: 12,
                      dataLength: n == null ? void 0 : n.length,
                      setNext: d,
                      title: l ? "Yüklənir..." : "Daha çox",
                    }),
                  ],
                }),
              ],
            })
      );
    },
    z4 = () => {
      const t = ys(),
        e = window.location.origin + t.pathname + t.search,
        [n, i] = U.useState(!1),
        a = async () => {
          i(!0);
          try {
            (await navigator.clipboard.writeText(e), xt.success("Copied!"));
          } catch (l) {
            console.log(l);
          } finally {
            setTimeout(() => {
              i(!1);
            }, 1500);
          }
        };
      return h.jsxs("section", {
        className: "share-announcement",
        children: [
          h.jsx(_t, {
            to: "",
            className: "item",
            children: h.jsx("img", { src: "/xx.svg", alt: "X" }),
          }),
          h.jsx(_t, {
            to: "",
            className: "item",
            children: h.jsx("img", { src: "/wppp.svg", alt: "WhatsApp" }),
          }),
          h.jsx(_t, {
            to: "",
            className: "item",
            children: h.jsx("img", { src: "/facee.svg", alt: "Facebook" }),
          }),
          h.jsxs("div", {
            onClick: a,
            className: `share-url ${n ? "copied" : ""}`,
            children: [
              h.jsxs("div", {
                className: "text",
                children: [
                  h.jsx("img", { src: "/mkn.svg", alt: "mkn" }),
                  h.jsx("span", { className: "link", children: e }),
                ],
              }),
              h.jsx("img", { src: "/cp.svg", alt: "Copyurl" }),
            ],
          }),
        ],
      });
    },
    P4 = ({ data: t }) => {
      var l;
      const e = nt((u) => u.selectedLanguage.selectedLanguage),
        { innerData: n, dataLoading: i } = Et(
          `other-advertisements?item_id=${(t == null ? void 0 : t.id) || 0}`,
          "announcement_other_key",
        ),
        a =
          n != null &&
          n.data &&
          ((l = n == null ? void 0 : n.data) == null ? void 0 : l.length) > 0
            ? n == null
              ? void 0
              : n.data
            : [];
      return i
        ? h.jsx(ze, {})
        : h.jsxs("section", {
            className: "content-section",
            children: [
              h.jsxs("div", {
                className: "left-content",
                children: [
                  h.jsxs("div", {
                    className: "toptitle",
                    children: [
                      h.jsxs("div", {
                        className: "date",
                        children: [
                          h.jsx("span", {
                            children: t == null ? void 0 : t.date,
                          }),
                          h.jsxs("div", {
                            className: "viewed",
                            children: [
                              h.jsx("img", {
                                src: "/viewimg.svg",
                                alt: "view-icon",
                              }),
                              h.jsx("p", {
                                children: t == null ? void 0 : t.view,
                              }),
                            ],
                          }),
                        ],
                      }),
                      h.jsx(xi, {
                        title: (t == null ? void 0 : t.title) || "",
                        customStyle: { color: "#062151" },
                        mutation: !0,
                      }),
                    ],
                  }),
                  (t == null ? void 0 : t.description) &&
                    h.jsx("div", {
                      className: "description",
                      dangerouslySetInnerHTML: {
                        __html: ip.sanitize(
                          (t == null ? void 0 : t.description) || "",
                        ),
                      },
                    }),
                  h.jsx(z4, {}),
                ],
              }),
              h.jsx("div", {
                className: "right-content",
                children:
                  a == null
                    ? void 0
                    : a.map((u) =>
                        h.jsxs(
                          _t,
                          {
                            className: "item-last",
                            to: `/elanlar/${e}/${u == null ? void 0 : u.slug[e]}`,
                            children: [
                              h.jsxs("div", {
                                className: "top",
                                children: [
                                  h.jsx("p", {
                                    children: u == null ? void 0 : u.date,
                                  }),
                                  h.jsx(JM, { className: "right" }),
                                ],
                              }),
                              h.jsx("h4", {
                                children: u == null ? void 0 : u.title,
                              }),
                            ],
                          },
                          u == null ? void 0 : u.id,
                        ),
                      ),
              }),
            ],
          });
    };
  function I4(t, e, n, i) {
    return (
      t.params.createElements &&
        Object.keys(i).forEach((a) => {
          if (!n[a] && n.auto === !0) {
            let l = dl(t.el, `.${i[a]}`)[0];
            (l || ((l = mb("div", i[a])), (l.className = i[a]), t.el.append(l)),
              (n[a] = l),
              (e[a] = l));
          }
        }),
      n
    );
  }
  function hg(t) {
    return (
      t === void 0 && (t = ""),
      `.${t
        .trim()
        .replace(/([\.:!+\/()[\]])/g, "\\$1")
        .replace(/ /g, ".")}`
    );
  }
  function tO(t) {
    let { swiper: e, extendParams: n, on: i, emit: a } = t;
    const l = "swiper-pagination";
    (n({
      pagination: {
        el: null,
        bulletElement: "span",
        clickable: !1,
        hideOnClick: !1,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: !1,
        type: "bullets",
        dynamicBullets: !1,
        dynamicMainBullets: 1,
        formatFractionCurrent: (M) => M,
        formatFractionTotal: (M) => M,
        bulletClass: `${l}-bullet`,
        bulletActiveClass: `${l}-bullet-active`,
        modifierClass: `${l}-`,
        currentClass: `${l}-current`,
        totalClass: `${l}-total`,
        hiddenClass: `${l}-hidden`,
        progressbarFillClass: `${l}-progressbar-fill`,
        progressbarOppositeClass: `${l}-progressbar-opposite`,
        clickableClass: `${l}-clickable`,
        lockClass: `${l}-lock`,
        horizontalClass: `${l}-horizontal`,
        verticalClass: `${l}-vertical`,
        paginationDisabledClass: `${l}-disabled`,
      },
    }),
      (e.pagination = { el: null, bullets: [] }));
    let u,
      d = 0;
    function m() {
      return (
        !e.params.pagination.el ||
        !e.pagination.el ||
        (Array.isArray(e.pagination.el) && e.pagination.el.length === 0)
      );
    }
    function g(M, N) {
      const { bulletActiveClass: R } = e.params.pagination;
      M &&
        ((M = M[`${N === "prev" ? "previous" : "next"}ElementSibling`]),
        M &&
          (M.classList.add(`${R}-${N}`),
          (M = M[`${N === "prev" ? "previous" : "next"}ElementSibling`]),
          M && M.classList.add(`${R}-${N}-${N}`)));
    }
    function v(M, N, R) {
      if (((M = M % R), (N = N % R), N === M + 1)) return "next";
      if (N === M - 1) return "previous";
    }
    function y(M) {
      const N = M.target.closest(hg(e.params.pagination.bulletClass));
      if (!N) return;
      M.preventDefault();
      const R = gb(N) * e.params.slidesPerGroup;
      if (e.params.loop) {
        if (e.realIndex === R) return;
        const P = v(e.realIndex, R, e.slides.length);
        P === "next"
          ? e.slideNext()
          : P === "previous"
            ? e.slidePrev()
            : e.slideToLoop(R);
      } else e.slideTo(R);
    }
    function w() {
      const M = e.rtl,
        N = e.params.pagination;
      if (m()) return;
      let R = e.pagination.el;
      R = Kl(R);
      let P, G;
      const Y =
          e.virtual && e.params.virtual.enabled
            ? e.virtual.slides.length
            : e.slides.length,
        B = e.params.loop
          ? Math.ceil(Y / e.params.slidesPerGroup)
          : e.snapGrid.length;
      if (
        (e.params.loop
          ? ((G = e.previousRealIndex || 0),
            (P =
              e.params.slidesPerGroup > 1
                ? Math.floor(e.realIndex / e.params.slidesPerGroup)
                : e.realIndex))
          : typeof e.snapIndex < "u"
            ? ((P = e.snapIndex), (G = e.previousSnapIndex))
            : ((G = e.previousIndex || 0), (P = e.activeIndex || 0)),
        N.type === "bullets" &&
          e.pagination.bullets &&
          e.pagination.bullets.length > 0)
      ) {
        const I = e.pagination.bullets;
        let H, X, fe;
        if (
          (N.dynamicBullets &&
            ((u = Y_(I[0], e.isHorizontal() ? "width" : "height")),
            R.forEach((ve) => {
              ve.style[e.isHorizontal() ? "width" : "height"] =
                `${u * (N.dynamicMainBullets + 4)}px`;
            }),
            N.dynamicMainBullets > 1 &&
              G !== void 0 &&
              ((d += P - (G || 0)),
              d > N.dynamicMainBullets - 1
                ? (d = N.dynamicMainBullets - 1)
                : d < 0 && (d = 0)),
            (H = Math.max(P - d, 0)),
            (X = H + (Math.min(I.length, N.dynamicMainBullets) - 1)),
            (fe = (X + H) / 2)),
          I.forEach((ve) => {
            const be = [
              ...[
                "",
                "-next",
                "-next-next",
                "-prev",
                "-prev-prev",
                "-main",
              ].map((Oe) => `${N.bulletActiveClass}${Oe}`),
            ]
              .map((Oe) =>
                typeof Oe == "string" && Oe.includes(" ") ? Oe.split(" ") : Oe,
              )
              .flat();
            ve.classList.remove(...be);
          }),
          R.length > 1)
        )
          I.forEach((ve) => {
            const be = gb(ve);
            (be === P
              ? ve.classList.add(...N.bulletActiveClass.split(" "))
              : e.isElement && ve.setAttribute("part", "bullet"),
              N.dynamicBullets &&
                (be >= H &&
                  be <= X &&
                  ve.classList.add(...`${N.bulletActiveClass}-main`.split(" ")),
                be === H && g(ve, "prev"),
                be === X && g(ve, "next")));
          });
        else {
          const ve = I[P];
          if (
            (ve && ve.classList.add(...N.bulletActiveClass.split(" ")),
            e.isElement &&
              I.forEach((be, Oe) => {
                be.setAttribute("part", Oe === P ? "bullet-active" : "bullet");
              }),
            N.dynamicBullets)
          ) {
            const be = I[H],
              Oe = I[X];
            for (let V = H; V <= X; V += 1)
              I[V] &&
                I[V].classList.add(...`${N.bulletActiveClass}-main`.split(" "));
            (g(be, "prev"), g(Oe, "next"));
          }
        }
        if (N.dynamicBullets) {
          const ve = Math.min(I.length, N.dynamicMainBullets + 4),
            be = (u * ve - u) / 2 - fe * u,
            Oe = M ? "right" : "left";
          I.forEach((V) => {
            V.style[e.isHorizontal() ? Oe : "top"] = `${be}px`;
          });
        }
      }
      R.forEach((I, H) => {
        if (
          (N.type === "fraction" &&
            (I.querySelectorAll(hg(N.currentClass)).forEach((X) => {
              X.textContent = N.formatFractionCurrent(P + 1);
            }),
            I.querySelectorAll(hg(N.totalClass)).forEach((X) => {
              X.textContent = N.formatFractionTotal(B);
            })),
          N.type === "progressbar")
        ) {
          let X;
          N.progressbarOpposite
            ? (X = e.isHorizontal() ? "vertical" : "horizontal")
            : (X = e.isHorizontal() ? "horizontal" : "vertical");
          const fe = (P + 1) / B;
          let ve = 1,
            be = 1;
          (X === "horizontal" ? (ve = fe) : (be = fe),
            I.querySelectorAll(hg(N.progressbarFillClass)).forEach((Oe) => {
              ((Oe.style.transform = `translate3d(0,0,0) scaleX(${ve}) scaleY(${be})`),
                (Oe.style.transitionDuration = `${e.params.speed}ms`));
            }));
        }
        (N.type === "custom" && N.renderCustom
          ? (vb(I, N.renderCustom(e, P + 1, B)),
            H === 0 && a("paginationRender", I))
          : (H === 0 && a("paginationRender", I), a("paginationUpdate", I)),
          e.params.watchOverflow &&
            e.enabled &&
            I.classList[e.isLocked ? "add" : "remove"](N.lockClass));
      });
    }
    function S() {
      const M = e.params.pagination;
      if (m()) return;
      const N =
        e.virtual && e.params.virtual.enabled
          ? e.virtual.slides.length
          : e.grid && e.params.grid.rows > 1
            ? e.slides.length / Math.ceil(e.params.grid.rows)
            : e.slides.length;
      let R = e.pagination.el;
      R = Kl(R);
      let P = "";
      if (M.type === "bullets") {
        let G = e.params.loop
          ? Math.ceil(N / e.params.slidesPerGroup)
          : e.snapGrid.length;
        e.params.freeMode && e.params.freeMode.enabled && G > N && (G = N);
        for (let Y = 0; Y < G; Y += 1)
          M.renderBullet
            ? (P += M.renderBullet.call(e, Y, M.bulletClass))
            : (P += `<${M.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${M.bulletClass}"></${M.bulletElement}>`);
      }
      (M.type === "fraction" &&
        (M.renderFraction
          ? (P = M.renderFraction.call(e, M.currentClass, M.totalClass))
          : (P = `<span class="${M.currentClass}"></span> / <span class="${M.totalClass}"></span>`)),
        M.type === "progressbar" &&
          (M.renderProgressbar
            ? (P = M.renderProgressbar.call(e, M.progressbarFillClass))
            : (P = `<span class="${M.progressbarFillClass}"></span>`)),
        (e.pagination.bullets = []),
        R.forEach((G) => {
          (M.type !== "custom" && vb(G, P || ""),
            M.type === "bullets" &&
              e.pagination.bullets.push(
                ...G.querySelectorAll(hg(M.bulletClass)),
              ));
        }),
        M.type !== "custom" && a("paginationRender", R[0]));
    }
    function T() {
      e.params.pagination = I4(
        e,
        e.originalParams.pagination,
        e.params.pagination,
        { el: "swiper-pagination" },
      );
      const M = e.params.pagination;
      if (!M.el) return;
      let N;
      (typeof M.el == "string" && e.isElement && (N = e.el.querySelector(M.el)),
        !N &&
          typeof M.el == "string" &&
          (N = [...document.querySelectorAll(M.el)]),
        N || (N = M.el),
        !(!N || N.length === 0) &&
          (e.params.uniqueNavElements &&
            typeof M.el == "string" &&
            Array.isArray(N) &&
            N.length > 1 &&
            ((N = [...e.el.querySelectorAll(M.el)]),
            N.length > 1 && (N = N.find((R) => uC(R, ".swiper")[0] === e.el))),
          Array.isArray(N) && N.length === 1 && (N = N[0]),
          Object.assign(e.pagination, { el: N }),
          (N = Kl(N)),
          N.forEach((R) => {
            (M.type === "bullets" &&
              M.clickable &&
              R.classList.add(...(M.clickableClass || "").split(" ")),
              R.classList.add(M.modifierClass + M.type),
              R.classList.add(
                e.isHorizontal() ? M.horizontalClass : M.verticalClass,
              ),
              M.type === "bullets" &&
                M.dynamicBullets &&
                (R.classList.add(`${M.modifierClass}${M.type}-dynamic`),
                (d = 0),
                M.dynamicMainBullets < 1 && (M.dynamicMainBullets = 1)),
              M.type === "progressbar" &&
                M.progressbarOpposite &&
                R.classList.add(M.progressbarOppositeClass),
              M.clickable && R.addEventListener("click", y),
              e.enabled || R.classList.add(M.lockClass));
          })));
    }
    function E() {
      const M = e.params.pagination;
      if (m()) return;
      let N = e.pagination.el;
      (N &&
        ((N = Kl(N)),
        N.forEach((R) => {
          (R.classList.remove(M.hiddenClass),
            R.classList.remove(M.modifierClass + M.type),
            R.classList.remove(
              e.isHorizontal() ? M.horizontalClass : M.verticalClass,
            ),
            M.clickable &&
              (R.classList.remove(...(M.clickableClass || "").split(" ")),
              R.removeEventListener("click", y)));
        })),
        e.pagination.bullets &&
          e.pagination.bullets.forEach((R) =>
            R.classList.remove(...M.bulletActiveClass.split(" ")),
          ));
    }
    (i("changeDirection", () => {
      if (!e.pagination || !e.pagination.el) return;
      const M = e.params.pagination;
      let { el: N } = e.pagination;
      ((N = Kl(N)),
        N.forEach((R) => {
          (R.classList.remove(M.horizontalClass, M.verticalClass),
            R.classList.add(
              e.isHorizontal() ? M.horizontalClass : M.verticalClass,
            ));
        }));
    }),
      i("init", () => {
        e.params.pagination.enabled === !1 ? O() : (T(), S(), w());
      }),
      i("activeIndexChange", () => {
        typeof e.snapIndex > "u" && w();
      }),
      i("snapIndexChange", () => {
        w();
      }),
      i("snapGridLengthChange", () => {
        (S(), w());
      }),
      i("destroy", () => {
        E();
      }),
      i("enable disable", () => {
        let { el: M } = e.pagination;
        M &&
          ((M = Kl(M)),
          M.forEach((N) =>
            N.classList[e.enabled ? "remove" : "add"](
              e.params.pagination.lockClass,
            ),
          ));
      }),
      i("lock unlock", () => {
        w();
      }),
      i("click", (M, N) => {
        const R = N.target,
          P = Kl(e.pagination.el);
        if (
          e.params.pagination.el &&
          e.params.pagination.hideOnClick &&
          P &&
          P.length > 0 &&
          !R.classList.contains(e.params.pagination.bulletClass)
        ) {
          if (
            e.navigation &&
            ((e.navigation.nextEl && R === e.navigation.nextEl) ||
              (e.navigation.prevEl && R === e.navigation.prevEl))
          )
            return;
          const G = P[0].classList.contains(e.params.pagination.hiddenClass);
          (a(G === !0 ? "paginationShow" : "paginationHide"),
            P.forEach((Y) =>
              Y.classList.toggle(e.params.pagination.hiddenClass),
            ));
        }
      }));
    const j = () => {
        e.el.classList.remove(e.params.pagination.paginationDisabledClass);
        let { el: M } = e.pagination;
        (M &&
          ((M = Kl(M)),
          M.forEach((N) =>
            N.classList.remove(e.params.pagination.paginationDisabledClass),
          )),
          T(),
          S(),
          w());
      },
      O = () => {
        e.el.classList.add(e.params.pagination.paginationDisabledClass);
        let { el: M } = e.pagination;
        (M &&
          ((M = Kl(M)),
          M.forEach((N) =>
            N.classList.add(e.params.pagination.paginationDisabledClass),
          )),
          E());
      };
    Object.assign(e.pagination, {
      enable: j,
      disable: O,
      render: S,
      update: w,
      init: T,
      destroy: E,
    });
  }
  function Sg(t) {
    let { swiper: e, extendParams: n, on: i, emit: a, params: l } = t;
    ((e.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
      n({
        autoplay: {
          enabled: !1,
          delay: 3e3,
          waitForTransition: !0,
          disableOnInteraction: !1,
          stopOnLastSlide: !1,
          reverseDirection: !1,
          pauseOnMouseEnter: !1,
        },
      }));
    let u,
      d,
      m = l && l.autoplay ? l.autoplay.delay : 3e3,
      g = l && l.autoplay ? l.autoplay.delay : 3e3,
      v,
      y = new Date().getTime(),
      w,
      S,
      T,
      E,
      j,
      O,
      M;
    function N(de) {
      !e ||
        e.destroyed ||
        !e.wrapperEl ||
        (de.target === e.wrapperEl &&
          (e.wrapperEl.removeEventListener("transitionend", N),
          !(M || (de.detail && de.detail.bySwiperTouchMove)) && H()));
    }
    const R = () => {
        if (e.destroyed || !e.autoplay.running) return;
        e.autoplay.paused ? (w = !0) : w && ((g = v), (w = !1));
        const de = e.autoplay.paused ? v : y + g - new Date().getTime();
        ((e.autoplay.timeLeft = de),
          a("autoplayTimeLeft", de, de / m),
          (d = requestAnimationFrame(() => {
            R();
          })));
      },
      P = () => {
        let de;
        return (
          e.virtual && e.params.virtual.enabled
            ? (de = e.slides.find((Te) =>
                Te.classList.contains("swiper-slide-active"),
              ))
            : (de = e.slides[e.activeIndex]),
          de ? parseInt(de.getAttribute("data-swiper-autoplay"), 10) : void 0
        );
      },
      G = (de) => {
        if (e.destroyed || !e.autoplay.running) return;
        (cancelAnimationFrame(d), R());
        let he = typeof de > "u" ? e.params.autoplay.delay : de;
        ((m = e.params.autoplay.delay), (g = e.params.autoplay.delay));
        const Te = P();
        (!Number.isNaN(Te) &&
          Te > 0 &&
          typeof de > "u" &&
          ((he = Te), (m = Te), (g = Te)),
          (v = he));
        const F = e.params.speed,
          ae = () => {
            !e ||
              e.destroyed ||
              (e.params.autoplay.reverseDirection
                ? !e.isBeginning || e.params.loop || e.params.rewind
                  ? (e.slidePrev(F, !0, !0), a("autoplay"))
                  : e.params.autoplay.stopOnLastSlide ||
                    (e.slideTo(e.slides.length - 1, F, !0, !0), a("autoplay"))
                : !e.isEnd || e.params.loop || e.params.rewind
                  ? (e.slideNext(F, !0, !0), a("autoplay"))
                  : e.params.autoplay.stopOnLastSlide ||
                    (e.slideTo(0, F, !0, !0), a("autoplay")),
              e.params.cssMode &&
                ((y = new Date().getTime()),
                requestAnimationFrame(() => {
                  G();
                })));
          };
        return (
          he > 0
            ? (clearTimeout(u),
              (u = setTimeout(() => {
                ae();
              }, he)))
            : requestAnimationFrame(() => {
                ae();
              }),
          he
        );
      },
      Y = () => {
        ((y = new Date().getTime()),
          (e.autoplay.running = !0),
          G(),
          a("autoplayStart"));
      },
      B = () => {
        ((e.autoplay.running = !1),
          clearTimeout(u),
          cancelAnimationFrame(d),
          a("autoplayStop"));
      },
      I = (de, he) => {
        if (e.destroyed || !e.autoplay.running) return;
        (clearTimeout(u), de || (O = !0));
        const Te = () => {
          (a("autoplayPause"),
            e.params.autoplay.waitForTransition
              ? e.wrapperEl.addEventListener("transitionend", N)
              : H());
        };
        if (((e.autoplay.paused = !0), he)) {
          (j && (v = e.params.autoplay.delay), (j = !1), Te());
          return;
        }
        ((v = (v || e.params.autoplay.delay) - (new Date().getTime() - y)),
          !(e.isEnd && v < 0 && !e.params.loop) && (v < 0 && (v = 0), Te()));
      },
      H = () => {
        (e.isEnd && v < 0 && !e.params.loop) ||
          e.destroyed ||
          !e.autoplay.running ||
          ((y = new Date().getTime()),
          O ? ((O = !1), G(v)) : G(),
          (e.autoplay.paused = !1),
          a("autoplayResume"));
      },
      X = () => {
        if (e.destroyed || !e.autoplay.running) return;
        const de = ml();
        (de.visibilityState === "hidden" && ((O = !0), I(!0)),
          de.visibilityState === "visible" && H());
      },
      fe = (de) => {
        de.pointerType === "mouse" &&
          ((O = !0), (M = !0), !(e.animating || e.autoplay.paused) && I(!0));
      },
      ve = (de) => {
        de.pointerType === "mouse" && ((M = !1), e.autoplay.paused && H());
      },
      be = () => {
        e.params.autoplay.pauseOnMouseEnter &&
          (e.el.addEventListener("pointerenter", fe),
          e.el.addEventListener("pointerleave", ve));
      },
      Oe = () => {
        e.el &&
          typeof e.el != "string" &&
          (e.el.removeEventListener("pointerenter", fe),
          e.el.removeEventListener("pointerleave", ve));
      },
      V = () => {
        ml().addEventListener("visibilitychange", X);
      },
      pe = () => {
        ml().removeEventListener("visibilitychange", X);
      };
    (i("init", () => {
      e.params.autoplay.enabled && (be(), V(), Y());
    }),
      i("destroy", () => {
        (Oe(), pe(), e.autoplay.running && B());
      }),
      i("_freeModeStaticRelease", () => {
        (T || O) && H();
      }),
      i("_freeModeNoMomentumRelease", () => {
        e.params.autoplay.disableOnInteraction ? B() : I(!0, !0);
      }),
      i("beforeTransitionStart", (de, he, Te) => {
        e.destroyed ||
          !e.autoplay.running ||
          (Te || !e.params.autoplay.disableOnInteraction ? I(!0, !0) : B());
      }),
      i("sliderFirstMove", () => {
        if (!(e.destroyed || !e.autoplay.running)) {
          if (e.params.autoplay.disableOnInteraction) {
            B();
            return;
          }
          ((S = !0),
            (T = !1),
            (O = !1),
            (E = setTimeout(() => {
              ((O = !0), (T = !0), I(!0));
            }, 200)));
        }
      }),
      i("touchEnd", () => {
        if (!(e.destroyed || !e.autoplay.running || !S)) {
          if (
            (clearTimeout(E),
            clearTimeout(u),
            e.params.autoplay.disableOnInteraction)
          ) {
            ((T = !1), (S = !1));
            return;
          }
          (T && e.params.cssMode && H(), (T = !1), (S = !1));
        }
      }),
      i("slideChange", () => {
        e.destroyed || !e.autoplay.running || (j = !0);
      }),
      Object.assign(e.autoplay, { start: Y, stop: B, pause: I, resume: H }));
  }
  const U4 = ({ data: t }) => {
      var e;
      return (
        h.jsx("section", {
          className: "hero-announcement",
          children: h.jsx(zc, {
            spaceBetween: 12,
            slidesPerView: 1,
            modules: [Sg, tO],
            pagination: {
              dynamicBullets: !0,
              bulletClass: "normal-bullet",
              bulletActiveClass: "actived-bullet",
            },
            autoplay: { delay: 2e3, pauseOnMouseEnter: !1 },
            loop: !0,
            speed: 2e3,
            children: h.jsx(
              Pc,
              {
                children:
                  (t == null ? void 0 : t.file_type) === "image"
                    ? h.jsx("img", {
                        src: t == null ? void 0 : t.image,
                        alt:
                          (e = t == null ? void 0 : t.id) == null
                            ? void 0
                            : e.toString(),
                      })
                    : h.jsxs("a", {
                        className: "lite-video-embed",
                        href: t == null ? void 0 : t.image,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": "Videonu YouTube-da aç",
                        children: [
                          h.jsx("img", {
                            src: tOThumbnail(t == null ? void 0 : t.image),
                            alt: "Video önizləməsi",
                          }),
                          h.jsx("span", {
                            "aria-hidden": "true",
                            children: "▶",
                          }),
                        ],
                      }),
              },
              t == null ? void 0 : t.id,
            ),
          }),
        })
      );
    },
    F4 = () => {
      const { slug: t } = Ir(),
        { instance: e } = si(),
        n = sn(),
        i = nt((m) => m.selectedLanguage.selectedLanguage),
        [a, l] = U.useState(null),
        [u, d] = U.useState(!0);
      return (
        U.useEffect(() => {
          t &&
            (async () => {
              var g;
              try {
                d(!0);
                const v = await e.get(`advertisements/${t}`);
                v.data
                  ? l((g = v.data) == null ? void 0 : g.data)
                  : console.log(v.status);
              } catch (v) {
                console.log("Error:", v);
              } finally {
                d(!1);
              }
            })();
        }, [t]),
        U.useEffect(() => {
          if (a) {
            const m = a.slug[i];
            n(`/elanlar/${i}/${m}`, { replace: !0 });
          }
        }, [i, a]),
        u
          ? h.jsx(ze, {})
          : h.jsxs("main", {
              className: "announcement-inner-page-wrapper",
              children: [
                h.jsx("title", {
                  children: (a == null ? void 0 : a.title) || t || "Elanlar",
                }),
                h.jsx("meta", {
                  name: "description",
                  content: (a == null ? void 0 : a.seo_description) ?? "",
                }),
                h.jsxs("div", {
                  className: "announcement-inner-page",
                  children: [h.jsx(U4, { data: a }), h.jsx(P4, { data: a })],
                }),
              ],
            })
      );
    },
    zw = ({ data: t, customStyle: e, customStyleImage: n }) => {
      const i = nt((l) => l.selectedLanguage.selectedLanguage),
        a = sn();
      return h.jsxs("article", {
        onClick: () => a(`/xeberler/${i}/${t == null ? void 0 : t.slug[i]}`),
        className: "news-card",
        style: e,
        children: [
          h.jsx("div", {
            className: "image-new",
            style: n,
            children: h.jsx("img", {
              src: t == null ? void 0 : t.image,
              alt: t == null ? void 0 : t.title,
              style: n,
            }),
          }),
          h.jsxs("div", {
            className: "bottom",
            children: [
              h.jsxs("div", {
                className: "top-desc",
                children: [
                  h.jsxs("div", {
                    className: "top-viewed",
                    children: [
                      h.jsxs("div", {
                        className: "left-view",
                        children: [
                          h.jsx("img", { src: "/view.svg", alt: "" }),
                          h.jsx("p", { children: t == null ? void 0 : t.view }),
                        ],
                      }),
                      h.jsx("p", {
                        className: "time",
                        children: t == null ? void 0 : t.date,
                      }),
                    ],
                  }),
                  h.jsx("h2", { children: t == null ? void 0 : t.title }),
                ],
              }),
              h.jsx(JC, { title: "Daha ətraflı", href: "/" }),
            ],
          }),
        ],
      });
    },
    B4 = () => {
      const { instance: t } = si(),
        [e, n] = U.useState([]),
        [i, a] = U.useState(!1),
        [l, u] = U.useState(!1),
        [d, m] = U.useState(1);
      return {
        fetchNews: async (v) => {
          var y, w;
          v === 1 ? a(!0) : u(!0);
          try {
            const S = await t.get(`blog-and-news?page=${v}`);
            S.data &&
              (n((T) => (v === 1 ? S.data.data : [...T, ...S.data.data])),
              m(
                ((w = (y = S.data) == null ? void 0 : y.meta) == null
                  ? void 0
                  : w.last_page) || 1,
              ));
          } catch (S) {
            console.log(S);
          } finally {
            (a(!1), u(!1));
          }
        },
        news: e,
        lastPage: d,
        isInitialLoading: i,
        isLoadingMore: l,
      };
    },
    H4 = () => {
      const { t } = Ot(),
        {
          fetchNews: e,
          isInitialLoading: n,
          isLoadingMore: i,
          lastPage: a,
          news: l,
        } = B4(),
        [u, d] = U.useState(1),
        m = () => {
          u < a && d((g) => g + 1);
        };
      return (
        U.useEffect(() => {
          e(u);
        }, [u]),
        n
          ? h.jsx(ze, {})
          : h.jsxs("main", {
              className: "news-page-wrapper",
              children: [
                h.jsx("title", { children: t("Xeberler") }),
                h.jsxs("div", {
                  className: "news-page",
                  children: [
                    h.jsx(xi, { title: t("xeberler"), mutation: !0 }),
                    h.jsxs("div", {
                      className: "other-news",
                      children: [
                        h.jsx("div", {
                          className: "grid-area",
                          children:
                            l == null
                              ? void 0
                              : l.map((g) =>
                                  h.jsx(
                                    zw,
                                    { data: g },
                                    g == null ? void 0 : g.id,
                                  ),
                                ),
                        }),
                        h.jsx(np, {
                          initialValue: 12,
                          next: u,
                          counterValue: 12,
                          dataLength: l == null ? void 0 : l.length,
                          setNext: m,
                          title: i ? "Yüklənir..." : "Daha çox",
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            })
      );
    },
    Y4 = ({ data: t }) => {
      var e;
      return h.jsx("section", {
        className: "hero-news",
        children: h.jsx(zc, {
          spaceBetween: 12,
          slidesPerView: 1,
          modules: [Sg, tO],
          pagination: {
            dynamicBullets: !0,
            bulletClass: "normal-bullet",
            bulletActiveClass: "actived-bullet",
          },
          autoplay: { delay: 2e3, pauseOnMouseEnter: !1 },
          loop: !0,
          speed: 2e3,
          children:
            (t == null ? void 0 : t.media) &&
            ((e = t == null ? void 0 : t.media) == null
              ? void 0
              : e.map((n) => {
                  var i;
                  return h.jsx(
                    Pc,
                    {
                      children: h.jsx("img", {
                        src: n == null ? void 0 : n.image,
                        alt:
                          (i = n == null ? void 0 : n.id) == null
                            ? void 0
                            : i.toString(),
                      }),
                    },
                    n == null ? void 0 : n.id,
                  );
                })),
        }),
      });
    },
    q4 = () => {
      const t = ys(),
        e = window.location.origin + t.pathname + t.search,
        [n, i] = U.useState(!1),
        a = async () => {
          i(!0);
          try {
            (await navigator.clipboard.writeText(e),
              xt.success("Link kopyalandı!"));
          } catch (l) {
            xt.error(`${l} copied error!`);
          } finally {
            setTimeout(() => {
              i(!1);
            }, 1500);
          }
        };
      return h.jsxs("section", {
        className: "share-announcement",
        children: [
          h.jsx("div", {
            className: "item",
            children: h.jsx("img", { src: "/xx.svg", alt: "X" }),
          }),
          h.jsx("div", {
            className: "item",
            children: h.jsx("img", { src: "/wppp.svg", alt: "WhatsApp" }),
          }),
          h.jsx("div", {
            className: "item",
            children: h.jsx("img", { src: "/facee.svg", alt: "Facebook" }),
          }),
          h.jsxs("div", {
            className: `share-url ${n ? "copied" : ""}`,
            onClick: a,
            style: { cursor: "pointer" },
            children: [
              h.jsxs("div", {
                className: "text",
                children: [
                  h.jsx("img", { src: "/mkn.svg", alt: "mkn" }),
                  h.jsx("span", { className: "link", children: e }),
                ],
              }),
              h.jsx("img", { src: "/cp.svg", alt: "Copyurl" }),
            ],
          }),
        ],
      });
    },
    $4 = ({ blogId: t }) => {
      var a;
      const { innerData: e, dataLoading: n } = Et(
          `blog-and-other-news?blog_id=${t}`,
          "blog_and_news_other_key",
        ),
        i =
          e != null &&
          e.data &&
          ((a = e == null ? void 0 : e.data) == null ? void 0 : a.length) > 0
            ? e == null
              ? void 0
              : e.data
            : [];
      return n
        ? h.jsx(ze, {})
        : h.jsxs("section", {
            className: "other-news-wrapper",
            children: [
              h.jsx("h3", { children: "Digər xəbərlər" }),
              h.jsx(zc, {
                spaceBetween: 24,
                breakpoints: {
                  968: { slidesPerView: 4 },
                  568: { slidesPerView: 2 },
                  468: { slidesPerView: 1 },
                },
                children:
                  i == null
                    ? void 0
                    : i.map((l) =>
                        h.jsx(
                          Pc,
                          { children: h.jsx(zw, { data: l }) },
                          l == null ? void 0 : l.id,
                        ),
                      ),
              }),
            ],
          });
    },
    G4 = () => {
      const { slug: t } = Ir(),
        { instance: e } = si(),
        n = sn(),
        i = nt((m) => m.selectedLanguage.selectedLanguage),
        [a, l] = U.useState(null),
        [u, d] = U.useState(!0);
      return (
        U.useEffect(() => {
          t &&
            (async () => {
              var g;
              try {
                d(!0);
                const v = await e.get(`blog-and-news/${t}`);
                v.data
                  ? l((g = v.data) == null ? void 0 : g.data)
                  : console.log(v.status);
              } catch (v) {
                console.log("Error:", v);
              } finally {
                d(!1);
              }
            })();
        }, [t]),
        U.useEffect(() => {
          if (a) {
            const m = a.slug[i];
            n(`/xeberler/${i}/${m}`, { replace: !0 });
          }
        }, [i, a]),
        u
          ? h.jsx(ze, { style: { height: "100vh" } })
          : h.jsxs("main", {
              className: "news-inner-page-wrapper",
              children: [
                h.jsx("title", {
                  children: (a == null ? void 0 : a.title) ?? "",
                }),
                h.jsx("meta", {
                  name: "description",
                  content:
                    (a == null ? void 0 : a.seo_description) ||
                    (a == null ? void 0 : a.description) ||
                    "",
                }),
                h.jsxs("div", {
                  className: "news-inner-page",
                  children: [
                    h.jsx(Y4, { data: a }),
                    h.jsxs("div", {
                      className: "description-news",
                      children: [
                        h.jsxs("div", {
                          className: "date",
                          children: [
                            h.jsx("span", {
                              children: a == null ? void 0 : a.date,
                            }),
                            h.jsxs("div", {
                              className: "viewed",
                              children: [
                                h.jsx("img", {
                                  src: "/viewimg.svg",
                                  alt: "view-icon",
                                }),
                                h.jsx("p", {
                                  children: a == null ? void 0 : a.view,
                                }),
                              ],
                            }),
                          ],
                        }),
                        (a == null ? void 0 : a.description) &&
                          h.jsx("div", {
                            dangerouslySetInnerHTML: {
                              __html: ip.sanitize(
                                (a == null ? void 0 : a.description) || "",
                              ),
                            },
                          }),
                      ],
                    }),
                    h.jsx(q4, {}),
                    h.jsx($4, {
                      blogId: Number(a == null ? void 0 : a.id) || 0,
                    }),
                  ],
                }),
              ],
            })
      );
    },
    V4 = () => {
      const { t } = Ot();
      return h.jsx("section", {
        className: "services-hero",
        children: h.jsxs("div", {
          className: "text-content",
          children: [
            h.jsx(xi, {
              title: t("onlayn_dersler"),
              customStyle: { color: "#FFFFFF" },
              mutation: !0,
            }),
            h.jsx("p", { children: t("text_onlayn_dersler") }),
          ],
        }),
      });
    },
    nO = () => {
      var i;
      const { t } = Ot(),
        { innerData: e } = Et("free-online-lessons", "lessons_data_key"),
        n =
          e &&
          e != null &&
          e.data &&
          ((i = e == null ? void 0 : e.data) == null ? void 0 : i.length) > 0
            ? e == null
              ? void 0
              : e.data
            : [];
      return h.jsx("section", {
        className: "online-lessons-wrapper",
        children: h.jsxs("div", {
          className: "online-lessons",
          children: [
            h.jsx(xi, {
              customStyle: { width: "100%", textAlign: "center" },
              title: t("odenissiz_onlayn_dersler"),
            }),
            h.jsx("div", {
              className: "lessons-grid",
              children:
                n == null
                  ? void 0
                  : n.map((a) =>
                      h.jsxs(
                        "div",
                        {
                          className: "lesson-item",
                          children: [
                            h.jsxs("div", {
                              className: "left",
                              children: [
                                h.jsx("div", {
                                  className: "icon",
                                  children: h.jsx("img", {
                                    src: "/lesson.svg",
                                    alt: "",
                                  }),
                                }),
                                h.jsxs("div", {
                                  className: "text",
                                  children: [
                                    h.jsx("h2", {
                                      children: a == null ? void 0 : a.title,
                                    }),
                                    h.jsx("p", {
                                      children: a == null ? void 0 : a.subtitle,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            h.jsx(Ct, {
                              pStyle: { fontSize: "13px", textWrap: "nowrap" },
                              title: t("derslere_qatil"),
                              icon: "/btnicon.svg",
                              isButton: !1,
                              href: (a == null ? void 0 : a.url) || "",
                              target: "_blank",
                            }),
                          ],
                        },
                        a == null ? void 0 : a.id,
                      ),
                    ),
            }),
          ],
        }),
      });
    },
    W4 = () => {
      const { instance: t } = si(),
        [e, n] = U.useState([]),
        [i, a] = U.useState(!1),
        [l, u] = U.useState(!1),
        [d, m] = U.useState(1);
      return {
        fetchServices: async (v) => {
          var y, w;
          v === 1 ? a(!0) : u(!0);
          try {
            const S = await t.get(`services?page=${v}`);
            S.data &&
              (n((T) => (v === 1 ? S.data.data : [...T, ...S.data.data])),
              m(
                ((w = (y = S.data) == null ? void 0 : y.meta) == null
                  ? void 0
                  : w.last_page) || 1,
              ));
          } catch (S) {
            console.log(S);
          } finally {
            (a(!1), u(!1));
          }
        },
        servicesData: e,
        lastPage: d,
        isInitialLoading: i,
        isLoadingMore: l,
      };
    },
    X4 = () => {
      const t = sn(),
        e = nt((v) => v.selectedLanguage.selectedLanguage),
        [n, i] = U.useState(1),
        {
          fetchServices: a,
          isInitialLoading: l,
          isLoadingMore: u,
          lastPage: d,
          servicesData: m,
        } = W4(),
        g = () => {
          n < d && i((v) => v + 1);
        };
      return (
        U.useEffect(() => {
          a(n);
        }, [n]),
        l
          ? h.jsx(ze, {})
          : h.jsxs("main", {
              className: "services-page-wrapper",
              children: [
                h.jsx("title", { children: "Xidmətlər" }),
                h.jsxs("div", {
                  className: "services-page",
                  children: [
                    h.jsx(V4, {}),
                    h.jsx("div", {
                      className: "grid-services",
                      children:
                        m == null
                          ? void 0
                          : m.map((v) =>
                              h.jsxs(
                                "article",
                                {
                                  onClick: () =>
                                    t(
                                      `/xidmetler/${e}/${v == null ? void 0 : v.slug[e]}`,
                                    ),
                                  className: "services-card",
                                  children: [
                                    h.jsx("div", {
                                      className: "left-area",
                                      children: h.jsxs("div", {
                                        className: "left-service-title",
                                        children: [
                                          h.jsx("div", {
                                            className: "icon",
                                            children: h.jsx("img", {
                                              src: "/check.svg",
                                              alt: "check-circle",
                                            }),
                                          }),
                                          h.jsx("h3", {
                                            children:
                                              v == null ? void 0 : v.title,
                                          }),
                                        ],
                                      }),
                                    }),
                                    h.jsxs("div", {
                                      className: "right-area",
                                      children: [
                                        h.jsx("p", {
                                          children:
                                            v == null ? void 0 : v.subtitle,
                                        }),
                                        "n",
                                        h.jsxs(_t, {
                                          to: `/xidmetler/${e}/${v == null ? void 0 : v.slug[e]}`,
                                          className: "show-more-button-custom",
                                          children: [
                                            h.jsx("span", {
                                              children: "Daha ətraflı",
                                            }),
                                            h.jsx("img", {
                                              src: "/arr.svg",
                                              alt: "arrow",
                                            }),
                                          ],
                                        }),
                                      ],
                                    }),
                                  ],
                                },
                                v == null ? void 0 : v.id,
                              ),
                            ),
                    }),
                    h.jsx(np, {
                      counterValue: 12,
                      dataLength: m == null ? void 0 : m.length,
                      initialValue: 12,
                      next: n,
                      setNext: g,
                      title: u ? "Yüklənir..." : "Daha çox",
                    }),
                    h.jsx(nO, {}),
                  ],
                }),
              ],
            })
      );
    },
    Q4 = () => {
      const { slug: t } = Ir(),
        { t: e } = Ot(),
        { instance: n } = si(),
        i = sn(),
        a = nt((S) => S.selectedLanguage.selectedLanguage),
        [l, u] = U.useState(null),
        [d, m] = U.useState(!0);
      (U.useEffect(() => {
        t &&
          (async () => {
            var T;
            try {
              m(!0);
              const E = await n.get(`services/${t}`);
              E.data
                ? u((T = E.data) == null ? void 0 : T.data)
                : console.log(E.status);
            } catch (E) {
              console.log("Error:", E);
            } finally {
              m(!1);
            }
          })();
      }, [t]),
        U.useEffect(() => {
          if (l) {
            const S = l.slug[a];
            i(`/xidmetler/${a}/${S}`, { replace: !0 });
          }
        }, [a, l]));
      const [g, v] = U.useState([]),
        [y, w] = U.useState(!0);
      return (
        U.useEffect(() => {
          (async () => {
            var T;
            if (l != null && l.id)
              try {
                w(!0);
                const E = await n.get(`other-services?item_id=${l.id}`);
                v(((T = E.data) == null ? void 0 : T.data) || []);
              } catch (E) {
                console.error("Error fetching other services:", E);
              } finally {
                w(!1);
              }
          })();
        }, [l]),
        d
          ? h.jsx(ze, {})
          : h.jsxs("div", {
              className: "inner-service-page-wrapper",
              children: [
                h.jsx("title", {
                  children: (l == null ? void 0 : l.title) ?? "",
                }),
                h.jsx("meta", {
                  name: "description",
                  content:
                    (l == null ? void 0 : l.seo_description) ||
                    (l == null ? void 0 : l.description) ||
                    "",
                }),
                h.jsxs("div", {
                  className: "inner-service-page",
                  children: [
                    h.jsx(xi, {
                      customStyle: { textAlign: "start", width: "100%" },
                      mutation: !0,
                      title: (l == null ? void 0 : l.title) || "",
                    }),
                    h.jsxs("div", {
                      className: "bottom-content",
                      children: [
                        h.jsxs("div", {
                          className: "left-content",
                          children: [
                            h.jsx("div", {
                              className: "image-container",
                              children: h.jsx("img", {
                                src: (l == null ? void 0 : l.image) || "",
                                alt: l == null ? void 0 : l.title,
                              }),
                            }),
                            (l == null ? void 0 : l.description) &&
                              h.jsx("div", {
                                className: "description",
                                dangerouslySetInnerHTML: {
                                  __html: ip.sanitize(
                                    (l == null ? void 0 : l.description) || "",
                                  ),
                                },
                              }),
                            h.jsxs(_t, {
                              target: "_blank",
                              rel: "noopener noreferrer",
                              to: `https://wa.me/${e("your_telephone_number")}`,
                              className: "phone-link",
                              children: [
                                h.jsx("img", {
                                  src: "/wp3.svg",
                                  alt: "WhatsApp",
                                  title: "WhatsApp",
                                }),
                                h.jsx("p", { children: "Müraciət et" }),
                              ],
                            }),
                          ],
                        }),
                        h.jsxs("div", {
                          className: "right-side",
                          children: [
                            h.jsx("span", {
                              className: "title-mini",
                              children: "Digər xidmətlər",
                            }),
                            y
                              ? h.jsx(ze, {})
                              : h.jsx("div", {
                                  className: "services-other",
                                  children:
                                    g == null
                                      ? void 0
                                      : g.map((S) =>
                                          h.jsxs(
                                            _t,
                                            {
                                              to: `/xidmetler/${a}/${S.slug[a]}`,
                                              className: `service-item-other ${(l == null ? void 0 : l.id) === (S == null ? void 0 : S.id) ? "active" : ""}`,
                                              children: [
                                                h.jsx("h4", {
                                                  children:
                                                    S == null
                                                      ? void 0
                                                      : S.title,
                                                }),
                                                h.jsx(Ab, {
                                                  className: "right-icon",
                                                }),
                                              ],
                                            },
                                            S == null ? void 0 : S.id,
                                          ),
                                        ),
                                }),
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            })
      );
    },
    Z4 = ({
      handleVerifyEmailOtp: t,
      otpIsSend: e,
      setModal: n,
      clickedPen: i,
      otp: a,
      setOtp: l,
      handleChangeEmail: u,
      changedEmail: d,
      setChangedEmail: m,
      load: g,
    }) => {
      const { t: v } = Ot();
      return h.jsx("div", {
        className: "change-modal-overlay",
        children: e
          ? h.jsxs("div", {
              className: "change-modal",
              children: [
                h.jsx("h3", { children: "Kodu daxil edin" }),
                h.jsx("button", {
                  type: "button",
                  className: "close",
                  onClick: () => n(""),
                  children: "X",
                }),
                h.jsxs("form", {
                  onSubmit: (y) => {
                    (y.preventDefault(), t());
                  },
                  acceptCharset: "UTF-8",
                  children: [
                    h.jsx("div", {
                      className: `input-field ${i[1] ? "actived" : ""}`,
                      children: h.jsx("input", {
                        name: "otp",
                        required: !0,
                        type: "text",
                        placeholder: "OTP Kodunu yazın",
                        value: a,
                        onChange: (y) => l(y.target.value),
                      }),
                    }),
                    h.jsx(Ct, {
                      buttonType: "submit",
                      title:
                        g === "email_verify"
                          ? v("zehmet_olmasa_gozleyin")
                          : "Təsdiqlə",
                      isButton: !0,
                      style: { width: "100%", marginTop: "12px" },
                    }),
                  ],
                }),
              ],
            })
          : h.jsxs("div", {
              className: "change-modal",
              children: [
                h.jsx("h3", { children: "Emaili dəyiş" }),
                h.jsx("button", {
                  type: "button",
                  className: "close",
                  onClick: () => n(""),
                  children: "X",
                }),
                h.jsxs("form", {
                  onSubmit: (y) => {
                    (y.preventDefault(), u());
                  },
                  acceptCharset: "UTF-8",
                  children: [
                    h.jsx("div", {
                      className: `input-field ${i[1] ? "actived" : ""}`,
                      children: h.jsx("input", {
                        name: "email",
                        required: !0,
                        type: "email",
                        placeholder: "Emaili yazın",
                        value: d,
                        onChange: (y) => m(y.target.value),
                      }),
                    }),
                    h.jsx(Ct, {
                      buttonType: "submit",
                      title:
                        g === "email_change"
                          ? v("zehmet_olmasa_gozleyin")
                          : "Kodu göndər",
                      isButton: !0,
                      style: { width: "100%", marginTop: "12px" },
                    }),
                  ],
                }),
              ],
            }),
      });
    },
    K4 = ({ load: t, clickedPen: e, setModal: n }) => {
      const { t: i } = Ot();
      return h.jsx("div", {
        className: "change-modal-overlay",
        children: h.jsxs("div", {
          className: "change-modal",
          children: [
            h.jsx("h3", { children: "Şifrəni dəyiş" }),
            h.jsx("button", {
              type: "button",
              className: "close",
              onClick: () => n(""),
              children: "X",
            }),
            h.jsxs("form", {
              onSubmit: (a) => {
                a.preventDefault();
              },
              acceptCharset: "UTF-8",
              children: [
                h.jsx("div", {
                  className: `input-field ${e[1] ? "actived" : ""}`,
                  children: h.jsx("input", {
                    name: "email",
                    required: !0,
                    type: "email",
                    placeholder: "Emailinizi yazın",
                  }),
                }),
                h.jsx(Ct, {
                  buttonType: "submit",
                  title:
                    t === "email_change"
                      ? i("zehmet_olmasa_gozleyin")
                      : "Kodu göndər",
                  isButton: !0,
                  style: { width: "100%", marginTop: "12px" },
                }),
              ],
            }),
          ],
        }),
      });
    },
    J4 = () => {
      const { instance: t } = si(),
        { user: e, setUser: n } = Sa(),
        { showServerSuccessMsg: i, showError: a, showServerErrorMsg: l } = wa(),
        [u, d] = U.useState(""),
        [m, g] = U.useState(""),
        [v, y] = U.useState(""),
        [w, S] = U.useState(!1),
        T = async () => {
          var M, N, R;
          g("email_change");
          try {
            const P = new FormData();
            P.append("email", v);
            const G = await t.post(`${Ii}change-email/send-otp`, P);
            G.data
              ? (i((M = G.data) == null ? void 0 : M.message), S(!0))
              : console.log(G.status);
          } catch (P) {
            if (Xe.isAxiosError(P)) {
              const G =
                (R =
                  (N = P == null ? void 0 : P.response) == null
                    ? void 0
                    : N.data) == null
                  ? void 0
                  : R.message;
              G ? l(G) : (a(), console.log(P));
            } else (a(), console.log(P));
          } finally {
            g("");
          }
        },
        [E, j] = U.useState("");
      return {
        handleVerifyEmailOtp: async () => {
          var M, N, R, P, G;
          g("email_verify");
          try {
            const Y = new FormData();
            Y.append("otp", E);
            const B = await t.post(`${Ii}change-email`, Y);
            if (B.data) {
              const I = {
                ...e,
                email:
                  ((N = (M = B.data) == null ? void 0 : M.data) == null
                    ? void 0
                    : N.email) || (e == null ? void 0 : e.email),
              };
              (n(I),
                localStorage.setItem("usr_education", JSON.stringify(I)),
                i((R = B.data) == null ? void 0 : R.message),
                S(!1),
                d(""),
                j(""));
            } else console.log(B.status);
          } catch (Y) {
            if (Xe.isAxiosError(Y)) {
              const B =
                (G =
                  (P = Y == null ? void 0 : Y.response) == null
                    ? void 0
                    : P.data) == null
                  ? void 0
                  : G.message;
              B ? l(B) : (a(), console.log(Y));
            } else (a(), console.log(Y));
          } finally {
            g("");
          }
        },
        handleChangeEmail: T,
        otpIsSend: w,
        setChangedEmail: y,
        changedEmail: v,
        modal: u,
        load: m,
        setModal: d,
        setLoad: g,
        setOtp: j,
        otp: E,
      };
    },
    ek = () => {
      const t = { 1: !1, 2: !1, 3: !1, 4: !1 },
        { instance: e } = si(),
        { setUser: n, user: i } = Sa(),
        { showError: a, showServerSuccessMsg: l, showServerErrorMsg: u } = wa(),
        [d, m] = U.useState(t),
        g = (E) => {
          m((j) => ({ ...j, [E]: !j[E] }));
        };
      U.useEffect(() => {
        m(t);
      }, []);
      const [v, y] = U.useState({}),
        [w, S] = U.useState({ name: "", phone: "" }),
        T = async (E, j, O) => {
          var M, N, R, P, G, Y, B;
          if (j) {
            y((I) => ({ ...I, [O]: !0 }));
            try {
              const I = new FormData();
              I.append(E, j);
              const H = await e.post("user/profile", I, {
                headers: { "Content-Type": "multipart/form-data" },
              });
              if (H.data) {
                const X = {
                  ...i,
                  [E]:
                    ((N = (M = H.data) == null ? void 0 : M.data) == null
                      ? void 0
                      : N[E]) || (i == null ? void 0 : i[E]),
                };
                (localStorage.setItem("usr_education", JSON.stringify(X)),
                  n(X),
                  m((fe) => ({ ...fe, [O]: !1 })),
                  l((R = H.data) == null ? void 0 : R.message));
              }
            } catch (I) {
              (Xe.isAxiosError(I)
                ? (G = (P = I.response) == null ? void 0 : P.data) != null &&
                  G.message
                  ? u(
                      (B = (Y = I.response) == null ? void 0 : Y.data) == null
                        ? void 0
                        : B.message,
                    )
                  : a()
                : (a(), console.log(I)),
                console.log(I));
            } finally {
              y((I) => ({ ...I, [O]: !1 }));
            }
          }
        };
      return (
        U.useEffect(() => {
          i && S({ name: i.name, phone: i.phone });
        }, [i]),
        {
          loading: v,
          data: w,
          handleFieldUpdate: T,
          clickedPen: d,
          handleClickPen: g,
          setData: S,
        }
      );
    },
    tk = () => {
      const { user: t } = Sa(),
        {
          clickedPen: e,
          data: n,
          handleClickPen: i,
          handleFieldUpdate: a,
          loading: l,
          setData: u,
        } = ek(),
        {
          handleChangeEmail: d,
          handleVerifyEmailOtp: m,
          load: g,
          modal: v,
          otpIsSend: y,
          setChangedEmail: w,
          changedEmail: S,
          setModal: T,
          setOtp: E,
          otp: j,
        } = J4(),
        { t: O } = Ot();
      return h.jsxs("div", {
        className: "my-informations",
        children: [
          v === "change_email" &&
            h.jsx(Z4, {
              changedEmail: S,
              clickedPen: e,
              handleChangeEmail: d,
              handleVerifyEmailOtp: m,
              load: g,
              otp: j,
              otpIsSend: y,
              setChangedEmail: w,
              setModal: T,
              setOtp: E,
            }),
          v === "change_password" &&
            h.jsx(K4, { clickedPen: e, load: g, setModal: T }),
          h.jsx(xi, {
            title: "Məlumatlarım",
            customStyle: { fontSize: "20px" },
          }),
          h.jsxs("form", {
            acceptCharset: "UTF-8",
            className: "grid-inputs",
            children: [
              h.jsxs("div", {
                className: `input-field ${e[1] ? "actived" : ""}`,
                children: [
                  h.jsx("input", {
                    name: "name",
                    type: "text",
                    value: n.name,
                    placeholder: (t == null ? void 0 : t.name) || "",
                    readOnly: !e[1],
                    onChange: (M) => u((N) => ({ ...N, name: M.target.value })),
                  }),
                  h.jsx("img", {
                    src: "/pen.svg",
                    alt: "Pen",
                    onClick: () => i(1),
                  }),
                  e[1] &&
                    h.jsx("button", {
                      onClick: (M) => {
                        (M.preventDefault(), a("name", n.name, 1));
                      },
                      type: "submit",
                      className: "checkedbtn",
                      children: l[1]
                        ? O("zehmet_olmasa_gozleyin")
                        : "Məlumatı yenilə",
                    }),
                ],
              }),
              h.jsxs("div", {
                className: `input-field ${e[2] ? "actived" : ""}`,
                onClick: () => T("change_email"),
                children: [
                  h.jsx("input", {
                    type: "email",
                    placeholder: (t == null ? void 0 : t.email) || "",
                    readOnly: !0,
                  }),
                  h.jsx("img", {
                    src: "/pen.svg",
                    alt: "Pen",
                    onClick: () => i(2),
                  }),
                ],
              }),
              h.jsxs("div", {
                className: `input-field ${e[3] ? "actived" : ""}`,
                children: [
                  h.jsx("input", {
                    name: "phone",
                    type: "tel",
                    value: n.phone,
                    readOnly: !e[3],
                    placeholder: (t == null ? void 0 : t.phone) || "",
                    onChange: (M) =>
                      u((N) => ({ ...N, phone: M.target.value })),
                  }),
                  h.jsx("img", {
                    src: "/pen.svg",
                    alt: "Pen",
                    onClick: () => i(3),
                  }),
                  e[3] &&
                    h.jsx("button", {
                      type: "button",
                      className: "checkedbtn",
                      onClick: () => a("phone", n.phone, 3),
                      children: l[3]
                        ? O("zehmet_olmasa_gozleyin")
                        : "Məlumatı yenilə",
                    }),
                ],
              }),
              h.jsxs("div", {
                className: `input-field ${e[4] ? "actived" : ""}`,
                children: [
                  h.jsx("input", {
                    type: "password",
                    placeholder: "******",
                    readOnly: !0,
                  }),
                  h.jsx("img", {
                    src: "/pen.svg",
                    alt: "Pen",
                    onClick: () => {
                      (i(4), T("change_password"));
                    },
                  }),
                ],
              }),
            ],
          }),
        ],
      });
    },
    Pw = ({ message: t }) =>
      h.jsx("p", { className: "no-data-text", children: t }),
    nk = () => {
      const { t } = Ot(),
        { SubscribtionsDataLoading: e, hasSubscribtions: n } = iv(),
        i = nt((l) => l.selectedLanguage.selectedLanguage);
      if (e) return h.jsx(ze, {});
      const a = Array.isArray(n) ? n : [];
      return (
        console.log(a),
        h.jsxs("div", {
          className: "my-subscribtions",
          children: [
            h.jsx(xi, {
              title: t("abuneliklerim"),
              customStyle: { fontSize: "20px" },
            }),
            h.jsx("div", {
              className: `subs-grid ${(a == null ? void 0 : a.length) === 0 && "no-data"}`,
              children:
                (a == null ? void 0 : a.length) > 0
                  ? a == null
                    ? void 0
                    : a.map((l) =>
                        h.jsxs(
                          "div",
                          {
                            className: "sub-item",
                            children: [
                              h.jsxs("div", {
                                className: "left-description",
                                children: [
                                  h.jsxs("div", {
                                    className: "top-title",
                                    children: [
                                      h.jsxs("div", {
                                        className: "package-name",
                                        children: [
                                          h.jsx("img", {
                                            src: "/hand.svg",
                                            alt: "hand",
                                          }),
                                          h.jsx("span", {
                                            children:
                                              l == null ? void 0 : l.plan_name,
                                          }),
                                        ],
                                      }),
                                      h.jsx("p", {
                                        className: "date",
                                        children: l == null ? void 0 : l.date,
                                      }),
                                    ],
                                  }),
                                  h.jsx("p", {
                                    className: "name",
                                    children:
                                      l == null ? void 0 : l.subCategoryName,
                                  }),
                                ],
                              }),
                              h.jsx("div", {
                                className: "right-main",
                                children:
                                  l != null && l.active
                                    ? h.jsxs("div", {
                                        className: "subscribe-flag",
                                        children: [
                                          h.jsx("img", {
                                            src: "/dd.svg",
                                            alt: "success",
                                          }),
                                          h.jsx("p", {
                                            style: { textWrap: "nowrap" },
                                            children:
                                              l == null ? void 0 : l.order_text,
                                          }),
                                        ],
                                      })
                                    : h.jsxs(h.Fragment, {
                                        children: [
                                          h.jsxs("p", {
                                            children: [
                                              "Premium ",
                                              l.duration_months,
                                              " aylıq paketinizin istifadə müddəti bitdi",
                                            ],
                                          }),
                                          h.jsx(Ct, {
                                            title: "Yenidən abunə ol",
                                            pStyle: { color: "#FFFFFF" },
                                            icon: "/righticoning.svg",
                                            href: `/imtahanlar/${i}/abunelik-paketleri`,
                                          }),
                                        ],
                                      }),
                              }),
                            ],
                          },
                          l == null ? void 0 : l.id,
                        ),
                      )
                  : h.jsx(Pw, {
                      message: "Hələ ki, aktiv abunəliyiniz yoxdur.",
                    }),
            }),
          ],
        })
      );
    },
    ik = () => {
      var a;
      const {
          innerData: t,
          dataLoading: e,
          hasInvalidateQuery: n,
        } = Et("user/exam-results", "dt_test_results_key", !0),
        i =
          t != null &&
          t.data &&
          ((a = t == null ? void 0 : t.data) == null ? void 0 : a.length) > 0
            ? t == null
              ? void 0
              : t.data
            : [];
      return { DTResultInvalidate: n, DTResultLoading: e, hasResults: i };
    },
    sk = () => {
      const { DTResultInvalidate: t, DTResultLoading: e, hasResults: n } = ik();
      return (
        U.useEffect(() => {
          t("dt_test_results_key");
        }, []),
        e
          ? h.jsx(ze, {})
          : h.jsxs("div", {
              className: "my-test-results",
              children: [
                h.jsx(xi, {
                  title: "Test nəticələrim",
                  customStyle: { fontSize: "20px" },
                }),
                h.jsx("div", {
                  className: "grid-tests",
                  children:
                    n == null
                      ? void 0
                      : n.map((i) => {
                          var a;
                          return h.jsx(
                            "div",
                            {
                              className: "test-item",
                              children: h.jsxs("div", {
                                className: "left",
                                children: [
                                  h.jsxs("div", {
                                    className: "text-and-results",
                                    children: [
                                      i.percentage &&
                                        ((a =
                                          i == null ? void 0 : i.percentage) !=
                                          null && a.endsWith("%")
                                          ? h.jsxs("p", {
                                              className: "result",
                                              children: [
                                                "Nəticə: ",
                                                i == null
                                                  ? void 0
                                                  : i.percentage,
                                              ],
                                            })
                                          : h.jsxs("p", {
                                              className: "result",
                                              children: [
                                                "Nəticə: ",
                                                i == null
                                                  ? void 0
                                                  : i.percentage,
                                                "%",
                                              ],
                                            })),
                                      h.jsxs("div", {
                                        className: "true",
                                        children: [
                                          h.jsx("img", {
                                            src: "/ss.svg",
                                            alt: "Success and true answers",
                                          }),
                                          h.jsxs("p", {
                                            children: [
                                              i == null
                                                ? void 0
                                                : i.questionCorrect,
                                              " düz",
                                            ],
                                          }),
                                        ],
                                      }),
                                      h.jsxs("div", {
                                        className: "false",
                                        children: [
                                          h.jsx("img", {
                                            src: "/false.svg",
                                            alt: "False answers",
                                          }),
                                          h.jsxs("p", {
                                            children: [
                                              i == null
                                                ? void 0
                                                : i.unQuestionCorrect,
                                              " səhv",
                                            ],
                                          }),
                                        ],
                                      }),
                                      h.jsxs("div", {
                                        className: "no_ans",
                                        children: [
                                          h.jsx("img", {
                                            src: "/noans.svg",
                                            alt: "Without answer",
                                          }),
                                          h.jsxs("p", {
                                            children: [
                                              i == null ? void 0 : i.unAnswers,
                                              " cavabsız",
                                            ],
                                          }),
                                        ],
                                      }),
                                    ],
                                  }),
                                  h.jsxs("p", {
                                    className: "desc",
                                    children: [
                                      h.jsx("span", { children: "Mövzu:" }),
                                      i == null ? void 0 : i.topic,
                                    ],
                                  }),
                                ],
                              }),
                            },
                            i == null ? void 0 : i.id,
                          );
                        }),
                }),
              ],
            })
      );
    };
  function wb(t) {
    return Fi({
      attr: {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      },
      child: [
        {
          tag: "path",
          attr: {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
          },
          child: [],
        },
        { tag: "circle", attr: { cx: "12", cy: "12", r: "3" }, child: [] },
      ],
    })(t);
  }
  function rk(t) {
    return Fi({
      attr: {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      },
      child: [
        { tag: "path", attr: { d: "M3 6h18" }, child: [] },
        {
          tag: "path",
          attr: { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" },
          child: [],
        },
        {
          tag: "path",
          attr: { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" },
          child: [],
        },
      ],
    })(t);
  }
  const ak = () => {
    const { instance: t } = si(),
      { showServerSuccessMsg: e } = wa(),
      [n, i] = U.useState(""),
      [a, l] = U.useState({}),
      [u, d] = U.useState({}),
      [m, g] = U.useState([]),
      [v, y] = U.useState([]),
      w = async () => {
        var M;
        i("fetchNotifications");
        try {
          const N = await t.get("/user/notifications");
          N.data
            ? g((M = N.data) == null ? void 0 : M.data)
            : console.log(N.status);
        } catch (N) {
          console.log(N);
        } finally {
          i("");
        }
      };
    return {
      fetchNotifications: w,
      notificatonData: m,
      loadingNtf: n,
      handleRead: async (M) => {
        d((N) => ({ ...N, [M]: !0 }));
        try {
          const N = await t.post(`/user/notifications/${M}/read`);
          if (N.data) return N.data;
          console.log(N.status);
        } catch (N) {
          console.log(N);
        } finally {
          d((N) => ({ ...N, [M]: !1 }));
        }
      },
      fetchUnreadNotifications: async () => {
        var M;
        i("readNotifications");
        try {
          const N = await t.get("/user/notifications/unread");
          N.data
            ? y((M = N.data) == null ? void 0 : M.data)
            : console.log(N.status);
        } catch (N) {
          console.log(N);
        } finally {
          i("");
        }
      },
      unreadNotificatonData: v,
      handleRemove: async (M) => {
        var N;
        l((R) => ({ ...R, [M]: !0 }));
        try {
          const R = await t.delete(`/user/notifications/${M}`);
          R.data && ((N = R.data) == null ? void 0 : N.status) === "success"
            ? w()
            : console.log(R.status);
        } catch (R) {
          console.log(R);
        } finally {
          l((R) => ({ ...R, [M]: !1 }));
        }
      },
      loadingRemoved: a,
      handleReadAll: async () => {
        var M, N;
        i("allRead");
        try {
          const R = await t.post("/user/notifications/read-all", void 0);
          R.data && ((M = R.data) == null ? void 0 : M.status) === "success"
            ? (e((N = R.data) == null ? void 0 : N.message), w())
            : console.log(R.status);
        } catch (R) {
          console.log(R);
        } finally {
          i("");
        }
      },
      loadingReadNotification: u,
      handleRemoveAll: async () => {
        var M, N;
        i("allRemove");
        try {
          const R = await t.delete("/user/notifications/delete-all", void 0);
          R.data && ((M = R.data) == null ? void 0 : M.status) === "success"
            ? (e((N = R.data) == null ? void 0 : N.message), w())
            : console.log(R.status);
        } catch (R) {
          console.log(R);
        } finally {
          i("");
        }
      },
    };
  }; //! moment.js
  //! version : 2.30.1
  //! authors : Tim Wood, Iskren Chernev, Moment.js contributors
  //! license : MIT
  //! momentjs.com
  var iO;
  function De() {
    return iO.apply(null, arguments);
  }
  function lk(t) {
    iO = t;
  }
  function va(t) {
    return (
      t instanceof Array ||
      Object.prototype.toString.call(t) === "[object Array]"
    );
  }
  function Af(t) {
    return t != null && Object.prototype.toString.call(t) === "[object Object]";
  }
  function Ft(t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }
  function Iw(t) {
    if (Object.getOwnPropertyNames)
      return Object.getOwnPropertyNames(t).length === 0;
    var e;
    for (e in t) if (Ft(t, e)) return !1;
    return !0;
  }
  function Us(t) {
    return t === void 0;
  }
  function bo(t) {
    return (
      typeof t == "number" ||
      Object.prototype.toString.call(t) === "[object Number]"
    );
  }
  function sv(t) {
    return (
      t instanceof Date || Object.prototype.toString.call(t) === "[object Date]"
    );
  }
  function sO(t, e) {
    var n = [],
      i,
      a = t.length;
    for (i = 0; i < a; ++i) n.push(e(t[i], i));
    return n;
  }
  function Lc(t, e) {
    for (var n in e) Ft(e, n) && (t[n] = e[n]);
    return (
      Ft(e, "toString") && (t.toString = e.toString),
      Ft(e, "valueOf") && (t.valueOf = e.valueOf),
      t
    );
  }
  function vl(t, e, n, i) {
    return OO(t, e, n, i, !0).utc();
  }
  function ok() {
    return {
      empty: !1,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: !1,
      invalidEra: null,
      invalidMonth: null,
      invalidFormat: !1,
      userInvalidated: !1,
      iso: !1,
      parsedDateParts: [],
      era: null,
      meridiem: null,
      rfc2822: !1,
      weekdayMismatch: !1,
    };
  }
  function dt(t) {
    return (t._pf == null && (t._pf = ok()), t._pf);
  }
  var K_;
  Array.prototype.some
    ? (K_ = Array.prototype.some)
    : (K_ = function (t) {
        var e = Object(this),
          n = e.length >>> 0,
          i;
        for (i = 0; i < n; i++)
          if (i in e && t.call(this, e[i], i, e)) return !0;
        return !1;
      });
  function Uw(t) {
    var e = null,
      n = !1,
      i = t._d && !isNaN(t._d.getTime());
    if (
      (i &&
        ((e = dt(t)),
        (n = K_.call(e.parsedDateParts, function (a) {
          return a != null;
        })),
        (i =
          e.overflow < 0 &&
          !e.empty &&
          !e.invalidEra &&
          !e.invalidMonth &&
          !e.invalidWeekday &&
          !e.weekdayMismatch &&
          !e.nullInput &&
          !e.invalidFormat &&
          !e.userInvalidated &&
          (!e.meridiem || (e.meridiem && n))),
        t._strict &&
          (i =
            i &&
            e.charsLeftOver === 0 &&
            e.unusedTokens.length === 0 &&
            e.bigHour === void 0)),
      Object.isFrozen == null || !Object.isFrozen(t))
    )
      t._isValid = i;
    else return i;
    return t._isValid;
  }
  function Gb(t) {
    var e = vl(NaN);
    return (t != null ? Lc(dt(e), t) : (dt(e).userInvalidated = !0), e);
  }
  var fE = (De.momentProperties = []),
    n_ = !1;
  function Fw(t, e) {
    var n,
      i,
      a,
      l = fE.length;
    if (
      (Us(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject),
      Us(e._i) || (t._i = e._i),
      Us(e._f) || (t._f = e._f),
      Us(e._l) || (t._l = e._l),
      Us(e._strict) || (t._strict = e._strict),
      Us(e._tzm) || (t._tzm = e._tzm),
      Us(e._isUTC) || (t._isUTC = e._isUTC),
      Us(e._offset) || (t._offset = e._offset),
      Us(e._pf) || (t._pf = dt(e)),
      Us(e._locale) || (t._locale = e._locale),
      l > 0)
    )
      for (n = 0; n < l; n++) ((i = fE[n]), (a = e[i]), Us(a) || (t[i] = a));
    return t;
  }
  function rv(t) {
    (Fw(this, t),
      (this._d = new Date(t._d != null ? t._d.getTime() : NaN)),
      this.isValid() || (this._d = new Date(NaN)),
      n_ === !1 && ((n_ = !0), De.updateOffset(this), (n_ = !1)));
  }
  function ya(t) {
    return t instanceof rv || (t != null && t._isAMomentObject != null);
  }
  function rO(t) {
    De.suppressDeprecationWarnings === !1 &&
      typeof console < "u" &&
      console.warn &&
      console.warn("Deprecation warning: " + t);
  }
  function Ur(t, e) {
    var n = !0;
    return Lc(function () {
      if (
        (De.deprecationHandler != null && De.deprecationHandler(null, t), n)
      ) {
        var i = [],
          a,
          l,
          u,
          d = arguments.length;
        for (l = 0; l < d; l++) {
          if (((a = ""), typeof arguments[l] == "object")) {
            a +=
              `
[` +
              l +
              "] ";
            for (u in arguments[0])
              Ft(arguments[0], u) && (a += u + ": " + arguments[0][u] + ", ");
            a = a.slice(0, -2);
          } else a = arguments[l];
          i.push(a);
        }
        (rO(
          t +
            `
Arguments: ` +
            Array.prototype.slice.call(i).join("") +
            `
` +
            new Error().stack,
        ),
          (n = !1));
      }
      return e.apply(this, arguments);
    }, e);
  }
  var dE = {};
  function aO(t, e) {
    (De.deprecationHandler != null && De.deprecationHandler(t, e),
      dE[t] || (rO(e), (dE[t] = !0)));
  }
  De.suppressDeprecationWarnings = !1;
  De.deprecationHandler = null;
  function yl(t) {
    return (
      (typeof Function < "u" && t instanceof Function) ||
      Object.prototype.toString.call(t) === "[object Function]"
    );
  }
  function ck(t) {
    var e, n;
    for (n in t)
      Ft(t, n) && ((e = t[n]), yl(e) ? (this[n] = e) : (this["_" + n] = e));
    ((this._config = t),
      (this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
          "|" +
          /\d{1,2}/.source,
      )));
  }
  function J_(t, e) {
    var n = Lc({}, t),
      i;
    for (i in e)
      Ft(e, i) &&
        (Af(t[i]) && Af(e[i])
          ? ((n[i] = {}), Lc(n[i], t[i]), Lc(n[i], e[i]))
          : e[i] != null
            ? (n[i] = e[i])
            : delete n[i]);
    for (i in t) Ft(t, i) && !Ft(e, i) && Af(t[i]) && (n[i] = Lc({}, n[i]));
    return n;
  }
  function Bw(t) {
    t != null && this.set(t);
  }
  var ew;
  Object.keys
    ? (ew = Object.keys)
    : (ew = function (t) {
        var e,
          n = [];
        for (e in t) Ft(t, e) && n.push(e);
        return n;
      });
  var uk = {
    sameDay: "[Today at] LT",
    nextDay: "[Tomorrow at] LT",
    nextWeek: "dddd [at] LT",
    lastDay: "[Yesterday at] LT",
    lastWeek: "[Last] dddd [at] LT",
    sameElse: "L",
  };
  function fk(t, e, n) {
    var i = this._calendar[t] || this._calendar.sameElse;
    return yl(i) ? i.call(e, n) : i;
  }
  function gl(t, e, n) {
    var i = "" + Math.abs(t),
      a = e - i.length,
      l = t >= 0;
    return (
      (l ? (n ? "+" : "") : "-") +
      Math.pow(10, Math.max(0, a)).toString().substr(1) +
      i
    );
  }
  var Hw =
      /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
    B0 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
    i_ = {},
    Lh = {};
  function $e(t, e, n, i) {
    var a = i;
    (typeof i == "string" &&
      (a = function () {
        return this[i]();
      }),
      t && (Lh[t] = a),
      e &&
        (Lh[e[0]] = function () {
          return gl(a.apply(this, arguments), e[1], e[2]);
        }),
      n &&
        (Lh[n] = function () {
          return this.localeData().ordinal(a.apply(this, arguments), t);
        }));
  }
  function dk(t) {
    return t.match(/\[[\s\S]/)
      ? t.replace(/^\[|\]$/g, "")
      : t.replace(/\\/g, "");
  }
  function hk(t) {
    var e = t.match(Hw),
      n,
      i;
    for (n = 0, i = e.length; n < i; n++)
      Lh[e[n]] ? (e[n] = Lh[e[n]]) : (e[n] = dk(e[n]));
    return function (a) {
      var l = "",
        u;
      for (u = 0; u < i; u++) l += yl(e[u]) ? e[u].call(a, t) : e[u];
      return l;
    };
  }
  function K0(t, e) {
    return t.isValid()
      ? ((e = lO(e, t.localeData())), (i_[e] = i_[e] || hk(e)), i_[e](t))
      : t.localeData().invalidDate();
  }
  function lO(t, e) {
    var n = 5;
    function i(a) {
      return e.longDateFormat(a) || a;
    }
    for (B0.lastIndex = 0; n >= 0 && B0.test(t); )
      ((t = t.replace(B0, i)), (B0.lastIndex = 0), (n -= 1));
    return t;
  }
  var pk = {
    LTS: "h:mm:ss A",
    LT: "h:mm A",
    L: "MM/DD/YYYY",
    LL: "MMMM D, YYYY",
    LLL: "MMMM D, YYYY h:mm A",
    LLLL: "dddd, MMMM D, YYYY h:mm A",
  };
  function mk(t) {
    var e = this._longDateFormat[t],
      n = this._longDateFormat[t.toUpperCase()];
    return e || !n
      ? e
      : ((this._longDateFormat[t] = n
          .match(Hw)
          .map(function (i) {
            return i === "MMMM" || i === "MM" || i === "DD" || i === "dddd"
              ? i.slice(1)
              : i;
          })
          .join("")),
        this._longDateFormat[t]);
  }
  var gk = "Invalid date";
  function vk() {
    return this._invalidDate;
  }
  var yk = "%d",
    bk = /\d{1,2}/;
  function xk(t) {
    return this._ordinal.replace("%d", t);
  }
  var _k = {
    future: "in %s",
    past: "%s ago",
    s: "a few seconds",
    ss: "%d seconds",
    m: "a minute",
    mm: "%d minutes",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    w: "a week",
    ww: "%d weeks",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years",
  };
  function wk(t, e, n, i) {
    var a = this._relativeTime[n];
    return yl(a) ? a(t, e, n, i) : a.replace(/%d/i, t);
  }
  function Sk(t, e) {
    var n = this._relativeTime[t > 0 ? "future" : "past"];
    return yl(n) ? n(e) : n.replace(/%s/i, e);
  }
  var hE = {
    D: "date",
    dates: "date",
    date: "date",
    d: "day",
    days: "day",
    day: "day",
    e: "weekday",
    weekdays: "weekday",
    weekday: "weekday",
    E: "isoWeekday",
    isoweekdays: "isoWeekday",
    isoweekday: "isoWeekday",
    DDD: "dayOfYear",
    dayofyears: "dayOfYear",
    dayofyear: "dayOfYear",
    h: "hour",
    hours: "hour",
    hour: "hour",
    ms: "millisecond",
    milliseconds: "millisecond",
    millisecond: "millisecond",
    m: "minute",
    minutes: "minute",
    minute: "minute",
    M: "month",
    months: "month",
    month: "month",
    Q: "quarter",
    quarters: "quarter",
    quarter: "quarter",
    s: "second",
    seconds: "second",
    second: "second",
    gg: "weekYear",
    weekyears: "weekYear",
    weekyear: "weekYear",
    GG: "isoWeekYear",
    isoweekyears: "isoWeekYear",
    isoweekyear: "isoWeekYear",
    w: "week",
    weeks: "week",
    week: "week",
    W: "isoWeek",
    isoweeks: "isoWeek",
    isoweek: "isoWeek",
    y: "year",
    years: "year",
    year: "year",
  };
  function Fr(t) {
    return typeof t == "string" ? hE[t] || hE[t.toLowerCase()] : void 0;
  }
  function Yw(t) {
    var e = {},
      n,
      i;
    for (i in t) Ft(t, i) && ((n = Fr(i)), n && (e[n] = t[i]));
    return e;
  }
  var Tk = {
    date: 9,
    day: 11,
    weekday: 11,
    isoWeekday: 11,
    dayOfYear: 4,
    hour: 13,
    millisecond: 16,
    minute: 14,
    month: 8,
    quarter: 7,
    second: 15,
    weekYear: 1,
    isoWeekYear: 1,
    week: 5,
    isoWeek: 5,
    year: 1,
  };
  function Ek(t) {
    var e = [],
      n;
    for (n in t) Ft(t, n) && e.push({ unit: n, priority: Tk[n] });
    return (
      e.sort(function (i, a) {
        return i.priority - a.priority;
      }),
      e
    );
  }
  var oO = /\d/,
    gr = /\d\d/,
    cO = /\d{3}/,
    qw = /\d{4}/,
    Vb = /[+-]?\d{6}/,
    yn = /\d\d?/,
    uO = /\d\d\d\d?/,
    fO = /\d\d\d\d\d\d?/,
    Wb = /\d{1,3}/,
    $w = /\d{1,4}/,
    Xb = /[+-]?\d{1,6}/,
    sp = /\d+/,
    Qb = /[+-]?\d+/,
    Ck = /Z|[+-]\d\d:?\d\d/gi,
    Zb = /Z|[+-]\d\d(?::?\d\d)?/gi,
    Ok = /[+-]?\d+(\.\d{1,3})?/,
    av =
      /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
    rp = /^[1-9]\d?/,
    Gw = /^([1-9]\d|\d)/,
    Sb;
  Sb = {};
  function Ue(t, e, n) {
    Sb[t] = yl(e)
      ? e
      : function (i, a) {
          return i && n ? n : e;
        };
  }
  function jk(t, e) {
    return Ft(Sb, t) ? Sb[t](e._strict, e._locale) : new RegExp(Mk(t));
  }
  function Mk(t) {
    return po(
      t
        .replace("\\", "")
        .replace(
          /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
          function (e, n, i, a, l) {
            return n || i || a || l;
          },
        ),
    );
  }
  function po(t) {
    return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  }
  function zr(t) {
    return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
  }
  function Tt(t) {
    var e = +t,
      n = 0;
    return (e !== 0 && isFinite(e) && (n = zr(e)), n);
  }
  var tw = {};
  function rn(t, e) {
    var n,
      i = e,
      a;
    for (
      typeof t == "string" && (t = [t]),
        bo(e) &&
          (i = function (l, u) {
            u[e] = Tt(l);
          }),
        a = t.length,
        n = 0;
      n < a;
      n++
    )
      tw[t[n]] = i;
  }
  function lv(t, e) {
    rn(t, function (n, i, a, l) {
      ((a._w = a._w || {}), e(n, a._w, a, l));
    });
  }
  function Nk(t, e, n) {
    e != null && Ft(tw, t) && tw[t](e, n._a, n, t);
  }
  function Kb(t) {
    return (t % 4 === 0 && t % 100 !== 0) || t % 400 === 0;
  }
  var Ui = 0,
    co = 1,
    fl = 2,
    ii = 3,
    ma = 4,
    uo = 5,
    yf = 6,
    Ak = 7,
    Rk = 8;
  $e("Y", 0, 0, function () {
    var t = this.year();
    return t <= 9999 ? gl(t, 4) : "+" + t;
  });
  $e(0, ["YY", 2], 0, function () {
    return this.year() % 100;
  });
  $e(0, ["YYYY", 4], 0, "year");
  $e(0, ["YYYYY", 5], 0, "year");
  $e(0, ["YYYYYY", 6, !0], 0, "year");
  Ue("Y", Qb);
  Ue("YY", yn, gr);
  Ue("YYYY", $w, qw);
  Ue("YYYYY", Xb, Vb);
  Ue("YYYYYY", Xb, Vb);
  rn(["YYYYY", "YYYYYY"], Ui);
  rn("YYYY", function (t, e) {
    e[Ui] = t.length === 2 ? De.parseTwoDigitYear(t) : Tt(t);
  });
  rn("YY", function (t, e) {
    e[Ui] = De.parseTwoDigitYear(t);
  });
  rn("Y", function (t, e) {
    e[Ui] = parseInt(t, 10);
  });
  function Tg(t) {
    return Kb(t) ? 366 : 365;
  }
  De.parseTwoDigitYear = function (t) {
    return Tt(t) + (Tt(t) > 68 ? 1900 : 2e3);
  };
  var dO = ap("FullYear", !0);
  function Lk() {
    return Kb(this.year());
  }
  function ap(t, e) {
    return function (n) {
      return n != null
        ? (hO(this, t, n), De.updateOffset(this, e), this)
        : kg(this, t);
    };
  }
  function kg(t, e) {
    if (!t.isValid()) return NaN;
    var n = t._d,
      i = t._isUTC;
    switch (e) {
      case "Milliseconds":
        return i ? n.getUTCMilliseconds() : n.getMilliseconds();
      case "Seconds":
        return i ? n.getUTCSeconds() : n.getSeconds();
      case "Minutes":
        return i ? n.getUTCMinutes() : n.getMinutes();
      case "Hours":
        return i ? n.getUTCHours() : n.getHours();
      case "Date":
        return i ? n.getUTCDate() : n.getDate();
      case "Day":
        return i ? n.getUTCDay() : n.getDay();
      case "Month":
        return i ? n.getUTCMonth() : n.getMonth();
      case "FullYear":
        return i ? n.getUTCFullYear() : n.getFullYear();
      default:
        return NaN;
    }
  }
  function hO(t, e, n) {
    var i, a, l, u, d;
    if (!(!t.isValid() || isNaN(n))) {
      switch (((i = t._d), (a = t._isUTC), e)) {
        case "Milliseconds":
          return void (a ? i.setUTCMilliseconds(n) : i.setMilliseconds(n));
        case "Seconds":
          return void (a ? i.setUTCSeconds(n) : i.setSeconds(n));
        case "Minutes":
          return void (a ? i.setUTCMinutes(n) : i.setMinutes(n));
        case "Hours":
          return void (a ? i.setUTCHours(n) : i.setHours(n));
        case "Date":
          return void (a ? i.setUTCDate(n) : i.setDate(n));
        case "FullYear":
          break;
        default:
          return;
      }
      ((l = n),
        (u = t.month()),
        (d = t.date()),
        (d = d === 29 && u === 1 && !Kb(l) ? 28 : d),
        a ? i.setUTCFullYear(l, u, d) : i.setFullYear(l, u, d));
    }
  }
  function Dk(t) {
    return ((t = Fr(t)), yl(this[t]) ? this[t]() : this);
  }
  function kk(t, e) {
    if (typeof t == "object") {
      t = Yw(t);
      var n = Ek(t),
        i,
        a = n.length;
      for (i = 0; i < a; i++) this[n[i].unit](t[n[i].unit]);
    } else if (((t = Fr(t)), yl(this[t]))) return this[t](e);
    return this;
  }
  function zk(t, e) {
    return ((t % e) + e) % e;
  }
  var $n;
  Array.prototype.indexOf
    ? ($n = Array.prototype.indexOf)
    : ($n = function (t) {
        var e;
        for (e = 0; e < this.length; ++e) if (this[e] === t) return e;
        return -1;
      });
  function Vw(t, e) {
    if (isNaN(t) || isNaN(e)) return NaN;
    var n = zk(e, 12);
    return (
      (t += (e - n) / 12),
      n === 1 ? (Kb(t) ? 29 : 28) : 31 - ((n % 7) % 2)
    );
  }
  $e("M", ["MM", 2], "Mo", function () {
    return this.month() + 1;
  });
  $e("MMM", 0, 0, function (t) {
    return this.localeData().monthsShort(this, t);
  });
  $e("MMMM", 0, 0, function (t) {
    return this.localeData().months(this, t);
  });
  Ue("M", yn, rp);
  Ue("MM", yn, gr);
  Ue("MMM", function (t, e) {
    return e.monthsShortRegex(t);
  });
  Ue("MMMM", function (t, e) {
    return e.monthsRegex(t);
  });
  rn(["M", "MM"], function (t, e) {
    e[co] = Tt(t) - 1;
  });
  rn(["MMM", "MMMM"], function (t, e, n, i) {
    var a = n._locale.monthsParse(t, i, n._strict);
    a != null ? (e[co] = a) : (dt(n).invalidMonth = t);
  });
  var Pk =
      "January_February_March_April_May_June_July_August_September_October_November_December".split(
        "_",
      ),
    pO = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    mO = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
    Ik = av,
    Uk = av;
  function Fk(t, e) {
    return t
      ? va(this._months)
        ? this._months[t.month()]
        : this._months[
            (this._months.isFormat || mO).test(e) ? "format" : "standalone"
          ][t.month()]
      : va(this._months)
        ? this._months
        : this._months.standalone;
  }
  function Bk(t, e) {
    return t
      ? va(this._monthsShort)
        ? this._monthsShort[t.month()]
        : this._monthsShort[mO.test(e) ? "format" : "standalone"][t.month()]
      : va(this._monthsShort)
        ? this._monthsShort
        : this._monthsShort.standalone;
  }
  function Hk(t, e, n) {
    var i,
      a,
      l,
      u = t.toLocaleLowerCase();
    if (!this._monthsParse)
      for (
        this._monthsParse = [],
          this._longMonthsParse = [],
          this._shortMonthsParse = [],
          i = 0;
        i < 12;
        ++i
      )
        ((l = vl([2e3, i])),
          (this._shortMonthsParse[i] = this.monthsShort(
            l,
            "",
          ).toLocaleLowerCase()),
          (this._longMonthsParse[i] = this.months(l, "").toLocaleLowerCase()));
    return n
      ? e === "MMM"
        ? ((a = $n.call(this._shortMonthsParse, u)), a !== -1 ? a : null)
        : ((a = $n.call(this._longMonthsParse, u)), a !== -1 ? a : null)
      : e === "MMM"
        ? ((a = $n.call(this._shortMonthsParse, u)),
          a !== -1
            ? a
            : ((a = $n.call(this._longMonthsParse, u)), a !== -1 ? a : null))
        : ((a = $n.call(this._longMonthsParse, u)),
          a !== -1
            ? a
            : ((a = $n.call(this._shortMonthsParse, u)), a !== -1 ? a : null));
  }
  function Yk(t, e, n) {
    var i, a, l;
    if (this._monthsParseExact) return Hk.call(this, t, e, n);
    for (
      this._monthsParse ||
        ((this._monthsParse = []),
        (this._longMonthsParse = []),
        (this._shortMonthsParse = [])),
        i = 0;
      i < 12;
      i++
    ) {
      if (
        ((a = vl([2e3, i])),
        n &&
          !this._longMonthsParse[i] &&
          ((this._longMonthsParse[i] = new RegExp(
            "^" + this.months(a, "").replace(".", "") + "$",
            "i",
          )),
          (this._shortMonthsParse[i] = new RegExp(
            "^" + this.monthsShort(a, "").replace(".", "") + "$",
            "i",
          ))),
        !n &&
          !this._monthsParse[i] &&
          ((l = "^" + this.months(a, "") + "|^" + this.monthsShort(a, "")),
          (this._monthsParse[i] = new RegExp(l.replace(".", ""), "i"))),
        n && e === "MMMM" && this._longMonthsParse[i].test(t))
      )
        return i;
      if (n && e === "MMM" && this._shortMonthsParse[i].test(t)) return i;
      if (!n && this._monthsParse[i].test(t)) return i;
    }
  }
  function gO(t, e) {
    if (!t.isValid()) return t;
    if (typeof e == "string") {
      if (/^\d+$/.test(e)) e = Tt(e);
      else if (((e = t.localeData().monthsParse(e)), !bo(e))) return t;
    }
    var n = e,
      i = t.date();
    return (
      (i = i < 29 ? i : Math.min(i, Vw(t.year(), n))),
      t._isUTC ? t._d.setUTCMonth(n, i) : t._d.setMonth(n, i),
      t
    );
  }
  function vO(t) {
    return t != null
      ? (gO(this, t), De.updateOffset(this, !0), this)
      : kg(this, "Month");
  }
  function qk() {
    return Vw(this.year(), this.month());
  }
  function $k(t) {
    return this._monthsParseExact
      ? (Ft(this, "_monthsRegex") || yO.call(this),
        t ? this._monthsShortStrictRegex : this._monthsShortRegex)
      : (Ft(this, "_monthsShortRegex") || (this._monthsShortRegex = Ik),
        this._monthsShortStrictRegex && t
          ? this._monthsShortStrictRegex
          : this._monthsShortRegex);
  }
  function Gk(t) {
    return this._monthsParseExact
      ? (Ft(this, "_monthsRegex") || yO.call(this),
        t ? this._monthsStrictRegex : this._monthsRegex)
      : (Ft(this, "_monthsRegex") || (this._monthsRegex = Uk),
        this._monthsStrictRegex && t
          ? this._monthsStrictRegex
          : this._monthsRegex);
  }
  function yO() {
    function t(m, g) {
      return g.length - m.length;
    }
    var e = [],
      n = [],
      i = [],
      a,
      l,
      u,
      d;
    for (a = 0; a < 12; a++)
      ((l = vl([2e3, a])),
        (u = po(this.monthsShort(l, ""))),
        (d = po(this.months(l, ""))),
        e.push(u),
        n.push(d),
        i.push(d),
        i.push(u));
    (e.sort(t),
      n.sort(t),
      i.sort(t),
      (this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i")),
      (this._monthsShortRegex = this._monthsRegex),
      (this._monthsStrictRegex = new RegExp("^(" + n.join("|") + ")", "i")),
      (this._monthsShortStrictRegex = new RegExp(
        "^(" + e.join("|") + ")",
        "i",
      )));
  }
  function Vk(t, e, n, i, a, l, u) {
    var d;
    return (
      t < 100 && t >= 0
        ? ((d = new Date(t + 400, e, n, i, a, l, u)),
          isFinite(d.getFullYear()) && d.setFullYear(t))
        : (d = new Date(t, e, n, i, a, l, u)),
      d
    );
  }
  function zg(t) {
    var e, n;
    return (
      t < 100 && t >= 0
        ? ((n = Array.prototype.slice.call(arguments)),
          (n[0] = t + 400),
          (e = new Date(Date.UTC.apply(null, n))),
          isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t))
        : (e = new Date(Date.UTC.apply(null, arguments))),
      e
    );
  }
  function Tb(t, e, n) {
    var i = 7 + e - n,
      a = (7 + zg(t, 0, i).getUTCDay() - e) % 7;
    return -a + i - 1;
  }
  function bO(t, e, n, i, a) {
    var l = (7 + n - i) % 7,
      u = Tb(t, i, a),
      d = 1 + 7 * (e - 1) + l + u,
      m,
      g;
    return (
      d <= 0
        ? ((m = t - 1), (g = Tg(m) + d))
        : d > Tg(t)
          ? ((m = t + 1), (g = d - Tg(t)))
          : ((m = t), (g = d)),
      { year: m, dayOfYear: g }
    );
  }
  function Pg(t, e, n) {
    var i = Tb(t.year(), e, n),
      a = Math.floor((t.dayOfYear() - i - 1) / 7) + 1,
      l,
      u;
    return (
      a < 1
        ? ((u = t.year() - 1), (l = a + mo(u, e, n)))
        : a > mo(t.year(), e, n)
          ? ((l = a - mo(t.year(), e, n)), (u = t.year() + 1))
          : ((u = t.year()), (l = a)),
      { week: l, year: u }
    );
  }
  function mo(t, e, n) {
    var i = Tb(t, e, n),
      a = Tb(t + 1, e, n);
    return (Tg(t) - i + a) / 7;
  }
  $e("w", ["ww", 2], "wo", "week");
  $e("W", ["WW", 2], "Wo", "isoWeek");
  Ue("w", yn, rp);
  Ue("ww", yn, gr);
  Ue("W", yn, rp);
  Ue("WW", yn, gr);
  lv(["w", "ww", "W", "WW"], function (t, e, n, i) {
    e[i.substr(0, 1)] = Tt(t);
  });
  function Wk(t) {
    return Pg(t, this._week.dow, this._week.doy).week;
  }
  var Xk = { dow: 0, doy: 6 };
  function Qk() {
    return this._week.dow;
  }
  function Zk() {
    return this._week.doy;
  }
  function Kk(t) {
    var e = this.localeData().week(this);
    return t == null ? e : this.add((t - e) * 7, "d");
  }
  function Jk(t) {
    var e = Pg(this, 1, 4).week;
    return t == null ? e : this.add((t - e) * 7, "d");
  }
  $e("d", 0, "do", "day");
  $e("dd", 0, 0, function (t) {
    return this.localeData().weekdaysMin(this, t);
  });
  $e("ddd", 0, 0, function (t) {
    return this.localeData().weekdaysShort(this, t);
  });
  $e("dddd", 0, 0, function (t) {
    return this.localeData().weekdays(this, t);
  });
  $e("e", 0, 0, "weekday");
  $e("E", 0, 0, "isoWeekday");
  Ue("d", yn);
  Ue("e", yn);
  Ue("E", yn);
  Ue("dd", function (t, e) {
    return e.weekdaysMinRegex(t);
  });
  Ue("ddd", function (t, e) {
    return e.weekdaysShortRegex(t);
  });
  Ue("dddd", function (t, e) {
    return e.weekdaysRegex(t);
  });
  lv(["dd", "ddd", "dddd"], function (t, e, n, i) {
    var a = n._locale.weekdaysParse(t, i, n._strict);
    a != null ? (e.d = a) : (dt(n).invalidWeekday = t);
  });
  lv(["d", "e", "E"], function (t, e, n, i) {
    e[i] = Tt(t);
  });
  function ez(t, e) {
    return typeof t != "string"
      ? t
      : isNaN(t)
        ? ((t = e.weekdaysParse(t)), typeof t == "number" ? t : null)
        : parseInt(t, 10);
  }
  function tz(t, e) {
    return typeof t == "string"
      ? e.weekdaysParse(t) % 7 || 7
      : isNaN(t)
        ? null
        : t;
  }
  function Ww(t, e) {
    return t.slice(e, 7).concat(t.slice(0, e));
  }
  var nz = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
      "_",
    ),
    xO = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    iz = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
    sz = av,
    rz = av,
    az = av;
  function lz(t, e) {
    var n = va(this._weekdays)
      ? this._weekdays
      : this._weekdays[
          t && t !== !0 && this._weekdays.isFormat.test(e)
            ? "format"
            : "standalone"
        ];
    return t === !0 ? Ww(n, this._week.dow) : t ? n[t.day()] : n;
  }
  function oz(t) {
    return t === !0
      ? Ww(this._weekdaysShort, this._week.dow)
      : t
        ? this._weekdaysShort[t.day()]
        : this._weekdaysShort;
  }
  function cz(t) {
    return t === !0
      ? Ww(this._weekdaysMin, this._week.dow)
      : t
        ? this._weekdaysMin[t.day()]
        : this._weekdaysMin;
  }
  function uz(t, e, n) {
    var i,
      a,
      l,
      u = t.toLocaleLowerCase();
    if (!this._weekdaysParse)
      for (
        this._weekdaysParse = [],
          this._shortWeekdaysParse = [],
          this._minWeekdaysParse = [],
          i = 0;
        i < 7;
        ++i
      )
        ((l = vl([2e3, 1]).day(i)),
          (this._minWeekdaysParse[i] = this.weekdaysMin(
            l,
            "",
          ).toLocaleLowerCase()),
          (this._shortWeekdaysParse[i] = this.weekdaysShort(
            l,
            "",
          ).toLocaleLowerCase()),
          (this._weekdaysParse[i] = this.weekdays(l, "").toLocaleLowerCase()));
    return n
      ? e === "dddd"
        ? ((a = $n.call(this._weekdaysParse, u)), a !== -1 ? a : null)
        : e === "ddd"
          ? ((a = $n.call(this._shortWeekdaysParse, u)), a !== -1 ? a : null)
          : ((a = $n.call(this._minWeekdaysParse, u)), a !== -1 ? a : null)
      : e === "dddd"
        ? ((a = $n.call(this._weekdaysParse, u)),
          a !== -1 || ((a = $n.call(this._shortWeekdaysParse, u)), a !== -1)
            ? a
            : ((a = $n.call(this._minWeekdaysParse, u)), a !== -1 ? a : null))
        : e === "ddd"
          ? ((a = $n.call(this._shortWeekdaysParse, u)),
            a !== -1 || ((a = $n.call(this._weekdaysParse, u)), a !== -1)
              ? a
              : ((a = $n.call(this._minWeekdaysParse, u)), a !== -1 ? a : null))
          : ((a = $n.call(this._minWeekdaysParse, u)),
            a !== -1 || ((a = $n.call(this._weekdaysParse, u)), a !== -1)
              ? a
              : ((a = $n.call(this._shortWeekdaysParse, u)),
                a !== -1 ? a : null));
  }
  function fz(t, e, n) {
    var i, a, l;
    if (this._weekdaysParseExact) return uz.call(this, t, e, n);
    for (
      this._weekdaysParse ||
        ((this._weekdaysParse = []),
        (this._minWeekdaysParse = []),
        (this._shortWeekdaysParse = []),
        (this._fullWeekdaysParse = [])),
        i = 0;
      i < 7;
      i++
    ) {
      if (
        ((a = vl([2e3, 1]).day(i)),
        n &&
          !this._fullWeekdaysParse[i] &&
          ((this._fullWeekdaysParse[i] = new RegExp(
            "^" + this.weekdays(a, "").replace(".", "\\.?") + "$",
            "i",
          )),
          (this._shortWeekdaysParse[i] = new RegExp(
            "^" + this.weekdaysShort(a, "").replace(".", "\\.?") + "$",
            "i",
          )),
          (this._minWeekdaysParse[i] = new RegExp(
            "^" + this.weekdaysMin(a, "").replace(".", "\\.?") + "$",
            "i",
          ))),
        this._weekdaysParse[i] ||
          ((l =
            "^" +
            this.weekdays(a, "") +
            "|^" +
            this.weekdaysShort(a, "") +
            "|^" +
            this.weekdaysMin(a, "")),
          (this._weekdaysParse[i] = new RegExp(l.replace(".", ""), "i"))),
        n && e === "dddd" && this._fullWeekdaysParse[i].test(t))
      )
        return i;
      if (n && e === "ddd" && this._shortWeekdaysParse[i].test(t)) return i;
      if (n && e === "dd" && this._minWeekdaysParse[i].test(t)) return i;
      if (!n && this._weekdaysParse[i].test(t)) return i;
    }
  }
  function dz(t) {
    if (!this.isValid()) return t != null ? this : NaN;
    var e = kg(this, "Day");
    return t != null
      ? ((t = ez(t, this.localeData())), this.add(t - e, "d"))
      : e;
  }
  function hz(t) {
    if (!this.isValid()) return t != null ? this : NaN;
    var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return t == null ? e : this.add(t - e, "d");
  }
  function pz(t) {
    if (!this.isValid()) return t != null ? this : NaN;
    if (t != null) {
      var e = tz(t, this.localeData());
      return this.day(this.day() % 7 ? e : e - 7);
    } else return this.day() || 7;
  }
  function mz(t) {
    return this._weekdaysParseExact
      ? (Ft(this, "_weekdaysRegex") || Xw.call(this),
        t ? this._weekdaysStrictRegex : this._weekdaysRegex)
      : (Ft(this, "_weekdaysRegex") || (this._weekdaysRegex = sz),
        this._weekdaysStrictRegex && t
          ? this._weekdaysStrictRegex
          : this._weekdaysRegex);
  }
  function gz(t) {
    return this._weekdaysParseExact
      ? (Ft(this, "_weekdaysRegex") || Xw.call(this),
        t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
      : (Ft(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = rz),
        this._weekdaysShortStrictRegex && t
          ? this._weekdaysShortStrictRegex
          : this._weekdaysShortRegex);
  }
  function vz(t) {
    return this._weekdaysParseExact
      ? (Ft(this, "_weekdaysRegex") || Xw.call(this),
        t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
      : (Ft(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = az),
        this._weekdaysMinStrictRegex && t
          ? this._weekdaysMinStrictRegex
          : this._weekdaysMinRegex);
  }
  function Xw() {
    function t(v, y) {
      return y.length - v.length;
    }
    var e = [],
      n = [],
      i = [],
      a = [],
      l,
      u,
      d,
      m,
      g;
    for (l = 0; l < 7; l++)
      ((u = vl([2e3, 1]).day(l)),
        (d = po(this.weekdaysMin(u, ""))),
        (m = po(this.weekdaysShort(u, ""))),
        (g = po(this.weekdays(u, ""))),
        e.push(d),
        n.push(m),
        i.push(g),
        a.push(d),
        a.push(m),
        a.push(g));
    (e.sort(t),
      n.sort(t),
      i.sort(t),
      a.sort(t),
      (this._weekdaysRegex = new RegExp("^(" + a.join("|") + ")", "i")),
      (this._weekdaysShortRegex = this._weekdaysRegex),
      (this._weekdaysMinRegex = this._weekdaysRegex),
      (this._weekdaysStrictRegex = new RegExp("^(" + i.join("|") + ")", "i")),
      (this._weekdaysShortStrictRegex = new RegExp(
        "^(" + n.join("|") + ")",
        "i",
      )),
      (this._weekdaysMinStrictRegex = new RegExp(
        "^(" + e.join("|") + ")",
        "i",
      )));
  }
  function Qw() {
    return this.hours() % 12 || 12;
  }
  function yz() {
    return this.hours() || 24;
  }
  $e("H", ["HH", 2], 0, "hour");
  $e("h", ["hh", 2], 0, Qw);
  $e("k", ["kk", 2], 0, yz);
  $e("hmm", 0, 0, function () {
    return "" + Qw.apply(this) + gl(this.minutes(), 2);
  });
  $e("hmmss", 0, 0, function () {
    return "" + Qw.apply(this) + gl(this.minutes(), 2) + gl(this.seconds(), 2);
  });
  $e("Hmm", 0, 0, function () {
    return "" + this.hours() + gl(this.minutes(), 2);
  });
  $e("Hmmss", 0, 0, function () {
    return "" + this.hours() + gl(this.minutes(), 2) + gl(this.seconds(), 2);
  });
  function _O(t, e) {
    $e(t, 0, 0, function () {
      return this.localeData().meridiem(this.hours(), this.minutes(), e);
    });
  }
  _O("a", !0);
  _O("A", !1);
  function wO(t, e) {
    return e._meridiemParse;
  }
  Ue("a", wO);
  Ue("A", wO);
  Ue("H", yn, Gw);
  Ue("h", yn, rp);
  Ue("k", yn, rp);
  Ue("HH", yn, gr);
  Ue("hh", yn, gr);
  Ue("kk", yn, gr);
  Ue("hmm", uO);
  Ue("hmmss", fO);
  Ue("Hmm", uO);
  Ue("Hmmss", fO);
  rn(["H", "HH"], ii);
  rn(["k", "kk"], function (t, e, n) {
    var i = Tt(t);
    e[ii] = i === 24 ? 0 : i;
  });
  rn(["a", "A"], function (t, e, n) {
    ((n._isPm = n._locale.isPM(t)), (n._meridiem = t));
  });
  rn(["h", "hh"], function (t, e, n) {
    ((e[ii] = Tt(t)), (dt(n).bigHour = !0));
  });
  rn("hmm", function (t, e, n) {
    var i = t.length - 2;
    ((e[ii] = Tt(t.substr(0, i))),
      (e[ma] = Tt(t.substr(i))),
      (dt(n).bigHour = !0));
  });
  rn("hmmss", function (t, e, n) {
    var i = t.length - 4,
      a = t.length - 2;
    ((e[ii] = Tt(t.substr(0, i))),
      (e[ma] = Tt(t.substr(i, 2))),
      (e[uo] = Tt(t.substr(a))),
      (dt(n).bigHour = !0));
  });
  rn("Hmm", function (t, e, n) {
    var i = t.length - 2;
    ((e[ii] = Tt(t.substr(0, i))), (e[ma] = Tt(t.substr(i))));
  });
  rn("Hmmss", function (t, e, n) {
    var i = t.length - 4,
      a = t.length - 2;
    ((e[ii] = Tt(t.substr(0, i))),
      (e[ma] = Tt(t.substr(i, 2))),
      (e[uo] = Tt(t.substr(a))));
  });
  function bz(t) {
    return (t + "").toLowerCase().charAt(0) === "p";
  }
  var xz = /[ap]\.?m?\.?/i,
    _z = ap("Hours", !0);
  function wz(t, e, n) {
    return t > 11 ? (n ? "pm" : "PM") : n ? "am" : "AM";
  }
  var SO = {
      calendar: uk,
      longDateFormat: pk,
      invalidDate: gk,
      ordinal: yk,
      dayOfMonthOrdinalParse: bk,
      relativeTime: _k,
      months: Pk,
      monthsShort: pO,
      week: Xk,
      weekdays: nz,
      weekdaysMin: iz,
      weekdaysShort: xO,
      meridiemParse: xz,
    },
    Tn = {},
    pg = {},
    Ig;
  function Sz(t, e) {
    var n,
      i = Math.min(t.length, e.length);
    for (n = 0; n < i; n += 1) if (t[n] !== e[n]) return n;
    return i;
  }
  function pE(t) {
    return t && t.toLowerCase().replace("_", "-");
  }
  function Tz(t) {
    for (var e = 0, n, i, a, l; e < t.length; ) {
      for (
        l = pE(t[e]).split("-"),
          n = l.length,
          i = pE(t[e + 1]),
          i = i ? i.split("-") : null;
        n > 0;

      ) {
        if (((a = Jb(l.slice(0, n).join("-"))), a)) return a;
        if (i && i.length >= n && Sz(l, i) >= n - 1) break;
        n--;
      }
      e++;
    }
    return Ig;
  }
  function Ez(t) {
    return !!(t && t.match("^[^/\\\\]*$"));
  }
  function Jb(t) {
    var e = null,
      n;
    if (Tn[t] === void 0 && typeof tb < "u" && tb && tb.exports && Ez(t))
      try {
        ((e = Ig._abbr), (n = require), n("./locale/" + t), Ic(e));
      } catch {
        Tn[t] = null;
      }
    return Tn[t];
  }
  function Ic(t, e) {
    var n;
    return (
      t &&
        (Us(e) ? (n = xo(t)) : (n = Zw(t, e)),
        n
          ? (Ig = n)
          : typeof console < "u" &&
            console.warn &&
            console.warn(
              "Locale " + t + " not found. Did you forget to load it?",
            )),
      Ig._abbr
    );
  }
  function Zw(t, e) {
    if (e !== null) {
      var n,
        i = SO;
      if (((e.abbr = t), Tn[t] != null))
        (aO(
          "defineLocaleOverride",
          "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.",
        ),
          (i = Tn[t]._config));
      else if (e.parentLocale != null)
        if (Tn[e.parentLocale] != null) i = Tn[e.parentLocale]._config;
        else if (((n = Jb(e.parentLocale)), n != null)) i = n._config;
        else
          return (
            pg[e.parentLocale] || (pg[e.parentLocale] = []),
            pg[e.parentLocale].push({ name: t, config: e }),
            null
          );
      return (
        (Tn[t] = new Bw(J_(i, e))),
        pg[t] &&
          pg[t].forEach(function (a) {
            Zw(a.name, a.config);
          }),
        Ic(t),
        Tn[t]
      );
    } else return (delete Tn[t], null);
  }
  function Cz(t, e) {
    if (e != null) {
      var n,
        i,
        a = SO;
      (Tn[t] != null && Tn[t].parentLocale != null
        ? Tn[t].set(J_(Tn[t]._config, e))
        : ((i = Jb(t)),
          i != null && (a = i._config),
          (e = J_(a, e)),
          i == null && (e.abbr = t),
          (n = new Bw(e)),
          (n.parentLocale = Tn[t]),
          (Tn[t] = n)),
        Ic(t));
    } else
      Tn[t] != null &&
        (Tn[t].parentLocale != null
          ? ((Tn[t] = Tn[t].parentLocale), t === Ic() && Ic(t))
          : Tn[t] != null && delete Tn[t]);
    return Tn[t];
  }
  function xo(t) {
    var e;
    if ((t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t))
      return Ig;
    if (!va(t)) {
      if (((e = Jb(t)), e)) return e;
      t = [t];
    }
    return Tz(t);
  }
  function Oz() {
    return ew(Tn);
  }
  function Kw(t) {
    var e,
      n = t._a;
    return (
      n &&
        dt(t).overflow === -2 &&
        ((e =
          n[co] < 0 || n[co] > 11
            ? co
            : n[fl] < 1 || n[fl] > Vw(n[Ui], n[co])
              ? fl
              : n[ii] < 0 ||
                  n[ii] > 24 ||
                  (n[ii] === 24 && (n[ma] !== 0 || n[uo] !== 0 || n[yf] !== 0))
                ? ii
                : n[ma] < 0 || n[ma] > 59
                  ? ma
                  : n[uo] < 0 || n[uo] > 59
                    ? uo
                    : n[yf] < 0 || n[yf] > 999
                      ? yf
                      : -1),
        dt(t)._overflowDayOfYear && (e < Ui || e > fl) && (e = fl),
        dt(t)._overflowWeeks && e === -1 && (e = Ak),
        dt(t)._overflowWeekday && e === -1 && (e = Rk),
        (dt(t).overflow = e)),
      t
    );
  }
  var jz =
      /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    Mz =
      /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    Nz = /Z|[+-]\d\d(?::?\d\d)?/,
    H0 = [
      ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
      ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
      ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
      ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
      ["YYYY-DDD", /\d{4}-\d{3}/],
      ["YYYY-MM", /\d{4}-\d\d/, !1],
      ["YYYYYYMMDD", /[+-]\d{10}/],
      ["YYYYMMDD", /\d{8}/],
      ["GGGG[W]WWE", /\d{4}W\d{3}/],
      ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
      ["YYYYDDD", /\d{7}/],
      ["YYYYMM", /\d{6}/, !1],
      ["YYYY", /\d{4}/, !1],
    ],
    s_ = [
      ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
      ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
      ["HH:mm:ss", /\d\d:\d\d:\d\d/],
      ["HH:mm", /\d\d:\d\d/],
      ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
      ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
      ["HHmmss", /\d\d\d\d\d\d/],
      ["HHmm", /\d\d\d\d/],
      ["HH", /\d\d/],
    ],
    Az = /^\/?Date\((-?\d+)/i,
    Rz =
      /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
    Lz = {
      UT: 0,
      GMT: 0,
      EDT: -240,
      EST: -300,
      CDT: -300,
      CST: -360,
      MDT: -360,
      MST: -420,
      PDT: -420,
      PST: -480,
    };
  function TO(t) {
    var e,
      n,
      i = t._i,
      a = jz.exec(i) || Mz.exec(i),
      l,
      u,
      d,
      m,
      g = H0.length,
      v = s_.length;
    if (a) {
      for (dt(t).iso = !0, e = 0, n = g; e < n; e++)
        if (H0[e][1].exec(a[1])) {
          ((u = H0[e][0]), (l = H0[e][2] !== !1));
          break;
        }
      if (u == null) {
        t._isValid = !1;
        return;
      }
      if (a[3]) {
        for (e = 0, n = v; e < n; e++)
          if (s_[e][1].exec(a[3])) {
            d = (a[2] || " ") + s_[e][0];
            break;
          }
        if (d == null) {
          t._isValid = !1;
          return;
        }
      }
      if (!l && d != null) {
        t._isValid = !1;
        return;
      }
      if (a[4])
        if (Nz.exec(a[4])) m = "Z";
        else {
          t._isValid = !1;
          return;
        }
      ((t._f = u + (d || "") + (m || "")), eS(t));
    } else t._isValid = !1;
  }
  function Dz(t, e, n, i, a, l) {
    var u = [
      kz(t),
      pO.indexOf(e),
      parseInt(n, 10),
      parseInt(i, 10),
      parseInt(a, 10),
    ];
    return (l && u.push(parseInt(l, 10)), u);
  }
  function kz(t) {
    var e = parseInt(t, 10);
    return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e;
  }
  function zz(t) {
    return t
      .replace(/\([^()]*\)|[\n\t]/g, " ")
      .replace(/(\s\s+)/g, " ")
      .replace(/^\s\s*/, "")
      .replace(/\s\s*$/, "");
  }
  function Pz(t, e, n) {
    if (t) {
      var i = xO.indexOf(t),
        a = new Date(e[0], e[1], e[2]).getDay();
      if (i !== a) return ((dt(n).weekdayMismatch = !0), (n._isValid = !1), !1);
    }
    return !0;
  }
  function Iz(t, e, n) {
    if (t) return Lz[t];
    if (e) return 0;
    var i = parseInt(n, 10),
      a = i % 100,
      l = (i - a) / 100;
    return l * 60 + a;
  }
  function EO(t) {
    var e = Rz.exec(zz(t._i)),
      n;
    if (e) {
      if (((n = Dz(e[4], e[3], e[2], e[5], e[6], e[7])), !Pz(e[1], n, t)))
        return;
      ((t._a = n),
        (t._tzm = Iz(e[8], e[9], e[10])),
        (t._d = zg.apply(null, t._a)),
        t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm),
        (dt(t).rfc2822 = !0));
    } else t._isValid = !1;
  }
  function Uz(t) {
    var e = Az.exec(t._i);
    if (e !== null) {
      t._d = new Date(+e[1]);
      return;
    }
    if ((TO(t), t._isValid === !1)) delete t._isValid;
    else return;
    if ((EO(t), t._isValid === !1)) delete t._isValid;
    else return;
    t._strict ? (t._isValid = !1) : De.createFromInputFallback(t);
  }
  De.createFromInputFallback = Ur(
    "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
    function (t) {
      t._d = new Date(t._i + (t._useUTC ? " UTC" : ""));
    },
  );
  function Nh(t, e, n) {
    return t ?? e ?? n;
  }
  function Fz(t) {
    var e = new Date(De.now());
    return t._useUTC
      ? [e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()]
      : [e.getFullYear(), e.getMonth(), e.getDate()];
  }
  function Jw(t) {
    var e,
      n,
      i = [],
      a,
      l,
      u;
    if (!t._d) {
      for (
        a = Fz(t),
          t._w && t._a[fl] == null && t._a[co] == null && Bz(t),
          t._dayOfYear != null &&
            ((u = Nh(t._a[Ui], a[Ui])),
            (t._dayOfYear > Tg(u) || t._dayOfYear === 0) &&
              (dt(t)._overflowDayOfYear = !0),
            (n = zg(u, 0, t._dayOfYear)),
            (t._a[co] = n.getUTCMonth()),
            (t._a[fl] = n.getUTCDate())),
          e = 0;
        e < 3 && t._a[e] == null;
        ++e
      )
        t._a[e] = i[e] = a[e];
      for (; e < 7; e++)
        t._a[e] = i[e] = t._a[e] == null ? (e === 2 ? 1 : 0) : t._a[e];
      (t._a[ii] === 24 &&
        t._a[ma] === 0 &&
        t._a[uo] === 0 &&
        t._a[yf] === 0 &&
        ((t._nextDay = !0), (t._a[ii] = 0)),
        (t._d = (t._useUTC ? zg : Vk).apply(null, i)),
        (l = t._useUTC ? t._d.getUTCDay() : t._d.getDay()),
        t._tzm != null && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm),
        t._nextDay && (t._a[ii] = 24),
        t._w &&
          typeof t._w.d < "u" &&
          t._w.d !== l &&
          (dt(t).weekdayMismatch = !0));
    }
  }
  function Bz(t) {
    var e, n, i, a, l, u, d, m, g;
    ((e = t._w),
      e.GG != null || e.W != null || e.E != null
        ? ((l = 1),
          (u = 4),
          (n = Nh(e.GG, t._a[Ui], Pg(vn(), 1, 4).year)),
          (i = Nh(e.W, 1)),
          (a = Nh(e.E, 1)),
          (a < 1 || a > 7) && (m = !0))
        : ((l = t._locale._week.dow),
          (u = t._locale._week.doy),
          (g = Pg(vn(), l, u)),
          (n = Nh(e.gg, t._a[Ui], g.year)),
          (i = Nh(e.w, g.week)),
          e.d != null
            ? ((a = e.d), (a < 0 || a > 6) && (m = !0))
            : e.e != null
              ? ((a = e.e + l), (e.e < 0 || e.e > 6) && (m = !0))
              : (a = l)),
      i < 1 || i > mo(n, l, u)
        ? (dt(t)._overflowWeeks = !0)
        : m != null
          ? (dt(t)._overflowWeekday = !0)
          : ((d = bO(n, i, a, l, u)),
            (t._a[Ui] = d.year),
            (t._dayOfYear = d.dayOfYear)));
  }
  De.ISO_8601 = function () {};
  De.RFC_2822 = function () {};
  function eS(t) {
    if (t._f === De.ISO_8601) {
      TO(t);
      return;
    }
    if (t._f === De.RFC_2822) {
      EO(t);
      return;
    }
    ((t._a = []), (dt(t).empty = !0));
    var e = "" + t._i,
      n,
      i,
      a,
      l,
      u,
      d = e.length,
      m = 0,
      g,
      v;
    for (
      a = lO(t._f, t._locale).match(Hw) || [], v = a.length, n = 0;
      n < v;
      n++
    )
      ((l = a[n]),
        (i = (e.match(jk(l, t)) || [])[0]),
        i &&
          ((u = e.substr(0, e.indexOf(i))),
          u.length > 0 && dt(t).unusedInput.push(u),
          (e = e.slice(e.indexOf(i) + i.length)),
          (m += i.length)),
        Lh[l]
          ? (i ? (dt(t).empty = !1) : dt(t).unusedTokens.push(l), Nk(l, i, t))
          : t._strict && !i && dt(t).unusedTokens.push(l));
    ((dt(t).charsLeftOver = d - m),
      e.length > 0 && dt(t).unusedInput.push(e),
      t._a[ii] <= 12 &&
        dt(t).bigHour === !0 &&
        t._a[ii] > 0 &&
        (dt(t).bigHour = void 0),
      (dt(t).parsedDateParts = t._a.slice(0)),
      (dt(t).meridiem = t._meridiem),
      (t._a[ii] = Hz(t._locale, t._a[ii], t._meridiem)),
      (g = dt(t).era),
      g !== null && (t._a[Ui] = t._locale.erasConvertYear(g, t._a[Ui])),
      Jw(t),
      Kw(t));
  }
  function Hz(t, e, n) {
    var i;
    return n == null
      ? e
      : t.meridiemHour != null
        ? t.meridiemHour(e, n)
        : (t.isPM != null &&
            ((i = t.isPM(n)),
            i && e < 12 && (e += 12),
            !i && e === 12 && (e = 0)),
          e);
  }
  function Yz(t) {
    var e,
      n,
      i,
      a,
      l,
      u,
      d = !1,
      m = t._f.length;
    if (m === 0) {
      ((dt(t).invalidFormat = !0), (t._d = new Date(NaN)));
      return;
    }
    for (a = 0; a < m; a++)
      ((l = 0),
        (u = !1),
        (e = Fw({}, t)),
        t._useUTC != null && (e._useUTC = t._useUTC),
        (e._f = t._f[a]),
        eS(e),
        Uw(e) && (u = !0),
        (l += dt(e).charsLeftOver),
        (l += dt(e).unusedTokens.length * 10),
        (dt(e).score = l),
        d
          ? l < i && ((i = l), (n = e))
          : (i == null || l < i || u) && ((i = l), (n = e), u && (d = !0)));
    Lc(t, n || e);
  }
  function qz(t) {
    if (!t._d) {
      var e = Yw(t._i),
        n = e.day === void 0 ? e.date : e.day;
      ((t._a = sO(
        [e.year, e.month, n, e.hour, e.minute, e.second, e.millisecond],
        function (i) {
          return i && parseInt(i, 10);
        },
      )),
        Jw(t));
    }
  }
  function $z(t) {
    var e = new rv(Kw(CO(t)));
    return (e._nextDay && (e.add(1, "d"), (e._nextDay = void 0)), e);
  }
  function CO(t) {
    var e = t._i,
      n = t._f;
    return (
      (t._locale = t._locale || xo(t._l)),
      e === null || (n === void 0 && e === "")
        ? Gb({ nullInput: !0 })
        : (typeof e == "string" && (t._i = e = t._locale.preparse(e)),
          ya(e)
            ? new rv(Kw(e))
            : (sv(e) ? (t._d = e) : va(n) ? Yz(t) : n ? eS(t) : Gz(t),
              Uw(t) || (t._d = null),
              t))
    );
  }
  function Gz(t) {
    var e = t._i;
    Us(e)
      ? (t._d = new Date(De.now()))
      : sv(e)
        ? (t._d = new Date(e.valueOf()))
        : typeof e == "string"
          ? Uz(t)
          : va(e)
            ? ((t._a = sO(e.slice(0), function (n) {
                return parseInt(n, 10);
              })),
              Jw(t))
            : Af(e)
              ? qz(t)
              : bo(e)
                ? (t._d = new Date(e))
                : De.createFromInputFallback(t);
  }
  function OO(t, e, n, i, a) {
    var l = {};
    return (
      (e === !0 || e === !1) && ((i = e), (e = void 0)),
      (n === !0 || n === !1) && ((i = n), (n = void 0)),
      ((Af(t) && Iw(t)) || (va(t) && t.length === 0)) && (t = void 0),
      (l._isAMomentObject = !0),
      (l._useUTC = l._isUTC = a),
      (l._l = n),
      (l._i = t),
      (l._f = e),
      (l._strict = i),
      $z(l)
    );
  }
  function vn(t, e, n, i) {
    return OO(t, e, n, i, !1);
  }
  var Vz = Ur(
      "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
      function () {
        var t = vn.apply(null, arguments);
        return this.isValid() && t.isValid() ? (t < this ? this : t) : Gb();
      },
    ),
    Wz = Ur(
      "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
      function () {
        var t = vn.apply(null, arguments);
        return this.isValid() && t.isValid() ? (t > this ? this : t) : Gb();
      },
    );
  function jO(t, e) {
    var n, i;
    if ((e.length === 1 && va(e[0]) && (e = e[0]), !e.length)) return vn();
    for (n = e[0], i = 1; i < e.length; ++i)
      (!e[i].isValid() || e[i][t](n)) && (n = e[i]);
    return n;
  }
  function Xz() {
    var t = [].slice.call(arguments, 0);
    return jO("isBefore", t);
  }
  function Qz() {
    var t = [].slice.call(arguments, 0);
    return jO("isAfter", t);
  }
  var Zz = function () {
      return Date.now ? Date.now() : +new Date();
    },
    mg = [
      "year",
      "quarter",
      "month",
      "week",
      "day",
      "hour",
      "minute",
      "second",
      "millisecond",
    ];
  function Kz(t) {
    var e,
      n = !1,
      i,
      a = mg.length;
    for (e in t)
      if (
        Ft(t, e) &&
        !($n.call(mg, e) !== -1 && (t[e] == null || !isNaN(t[e])))
      )
        return !1;
    for (i = 0; i < a; ++i)
      if (t[mg[i]]) {
        if (n) return !1;
        parseFloat(t[mg[i]]) !== Tt(t[mg[i]]) && (n = !0);
      }
    return !0;
  }
  function Jz() {
    return this._isValid;
  }
  function eP() {
    return Ea(NaN);
  }
  function e1(t) {
    var e = Yw(t),
      n = e.year || 0,
      i = e.quarter || 0,
      a = e.month || 0,
      l = e.week || e.isoWeek || 0,
      u = e.day || 0,
      d = e.hour || 0,
      m = e.minute || 0,
      g = e.second || 0,
      v = e.millisecond || 0;
    ((this._isValid = Kz(e)),
      (this._milliseconds = +v + g * 1e3 + m * 6e4 + d * 1e3 * 60 * 60),
      (this._days = +u + l * 7),
      (this._months = +a + i * 3 + n * 12),
      (this._data = {}),
      (this._locale = xo()),
      this._bubble());
  }
  function J0(t) {
    return t instanceof e1;
  }
  function nw(t) {
    return t < 0 ? Math.round(-1 * t) * -1 : Math.round(t);
  }
  function tP(t, e, n) {
    var i = Math.min(t.length, e.length),
      a = Math.abs(t.length - e.length),
      l = 0,
      u;
    for (u = 0; u < i; u++) Tt(t[u]) !== Tt(e[u]) && l++;
    return l + a;
  }
  function MO(t, e) {
    $e(t, 0, 0, function () {
      var n = this.utcOffset(),
        i = "+";
      return (
        n < 0 && ((n = -n), (i = "-")),
        i + gl(~~(n / 60), 2) + e + gl(~~n % 60, 2)
      );
    });
  }
  MO("Z", ":");
  MO("ZZ", "");
  Ue("Z", Zb);
  Ue("ZZ", Zb);
  rn(["Z", "ZZ"], function (t, e, n) {
    ((n._useUTC = !0), (n._tzm = tS(Zb, t)));
  });
  var nP = /([\+\-]|\d\d)/gi;
  function tS(t, e) {
    var n = (e || "").match(t),
      i,
      a,
      l;
    return n === null
      ? null
      : ((i = n[n.length - 1] || []),
        (a = (i + "").match(nP) || ["-", 0, 0]),
        (l = +(a[1] * 60) + Tt(a[2])),
        l === 0 ? 0 : a[0] === "+" ? l : -l);
  }
  function nS(t, e) {
    var n, i;
    return e._isUTC
      ? ((n = e.clone()),
        (i = (ya(t) || sv(t) ? t.valueOf() : vn(t).valueOf()) - n.valueOf()),
        n._d.setTime(n._d.valueOf() + i),
        De.updateOffset(n, !1),
        n)
      : vn(t).local();
  }
  function iw(t) {
    return -Math.round(t._d.getTimezoneOffset());
  }
  De.updateOffset = function () {};
  function iP(t, e, n) {
    var i = this._offset || 0,
      a;
    if (!this.isValid()) return t != null ? this : NaN;
    if (t != null) {
      if (typeof t == "string") {
        if (((t = tS(Zb, t)), t === null)) return this;
      } else Math.abs(t) < 16 && !n && (t = t * 60);
      return (
        !this._isUTC && e && (a = iw(this)),
        (this._offset = t),
        (this._isUTC = !0),
        a != null && this.add(a, "m"),
        i !== t &&
          (!e || this._changeInProgress
            ? RO(this, Ea(t - i, "m"), 1, !1)
            : this._changeInProgress ||
              ((this._changeInProgress = !0),
              De.updateOffset(this, !0),
              (this._changeInProgress = null))),
        this
      );
    } else return this._isUTC ? i : iw(this);
  }
  function sP(t, e) {
    return t != null
      ? (typeof t != "string" && (t = -t), this.utcOffset(t, e), this)
      : -this.utcOffset();
  }
  function rP(t) {
    return this.utcOffset(0, t);
  }
  function aP(t) {
    return (
      this._isUTC &&
        (this.utcOffset(0, t),
        (this._isUTC = !1),
        t && this.subtract(iw(this), "m")),
      this
    );
  }
  function lP() {
    if (this._tzm != null) this.utcOffset(this._tzm, !1, !0);
    else if (typeof this._i == "string") {
      var t = tS(Ck, this._i);
      t != null ? this.utcOffset(t) : this.utcOffset(0, !0);
    }
    return this;
  }
  function oP(t) {
    return this.isValid()
      ? ((t = t ? vn(t).utcOffset() : 0), (this.utcOffset() - t) % 60 === 0)
      : !1;
  }
  function cP() {
    return (
      this.utcOffset() > this.clone().month(0).utcOffset() ||
      this.utcOffset() > this.clone().month(5).utcOffset()
    );
  }
  function uP() {
    if (!Us(this._isDSTShifted)) return this._isDSTShifted;
    var t = {},
      e;
    return (
      Fw(t, this),
      (t = CO(t)),
      t._a
        ? ((e = t._isUTC ? vl(t._a) : vn(t._a)),
          (this._isDSTShifted = this.isValid() && tP(t._a, e.toArray()) > 0))
        : (this._isDSTShifted = !1),
      this._isDSTShifted
    );
  }
  function fP() {
    return this.isValid() ? !this._isUTC : !1;
  }
  function dP() {
    return this.isValid() ? this._isUTC : !1;
  }
  function NO() {
    return this.isValid() ? this._isUTC && this._offset === 0 : !1;
  }
  var hP = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
    pP =
      /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
  function Ea(t, e) {
    var n = t,
      i = null,
      a,
      l,
      u;
    return (
      J0(t)
        ? (n = { ms: t._milliseconds, d: t._days, M: t._months })
        : bo(t) || !isNaN(+t)
          ? ((n = {}), e ? (n[e] = +t) : (n.milliseconds = +t))
          : (i = hP.exec(t))
            ? ((a = i[1] === "-" ? -1 : 1),
              (n = {
                y: 0,
                d: Tt(i[fl]) * a,
                h: Tt(i[ii]) * a,
                m: Tt(i[ma]) * a,
                s: Tt(i[uo]) * a,
                ms: Tt(nw(i[yf] * 1e3)) * a,
              }))
            : (i = pP.exec(t))
              ? ((a = i[1] === "-" ? -1 : 1),
                (n = {
                  y: df(i[2], a),
                  M: df(i[3], a),
                  w: df(i[4], a),
                  d: df(i[5], a),
                  h: df(i[6], a),
                  m: df(i[7], a),
                  s: df(i[8], a),
                }))
              : n == null
                ? (n = {})
                : typeof n == "object" &&
                  ("from" in n || "to" in n) &&
                  ((u = mP(vn(n.from), vn(n.to))),
                  (n = {}),
                  (n.ms = u.milliseconds),
                  (n.M = u.months)),
      (l = new e1(n)),
      J0(t) && Ft(t, "_locale") && (l._locale = t._locale),
      J0(t) && Ft(t, "_isValid") && (l._isValid = t._isValid),
      l
    );
  }
  Ea.fn = e1.prototype;
  Ea.invalid = eP;
  function df(t, e) {
    var n = t && parseFloat(t.replace(",", "."));
    return (isNaN(n) ? 0 : n) * e;
  }
  function mE(t, e) {
    var n = {};
    return (
      (n.months = e.month() - t.month() + (e.year() - t.year()) * 12),
      t.clone().add(n.months, "M").isAfter(e) && --n.months,
      (n.milliseconds = +e - +t.clone().add(n.months, "M")),
      n
    );
  }
  function mP(t, e) {
    var n;
    return t.isValid() && e.isValid()
      ? ((e = nS(e, t)),
        t.isBefore(e)
          ? (n = mE(t, e))
          : ((n = mE(e, t)),
            (n.milliseconds = -n.milliseconds),
            (n.months = -n.months)),
        n)
      : { milliseconds: 0, months: 0 };
  }
  function AO(t, e) {
    return function (n, i) {
      var a, l;
      return (
        i !== null &&
          !isNaN(+i) &&
          (aO(
            e,
            "moment()." +
              e +
              "(period, number) is deprecated. Please use moment()." +
              e +
              "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.",
          ),
          (l = n),
          (n = i),
          (i = l)),
        (a = Ea(n, i)),
        RO(this, a, t),
        this
      );
    };
  }
  function RO(t, e, n, i) {
    var a = e._milliseconds,
      l = nw(e._days),
      u = nw(e._months);
    t.isValid() &&
      ((i = i ?? !0),
      u && gO(t, kg(t, "Month") + u * n),
      l && hO(t, "Date", kg(t, "Date") + l * n),
      a && t._d.setTime(t._d.valueOf() + a * n),
      i && De.updateOffset(t, l || u));
  }
  var gP = AO(1, "add"),
    vP = AO(-1, "subtract");
  function LO(t) {
    return typeof t == "string" || t instanceof String;
  }
  function yP(t) {
    return (
      ya(t) ||
      sv(t) ||
      LO(t) ||
      bo(t) ||
      xP(t) ||
      bP(t) ||
      t === null ||
      t === void 0
    );
  }
  function bP(t) {
    var e = Af(t) && !Iw(t),
      n = !1,
      i = [
        "years",
        "year",
        "y",
        "months",
        "month",
        "M",
        "days",
        "day",
        "d",
        "dates",
        "date",
        "D",
        "hours",
        "hour",
        "h",
        "minutes",
        "minute",
        "m",
        "seconds",
        "second",
        "s",
        "milliseconds",
        "millisecond",
        "ms",
      ],
      a,
      l,
      u = i.length;
    for (a = 0; a < u; a += 1) ((l = i[a]), (n = n || Ft(t, l)));
    return e && n;
  }
  function xP(t) {
    var e = va(t),
      n = !1;
    return (
      e &&
        (n =
          t.filter(function (i) {
            return !bo(i) && LO(t);
          }).length === 0),
      e && n
    );
  }
  function _P(t) {
    var e = Af(t) && !Iw(t),
      n = !1,
      i = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"],
      a,
      l;
    for (a = 0; a < i.length; a += 1) ((l = i[a]), (n = n || Ft(t, l)));
    return e && n;
  }
  function wP(t, e) {
    var n = t.diff(e, "days", !0);
    return n < -6
      ? "sameElse"
      : n < -1
        ? "lastWeek"
        : n < 0
          ? "lastDay"
          : n < 1
            ? "sameDay"
            : n < 2
              ? "nextDay"
              : n < 7
                ? "nextWeek"
                : "sameElse";
  }
  function SP(t, e) {
    arguments.length === 1 &&
      (arguments[0]
        ? yP(arguments[0])
          ? ((t = arguments[0]), (e = void 0))
          : _P(arguments[0]) && ((e = arguments[0]), (t = void 0))
        : ((t = void 0), (e = void 0)));
    var n = t || vn(),
      i = nS(n, this).startOf("day"),
      a = De.calendarFormat(this, i) || "sameElse",
      l = e && (yl(e[a]) ? e[a].call(this, n) : e[a]);
    return this.format(l || this.localeData().calendar(a, this, vn(n)));
  }
  function TP() {
    return new rv(this);
  }
  function EP(t, e) {
    var n = ya(t) ? t : vn(t);
    return this.isValid() && n.isValid()
      ? ((e = Fr(e) || "millisecond"),
        e === "millisecond"
          ? this.valueOf() > n.valueOf()
          : n.valueOf() < this.clone().startOf(e).valueOf())
      : !1;
  }
  function CP(t, e) {
    var n = ya(t) ? t : vn(t);
    return this.isValid() && n.isValid()
      ? ((e = Fr(e) || "millisecond"),
        e === "millisecond"
          ? this.valueOf() < n.valueOf()
          : this.clone().endOf(e).valueOf() < n.valueOf())
      : !1;
  }
  function OP(t, e, n, i) {
    var a = ya(t) ? t : vn(t),
      l = ya(e) ? e : vn(e);
    return this.isValid() && a.isValid() && l.isValid()
      ? ((i = i || "()"),
        (i[0] === "(" ? this.isAfter(a, n) : !this.isBefore(a, n)) &&
          (i[1] === ")" ? this.isBefore(l, n) : !this.isAfter(l, n)))
      : !1;
  }
  function jP(t, e) {
    var n = ya(t) ? t : vn(t),
      i;
    return this.isValid() && n.isValid()
      ? ((e = Fr(e) || "millisecond"),
        e === "millisecond"
          ? this.valueOf() === n.valueOf()
          : ((i = n.valueOf()),
            this.clone().startOf(e).valueOf() <= i &&
              i <= this.clone().endOf(e).valueOf()))
      : !1;
  }
  function MP(t, e) {
    return this.isSame(t, e) || this.isAfter(t, e);
  }
  function NP(t, e) {
    return this.isSame(t, e) || this.isBefore(t, e);
  }
  function AP(t, e, n) {
    var i, a, l;
    if (!this.isValid()) return NaN;
    if (((i = nS(t, this)), !i.isValid())) return NaN;
    switch (((a = (i.utcOffset() - this.utcOffset()) * 6e4), (e = Fr(e)), e)) {
      case "year":
        l = eb(this, i) / 12;
        break;
      case "month":
        l = eb(this, i);
        break;
      case "quarter":
        l = eb(this, i) / 3;
        break;
      case "second":
        l = (this - i) / 1e3;
        break;
      case "minute":
        l = (this - i) / 6e4;
        break;
      case "hour":
        l = (this - i) / 36e5;
        break;
      case "day":
        l = (this - i - a) / 864e5;
        break;
      case "week":
        l = (this - i - a) / 6048e5;
        break;
      default:
        l = this - i;
    }
    return n ? l : zr(l);
  }
  function eb(t, e) {
    if (t.date() < e.date()) return -eb(e, t);
    var n = (e.year() - t.year()) * 12 + (e.month() - t.month()),
      i = t.clone().add(n, "months"),
      a,
      l;
    return (
      e - i < 0
        ? ((a = t.clone().add(n - 1, "months")), (l = (e - i) / (i - a)))
        : ((a = t.clone().add(n + 1, "months")), (l = (e - i) / (a - i))),
      -(n + l) || 0
    );
  }
  De.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
  De.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
  function RP() {
    return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
  }
  function LP(t) {
    if (!this.isValid()) return null;
    var e = t !== !0,
      n = e ? this.clone().utc() : this;
    return n.year() < 0 || n.year() > 9999
      ? K0(
          n,
          e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ",
        )
      : yl(Date.prototype.toISOString)
        ? e
          ? this.toDate().toISOString()
          : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3)
              .toISOString()
              .replace("Z", K0(n, "Z"))
        : K0(
            n,
            e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ",
          );
  }
  function DP() {
    if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
    var t = "moment",
      e = "",
      n,
      i,
      a,
      l;
    return (
      this.isLocal() ||
        ((t = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone"),
        (e = "Z")),
      (n = "[" + t + '("]'),
      (i = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY"),
      (a = "-MM-DD[T]HH:mm:ss.SSS"),
      (l = e + '[")]'),
      this.format(n + i + a + l)
    );
  }
  function kP(t) {
    t || (t = this.isUtc() ? De.defaultFormatUtc : De.defaultFormat);
    var e = K0(this, t);
    return this.localeData().postformat(e);
  }
  function zP(t, e) {
    return this.isValid() && ((ya(t) && t.isValid()) || vn(t).isValid())
      ? Ea({ to: this, from: t }).locale(this.locale()).humanize(!e)
      : this.localeData().invalidDate();
  }
  function PP(t) {
    return this.from(vn(), t);
  }
  function IP(t, e) {
    return this.isValid() && ((ya(t) && t.isValid()) || vn(t).isValid())
      ? Ea({ from: this, to: t }).locale(this.locale()).humanize(!e)
      : this.localeData().invalidDate();
  }
  function UP(t) {
    return this.to(vn(), t);
  }
  function DO(t) {
    var e;
    return t === void 0
      ? this._locale._abbr
      : ((e = xo(t)), e != null && (this._locale = e), this);
  }
  var kO = Ur(
    "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
    function (t) {
      return t === void 0 ? this.localeData() : this.locale(t);
    },
  );
  function zO() {
    return this._locale;
  }
  var Eb = 1e3,
    Dh = 60 * Eb,
    Cb = 60 * Dh,
    PO = (365 * 400 + 97) * 24 * Cb;
  function kh(t, e) {
    return ((t % e) + e) % e;
  }
  function IO(t, e, n) {
    return t < 100 && t >= 0
      ? new Date(t + 400, e, n) - PO
      : new Date(t, e, n).valueOf();
  }
  function UO(t, e, n) {
    return t < 100 && t >= 0 ? Date.UTC(t + 400, e, n) - PO : Date.UTC(t, e, n);
  }
  function FP(t) {
    var e, n;
    if (((t = Fr(t)), t === void 0 || t === "millisecond" || !this.isValid()))
      return this;
    switch (((n = this._isUTC ? UO : IO), t)) {
      case "year":
        e = n(this.year(), 0, 1);
        break;
      case "quarter":
        e = n(this.year(), this.month() - (this.month() % 3), 1);
        break;
      case "month":
        e = n(this.year(), this.month(), 1);
        break;
      case "week":
        e = n(this.year(), this.month(), this.date() - this.weekday());
        break;
      case "isoWeek":
        e = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
        break;
      case "day":
      case "date":
        e = n(this.year(), this.month(), this.date());
        break;
      case "hour":
        ((e = this._d.valueOf()),
          (e -= kh(e + (this._isUTC ? 0 : this.utcOffset() * Dh), Cb)));
        break;
      case "minute":
        ((e = this._d.valueOf()), (e -= kh(e, Dh)));
        break;
      case "second":
        ((e = this._d.valueOf()), (e -= kh(e, Eb)));
        break;
    }
    return (this._d.setTime(e), De.updateOffset(this, !0), this);
  }
  function BP(t) {
    var e, n;
    if (((t = Fr(t)), t === void 0 || t === "millisecond" || !this.isValid()))
      return this;
    switch (((n = this._isUTC ? UO : IO), t)) {
      case "year":
        e = n(this.year() + 1, 0, 1) - 1;
        break;
      case "quarter":
        e = n(this.year(), this.month() - (this.month() % 3) + 3, 1) - 1;
        break;
      case "month":
        e = n(this.year(), this.month() + 1, 1) - 1;
        break;
      case "week":
        e = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
        break;
      case "isoWeek":
        e =
          n(
            this.year(),
            this.month(),
            this.date() - (this.isoWeekday() - 1) + 7,
          ) - 1;
        break;
      case "day":
      case "date":
        e = n(this.year(), this.month(), this.date() + 1) - 1;
        break;
      case "hour":
        ((e = this._d.valueOf()),
          (e +=
            Cb - kh(e + (this._isUTC ? 0 : this.utcOffset() * Dh), Cb) - 1));
        break;
      case "minute":
        ((e = this._d.valueOf()), (e += Dh - kh(e, Dh) - 1));
        break;
      case "second":
        ((e = this._d.valueOf()), (e += Eb - kh(e, Eb) - 1));
        break;
    }
    return (this._d.setTime(e), De.updateOffset(this, !0), this);
  }
  function HP() {
    return this._d.valueOf() - (this._offset || 0) * 6e4;
  }
  function YP() {
    return Math.floor(this.valueOf() / 1e3);
  }
  function qP() {
    return new Date(this.valueOf());
  }
  function $P() {
    var t = this;
    return [
      t.year(),
      t.month(),
      t.date(),
      t.hour(),
      t.minute(),
      t.second(),
      t.millisecond(),
    ];
  }
  function GP() {
    var t = this;
    return {
      years: t.year(),
      months: t.month(),
      date: t.date(),
      hours: t.hours(),
      minutes: t.minutes(),
      seconds: t.seconds(),
      milliseconds: t.milliseconds(),
    };
  }
  function VP() {
    return this.isValid() ? this.toISOString() : null;
  }
  function WP() {
    return Uw(this);
  }
  function XP() {
    return Lc({}, dt(this));
  }
  function QP() {
    return dt(this).overflow;
  }
  function ZP() {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict,
    };
  }
  $e("N", 0, 0, "eraAbbr");
  $e("NN", 0, 0, "eraAbbr");
  $e("NNN", 0, 0, "eraAbbr");
  $e("NNNN", 0, 0, "eraName");
  $e("NNNNN", 0, 0, "eraNarrow");
  $e("y", ["y", 1], "yo", "eraYear");
  $e("y", ["yy", 2], 0, "eraYear");
  $e("y", ["yyy", 3], 0, "eraYear");
  $e("y", ["yyyy", 4], 0, "eraYear");
  Ue("N", iS);
  Ue("NN", iS);
  Ue("NNN", iS);
  Ue("NNNN", o6);
  Ue("NNNNN", c6);
  rn(["N", "NN", "NNN", "NNNN", "NNNNN"], function (t, e, n, i) {
    var a = n._locale.erasParse(t, i, n._strict);
    a ? (dt(n).era = a) : (dt(n).invalidEra = t);
  });
  Ue("y", sp);
  Ue("yy", sp);
  Ue("yyy", sp);
  Ue("yyyy", sp);
  Ue("yo", u6);
  rn(["y", "yy", "yyy", "yyyy"], Ui);
  rn(["yo"], function (t, e, n, i) {
    var a;
    (n._locale._eraYearOrdinalRegex &&
      (a = t.match(n._locale._eraYearOrdinalRegex)),
      n._locale.eraYearOrdinalParse
        ? (e[Ui] = n._locale.eraYearOrdinalParse(t, a))
        : (e[Ui] = parseInt(t, 10)));
  });
  function KP(t, e) {
    var n,
      i,
      a,
      l = this._eras || xo("en")._eras;
    for (n = 0, i = l.length; n < i; ++n) {
      switch (typeof l[n].since) {
        case "string":
          ((a = De(l[n].since).startOf("day")), (l[n].since = a.valueOf()));
          break;
      }
      switch (typeof l[n].until) {
        case "undefined":
          l[n].until = 1 / 0;
          break;
        case "string":
          ((a = De(l[n].until).startOf("day").valueOf()),
            (l[n].until = a.valueOf()));
          break;
      }
    }
    return l;
  }
  function JP(t, e, n) {
    var i,
      a,
      l = this.eras(),
      u,
      d,
      m;
    for (t = t.toUpperCase(), i = 0, a = l.length; i < a; ++i)
      if (
        ((u = l[i].name.toUpperCase()),
        (d = l[i].abbr.toUpperCase()),
        (m = l[i].narrow.toUpperCase()),
        n)
      )
        switch (e) {
          case "N":
          case "NN":
          case "NNN":
            if (d === t) return l[i];
            break;
          case "NNNN":
            if (u === t) return l[i];
            break;
          case "NNNNN":
            if (m === t) return l[i];
            break;
        }
      else if ([u, d, m].indexOf(t) >= 0) return l[i];
  }
  function e6(t, e) {
    var n = t.since <= t.until ? 1 : -1;
    return e === void 0
      ? De(t.since).year()
      : De(t.since).year() + (e - t.offset) * n;
  }
  function t6() {
    var t,
      e,
      n,
      i = this.localeData().eras();
    for (t = 0, e = i.length; t < e; ++t)
      if (
        ((n = this.clone().startOf("day").valueOf()),
        (i[t].since <= n && n <= i[t].until) ||
          (i[t].until <= n && n <= i[t].since))
      )
        return i[t].name;
    return "";
  }
  function n6() {
    var t,
      e,
      n,
      i = this.localeData().eras();
    for (t = 0, e = i.length; t < e; ++t)
      if (
        ((n = this.clone().startOf("day").valueOf()),
        (i[t].since <= n && n <= i[t].until) ||
          (i[t].until <= n && n <= i[t].since))
      )
        return i[t].narrow;
    return "";
  }
  function i6() {
    var t,
      e,
      n,
      i = this.localeData().eras();
    for (t = 0, e = i.length; t < e; ++t)
      if (
        ((n = this.clone().startOf("day").valueOf()),
        (i[t].since <= n && n <= i[t].until) ||
          (i[t].until <= n && n <= i[t].since))
      )
        return i[t].abbr;
    return "";
  }
  function s6() {
    var t,
      e,
      n,
      i,
      a = this.localeData().eras();
    for (t = 0, e = a.length; t < e; ++t)
      if (
        ((n = a[t].since <= a[t].until ? 1 : -1),
        (i = this.clone().startOf("day").valueOf()),
        (a[t].since <= i && i <= a[t].until) ||
          (a[t].until <= i && i <= a[t].since))
      )
        return (this.year() - De(a[t].since).year()) * n + a[t].offset;
    return this.year();
  }
  function r6(t) {
    return (
      Ft(this, "_erasNameRegex") || sS.call(this),
      t ? this._erasNameRegex : this._erasRegex
    );
  }
  function a6(t) {
    return (
      Ft(this, "_erasAbbrRegex") || sS.call(this),
      t ? this._erasAbbrRegex : this._erasRegex
    );
  }
  function l6(t) {
    return (
      Ft(this, "_erasNarrowRegex") || sS.call(this),
      t ? this._erasNarrowRegex : this._erasRegex
    );
  }
  function iS(t, e) {
    return e.erasAbbrRegex(t);
  }
  function o6(t, e) {
    return e.erasNameRegex(t);
  }
  function c6(t, e) {
    return e.erasNarrowRegex(t);
  }
  function u6(t, e) {
    return e._eraYearOrdinalRegex || sp;
  }
  function sS() {
    var t = [],
      e = [],
      n = [],
      i = [],
      a,
      l,
      u,
      d,
      m,
      g = this.eras();
    for (a = 0, l = g.length; a < l; ++a)
      ((u = po(g[a].name)),
        (d = po(g[a].abbr)),
        (m = po(g[a].narrow)),
        e.push(u),
        t.push(d),
        n.push(m),
        i.push(u),
        i.push(d),
        i.push(m));
    ((this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i")),
      (this._erasNameRegex = new RegExp("^(" + e.join("|") + ")", "i")),
      (this._erasAbbrRegex = new RegExp("^(" + t.join("|") + ")", "i")),
      (this._erasNarrowRegex = new RegExp("^(" + n.join("|") + ")", "i")));
  }
  $e(0, ["gg", 2], 0, function () {
    return this.weekYear() % 100;
  });
  $e(0, ["GG", 2], 0, function () {
    return this.isoWeekYear() % 100;
  });
  function t1(t, e) {
    $e(0, [t, t.length], 0, e);
  }
  t1("gggg", "weekYear");
  t1("ggggg", "weekYear");
  t1("GGGG", "isoWeekYear");
  t1("GGGGG", "isoWeekYear");
  Ue("G", Qb);
  Ue("g", Qb);
  Ue("GG", yn, gr);
  Ue("gg", yn, gr);
  Ue("GGGG", $w, qw);
  Ue("gggg", $w, qw);
  Ue("GGGGG", Xb, Vb);
  Ue("ggggg", Xb, Vb);
  lv(["gggg", "ggggg", "GGGG", "GGGGG"], function (t, e, n, i) {
    e[i.substr(0, 2)] = Tt(t);
  });
  lv(["gg", "GG"], function (t, e, n, i) {
    e[i] = De.parseTwoDigitYear(t);
  });
  function f6(t) {
    return FO.call(
      this,
      t,
      this.week(),
      this.weekday() + this.localeData()._week.dow,
      this.localeData()._week.dow,
      this.localeData()._week.doy,
    );
  }
  function d6(t) {
    return FO.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4);
  }
  function h6() {
    return mo(this.year(), 1, 4);
  }
  function p6() {
    return mo(this.isoWeekYear(), 1, 4);
  }
  function m6() {
    var t = this.localeData()._week;
    return mo(this.year(), t.dow, t.doy);
  }
  function g6() {
    var t = this.localeData()._week;
    return mo(this.weekYear(), t.dow, t.doy);
  }
  function FO(t, e, n, i, a) {
    var l;
    return t == null
      ? Pg(this, i, a).year
      : ((l = mo(t, i, a)), e > l && (e = l), v6.call(this, t, e, n, i, a));
  }
  function v6(t, e, n, i, a) {
    var l = bO(t, e, n, i, a),
      u = zg(l.year, 0, l.dayOfYear);
    return (
      this.year(u.getUTCFullYear()),
      this.month(u.getUTCMonth()),
      this.date(u.getUTCDate()),
      this
    );
  }
  $e("Q", 0, "Qo", "quarter");
  Ue("Q", oO);
  rn("Q", function (t, e) {
    e[co] = (Tt(t) - 1) * 3;
  });
  function y6(t) {
    return t == null
      ? Math.ceil((this.month() + 1) / 3)
      : this.month((t - 1) * 3 + (this.month() % 3));
  }
  $e("D", ["DD", 2], "Do", "date");
  Ue("D", yn, rp);
  Ue("DD", yn, gr);
  Ue("Do", function (t, e) {
    return t
      ? e._dayOfMonthOrdinalParse || e._ordinalParse
      : e._dayOfMonthOrdinalParseLenient;
  });
  rn(["D", "DD"], fl);
  rn("Do", function (t, e) {
    e[fl] = Tt(t.match(yn)[0]);
  });
  var BO = ap("Date", !0);
  $e("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
  Ue("DDD", Wb);
  Ue("DDDD", cO);
  rn(["DDD", "DDDD"], function (t, e, n) {
    n._dayOfYear = Tt(t);
  });
  function b6(t) {
    var e =
      Math.round(
        (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5,
      ) + 1;
    return t == null ? e : this.add(t - e, "d");
  }
  $e("m", ["mm", 2], 0, "minute");
  Ue("m", yn, Gw);
  Ue("mm", yn, gr);
  rn(["m", "mm"], ma);
  var x6 = ap("Minutes", !1);
  $e("s", ["ss", 2], 0, "second");
  Ue("s", yn, Gw);
  Ue("ss", yn, gr);
  rn(["s", "ss"], uo);
  var _6 = ap("Seconds", !1);
  $e("S", 0, 0, function () {
    return ~~(this.millisecond() / 100);
  });
  $e(0, ["SS", 2], 0, function () {
    return ~~(this.millisecond() / 10);
  });
  $e(0, ["SSS", 3], 0, "millisecond");
  $e(0, ["SSSS", 4], 0, function () {
    return this.millisecond() * 10;
  });
  $e(0, ["SSSSS", 5], 0, function () {
    return this.millisecond() * 100;
  });
  $e(0, ["SSSSSS", 6], 0, function () {
    return this.millisecond() * 1e3;
  });
  $e(0, ["SSSSSSS", 7], 0, function () {
    return this.millisecond() * 1e4;
  });
  $e(0, ["SSSSSSSS", 8], 0, function () {
    return this.millisecond() * 1e5;
  });
  $e(0, ["SSSSSSSSS", 9], 0, function () {
    return this.millisecond() * 1e6;
  });
  Ue("S", Wb, oO);
  Ue("SS", Wb, gr);
  Ue("SSS", Wb, cO);
  var Dc, HO;
  for (Dc = "SSSS"; Dc.length <= 9; Dc += "S") Ue(Dc, sp);
  function w6(t, e) {
    e[yf] = Tt(("0." + t) * 1e3);
  }
  for (Dc = "S"; Dc.length <= 9; Dc += "S") rn(Dc, w6);
  HO = ap("Milliseconds", !1);
  $e("z", 0, 0, "zoneAbbr");
  $e("zz", 0, 0, "zoneName");
  function S6() {
    return this._isUTC ? "UTC" : "";
  }
  function T6() {
    return this._isUTC ? "Coordinated Universal Time" : "";
  }
  var je = rv.prototype;
  je.add = gP;
  je.calendar = SP;
  je.clone = TP;
  je.diff = AP;
  je.endOf = BP;
  je.format = kP;
  je.from = zP;
  je.fromNow = PP;
  je.to = IP;
  je.toNow = UP;
  je.get = Dk;
  je.invalidAt = QP;
  je.isAfter = EP;
  je.isBefore = CP;
  je.isBetween = OP;
  je.isSame = jP;
  je.isSameOrAfter = MP;
  je.isSameOrBefore = NP;
  je.isValid = WP;
  je.lang = kO;
  je.locale = DO;
  je.localeData = zO;
  je.max = Wz;
  je.min = Vz;
  je.parsingFlags = XP;
  je.set = kk;
  je.startOf = FP;
  je.subtract = vP;
  je.toArray = $P;
  je.toObject = GP;
  je.toDate = qP;
  je.toISOString = LP;
  je.inspect = DP;
  typeof Symbol < "u" &&
    Symbol.for != null &&
    (je[Symbol.for("nodejs.util.inspect.custom")] = function () {
      return "Moment<" + this.format() + ">";
    });
  je.toJSON = VP;
  je.toString = RP;
  je.unix = YP;
  je.valueOf = HP;
  je.creationData = ZP;
  je.eraName = t6;
  je.eraNarrow = n6;
  je.eraAbbr = i6;
  je.eraYear = s6;
  je.year = dO;
  je.isLeapYear = Lk;
  je.weekYear = f6;
  je.isoWeekYear = d6;
  je.quarter = je.quarters = y6;
  je.month = vO;
  je.daysInMonth = qk;
  je.week = je.weeks = Kk;
  je.isoWeek = je.isoWeeks = Jk;
  je.weeksInYear = m6;
  je.weeksInWeekYear = g6;
  je.isoWeeksInYear = h6;
  je.isoWeeksInISOWeekYear = p6;
  je.date = BO;
  je.day = je.days = dz;
  je.weekday = hz;
  je.isoWeekday = pz;
  je.dayOfYear = b6;
  je.hour = je.hours = _z;
  je.minute = je.minutes = x6;
  je.second = je.seconds = _6;
  je.millisecond = je.milliseconds = HO;
  je.utcOffset = iP;
  je.utc = rP;
  je.local = aP;
  je.parseZone = lP;
  je.hasAlignedHourOffset = oP;
  je.isDST = cP;
  je.isLocal = fP;
  je.isUtcOffset = dP;
  je.isUtc = NO;
  je.isUTC = NO;
  je.zoneAbbr = S6;
  je.zoneName = T6;
  je.dates = Ur("dates accessor is deprecated. Use date instead.", BO);
  je.months = Ur("months accessor is deprecated. Use month instead", vO);
  je.years = Ur("years accessor is deprecated. Use year instead", dO);
  je.zone = Ur(
    "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
    sP,
  );
  je.isDSTShifted = Ur(
    "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
    uP,
  );
  function E6(t) {
    return vn(t * 1e3);
  }
  function C6() {
    return vn.apply(null, arguments).parseZone();
  }
  function YO(t) {
    return t;
  }
  var Bt = Bw.prototype;
  Bt.calendar = fk;
  Bt.longDateFormat = mk;
  Bt.invalidDate = vk;
  Bt.ordinal = xk;
  Bt.preparse = YO;
  Bt.postformat = YO;
  Bt.relativeTime = wk;
  Bt.pastFuture = Sk;
  Bt.set = ck;
  Bt.eras = KP;
  Bt.erasParse = JP;
  Bt.erasConvertYear = e6;
  Bt.erasAbbrRegex = a6;
  Bt.erasNameRegex = r6;
  Bt.erasNarrowRegex = l6;
  Bt.months = Fk;
  Bt.monthsShort = Bk;
  Bt.monthsParse = Yk;
  Bt.monthsRegex = Gk;
  Bt.monthsShortRegex = $k;
  Bt.week = Wk;
  Bt.firstDayOfYear = Zk;
  Bt.firstDayOfWeek = Qk;
  Bt.weekdays = lz;
  Bt.weekdaysMin = cz;
  Bt.weekdaysShort = oz;
  Bt.weekdaysParse = fz;
  Bt.weekdaysRegex = mz;
  Bt.weekdaysShortRegex = gz;
  Bt.weekdaysMinRegex = vz;
  Bt.isPM = bz;
  Bt.meridiem = wz;
  function Ob(t, e, n, i) {
    var a = xo(),
      l = vl().set(i, e);
    return a[n](l, t);
  }
  function qO(t, e, n) {
    if ((bo(t) && ((e = t), (t = void 0)), (t = t || ""), e != null))
      return Ob(t, e, n, "month");
    var i,
      a = [];
    for (i = 0; i < 12; i++) a[i] = Ob(t, i, n, "month");
    return a;
  }
  function rS(t, e, n, i) {
    typeof t == "boolean"
      ? (bo(e) && ((n = e), (e = void 0)), (e = e || ""))
      : ((e = t),
        (n = e),
        (t = !1),
        bo(e) && ((n = e), (e = void 0)),
        (e = e || ""));
    var a = xo(),
      l = t ? a._week.dow : 0,
      u,
      d = [];
    if (n != null) return Ob(e, (n + l) % 7, i, "day");
    for (u = 0; u < 7; u++) d[u] = Ob(e, (u + l) % 7, i, "day");
    return d;
  }
  function O6(t, e) {
    return qO(t, e, "months");
  }
  function j6(t, e) {
    return qO(t, e, "monthsShort");
  }
  function M6(t, e, n) {
    return rS(t, e, n, "weekdays");
  }
  function N6(t, e, n) {
    return rS(t, e, n, "weekdaysShort");
  }
  function A6(t, e, n) {
    return rS(t, e, n, "weekdaysMin");
  }
  Ic("en", {
    eras: [
      {
        since: "0001-01-01",
        until: 1 / 0,
        offset: 1,
        name: "Anno Domini",
        narrow: "AD",
        abbr: "AD",
      },
      {
        since: "0000-12-31",
        until: -1 / 0,
        offset: 1,
        name: "Before Christ",
        narrow: "BC",
        abbr: "BC",
      },
    ],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function (t) {
      var e = t % 10,
        n =
          Tt((t % 100) / 10) === 1
            ? "th"
            : e === 1
              ? "st"
              : e === 2
                ? "nd"
                : e === 3
                  ? "rd"
                  : "th";
      return t + n;
    },
  });
  De.lang = Ur("moment.lang is deprecated. Use moment.locale instead.", Ic);
  De.langData = Ur(
    "moment.langData is deprecated. Use moment.localeData instead.",
    xo,
  );
  var to = Math.abs;
  function R6() {
    var t = this._data;
    return (
      (this._milliseconds = to(this._milliseconds)),
      (this._days = to(this._days)),
      (this._months = to(this._months)),
      (t.milliseconds = to(t.milliseconds)),
      (t.seconds = to(t.seconds)),
      (t.minutes = to(t.minutes)),
      (t.hours = to(t.hours)),
      (t.months = to(t.months)),
      (t.years = to(t.years)),
      this
    );
  }
  function $O(t, e, n, i) {
    var a = Ea(e, n);
    return (
      (t._milliseconds += i * a._milliseconds),
      (t._days += i * a._days),
      (t._months += i * a._months),
      t._bubble()
    );
  }
  function L6(t, e) {
    return $O(this, t, e, 1);
  }
  function D6(t, e) {
    return $O(this, t, e, -1);
  }
  function gE(t) {
    return t < 0 ? Math.floor(t) : Math.ceil(t);
  }
  function k6() {
    var t = this._milliseconds,
      e = this._days,
      n = this._months,
      i = this._data,
      a,
      l,
      u,
      d,
      m;
    return (
      (t >= 0 && e >= 0 && n >= 0) ||
        (t <= 0 && e <= 0 && n <= 0) ||
        ((t += gE(sw(n) + e) * 864e5), (e = 0), (n = 0)),
      (i.milliseconds = t % 1e3),
      (a = zr(t / 1e3)),
      (i.seconds = a % 60),
      (l = zr(a / 60)),
      (i.minutes = l % 60),
      (u = zr(l / 60)),
      (i.hours = u % 24),
      (e += zr(u / 24)),
      (m = zr(GO(e))),
      (n += m),
      (e -= gE(sw(m))),
      (d = zr(n / 12)),
      (n %= 12),
      (i.days = e),
      (i.months = n),
      (i.years = d),
      this
    );
  }
  function GO(t) {
    return (t * 4800) / 146097;
  }
  function sw(t) {
    return (t * 146097) / 4800;
  }
  function z6(t) {
    if (!this.isValid()) return NaN;
    var e,
      n,
      i = this._milliseconds;
    if (((t = Fr(t)), t === "month" || t === "quarter" || t === "year"))
      switch (((e = this._days + i / 864e5), (n = this._months + GO(e)), t)) {
        case "month":
          return n;
        case "quarter":
          return n / 3;
        case "year":
          return n / 12;
      }
    else
      switch (((e = this._days + Math.round(sw(this._months))), t)) {
        case "week":
          return e / 7 + i / 6048e5;
        case "day":
          return e + i / 864e5;
        case "hour":
          return e * 24 + i / 36e5;
        case "minute":
          return e * 1440 + i / 6e4;
        case "second":
          return e * 86400 + i / 1e3;
        case "millisecond":
          return Math.floor(e * 864e5) + i;
        default:
          throw new Error("Unknown unit " + t);
      }
  }
  function _o(t) {
    return function () {
      return this.as(t);
    };
  }
  var VO = _o("ms"),
    P6 = _o("s"),
    I6 = _o("m"),
    U6 = _o("h"),
    F6 = _o("d"),
    B6 = _o("w"),
    H6 = _o("M"),
    Y6 = _o("Q"),
    q6 = _o("y"),
    $6 = VO;
  function G6() {
    return Ea(this);
  }
  function V6(t) {
    return ((t = Fr(t)), this.isValid() ? this[t + "s"]() : NaN);
  }
  function If(t) {
    return function () {
      return this.isValid() ? this._data[t] : NaN;
    };
  }
  var W6 = If("milliseconds"),
    X6 = If("seconds"),
    Q6 = If("minutes"),
    Z6 = If("hours"),
    K6 = If("days"),
    J6 = If("months"),
    e8 = If("years");
  function t8() {
    return zr(this.days() / 7);
  }
  var so = Math.round,
    Ah = { ss: 44, s: 45, m: 45, h: 22, d: 26, w: null, M: 11 };
  function n8(t, e, n, i, a) {
    return a.relativeTime(e || 1, !!n, t, i);
  }
  function i8(t, e, n, i) {
    var a = Ea(t).abs(),
      l = so(a.as("s")),
      u = so(a.as("m")),
      d = so(a.as("h")),
      m = so(a.as("d")),
      g = so(a.as("M")),
      v = so(a.as("w")),
      y = so(a.as("y")),
      w =
        (l <= n.ss && ["s", l]) ||
        (l < n.s && ["ss", l]) ||
        (u <= 1 && ["m"]) ||
        (u < n.m && ["mm", u]) ||
        (d <= 1 && ["h"]) ||
        (d < n.h && ["hh", d]) ||
        (m <= 1 && ["d"]) ||
        (m < n.d && ["dd", m]);
    return (
      n.w != null && (w = w || (v <= 1 && ["w"]) || (v < n.w && ["ww", v])),
      (w = w ||
        (g <= 1 && ["M"]) ||
        (g < n.M && ["MM", g]) ||
        (y <= 1 && ["y"]) || ["yy", y]),
      (w[2] = e),
      (w[3] = +t > 0),
      (w[4] = i),
      n8.apply(null, w)
    );
  }
  function s8(t) {
    return t === void 0 ? so : typeof t == "function" ? ((so = t), !0) : !1;
  }
  function r8(t, e) {
    return Ah[t] === void 0
      ? !1
      : e === void 0
        ? Ah[t]
        : ((Ah[t] = e), t === "s" && (Ah.ss = e - 1), !0);
  }
  function a8(t, e) {
    if (!this.isValid()) return this.localeData().invalidDate();
    var n = !1,
      i = Ah,
      a,
      l;
    return (
      typeof t == "object" && ((e = t), (t = !1)),
      typeof t == "boolean" && (n = t),
      typeof e == "object" &&
        ((i = Object.assign({}, Ah, e)),
        e.s != null && e.ss == null && (i.ss = e.s - 1)),
      (a = this.localeData()),
      (l = i8(this, !n, i, a)),
      n && (l = a.pastFuture(+this, l)),
      a.postformat(l)
    );
  }
  var r_ = Math.abs;
  function jh(t) {
    return (t > 0) - (t < 0) || +t;
  }
  function n1() {
    if (!this.isValid()) return this.localeData().invalidDate();
    var t = r_(this._milliseconds) / 1e3,
      e = r_(this._days),
      n = r_(this._months),
      i,
      a,
      l,
      u,
      d = this.asSeconds(),
      m,
      g,
      v,
      y;
    return d
      ? ((i = zr(t / 60)),
        (a = zr(i / 60)),
        (t %= 60),
        (i %= 60),
        (l = zr(n / 12)),
        (n %= 12),
        (u = t ? t.toFixed(3).replace(/\.?0+$/, "") : ""),
        (m = d < 0 ? "-" : ""),
        (g = jh(this._months) !== jh(d) ? "-" : ""),
        (v = jh(this._days) !== jh(d) ? "-" : ""),
        (y = jh(this._milliseconds) !== jh(d) ? "-" : ""),
        m +
          "P" +
          (l ? g + l + "Y" : "") +
          (n ? g + n + "M" : "") +
          (e ? v + e + "D" : "") +
          (a || i || t ? "T" : "") +
          (a ? y + a + "H" : "") +
          (i ? y + i + "M" : "") +
          (t ? y + u + "S" : ""))
      : "P0D";
  }
  var Dt = e1.prototype;
  Dt.isValid = Jz;
  Dt.abs = R6;
  Dt.add = L6;
  Dt.subtract = D6;
  Dt.as = z6;
  Dt.asMilliseconds = VO;
  Dt.asSeconds = P6;
  Dt.asMinutes = I6;
  Dt.asHours = U6;
  Dt.asDays = F6;
  Dt.asWeeks = B6;
  Dt.asMonths = H6;
  Dt.asQuarters = Y6;
  Dt.asYears = q6;
  Dt.valueOf = $6;
  Dt._bubble = k6;
  Dt.clone = G6;
  Dt.get = V6;
  Dt.milliseconds = W6;
  Dt.seconds = X6;
  Dt.minutes = Q6;
  Dt.hours = Z6;
  Dt.days = K6;
  Dt.weeks = t8;
  Dt.months = J6;
  Dt.years = e8;
  Dt.humanize = a8;
  Dt.toISOString = n1;
  Dt.toString = n1;
  Dt.toJSON = n1;
  Dt.locale = DO;
  Dt.localeData = zO;
  Dt.toIsoString = Ur(
    "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
    n1,
  );
  Dt.lang = kO;
  $e("X", 0, 0, "unix");
  $e("x", 0, 0, "valueOf");
  Ue("x", Qb);
  Ue("X", Ok);
  rn("X", function (t, e, n) {
    n._d = new Date(parseFloat(t) * 1e3);
  });
  rn("x", function (t, e, n) {
    n._d = new Date(Tt(t));
  }); //! moment.js
  De.version = "2.30.1";
  lk(vn);
  De.fn = je;
  De.min = Xz;
  De.max = Qz;
  De.now = Zz;
  De.utc = vl;
  De.unix = E6;
  De.months = O6;
  De.isDate = sv;
  De.locale = Ic;
  De.invalid = Gb;
  De.duration = Ea;
  De.isMoment = ya;
  De.weekdays = M6;
  De.parseZone = C6;
  De.localeData = xo;
  De.isDuration = J0;
  De.monthsShort = j6;
  De.weekdaysMin = A6;
  De.defineLocale = Zw;
  De.updateLocale = Cz;
  De.locales = Oz;
  De.weekdaysShort = N6;
  De.normalizeUnits = Fr;
  De.relativeTimeRounding = s8;
  De.relativeTimeThreshold = r8;
  De.calendarFormat = wP;
  De.prototype = je;
  De.HTML5_FMT = {
    DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
    DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
    DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
    DATE: "YYYY-MM-DD",
    TIME: "HH:mm",
    TIME_SECONDS: "HH:mm:ss",
    TIME_MS: "HH:mm:ss.SSS",
    WEEK: "GGGG-[W]WW",
    MONTH: "YYYY-MM",
  };
  const l8 = () => {
      const {
          notificatonData: t,
          fetchNotifications: e,
          loadingNtf: n,
          handleRead: i,
          fetchUnreadNotifications: a,
          unreadNotificatonData: l,
          handleRemove: u,
          loadingRemoved: d,
          handleReadAll: m,
          loadingReadNotification: g,
          handleRemoveAll: v,
        } = ak(),
        y = t && (t == null ? void 0 : t.length) > 0 ? t : [],
        [w, S] = U.useState(null),
        T = (O) => {
          S(O);
        },
        E =
          y == null ? void 0 : y.find((O) => w === (O == null ? void 0 : O.id)),
        j = ({ data: O }) => {
          var R, P;
          const M = U.useRef(null),
            N = (G) => {
              M.current && !M.current.contains(G.target) && S(null);
            };
          return (
            U.useEffect(
              () => (
                document.addEventListener("mousedown", N),
                () => document.removeEventListener("mousedown", N)
              ),
              [],
            ),
            h.jsx("div", {
              className: "modal-overlay-notification",
              children: h.jsxs("div", {
                className: "notification-modal",
                ref: M,
                children: [
                  h.jsx("div", {
                    className: "close-area",
                    children: h.jsx(V5, {
                      className: "close",
                      onClick: () => S(null),
                    }),
                  }),
                  h.jsxs("div", {
                    className: "content",
                    children: [
                      h.jsx("span", {
                        className: "time",
                        children: De(O == null ? void 0 : O.created_at).format(
                          "DD.MM.YYYY - HH:mm",
                        ),
                      }),
                      h.jsxs("div", {
                        className: "paragraph",
                        children: [
                          h.jsx("h3", {
                            children:
                              (R = O == null ? void 0 : O.data) == null
                                ? void 0
                                : R.message,
                          }),
                          h.jsx("div", {
                            className: "n-data",
                            dangerouslySetInnerHTML: {
                              __html: ip.sanitize(
                                ((P = O == null ? void 0 : O.data) == null
                                  ? void 0
                                  : P.additional_info) || "",
                              ),
                            },
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
            })
          );
        };
      return (
        U.useEffect(() => {
          (e(), a());
        }, [E == null ? void 0 : E.id]),
        h.jsxs("section", {
          className: "notifications",
          children: [
            E && h.jsx(j, { data: E }),
            h.jsx("div", {
              className: "title-content",
              children: h.jsxs("div", {
                className: `right-buttons ${(y == null ? void 0 : y.length) === 0 ? "disabled" : ""}`,
                children: [
                  h.jsx("button", {
                    className: "remove-all",
                    type: "button",
                    onClick: v,
                    children:
                      n === "allRemove"
                        ? h.jsx(ze, {})
                        : h.jsxs(U.Fragment, {
                            children: [
                              h.jsx("img", {
                                src: "/trashhh.svg",
                                alt: "remove",
                              }),
                              h.jsx("p", { children: "hamisini sil" }),
                            ],
                          }),
                  }),
                  h.jsx("button", {
                    className: "read-all",
                    type: "button",
                    onClick: m,
                    children:
                      n === "allRead"
                        ? h.jsx(ze, {})
                        : h.jsxs(U.Fragment, {
                            children: [
                              h.jsx("img", {
                                src: "/successing.svg",
                                alt: "read-all",
                              }),
                              h.jsx("p", { children: "hamisini oxu isarele" }),
                            ],
                          }),
                  }),
                  n === "fetchNotifications" && h.jsx(ze, {}),
                ],
              }),
            }),
            h.jsxs("div", {
              className: "content-notifications",
              children: [
                (y == null ? void 0 : y.length) > 0
                  ? h.jsxs("p", {
                      children: [
                        l == null ? void 0 : l.length,
                        " oxunmamis bildiris",
                      ],
                    })
                  : null,
                h.jsx("div", {
                  className: "grid-template",
                  children:
                    (y == null ? void 0 : y.length) > 0
                      ? y == null
                        ? void 0
                        : y.map((O) => {
                            var M;
                            return h.jsxs(
                              "div",
                              {
                                className: `item-template ${O.read_at !== null ? "readed" : ""}`,
                                onClick: () => {
                                  (T(O == null ? void 0 : O.id),
                                    O.read_at === null &&
                                      i(O == null ? void 0 : O.id));
                                },
                                children: [
                                  h.jsxs("div", {
                                    className: "left",
                                    children: [
                                      h.jsxs("div", {
                                        className: "left-title",
                                        children: [
                                          g[O == null ? void 0 : O.id]
                                            ? h.jsx(ze, {})
                                            : h.jsx("span", {
                                                className: "reading-flag",
                                              }),
                                          h.jsx("h2", {
                                            children:
                                              ((M =
                                                O == null ? void 0 : O.data) ==
                                              null
                                                ? void 0
                                                : M.message) || "",
                                          }),
                                        ],
                                      }),
                                      h.jsx("p", {
                                        children: De(
                                          O == null ? void 0 : O.created_at,
                                        ).format("DD.MM.YYYY - HH:mm"),
                                      }),
                                    ],
                                  }),
                                  d[O == null ? void 0 : O.id]
                                    ? h.jsx(ze, {})
                                    : h.jsx(rk, {
                                        className: "remove",
                                        onClick: (N) => {
                                          (N.stopPropagation(),
                                            u(O == null ? void 0 : O.id));
                                        },
                                      }),
                                ],
                              },
                              O == null ? void 0 : O.id,
                            );
                          })
                      : h.jsx(Pw, { message: "Hələ ki, bildirişiniz yoxdur." }),
                }),
              ],
            }),
          ],
        })
      );
    },
    o8 = () => {
      const { t } = Ot();
      return {
        NavDashboardLinks: [
          {
            id: 1,
            title: t("melumatlarim"),
            route: "/kabinet/melumatlarim",
            icon: "/iconactive.svg",
            iconActive: "/iconactive1.svg",
            returnedComponent: h.jsx(tk, {}),
          },
          {
            id: 2,
            title: t("abuneliklerim"),
            route: "/kabinet/abunelikler",
            icon: "/icon22.svg",
            iconActive: "/iconactive2.svg",
            returnedComponent: h.jsx(nk, {}),
          },
          {
            id: 3,
            title: t("test_neticelerim"),
            route: "/kabinet/test-neticelerim",
            icon: "/testnormal.svg",
            iconActive: "/test.svg",
            returnedComponent: h.jsx(sk, {}),
          },
          {
            id: 4,
            title: t("bildirisler"),
            route: "/kabinet/bildirisler",
            icon: "/notif.svg",
            iconActive: "/notifactive.svg",
            returnedComponent: h.jsx(l8, {}),
          },
        ],
      };
    },
    c8 = () => {
      var m, g;
      const { t } = Ot(),
        { NavDashboardLinks: e } = o8(),
        { logout: n, load: i, user: a } = Sa(),
        l = e.find((v) => v.route === location.pathname),
        [u, d] = U.useState((l == null ? void 0 : l.id) || 1);
      return (
        U.useEffect(() => {
          const v = e.find((y) => y.route === location.pathname);
          v && d(v.id);
        }, [location]),
        h.jsxs("main", {
          className: "dashboard-page-wrapper",
          children: [
            h.jsx("title", { children: t("sexsi_kabinet") }),
            h.jsxs("div", {
              className: "dashboard",
              children: [
                h.jsxs("div", {
                  className: "left-aside",
                  children: [
                    h.jsxs("div", {
                      className: "top-username",
                      children: [
                        h.jsx("div", {
                          className: "profile",
                          children: h.jsx("span", {
                            children:
                              (m = a == null ? void 0 : a.name) == null
                                ? void 0
                                : m.slice(0, 1),
                          }),
                        }),
                        h.jsx("p", { children: a == null ? void 0 : a.name }),
                      ],
                    }),
                    h.jsxs("nav", {
                      className: "nav-content",
                      children: [
                        e == null
                          ? void 0
                          : e.map((v) =>
                              h.jsxs(
                                VE,
                                {
                                  onClick: () => d(v == null ? void 0 : v.id),
                                  to: (v == null ? void 0 : v.route) || "",
                                  className: "link-nav",
                                  children: [
                                    h.jsx("img", {
                                      src:
                                        u === (v == null ? void 0 : v.id)
                                          ? v == null
                                            ? void 0
                                            : v.iconActive
                                          : v == null
                                            ? void 0
                                            : v.icon,
                                      alt: "",
                                    }),
                                    h.jsx("p", {
                                      children: v == null ? void 0 : v.title,
                                    }),
                                  ],
                                },
                                v == null ? void 0 : v.id,
                              ),
                            ),
                        h.jsxs("button", {
                          onClick: (v) => {
                            (v.preventDefault(), n());
                          },
                          disabled: i,
                          type: "submit",
                          className: "exit-button",
                          children: [
                            !i &&
                              h.jsx("img", { src: "/exit.svg", alt: "Exit" }),
                            h.jsx("p", {
                              children: t(
                                i ? "zehmet_olmasa_gozleyin" : "cixis",
                              ),
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
                h.jsx("div", {
                  className: "right-content",
                  children:
                    ((g = e.find((v) => v.id === u)) == null
                      ? void 0
                      : g.returnedComponent) ||
                    h.jsx("div", { children: "Bu səhifə mövcud deyil" }),
                }),
              ],
            }),
          ],
        })
      );
    },
    u8 = () => {
      var i, a;
      const { innerData: t, dataLoading: e } = Et(
          "terms-and-conditions",
          "terms_and_conditions_key",
        ),
        n = t && t != null && t.data ? (t == null ? void 0 : t.data) : null;
      return e
        ? h.jsx(ze, {})
        : h.jsxs("main", {
            className: "privacy-container-wrapper",
            children: [
              h.jsx("title", {
                children:
                  (i = t == null ? void 0 : t.data) == null ? void 0 : i.title,
              }),
              h.jsx("meta", {
                name: "description",
                content:
                  ((a = t == null ? void 0 : t.data) == null
                    ? void 0
                    : a.seo_description) ?? "",
              }),
              n
                ? h.jsxs("div", {
                    className: "privacy",
                    children: [
                      h.jsx(xi, {
                        title: n == null ? void 0 : n.title,
                        customStyle: { width: "100%", textAlign: "start" },
                      }),
                      (n == null ? void 0 : n.description) &&
                        h.jsx("div", {
                          className: "description-content",
                          dangerouslySetInnerHTML: {
                            __html: ip.sanitize(
                              (n == null ? void 0 : n.description) || "",
                            ),
                          },
                        }),
                    ],
                  })
                : null,
            ],
          });
    },
    f8 = () => {
      const t = sn(),
        { t: e } = Ot(),
        n = nt((u) => u.selectedLanguage.selectedLanguage) || "az",
        { innerData: i, dataLoading: a } = Et(
          "home-categories",
          "home_categories_key",
        ),
        l = i && (i == null ? void 0 : i.length) > 0 ? i : [];
      return (
        console.log(l, "hasCategories"),
        h.jsxs("section", {
          className: "hero-wrapper",
          children: [
            h.jsxs("svg", {
              className: "gradient",
              width: "579",
              height: "543",
              viewBox: "0 0 579 543",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [
                h.jsx("path", {
                  d: "M9.72944 370.668C-1.67128 516.281 -126.03 555.193 -186.784 556.448L-208.659 566.421L-411.406 467.018C-187.231 134.153 263.017 -530.616 270.608 -526.775C278.199 -522.933 479.117 -391.777 578.628 -326.679C555.916 -299.157 489.945 -236.863 407.76 -207.871C305.028 -171.632 337.246 27.1419 211.309 88.1473C85.372 149.153 23.9803 188.652 9.72944 370.668Z",
                  fill: "url(#paint0_linear_428_2609)",
                  fillOpacity: "0.08",
                  stroke: "url(#paint1_linear_428_2609)",
                  strokeOpacity: "0.2",
                  strokeWidth: "0.5",
                }),
                h.jsxs("defs", {
                  children: [
                    h.jsxs("linearGradient", {
                      id: "paint0_linear_428_2609",
                      x1: "318.802",
                      y1: "238.307",
                      x2: "-33.7079",
                      y2: "-13.2096",
                      gradientUnits: "userSpaceOnUse",
                      children: [
                        h.jsx("stop", { stopColor: "white" }),
                        h.jsx("stop", {
                          offset: "0.593941",
                          stopColor: "#809DFF",
                        }),
                        h.jsx("stop", { offset: "1", stopColor: "#062151" }),
                      ],
                    }),
                    h.jsxs("linearGradient", {
                      id: "paint1_linear_428_2609",
                      x1: "-280.811",
                      y1: "560.199",
                      x2: "428.439",
                      y2: "-433.84",
                      gradientUnits: "userSpaceOnUse",
                      children: [
                        h.jsx("stop", {
                          stopColor: "white",
                          stopOpacity: "0.72",
                        }),
                        h.jsx("stop", {
                          offset: "1",
                          stopColor: "white",
                          stopOpacity: "0.46",
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            }),
            h.jsxs("div", {
              className: "hero",
              children: [
                h.jsxs("div", {
                  className: "top-title-hero",
                  children: [
                    h.jsx("h1", { children: e("kateqoriyalar") }),
                    h.jsx("p", { children: e("recruitment") }),
                  ],
                }),
                h.jsx("div", {
                  className: "categories",
                  style: { gridTemplateColumns: a ? "repeat(1, 1fr)" : "" },
                  children: a
                    ? h.jsx(ze, {})
                    : l.map((u) =>
                        h.jsxs(
                          "div",
                          {
                            className: "category-item",
                            onClick: () => {
                              t(`/imtahanlar/${n}/${u.slug[n]}`);
                            },
                            children: [
                              h.jsxs("div", {
                                className: "left",
                                children: [
                                  h.jsx("div", {
                                    className: "icon-wrap",
                                    children: h.jsx("img", {
                                      src: u == null ? void 0 : u.icon,
                                      alt: u == null ? void 0 : u.title,
                                    }),
                                  }),
                                  h.jsx("h2", {
                                    children: u == null ? void 0 : u.title,
                                  }),
                                ],
                              }),
                              h.jsx("div", {
                                className: "right-icon",
                                children: h.jsx(Ab, { className: "icon" }),
                              }),
                            ],
                          },
                          u == null ? void 0 : u.id,
                        ),
                      ),
                }),
              ],
            }),
          ],
        })
      );
    },
    WO = ({ title: t, customStyle: e, href: n }) =>
      h.jsxs(_t, {
        to: n || "",
        style: e,
        className: "show-more-button-ui",
        children: [
          h.jsx("p", { children: t }),
          h.jsx("img", { src: "/right.svg", alt: "right-arrow" }),
        ],
      }),
    d8 = () => {
      var a;
      const { t } = Ot(),
        { innerData: e, dataLoading: n } = Et(
          "home-advertisements",
          "home_announcements_key",
        ),
        i =
          e != null &&
          e.data &&
          ((a = e == null ? void 0 : e.data) == null ? void 0 : a.length) > 0
            ? e == null
              ? void 0
              : e.data
            : [];
      return n
        ? h.jsx(ze, {})
        : h.jsx("section", {
            className: "announcements-wrapper",
            children: h.jsxs("div", {
              className: "announcements",
              children: [
                h.jsxs("div", {
                  className: "top-title-ann",
                  children: [
                    h.jsx(xi, { title: t("elanlar") }),
                    h.jsx(WO, { title: t("hamisina_bax"), href: "/elanlar" }),
                  ],
                }),
                h.jsx("div", {
                  className: "content-contain",
                  children:
                    i == null
                      ? void 0
                      : i.map((l) =>
                          h.jsx(eO, { data: l }, l == null ? void 0 : l.id),
                        ),
                }),
              ],
            }),
          });
    },
    h8 = () => {
      var a;
      const { t } = Ot(),
        { innerData: e, dataLoading: n } = Et(
          "home-blog-and-news",
          "home_news_key",
        ),
        i =
          e != null &&
          e.data &&
          ((a = e == null ? void 0 : e.data) == null ? void 0 : a.length) > 0
            ? e == null
              ? void 0
              : e.data
            : [];
      return n
        ? h.jsx(ze, {})
        : h.jsx("section", {
            className: "news-wrapper",
            children: h.jsxs("div", {
              className: "news",
              children: [
                h.jsxs("div", {
                  className: "top-title-ann",
                  children: [
                    h.jsx(xi, { title: t("xeberler") }),
                    h.jsx(WO, { title: t("hamisina_bax"), href: "/xeberler" }),
                  ],
                }),
                h.jsx("div", {
                  className: "content-contain",
                  children:
                    i == null
                      ? void 0
                      : i.map((l) =>
                          h.jsx(zw, { data: l }, l == null ? void 0 : l.id),
                        ),
                }),
              ],
            }),
          });
    },
    p8 = () => {
      var u;
      const { t } = Ot(),
        { innerData: e, dataLoading: n } = Et(
          "home-textbooks",
          "home_textbooks_key",
        ),
        i = (e && (e == null ? void 0 : e.whatsapp_textbook_number)) || "",
        a = _a();
      U.useEffect(() => {
        e &&
          e.whatsapp_textbook_number &&
          a(aC((e == null ? void 0 : e.whatsapp_textbook_number) || ""));
      }, [e]);
      const l =
        e &&
        e != null &&
        e.data &&
        ((u = e == null ? void 0 : e.data) == null ? void 0 : u.length) > 0
          ? e == null
            ? void 0
            : e.data
          : [];
      return n
        ? h.jsx(ze, {})
        : h.jsx("section", {
            className: "test-banks-home-wrapper",
            children: h.jsxs("div", {
              className: "test-banks-home",
              children: [
                h.jsxs("div", {
                  className: "left-title",
                  children: [
                    h.jsxs("div", {
                      className: "top-title",
                      children: [
                        h.jsx(xi, { title: t("derslik_ve_test_banklari") }),
                        h.jsx("p", {
                          children: t("derslik_ve_test_banklari_text"),
                        }),
                      ],
                    }),
                    h.jsx(Ct, {
                      title: t("hamisina_bax"),
                      href: "/derslikler-ve-test-banklari",
                    }),
                  ],
                }),
                h.jsx("div", {
                  className: "right-grid",
                  children:
                    l == null
                      ? void 0
                      : l.map((d, m) => h.jsx(q2, { data: d, wpNumber: i }, m)),
                }),
              ],
            }),
          });
    },
    m8 = () => {
      const { instance: t } = si(),
        { showServerErrorMsg: e, showServerSuccessMsg: n, showError: i } = wa(),
        [a, l] = U.useState(!1);
      return {
        handleSubmitForm: async (d) => {
          var m, g, v, y;
          l(!0);
          try {
            const w = new FormData();
            (w.append("name", d == null ? void 0 : d.name),
              w.append("surname", d == null ? void 0 : d.surname),
              w.append("phone", d == null ? void 0 : d.phone),
              w.append("email", d == null ? void 0 : d.email),
              w.append("note", d == null ? void 0 : d.note));
            const S = await t.post("/have-question", w, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            S.data
              ? ((d.name = ""),
                (d.surname = ""),
                (d.email = ""),
                (d.note = ""),
                (d.phone = ""),
                n((m = S.data) == null ? void 0 : m.message))
              : console.log(S.status);
          } catch (w) {
            (Xe.isAxiosError(w) && (g = w.response) != null && g.data
              ? e(
                  (y =
                    (v = w == null ? void 0 : w.response) == null
                      ? void 0
                      : v.data) == null
                    ? void 0
                    : y.message,
                )
              : i(),
              console.log(w));
          } finally {
            l(!1);
          }
        },
        loadForm: a,
      };
    },
    g8 = () => {
      const { t } = Ot(),
        e = { email: "", name: "", note: "", phone: "", surname: "" },
        [n, i] = U.useState(e),
        { handleSubmitForm: a, loadForm: l } = m8();
      return h.jsx("section", {
        className: "form-wrapper",
        children: h.jsxs("div", {
          className: "form",
          children: [
            h.jsxs("div", {
              className: "left-info-box",
              children: [
                h.jsx("h2", { children: t("elave_melumatlar_form") }),
                h.jsxs("div", {
                  className: "information-content",
                  children: [
                    h.jsxs("div", {
                      className: "item-content",
                      children: [
                        h.jsx("img", { src: "/tel.svg", alt: "telephone" }),
                        h.jsx(_t, {
                          className: "link",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          to: `https://wa.me/${t("your_telephone_number")}`,
                          children: t("your_telephone_number"),
                        }),
                      ],
                    }),
                    h.jsxs("div", {
                      className: "item-content",
                      children: [
                        h.jsx("img", { src: "/location.svg", alt: "location" }),
                        h.jsx("p", { children: t("your_location") }),
                      ],
                    }),
                    h.jsxs("div", {
                      className: "item-content",
                      children: [
                        h.jsx("img", { src: "/mail.svg", alt: "email" }),
                        h.jsx(_t, {
                          to: `mailto:${t("your_email")}`,
                          className: "link",
                          children: t("your_email"),
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            }),
            h.jsxs("form", {
              acceptCharset: "UTF-8",
              className: "right",
              onSubmit: (u) => {
                (u.preventDefault(), a(n));
              },
              children: [
                h.jsx("h2", { children: t("sualin_var_form_title") }),
                h.jsxs("div", {
                  className: "inputs",
                  children: [
                    h.jsxs("div", {
                      className: "grid-input",
                      children: [
                        h.jsx("div", {
                          className: "input-field",
                          children: h.jsx("input", {
                            value: n == null ? void 0 : n.name,
                            type: "text",
                            placeholder: "Ad",
                            name: "name",
                            required: !0,
                            onChange: (u) =>
                              i((d) => ({ ...d, name: u.target.value })),
                          }),
                        }),
                        h.jsx("div", {
                          className: "input-field",
                          children: h.jsx("input", {
                            type: "text",
                            placeholder: "Soyad",
                            value: n == null ? void 0 : n.surname,
                            required: !0,
                            name: "surname",
                            onChange: (u) =>
                              i((d) => ({ ...d, surname: u.target.value })),
                          }),
                        }),
                      ],
                    }),
                    h.jsxs("div", {
                      className: "grid-input",
                      children: [
                        h.jsx("div", {
                          className: "input-field",
                          children: h.jsx("input", {
                            value: n == null ? void 0 : n.email,
                            required: !0,
                            name: "email",
                            onChange: (u) =>
                              i((d) => ({ ...d, email: u.target.value })),
                            type: "email",
                            placeholder: "Email",
                          }),
                        }),
                        h.jsx("div", {
                          className: "input-field",
                          children: h.jsx("input", {
                            value: n == null ? void 0 : n.phone,
                            name: "phone",
                            required: !0,
                            style: { paddingLeft: "16px" },
                            type: "number",
                            placeholder: "+ 994 000 00 00",
                            onChange: (u) =>
                              i((d) => ({ ...d, phone: u.target.value })),
                          }),
                        }),
                      ],
                    }),
                    h.jsx("div", {
                      className: "input-normal",
                      children: h.jsx("textarea", {
                        placeholder: t("input_text"),
                        value: n == null ? void 0 : n.note,
                        name: "note",
                        required: !0,
                        onChange: (u) =>
                          i((d) => ({ ...d, note: u.target.value })),
                      }),
                    }),
                  ],
                }),
                l
                  ? h.jsx(ze, {
                      style: {
                        backgroundColor: "white",
                        height: "100px",
                        minHeight: "100px",
                      },
                    })
                  : h.jsx("button", {
                      disabled: l,
                      type: "submit",
                      children: t("gonder_button_basligi"),
                    }),
              ],
            }),
          ],
        }),
      });
    },
    v8 = () => {
      var y, w, S;
      const { t } = Ot(),
        { innerData: e, dataLoading: n } = Et(
          "important-links",
          "important_links_key",
        ),
        i =
          e &&
          e != null &&
          e.data &&
          ((y = e == null ? void 0 : e.data) == null ? void 0 : y.length) > 0
            ? e == null
              ? void 0
              : e.data
            : [],
        { innerData: a, dataLoading: l } = Et(
          "educational-regions",
          "educational_regions_key",
        ),
        u =
          a &&
          a != null &&
          a.data &&
          ((w = a == null ? void 0 : a.data) == null ? void 0 : w.length) > 0
            ? a == null
              ? void 0
              : a.data
            : [],
        { innerData: d, dataLoading: m } = Et("partners", "partners_key"),
        g =
          d &&
          d != null &&
          d.data &&
          ((S = d == null ? void 0 : d.data) == null ? void 0 : S.length) > 0
            ? d == null
              ? void 0
              : d.data
            : [],
        v = [
          {
            id: 1,
            title: t("muhum_kecidler"),
            component: h.jsx("div", {
              className: "card-one",
              children: h.jsx(zc, {
                speed: 2e3,
                autoplay: { delay: 1e3 },
                modules: [Sg],
                spaceBetween: 24,
                breakpoints: {
                  968: { slidesPerView: 4 },
                  568: { slidesPerView: 3 },
                  368: { slidesPerView: 2 },
                  268: { slidesPerView: 1 },
                },
                children:
                  i == null
                    ? void 0
                    : i.map((T) =>
                        h.jsx(
                          Pc,
                          {
                            style: { cursor: "pointer" },
                            onClick: () => (window.location.href = T.url),
                            children: h.jsx("img", {
                              src: T == null ? void 0 : T.image,
                              alt: T == null ? void 0 : T.image,
                            }),
                          },
                          T == null ? void 0 : T.id,
                        ),
                      ),
              }),
            }),
          },
          {
            id: 2,
            title: t("tehsil_regionlari"),
            component: h.jsx("div", {
              className: "card-two",
              children: h.jsx(zc, {
                speed: 2e3,
                autoplay: { delay: 1e3 },
                modules: [Sg],
                spaceBetween: 24,
                breakpoints: {
                  968: { slidesPerView: 4 },
                  568: { slidesPerView: 3 },
                  368: { slidesPerView: 2 },
                  268: { slidesPerView: 1 },
                },
                children:
                  u == null
                    ? void 0
                    : u.map((T) =>
                        h.jsx(
                          Pc,
                          {
                            style: { cursor: "pointer" },
                            onClick: () => (window.location.href = T.url),
                            children: h.jsx("img", {
                              src: T == null ? void 0 : T.image,
                              alt: T == null ? void 0 : T.image,
                            }),
                          },
                          T == null ? void 0 : T.id,
                        ),
                      ),
              }),
            }),
          },
          {
            id: 3,
            title: t("partnyorlar"),
            component: h.jsx("div", {
              className: "partners",
              children: h.jsx(zc, {
                speed: 2e3,
                autoplay: { delay: 1e3 },
                modules: [Sg],
                spaceBetween: 24,
                breakpoints: {
                  968: { slidesPerView: 4 },
                  568: { slidesPerView: 3 },
                  368: { slidesPerView: 2 },
                  268: { slidesPerView: 1 },
                },
                children:
                  g == null
                    ? void 0
                    : g.map((T) =>
                        h.jsx(
                          Pc,
                          {
                            style: { cursor: "pointer" },
                            onClick: () => (window.location.href = T.url),
                            children: h.jsx("img", {
                              src: T == null ? void 0 : T.image,
                              alt: T == null ? void 0 : T.image,
                            }),
                          },
                          T == null ? void 0 : T.id,
                        ),
                      ),
              }),
            }),
          },
        ];
      return {
        importantLinksLoading: n,
        educationalRegionsLoading: l,
        partnersLoading: m,
        Cards: v,
      };
    },
    y8 = () => {
      const {
        Cards: t,
        educationalRegionsLoading: e,
        importantLinksLoading: n,
        partnersLoading: i,
      } = v8();
      return n || e || i
        ? h.jsx(ze, {})
        : h.jsx("section", {
            className: "home-cards-wrapper",
            children: h.jsx("div", {
              className: "home-cards",
              children:
                t == null
                  ? void 0
                  : t.map((a, l) =>
                      h.jsxs(
                        "div",
                        {
                          className: "card-item",
                          children: [
                            h.jsx(xi, { title: a == null ? void 0 : a.title }),
                            a == null ? void 0 : a.component,
                          ],
                        },
                        l,
                      ),
                    ),
            }),
          });
    },
    b8 = () => {
      const { t } = Ot(),
        { isAuth: e } = Sa(),
        n = sn(),
        i = nt((d) => d.selectedLanguage.selectedLanguage),
        { innerData: a, dataLoading: l } = Et(
          "subscription-banner",
          "subscription_banner_key",
        ),
        u = a == null ? void 0 : a.data;
      return l
        ? h.jsx(ze, {})
        : u
          ? h.jsx("div", {
              className: "home-subscribe-container",
              children: h.jsxs("div", {
                className: "home-subscribe",
                children: [
                  h.jsx("img", {
                    src: u.image,
                    alt: "",
                    className: "home-subscribe-image",
                  }),
                  h.jsx("h2", {
                    className: "subscribe-title",
                    children: u.title,
                  }),
                  h.jsx("div", {
                    className: "subscribe-text",
                    dangerouslySetInnerHTML: {
                      __html: ip.sanitize(u.description || ""),
                    },
                  }),
                  h.jsx(Ct, {
                    onClickFunc: () => {
                      n(
                        e ? `/imtahanlar/${i}/abunelik-paketleri` : "/daxil-ol",
                      );
                    },
                    isButton: !0,
                    style: { border: "2px solid #407DF23D" },
                    pStyle: { color: "#FFFFFF" },
                    title: t("abune_ol"),
                    icon: "/whiteright.svg",
                  }),
                ],
              }),
            })
          : null;
    },
    x8 = () => {
      const { t, loading: e } = Ot();
      return e
        ? h.jsx(ze, {})
        : h.jsxs("div", {
            className: "home",
            children: [
              h.jsx("title", { children: t("tehsil_ana_sehife_meta_title") }),
              h.jsx(f8, {}),
              h.jsx(b8, {}),
              h.jsx(nO, {}),
              h.jsx(d8, {}),
              h.jsx(h8, {}),
              h.jsx(p8, {}),
              h.jsx(y8, {}),
              h.jsx(g8, {}),
            ],
          });
    },
    _8 = ({ children: t }) => {
      const { isAuth: e, loading: n } = Sa();
      return n
        ? h.jsx(ze, {})
        : e
          ? h.jsx(h.Fragment, { children: t })
          : h.jsx(cM, { to: "/daxil-ol", replace: !0 });
    },
    w8 = () => {
      const { innerData: t, dataLoading: e } = Et(
        "subscription-plans",
        "subscription_plans_key",
      );
      return {
        hasPackets: (t == null ? void 0 : t.data) ?? [],
        PacketsDataLoading: e,
      };
    },
    S8 = () => {
      const { t } = Ot(),
        { hasPackets: e, PacketsDataLoading: n } = w8(),
        {
          handleSubscribtion: i,
          loading: a,
          hasSubscribtions: l,
          isPremium: u,
        } = iv(),
        [d, m] = U.useState(null),
        g = Array.isArray(l) ? l : [];
      if (
        (U.useEffect(() => {
          e.length > 0 && m(e[0].id);
        }, [e]),
        n)
      )
        return h.jsx(ze, {});
      if (!e.length)
        return h.jsx(Pw, {
          message: t("bu_dersin_abunelik_ucun_paketleri_movcud_deyil"),
        });
      const v = e.find((S) => S.id === d),
        y = g.map((S) => S.plan_id),
        w = u || g.some((S) => S.active === !0) || (v && y.includes(v.id));
      return h.jsxs("section", {
        className: "subscribtion-content",
        children: [
          h.jsxs("div", {
            className: "top-title-subscribe",
            children: [
              h.jsx("h5", { children: t("abune_paketleri_ile_tanis_ol") }),
              h.jsx("p", {
                children: t("abunelik_paketleri_ile_tanis_ol_text"),
              }),
            ],
          }),
          h.jsxs("div", {
            className: "wrapper-cards",
            children: [
              h.jsx("div", {
                className: "select-months",
                children: h.jsx("div", {
                  className: "months",
                  children: e.map((S) =>
                    h.jsx(
                      "p",
                      {
                        onClick: () => m(S.id),
                        className: `month ${d === S.id ? "active-month" : ""}`,
                        children: S.duration_label,
                      },
                      S.id,
                    ),
                  ),
                }),
              }),
              v &&
                h.jsx("div", {
                  className: "cards-package",
                  children: h.jsxs("div", {
                    className: "package-card",
                    children: [
                      h.jsxs("div", {
                        className: "title-card",
                        children: [
                          h.jsxs("div", {
                            className: "top",
                            children: [
                              h.jsx("img", {
                                src: "/HandMoney.svg",
                                alt: v.title,
                              }),
                              h.jsx("h2", { children: v.title }),
                            ],
                          }),
                          v.description &&
                            h.jsx("p", { children: v.description }),
                        ],
                      }),
                      h.jsxs("div", {
                        className: "content-card",
                        children: [
                          h.jsxs("div", {
                            className: "toping",
                            children: [
                              h.jsxs("div", {
                                className: "price-and-time",
                                children: [
                                  h.jsxs("h3", {
                                    children: [v.active_price, " azn"],
                                  }),
                                  h.jsxs("span", {
                                    children: ["Müddət: ", v.duration_label],
                                  }),
                                ],
                              }),
                              h.jsxs("div", {
                                className: "content-pack",
                                children: [
                                  h.jsx("span", { children: "Daxildir:" }),
                                  v.chooseElements &&
                                    v.chooseElements.length > 0 &&
                                    h.jsx("div", {
                                      className: "content-grid",
                                      children: v.chooseElements.map((S) =>
                                        h.jsxs(
                                          "div",
                                          {
                                            className: "requirements",
                                            children: [
                                              h.jsx("img", {
                                                alt: "CheckCircle",
                                                src: "/CheckCircle.svg",
                                              }),
                                              h.jsx("p", { children: S.title }),
                                            ],
                                          },
                                          S.id,
                                        ),
                                      ),
                                    }),
                                ],
                              }),
                            ],
                          }),
                          h.jsx("div", {
                            className: "button-bottom",
                            children: h.jsx(Ct, {
                              class_name: "subscribe-button",
                              isButton: !0,
                              disabled: a === v.id || w,
                              title: u
                                ? "Premium aktivdir"
                                : w
                                  ? "Artıq alınıb"
                                  : a === v.id
                                    ? t("zehmet_olmasa_gozleyin")
                                    : t("abune_ol"),
                              onClickFunc: () => {
                                w || i({ plan_id: v.id }, v.id);
                              },
                            }),
                          }),
                        ],
                      }),
                    ],
                  }),
                }),
            ],
          }),
        ],
      });
    },
    T8 = () => {
      const { t } = Ot();
      return (
        console.log("SubscribtionPage MOUNT"),
        h.jsxs("main", {
          className: "subs-page-wrapper",
          children: [
            h.jsx("title", { children: t("abunelik_paketleri") }),
            h.jsx("div", { className: "subs-page", children: h.jsx(S8, {}) }),
          ],
        })
      );
    };
  var a_, vE;
  function E8() {
    if (vE) return a_;
    vE = 1;
    var t = {
      linear: function (e, n, i, a) {
        var l = i - n;
        return (l * e) / a + n;
      },
      easeInQuad: function (e, n, i, a) {
        var l = i - n;
        return l * (e /= a) * e + n;
      },
      easeOutQuad: function (e, n, i, a) {
        var l = i - n;
        return -l * (e /= a) * (e - 2) + n;
      },
      easeInOutQuad: function (e, n, i, a) {
        var l = i - n;
        return (e /= a / 2) < 1
          ? (l / 2) * e * e + n
          : (-l / 2) * (--e * (e - 2) - 1) + n;
      },
      easeInCubic: function (e, n, i, a) {
        var l = i - n;
        return l * (e /= a) * e * e + n;
      },
      easeOutCubic: function (e, n, i, a) {
        var l = i - n;
        return l * ((e = e / a - 1) * e * e + 1) + n;
      },
      easeInOutCubic: function (e, n, i, a) {
        var l = i - n;
        return (e /= a / 2) < 1
          ? (l / 2) * e * e * e + n
          : (l / 2) * ((e -= 2) * e * e + 2) + n;
      },
      easeInQuart: function (e, n, i, a) {
        var l = i - n;
        return l * (e /= a) * e * e * e + n;
      },
      easeOutQuart: function (e, n, i, a) {
        var l = i - n;
        return -l * ((e = e / a - 1) * e * e * e - 1) + n;
      },
      easeInOutQuart: function (e, n, i, a) {
        var l = i - n;
        return (e /= a / 2) < 1
          ? (l / 2) * e * e * e * e + n
          : (-l / 2) * ((e -= 2) * e * e * e - 2) + n;
      },
      easeInQuint: function (e, n, i, a) {
        var l = i - n;
        return l * (e /= a) * e * e * e * e + n;
      },
      easeOutQuint: function (e, n, i, a) {
        var l = i - n;
        return l * ((e = e / a - 1) * e * e * e * e + 1) + n;
      },
      easeInOutQuint: function (e, n, i, a) {
        var l = i - n;
        return (e /= a / 2) < 1
          ? (l / 2) * e * e * e * e * e + n
          : (l / 2) * ((e -= 2) * e * e * e * e + 2) + n;
      },
      easeInSine: function (e, n, i, a) {
        var l = i - n;
        return -l * Math.cos((e / a) * (Math.PI / 2)) + l + n;
      },
      easeOutSine: function (e, n, i, a) {
        var l = i - n;
        return l * Math.sin((e / a) * (Math.PI / 2)) + n;
      },
      easeInOutSine: function (e, n, i, a) {
        var l = i - n;
        return (-l / 2) * (Math.cos((Math.PI * e) / a) - 1) + n;
      },
      easeInExpo: function (e, n, i, a) {
        var l = i - n;
        return e == 0 ? n : l * Math.pow(2, 10 * (e / a - 1)) + n;
      },
      easeOutExpo: function (e, n, i, a) {
        var l = i - n;
        return e == a ? n + l : l * (-Math.pow(2, (-10 * e) / a) + 1) + n;
      },
      easeInOutExpo: function (e, n, i, a) {
        var l = i - n;
        return e === 0
          ? n
          : e === a
            ? n + l
            : (e /= a / 2) < 1
              ? (l / 2) * Math.pow(2, 10 * (e - 1)) + n
              : (l / 2) * (-Math.pow(2, -10 * --e) + 2) + n;
      },
      easeInCirc: function (e, n, i, a) {
        var l = i - n;
        return -l * (Math.sqrt(1 - (e /= a) * e) - 1) + n;
      },
      easeOutCirc: function (e, n, i, a) {
        var l = i - n;
        return l * Math.sqrt(1 - (e = e / a - 1) * e) + n;
      },
      easeInOutCirc: function (e, n, i, a) {
        var l = i - n;
        return (e /= a / 2) < 1
          ? (-l / 2) * (Math.sqrt(1 - e * e) - 1) + n
          : (l / 2) * (Math.sqrt(1 - (e -= 2) * e) + 1) + n;
      },
      easeInElastic: function (e, n, i, a) {
        var l = i - n,
          u,
          d,
          m;
        return (
          (m = 1.70158),
          (d = 0),
          (u = l),
          e === 0
            ? n
            : (e /= a) === 1
              ? n + l
              : (d || (d = a * 0.3),
                u < Math.abs(l)
                  ? ((u = l), (m = d / 4))
                  : (m = (d / (2 * Math.PI)) * Math.asin(l / u)),
                -(
                  u *
                  Math.pow(2, 10 * (e -= 1)) *
                  Math.sin(((e * a - m) * (2 * Math.PI)) / d)
                ) + n)
        );
      },
      easeOutElastic: function (e, n, i, a) {
        var l = i - n,
          u,
          d,
          m;
        return (
          (m = 1.70158),
          (d = 0),
          (u = l),
          e === 0
            ? n
            : (e /= a) === 1
              ? n + l
              : (d || (d = a * 0.3),
                u < Math.abs(l)
                  ? ((u = l), (m = d / 4))
                  : (m = (d / (2 * Math.PI)) * Math.asin(l / u)),
                u *
                  Math.pow(2, -10 * e) *
                  Math.sin(((e * a - m) * (2 * Math.PI)) / d) +
                  l +
                  n)
        );
      },
      easeInOutElastic: function (e, n, i, a) {
        var l = i - n,
          u,
          d,
          m;
        return (
          (m = 1.70158),
          (d = 0),
          (u = l),
          e === 0
            ? n
            : (e /= a / 2) === 2
              ? n + l
              : (d || (d = a * (0.3 * 1.5)),
                u < Math.abs(l)
                  ? ((u = l), (m = d / 4))
                  : (m = (d / (2 * Math.PI)) * Math.asin(l / u)),
                e < 1
                  ? -0.5 *
                      (u *
                        Math.pow(2, 10 * (e -= 1)) *
                        Math.sin(((e * a - m) * (2 * Math.PI)) / d)) +
                    n
                  : u *
                      Math.pow(2, -10 * (e -= 1)) *
                      Math.sin(((e * a - m) * (2 * Math.PI)) / d) *
                      0.5 +
                    l +
                    n)
        );
      },
      easeInBack: function (e, n, i, a, l) {
        var u = i - n;
        return (
          l === void 0 && (l = 1.70158),
          u * (e /= a) * e * ((l + 1) * e - l) + n
        );
      },
      easeOutBack: function (e, n, i, a, l) {
        var u = i - n;
        return (
          l === void 0 && (l = 1.70158),
          u * ((e = e / a - 1) * e * ((l + 1) * e + l) + 1) + n
        );
      },
      easeInOutBack: function (e, n, i, a, l) {
        var u = i - n;
        return (
          l === void 0 && (l = 1.70158),
          (e /= a / 2) < 1
            ? (u / 2) * (e * e * (((l *= 1.525) + 1) * e - l)) + n
            : (u / 2) * ((e -= 2) * e * (((l *= 1.525) + 1) * e + l) + 2) + n
        );
      },
      easeInBounce: function (e, n, i, a) {
        var l = i - n,
          u;
        return ((u = t.easeOutBounce(a - e, 0, l, a)), l - u + n);
      },
      easeOutBounce: function (e, n, i, a) {
        var l = i - n;
        return (e /= a) < 1 / 2.75
          ? l * (7.5625 * e * e) + n
          : e < 2 / 2.75
            ? l * (7.5625 * (e -= 1.5 / 2.75) * e + 0.75) + n
            : e < 2.5 / 2.75
              ? l * (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375) + n
              : l * (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375) + n;
      },
      easeInOutBounce: function (e, n, i, a) {
        var l = i - n,
          u;
        return e < a / 2
          ? ((u = t.easeInBounce(e * 2, 0, l, a)), u * 0.5 + n)
          : ((u = t.easeOutBounce(e * 2 - a, 0, l, a)), u * 0.5 + l * 0.5 + n);
      },
    };
    return ((a_ = t), a_);
  }
  var C8 = E8();
  function O8(t) {
    return (t * Math.PI) / 180;
  }
  function fr(t, e) {
    return t + Math.random() * (e - t);
  }
  function j8(t, e) {
    return Math.floor(t + Math.random() * (e - t + 1));
  }
  var Eg;
  (function (t) {
    ((t[(t.Circle = 0)] = "Circle"),
      (t[(t.Square = 1)] = "Square"),
      (t[(t.Strip = 2)] = "Strip"));
  })(Eg || (Eg = {}));
  var Sc;
  (function (t) {
    ((t[(t.Positive = 1)] = "Positive"), (t[(t.Negative = -1)] = "Negative"));
  })(Sc || (Sc = {}));
  const M8 = 1e3 / 60;
  class N8 {
    constructor(e, n, i, a) {
      this.getOptions = n;
      const {
        colors: l,
        initialVelocityX: u,
        initialVelocityY: d,
      } = this.getOptions();
      ((this.context = e),
        (this.x = i),
        (this.y = a),
        (this.w = fr(5, 20)),
        (this.h = fr(5, 20)),
        (this.radius = fr(5, 10)),
        (this.vx = typeof u == "number" ? fr(-u, u) : fr(u.min, u.max)),
        (this.vy = typeof d == "number" ? fr(-d, 0) : fr(d.min, d.max)),
        (this.shape = j8(0, 2)),
        (this.angle = O8(fr(0, 360))),
        (this.angularSpin = fr(-0.2, 0.2)),
        (this.color = l[Math.floor(Math.random() * l.length)]),
        (this.rotateY = fr(0, 1)),
        (this.rotationDirection = fr(0, 1) ? Sc.Positive : Sc.Negative));
    }
    update(e) {
      const {
          gravity: n,
          wind: i,
          friction: a,
          opacity: l,
          drawShape: u,
        } = this.getOptions(),
        d = e / M8;
      ((this.x += this.vx * d),
        (this.y += this.vy * d),
        (this.vy += n * d),
        (this.vx += i * d),
        (this.vx *= a ** d),
        (this.vy *= a ** d),
        this.rotateY >= 1 && this.rotationDirection === Sc.Positive
          ? (this.rotationDirection = Sc.Negative)
          : this.rotateY <= -1 &&
            this.rotationDirection === Sc.Negative &&
            (this.rotationDirection = Sc.Positive));
      const m = 0.1 * this.rotationDirection * d;
      if (
        ((this.rotateY += m),
        (this.angle += this.angularSpin),
        this.context.save(),
        this.context.translate(this.x, this.y),
        this.context.rotate(this.angle),
        this.context.scale(1, this.rotateY),
        this.context.rotate(this.angle),
        this.context.beginPath(),
        (this.context.fillStyle = this.color),
        (this.context.strokeStyle = this.color),
        (this.context.globalAlpha = l),
        (this.context.lineCap = "round"),
        (this.context.lineWidth = 2),
        u && typeof u == "function")
      )
        u.call(this, this.context);
      else
        switch (this.shape) {
          case Eg.Circle: {
            (this.context.beginPath(),
              this.context.arc(0, 0, this.radius, 0, 2 * Math.PI),
              this.context.fill());
            break;
          }
          case Eg.Square: {
            this.context.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
            break;
          }
          case Eg.Strip: {
            this.context.fillRect(-this.w / 6, -this.h / 2, this.w / 3, this.h);
            break;
          }
        }
      (this.context.closePath(), this.context.restore());
    }
  }
  class A8 {
    constructor(e, n) {
      ((this.x = 0),
        (this.y = 0),
        (this.w = 0),
        (this.h = 0),
        (this.lastNumberOfPieces = 0),
        (this.tweenProgress = 0),
        (this.tweenFrom = 0),
        (this.particles = []),
        (this.particlesGenerated = 0),
        (this.removeParticleAt = (a) => {
          this.particles.splice(a, 1);
        }),
        (this.getParticle = () => {
          const a = fr(this.x, this.w + this.x),
            l = fr(this.y, this.h + this.y);
          return new N8(this.context, this.getOptions, a, l);
        }),
        (this.animate = (a) => {
          const {
              canvas: l,
              context: u,
              particlesGenerated: d,
              lastNumberOfPieces: m,
            } = this,
            {
              run: g,
              recycle: v,
              numberOfPieces: y,
              debug: w,
              tweenFunction: S,
              tweenDuration: T,
            } = this.getOptions();
          if (!g) return !1;
          const E = this.particles.length,
            j = v ? E : d;
          if (j < y) {
            (m !== y &&
              ((this.tweenProgress = 0),
              (this.tweenFrom = j),
              (this.lastNumberOfPieces = y)),
              (this.tweenProgress = Math.min(
                T,
                Math.max(0, this.tweenProgress + a),
              )));
            const O = S(this.tweenProgress, this.tweenFrom, y, T),
              M = Math.round(O - j);
            for (let N = 0; N < M; N++) this.particles.push(this.getParticle());
            this.particlesGenerated += M;
          }
          w &&
            ((u.font = "12px sans-serif"),
            (u.fillStyle = "#333"),
            (u.textAlign = "right"),
            u.fillText(`Particles: ${E}`, l.width - 10, l.height - 20));
          for (let O = this.particles.length - 1; O >= 0; O--) {
            const M = this.particles[O];
            (M.update(a),
              (M.y > l.height ||
                M.y < -100 ||
                M.x > l.width + 100 ||
                M.x < -100) &&
                (v && j <= y
                  ? (this.particles[O] = this.getParticle())
                  : this.removeParticleAt(O)));
          }
          return E > 0 || j < y;
        }),
        (this.canvas = e));
      const i = this.canvas.getContext("2d");
      if (!i) throw new Error("Could not get canvas context");
      ((this.context = i), (this.getOptions = n));
    }
  }
  const aS = {
    width: typeof window < "u" ? window.innerWidth : 300,
    height: typeof window < "u" ? window.innerHeight : 200,
    numberOfPieces: 200,
    friction: 0.99,
    wind: 0,
    gravity: 0.1,
    initialVelocityX: 4,
    initialVelocityY: 10,
    colors: [
      "#f44336",
      "#e91e63",
      "#9c27b0",
      "#673ab7",
      "#3f51b5",
      "#2196f3",
      "#03a9f4",
      "#00bcd4",
      "#009688",
      "#4CAF50",
      "#8BC34A",
      "#CDDC39",
      "#FFEB3B",
      "#FFC107",
      "#FF9800",
      "#FF5722",
      "#795548",
    ],
    opacity: 1,
    debug: !1,
    tweenFunction: C8.easeInOutQuad,
    tweenDuration: 5e3,
    recycle: !0,
    run: !0,
  };
  class R8 {
    constructor(e, n) {
      ((this.lastFrameTime = 0),
        (this.setOptionsWithDefaults = (a) => {
          const l = {
            confettiSource: { x: 0, y: 0, w: this.canvas.width, h: 0 },
          };
          ((this._options = { ...l, ...aS, ...a }),
            Object.assign(this, a.confettiSource));
        }),
        (this.update = (a = 0) => {
          const {
              options: { run: l, onConfettiComplete: u, frameRate: d },
              canvas: m,
              context: g,
            } = this,
            v = Math.min(a - this.lastFrameTime, 50);
          if (d && v < 1e3 / d) {
            this.rafId = requestAnimationFrame(this.update);
            return;
          }
          ((this.lastFrameTime = a - (d ? v % d : 0)),
            l &&
              ((g.fillStyle = "white"), g.clearRect(0, 0, m.width, m.height)),
            this.generator.animate(v)
              ? (this.rafId = requestAnimationFrame(this.update))
              : (u &&
                  typeof u == "function" &&
                  this.generator.particlesGenerated > 0 &&
                  u.call(this, this),
                (this._options.run = !1)));
        }),
        (this.reset = () => {
          this.generator &&
            this.generator.particlesGenerated > 0 &&
            ((this.generator.particlesGenerated = 0),
            (this.generator.particles = []),
            (this.generator.lastNumberOfPieces = 0));
        }),
        (this.stop = () => {
          ((this.options = { run: !1 }),
            this.rafId &&
              (cancelAnimationFrame(this.rafId), (this.rafId = void 0)));
        }),
        (this.canvas = e));
      const i = this.canvas.getContext("2d");
      if (!i) throw new Error("Could not get canvas context");
      ((this.context = i),
        (this.generator = new A8(this.canvas, () => this.options)),
        (this.options = n),
        this.update());
    }
    get options() {
      return this._options;
    }
    set options(e) {
      var a, l;
      const n = (a = this._options) == null ? void 0 : a.run,
        i = (l = this._options) == null ? void 0 : l.recycle;
      (this.setOptionsWithDefaults(e),
        this.generator &&
          (Object.assign(this.generator, this.options.confettiSource),
          typeof e.recycle == "boolean" &&
            e.recycle &&
            i === !1 &&
            (this.generator.lastNumberOfPieces =
              this.generator.particles.length)),
        typeof e.run == "boolean" && e.run && n === !1 && this.update());
    }
  }
  const L8 = U.createRef();
  class lS extends U.Component {
    constructor(e) {
      (super(e),
        (this.canvas = U.createRef()),
        (this.canvas = e.canvasRef || L8));
    }
    componentDidMount() {
      if (this.canvas.current) {
        const e = l_(this.props)[0];
        this.confetti = new R8(this.canvas.current, e);
      }
    }
    componentDidUpdate() {
      const e = l_(this.props)[0];
      this.confetti && (this.confetti.options = e);
    }
    componentWillUnmount() {
      (this.confetti && this.confetti.stop(), (this.confetti = void 0));
    }
    render() {
      const [e, n] = l_(this.props),
        i = {
          zIndex: 2,
          position: "absolute",
          pointerEvents: "none",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          ...n.style,
        };
      return h.jsx("canvas", {
        width: e.width,
        height: e.height,
        ref: this.canvas,
        ...n,
        style: i,
      });
    }
  }
  lS.defaultProps = { ...aS };
  lS.displayName = "ReactConfetti";
  function l_(t) {
    const e = {},
      n = {},
      i = {},
      a = [
        ...Object.keys(aS),
        "confettiSource",
        "drawShape",
        "onConfettiComplete",
        "frameRate",
      ],
      l = ["canvasRef"];
    for (const u in t) {
      const d = t[u];
      a.includes(u) ? (e[u] = d) : l.includes(u) ? (l[u] = d) : (i[u] = d);
    }
    return [e, i, n];
  }
  const D8 = U.forwardRef((t, e) => h.jsx(lS, { canvasRef: e, ...t })),
    k8 = () => {
      const [t, e] = W.useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      return (
        W.useEffect(() => {
          const n = () => {
            e({ width: window.innerWidth, height: window.innerHeight });
          };
          return (
            window.addEventListener("resize", n),
            () => window.removeEventListener("resize", n)
          );
        }, []),
        t
      );
    },
    z8 = () => {
      const { t, loading: e } = Ot(),
        { width: n, height: i } = k8();
      return e
        ? h.jsx(ze, {})
        : h.jsxs("div", {
            className: "subscribtion-success-page",
            children: [
              h.jsx("title", { children: t("tebrikler_ugurla_odenis_edildi") }),
              h.jsx(D8, {
                width: n,
                height: i,
                numberOfPieces: 1e3,
                recycle: !1,
                style: { position: "fixed", top: 0, left: 0, zIndex: 9999999 },
              }),
              h.jsx("img", {
                src: "/Sucsesselement.svg",
                alt: "Sucsesselement",
              }),
              h.jsxs("div", {
                className: "texts",
                children: [
                  h.jsxs("div", {
                    className: "top-texts",
                    children: [
                      h.jsx("h1", { children: t("ugurla_odenis_edildi") }),
                      h.jsx("p", {
                        children: t("abunelikler_haqqinda_melumat_title"),
                      }),
                    ],
                  }),
                  h.jsxs("div", {
                    className: "buttons",
                    children: [
                      h.jsx(Ct, {
                        title: t("abuneliklerim"),
                        class_name: "get-sub",
                        href: "/kabinet/abunelikler",
                      }),
                      h.jsx(Ct, {
                        title: "Ana səhifəyə qayıt",
                        icon: "/sss.svg",
                        class_name: "get-back-home",
                        href: "/",
                      }),
                    ],
                  }),
                ],
              }),
            ],
          });
    },
    P8 = () =>
      h.jsxs("div", {
        className: "subscribtion-error-page",
        children: [
          h.jsx("title", { children: "Xəta baş verdi!" }),
          h.jsx("img", { src: "/sssss.svg", alt: "Error order" }),
          h.jsxs("div", {
            className: "texts",
            children: [
              h.jsxs("div", {
                className: "top-texts",
                children: [
                  h.jsx("h1", { children: "Upps, xəta baş verdi!" }),
                  h.jsx("p", {
                    children:
                      "Təəssüf ki, ödəniş edərkən xəta baş verdi, zəhmət olmasa yenidən cəhd edin.",
                  }),
                ],
              }),
              h.jsxs("div", {
                className: "buttons",
                children: [
                  h.jsx(Ct, {
                    title: "Yenidən cəhd et",
                    class_name: "get-sub",
                    href: "/imtahanlar",
                  }),
                  h.jsx(Ct, {
                    title: "Ana səhifəyə qayıt",
                    icon: "/sss.svg",
                    class_name: "get-back-home",
                    href: "/",
                  }),
                ],
              }),
            ],
          }),
        ],
      }),
    I8 = () => {
      const { base: t } = si(),
        e = sn(),
        { showError: n, showServerErrorMsg: i, showServerSuccessMsg: a } = wa(),
        [l] = XE(),
        u = l.get("email"),
        d = l.get("token"),
        [m, g] = U.useState(""),
        [v, y] = U.useState(""),
        [w, S] = U.useState(!1),
        T = async () => {
          var E, j, O, M, N;
          S(!0);
          try {
            const R = new FormData();
            (R.append("password", m),
              R.append("password_confirmation", v),
              R.append("token", d || ""),
              R.append("email", u || ""));
            const P = await Xe.post(`${t}reset-password`, R, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            P.data
              ? (e("/daxil-ol"),
                a(((E = P.data) == null ? void 0 : E.message) || ""))
              : console.log(P.status);
          } catch (R) {
            Xe.isAxiosError(R) &&
            (O =
              (j = R == null ? void 0 : R.response) == null
                ? void 0
                : j.data) != null &&
            O.message
              ? i(
                  (N =
                    (M = R == null ? void 0 : R.response) == null
                      ? void 0
                      : M.data) == null
                    ? void 0
                    : N.message,
                )
              : (n(), console.log(R));
          } finally {
            S(!1);
          }
        };
      return h.jsxs("div", {
        className: "login",
        children: [
          h.jsx("title", {
            children: "Təhsil / Şifrənin bərpa edilməsi prosesi",
          }),
          h.jsxs("form", {
            onSubmit: (E) => {
              (E.preventDefault(), T());
            },
            acceptCharset: "UTF-8",
            className: "left",
            children: [
              h.jsx("div", {
                className: "button-get-back",
                children: h.jsx(_t, {
                  to: "/",
                  className: "btn",
                  children: h.jsx("img", {
                    src: "/ArrowLeft.svg",
                    alt: "arrow-left",
                  }),
                }),
              }),
              h.jsxs("div", {
                className: "form-container",
                children: [
                  h.jsxs("div", {
                    className: "title-content",
                    children: [
                      h.jsx("h1", { children: "Şifrənin bərpası" }),
                      h.jsx("p", { children: "Şifrənizi yeniləyin" }),
                    ],
                  }),
                  h.jsx("div", {
                    className: "content",
                    children: h.jsxs("div", {
                      className: "input-container",
                      children: [
                        h.jsx("div", {
                          className: "input-field",
                          children: h.jsx("input", {
                            type: "password",
                            placeholder: "Yeni şifrə",
                            name: "password",
                            value: m,
                            required: !0,
                            onChange: (E) => g(E.target.value),
                          }),
                        }),
                        h.jsx("div", {
                          className: "input-field",
                          children: h.jsx("input", {
                            type: "password",
                            placeholder: "Yeni şifrə təkrarı",
                            name: "password_confirmation",
                            value: v,
                            required: !0,
                            onChange: (E) => y(E.target.value),
                          }),
                        }),
                        w
                          ? h.jsx(ze, {
                              style: { height: "30px" },
                              styleLoader: { height: "30px" },
                            })
                          : h.jsx(Ct, {
                              buttonType: "submit",
                              title: "Yenilə",
                              disabled: w,
                              isButton: !0,
                              style: { width: "100%" },
                            }),
                      ],
                    }),
                  }),
                ],
              }),
            ],
          }),
          h.jsx("div", { className: "right" }),
        ],
      });
    },
    gn = (t, e) =>
      h.jsxs(h.Fragment, {
        children: [h.jsx(NA, { currentPage: t }), h.jsx(e, {})],
      }),
    U8 = [
      { id: 1, route: "/", title: "Home", component: h.jsx(x8, {}) },
      {
        id: 2,
        route: "/derslikler-ve-test-banklari",
        title: "Dərsliklər və test bankları",
        component: gn("Dərsliklər və test bankları", l3),
      },
      {
        id: 3,
        route: "/derslikler-ve-test-banklari/:lang/:slug",
        title: "Dərsliklər və test bankları",
        component: gn("Dərsliklər və test bankları", o5),
      },
      {
        id: 4,
        route: "/haqqimda-ve-bioqrafiya",
        title: "Haqqımda və bioqrafiya",
        component: gn("Haqqımda və bioqrafiya", g5),
      },
      {
        id: 5,
        route: "/imtahanlar",
        title: "İmtahanlar",
        component: gn("İmtahanlar", x5),
      },
      {
        id: 6,
        route: "/imtahanlar/:lang/:slug",
        title: "İmtahanlar Daxili",
        component: gn("İmtahan adı", T5),
      },
      {
        id: 7,
        route: "/imtahanlar/kateqoriyalar/:lang/:slug",
        title: "İmtahan Kateqoriya Daxili",
        component: gn("İmtahan kateqoriya adı", $5),
      },
      {
        id: 8,
        route: "/imtahanlar/kateqoriyalar/:lang/:slug/teste-basla/:testSlug",
        title: "Testə Başla",
        component: gn("Test imtahanı", K5),
      },
      {
        id: 9,
        route:
          "/imtahanlar/kateqoriyalar/:lang/:slug/teste-basla/:testSlug/suallar",
        title: "Suallar",
        component: gn("Suallar", s4),
      },
      {
        id: 10,
        route:
          "/imtahanlar/kateqoriyalar/:lang/:slug/teste-basla/:testSlug/suallar/neticeler",
        title: "Nəticələr",
        component: gn("İmtahan nəticələri", r4),
      },
      {
        id: 11,
        route:
          "/imtahanlar/kateqoriyalar/:lang/:slug/teste-basla/:testSlug/suallar/neticeler/suallara-bax",
        title: "Suallara bax",
        component: gn("Suallara bax", o4),
      },
      {
        id: 12,
        route: "/qalereya",
        title: "Qalereya",
        component: gn("Qalereya", v4),
      },
      {
        id: 12,
        route: "/qalereya/sekiller/:lang/:slug",
        title: "Qalereya",
        component: gn("Qalereya / Şəkillər", R4),
      },
      {
        id: 13,
        route: "/qalereya/videolar/:lang/:slug",
        title: "Qalereya",
        component: gn("Qalereya / Videolar", L4),
      },
      {
        id: 14,
        route: "/elanlar",
        title: "Elanlar",
        component: gn("Elanlar", k4),
      },
      {
        id: 15,
        route: "/elanlar/:lang/:slug",
        title: "Elanlar",
        component: gn("Elanlar", F4),
      },
      {
        id: 16,
        route: "/xeberler",
        title: "Xəbərlər və yeniliklər",
        component: gn("Xəbərlər və yeniliklər", H4),
      },
      {
        id: 17,
        route: "/xeberler/:lang/:slug",
        title: "Xəbərlər və yeniliklər",
        component: gn("Xəbərlər və yeniliklər", G4),
      },
      {
        id: 18,
        route: "/xidmetler",
        title: "Xidmətlər",
        component: gn("Xidmətlər", X4),
      },
      {
        id: 19,
        route: "/xidmetler/:lang/:slug",
        title: "Xidmətlər daxili",
        component: gn("Xidmətlər", Q4),
      },
      {
        id: 20,
        route: "/kabinet/*",
        title: "Kabinet",
        component: h.jsx(_8, { children: gn("Kabinet", c8) }),
      },
      {
        id: 21,
        route: "/qaydalar-ve-sertler",
        title: "Qaydalar və şərtlər",
        component: gn("Qaydalar və şərtlər", u8),
      },
      {
        id: 22,
        route: "/imtahanlar/:lang/abunelik-paketleri",
        title: "Paketlər",
        component: gn("Paketlər", T8),
      },
      {
        id: 23,
        route: "/successfully-order",
        title: "Ödəniş uğurludur!",
        component: gn("Ödəniş uğurludur!", z8),
      },
      {
        id: 24,
        route: "/cancel-order",
        title: "Ödəniş uğursuzdur!",
        component: gn("Ödəniş uğursuzdur!", P8),
      },
      {
        id: 25,
        route: "/password-reset",
        title: "Şifrəni yenilə",
        component: gn("Şifrəni yenilə", I8),
      },
    ],
    F8 = { toggle: !1 },
    XO = nv({
      name: "headerToggle",
      initialState: F8,
      reducers: {
        setToggle: (t) => {
          t.toggle = !t.toggle;
        },
        setFalse: (t) => {
          t.toggle = !1;
        },
      },
    }),
    { setToggle: QO, setFalse: o_ } = XO.actions,
    B8 = XO.reducer,
    H8 = ({ buttonRef: t }) => {
      const e = _a(),
        n = nt((i) => i.headerToggle.toggle);
      return h.jsxs("div", {
        ref: t,
        className: "menu-button",
        onClick: () => e(QO()),
        children: [
          h.jsx("div", {
            className: `menu-icon-custom ${n ? "active" : ""}`,
            children: h.jsxs("div", {
              className: "wrap",
              children: [
                h.jsx("span", { className: "line" }),
                h.jsx("span", { className: "line" }),
                h.jsx("span", { className: "line" }),
              ],
            }),
          }),
          h.jsx("p", {
            className: "menu-title",
            style: { color: n ? "#407df2" : "" },
            children: "Menu",
          }),
        ],
      });
    },
    Y8 = () => {
      var n;
      const { cachedData: t } = Et("social-links", "social_links_key"),
        e =
          t &&
          t != null &&
          t.data &&
          ((n = t == null ? void 0 : t.data) == null ? void 0 : n.length) > 0
            ? t == null
              ? void 0
              : t.data
            : [];
      return h.jsx("div", {
        className: "social-header",
        children:
          e == null
            ? void 0
            : e.map((i) =>
                h.jsx(
                  _t,
                  {
                    target: "_blank",
                    className: "icon-social",
                    to: (i == null ? void 0 : i.url) || "",
                    children: h.jsx("img", {
                      src: i == null ? void 0 : i.icon,
                      alt: i == null ? void 0 : i.title,
                      title: i == null ? void 0 : i.title,
                    }),
                  },
                  i == null ? void 0 : i.id,
                ),
              ),
      });
    },
    q8 = ({ buttonRef: t }) =>
      h.jsxs("section", {
        className: "left-section",
        children: [h.jsx(H8, { buttonRef: t }), h.jsx(Y8, {})],
      }),
    oS = () => {
      const { innerData: t, dataLoading: e } = Et(
        "site-settings",
        "site_settings",
      );
      return { SiteSettingsData: t, SiteSettingsLoading: e };
    },
    $8 = () => {
      var i;
      const { SiteSettingsData: t } = oS(),
        e =
          t != null &&
          t.data &&
          ((i = Object.keys(t == null ? void 0 : t.data)) == null
            ? void 0
            : i.length) > 0
            ? t == null
              ? void 0
              : t.data
            : "",
        n =
          e && e != null && e.header_logo
            ? e == null
              ? void 0
              : e.header_logo
            : "/logo.svg";
      return h.jsx(_t, {
        to: "",
        className: "logo-wrapper",
        children: h.jsx("img", { src: n, alt: "Logo" }),
      });
    },
    cS = () => {
      var m, g, v, y, w, S, T, E, j, O, M, N;
      const { SiteSettingsData: t } = oS(),
        { t: e } = Ot(),
        n =
          (m = t == null ? void 0 : t.data) != null &&
          m.header_site_icon1 &&
          ((v =
            (g = t == null ? void 0 : t.data) == null
              ? void 0
              : g.header_site_icon1) == null
            ? void 0
            : v.length) > 0
            ? (y = t == null ? void 0 : t.data) == null
              ? void 0
              : y.header_site_icon1
            : "/v.svg",
        i =
          (w = t == null ? void 0 : t.data) != null &&
          w.header_site_icon2 &&
          ((T =
            (S = t == null ? void 0 : t.data) == null
              ? void 0
              : S.header_site_icon2) == null
            ? void 0
            : T.length) > 0
            ? (E = t == null ? void 0 : t.data) == null
              ? void 0
              : E.header_site_icon2
            : "/gerb.svg",
        a =
          (j = t == null ? void 0 : t.data) != null &&
          j.header_site_icon3 &&
          ((M =
            (O = t == null ? void 0 : t.data) == null
              ? void 0
              : O.header_site_icon3) == null
            ? void 0
            : M.length) > 0
            ? (N = t == null ? void 0 : t.data) == null
              ? void 0
              : N.header_site_icon3
            : "/Azerbaijanflag.svg";
      return {
        Navbar: {
          id: 111,
          categories: [
            {
              id: 1,
              categoryIcon: "/c1.svg",
              categoryName: "Ümumi təhsil üzrə  işə qəbul",
              innerCategory: [
                { id: 1, title: "Lorem ipsum", to: "" },
                { id: 2, title: "Lorem ipsum", to: "" },
                { id: 3, title: "Lorem ipsum", to: "" },
              ],
            },
            {
              id: 2,
              categoryIcon: "/c2.svg",
              categoryName: "Məktəbəqədər təhsil üzrə işə qəbul",
              innerCategory: [
                { id: 1, title: "Lorem ipsum", to: "" },
                { id: 2, title: "Lorem ipsum", to: "" },
                { id: 3, title: "Lorem ipsum", to: "" },
              ],
            },
            {
              id: 3,
              categoryIcon: "/c3.svg",
              categoryName: "Peşə təhsili üzrə işə qəbul",
              innerCategory: [
                { id: 1, title: "Lorem ipsum", to: "" },
                { id: 2, title: "Lorem ipsum", to: "" },
                { id: 3, title: "Lorem ipsum", to: "" },
              ],
            },
            {
              id: 4,
              categoryIcon: "/c4.svg",
              categoryName: "Musiqi məktəb üzrə işə qəbul",
              innerCategory: [
                { id: 1, title: "Lorem ipsum", to: "" },
                { id: 2, title: "Lorem ipsum", to: "" },
                { id: 3, title: "Lorem ipsum", to: "" },
              ],
            },
            {
              id: 5,
              categoryIcon: "/c5.svg",
              categoryName: "Kurikulum",
              innerCategory: [
                { id: 1, title: "Lorem ipsum", to: "" },
                { id: 2, title: "Lorem ipsum", to: "" },
                { id: 3, title: "Lorem ipsum", to: "" },
              ],
            },
          ],
          menu: [
            {
              id: 1,
              title: e("haqqimda_bioqrafiya"),
              to: "/haqqimda-ve-bioqrafiya",
            },
            { id: 2, title: e("imtahanlar"), to: "/imtahanlar" },
            {
              id: 3,
              title: e("derslikler"),
              to: "/derslikler-ve-test-banklari",
            },
            { id: 5, title: e("xeberler"), to: "/xeberler" },
            { id: 6, title: e("xidmetler"), to: "/xidmetler" },
            { id: 7, title: e("elanlar"), to: "/elanlar" },
            { id: 8, title: e("qalereya"), to: "/qalereya" },
            {
              id: 9,
              title: e("qaydalar_ve_sertler"),
              to: "/qaydalar-ve-sertler",
            },
          ],
        },
        NavbarSocial: [
          { id: 1, icon: "/face.svg", link: "", title: "Facebook" },
          { id: 2, icon: "/wp.svg", link: "", title: "WhatsApp" },
          { id: 3, icon: "/yt.svg", link: "", title: "YouTube" },
          { id: 4, icon: "/x.svg", link: "", title: "X" },
          { id: 5, icon: "/tg.svg", link: "", title: "Telegram" },
          { id: 6, icon: "/insta.svg", link: "", title: "Instagram" },
        ],
        NavbarFlags: [
          { id: 1, flag: n, title: "Veteran" },
          { id: 2, flag: i, title: "Azərbaycan Milli Gerbi" },
          { id: 3, flag: a, title: "Azərbaycan Milli Bayrağı" },
        ],
      };
    },
    G8 = { selectedLanguage: localStorage.getItem("language") || "az" },
    ZO = nv({
      name: "selectedLanguage",
      initialState: G8,
      reducers: {
        setSelectedLanguage: (t, e) => {
          ((t.selectedLanguage = e.payload),
            localStorage.setItem("language", e.payload));
        },
      },
    }),
    { setSelectedLanguage: V8 } = ZO.actions,
    W8 = ZO.reducer,
    X8 = () => {
      const { t } = Ot(),
        { isAuth: e, user: n } = Sa(),
        { NavbarFlags: i } = cS(),
        a = _a(),
        l = nt((u) => u.selectedLanguage.selectedLanguage);
      return (
        U.useEffect(() => {
          const u = localStorage.getItem("language");
          u && u !== l && a(V8(u));
        }, [a]),
        h.jsxs("section", {
          className: "right-section",
          children: [
            h.jsx("div", {
              className: "flags-contain",
              children:
                i == null
                  ? void 0
                  : i.map((u) =>
                      h.jsx(
                        "div",
                        {
                          className: "flag-container",
                          children: h.jsx(
                            "img",
                            {
                              src: u == null ? void 0 : u.flag,
                              alt: u == null ? void 0 : u.title,
                            },
                            u == null ? void 0 : u.id,
                          ),
                        },
                        u == null ? void 0 : u.id,
                      ),
                    ),
            }),
            h.jsxs(_t, {
              to: "/kabinet/melumatlarim",
              className: "profile-button",
              children: [
                h.jsx("div", {
                  className: "profile-icon",
                  children: h.jsx("img", {
                    style: { transform: "scale(0.8)" },
                    src: "/profile.svg",
                    alt: "",
                  }),
                }),
                h.jsx("h3", {
                  children: e
                    ? n == null
                      ? void 0
                      : n.name
                    : t("sexsi_kabinet"),
                }),
              ],
            }),
          ],
        })
      );
    },
    Q8 = () => {
      const [t, e] = U.useState(!1);
      return (
        U.useEffect(() => {
          const n = () => {
            e(window.innerWidth <= 968);
          };
          return (
            n(),
            window.addEventListener("resize", n),
            () => window.removeEventListener("resize", n)
          );
        }, []),
        { mobile: t }
      );
    },
    Z8 = () => {
      var X, fe, ve;
      const t = nt((be) => be.selectedLanguage.selectedLanguage) || "az",
        { isAuth: e, user: n } = Sa(),
        { t: i } = Ot(),
        a = ys(),
        { SiteSettingsLoading: l, SiteSettingsData: u } = oS(),
        d = a.pathname === "/qeydiyyat/otp-verification",
        m = a.pathname === "/sifremi-unuttum",
        g = a.pathname === "/custom-password-reset",
        { innerData: v, dataLoading: y } = Et(
          "home-categories",
          "home_categories_key",
        ),
        w = v && (v == null ? void 0 : v.length) > 0 ? v : [],
        S = _a(),
        T = nt((be) => be.headerToggle.toggle),
        { Navbar: E } = cS(),
        j = U.useRef(null),
        O = U.useRef(null),
        M = (be) => {
          j.current &&
            !j.current.contains(be.target) &&
            O.current &&
            !O.current.contains(be.target) &&
            S(o_());
        };
      U.useEffect(
        () => (
          document.addEventListener("mousedown", M),
          () => document.removeEventListener("mousedown", M)
        ),
        [],
      );
      const { mobile: N } = Q8(),
        [R, P] = U.useState(!1),
        G = U.useRef(null),
        Y = (be) => {
          var Oe;
          G.current &&
            !((Oe = G.current) != null && Oe.contains(be.target)) &&
            P(!1);
        };
      U.useEffect(
        () => (
          document.addEventListener("mousedown", Y),
          () => document.removeEventListener("mousedown", Y)
        ),
        [],
      );
      const B = a.pathname !== "/daxil-ol" && a.pathname !== "/qeydiyyat",
        I = (be) => {
          let Oe = document.querySelector("link[rel*='icon']");
          (Oe ||
            ((Oe = document.createElement("link")),
            (Oe.rel = "icon"),
            document.head.appendChild(Oe)),
            (Oe.href = be));
        },
        H =
          u != null &&
          u.data &&
          (X = u == null ? void 0 : u.data) != null &&
          X.favicon
            ? (fe = u == null ? void 0 : u.data) == null
              ? void 0
              : fe.favicon
            : "/logo.svg";
      return (
        U.useEffect(() => {
          I(H);
        }, [H]),
        h.jsx("header", {
          className: "header-wrapper",
          style: { display: B ? (d || m || g ? "none" : "flex") : "none" },
          children: l
            ? h.jsx(ze, { style: { minHeight: "60px" } })
            : h.jsxs("div", {
                className: "header",
                children: [
                  h.jsx(q8, { buttonRef: O }),
                  h.jsx($8, {}),
                  h.jsx("div", {
                    ref: G,
                    className: `search-wrapper ${R ? "active" : ""}`,
                    style: { transform: N ? "translateY(50px)" : "" },
                    children: h.jsx("input", {
                      type: "text",
                      placeholder: "Axtarışe et",
                    }),
                  }),
                  h.jsx(X8, {}),
                  h.jsx("div", {
                    className: `toggle-menu ${T ? "active" : ""}`,
                    style: { transform: N ? "translateY(50px)" : "" },
                    children: h.jsxs("div", {
                      ref: j,
                      className: `menu ${T ? "active" : ""}`,
                      children: [
                        h.jsx("div", {
                          className: "our-cabinet",
                          children: h.jsxs(_t, {
                            to: "/kabinet/melumatlarim",
                            className: "profile-button",
                            onClick: () => S(QO()),
                            children: [
                              h.jsx("div", {
                                className: "profile-icon",
                                children: h.jsx("img", {
                                  style: { transform: "scale(0.8)" },
                                  src: "/profile.svg",
                                  alt: "",
                                }),
                              }),
                              h.jsx("h3", {
                                children: e
                                  ? n == null
                                    ? void 0
                                    : n.name
                                  : i("sexsi_kabinet"),
                              }),
                            ],
                          }),
                        }),
                        y
                          ? h.jsx(ze, {})
                          : h.jsxs("div", {
                              className: "categories",
                              children: [
                                h.jsx("p", { children: i("kateqoriyalar") }),
                                h.jsx("div", {
                                  className: "category-items",
                                  children:
                                    w == null
                                      ? void 0
                                      : w.map((be) =>
                                          h.jsxs(
                                            _t,
                                            {
                                              to: `/imtahanlar/${t}/${be.slug[t]}`,
                                              onClick: () => S(o_()),
                                              className: "category-item",
                                              children: [
                                                h.jsxs("div", {
                                                  className: "left",
                                                  children: [
                                                    h.jsx("div", {
                                                      className: "icon-wrapper",
                                                      children: h.jsx("img", {
                                                        src:
                                                          be == null
                                                            ? void 0
                                                            : be.icon,
                                                        alt:
                                                          be == null
                                                            ? void 0
                                                            : be.title,
                                                      }),
                                                    }),
                                                    h.jsx("h2", {
                                                      children:
                                                        be == null
                                                          ? void 0
                                                          : be.title,
                                                    }),
                                                  ],
                                                }),
                                                h.jsx(d_, {
                                                  className: "right",
                                                }),
                                              ],
                                            },
                                            be == null ? void 0 : be.id,
                                          ),
                                        ),
                                }),
                              ],
                            }),
                        h.jsxs("div", {
                          className: "others",
                          children: [
                            h.jsx("p", { children: "Vacib keçidlər" }),
                            h.jsx("div", {
                              className: "menu-items",
                              children:
                                (ve = E == null ? void 0 : E.menu) == null
                                  ? void 0
                                  : ve.map((be) =>
                                      h.jsxs(
                                        _t,
                                        {
                                          onClick: () => S(o_()),
                                          to:
                                            (be == null ? void 0 : be.to) || "",
                                          className: "menu-item",
                                          children: [
                                            h.jsx("div", {
                                              className: "left",
                                              children: h.jsx("h2", {
                                                children:
                                                  be == null
                                                    ? void 0
                                                    : be.title,
                                              }),
                                            }),
                                            h.jsx(d_, { className: "right" }),
                                          ],
                                        },
                                        be == null ? void 0 : be.id,
                                      ),
                                    ),
                            }),
                          ],
                        }),
                      ],
                    }),
                  }),
                ],
              }),
        })
      );
    },
    K8 = GL({
      reducer: {
        headerToggle: B8,
        selectedLanguage: W8,
        wpNumberState: r3,
        videoState: N5,
        startTestModalState: X5,
      },
    }),
    J8 = () => {
      var l, u;
      const { innerData: t } = Et("social-links", "social_links_key"),
        e =
          t &&
          t != null &&
          t.data &&
          ((l = t == null ? void 0 : t.data) == null ? void 0 : l.length) > 0
            ? t == null
              ? void 0
              : t.data
            : [],
        n = ys(),
        { Navbar: i } = cS(),
        a = n.pathname !== "/daxil-ol" && n.pathname !== "/qeydiyyat";
      return h.jsx("footer", {
        className: "footer-wrapper",
        style: { display: a ? "flex" : "none" },
        children: h.jsxs("div", {
          className: "footer",
          children: [
            h.jsxs("div", {
              className: "top-links",
              children: [
                h.jsx("div", {
                  className: "links",
                  children:
                    (u = i == null ? void 0 : i.menu) == null
                      ? void 0
                      : u.map((d) =>
                          h.jsx(
                            _t,
                            {
                              to: (d == null ? void 0 : d.to) || "",
                              className: "link",
                              children: d == null ? void 0 : d.title,
                            },
                            d == null ? void 0 : d.id,
                          ),
                        ),
                }),
                h.jsx("div", {
                  className: "socials",
                  children:
                    e == null
                      ? void 0
                      : e.map((d) =>
                          h.jsx(
                            _t,
                            {
                              target: "_blank",
                              to: (d == null ? void 0 : d.url) || "",
                              className: "social-item",
                              children: h.jsx("img", {
                                src: d == null ? void 0 : d.icon,
                                alt: d == null ? void 0 : d.title,
                                title: d == null ? void 0 : d.title,
                              }),
                            },
                            d == null ? void 0 : d.id,
                          ),
                        ),
                }),
              ],
            }),
            h.jsxs("div", {
              className: "footer-bottom",
              children: [
                h.jsxs("div", {
                  className: "footer-bottom-item",
                  children: [
                    h.jsx("p", { children: "Hüquqi ad:" }),
                    h.jsx("span", { children: "Rifah tədris mərkəzi" }),
                  ],
                }),
                h.jsxs("div", {
                  className: "footer-bottom-item",
                  children: [
                    h.jsx("p", { children: "Hüquqi ünvan:" }),
                    h.jsx("span", {
                      children:
                        "Bakı şəhəri Xəzər rayonu Rizvan Məmmədhüseynov ev 24",
                    }),
                  ],
                }),
                h.jsxs("div", {
                  className: "footer-bottom-item",
                  children: [
                    h.jsx("p", { children: "Vöen:" }),
                    h.jsx("span", { children: "1807002112" }),
                  ],
                }),
              ],
            }),
            h.jsx("div", {
              className: "bottom",
              children: h.jsxs("div", {
                className: "title",
                children: [
                  h.jsx("p", { children: "Site by 166 Tech" }),
                  h.jsx("img", {
                    onClick: () => window.open("https://166tech.az/", "_blank"),
                    src: "/166tech.svg",
                    alt: "166Tech",
                    title: "166Tech",
                  }),
                ],
              }),
            }),
          ],
        }),
      });
    };
  function eI(t) {
    return Fi({
      attr: { viewBox: "0 0 24 24" },
      child: [
        { tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] },
        {
          tag: "path",
          attr: {
            d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
          },
          child: [],
        },
      ],
    })(t);
  }
  const tI = () => {
      const {
          showServerErrorMsg: t,
          showError: e,
          showServerSuccessMsg: n,
        } = wa(),
        [i, a] = U.useState(!1);
      return {
        handleSubmit: async (u) => {
          var d, m, g, v, y;
          a(!0);
          try {
            const w = new FormData();
            (w.append("rating", u.rating), w.append("note", u.note));
            const S = await Xe.post(`${Ii}website-likes`, w, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            S.data
              ? (n((d = S.data) == null ? void 0 : d.message),
                (u.rating = ""),
                (u.note = ""))
              : e();
          } catch (w) {
            Xe.isAxiosError(w) &&
            (g = (m = w.response) == null ? void 0 : m.data) != null &&
            g.message
              ? t(
                  (y = (v = w.response) == null ? void 0 : v.data) == null
                    ? void 0
                    : y.message,
                )
              : (e(), console.log(w));
          } finally {
            a(!1);
          }
        },
        loadingForm: i,
      };
    },
    nI = [
      { id: 1, icon: "/starempty.svg", iconFill: "/starfill.svg", rate: 1 },
      { id: 2, icon: "/starempty.svg", iconFill: "/starfill.svg", rate: 2 },
      { id: 3, icon: "/starempty.svg", iconFill: "/starfill.svg", rate: 3 },
      { id: 4, icon: "/starempty.svg", iconFill: "/starfill.svg", rate: 4 },
      { id: 5, icon: "/starempty.svg", iconFill: "/starfill.svg", rate: 5 },
    ],
    iI = () => {
      const { t } = Ot(),
        { handleSubmit: e, loadingForm: n } = tI(),
        [i, a] = U.useState(!1),
        [l, u] = U.useState(null),
        [d, m] = U.useState(null);
      U.useEffect(() => {
        if (!sessionStorage.getItem("delayed")) {
          const S = setTimeout(() => {
            (a(!0), sessionStorage.setItem("delayed", "true"));
          }, 5e4);
          return () => clearTimeout(S);
        }
      }, []);
      const g = (w) => {
          u(w);
        },
        [v, y] = U.useState({ note: "", rating: "" });
      return h.jsxs("section", {
        className: `delayed-modal ${i ? "active" : ""}`,
        children: [
          h.jsx("div", {
            className: "close-area",
            children: h.jsx(eI, {
              className: "close-icon-mini",
              onClick: () => a(!1),
            }),
          }),
          h.jsxs("form", {
            acceptCharset: "UTF-8",
            className: "content-modal",
            onSubmit: (w) => {
              (w.preventDefault(),
                e(v),
                setTimeout(() => {
                  a(!1);
                }, 3e3));
            },
            children: [
              h.jsxs("div", {
                className: "top-title-modal",
                children: [
                  h.jsx("h2", { children: t("sayti_beyenirsiniz") }),
                  h.jsx("p", { children: t("sayti_beyenirsiniz_text") }),
                ],
              }),
              h.jsx("div", {
                className: "rate",
                children: nI.map((w) =>
                  h.jsx(
                    "div",
                    {
                      className: "star-icon",
                      onMouseEnter: () => m(w.id),
                      onMouseLeave: () => m(null),
                      style: { cursor: "pointer" },
                      onClick: () => {
                        (g(w.id), y((S) => ({ ...S, rating: String(w.id) })));
                      },
                      children: h.jsx("img", {
                        src:
                          w.id <= Math.max(d ?? 0, l ?? 0)
                            ? w.iconFill
                            : w.icon,
                        alt: "star",
                      }),
                    },
                    w.id,
                  ),
                ),
              }),
              h.jsx("textarea", {
                name: "note",
                placeholder: t("qeyd"),
                value: v.note,
                onChange: (w) => y((S) => ({ ...S, note: w.target.value })),
              }),
              h.jsx("button", {
                type: "submit",
                className: "submit-btn",
                children: t(
                  n ? "sorgunuz_gonderilir" : "gonder_button_basligi",
                ),
              }),
            ],
          }),
        ],
      });
    };
  function jb(t) {
    return Fi({
      attr: { viewBox: "0 0 24 24", fill: "currentColor" },
      child: [
        {
          tag: "path",
          attr: {
            d: "M10.1305 15.8421L9.34268 18.7821L7.41083 18.2645L8.1983 15.3256C7.00919 14.8876 5.91661 14.2501 4.96116 13.4536L2.80783 15.6069L1.39362 14.1927L3.54695 12.0394C2.35581 10.6105 1.52014 8.8749 1.17578 6.96843L2.07634 6.80469C4.86882 8.81573 8.29618 10.0003 12.0002 10.0003C15.7043 10.0003 19.1316 8.81573 21.9241 6.80469L22.8247 6.96843C22.4803 8.8749 21.6446 10.6105 20.4535 12.0394L22.6068 14.1927L21.1926 15.6069L19.0393 13.4536C18.0838 14.2501 16.9912 14.8876 15.8021 15.3256L16.5896 18.2645L14.6578 18.7821L13.87 15.8421C13.2623 15.9461 12.6376 16.0003 12.0002 16.0003C11.3629 16.0003 10.7381 15.9461 10.1305 15.8421Z",
          },
          child: [],
        },
      ],
    })(t);
  }
  const i1 = () => {
      const { login: t } = Sa(),
        e = sn(),
        { showServerErrorMsg: n, showServerSuccessMsg: i, showError: a } = wa(),
        [l, u] = U.useState({});
      return {
        handleRegister: async (y) => {
          var w, S, T, E, j;
          u((O) => ({ ...O, 1: !0 }));
          try {
            const O = new FormData();
            (O.append("name", y.name),
              O.append("email", y.email),
              O.append("password", y.password),
              O.append("phone", y.phone));
            const M = await Xe.post(`${Ii}register`, O, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            M.data
              ? (sessionStorage.setItem(
                  "email_for_verify",
                  (y == null ? void 0 : y.email) || "",
                ),
                i(
                  ((w = M.data) == null ? void 0 : w.message) ||
                    "Login successfully!",
                ),
                e("/qeydiyyat/otp-verification", { replace: !0 }),
                (y.email = ""),
                (y.name = ""),
                (y.password = ""),
                (y.phone = ""))
              : console.log(M.status);
          } catch (O) {
            (Xe.isAxiosError(O) &&
            (T = (S = O.response) == null ? void 0 : S.data) != null &&
            T.message
              ? n(
                  (j = (E = O.response) == null ? void 0 : E.data) == null
                    ? void 0
                    : j.message,
                )
              : a(),
              console.log(O));
          } finally {
            u((O) => ({ ...O, 1: !1 }));
          }
        },
        handleLogin: async (y) => {
          var w, S, T, E, j, O, M, N, R, P, G;
          u((Y) => ({ ...Y, 2: !0 }));
          try {
            const Y = await Xe.post(`${Ii}login`, y, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            if (Y.data) {
              i(
                ((w = Y.data) == null ? void 0 : w.message) ||
                  "Login successfully",
              );
              const B =
                  (T = (S = Y.data) == null ? void 0 : S.data) == null
                    ? void 0
                    : T.user,
                I =
                  (j = (E = Y.data) == null ? void 0 : E.data) == null
                    ? void 0
                    : j.token,
                H =
                  (M = (O = Y.data) == null ? void 0 : O.data) == null
                    ? void 0
                    : M.refresh_token;
              (t(B, I, H), e("/kabinet/melumatlarim", { replace: !0 }));
            } else console.log(Y.status);
          } catch (Y) {
            (Xe.isAxiosError(Y) &&
            (R = (N = Y.response) == null ? void 0 : N.data) != null &&
            R.message
              ? n(
                  (G = (P = Y.response) == null ? void 0 : P.data) == null
                    ? void 0
                    : G.message,
                )
              : a(),
              console.log(Y));
          } finally {
            u((Y) => ({ ...Y, 2: !1 }));
          }
        },
        handleForgotPassword: async (y) => {
          var w, S, T, E, j;
          u((O) => ({ ...O, 3: !0 }));
          try {
            const O = await Xe.post(`${Ii}forgot-password`, y, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            O.data
              ? (i(
                  ((w = O.data) == null ? void 0 : w.message) || "Email sended",
                ),
                xt.success(
                  "Şifrə yeniləmə linki qeyd olunan ünvana göndərildi. Zəhmət olmasa emailinizi yoxlayın",
                ))
              : console.log(O.status);
          } catch (O) {
            (Xe.isAxiosError(O) &&
            (T = (S = O.response) == null ? void 0 : S.data) != null &&
            T.message
              ? n(
                  (j = (E = O.response) == null ? void 0 : E.data) == null
                    ? void 0
                    : j.message,
                )
              : a(),
              console.log(O));
          } finally {
            u((O) => ({ ...O, 3: !1 }));
          }
        },
        handleChangePassword: async (y) => {
          var w, S, T, E, j;
          u((O) => ({ ...O, 4: !0 }));
          try {
            const O = await Xe.post(`${Ii}reset-password`, y, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            O.data
              ? (i(
                  ((w = O.data) == null ? void 0 : w.message) ||
                    "Is Password Change successfully!",
                ),
                e("/daxil-ol", { replace: !0 }))
              : console.log(O.status);
          } catch (O) {
            (Xe.isAxiosError(O) &&
            (T = (S = O.response) == null ? void 0 : S.data) != null &&
            T.message
              ? n(
                  (j = (E = O.response) == null ? void 0 : E.data) == null
                    ? void 0
                    : j.message,
                )
              : a(),
              console.log(O));
          } finally {
            u((O) => ({ ...O, 4: !1 }));
          }
        },
        loading: l,
      };
    },
    sI = () => {
      const { t } = Ot(),
        { handleLogin: e, loading: n } = i1(),
        [i, a] = U.useState(!1),
        [l, u] = U.useState({ email: "", password: "" });
      return h.jsxs("div", {
        className: "login",
        children: [
          h.jsx("title", { children: t("daxil_ol") }),
          h.jsx("meta", {
            name: "description",
            content: "Tehsil platformasına daxil ol",
          }),
          h.jsx("meta", { property: "og:title", content: t("daxil_ol") }),
          h.jsx("meta", {
            property: "og:description",
            content: "Tehsil platformasına daxil ol",
          }),
          h.jsxs("form", {
            onSubmit: (d) => {
              (d.preventDefault(), e(l));
            },
            acceptCharset: "UTF-8",
            className: "left",
            children: [
              h.jsx("div", {
                className: "button-get-back",
                children: h.jsx(_t, {
                  to: "/",
                  className: "btn",
                  children: h.jsx("img", {
                    src: "/ArrowLeft.svg",
                    alt: "arrow-left",
                  }),
                }),
              }),
              h.jsxs("div", {
                className: "form-container",
                children: [
                  h.jsxs("div", {
                    className: "title-content",
                    children: [
                      h.jsx("h1", { children: t("xos_geldiniz") }),
                      h.jsx("p", { children: t("hesabiniza_daxil_olun") }),
                    ],
                  }),
                  h.jsxs("div", {
                    className: "content",
                    children: [
                      h.jsxs("div", {
                        className: "input-container",
                        children: [
                          h.jsx("div", {
                            className: "input-field",
                            children: h.jsx("input", {
                              type: "email",
                              placeholder: "Email",
                              name: "email",
                              value: l == null ? void 0 : l.email,
                              required: !0,
                              onChange: (d) =>
                                u((m) => ({ ...m, email: d.target.value })),
                            }),
                          }),
                          h.jsxs("div", {
                            className: "input-field",
                            children: [
                              i
                                ? h.jsx(jb, {
                                    className: "eye",
                                    onClick: () => a(!1),
                                  })
                                : h.jsx(wb, {
                                    className: "eye",
                                    onClick: () => a(!0),
                                  }),
                              h.jsx("input", {
                                type: i ? "text" : "password",
                                placeholder: "Şifrə",
                                name: "password",
                                value: l == null ? void 0 : l.password,
                                required: !0,
                                onChange: (d) =>
                                  u((m) => ({
                                    ...m,
                                    password: d.target.value,
                                  })),
                              }),
                            ],
                          }),
                          h.jsx("div", {
                            className: "check-area",
                            children: h.jsx(_t, {
                              className: "link",
                              to: "/sifremi-unuttum",
                              children: t("sifreni_unuttum"),
                            }),
                          }),
                          n[2]
                            ? h.jsx(ze, {
                                style: { height: "30px" },
                                styleLoader: { height: "30px" },
                              })
                            : h.jsx(Ct, {
                                buttonType: "submit",
                                title: t("daxil_ol"),
                                href: "/daxil-ol",
                                isButton: !0,
                                style: { width: "100%" },
                                disabled: n[2],
                              }),
                        ],
                      }),
                      h.jsx("div", {
                        className: "message",
                        children: h.jsxs("p", {
                          children: [
                            "Hesabın yoxdur?",
                            h.jsx(_t, {
                              to: "/qeydiyyat",
                              className: "linked",
                              children: t("qeydiyyat"),
                            }),
                          ],
                        }),
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
          h.jsx("div", { className: "right" }),
        ],
      });
    },
    rI = () => {
      const { t } = Ot(),
        [e, n] = U.useState(!1),
        [i, a] = U.useState({ email: "", name: "", password: "", phone: "" }),
        { handleRegister: l, loading: u } = i1();
      return h.jsxs("div", {
        className: "register",
        children: [
          h.jsx("title", { children: "Qeydiyyatdan keç - Təhsil" }),
          h.jsx("meta", {
            name: "description",
            content: "Tehsil platformasına qeydiyyatdan keç",
          }),
          h.jsx("meta", {
            property: "og:title",
            content: "Qeydiyyatdan keç - Təhsil",
          }),
          h.jsx("meta", {
            property: "og:description",
            content: "Tehsil platformasına qeydiyyatdan keç",
          }),
          h.jsxs("form", {
            onSubmit: (d) => {
              (d.preventDefault(), l(i));
            },
            acceptCharset: "UTF-8",
            className: "left",
            children: [
              h.jsx("div", {
                className: "button-get-back",
                children: h.jsx(_t, {
                  to: "/",
                  className: "btn",
                  children: h.jsx("img", {
                    src: "/ArrowLeft.svg",
                    alt: "arrow-left",
                  }),
                }),
              }),
              h.jsxs("div", {
                className: "form-container",
                children: [
                  h.jsxs("div", {
                    className: "title-content",
                    children: [
                      h.jsx("h1", { children: t("xos_geldiniz") }),
                      h.jsx("p", {
                        children: t(
                          "hesabiniza_daxil_olun_veya_qeydiyyatdan_kecin",
                        ),
                      }),
                    ],
                  }),
                  h.jsxs("div", {
                    className: "content",
                    children: [
                      h.jsxs("div", {
                        className: "input-container",
                        children: [
                          h.jsx("div", {
                            className: "input-field",
                            children: h.jsx("input", {
                              type: "text",
                              placeholder: "Ad və soyad",
                              name: "name",
                              value: i == null ? void 0 : i.name,
                              required: !0,
                              onChange: (d) =>
                                a((m) => ({ ...m, name: d.target.value })),
                            }),
                          }),
                          h.jsx("div", {
                            className: "input-field",
                            children: h.jsx("input", {
                              type: "number",
                              placeholder: "+994 00 000 00 00",
                              name: "phone",
                              value: i == null ? void 0 : i.phone,
                              required: !0,
                              onChange: (d) =>
                                a((m) => ({ ...m, phone: d.target.value })),
                            }),
                          }),
                          h.jsx("div", {
                            className: "input-field",
                            children: h.jsx("input", {
                              type: "email",
                              placeholder: "Email",
                              name: "email",
                              value: i == null ? void 0 : i.email,
                              required: !0,
                              onChange: (d) =>
                                a((m) => ({ ...m, email: d.target.value })),
                            }),
                          }),
                          h.jsxs("div", {
                            className: "input-field",
                            children: [
                              e
                                ? h.jsx(jb, {
                                    className: "eye",
                                    onClick: () => n(!1),
                                  })
                                : h.jsx(wb, {
                                    className: "eye",
                                    onClick: () => n(!0),
                                  }),
                              h.jsx("input", {
                                type: e ? "text" : "password",
                                placeholder: "Şifrə",
                                name: "password",
                                value: i == null ? void 0 : i.password,
                                required: !0,
                                onChange: (d) =>
                                  a((m) => ({
                                    ...m,
                                    password: d.target.value,
                                  })),
                              }),
                            ],
                          }),
                          h.jsxs("div", {
                            className: "check-area",
                            children: [
                              h.jsx("input", {
                                name: "rules",
                                required: !0,
                                type: "checkbox",
                              }),
                              h.jsxs("p", {
                                children: [
                                  "Mən ",
                                  h.jsx(_t, {
                                    to: "",
                                    className: "link",
                                    children: "Qaydalar və Şərtləri",
                                  }),
                                  " oxudum və razıyam.",
                                ],
                              }),
                            ],
                          }),
                          u[1]
                            ? h.jsx(ze, { style: { height: "40px" } })
                            : h.jsx(Ct, {
                                buttonType: "submit",
                                title: "Qeydiyyatdan keç",
                                isButton: !0,
                                disabled: u[1],
                                style: { width: "100%" },
                              }),
                        ],
                      }),
                      h.jsx("div", {
                        className: "message",
                        children: h.jsxs("p", {
                          children: [
                            "Hesabın var? ",
                            h.jsx(_t, {
                              to: "/daxil-ol",
                              className: "linked",
                              children: t("daxil_ol"),
                            }),
                          ],
                        }),
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
          h.jsx("div", { className: "right" }),
        ],
      });
    };
  var yE = function (t) {
      return typeof t == "object" && t !== null;
    },
    aI = function (t) {
      var e = t.value,
        n = e === void 0 ? "" : e,
        i = t.numInputs,
        a = i === void 0 ? 4 : i,
        l = t.onChange,
        u = t.onPaste,
        d = t.renderInput,
        m = t.shouldAutoFocus,
        g = m === void 0 ? !1 : m,
        v = t.inputType,
        y = v === void 0 ? "text" : v,
        w = t.renderSeparator,
        S = t.placeholder,
        T = t.containerStyle,
        E = t.inputStyle,
        j = t.skipDefaultStyles,
        O = j === void 0 ? !1 : j,
        M = U.useState(0),
        N = M[0],
        R = M[1],
        P = U.useRef([]),
        G = function () {
          return n ? n.toString().split("") : [];
        },
        Y = y === "number" || y === "tel";
      (U.useEffect(
        function () {
          P.current = P.current.slice(0, a);
        },
        [a],
      ),
        U.useEffect(
          function () {
            var he;
            g && ((he = P.current[0]) === null || he === void 0 || he.focus());
          },
          [g],
        ));
      var B = function () {
          if (typeof S == "string") {
            if (S.length === a) return S;
            S.length > 0 &&
              console.error(
                "Length of the placeholder should be equal to the number of inputs.",
              );
          }
        },
        I = function (he) {
          var Te = Y ? !isNaN(Number(he)) : typeof he == "string";
          return Te && he.trim().length === 1;
        },
        H = function (he) {
          var Te = he.target.value;
          I(Te) && (V(Te), Oe(N + 1));
        },
        X = function (he) {
          var Te = he.nativeEvent,
            F = he.target.value;
          if (!I(F)) {
            if (F.length === a) {
              var ae = F.split("").some(function (xe) {
                return !I(xe);
              });
              ae || (pe(F.split("")), Oe(a - 1));
            }
            (Te.data === null &&
              Te.inputType === "deleteContentBackward" &&
              (he.preventDefault(), V(""), Oe(N - 1)),
              (he.target.value = ""));
          }
        },
        fe = function (he) {
          return function (Te) {
            (R(Te), he.target.select());
          };
        },
        ve = function () {
          R(N - 1);
        },
        be = function (he) {
          var Te = G();
          [he.code, he.key].includes("Backspace")
            ? (he.preventDefault(), V(""), Oe(N - 1))
            : he.code === "Delete"
              ? (he.preventDefault(), V(""))
              : he.code === "ArrowLeft"
                ? (he.preventDefault(), Oe(N - 1))
                : he.code === "ArrowRight" || he.key === Te[N]
                  ? (he.preventDefault(), Oe(N + 1))
                  : (he.code === "Spacebar" ||
                      he.code === "Space" ||
                      he.code === "ArrowUp" ||
                      he.code === "ArrowDown") &&
                    he.preventDefault();
        },
        Oe = function (he) {
          var Te,
            F,
            ae = Math.max(Math.min(a - 1, he), 0);
          P.current[ae] &&
            ((Te = P.current[ae]) === null || Te === void 0 || Te.focus(),
            (F = P.current[ae]) === null || F === void 0 || F.select(),
            R(ae));
        },
        V = function (he) {
          var Te = G();
          ((Te[N] = he[0]), pe(Te));
        },
        pe = function (he) {
          var Te = he.join("");
          l(Te);
        },
        de = function (he) {
          var Te;
          he.preventDefault();
          var F = G(),
            ae = N,
            xe = he.clipboardData
              .getData("text/plain")
              .slice(0, a - N)
              .split("");
          if (
            !(
              Y &&
              xe.some(function (le) {
                return isNaN(Number(le));
              })
            )
          ) {
            for (var Me = 0; Me < a; ++Me)
              Me >= N &&
                xe.length > 0 &&
                ((F[Me] =
                  (Te = xe.shift()) !== null && Te !== void 0 ? Te : ""),
                ae++);
            (Oe(ae), pe(F));
          }
        };
      return U.createElement(
        "div",
        {
          style: Object.assign(
            { display: "flex", alignItems: "center" },
            yE(T) && T,
          ),
          className: typeof T == "string" ? T : void 0,
          onPaste: u,
        },
        Array.from({ length: a }, function (he, Te) {
          return Te;
        }).map(function (he) {
          var Te, F, ae;
          return U.createElement(
            U.Fragment,
            { key: he },
            d(
              {
                value: (Te = G()[he]) !== null && Te !== void 0 ? Te : "",
                placeholder:
                  (ae = (F = B()) === null || F === void 0 ? void 0 : F[he]) !==
                    null && ae !== void 0
                    ? ae
                    : void 0,
                ref: function (xe) {
                  return (P.current[he] = xe);
                },
                onChange: H,
                onFocus: function (xe) {
                  return fe(xe)(he);
                },
                onBlur: ve,
                onKeyDown: be,
                onPaste: de,
                autoComplete: "off",
                "aria-label": "Please enter OTP character ".concat(he + 1),
                style: Object.assign(
                  O ? {} : { width: "1em", textAlign: "center" },
                  yE(E) ? E : {},
                ),
                className: typeof E == "string" ? E : void 0,
                type: y,
                inputMode: Y ? "numeric" : "text",
                onInput: X,
              },
              he,
            ),
            he < a - 1 && (typeof w == "function" ? w(he) : w),
          );
        }),
      );
    },
    xg = { exports: {} };
  /**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */ var lI = xg.exports,
    bE;
  function oI() {
    return (
      bE ||
        ((bE = 1),
        (function (t, e) {
          (function () {
            var n,
              i = "4.17.21",
              a = 200,
              l =
                "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",
              u = "Expected a function",
              d = "Invalid `variable` option passed into `_.template`",
              m = "__lodash_hash_undefined__",
              g = 500,
              v = "__lodash_placeholder__",
              y = 1,
              w = 2,
              S = 4,
              T = 1,
              E = 2,
              j = 1,
              O = 2,
              M = 4,
              N = 8,
              R = 16,
              P = 32,
              G = 64,
              Y = 128,
              B = 256,
              I = 512,
              H = 30,
              X = "...",
              fe = 800,
              ve = 16,
              be = 1,
              Oe = 2,
              V = 3,
              pe = 1 / 0,
              de = 9007199254740991,
              he = 17976931348623157e292,
              Te = NaN,
              F = 4294967295,
              ae = F - 1,
              xe = F >>> 1,
              Me = [
                ["ary", Y],
                ["bind", j],
                ["bindKey", O],
                ["curry", N],
                ["curryRight", R],
                ["flip", I],
                ["partial", P],
                ["partialRight", G],
                ["rearg", B],
              ],
              le = "[object Arguments]",
              Re = "[object Array]",
              Je = "[object AsyncFunction]",
              ut = "[object Boolean]",
              ot = "[object Date]",
              di = "[object DOMException]",
              ri = "[object Error]",
              Bi = "[object Function]",
              Cn = "[object GeneratorFunction]",
              Gt = "[object Map]",
              An = "[object Number]",
              bl = "[object Null]",
              Hi = "[object Object]",
              vr = "[object Promise]",
              Ca = "[object Proxy]",
              xs = "[object RegExp]",
              ai = "[object Set]",
              Oa = "[object String]",
              wo = "[object Symbol]",
              Xn = "[object Undefined]",
              Gs = "[object WeakMap]",
              Br = "[object WeakSet]",
              Qn = "[object ArrayBuffer]",
              Yi = "[object DataView]",
              So = "[object Float32Array]",
              xl = "[object Float64Array]",
              _l = "[object Int8Array]",
              To = "[object Int16Array]",
              _s = "[object Int32Array]",
              Rn = "[object Uint8Array]",
              Ln = "[object Uint8ClampedArray]",
              bn = "[object Uint16Array]",
              wl = "[object Uint32Array]",
              Hc = /\b__p \+= '';/g,
              lp = /\b(__p \+=) '' \+/g,
              Hr = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
              yr = /&(?:amp|lt|gt|quot|#39);/g,
              Sl = /[&<>"']/g,
              qi = RegExp(yr.source),
              Eo = RegExp(Sl.source),
              Tl = /<%-([\s\S]+?)%>/g,
              On = /<%([\s\S]+?)%>/g,
              br = /<%=([\s\S]+?)%>/g,
              Yc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
              ja = /^\w*$/,
              qc =
                /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
              El = /[\\^$.*+?()[\]{}|]/g,
              $c = RegExp(El.source),
              Co = /^\s+/,
              _i = /\s/,
              Vs = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
              Gc = /\{\n\/\* \[wrapped with (.+)\] \*/,
              Vc = /,? & /,
              ws = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
              Dn = /[()=,{}\[\]\/\s]/,
              on = /\\(\\)?/g,
              Yr = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
              Cl = /\w*$/,
              Uf = /^[-+]0x[0-9a-f]+$/i,
              Ff = /^0b[01]+$/i,
              Bf = /^\[object .+?Constructor\]$/,
              Fe = /^0o[0-7]+$/i,
              Z = /^(?:0|[1-9]\d*)$/,
              Ce = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
              Le = /($^)/,
              zt = /['\n\r\u2028\u2029\\]/g,
              nn = "\\ud800-\\udfff",
              ft = "\\u0300-\\u036f",
              Zn = "\\ufe20-\\ufe2f",
              Ss = "\\u20d0-\\u20ff",
              hi = ft + Zn + Ss,
              Ws = "\\u2700-\\u27bf",
              kn = "a-z\\xdf-\\xf6\\xf8-\\xff",
              Wc = "\\xac\\xb1\\xd7\\xf7",
              Xc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",
              s1 = "\\u2000-\\u206f",
              Hf =
                " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
              Qc = "A-Z\\xc0-\\xd6\\xd8-\\xde",
              xr = "\\ufe0e\\ufe0f",
              $i = Wc + Xc + s1 + Hf,
              Yf = "['’]",
              r1 = "[" + nn + "]",
              qf = "[" + $i + "]",
              Zc = "[" + hi + "]",
              Kc = "\\d+",
              a1 = "[" + Ws + "]",
              Gi = "[" + kn + "]",
              $f = "[^" + nn + $i + Kc + Ws + kn + Qc + "]",
              Gf = "\\ud83c[\\udffb-\\udfff]",
              op = "(?:" + Zc + "|" + Gf + ")",
              Ol = "[^" + nn + "]",
              Vf = "(?:\\ud83c[\\udde6-\\uddff]){2}",
              Wf = "[\\ud800-\\udbff][\\udc00-\\udfff]",
              Xs = "[" + Qc + "]",
              ov = "\\u200d",
              cp = "(?:" + Gi + "|" + $f + ")",
              cv = "(?:" + Xs + "|" + $f + ")",
              Xf = "(?:" + Yf + "(?:d|ll|m|re|s|t|ve))?",
              uv = "(?:" + Yf + "(?:D|LL|M|RE|S|T|VE))?",
              fv = op + "?",
              Jc = "[" + xr + "]?",
              qr =
                "(?:" +
                ov +
                "(?:" +
                [Ol, Vf, Wf].join("|") +
                ")" +
                Jc +
                fv +
                ")*",
              up = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
              fp = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
              jl = Jc + fv + qr,
              Oo = "(?:" + [a1, Vf, Wf].join("|") + ")" + jl,
              dv = "(?:" + [Ol + Zc + "?", Zc, Vf, Wf, r1].join("|") + ")",
              dp = RegExp(Yf, "g"),
              hv = RegExp(Zc, "g"),
              Ml = RegExp(Gf + "(?=" + Gf + ")|" + dv + jl, "g"),
              $r = RegExp(
                [
                  Xs +
                    "?" +
                    Gi +
                    "+" +
                    Xf +
                    "(?=" +
                    [qf, Xs, "$"].join("|") +
                    ")",
                  cv + "+" + uv + "(?=" + [qf, Xs + cp, "$"].join("|") + ")",
                  Xs + "?" + cp + "+" + Xf,
                  Xs + "+" + uv,
                  fp,
                  up,
                  Kc,
                  Oo,
                ].join("|"),
                "g",
              ),
              hp = RegExp("[" + ov + nn + hi + xr + "]"),
              eu =
                /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
              Ma = [
                "Array",
                "Buffer",
                "DataView",
                "Date",
                "Error",
                "Float32Array",
                "Float64Array",
                "Function",
                "Int8Array",
                "Int16Array",
                "Int32Array",
                "Map",
                "Math",
                "Object",
                "Promise",
                "RegExp",
                "Set",
                "String",
                "Symbol",
                "TypeError",
                "Uint8Array",
                "Uint8ClampedArray",
                "Uint16Array",
                "Uint32Array",
                "WeakMap",
                "_",
                "clearTimeout",
                "isFinite",
                "parseInt",
                "setTimeout",
              ],
              pp = -1,
              Vt = {};
            ((Vt[So] =
              Vt[xl] =
              Vt[_l] =
              Vt[To] =
              Vt[_s] =
              Vt[Rn] =
              Vt[Ln] =
              Vt[bn] =
              Vt[wl] =
                !0),
              (Vt[le] =
                Vt[Re] =
                Vt[Qn] =
                Vt[ut] =
                Vt[Yi] =
                Vt[ot] =
                Vt[ri] =
                Vt[Bi] =
                Vt[Gt] =
                Vt[An] =
                Vt[Hi] =
                Vt[xs] =
                Vt[ai] =
                Vt[Oa] =
                Vt[Gs] =
                  !1));
            var Jt = {};
            ((Jt[le] =
              Jt[Re] =
              Jt[Qn] =
              Jt[Yi] =
              Jt[ut] =
              Jt[ot] =
              Jt[So] =
              Jt[xl] =
              Jt[_l] =
              Jt[To] =
              Jt[_s] =
              Jt[Gt] =
              Jt[An] =
              Jt[Hi] =
              Jt[xs] =
              Jt[ai] =
              Jt[Oa] =
              Jt[wo] =
              Jt[Rn] =
              Jt[Ln] =
              Jt[bn] =
              Jt[wl] =
                !0),
              (Jt[ri] = Jt[Bi] = Jt[Gs] = !1));
            var Qf = {
                À: "A",
                Á: "A",
                Â: "A",
                Ã: "A",
                Ä: "A",
                Å: "A",
                à: "a",
                á: "a",
                â: "a",
                ã: "a",
                ä: "a",
                å: "a",
                Ç: "C",
                ç: "c",
                Ð: "D",
                ð: "d",
                È: "E",
                É: "E",
                Ê: "E",
                Ë: "E",
                è: "e",
                é: "e",
                ê: "e",
                ë: "e",
                Ì: "I",
                Í: "I",
                Î: "I",
                Ï: "I",
                ì: "i",
                í: "i",
                î: "i",
                ï: "i",
                Ñ: "N",
                ñ: "n",
                Ò: "O",
                Ó: "O",
                Ô: "O",
                Õ: "O",
                Ö: "O",
                Ø: "O",
                ò: "o",
                ó: "o",
                ô: "o",
                õ: "o",
                ö: "o",
                ø: "o",
                Ù: "U",
                Ú: "U",
                Û: "U",
                Ü: "U",
                ù: "u",
                ú: "u",
                û: "u",
                ü: "u",
                Ý: "Y",
                ý: "y",
                ÿ: "y",
                Æ: "Ae",
                æ: "ae",
                Þ: "Th",
                þ: "th",
                ß: "ss",
                Ā: "A",
                Ă: "A",
                Ą: "A",
                ā: "a",
                ă: "a",
                ą: "a",
                Ć: "C",
                Ĉ: "C",
                Ċ: "C",
                Č: "C",
                ć: "c",
                ĉ: "c",
                ċ: "c",
                č: "c",
                Ď: "D",
                Đ: "D",
                ď: "d",
                đ: "d",
                Ē: "E",
                Ĕ: "E",
                Ė: "E",
                Ę: "E",
                Ě: "E",
                ē: "e",
                ĕ: "e",
                ė: "e",
                ę: "e",
                ě: "e",
                Ĝ: "G",
                Ğ: "G",
                Ġ: "G",
                Ģ: "G",
                ĝ: "g",
                ğ: "g",
                ġ: "g",
                ģ: "g",
                Ĥ: "H",
                Ħ: "H",
                ĥ: "h",
                ħ: "h",
                Ĩ: "I",
                Ī: "I",
                Ĭ: "I",
                Į: "I",
                İ: "I",
                ĩ: "i",
                ī: "i",
                ĭ: "i",
                į: "i",
                ı: "i",
                Ĵ: "J",
                ĵ: "j",
                Ķ: "K",
                ķ: "k",
                ĸ: "k",
                Ĺ: "L",
                Ļ: "L",
                Ľ: "L",
                Ŀ: "L",
                Ł: "L",
                ĺ: "l",
                ļ: "l",
                ľ: "l",
                ŀ: "l",
                ł: "l",
                Ń: "N",
                Ņ: "N",
                Ň: "N",
                Ŋ: "N",
                ń: "n",
                ņ: "n",
                ň: "n",
                ŋ: "n",
                Ō: "O",
                Ŏ: "O",
                Ő: "O",
                ō: "o",
                ŏ: "o",
                ő: "o",
                Ŕ: "R",
                Ŗ: "R",
                Ř: "R",
                ŕ: "r",
                ŗ: "r",
                ř: "r",
                Ś: "S",
                Ŝ: "S",
                Ş: "S",
                Š: "S",
                ś: "s",
                ŝ: "s",
                ş: "s",
                š: "s",
                Ţ: "T",
                Ť: "T",
                Ŧ: "T",
                ţ: "t",
                ť: "t",
                ŧ: "t",
                Ũ: "U",
                Ū: "U",
                Ŭ: "U",
                Ů: "U",
                Ű: "U",
                Ų: "U",
                ũ: "u",
                ū: "u",
                ŭ: "u",
                ů: "u",
                ű: "u",
                ų: "u",
                Ŵ: "W",
                ŵ: "w",
                Ŷ: "Y",
                ŷ: "y",
                Ÿ: "Y",
                Ź: "Z",
                Ż: "Z",
                Ž: "Z",
                ź: "z",
                ż: "z",
                ž: "z",
                Ĳ: "IJ",
                ĳ: "ij",
                Œ: "Oe",
                œ: "oe",
                ŉ: "'n",
                ſ: "s",
              },
              Zf = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;",
              },
              pv = {
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&quot;": '"',
                "&#39;": "'",
              },
              wi = {
                "\\": "\\",
                "'": "'",
                "\n": "n",
                "\r": "r",
                "\u2028": "u2028",
                "\u2029": "u2029",
              },
              Nl = parseFloat,
              Kf = parseInt,
              jo = typeof y0 == "object" && y0 && y0.Object === Object && y0,
              l1 =
                typeof self == "object" &&
                self &&
                self.Object === Object &&
                self,
              Bn = jo || l1 || Function("return this")(),
              tu = e && !e.nodeType && e,
              Qs = tu && !0 && t && !t.nodeType && t,
              nu = Qs && Qs.exports === tu,
              Jf = nu && jo.process,
              Ts = (function () {
                try {
                  var ee = Qs && Qs.require && Qs.require("util").types;
                  return ee || (Jf && Jf.binding && Jf.binding("util"));
                } catch {}
              })(),
              mv = Ts && Ts.isArrayBuffer,
              gv = Ts && Ts.isDate,
              ed = Ts && Ts.isMap,
              vv = Ts && Ts.isRegExp,
              yv = Ts && Ts.isSet,
              bv = Ts && Ts.isTypedArray;
            function Vi(ee, me, oe) {
              switch (oe.length) {
                case 0:
                  return ee.call(me);
                case 1:
                  return ee.call(me, oe[0]);
                case 2:
                  return ee.call(me, oe[0], oe[1]);
                case 3:
                  return ee.call(me, oe[0], oe[1], oe[2]);
              }
              return ee.apply(me, oe);
            }
            function o1(ee, me, oe, ke) {
              for (var et = -1, pt = ee == null ? 0 : ee.length; ++et < pt; ) {
                var un = ee[et];
                me(ke, un, oe(un), ee);
              }
              return ke;
            }
            function Wi(ee, me) {
              for (
                var oe = -1, ke = ee == null ? 0 : ee.length;
                ++oe < ke && me(ee[oe], oe, ee) !== !1;

              );
              return ee;
            }
            function c1(ee, me) {
              for (
                var oe = ee == null ? 0 : ee.length;
                oe-- && me(ee[oe], oe, ee) !== !1;

              );
              return ee;
            }
            function xv(ee, me) {
              for (var oe = -1, ke = ee == null ? 0 : ee.length; ++oe < ke; )
                if (!me(ee[oe], oe, ee)) return !1;
              return !0;
            }
            function Na(ee, me) {
              for (
                var oe = -1, ke = ee == null ? 0 : ee.length, et = 0, pt = [];
                ++oe < ke;

              ) {
                var un = ee[oe];
                me(un, oe, ee) && (pt[et++] = un);
              }
              return pt;
            }
            function td(ee, me) {
              var oe = ee == null ? 0 : ee.length;
              return !!oe && Mo(ee, me, 0) > -1;
            }
            function iu(ee, me, oe) {
              for (var ke = -1, et = ee == null ? 0 : ee.length; ++ke < et; )
                if (oe(me, ee[ke])) return !0;
              return !1;
            }
            function cn(ee, me) {
              for (
                var oe = -1, ke = ee == null ? 0 : ee.length, et = Array(ke);
                ++oe < ke;

              )
                et[oe] = me(ee[oe], oe, ee);
              return et;
            }
            function Aa(ee, me) {
              for (var oe = -1, ke = me.length, et = ee.length; ++oe < ke; )
                ee[et + oe] = me[oe];
              return ee;
            }
            function mp(ee, me, oe, ke) {
              var et = -1,
                pt = ee == null ? 0 : ee.length;
              for (ke && pt && (oe = ee[++et]); ++et < pt; )
                oe = me(oe, ee[et], et, ee);
              return oe;
            }
            function _v(ee, me, oe, ke) {
              var et = ee == null ? 0 : ee.length;
              for (ke && et && (oe = ee[--et]); et--; )
                oe = me(oe, ee[et], et, ee);
              return oe;
            }
            function gp(ee, me) {
              for (var oe = -1, ke = ee == null ? 0 : ee.length; ++oe < ke; )
                if (me(ee[oe], oe, ee)) return !0;
              return !1;
            }
            var u1 = Al("length");
            function f1(ee) {
              return ee.split("");
            }
            function d1(ee) {
              return ee.match(ws) || [];
            }
            function wv(ee, me, oe) {
              var ke;
              return (
                oe(ee, function (et, pt, un) {
                  if (me(et, pt, un)) return ((ke = pt), !1);
                }),
                ke
              );
            }
            function nd(ee, me, oe, ke) {
              for (
                var et = ee.length, pt = oe + (ke ? 1 : -1);
                ke ? pt-- : ++pt < et;

              )
                if (me(ee[pt], pt, ee)) return pt;
              return -1;
            }
            function Mo(ee, me, oe) {
              return me === me ? g1(ee, me, oe) : nd(ee, Sv, oe);
            }
            function h1(ee, me, oe, ke) {
              for (var et = oe - 1, pt = ee.length; ++et < pt; )
                if (ke(ee[et], me)) return et;
              return -1;
            }
            function Sv(ee) {
              return ee !== ee;
            }
            function id(ee, me) {
              var oe = ee == null ? 0 : ee.length;
              return oe ? sd(ee, me) / oe : Te;
            }
            function Al(ee) {
              return function (me) {
                return me == null ? n : me[ee];
              };
            }
            function vp(ee) {
              return function (me) {
                return ee == null ? n : ee[me];
              };
            }
            function yp(ee, me, oe, ke, et) {
              return (
                et(ee, function (pt, un, Ht) {
                  oe = ke ? ((ke = !1), pt) : me(oe, pt, un, Ht);
                }),
                oe
              );
            }
            function Tv(ee, me) {
              var oe = ee.length;
              for (ee.sort(me); oe--; ) ee[oe] = ee[oe].value;
              return ee;
            }
            function sd(ee, me) {
              for (var oe, ke = -1, et = ee.length; ++ke < et; ) {
                var pt = me(ee[ke]);
                pt !== n && (oe = oe === n ? pt : oe + pt);
              }
              return oe;
            }
            function rd(ee, me) {
              for (var oe = -1, ke = Array(ee); ++oe < ee; ) ke[oe] = me(oe);
              return ke;
            }
            function Ev(ee, me) {
              return cn(me, function (oe) {
                return [oe, ee[oe]];
              });
            }
            function Rl(ee) {
              return ee && ee.slice(0, Ao(ee) + 1).replace(Co, "");
            }
            function Xi(ee) {
              return function (me) {
                return ee(me);
              };
            }
            function bp(ee, me) {
              return cn(me, function (oe) {
                return ee[oe];
              });
            }
            function su(ee, me) {
              return ee.has(me);
            }
            function xp(ee, me) {
              for (
                var oe = -1, ke = ee.length;
                ++oe < ke && Mo(me, ee[oe], 0) > -1;

              );
              return oe;
            }
            function _p(ee, me) {
              for (var oe = ee.length; oe-- && Mo(me, ee[oe], 0) > -1; );
              return oe;
            }
            function ru(ee, me) {
              for (var oe = ee.length, ke = 0; oe--; ) ee[oe] === me && ++ke;
              return ke;
            }
            var au = vp(Qf),
              p1 = vp(Zf);
            function ad(ee) {
              return "\\" + wi[ee];
            }
            function Cv(ee, me) {
              return ee == null ? n : ee[me];
            }
            function Ll(ee) {
              return hp.test(ee);
            }
            function wp(ee) {
              return eu.test(ee);
            }
            function Sp(ee) {
              for (var me, oe = []; !(me = ee.next()).done; ) oe.push(me.value);
              return oe;
            }
            function ld(ee) {
              var me = -1,
                oe = Array(ee.size);
              return (
                ee.forEach(function (ke, et) {
                  oe[++me] = [et, ke];
                }),
                oe
              );
            }
            function Tp(ee, me) {
              return function (oe) {
                return ee(me(oe));
              };
            }
            function Gr(ee, me) {
              for (var oe = -1, ke = ee.length, et = 0, pt = []; ++oe < ke; ) {
                var un = ee[oe];
                (un === me || un === v) && ((ee[oe] = v), (pt[et++] = oe));
              }
              return pt;
            }
            function od(ee) {
              var me = -1,
                oe = Array(ee.size);
              return (
                ee.forEach(function (ke) {
                  oe[++me] = ke;
                }),
                oe
              );
            }
            function m1(ee) {
              var me = -1,
                oe = Array(ee.size);
              return (
                ee.forEach(function (ke) {
                  oe[++me] = [ke, ke];
                }),
                oe
              );
            }
            function g1(ee, me, oe) {
              for (var ke = oe - 1, et = ee.length; ++ke < et; )
                if (ee[ke] === me) return ke;
              return -1;
            }
            function v1(ee, me, oe) {
              for (var ke = oe + 1; ke--; ) if (ee[ke] === me) return ke;
              return ke;
            }
            function No(ee) {
              return Ll(ee) ? jv(ee) : u1(ee);
            }
            function hn(ee) {
              return Ll(ee) ? Mv(ee) : f1(ee);
            }
            function Ao(ee) {
              for (var me = ee.length; me-- && _i.test(ee.charAt(me)); );
              return me;
            }
            var Ov = vp(pv);
            function jv(ee) {
              for (var me = (Ml.lastIndex = 0); Ml.test(ee); ) ++me;
              return me;
            }
            function Mv(ee) {
              return ee.match(Ml) || [];
            }
            function Nv(ee) {
              return ee.match($r) || [];
            }
            var Ep = function ee(me) {
                me =
                  me == null
                    ? Bn
                    : Ro.defaults(Bn.Object(), me, Ro.pick(Bn, Ma));
                var oe = me.Array,
                  ke = me.Date,
                  et = me.Error,
                  pt = me.Function,
                  un = me.Math,
                  Ht = me.Object,
                  cd = me.RegExp,
                  Dl = me.String,
                  Qi = me.TypeError,
                  lu = oe.prototype,
                  Av = pt.prototype,
                  Lo = Ht.prototype,
                  ud = me["__core-js_shared__"],
                  fd = Av.toString,
                  Pt = Lo.hasOwnProperty,
                  Rv = 0,
                  dd = (function () {
                    var c = /[^.]+$/.exec(
                      (ud && ud.keys && ud.keys.IE_PROTO) || "",
                    );
                    return c ? "Symbol(src)_1." + c : "";
                  })(),
                  Si = Lo.toString,
                  hd = fd.call(Ht),
                  Es = Bn._,
                  Do = cd(
                    "^" +
                      fd
                        .call(Pt)
                        .replace(El, "\\$&")
                        .replace(
                          /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                          "$1.*?",
                        ) +
                      "$",
                  ),
                  ko = nu ? me.Buffer : n,
                  Zs = me.Symbol,
                  kl = me.Uint8Array,
                  pd = ko ? ko.allocUnsafe : n,
                  _r = Tp(Ht.getPrototypeOf, Ht),
                  Cp = Ht.create,
                  ou = Lo.propertyIsEnumerable,
                  Vr = lu.splice,
                  Lv = Zs ? Zs.isConcatSpreadable : n,
                  Kn = Zs ? Zs.iterator : n,
                  Wr = Zs ? Zs.toStringTag : n,
                  Cs = (function () {
                    try {
                      var c = qa(Ht, "defineProperty");
                      return (c({}, "", {}), c);
                    } catch {}
                  })(),
                  Dv = me.clearTimeout !== Bn.clearTimeout && me.clearTimeout,
                  md = ke && ke.now !== Bn.Date.now && ke.now,
                  zl = me.setTimeout !== Bn.setTimeout && me.setTimeout,
                  zo = un.ceil,
                  cu = un.floor,
                  uu = Ht.getOwnPropertySymbols,
                  kv = ko ? ko.isBuffer : n,
                  Zi = me.isFinite,
                  Po = lu.join,
                  Io = Tp(Ht.keys, Ht),
                  xn = un.max,
                  zn = un.min,
                  Os = ke.now,
                  js = me.parseInt,
                  Xr = un.random,
                  wr = lu.reverse,
                  Ms = qa(me, "DataView"),
                  Ki = qa(me, "Map"),
                  gd = qa(me, "Promise"),
                  Ra = qa(me, "Set"),
                  Pl = qa(me, "WeakMap"),
                  Uo = qa(Ht, "create"),
                  Pn = Pl && new Pl(),
                  It = {},
                  wt = ci(Ms),
                  La = ci(Ki),
                  Ns = ci(gd),
                  Op = ci(Ra),
                  Da = ci(Pl),
                  fu = Zs ? Zs.prototype : n,
                  Fo = fu ? fu.valueOf : n,
                  Il = fu ? fu.toString : n;
                function k(c) {
                  if (Sn(c) && !tt(c) && !(c instanceof it)) {
                    if (c instanceof Ti) return c;
                    if (Pt.call(c, "__wrapped__")) return Vd(c);
                  }
                  return new Ti(c);
                }
                var ka = (function () {
                  function c() {}
                  return function (p) {
                    if (!dn(p)) return {};
                    if (Cp) return Cp(p);
                    c.prototype = p;
                    var x = new c();
                    return ((c.prototype = n), x);
                  };
                })();
                function za() {}
                function Ti(c, p) {
                  ((this.__wrapped__ = c),
                    (this.__actions__ = []),
                    (this.__chain__ = !!p),
                    (this.__index__ = 0),
                    (this.__values__ = n));
                }
                ((k.templateSettings = {
                  escape: Tl,
                  evaluate: On,
                  interpolate: br,
                  variable: "",
                  imports: { _: k },
                }),
                  (k.prototype = za.prototype),
                  (k.prototype.constructor = k),
                  (Ti.prototype = ka(za.prototype)),
                  (Ti.prototype.constructor = Ti));
                function it(c) {
                  ((this.__wrapped__ = c),
                    (this.__actions__ = []),
                    (this.__dir__ = 1),
                    (this.__filtered__ = !1),
                    (this.__iteratees__ = []),
                    (this.__takeCount__ = F),
                    (this.__views__ = []));
                }
                function Qr() {
                  var c = new it(this.__wrapped__);
                  return (
                    (c.__actions__ = mi(this.__actions__)),
                    (c.__dir__ = this.__dir__),
                    (c.__filtered__ = this.__filtered__),
                    (c.__iteratees__ = mi(this.__iteratees__)),
                    (c.__takeCount__ = this.__takeCount__),
                    (c.__views__ = mi(this.__views__)),
                    c
                  );
                }
                function Pa() {
                  if (this.__filtered__) {
                    var c = new it(this);
                    ((c.__dir__ = -1), (c.__filtered__ = !0));
                  } else ((c = this.clone()), (c.__dir__ *= -1));
                  return c;
                }
                function Zr() {
                  var c = this.__wrapped__.value(),
                    p = this.__dir__,
                    x = tt(c),
                    C = p < 0,
                    L = x ? c.length : 0,
                    z = C1(0, L, this.__views__),
                    q = z.start,
                    Q = z.end,
                    ne = Q - q,
                    we = C ? Q : q - 1,
                    Se = this.__iteratees__,
                    Ee = Se.length,
                    Ae = 0,
                    He = zn(ne, this.__takeCount__);
                  if (!x || (!C && L == ne && He == ne))
                    return Hp(c, this.__actions__);
                  var Ze = [];
                  e: for (; ne-- && Ae < He; ) {
                    we += p;
                    for (var ht = -1, Ke = c[we]; ++ht < Ee; ) {
                      var St = Se[ht],
                        jt = St.iteratee,
                        cr = St.type,
                        us = jt(Ke);
                      if (cr == Oe) Ke = us;
                      else if (!us) {
                        if (cr == be) continue e;
                        break e;
                      }
                    }
                    Ze[Ae++] = Ke;
                  }
                  return Ze;
                }
                ((it.prototype = ka(za.prototype)),
                  (it.prototype.constructor = it));
                function Kr(c) {
                  var p = -1,
                    x = c == null ? 0 : c.length;
                  for (this.clear(); ++p < x; ) {
                    var C = c[p];
                    this.set(C[0], C[1]);
                  }
                }
                function jp() {
                  ((this.__data__ = Uo ? Uo(null) : {}), (this.size = 0));
                }
                function Bo(c) {
                  var p = this.has(c) && delete this.__data__[c];
                  return ((this.size -= p ? 1 : 0), p);
                }
                function vd(c) {
                  var p = this.__data__;
                  if (Uo) {
                    var x = p[c];
                    return x === m ? n : x;
                  }
                  return Pt.call(p, c) ? p[c] : n;
                }
                function Ul(c) {
                  var p = this.__data__;
                  return Uo ? p[c] !== n : Pt.call(p, c);
                }
                function Jn(c, p) {
                  var x = this.__data__;
                  return (
                    (this.size += this.has(c) ? 0 : 1),
                    (x[c] = Uo && p === n ? m : p),
                    this
                  );
                }
                ((Kr.prototype.clear = jp),
                  (Kr.prototype.delete = Bo),
                  (Kr.prototype.get = vd),
                  (Kr.prototype.has = Ul),
                  (Kr.prototype.set = Jn));
                function As(c) {
                  var p = -1,
                    x = c == null ? 0 : c.length;
                  for (this.clear(); ++p < x; ) {
                    var C = c[p];
                    this.set(C[0], C[1]);
                  }
                }
                function zv() {
                  ((this.__data__ = []), (this.size = 0));
                }
                function y1(c) {
                  var p = this.__data__,
                    x = Sr(p, c);
                  if (x < 0) return !1;
                  var C = p.length - 1;
                  return (x == C ? p.pop() : Vr.call(p, x, 1), --this.size, !0);
                }
                function b1(c) {
                  var p = this.__data__,
                    x = Sr(p, c);
                  return x < 0 ? n : p[x][1];
                }
                function x1(c) {
                  return Sr(this.__data__, c) > -1;
                }
                function In(c, p) {
                  var x = this.__data__,
                    C = Sr(x, c);
                  return (
                    C < 0 ? (++this.size, x.push([c, p])) : (x[C][1] = p),
                    this
                  );
                }
                ((As.prototype.clear = zv),
                  (As.prototype.delete = y1),
                  (As.prototype.get = b1),
                  (As.prototype.has = x1),
                  (As.prototype.set = In));
                function Ks(c) {
                  var p = -1,
                    x = c == null ? 0 : c.length;
                  for (this.clear(); ++p < x; ) {
                    var C = c[p];
                    this.set(C[0], C[1]);
                  }
                }
                function du() {
                  ((this.size = 0),
                    (this.__data__ = {
                      hash: new Kr(),
                      map: new (Ki || As)(),
                      string: new Kr(),
                    }));
                }
                function hu(c) {
                  var p = Au(this, c).delete(c);
                  return ((this.size -= p ? 1 : 0), p);
                }
                function Mp(c) {
                  return Au(this, c).get(c);
                }
                function Ho(c) {
                  return Au(this, c).has(c);
                }
                function Yo(c, p) {
                  var x = Au(this, c),
                    C = x.size;
                  return (
                    x.set(c, p),
                    (this.size += x.size == C ? 0 : 1),
                    this
                  );
                }
                ((Ks.prototype.clear = du),
                  (Ks.prototype.delete = hu),
                  (Ks.prototype.get = Mp),
                  (Ks.prototype.has = Ho),
                  (Ks.prototype.set = Yo));
                function Fl(c) {
                  var p = -1,
                    x = c == null ? 0 : c.length;
                  for (this.__data__ = new Ks(); ++p < x; ) this.add(c[p]);
                }
                function Pv(c) {
                  return (this.__data__.set(c, m), this);
                }
                function _1(c) {
                  return this.__data__.has(c);
                }
                ((Fl.prototype.add = Fl.prototype.push = Pv),
                  (Fl.prototype.has = _1));
                function Rs(c) {
                  var p = (this.__data__ = new As(c));
                  this.size = p.size;
                }
                function Bl() {
                  ((this.__data__ = new As()), (this.size = 0));
                }
                function Np(c) {
                  var p = this.__data__,
                    x = p.delete(c);
                  return ((this.size = p.size), x);
                }
                function yd(c) {
                  return this.__data__.get(c);
                }
                function Iv(c) {
                  return this.__data__.has(c);
                }
                function qo(c, p) {
                  var x = this.__data__;
                  if (x instanceof As) {
                    var C = x.__data__;
                    if (!Ki || C.length < a - 1)
                      return (C.push([c, p]), (this.size = ++x.size), this);
                    x = this.__data__ = new Ks(C);
                  }
                  return (x.set(c, p), (this.size = x.size), this);
                }
                ((Rs.prototype.clear = Bl),
                  (Rs.prototype.delete = Np),
                  (Rs.prototype.get = yd),
                  (Rs.prototype.has = Iv),
                  (Rs.prototype.set = qo));
                function bd(c, p) {
                  var x = tt(c),
                    C = !x && Xl(c),
                    L = !x && !C && Za(c),
                    z = !x && !C && !L && Ka(c),
                    q = x || C || L || z,
                    Q = q ? rd(c.length, Dl) : [],
                    ne = Q.length;
                  for (var we in c)
                    (p || Pt.call(c, we)) &&
                      !(
                        q &&
                        (we == "length" ||
                          (L && (we == "offset" || we == "parent")) ||
                          (z &&
                            (we == "buffer" ||
                              we == "byteLength" ||
                              we == "byteOffset")) ||
                          rr(we, ne))
                      ) &&
                      Q.push(we);
                  return Q;
                }
                function pu(c) {
                  var p = c.length;
                  return p ? c[Ko(0, p - 1)] : n;
                }
                function xd(c, p) {
                  return Uu(mi(c), er(p, 0, c.length));
                }
                function Uv(c) {
                  return Uu(mi(c));
                }
                function _d(c, p, x) {
                  ((x !== n && !ls(c[p], x)) || (x === n && !(p in c))) &&
                    Ji(c, p, x);
                }
                function Js(c, p, x) {
                  var C = c[p];
                  (!(Pt.call(c, p) && ls(C, x)) || (x === n && !(p in c))) &&
                    Ji(c, p, x);
                }
                function Sr(c, p) {
                  for (var x = c.length; x--; ) if (ls(c[x][0], p)) return x;
                  return -1;
                }
                function Fv(c, p, x, C) {
                  return (
                    Tr(c, function (L, z, q) {
                      p(C, L, x(L), q);
                    }),
                    C
                  );
                }
                function Ap(c, p) {
                  return c && zs(p, Vn(p), c);
                }
                function $o(c, p) {
                  return c && zs(p, Di(p), c);
                }
                function Ji(c, p, x) {
                  p == "__proto__" && Cs
                    ? Cs(c, p, {
                        configurable: !0,
                        enumerable: !0,
                        value: x,
                        writable: !0,
                      })
                    : (c[p] = x);
                }
                function Go(c, p) {
                  for (
                    var x = -1, C = p.length, L = oe(C), z = c == null;
                    ++x < C;

                  )
                    L[x] = z ? n : Ja(c, p[x]);
                  return L;
                }
                function er(c, p, x) {
                  return (
                    c === c &&
                      (x !== n && (c = c <= x ? c : x),
                      p !== n && (c = c >= p ? c : p)),
                    c
                  );
                }
                function pi(c, p, x, C, L, z) {
                  var q,
                    Q = p & y,
                    ne = p & w,
                    we = p & S;
                  if ((x && (q = L ? x(c, C, L, z) : x(c)), q !== n)) return q;
                  if (!dn(c)) return c;
                  var Se = tt(c);
                  if (Se) {
                    if (((q = iy(c)), !Q)) return mi(c, q);
                  } else {
                    var Ee = ti(c),
                      Ae = Ee == Bi || Ee == Cn;
                    if (Za(c)) return $p(c, Q);
                    if (Ee == Hi || Ee == le || (Ae && !L)) {
                      if (((q = ne || Ae ? {} : rm(c)), !Q))
                        return ne ? Kv(c, $o(q, c)) : Zv(c, Ap(q, c));
                    } else {
                      if (!Jt[Ee]) return L ? c : {};
                      q = sy(c, Ee, Q);
                    }
                  }
                  z || (z = new Rs());
                  var He = z.get(c);
                  if (He) return He;
                  (z.set(c, q),
                    tf(c)
                      ? c.forEach(function (Ke) {
                          q.add(pi(Ke, p, x, Ke, c, z));
                        })
                      : Fy(c) &&
                        c.forEach(function (Ke, St) {
                          q.set(St, pi(Ke, p, x, St, c, z));
                        }));
                  var Ze = we ? (ne ? sm : Ud) : ne ? Di : Vn,
                    ht = Se ? n : Ze(c);
                  return (
                    Wi(ht || c, function (Ke, St) {
                      (ht && ((St = Ke), (Ke = c[St])),
                        Js(q, St, pi(Ke, p, x, St, c, z)));
                    }),
                    q
                  );
                }
                function Bv(c) {
                  var p = Vn(c);
                  return function (x) {
                    return Ia(x, c, p);
                  };
                }
                function Ia(c, p, x) {
                  var C = x.length;
                  if (c == null) return !C;
                  for (c = Ht(c); C--; ) {
                    var L = x[C],
                      z = p[L],
                      q = c[L];
                    if ((q === n && !(L in c)) || !z(q)) return !1;
                  }
                  return !0;
                }
                function Rp(c, p, x) {
                  if (typeof c != "function") throw new Qi(u);
                  return Iu(function () {
                    c.apply(n, x);
                  }, p);
                }
                function Ls(c, p, x, C) {
                  var L = -1,
                    z = td,
                    q = !0,
                    Q = c.length,
                    ne = [],
                    we = p.length;
                  if (!Q) return ne;
                  (x && (p = cn(p, Xi(x))),
                    C
                      ? ((z = iu), (q = !1))
                      : p.length >= a && ((z = su), (q = !1), (p = new Fl(p))));
                  e: for (; ++L < Q; ) {
                    var Se = c[L],
                      Ee = x == null ? Se : x(Se);
                    if (((Se = C || Se !== 0 ? Se : 0), q && Ee === Ee)) {
                      for (var Ae = we; Ae--; ) if (p[Ae] === Ee) continue e;
                      ne.push(Se);
                    } else z(p, Ee, C) || ne.push(Se);
                  }
                  return ne;
                }
                var Tr = Xp(nr),
                  wd = Xp(Td, !0);
                function Ua(c, p) {
                  var x = !0;
                  return (
                    Tr(c, function (C, L, z) {
                      return ((x = !!p(C, L, z)), x);
                    }),
                    x
                  );
                }
                function tr(c, p, x) {
                  for (var C = -1, L = c.length; ++C < L; ) {
                    var z = c[C],
                      q = p(z);
                    if (q != null && (Q === n ? q === q && !Li(q) : x(q, Q)))
                      var Q = q,
                        ne = z;
                  }
                  return ne;
                }
                function mu(c, p, x, C) {
                  var L = c.length;
                  for (
                    x = Qe(x),
                      x < 0 && (x = -x > L ? 0 : L + x),
                      C = C === n || C > L ? L : Qe(C),
                      C < 0 && (C += L),
                      C = x > C ? 0 : qm(C);
                    x < C;

                  )
                    c[x++] = p;
                  return c;
                }
                function Sd(c, p) {
                  var x = [];
                  return (
                    Tr(c, function (C, L, z) {
                      p(C, L, z) && x.push(C);
                    }),
                    x
                  );
                }
                function Hn(c, p, x, C, L) {
                  var z = -1,
                    q = c.length;
                  for (x || (x = lm), L || (L = []); ++z < q; ) {
                    var Q = c[z];
                    p > 0 && x(Q)
                      ? p > 1
                        ? Hn(Q, p - 1, x, C, L)
                        : Aa(L, Q)
                      : C || (L[L.length] = Q);
                  }
                  return L;
                }
                var Hl = Qp(),
                  Vo = Qp(!0);
                function nr(c, p) {
                  return c && Hl(c, p, Vn);
                }
                function Td(c, p) {
                  return c && Vo(c, p, Vn);
                }
                function Jr(c, p) {
                  return Na(p, function (x) {
                    return os(c[x]);
                  });
                }
                function Er(c, p) {
                  p = is(p, c);
                  for (var x = 0, C = p.length; c != null && x < C; )
                    c = c[Oi(p[x++])];
                  return x && x == C ? c : n;
                }
                function Lp(c, p, x) {
                  var C = p(c);
                  return tt(c) ? C : Aa(C, x(c));
                }
                function ei(c) {
                  return c == null
                    ? c === n
                      ? Xn
                      : bl
                    : Wr && Wr in Ht(c)
                      ? Ru(c)
                      : cm(c);
                }
                function gu(c, p) {
                  return c > p;
                }
                function es(c, p) {
                  return c != null && Pt.call(c, p);
                }
                function Ds(c, p) {
                  return c != null && p in Ht(c);
                }
                function Fa(c, p, x) {
                  return c >= zn(p, x) && c < xn(p, x);
                }
                function vu(c, p, x) {
                  for (
                    var C = x ? iu : td,
                      L = c[0].length,
                      z = c.length,
                      q = z,
                      Q = oe(z),
                      ne = 1 / 0,
                      we = [];
                    q--;

                  ) {
                    var Se = c[q];
                    (q && p && (Se = cn(Se, Xi(p))),
                      (ne = zn(Se.length, ne)),
                      (Q[q] =
                        !x && (p || (L >= 120 && Se.length >= 120))
                          ? new Fl(q && Se)
                          : n));
                  }
                  Se = c[0];
                  var Ee = -1,
                    Ae = Q[0];
                  e: for (; ++Ee < L && we.length < ne; ) {
                    var He = Se[Ee],
                      Ze = p ? p(He) : He;
                    if (
                      ((He = x || He !== 0 ? He : 0),
                      !(Ae ? su(Ae, Ze) : C(we, Ze, x)))
                    ) {
                      for (q = z; --q; ) {
                        var ht = Q[q];
                        if (!(ht ? su(ht, Ze) : C(c[q], Ze, x))) continue e;
                      }
                      (Ae && Ae.push(Ze), we.push(He));
                    }
                  }
                  return we;
                }
                function Hv(c, p, x, C) {
                  return (
                    nr(c, function (L, z, q) {
                      p(C, x(L), z, q);
                    }),
                    C
                  );
                }
                function ks(c, p, x) {
                  ((p = is(p, c)), (c = zu(c, p)));
                  var C = c == null ? c : c[Oi(ln(p))];
                  return C == null ? n : Vi(C, c, x);
                }
                function Ei(c) {
                  return Sn(c) && ei(c) == le;
                }
                function jn(c) {
                  return Sn(c) && ei(c) == Qn;
                }
                function Ed(c) {
                  return Sn(c) && ei(c) == ot;
                }
                function ts(c, p, x, C, L) {
                  return c === p
                    ? !0
                    : c == null || p == null || (!Sn(c) && !Sn(p))
                      ? c !== c && p !== p
                      : st(c, p, x, C, ts, L);
                }
                function st(c, p, x, C, L, z) {
                  var q = tt(c),
                    Q = tt(p),
                    ne = q ? Re : ti(c),
                    we = Q ? Re : ti(p);
                  ((ne = ne == le ? Hi : ne), (we = we == le ? Hi : we));
                  var Se = ne == Hi,
                    Ee = we == Hi,
                    Ae = ne == we;
                  if (Ae && Za(c)) {
                    if (!Za(p)) return !1;
                    ((q = !0), (Se = !1));
                  }
                  if (Ae && !Se)
                    return (
                      z || (z = new Rs()),
                      q || Ka(c)
                        ? Mu(c, p, x, C, L, z)
                        : ny(c, p, ne, x, C, L, z)
                    );
                  if (!(x & T)) {
                    var He = Se && Pt.call(c, "__wrapped__"),
                      Ze = Ee && Pt.call(p, "__wrapped__");
                    if (He || Ze) {
                      var ht = He ? c.value() : c,
                        Ke = Ze ? p.value() : p;
                      return (z || (z = new Rs()), L(ht, Ke, x, C, z));
                    }
                  }
                  return Ae ? (z || (z = new Rs()), im(c, p, x, C, L, z)) : !1;
                }
                function Wt(c) {
                  return Sn(c) && ti(c) == Gt;
                }
                function _n(c, p, x, C) {
                  var L = x.length,
                    z = L,
                    q = !C;
                  if (c == null) return !z;
                  for (c = Ht(c); L--; ) {
                    var Q = x[L];
                    if (q && Q[2] ? Q[1] !== c[Q[0]] : !(Q[0] in c)) return !1;
                  }
                  for (; ++L < z; ) {
                    Q = x[L];
                    var ne = Q[0],
                      we = c[ne],
                      Se = Q[1];
                    if (q && Q[2]) {
                      if (we === n && !(ne in c)) return !1;
                    } else {
                      var Ee = new Rs();
                      if (C) var Ae = C(we, Se, ne, c, p, Ee);
                      if (!(Ae === n ? ts(Se, we, T | E, C, Ee) : Ae))
                        return !1;
                    }
                  }
                  return !0;
                }
                function yu(c) {
                  if (!dn(c) || ry(c)) return !1;
                  var p = os(c) ? Do : Bf;
                  return p.test(ci(c));
                }
                function Wo(c) {
                  return Sn(c) && ei(c) == xs;
                }
                function Yl(c) {
                  return Sn(c) && ti(c) == ai;
                }
                function Cd(c) {
                  return Sn(c) && ah(c.length) && !!Vt[ei(c)];
                }
                function Xo(c) {
                  return typeof c == "function"
                    ? c
                    : c == null
                      ? vi
                      : typeof c == "object"
                        ? tt(c)
                          ? Dp(c[0], c[1])
                          : jd(c)
                        : D(c);
                }
                function Ba(c) {
                  if (!ic(c)) return Io(c);
                  var p = [];
                  for (var x in Ht(c))
                    Pt.call(c, x) && x != "constructor" && p.push(x);
                  return p;
                }
                function w1(c) {
                  if (!dn(c)) return ta(c);
                  var p = ic(c),
                    x = [];
                  for (var C in c)
                    (C == "constructor" && (p || !Pt.call(c, C))) || x.push(C);
                  return x;
                }
                function fn(c, p) {
                  return c < p;
                }
                function Od(c, p) {
                  var x = -1,
                    C = Ri(c) ? oe(c.length) : [];
                  return (
                    Tr(c, function (L, z, q) {
                      C[++x] = p(L, z, q);
                    }),
                    C
                  );
                }
                function jd(c) {
                  var p = Fd(c);
                  return p.length == 1 && p[0][2]
                    ? $d(p[0][0], p[0][1])
                    : function (x) {
                        return x === c || _n(x, c, p);
                      };
                }
                function Dp(c, p) {
                  return Du(c) && Or(p)
                    ? $d(Oi(c), p)
                    : function (x) {
                        var C = Ja(x, c);
                        return C === n && C === p ? Gm(x, c) : ts(p, C, T | E);
                      };
                }
                function bu(c, p, x, C, L) {
                  c !== p &&
                    Hl(
                      p,
                      function (z, q) {
                        if ((L || (L = new Rs()), dn(z)))
                          S1(c, p, q, x, bu, C, L);
                        else {
                          var Q = C ? C(en(c, q), z, q + "", c, p, L) : n;
                          (Q === n && (Q = z), _d(c, q, Q));
                        }
                      },
                      Di,
                    );
                }
                function S1(c, p, x, C, L, z, q) {
                  var Q = en(c, x),
                    ne = en(p, x),
                    we = q.get(ne);
                  if (we) {
                    _d(c, x, we);
                    return;
                  }
                  var Se = z ? z(Q, ne, x + "", c, p, q) : n,
                    Ee = Se === n;
                  if (Ee) {
                    var Ae = tt(ne),
                      He = !Ae && Za(ne),
                      Ze = !Ae && !He && Ka(ne);
                    ((Se = ne),
                      Ae || He || Ze
                        ? tt(Q)
                          ? (Se = Q)
                          : Nn(Q)
                            ? (Se = mi(Q))
                            : He
                              ? ((Ee = !1), (Se = $p(ne, !0)))
                              : Ze
                                ? ((Ee = !1), (Se = Gp(ne, !0)))
                                : (Se = [])
                        : Ju(ne) || Xl(ne)
                          ? ((Se = Q),
                            Xl(Q)
                              ? (Se = lh(Q))
                              : (!dn(Q) || os(Q)) && (Se = rm(ne)))
                          : (Ee = !1));
                  }
                  (Ee && (q.set(ne, Se), L(Se, ne, C, z, q), q.delete(ne)),
                    _d(c, x, Se));
                }
                function Md(c, p) {
                  var x = c.length;
                  if (x) return ((p += p < 0 ? x : 0), rr(p, x) ? c[p] : n);
                }
                function Nd(c, p, x) {
                  p.length
                    ? (p = cn(p, function (z) {
                        return tt(z)
                          ? function (q) {
                              return Er(q, z.length === 1 ? z[0] : z);
                            }
                          : z;
                      }))
                    : (p = [vi]);
                  var C = -1;
                  p = cn(p, Xi(Ge()));
                  var L = Od(c, function (z, q, Q) {
                    var ne = cn(p, function (we) {
                      return we(z);
                    });
                    return { criteria: ne, index: ++C, value: z };
                  });
                  return Tv(L, function (z, q) {
                    return Qv(z, q, x);
                  });
                }
                function kp(c, p) {
                  return li(c, p, function (x, C) {
                    return Gm(c, C);
                  });
                }
                function li(c, p, x) {
                  for (var C = -1, L = p.length, z = {}; ++C < L; ) {
                    var q = p[C],
                      Q = Er(c, q);
                    x(Q, q) && Jo(z, is(q, c), Q);
                  }
                  return z;
                }
                function Mn(c) {
                  return function (p) {
                    return Er(p, c);
                  };
                }
                function Qo(c, p, x, C) {
                  var L = C ? h1 : Mo,
                    z = -1,
                    q = p.length,
                    Q = c;
                  for (
                    c === p && (p = mi(p)), x && (Q = cn(c, Xi(x)));
                    ++z < q;

                  )
                    for (
                      var ne = 0, we = p[z], Se = x ? x(we) : we;
                      (ne = L(Q, Se, ne, C)) > -1;

                    )
                      (Q !== c && Vr.call(Q, ne, 1), Vr.call(c, ne, 1));
                  return c;
                }
                function Zo(c, p) {
                  for (var x = c ? p.length : 0, C = x - 1; x--; ) {
                    var L = p[x];
                    if (x == C || L !== z) {
                      var z = L;
                      rr(L) ? Vr.call(c, L, 1) : xu(c, L);
                    }
                  }
                  return c;
                }
                function Ko(c, p) {
                  return c + cu(Xr() * (p - c + 1));
                }
                function zp(c, p, x, C) {
                  for (
                    var L = -1, z = xn(zo((p - c) / (x || 1)), 0), q = oe(z);
                    z--;

                  )
                    ((q[C ? z : ++L] = c), (c += x));
                  return q;
                }
                function ir(c, p) {
                  var x = "";
                  if (!c || p < 1 || p > de) return x;
                  do (p % 2 && (x += c), (p = cu(p / 2)), p && (c += c));
                  while (p);
                  return x;
                }
                function rt(c, p) {
                  return Gd(um(c, p, vi), c + "");
                }
                function Pp(c) {
                  return pu(vc(c));
                }
                function Ip(c, p) {
                  var x = vc(c);
                  return Uu(x, er(p, 0, x.length));
                }
                function Jo(c, p, x, C) {
                  if (!dn(c)) return c;
                  p = is(p, c);
                  for (
                    var L = -1, z = p.length, q = z - 1, Q = c;
                    Q != null && ++L < z;

                  ) {
                    var ne = Oi(p[L]),
                      we = x;
                    if (
                      ne === "__proto__" ||
                      ne === "constructor" ||
                      ne === "prototype"
                    )
                      return c;
                    if (L != q) {
                      var Se = Q[ne];
                      ((we = C ? C(Se, ne, Q) : n),
                        we === n &&
                          (we = dn(Se) ? Se : rr(p[L + 1]) ? [] : {}));
                    }
                    (Js(Q, ne, we), (Q = Q[ne]));
                  }
                  return c;
                }
                var Up = Pn
                    ? function (c, p) {
                        return (Pn.set(c, p), c);
                      }
                    : vi,
                  Yv = Cs
                    ? function (c, p) {
                        return Cs(c, "toString", {
                          configurable: !0,
                          enumerable: !1,
                          value: bc(p),
                          writable: !0,
                        });
                      }
                    : vi;
                function qv(c) {
                  return Uu(vc(c));
                }
                function ns(c, p, x) {
                  var C = -1,
                    L = c.length;
                  (p < 0 && (p = -p > L ? 0 : L + p),
                    (x = x > L ? L : x),
                    x < 0 && (x += L),
                    (L = p > x ? 0 : (x - p) >>> 0),
                    (p >>>= 0));
                  for (var z = oe(L); ++C < L; ) z[C] = c[C + p];
                  return z;
                }
                function $v(c, p) {
                  var x;
                  return (
                    Tr(c, function (C, L, z) {
                      return ((x = p(C, L, z)), !x);
                    }),
                    !!x
                  );
                }
                function ec(c, p, x) {
                  var C = 0,
                    L = c == null ? C : c.length;
                  if (typeof p == "number" && p === p && L <= xe) {
                    for (; C < L; ) {
                      var z = (C + L) >>> 1,
                        q = c[z];
                      q !== null && !Li(q) && (x ? q <= p : q < p)
                        ? (C = z + 1)
                        : (L = z);
                    }
                    return L;
                  }
                  return Ad(c, p, vi, x);
                }
                function Ad(c, p, x, C) {
                  var L = 0,
                    z = c == null ? 0 : c.length;
                  if (z === 0) return 0;
                  p = x(p);
                  for (
                    var q = p !== p, Q = p === null, ne = Li(p), we = p === n;
                    L < z;

                  ) {
                    var Se = cu((L + z) / 2),
                      Ee = x(c[Se]),
                      Ae = Ee !== n,
                      He = Ee === null,
                      Ze = Ee === Ee,
                      ht = Li(Ee);
                    if (q) var Ke = C || Ze;
                    else
                      we
                        ? (Ke = Ze && (C || Ae))
                        : Q
                          ? (Ke = Ze && Ae && (C || !He))
                          : ne
                            ? (Ke = Ze && Ae && !He && (C || !ht))
                            : He || ht
                              ? (Ke = !1)
                              : (Ke = C ? Ee <= p : Ee < p);
                    Ke ? (L = Se + 1) : (z = Se);
                  }
                  return zn(z, ae);
                }
                function Gv(c, p) {
                  for (var x = -1, C = c.length, L = 0, z = []; ++x < C; ) {
                    var q = c[x],
                      Q = p ? p(q) : q;
                    if (!x || !ls(Q, ne)) {
                      var ne = Q;
                      z[L++] = q === 0 ? 0 : q;
                    }
                  }
                  return z;
                }
                function Fp(c) {
                  return typeof c == "number" ? c : Li(c) ? Te : +c;
                }
                function Ci(c) {
                  if (typeof c == "string") return c;
                  if (tt(c)) return cn(c, Ci) + "";
                  if (Li(c)) return Il ? Il.call(c) : "";
                  var p = c + "";
                  return p == "0" && 1 / c == -pe ? "-0" : p;
                }
                function ea(c, p, x) {
                  var C = -1,
                    L = td,
                    z = c.length,
                    q = !0,
                    Q = [],
                    ne = Q;
                  if (x) ((q = !1), (L = iu));
                  else if (z >= a) {
                    var we = p ? null : ey(c);
                    if (we) return od(we);
                    ((q = !1), (L = su), (ne = new Fl()));
                  } else ne = p ? [] : Q;
                  e: for (; ++C < z; ) {
                    var Se = c[C],
                      Ee = p ? p(Se) : Se;
                    if (((Se = x || Se !== 0 ? Se : 0), q && Ee === Ee)) {
                      for (var Ae = ne.length; Ae--; )
                        if (ne[Ae] === Ee) continue e;
                      (p && ne.push(Ee), Q.push(Se));
                    } else
                      L(ne, Ee, x) || (ne !== Q && ne.push(Ee), Q.push(Se));
                  }
                  return Q;
                }
                function xu(c, p) {
                  return (
                    (p = is(p, c)),
                    (c = zu(c, p)),
                    c == null || delete c[Oi(ln(p))]
                  );
                }
                function Bp(c, p, x, C) {
                  return Jo(c, p, x(Er(c, p)), C);
                }
                function _u(c, p, x, C) {
                  for (
                    var L = c.length, z = C ? L : -1;
                    (C ? z-- : ++z < L) && p(c[z], z, c);

                  );
                  return x
                    ? ns(c, C ? 0 : z, C ? z + 1 : L)
                    : ns(c, C ? z + 1 : 0, C ? L : z);
                }
                function Hp(c, p) {
                  var x = c;
                  return (
                    x instanceof it && (x = x.value()),
                    mp(
                      p,
                      function (C, L) {
                        return L.func.apply(L.thisArg, Aa([C], L.args));
                      },
                      x,
                    )
                  );
                }
                function Rd(c, p, x) {
                  var C = c.length;
                  if (C < 2) return C ? ea(c[0]) : [];
                  for (var L = -1, z = oe(C); ++L < C; )
                    for (var q = c[L], Q = -1; ++Q < C; )
                      Q != L && (z[L] = Ls(z[L] || q, c[Q], p, x));
                  return ea(Hn(z, 1), p, x);
                }
                function Yp(c, p, x) {
                  for (
                    var C = -1, L = c.length, z = p.length, q = {};
                    ++C < L;

                  ) {
                    var Q = C < z ? p[C] : n;
                    x(q, c[C], Q);
                  }
                  return q;
                }
                function qp(c) {
                  return Nn(c) ? c : [];
                }
                function Ld(c) {
                  return typeof c == "function" ? c : vi;
                }
                function is(c, p) {
                  return tt(c) ? c : Du(c, p) ? [c] : fm(Ut(c));
                }
                var Vv = rt;
                function sr(c, p, x) {
                  var C = c.length;
                  return (
                    (x = x === n ? C : x),
                    !p && x >= C ? c : ns(c, p, x)
                  );
                }
                var wu =
                  Dv ||
                  function (c) {
                    return Bn.clearTimeout(c);
                  };
                function $p(c, p) {
                  if (p) return c.slice();
                  var x = c.length,
                    C = pd ? pd(x) : new c.constructor(x);
                  return (c.copy(C), C);
                }
                function Su(c) {
                  var p = new c.constructor(c.byteLength);
                  return (new kl(p).set(new kl(c)), p);
                }
                function T1(c, p) {
                  var x = p ? Su(c.buffer) : c.buffer;
                  return new c.constructor(x, c.byteOffset, c.byteLength);
                }
                function Wv(c) {
                  var p = new c.constructor(c.source, Cl.exec(c));
                  return ((p.lastIndex = c.lastIndex), p);
                }
                function Xv(c) {
                  return Fo ? Ht(Fo.call(c)) : {};
                }
                function Gp(c, p) {
                  var x = p ? Su(c.buffer) : c.buffer;
                  return new c.constructor(x, c.byteOffset, c.length);
                }
                function Vp(c, p) {
                  if (c !== p) {
                    var x = c !== n,
                      C = c === null,
                      L = c === c,
                      z = Li(c),
                      q = p !== n,
                      Q = p === null,
                      ne = p === p,
                      we = Li(p);
                    if (
                      (!Q && !we && !z && c > p) ||
                      (z && q && ne && !Q && !we) ||
                      (C && q && ne) ||
                      (!x && ne) ||
                      !L
                    )
                      return 1;
                    if (
                      (!C && !z && !we && c < p) ||
                      (we && x && L && !C && !z) ||
                      (Q && x && L) ||
                      (!q && L) ||
                      !ne
                    )
                      return -1;
                  }
                  return 0;
                }
                function Qv(c, p, x) {
                  for (
                    var C = -1,
                      L = c.criteria,
                      z = p.criteria,
                      q = L.length,
                      Q = x.length;
                    ++C < q;

                  ) {
                    var ne = Vp(L[C], z[C]);
                    if (ne) {
                      if (C >= Q) return ne;
                      var we = x[C];
                      return ne * (we == "desc" ? -1 : 1);
                    }
                  }
                  return c.index - p.index;
                }
                function Dd(c, p, x, C) {
                  for (
                    var L = -1,
                      z = c.length,
                      q = x.length,
                      Q = -1,
                      ne = p.length,
                      we = xn(z - q, 0),
                      Se = oe(ne + we),
                      Ee = !C;
                    ++Q < ne;

                  )
                    Se[Q] = p[Q];
                  for (; ++L < q; ) (Ee || L < z) && (Se[x[L]] = c[L]);
                  for (; we--; ) Se[Q++] = c[L++];
                  return Se;
                }
                function Wp(c, p, x, C) {
                  for (
                    var L = -1,
                      z = c.length,
                      q = -1,
                      Q = x.length,
                      ne = -1,
                      we = p.length,
                      Se = xn(z - Q, 0),
                      Ee = oe(Se + we),
                      Ae = !C;
                    ++L < Se;

                  )
                    Ee[L] = c[L];
                  for (var He = L; ++ne < we; ) Ee[He + ne] = p[ne];
                  for (; ++q < Q; ) (Ae || L < z) && (Ee[He + x[q]] = c[L++]);
                  return Ee;
                }
                function mi(c, p) {
                  var x = -1,
                    C = c.length;
                  for (p || (p = oe(C)); ++x < C; ) p[x] = c[x];
                  return p;
                }
                function zs(c, p, x, C) {
                  var L = !x;
                  x || (x = {});
                  for (var z = -1, q = p.length; ++z < q; ) {
                    var Q = p[z],
                      ne = C ? C(x[Q], c[Q], Q, x, c) : n;
                    (ne === n && (ne = c[Q]), L ? Ji(x, Q, ne) : Js(x, Q, ne));
                  }
                  return x;
                }
                function Zv(c, p) {
                  return zs(c, Bd(c), p);
                }
                function Kv(c, p) {
                  return zs(c, Lu(c), p);
                }
                function kd(c, p) {
                  return function (x, C) {
                    var L = tt(x) ? o1 : Fv,
                      z = p ? p() : {};
                    return L(x, c, Ge(C, 2), z);
                  };
                }
                function Ha(c) {
                  return rt(function (p, x) {
                    var C = -1,
                      L = x.length,
                      z = L > 1 ? x[L - 1] : n,
                      q = L > 2 ? x[2] : n;
                    for (
                      z = c.length > 3 && typeof z == "function" ? (L--, z) : n,
                        q &&
                          oi(x[0], x[1], q) &&
                          ((z = L < 3 ? n : z), (L = 1)),
                        p = Ht(p);
                      ++C < L;

                    ) {
                      var Q = x[C];
                      Q && c(p, Q, C, z);
                    }
                    return p;
                  });
                }
                function Xp(c, p) {
                  return function (x, C) {
                    if (x == null) return x;
                    if (!Ri(x)) return c(x, C);
                    for (
                      var L = x.length, z = p ? L : -1, q = Ht(x);
                      (p ? z-- : ++z < L) && C(q[z], z, q) !== !1;

                    );
                    return x;
                  };
                }
                function Qp(c) {
                  return function (p, x, C) {
                    for (var L = -1, z = Ht(p), q = C(p), Q = q.length; Q--; ) {
                      var ne = q[c ? Q : ++L];
                      if (x(z[ne], ne, z) === !1) break;
                    }
                    return p;
                  };
                }
                function Zp(c, p, x) {
                  var C = p & j,
                    L = Tu(c);
                  function z() {
                    var q = this && this !== Bn && this instanceof z ? L : c;
                    return q.apply(C ? x : this, arguments);
                  }
                  return z;
                }
                function Kp(c) {
                  return function (p) {
                    p = Ut(p);
                    var x = Ll(p) ? hn(p) : n,
                      C = x ? x[0] : p.charAt(0),
                      L = x ? sr(x, 1).join("") : p.slice(1);
                    return C[c]() + L;
                  };
                }
                function ql(c) {
                  return function (p) {
                    return mp(h0(yc(p).replace(dp, "")), c, "");
                  };
                }
                function Tu(c) {
                  return function () {
                    var p = arguments;
                    switch (p.length) {
                      case 0:
                        return new c();
                      case 1:
                        return new c(p[0]);
                      case 2:
                        return new c(p[0], p[1]);
                      case 3:
                        return new c(p[0], p[1], p[2]);
                      case 4:
                        return new c(p[0], p[1], p[2], p[3]);
                      case 5:
                        return new c(p[0], p[1], p[2], p[3], p[4]);
                      case 6:
                        return new c(p[0], p[1], p[2], p[3], p[4], p[5]);
                      case 7:
                        return new c(p[0], p[1], p[2], p[3], p[4], p[5], p[6]);
                    }
                    var x = ka(c.prototype),
                      C = c.apply(x, p);
                    return dn(C) ? C : x;
                  };
                }
                function E1(c, p, x) {
                  var C = Tu(c);
                  function L() {
                    for (
                      var z = arguments.length, q = oe(z), Q = z, ne = wn(L);
                      Q--;

                    )
                      q[Q] = arguments[Q];
                    var we =
                      z < 3 && q[0] !== ne && q[z - 1] !== ne ? [] : Gr(q, ne);
                    if (((z -= we.length), z < x))
                      return Id(c, p, nc, L.placeholder, n, q, we, n, n, x - z);
                    var Se = this && this !== Bn && this instanceof L ? C : c;
                    return Vi(Se, this, q);
                  }
                  return L;
                }
                function Jp(c) {
                  return function (p, x, C) {
                    var L = Ht(p);
                    if (!Ri(p)) {
                      var z = Ge(x, 3);
                      ((p = Vn(p)),
                        (x = function (Q) {
                          return z(L[Q], Q, L);
                        }));
                    }
                    var q = c(p, x, C);
                    return q > -1 ? L[z ? p[q] : q] : n;
                  };
                }
                function tc(c) {
                  return Cr(function (p) {
                    var x = p.length,
                      C = x,
                      L = Ti.prototype.thru;
                    for (c && p.reverse(); C--; ) {
                      var z = p[C];
                      if (typeof z != "function") throw new Qi(u);
                      if (L && !q && pn(z) == "wrapper") var q = new Ti([], !0);
                    }
                    for (C = q ? C : x; ++C < x; ) {
                      z = p[C];
                      var Q = pn(z),
                        ne = Q == "wrapper" ? Nu(z) : n;
                      ne &&
                      ku(ne[0]) &&
                      ne[1] == (Y | N | P | B) &&
                      !ne[4].length &&
                      ne[9] == 1
                        ? (q = q[pn(ne[0])].apply(q, ne[3]))
                        : (q = z.length == 1 && ku(z) ? q[Q]() : q.thru(z));
                    }
                    return function () {
                      var we = arguments,
                        Se = we[0];
                      if (q && we.length == 1 && tt(Se))
                        return q.plant(Se).value();
                      for (
                        var Ee = 0, Ae = x ? p[Ee].apply(this, we) : Se;
                        ++Ee < x;

                      )
                        Ae = p[Ee].call(this, Ae);
                      return Ae;
                    };
                  });
                }
                function nc(c, p, x, C, L, z, q, Q, ne, we) {
                  var Se = p & Y,
                    Ee = p & j,
                    Ae = p & O,
                    He = p & (N | R),
                    Ze = p & I,
                    ht = Ae ? n : Tu(c);
                  function Ke() {
                    for (
                      var St = arguments.length, jt = oe(St), cr = St;
                      cr--;

                    )
                      jt[cr] = arguments[cr];
                    if (He)
                      var us = wn(Ke),
                        ur = ru(jt, us);
                    if (
                      (C && (jt = Dd(jt, C, L, He)),
                      z && (jt = Wp(jt, z, q, He)),
                      (St -= ur),
                      He && St < we)
                    ) {
                      var qn = Gr(jt, us);
                      return Id(
                        c,
                        p,
                        nc,
                        Ke.placeholder,
                        x,
                        jt,
                        qn,
                        Q,
                        ne,
                        we - St,
                      );
                    }
                    var ua = Ee ? x : this,
                      Zl = Ae ? ua[c] : c;
                    return (
                      (St = jt.length),
                      Q ? (jt = Pu(jt, Q)) : Ze && St > 1 && jt.reverse(),
                      Se && ne < St && (jt.length = ne),
                      this &&
                        this !== Bn &&
                        this instanceof Ke &&
                        (Zl = ht || Tu(Zl)),
                      Zl.apply(ua, jt)
                    );
                  }
                  return Ke;
                }
                function Eu(c, p) {
                  return function (x, C) {
                    return Hv(x, c, p(C), {});
                  };
                }
                function Cu(c, p) {
                  return function (x, C) {
                    var L;
                    if (x === n && C === n) return p;
                    if ((x !== n && (L = x), C !== n)) {
                      if (L === n) return C;
                      (typeof x == "string" || typeof C == "string"
                        ? ((x = Ci(x)), (C = Ci(C)))
                        : ((x = Fp(x)), (C = Fp(C))),
                        (L = c(x, C)));
                    }
                    return L;
                  };
                }
                function zd(c) {
                  return Cr(function (p) {
                    return (
                      (p = cn(p, Xi(Ge()))),
                      rt(function (x) {
                        var C = this;
                        return c(p, function (L) {
                          return Vi(L, C, x);
                        });
                      })
                    );
                  });
                }
                function Ya(c, p) {
                  p = p === n ? " " : Ci(p);
                  var x = p.length;
                  if (x < 2) return x ? ir(p, c) : p;
                  var C = ir(p, zo(c / No(p)));
                  return Ll(p) ? sr(hn(C), 0, c).join("") : C.slice(0, c);
                }
                function Jv(c, p, x, C) {
                  var L = p & j,
                    z = Tu(c);
                  function q() {
                    for (
                      var Q = -1,
                        ne = arguments.length,
                        we = -1,
                        Se = C.length,
                        Ee = oe(Se + ne),
                        Ae = this && this !== Bn && this instanceof q ? z : c;
                      ++we < Se;

                    )
                      Ee[we] = C[we];
                    for (; ne--; ) Ee[we++] = arguments[++Q];
                    return Vi(Ae, L ? x : this, Ee);
                  }
                  return q;
                }
                function Pd(c) {
                  return function (p, x, C) {
                    return (
                      C && typeof C != "number" && oi(p, x, C) && (x = C = n),
                      (p = oa(p)),
                      x === n ? ((x = p), (p = 0)) : (x = oa(x)),
                      (C = C === n ? (p < x ? 1 : -1) : oa(C)),
                      zp(p, x, C, c)
                    );
                  };
                }
                function Ou(c) {
                  return function (p, x) {
                    return (
                      (typeof p == "string" && typeof x == "string") ||
                        ((p = cs(p)), (x = cs(x))),
                      c(p, x)
                    );
                  };
                }
                function Id(c, p, x, C, L, z, q, Q, ne, we) {
                  var Se = p & N,
                    Ee = Se ? q : n,
                    Ae = Se ? n : q,
                    He = Se ? z : n,
                    Ze = Se ? n : z;
                  ((p |= Se ? P : G), (p &= ~(Se ? G : P)), p & M || (p &= -4));
                  var ht = [c, p, L, He, Ee, Ze, Ae, Q, ne, we],
                    Ke = x.apply(n, ht);
                  return (
                    ku(c) && ly(Ke, ht),
                    (Ke.placeholder = C),
                    sc(Ke, c, p)
                  );
                }
                function ju(c) {
                  var p = un[c];
                  return function (x, C) {
                    if (
                      ((x = cs(x)),
                      (C = C == null ? 0 : zn(Qe(C), 292)),
                      C && Zi(x))
                    ) {
                      var L = (Ut(x) + "e").split("e"),
                        z = p(L[0] + "e" + (+L[1] + C));
                      return (
                        (L = (Ut(z) + "e").split("e")),
                        +(L[0] + "e" + (+L[1] - C))
                      );
                    }
                    return p(x);
                  };
                }
                var ey =
                  Ra && 1 / od(new Ra([, -0]))[1] == pe
                    ? function (c) {
                        return new Ra(c);
                      }
                    : o;
                function em(c) {
                  return function (p) {
                    var x = ti(p);
                    return x == Gt ? ld(p) : x == ai ? m1(p) : Ev(p, c(p));
                  };
                }
                function gi(c, p, x, C, L, z, q, Q) {
                  var ne = p & O;
                  if (!ne && typeof c != "function") throw new Qi(u);
                  var we = C ? C.length : 0;
                  if (
                    (we || ((p &= -97), (C = L = n)),
                    (q = q === n ? q : xn(Qe(q), 0)),
                    (Q = Q === n ? Q : Qe(Q)),
                    (we -= L ? L.length : 0),
                    p & G)
                  ) {
                    var Se = C,
                      Ee = L;
                    C = L = n;
                  }
                  var Ae = ne ? n : Nu(c),
                    He = [c, p, x, C, L, Se, Ee, z, q, Q];
                  if (
                    (Ae && ay(He, Ae),
                    (c = He[0]),
                    (p = He[1]),
                    (x = He[2]),
                    (C = He[3]),
                    (L = He[4]),
                    (Q = He[9] =
                      He[9] === n ? (ne ? 0 : c.length) : xn(He[9] - we, 0)),
                    !Q && p & (N | R) && (p &= -25),
                    !p || p == j)
                  )
                    var Ze = Zp(c, p, x);
                  else
                    p == N || p == R
                      ? (Ze = E1(c, p, Q))
                      : (p == P || p == (j | P)) && !L.length
                        ? (Ze = Jv(c, p, x, C))
                        : (Ze = nc.apply(n, He));
                  var ht = Ae ? Up : ly;
                  return sc(ht(Ze, He), c, p);
                }
                function tm(c, p, x, C) {
                  return c === n || (ls(c, Lo[x]) && !Pt.call(C, x)) ? p : c;
                }
                function nm(c, p, x, C, L, z) {
                  return (
                    dn(c) &&
                      dn(p) &&
                      (z.set(p, c), bu(c, p, n, nm, z), z.delete(p)),
                    c
                  );
                }
                function ty(c) {
                  return Ju(c) ? n : c;
                }
                function Mu(c, p, x, C, L, z) {
                  var q = x & T,
                    Q = c.length,
                    ne = p.length;
                  if (Q != ne && !(q && ne > Q)) return !1;
                  var we = z.get(c),
                    Se = z.get(p);
                  if (we && Se) return we == p && Se == c;
                  var Ee = -1,
                    Ae = !0,
                    He = x & E ? new Fl() : n;
                  for (z.set(c, p), z.set(p, c); ++Ee < Q; ) {
                    var Ze = c[Ee],
                      ht = p[Ee];
                    if (C)
                      var Ke = q
                        ? C(ht, Ze, Ee, p, c, z)
                        : C(Ze, ht, Ee, c, p, z);
                    if (Ke !== n) {
                      if (Ke) continue;
                      Ae = !1;
                      break;
                    }
                    if (He) {
                      if (
                        !gp(p, function (St, jt) {
                          if (!su(He, jt) && (Ze === St || L(Ze, St, x, C, z)))
                            return He.push(jt);
                        })
                      ) {
                        Ae = !1;
                        break;
                      }
                    } else if (!(Ze === ht || L(Ze, ht, x, C, z))) {
                      Ae = !1;
                      break;
                    }
                  }
                  return (z.delete(c), z.delete(p), Ae);
                }
                function ny(c, p, x, C, L, z, q) {
                  switch (x) {
                    case Yi:
                      if (
                        c.byteLength != p.byteLength ||
                        c.byteOffset != p.byteOffset
                      )
                        return !1;
                      ((c = c.buffer), (p = p.buffer));
                    case Qn:
                      return !(
                        c.byteLength != p.byteLength || !z(new kl(c), new kl(p))
                      );
                    case ut:
                    case ot:
                    case An:
                      return ls(+c, +p);
                    case ri:
                      return c.name == p.name && c.message == p.message;
                    case xs:
                    case Oa:
                      return c == p + "";
                    case Gt:
                      var Q = ld;
                    case ai:
                      var ne = C & T;
                      if ((Q || (Q = od), c.size != p.size && !ne)) return !1;
                      var we = q.get(c);
                      if (we) return we == p;
                      ((C |= E), q.set(c, p));
                      var Se = Mu(Q(c), Q(p), C, L, z, q);
                      return (q.delete(c), Se);
                    case wo:
                      if (Fo) return Fo.call(c) == Fo.call(p);
                  }
                  return !1;
                }
                function im(c, p, x, C, L, z) {
                  var q = x & T,
                    Q = Ud(c),
                    ne = Q.length,
                    we = Ud(p),
                    Se = we.length;
                  if (ne != Se && !q) return !1;
                  for (var Ee = ne; Ee--; ) {
                    var Ae = Q[Ee];
                    if (!(q ? Ae in p : Pt.call(p, Ae))) return !1;
                  }
                  var He = z.get(c),
                    Ze = z.get(p);
                  if (He && Ze) return He == p && Ze == c;
                  var ht = !0;
                  (z.set(c, p), z.set(p, c));
                  for (var Ke = q; ++Ee < ne; ) {
                    Ae = Q[Ee];
                    var St = c[Ae],
                      jt = p[Ae];
                    if (C)
                      var cr = q
                        ? C(jt, St, Ae, p, c, z)
                        : C(St, jt, Ae, c, p, z);
                    if (!(cr === n ? St === jt || L(St, jt, x, C, z) : cr)) {
                      ht = !1;
                      break;
                    }
                    Ke || (Ke = Ae == "constructor");
                  }
                  if (ht && !Ke) {
                    var us = c.constructor,
                      ur = p.constructor;
                    us != ur &&
                      "constructor" in c &&
                      "constructor" in p &&
                      !(
                        typeof us == "function" &&
                        us instanceof us &&
                        typeof ur == "function" &&
                        ur instanceof ur
                      ) &&
                      (ht = !1);
                  }
                  return (z.delete(c), z.delete(p), ht);
                }
                function Cr(c) {
                  return Gd(um(c, n, an), c + "");
                }
                function Ud(c) {
                  return Lp(c, Vn, Bd);
                }
                function sm(c) {
                  return Lp(c, Di, Lu);
                }
                var Nu = Pn
                  ? function (c) {
                      return Pn.get(c);
                    }
                  : o;
                function pn(c) {
                  for (
                    var p = c.name + "",
                      x = It[p],
                      C = Pt.call(It, p) ? x.length : 0;
                    C--;

                  ) {
                    var L = x[C],
                      z = L.func;
                    if (z == null || z == c) return L.name;
                  }
                  return p;
                }
                function wn(c) {
                  var p = Pt.call(k, "placeholder") ? k : c;
                  return p.placeholder;
                }
                function Ge() {
                  var c = k.iteratee || of;
                  return (
                    (c = c === of ? Xo : c),
                    arguments.length ? c(arguments[0], arguments[1]) : c
                  );
                }
                function Au(c, p) {
                  var x = c.__data__;
                  return qd(p)
                    ? x[typeof p == "string" ? "string" : "hash"]
                    : x.map;
                }
                function Fd(c) {
                  for (var p = Vn(c), x = p.length; x--; ) {
                    var C = p[x],
                      L = c[C];
                    p[x] = [C, L, Or(L)];
                  }
                  return p;
                }
                function qa(c, p) {
                  var x = Cv(c, p);
                  return yu(x) ? x : n;
                }
                function Ru(c) {
                  var p = Pt.call(c, Wr),
                    x = c[Wr];
                  try {
                    c[Wr] = n;
                    var C = !0;
                  } catch {}
                  var L = Si.call(c);
                  return (C && (p ? (c[Wr] = x) : delete c[Wr]), L);
                }
                var Bd = uu
                    ? function (c) {
                        return c == null
                          ? []
                          : ((c = Ht(c)),
                            Na(uu(c), function (p) {
                              return ou.call(c, p);
                            }));
                      }
                    : _e,
                  Lu = uu
                    ? function (c) {
                        for (var p = []; c; ) (Aa(p, Bd(c)), (c = _r(c)));
                        return p;
                      }
                    : _e,
                  ti = ei;
                ((Ms && ti(new Ms(new ArrayBuffer(1))) != Yi) ||
                  (Ki && ti(new Ki()) != Gt) ||
                  (gd && ti(gd.resolve()) != vr) ||
                  (Ra && ti(new Ra()) != ai) ||
                  (Pl && ti(new Pl()) != Gs)) &&
                  (ti = function (c) {
                    var p = ei(c),
                      x = p == Hi ? c.constructor : n,
                      C = x ? ci(x) : "";
                    if (C)
                      switch (C) {
                        case wt:
                          return Yi;
                        case La:
                          return Gt;
                        case Ns:
                          return vr;
                        case Op:
                          return ai;
                        case Da:
                          return Gs;
                      }
                    return p;
                  });
                function C1(c, p, x) {
                  for (var C = -1, L = x.length; ++C < L; ) {
                    var z = x[C],
                      q = z.size;
                    switch (z.type) {
                      case "drop":
                        c += q;
                        break;
                      case "dropRight":
                        p -= q;
                        break;
                      case "take":
                        p = zn(p, c + q);
                        break;
                      case "takeRight":
                        c = xn(c, p - q);
                        break;
                    }
                  }
                  return { start: c, end: p };
                }
                function Hd(c) {
                  var p = c.match(Gc);
                  return p ? p[1].split(Vc) : [];
                }
                function Yd(c, p, x) {
                  p = is(p, c);
                  for (var C = -1, L = p.length, z = !1; ++C < L; ) {
                    var q = Oi(p[C]);
                    if (!(z = c != null && x(c, q))) break;
                    c = c[q];
                  }
                  return z || ++C != L
                    ? z
                    : ((L = c == null ? 0 : c.length),
                      !!L && ah(L) && rr(q, L) && (tt(c) || Xl(c)));
                }
                function iy(c) {
                  var p = c.length,
                    x = new c.constructor(p);
                  return (
                    p &&
                      typeof c[0] == "string" &&
                      Pt.call(c, "index") &&
                      ((x.index = c.index), (x.input = c.input)),
                    x
                  );
                }
                function rm(c) {
                  return typeof c.constructor == "function" && !ic(c)
                    ? ka(_r(c))
                    : {};
                }
                function sy(c, p, x) {
                  var C = c.constructor;
                  switch (p) {
                    case Qn:
                      return Su(c);
                    case ut:
                    case ot:
                      return new C(+c);
                    case Yi:
                      return T1(c, x);
                    case So:
                    case xl:
                    case _l:
                    case To:
                    case _s:
                    case Rn:
                    case Ln:
                    case bn:
                    case wl:
                      return Gp(c, x);
                    case Gt:
                      return new C();
                    case An:
                    case Oa:
                      return new C(c);
                    case xs:
                      return Wv(c);
                    case ai:
                      return new C();
                    case wo:
                      return Xv(c);
                  }
                }
                function am(c, p) {
                  var x = p.length;
                  if (!x) return c;
                  var C = x - 1;
                  return (
                    (p[C] = (x > 1 ? "& " : "") + p[C]),
                    (p = p.join(x > 2 ? ", " : " ")),
                    c.replace(
                      Vs,
                      `{
/* [wrapped with ` +
                        p +
                        `] */
`,
                    )
                  );
                }
                function lm(c) {
                  return tt(c) || Xl(c) || !!(Lv && c && c[Lv]);
                }
                function rr(c, p) {
                  var x = typeof c;
                  return (
                    (p = p ?? de),
                    !!p &&
                      (x == "number" || (x != "symbol" && Z.test(c))) &&
                      c > -1 &&
                      c % 1 == 0 &&
                      c < p
                  );
                }
                function oi(c, p, x) {
                  if (!dn(x)) return !1;
                  var C = typeof p;
                  return (
                    C == "number"
                      ? Ri(x) && rr(p, x.length)
                      : C == "string" && p in x
                  )
                    ? ls(x[p], c)
                    : !1;
                }
                function Du(c, p) {
                  if (tt(c)) return !1;
                  var x = typeof c;
                  return x == "number" ||
                    x == "symbol" ||
                    x == "boolean" ||
                    c == null ||
                    Li(c)
                    ? !0
                    : ja.test(c) || !Yc.test(c) || (p != null && c in Ht(p));
                }
                function qd(c) {
                  var p = typeof c;
                  return p == "string" ||
                    p == "number" ||
                    p == "symbol" ||
                    p == "boolean"
                    ? c !== "__proto__"
                    : c === null;
                }
                function ku(c) {
                  var p = pn(c),
                    x = k[p];
                  if (typeof x != "function" || !(p in it.prototype)) return !1;
                  if (c === x) return !0;
                  var C = Nu(x);
                  return !!C && c === C[0];
                }
                function ry(c) {
                  return !!dd && dd in c;
                }
                var om = ud ? os : re;
                function ic(c) {
                  var p = c && c.constructor,
                    x = (typeof p == "function" && p.prototype) || Lo;
                  return c === x;
                }
                function Or(c) {
                  return c === c && !dn(c);
                }
                function $d(c, p) {
                  return function (x) {
                    return x == null
                      ? !1
                      : x[c] === p && (p !== n || c in Ht(x));
                  };
                }
                function O1(c) {
                  var p = Xu(c, function (C) {
                      return (x.size === g && x.clear(), C);
                    }),
                    x = p.cache;
                  return p;
                }
                function ay(c, p) {
                  var x = c[1],
                    C = p[1],
                    L = x | C,
                    z = L < (j | O | Y),
                    q =
                      (C == Y && x == N) ||
                      (C == Y && x == B && c[7].length <= p[8]) ||
                      (C == (Y | B) && p[7].length <= p[8] && x == N);
                  if (!(z || q)) return c;
                  C & j && ((c[2] = p[2]), (L |= x & j ? 0 : M));
                  var Q = p[3];
                  if (Q) {
                    var ne = c[3];
                    ((c[3] = ne ? Dd(ne, Q, p[4]) : Q),
                      (c[4] = ne ? Gr(c[3], v) : p[4]));
                  }
                  return (
                    (Q = p[5]),
                    Q &&
                      ((ne = c[5]),
                      (c[5] = ne ? Wp(ne, Q, p[6]) : Q),
                      (c[6] = ne ? Gr(c[5], v) : p[6])),
                    (Q = p[7]),
                    Q && (c[7] = Q),
                    C & Y && (c[8] = c[8] == null ? p[8] : zn(c[8], p[8])),
                    c[9] == null && (c[9] = p[9]),
                    (c[0] = p[0]),
                    (c[1] = L),
                    c
                  );
                }
                function ta(c) {
                  var p = [];
                  if (c != null) for (var x in Ht(c)) p.push(x);
                  return p;
                }
                function cm(c) {
                  return Si.call(c);
                }
                function um(c, p, x) {
                  return (
                    (p = xn(p === n ? c.length - 1 : p, 0)),
                    function () {
                      for (
                        var C = arguments,
                          L = -1,
                          z = xn(C.length - p, 0),
                          q = oe(z);
                        ++L < z;

                      )
                        q[L] = C[p + L];
                      L = -1;
                      for (var Q = oe(p + 1); ++L < p; ) Q[L] = C[L];
                      return ((Q[p] = x(q)), Vi(c, this, Q));
                    }
                  );
                }
                function zu(c, p) {
                  return p.length < 2 ? c : Er(c, ns(p, 0, -1));
                }
                function Pu(c, p) {
                  for (
                    var x = c.length, C = zn(p.length, x), L = mi(c);
                    C--;

                  ) {
                    var z = p[C];
                    c[C] = rr(z, x) ? L[z] : n;
                  }
                  return c;
                }
                function en(c, p) {
                  if (
                    !(p === "constructor" && typeof c[p] == "function") &&
                    p != "__proto__"
                  )
                    return c[p];
                }
                var ly = na(Up),
                  Iu =
                    zl ||
                    function (c, p) {
                      return Bn.setTimeout(c, p);
                    },
                  Gd = na(Yv);
                function sc(c, p, x) {
                  var C = p + "";
                  return Gd(c, am(C, oy(Hd(C), x)));
                }
                function na(c) {
                  var p = 0,
                    x = 0;
                  return function () {
                    var C = Os(),
                      L = ve - (C - x);
                    if (((x = C), L > 0)) {
                      if (++p >= fe) return arguments[0];
                    } else p = 0;
                    return c.apply(n, arguments);
                  };
                }
                function Uu(c, p) {
                  var x = -1,
                    C = c.length,
                    L = C - 1;
                  for (p = p === n ? C : p; ++x < p; ) {
                    var z = Ko(x, L),
                      q = c[z];
                    ((c[z] = c[x]), (c[x] = q));
                  }
                  return ((c.length = p), c);
                }
                var fm = O1(function (c) {
                  var p = [];
                  return (
                    c.charCodeAt(0) === 46 && p.push(""),
                    c.replace(qc, function (x, C, L, z) {
                      p.push(L ? z.replace(on, "$1") : C || x);
                    }),
                    p
                  );
                });
                function Oi(c) {
                  if (typeof c == "string" || Li(c)) return c;
                  var p = c + "";
                  return p == "0" && 1 / c == -pe ? "-0" : p;
                }
                function ci(c) {
                  if (c != null) {
                    try {
                      return fd.call(c);
                    } catch {}
                    try {
                      return c + "";
                    } catch {}
                  }
                  return "";
                }
                function oy(c, p) {
                  return (
                    Wi(Me, function (x) {
                      var C = "_." + x[0];
                      p & x[1] && !td(c, C) && c.push(C);
                    }),
                    c.sort()
                  );
                }
                function Vd(c) {
                  if (c instanceof it) return c.clone();
                  var p = new Ti(c.__wrapped__, c.__chain__);
                  return (
                    (p.__actions__ = mi(c.__actions__)),
                    (p.__index__ = c.__index__),
                    (p.__values__ = c.__values__),
                    p
                  );
                }
                function cy(c, p, x) {
                  (x ? oi(c, p, x) : p === n) ? (p = 1) : (p = xn(Qe(p), 0));
                  var C = c == null ? 0 : c.length;
                  if (!C || p < 1) return [];
                  for (var L = 0, z = 0, q = oe(zo(C / p)); L < C; )
                    q[z++] = ns(c, L, (L += p));
                  return q;
                }
                function dm(c) {
                  for (
                    var p = -1, x = c == null ? 0 : c.length, C = 0, L = [];
                    ++p < x;

                  ) {
                    var z = c[p];
                    z && (L[C++] = z);
                  }
                  return L;
                }
                function hm() {
                  var c = arguments.length;
                  if (!c) return [];
                  for (var p = oe(c - 1), x = arguments[0], C = c; C--; )
                    p[C - 1] = arguments[C];
                  return Aa(tt(x) ? mi(x) : [x], Hn(p, 1));
                }
                var Wd = rt(function (c, p) {
                    return Nn(c) ? Ls(c, Hn(p, 1, Nn, !0)) : [];
                  }),
                  uy = rt(function (c, p) {
                    var x = ln(p);
                    return (
                      Nn(x) && (x = n),
                      Nn(c) ? Ls(c, Hn(p, 1, Nn, !0), Ge(x, 2)) : []
                    );
                  }),
                  ia = rt(function (c, p) {
                    var x = ln(p);
                    return (
                      Nn(x) && (x = n),
                      Nn(c) ? Ls(c, Hn(p, 1, Nn, !0), n, x) : []
                    );
                  });
                function Un(c, p, x) {
                  var C = c == null ? 0 : c.length;
                  return C
                    ? ((p = x || p === n ? 1 : Qe(p)), ns(c, p < 0 ? 0 : p, C))
                    : [];
                }
                function pm(c, p, x) {
                  var C = c == null ? 0 : c.length;
                  return C
                    ? ((p = x || p === n ? 1 : Qe(p)),
                      (p = C - p),
                      ns(c, 0, p < 0 ? 0 : p))
                    : [];
                }
                function fy(c, p) {
                  return c && c.length ? _u(c, Ge(p, 3), !0, !0) : [];
                }
                function Gn(c, p) {
                  return c && c.length ? _u(c, Ge(p, 3), !0) : [];
                }
                function j1(c, p, x, C) {
                  var L = c == null ? 0 : c.length;
                  return L
                    ? (x &&
                        typeof x != "number" &&
                        oi(c, p, x) &&
                        ((x = 0), (C = L)),
                      mu(c, p, x, C))
                    : [];
                }
                function mm(c, p, x) {
                  var C = c == null ? 0 : c.length;
                  if (!C) return -1;
                  var L = x == null ? 0 : Qe(x);
                  return (L < 0 && (L = xn(C + L, 0)), nd(c, Ge(p, 3), L));
                }
                function gm(c, p, x) {
                  var C = c == null ? 0 : c.length;
                  if (!C) return -1;
                  var L = C - 1;
                  return (
                    x !== n &&
                      ((L = Qe(x)), (L = x < 0 ? xn(C + L, 0) : zn(L, C - 1))),
                    nd(c, Ge(p, 3), L, !0)
                  );
                }
                function an(c) {
                  var p = c == null ? 0 : c.length;
                  return p ? Hn(c, 1) : [];
                }
                function ji(c) {
                  var p = c == null ? 0 : c.length;
                  return p ? Hn(c, pe) : [];
                }
                function sa(c, p) {
                  var x = c == null ? 0 : c.length;
                  return x ? ((p = p === n ? 1 : Qe(p)), Hn(c, p)) : [];
                }
                function dy(c) {
                  for (
                    var p = -1, x = c == null ? 0 : c.length, C = {};
                    ++p < x;

                  ) {
                    var L = c[p];
                    C[L[0]] = L[1];
                  }
                  return C;
                }
                function vm(c) {
                  return c && c.length ? c[0] : n;
                }
                function hy(c, p, x) {
                  var C = c == null ? 0 : c.length;
                  if (!C) return -1;
                  var L = x == null ? 0 : Qe(x);
                  return (L < 0 && (L = xn(C + L, 0)), Mo(c, p, L));
                }
                function M1(c) {
                  var p = c == null ? 0 : c.length;
                  return p ? ns(c, 0, -1) : [];
                }
                var Xd = rt(function (c) {
                    var p = cn(c, qp);
                    return p.length && p[0] === c[0] ? vu(p) : [];
                  }),
                  Mi = rt(function (c) {
                    var p = ln(c),
                      x = cn(c, qp);
                    return (
                      p === ln(x) ? (p = n) : x.pop(),
                      x.length && x[0] === c[0] ? vu(x, Ge(p, 2)) : []
                    );
                  }),
                  ar = rt(function (c) {
                    var p = ln(c),
                      x = cn(c, qp);
                    return (
                      (p = typeof p == "function" ? p : n),
                      p && x.pop(),
                      x.length && x[0] === c[0] ? vu(x, n, p) : []
                    );
                  });
                function py(c, p) {
                  return c == null ? "" : Po.call(c, p);
                }
                function ln(c) {
                  var p = c == null ? 0 : c.length;
                  return p ? c[p - 1] : n;
                }
                function my(c, p, x) {
                  var C = c == null ? 0 : c.length;
                  if (!C) return -1;
                  var L = C;
                  return (
                    x !== n &&
                      ((L = Qe(x)), (L = L < 0 ? xn(C + L, 0) : zn(L, C - 1))),
                    p === p ? v1(c, p, L) : nd(c, Sv, L, !0)
                  );
                }
                function ra(c, p) {
                  return c && c.length ? Md(c, Qe(p)) : n;
                }
                var $l = rt(jr);
                function jr(c, p) {
                  return c && c.length && p && p.length ? Qo(c, p) : c;
                }
                function ym(c, p, x) {
                  return c && c.length && p && p.length
                    ? Qo(c, p, Ge(x, 2))
                    : c;
                }
                function bm(c, p, x) {
                  return c && c.length && p && p.length ? Qo(c, p, n, x) : c;
                }
                var lr = Cr(function (c, p) {
                  var x = c == null ? 0 : c.length,
                    C = Go(c, p);
                  return (
                    Zo(
                      c,
                      cn(p, function (L) {
                        return rr(L, x) ? +L : L;
                      }).sort(Vp),
                    ),
                    C
                  );
                });
                function gy(c, p) {
                  var x = [];
                  if (!(c && c.length)) return x;
                  var C = -1,
                    L = [],
                    z = c.length;
                  for (p = Ge(p, 3); ++C < z; ) {
                    var q = c[C];
                    p(q, C, c) && (x.push(q), L.push(C));
                  }
                  return (Zo(c, L), x);
                }
                function $a(c) {
                  return c == null ? c : wr.call(c);
                }
                function Fu(c, p, x) {
                  var C = c == null ? 0 : c.length;
                  return C
                    ? (x && typeof x != "number" && oi(c, p, x)
                        ? ((p = 0), (x = C))
                        : ((p = p == null ? 0 : Qe(p)),
                          (x = x === n ? C : Qe(x))),
                      ns(c, p, x))
                    : [];
                }
                function Bu(c, p) {
                  return ec(c, p);
                }
                function rc(c, p, x) {
                  return Ad(c, p, Ge(x, 2));
                }
                function vy(c, p) {
                  var x = c == null ? 0 : c.length;
                  if (x) {
                    var C = ec(c, p);
                    if (C < x && ls(c[C], p)) return C;
                  }
                  return -1;
                }
                function yy(c, p) {
                  return ec(c, p, !0);
                }
                function Hu(c, p, x) {
                  return Ad(c, p, Ge(x, 2), !0);
                }
                function by(c, p) {
                  var x = c == null ? 0 : c.length;
                  if (x) {
                    var C = ec(c, p, !0) - 1;
                    if (ls(c[C], p)) return C;
                  }
                  return -1;
                }
                function Qd(c) {
                  return c && c.length ? Gv(c) : [];
                }
                function xy(c, p) {
                  return c && c.length ? Gv(c, Ge(p, 2)) : [];
                }
                function N1(c) {
                  var p = c == null ? 0 : c.length;
                  return p ? ns(c, 1, p) : [];
                }
                function A1(c, p, x) {
                  return c && c.length
                    ? ((p = x || p === n ? 1 : Qe(p)), ns(c, 0, p < 0 ? 0 : p))
                    : [];
                }
                function kt(c, p, x) {
                  var C = c == null ? 0 : c.length;
                  return C
                    ? ((p = x || p === n ? 1 : Qe(p)),
                      (p = C - p),
                      ns(c, p < 0 ? 0 : p, C))
                    : [];
                }
                function tn(c, p) {
                  return c && c.length ? _u(c, Ge(p, 3), !1, !0) : [];
                }
                function mt(c, p) {
                  return c && c.length ? _u(c, Ge(p, 3)) : [];
                }
                var vt = rt(function (c) {
                    return ea(Hn(c, 1, Nn, !0));
                  }),
                  Yt = rt(function (c) {
                    var p = ln(c);
                    return (Nn(p) && (p = n), ea(Hn(c, 1, Nn, !0), Ge(p, 2)));
                  }),
                  ss = rt(function (c) {
                    var p = ln(c);
                    return (
                      (p = typeof p == "function" ? p : n),
                      ea(Hn(c, 1, Nn, !0), n, p)
                    );
                  });
                function Ga(c) {
                  return c && c.length ? ea(c) : [];
                }
                function ac(c, p) {
                  return c && c.length ? ea(c, Ge(p, 2)) : [];
                }
                function xm(c, p) {
                  return (
                    (p = typeof p == "function" ? p : n),
                    c && c.length ? ea(c, n, p) : []
                  );
                }
                function or(c) {
                  if (!(c && c.length)) return [];
                  var p = 0;
                  return (
                    (c = Na(c, function (x) {
                      if (Nn(x)) return ((p = xn(x.length, p)), !0);
                    })),
                    rd(p, function (x) {
                      return cn(c, Al(x));
                    })
                  );
                }
                function mn(c, p) {
                  if (!(c && c.length)) return [];
                  var x = or(c);
                  return p == null
                    ? x
                    : cn(x, function (C) {
                        return Vi(p, n, C);
                      });
                }
                var Va = rt(function (c, p) {
                    return Nn(c) ? Ls(c, p) : [];
                  }),
                  Gl = rt(function (c) {
                    return Rd(Na(c, Nn));
                  }),
                  _m = rt(function (c) {
                    var p = ln(c);
                    return (Nn(p) && (p = n), Rd(Na(c, Nn), Ge(p, 2)));
                  }),
                  rs = rt(function (c) {
                    var p = ln(c);
                    return (
                      (p = typeof p == "function" ? p : n),
                      Rd(Na(c, Nn), n, p)
                    );
                  }),
                  lc = rt(or);
                function Yu(c, p) {
                  return Yp(c || [], p || [], Js);
                }
                function Ni(c, p) {
                  return Yp(c || [], p || [], Jo);
                }
                var wm = rt(function (c) {
                  var p = c.length,
                    x = p > 1 ? c[p - 1] : n;
                  return (
                    (x = typeof x == "function" ? (c.pop(), x) : n),
                    mn(c, x)
                  );
                });
                function qu(c) {
                  var p = k(c);
                  return ((p.__chain__ = !0), p);
                }
                function _y(c, p) {
                  return (p(c), c);
                }
                function Vl(c, p) {
                  return p(c);
                }
                var Zd = Cr(function (c) {
                  var p = c.length,
                    x = p ? c[0] : 0,
                    C = this.__wrapped__,
                    L = function (z) {
                      return Go(z, c);
                    };
                  return p > 1 ||
                    this.__actions__.length ||
                    !(C instanceof it) ||
                    !rr(x)
                    ? this.thru(L)
                    : ((C = C.slice(x, +x + (p ? 1 : 0))),
                      C.__actions__.push({ func: Vl, args: [L], thisArg: n }),
                      new Ti(C, this.__chain__).thru(function (z) {
                        return (p && !z.length && z.push(n), z);
                      }));
                });
                function Wa() {
                  return qu(this);
                }
                function Yn() {
                  return new Ti(this.value(), this.__chain__);
                }
                function Xa() {
                  this.__values__ === n && (this.__values__ = $y(this.value()));
                  var c = this.__index__ >= this.__values__.length,
                    p = c ? n : this.__values__[this.__index__++];
                  return { done: c, value: p };
                }
                function oc() {
                  return this;
                }
                function aa(c) {
                  for (var p, x = this; x instanceof za; ) {
                    var C = Vd(x);
                    ((C.__index__ = 0),
                      (C.__values__ = n),
                      p ? (L.__wrapped__ = C) : (p = C));
                    var L = C;
                    x = x.__wrapped__;
                  }
                  return ((L.__wrapped__ = c), p);
                }
                function Sm() {
                  var c = this.__wrapped__;
                  if (c instanceof it) {
                    var p = c;
                    return (
                      this.__actions__.length && (p = new it(this)),
                      (p = p.reverse()),
                      p.__actions__.push({ func: Vl, args: [$a], thisArg: n }),
                      new Ti(p, this.__chain__)
                    );
                  }
                  return this.thru($a);
                }
                function Tm() {
                  return Hp(this.__wrapped__, this.__actions__);
                }
                var wy = kd(function (c, p, x) {
                  Pt.call(c, x) ? ++c[x] : Ji(c, x, 1);
                });
                function $u(c, p, x) {
                  var C = tt(c) ? xv : Ua;
                  return (x && oi(c, p, x) && (p = n), C(c, Ge(p, 3)));
                }
                function Em(c, p) {
                  var x = tt(c) ? Na : Sd;
                  return x(c, Ge(p, 3));
                }
                var as = Jp(mm),
                  Sy = Jp(gm);
                function Ai(c, p) {
                  return Hn(Gu(c, p), 1);
                }
                function Ty(c, p) {
                  return Hn(Gu(c, p), pe);
                }
                function Ey(c, p, x) {
                  return ((x = x === n ? 1 : Qe(x)), Hn(Gu(c, p), x));
                }
                function Cy(c, p) {
                  var x = tt(c) ? Wi : Tr;
                  return x(c, Ge(p, 3));
                }
                function la(c, p) {
                  var x = tt(c) ? c1 : wd;
                  return x(c, Ge(p, 3));
                }
                var Kd = kd(function (c, p, x) {
                  Pt.call(c, x) ? c[x].push(p) : Ji(c, x, [p]);
                });
                function Cm(c, p, x, C) {
                  ((c = Ri(c) ? c : vc(c)), (x = x && !C ? Qe(x) : 0));
                  var L = c.length;
                  return (
                    x < 0 && (x = xn(L + x, 0)),
                    nf(c)
                      ? x <= L && c.indexOf(p, x) > -1
                      : !!L && Mo(c, p, x) > -1
                  );
                }
                var cc = rt(function (c, p, x) {
                    var C = -1,
                      L = typeof p == "function",
                      z = Ri(c) ? oe(c.length) : [];
                    return (
                      Tr(c, function (q) {
                        z[++C] = L ? Vi(p, q, x) : ks(q, p, x);
                      }),
                      z
                    );
                  }),
                  Oy = kd(function (c, p, x) {
                    Ji(c, x, p);
                  });
                function Gu(c, p) {
                  var x = tt(c) ? cn : Od;
                  return x(c, Ge(p, 3));
                }
                function jy(c, p, x, C) {
                  return c == null
                    ? []
                    : (tt(p) || (p = p == null ? [] : [p]),
                      (x = C ? n : x),
                      tt(x) || (x = x == null ? [] : [x]),
                      Nd(c, p, x));
                }
                var My = kd(
                  function (c, p, x) {
                    c[x ? 0 : 1].push(p);
                  },
                  function () {
                    return [[], []];
                  },
                );
                function Jd(c, p, x) {
                  var C = tt(c) ? mp : yp,
                    L = arguments.length < 3;
                  return C(c, Ge(p, 4), x, L, Tr);
                }
                function Om(c, p, x) {
                  var C = tt(c) ? _v : yp,
                    L = arguments.length < 3;
                  return C(c, Ge(p, 4), x, L, wd);
                }
                function R1(c, p) {
                  var x = tt(c) ? Na : Sd;
                  return x(c, nh(Ge(p, 3)));
                }
                function L1(c) {
                  var p = tt(c) ? pu : Pp;
                  return p(c);
                }
                function D1(c, p, x) {
                  (x ? oi(c, p, x) : p === n) ? (p = 1) : (p = Qe(p));
                  var C = tt(c) ? xd : Ip;
                  return C(c, p);
                }
                function Ny(c) {
                  var p = tt(c) ? Uv : qv;
                  return p(c);
                }
                function Ay(c) {
                  if (c == null) return 0;
                  if (Ri(c)) return nf(c) ? No(c) : c.length;
                  var p = ti(c);
                  return p == Gt || p == ai ? c.size : Ba(c).length;
                }
                function uc(c, p, x) {
                  var C = tt(c) ? gp : $v;
                  return (x && oi(c, p, x) && (p = n), C(c, Ge(p, 3)));
                }
                var eh = rt(function (c, p) {
                    if (c == null) return [];
                    var x = p.length;
                    return (
                      x > 1 && oi(c, p[0], p[1])
                        ? (p = [])
                        : x > 2 && oi(p[0], p[1], p[2]) && (p = [p[0]]),
                      Nd(c, Hn(p, 1), [])
                    );
                  }),
                  Vu =
                    md ||
                    function () {
                      return Bn.Date.now();
                    };
                function Ry(c, p) {
                  if (typeof p != "function") throw new Qi(u);
                  return (
                    (c = Qe(c)),
                    function () {
                      if (--c < 1) return p.apply(this, arguments);
                    }
                  );
                }
                function jm(c, p, x) {
                  return (
                    (p = x ? n : p),
                    (p = c && p == null ? c.length : p),
                    gi(c, Y, n, n, n, n, p)
                  );
                }
                function Mm(c, p) {
                  var x;
                  if (typeof p != "function") throw new Qi(u);
                  return (
                    (c = Qe(c)),
                    function () {
                      return (
                        --c > 0 && (x = p.apply(this, arguments)),
                        c <= 1 && (p = n),
                        x
                      );
                    }
                  );
                }
                var th = rt(function (c, p, x) {
                    var C = j;
                    if (x.length) {
                      var L = Gr(x, wn(th));
                      C |= P;
                    }
                    return gi(c, C, p, x, L);
                  }),
                  Nm = rt(function (c, p, x) {
                    var C = j | O;
                    if (x.length) {
                      var L = Gr(x, wn(Nm));
                      C |= P;
                    }
                    return gi(p, C, c, x, L);
                  });
                function Wu(c, p, x) {
                  p = x ? n : p;
                  var C = gi(c, N, n, n, n, n, n, p);
                  return ((C.placeholder = Wu.placeholder), C);
                }
                function Am(c, p, x) {
                  p = x ? n : p;
                  var C = gi(c, R, n, n, n, n, n, p);
                  return ((C.placeholder = Am.placeholder), C);
                }
                function Rm(c, p, x) {
                  var C,
                    L,
                    z,
                    q,
                    Q,
                    ne,
                    we = 0,
                    Se = !1,
                    Ee = !1,
                    Ae = !0;
                  if (typeof c != "function") throw new Qi(u);
                  ((p = cs(p) || 0),
                    dn(x) &&
                      ((Se = !!x.leading),
                      (Ee = "maxWait" in x),
                      (z = Ee ? xn(cs(x.maxWait) || 0, p) : z),
                      (Ae = "trailing" in x ? !!x.trailing : Ae)));
                  function He(qn) {
                    var ua = C,
                      Zl = L;
                    return ((C = L = n), (we = qn), (q = c.apply(Zl, ua)), q);
                  }
                  function Ze(qn) {
                    return ((we = qn), (Q = Iu(St, p)), Se ? He(qn) : q);
                  }
                  function ht(qn) {
                    var ua = qn - ne,
                      Zl = qn - we,
                      uS = p - ua;
                    return Ee ? zn(uS, z - Zl) : uS;
                  }
                  function Ke(qn) {
                    var ua = qn - ne,
                      Zl = qn - we;
                    return ne === n || ua >= p || ua < 0 || (Ee && Zl >= z);
                  }
                  function St() {
                    var qn = Vu();
                    if (Ke(qn)) return jt(qn);
                    Q = Iu(St, ht(qn));
                  }
                  function jt(qn) {
                    return ((Q = n), Ae && C ? He(qn) : ((C = L = n), q));
                  }
                  function cr() {
                    (Q !== n && wu(Q), (we = 0), (C = ne = L = Q = n));
                  }
                  function us() {
                    return Q === n ? q : jt(Vu());
                  }
                  function ur() {
                    var qn = Vu(),
                      ua = Ke(qn);
                    if (((C = arguments), (L = this), (ne = qn), ua)) {
                      if (Q === n) return Ze(ne);
                      if (Ee) return (wu(Q), (Q = Iu(St, p)), He(ne));
                    }
                    return (Q === n && (Q = Iu(St, p)), q);
                  }
                  return ((ur.cancel = cr), (ur.flush = us), ur);
                }
                var qt = rt(function (c, p) {
                    return Rp(c, 1, p);
                  }),
                  Lm = rt(function (c, p, x) {
                    return Rp(c, cs(p) || 0, x);
                  });
                function k1(c) {
                  return gi(c, I);
                }
                function Xu(c, p) {
                  if (
                    typeof c != "function" ||
                    (p != null && typeof p != "function")
                  )
                    throw new Qi(u);
                  var x = function () {
                    var C = arguments,
                      L = p ? p.apply(this, C) : C[0],
                      z = x.cache;
                    if (z.has(L)) return z.get(L);
                    var q = c.apply(this, C);
                    return ((x.cache = z.set(L, q) || z), q);
                  };
                  return ((x.cache = new (Xu.Cache || Ks)()), x);
                }
                Xu.Cache = Ks;
                function nh(c) {
                  if (typeof c != "function") throw new Qi(u);
                  return function () {
                    var p = arguments;
                    switch (p.length) {
                      case 0:
                        return !c.call(this);
                      case 1:
                        return !c.call(this, p[0]);
                      case 2:
                        return !c.call(this, p[0], p[1]);
                      case 3:
                        return !c.call(this, p[0], p[1], p[2]);
                    }
                    return !c.apply(this, p);
                  };
                }
                function z1(c) {
                  return Mm(2, c);
                }
                var P1 = Vv(function (c, p) {
                    p =
                      p.length == 1 && tt(p[0])
                        ? cn(p[0], Xi(Ge()))
                        : cn(Hn(p, 1), Xi(Ge()));
                    var x = p.length;
                    return rt(function (C) {
                      for (var L = -1, z = zn(C.length, x); ++L < z; )
                        C[L] = p[L].call(this, C[L]);
                      return Vi(c, this, C);
                    });
                  }),
                  fc = rt(function (c, p) {
                    var x = Gr(p, wn(fc));
                    return gi(c, P, n, p, x);
                  }),
                  Wl = rt(function (c, p) {
                    var x = Gr(p, wn(Wl));
                    return gi(c, G, n, p, x);
                  }),
                  Dm = Cr(function (c, p) {
                    return gi(c, B, n, n, n, p);
                  });
                function ih(c, p) {
                  if (typeof c != "function") throw new Qi(u);
                  return ((p = p === n ? p : Qe(p)), rt(c, p));
                }
                function km(c, p) {
                  if (typeof c != "function") throw new Qi(u);
                  return (
                    (p = p == null ? 0 : xn(Qe(p), 0)),
                    rt(function (x) {
                      var C = x[p],
                        L = sr(x, 0, p);
                      return (C && Aa(L, C), Vi(c, this, L));
                    })
                  );
                }
                function Qa(c, p, x) {
                  var C = !0,
                    L = !0;
                  if (typeof c != "function") throw new Qi(u);
                  return (
                    dn(x) &&
                      ((C = "leading" in x ? !!x.leading : C),
                      (L = "trailing" in x ? !!x.trailing : L)),
                    Rm(c, p, { leading: C, maxWait: p, trailing: L })
                  );
                }
                function Mr(c) {
                  return jm(c, 1);
                }
                function Qu(c, p) {
                  return fc(Ld(p), c);
                }
                function I1() {
                  if (!arguments.length) return [];
                  var c = arguments[0];
                  return tt(c) ? c : [c];
                }
                function Ly(c) {
                  return pi(c, S);
                }
                function Dy(c, p) {
                  return ((p = typeof p == "function" ? p : n), pi(c, S, p));
                }
                function ky(c) {
                  return pi(c, y | S);
                }
                function zy(c, p) {
                  return (
                    (p = typeof p == "function" ? p : n),
                    pi(c, y | S, p)
                  );
                }
                function U1(c, p) {
                  return p == null || Ia(c, p, Vn(p));
                }
                function ls(c, p) {
                  return c === p || (c !== c && p !== p);
                }
                var Py = Ou(gu),
                  Iy = Ou(function (c, p) {
                    return c >= p;
                  }),
                  Xl = Ei(
                    (function () {
                      return arguments;
                    })(),
                  )
                    ? Ei
                    : function (c) {
                        return (
                          Sn(c) && Pt.call(c, "callee") && !ou.call(c, "callee")
                        );
                      },
                  tt = oe.isArray,
                  zm = mv ? Xi(mv) : jn;
                function Ri(c) {
                  return c != null && ah(c.length) && !os(c);
                }
                function Nn(c) {
                  return Sn(c) && Ri(c);
                }
                function Zu(c) {
                  return c === !0 || c === !1 || (Sn(c) && ei(c) == ut);
                }
                var Za = kv || re,
                  Uy = gv ? Xi(gv) : Ed;
                function gt(c) {
                  return Sn(c) && c.nodeType === 1 && !Ju(c);
                }
                function Pm(c) {
                  if (c == null) return !0;
                  if (
                    Ri(c) &&
                    (tt(c) ||
                      typeof c == "string" ||
                      typeof c.splice == "function" ||
                      Za(c) ||
                      Ka(c) ||
                      Xl(c))
                  )
                    return !c.length;
                  var p = ti(c);
                  if (p == Gt || p == ai) return !c.size;
                  if (ic(c)) return !Ba(c).length;
                  for (var x in c) if (Pt.call(c, x)) return !1;
                  return !0;
                }
                function sh(c, p) {
                  return ts(c, p);
                }
                function Im(c, p, x) {
                  x = typeof x == "function" ? x : n;
                  var C = x ? x(c, p) : n;
                  return C === n ? ts(c, p, n, x) : !!C;
                }
                function rh(c) {
                  if (!Sn(c)) return !1;
                  var p = ei(c);
                  return (
                    p == ri ||
                    p == di ||
                    (typeof c.message == "string" &&
                      typeof c.name == "string" &&
                      !Ju(c))
                  );
                }
                function Um(c) {
                  return typeof c == "number" && Zi(c);
                }
                function os(c) {
                  if (!dn(c)) return !1;
                  var p = ei(c);
                  return p == Bi || p == Cn || p == Je || p == Ca;
                }
                function Ku(c) {
                  return typeof c == "number" && c == Qe(c);
                }
                function ah(c) {
                  return (
                    typeof c == "number" && c > -1 && c % 1 == 0 && c <= de
                  );
                }
                function dn(c) {
                  var p = typeof c;
                  return c != null && (p == "object" || p == "function");
                }
                function Sn(c) {
                  return c != null && typeof c == "object";
                }
                var Fy = ed ? Xi(ed) : Wt;
                function By(c, p) {
                  return c === p || _n(c, p, Fd(p));
                }
                function Hy(c, p, x) {
                  return (
                    (x = typeof x == "function" ? x : n),
                    _n(c, p, Fd(p), x)
                  );
                }
                function Xt(c) {
                  return Bm(c) && c != +c;
                }
                function Fm(c) {
                  if (om(c)) throw new et(l);
                  return yu(c);
                }
                function ni(c) {
                  return c === null;
                }
                function F1(c) {
                  return c == null;
                }
                function Bm(c) {
                  return typeof c == "number" || (Sn(c) && ei(c) == An);
                }
                function Ju(c) {
                  if (!Sn(c) || ei(c) != Hi) return !1;
                  var p = _r(c);
                  if (p === null) return !0;
                  var x = Pt.call(p, "constructor") && p.constructor;
                  return (
                    typeof x == "function" && x instanceof x && fd.call(x) == hd
                  );
                }
                var ef = vv ? Xi(vv) : Wo;
                function Hm(c) {
                  return Ku(c) && c >= -de && c <= de;
                }
                var tf = yv ? Xi(yv) : Yl;
                function nf(c) {
                  return (
                    typeof c == "string" || (!tt(c) && Sn(c) && ei(c) == Oa)
                  );
                }
                function Li(c) {
                  return typeof c == "symbol" || (Sn(c) && ei(c) == wo);
                }
                var Ka = bv ? Xi(bv) : Cd;
                function Ym(c) {
                  return c === n;
                }
                function B1(c) {
                  return Sn(c) && ti(c) == Gs;
                }
                function Yy(c) {
                  return Sn(c) && ei(c) == Br;
                }
                var H1 = Ou(fn),
                  qy = Ou(function (c, p) {
                    return c <= p;
                  });
                function $y(c) {
                  if (!c) return [];
                  if (Ri(c)) return nf(c) ? hn(c) : mi(c);
                  if (Kn && c[Kn]) return Sp(c[Kn]());
                  var p = ti(c),
                    x = p == Gt ? ld : p == ai ? od : vc;
                  return x(c);
                }
                function oa(c) {
                  if (!c) return c === 0 ? c : 0;
                  if (((c = cs(c)), c === pe || c === -pe)) {
                    var p = c < 0 ? -1 : 1;
                    return p * he;
                  }
                  return c === c ? c : 0;
                }
                function Qe(c) {
                  var p = oa(c),
                    x = p % 1;
                  return p === p ? (x ? p - x : p) : 0;
                }
                function qm(c) {
                  return c ? er(Qe(c), 0, F) : 0;
                }
                function cs(c) {
                  if (typeof c == "number") return c;
                  if (Li(c)) return Te;
                  if (dn(c)) {
                    var p = typeof c.valueOf == "function" ? c.valueOf() : c;
                    c = dn(p) ? p + "" : p;
                  }
                  if (typeof c != "string") return c === 0 ? c : +c;
                  c = Rl(c);
                  var x = Ff.test(c);
                  return x || Fe.test(c)
                    ? Kf(c.slice(2), x ? 2 : 8)
                    : Uf.test(c)
                      ? Te
                      : +c;
                }
                function lh(c) {
                  return zs(c, Di(c));
                }
                function Y1(c) {
                  return c ? er(Qe(c), -de, de) : c === 0 ? c : 0;
                }
                function Ut(c) {
                  return c == null ? "" : Ci(c);
                }
                var Gy = Ha(function (c, p) {
                    if (ic(p) || Ri(p)) {
                      zs(p, Vn(p), c);
                      return;
                    }
                    for (var x in p) Pt.call(p, x) && Js(c, x, p[x]);
                  }),
                  oh = Ha(function (c, p) {
                    zs(p, Di(p), c);
                  }),
                  dc = Ha(function (c, p, x, C) {
                    zs(p, Di(p), c, C);
                  }),
                  q1 = Ha(function (c, p, x, C) {
                    zs(p, Vn(p), c, C);
                  }),
                  Ps = Cr(Go);
                function $m(c, p) {
                  var x = ka(c);
                  return p == null ? x : Ap(x, p);
                }
                var Vy = rt(function (c, p) {
                    c = Ht(c);
                    var x = -1,
                      C = p.length,
                      L = C > 2 ? p[2] : n;
                    for (L && oi(p[0], p[1], L) && (C = 1); ++x < C; )
                      for (
                        var z = p[x], q = Di(z), Q = -1, ne = q.length;
                        ++Q < ne;

                      ) {
                        var we = q[Q],
                          Se = c[we];
                        (Se === n || (ls(Se, Lo[we]) && !Pt.call(c, we))) &&
                          (c[we] = z[we]);
                      }
                    return c;
                  }),
                  Wy = rt(function (c) {
                    return (c.push(n, nm), Vi(pc, n, c));
                  });
                function Xy(c, p) {
                  return wv(c, Ge(p, 3), nr);
                }
                function sf(c, p) {
                  return wv(c, Ge(p, 3), Td);
                }
                function Is(c, p) {
                  return c == null ? c : Hl(c, Ge(p, 3), Di);
                }
                function Qy(c, p) {
                  return c == null ? c : Vo(c, Ge(p, 3), Di);
                }
                function ch(c, p) {
                  return c && nr(c, Ge(p, 3));
                }
                function ca(c, p) {
                  return c && Td(c, Ge(p, 3));
                }
                function $1(c) {
                  return c == null ? [] : Jr(c, Vn(c));
                }
                function G1(c) {
                  return c == null ? [] : Jr(c, Di(c));
                }
                function Ja(c, p, x) {
                  var C = c == null ? n : Er(c, p);
                  return C === n ? x : C;
                }
                function Zy(c, p) {
                  return c != null && Yd(c, p, es);
                }
                function Gm(c, p) {
                  return c != null && Yd(c, p, Ds);
                }
                var V1 = Eu(function (c, p, x) {
                    (p != null &&
                      typeof p.toString != "function" &&
                      (p = Si.call(p)),
                      (c[p] = x));
                  }, bc(vi)),
                  W1 = Eu(function (c, p, x) {
                    (p != null &&
                      typeof p.toString != "function" &&
                      (p = Si.call(p)),
                      Pt.call(c, p) ? c[p].push(x) : (c[p] = [x]));
                  }, Ge),
                  X1 = rt(ks);
                function Vn(c) {
                  return Ri(c) ? bd(c) : Ba(c);
                }
                function Di(c) {
                  return Ri(c) ? bd(c, !0) : w1(c);
                }
                function Q1(c, p) {
                  var x = {};
                  return (
                    (p = Ge(p, 3)),
                    nr(c, function (C, L, z) {
                      Ji(x, p(C, L, z), C);
                    }),
                    x
                  );
                }
                function Ky(c, p) {
                  var x = {};
                  return (
                    (p = Ge(p, 3)),
                    nr(c, function (C, L, z) {
                      Ji(x, L, p(C, L, z));
                    }),
                    x
                  );
                }
                var hc = Ha(function (c, p, x) {
                    bu(c, p, x);
                  }),
                  pc = Ha(function (c, p, x, C) {
                    bu(c, p, x, C);
                  }),
                  Jy = Cr(function (c, p) {
                    var x = {};
                    if (c == null) return x;
                    var C = !1;
                    ((p = cn(p, function (z) {
                      return ((z = is(z, c)), C || (C = z.length > 1), z);
                    })),
                      zs(c, sm(c), x),
                      C && (x = pi(x, y | w | S, ty)));
                    for (var L = p.length; L--; ) xu(x, p[L]);
                    return x;
                  });
                function Z1(c, p) {
                  return gc(c, nh(Ge(p)));
                }
                var mc = Cr(function (c, p) {
                  return c == null ? {} : kp(c, p);
                });
                function gc(c, p) {
                  if (c == null) return {};
                  var x = cn(sm(c), function (C) {
                    return [C];
                  });
                  return (
                    (p = Ge(p)),
                    li(c, x, function (C, L) {
                      return p(C, L[0]);
                    })
                  );
                }
                function e0(c, p, x) {
                  p = is(p, c);
                  var C = -1,
                    L = p.length;
                  for (L || ((L = 1), (c = n)); ++C < L; ) {
                    var z = c == null ? n : c[Oi(p[C])];
                    (z === n && ((C = L), (z = x)),
                      (c = os(z) ? z.call(c) : z));
                  }
                  return c;
                }
                function uh(c, p, x) {
                  return c == null ? c : Jo(c, p, x);
                }
                function Vm(c, p, x, C) {
                  return (
                    (C = typeof C == "function" ? C : n),
                    c == null ? c : Jo(c, p, x, C)
                  );
                }
                var fh = em(Vn),
                  rf = em(Di);
                function t0(c, p, x) {
                  var C = tt(c),
                    L = C || Za(c) || Ka(c);
                  if (((p = Ge(p, 4)), x == null)) {
                    var z = c && c.constructor;
                    L
                      ? (x = C ? new z() : [])
                      : dn(c)
                        ? (x = os(z) ? ka(_r(c)) : {})
                        : (x = {});
                  }
                  return (
                    (L ? Wi : nr)(c, function (q, Q, ne) {
                      return p(x, q, Q, ne);
                    }),
                    x
                  );
                }
                function n0(c, p) {
                  return c == null ? !0 : xu(c, p);
                }
                function K1(c, p, x) {
                  return c == null ? c : Bp(c, p, Ld(x));
                }
                function i0(c, p, x, C) {
                  return (
                    (C = typeof C == "function" ? C : n),
                    c == null ? c : Bp(c, p, Ld(x), C)
                  );
                }
                function vc(c) {
                  return c == null ? [] : bp(c, Vn(c));
                }
                function Wm(c) {
                  return c == null ? [] : bp(c, Di(c));
                }
                function J1(c, p, x) {
                  return (
                    x === n && ((x = p), (p = n)),
                    x !== n && ((x = cs(x)), (x = x === x ? x : 0)),
                    p !== n && ((p = cs(p)), (p = p === p ? p : 0)),
                    er(cs(c), p, x)
                  );
                }
                function dh(c, p, x) {
                  return (
                    (p = oa(p)),
                    x === n ? ((x = p), (p = 0)) : (x = oa(x)),
                    (c = cs(c)),
                    Fa(c, p, x)
                  );
                }
                function hh(c, p, x) {
                  if (
                    (x && typeof x != "boolean" && oi(c, p, x) && (p = x = n),
                    x === n &&
                      (typeof p == "boolean"
                        ? ((x = p), (p = n))
                        : typeof c == "boolean" && ((x = c), (c = n))),
                    c === n && p === n
                      ? ((c = 0), (p = 1))
                      : ((c = oa(c)),
                        p === n ? ((p = c), (c = 0)) : (p = oa(p))),
                    c > p)
                  ) {
                    var C = c;
                    ((c = p), (p = C));
                  }
                  if (x || c % 1 || p % 1) {
                    var L = Xr();
                    return zn(
                      c + L * (p - c + Nl("1e-" + ((L + "").length - 1))),
                      p,
                    );
                  }
                  return Ko(c, p);
                }
                var ph = ql(function (c, p, x) {
                  return ((p = p.toLowerCase()), c + (x ? s0(p) : p));
                });
                function s0(c) {
                  return Ql(Ut(c).toLowerCase());
                }
                function yc(c) {
                  return ((c = Ut(c)), c && c.replace(Ce, au).replace(hv, ""));
                }
                function ex(c, p, x) {
                  ((c = Ut(c)), (p = Ci(p)));
                  var C = c.length;
                  x = x === n ? C : er(Qe(x), 0, C);
                  var L = x;
                  return ((x -= p.length), x >= 0 && c.slice(x, L) == p);
                }
                function r0(c) {
                  return ((c = Ut(c)), c && Eo.test(c) ? c.replace(Sl, p1) : c);
                }
                function a0(c) {
                  return (
                    (c = Ut(c)),
                    c && $c.test(c) ? c.replace(El, "\\$&") : c
                  );
                }
                var l0 = ql(function (c, p, x) {
                    return c + (x ? "-" : "") + p.toLowerCase();
                  }),
                  o0 = ql(function (c, p, x) {
                    return c + (x ? " " : "") + p.toLowerCase();
                  }),
                  Xm = Kp("toLowerCase");
                function c0(c, p, x) {
                  ((c = Ut(c)), (p = Qe(p)));
                  var C = p ? No(c) : 0;
                  if (!p || C >= p) return c;
                  var L = (p - C) / 2;
                  return Ya(cu(L), x) + c + Ya(zo(L), x);
                }
                function u0(c, p, x) {
                  ((c = Ut(c)), (p = Qe(p)));
                  var C = p ? No(c) : 0;
                  return p && C < p ? c + Ya(p - C, x) : c;
                }
                function mh(c, p, x) {
                  ((c = Ut(c)), (p = Qe(p)));
                  var C = p ? No(c) : 0;
                  return p && C < p ? Ya(p - C, x) + c : c;
                }
                function tx(c, p, x) {
                  return (
                    x || p == null ? (p = 0) : p && (p = +p),
                    js(Ut(c).replace(Co, ""), p || 0)
                  );
                }
                function nx(c, p, x) {
                  return (
                    (x ? oi(c, p, x) : p === n) ? (p = 1) : (p = Qe(p)),
                    ir(Ut(c), p)
                  );
                }
                function Qm() {
                  var c = arguments,
                    p = Ut(c[0]);
                  return c.length < 3 ? p : p.replace(c[1], c[2]);
                }
                var Zm = ql(function (c, p, x) {
                  return c + (x ? "_" : "") + p.toLowerCase();
                });
                function gh(c, p, x) {
                  return (
                    x && typeof x != "number" && oi(c, p, x) && (p = x = n),
                    (x = x === n ? F : x >>> 0),
                    x
                      ? ((c = Ut(c)),
                        c &&
                        (typeof p == "string" || (p != null && !ef(p))) &&
                        ((p = Ci(p)), !p && Ll(c))
                          ? sr(hn(c), 0, x)
                          : c.split(p, x))
                      : []
                  );
                }
                var Km = ql(function (c, p, x) {
                  return c + (x ? " " : "") + Ql(p);
                });
                function f0(c, p, x) {
                  return (
                    (c = Ut(c)),
                    (x = x == null ? 0 : er(Qe(x), 0, c.length)),
                    (p = Ci(p)),
                    c.slice(x, x + p.length) == p
                  );
                }
                function Jm(c, p, x) {
                  var C = k.templateSettings;
                  (x && oi(c, p, x) && (p = n),
                    (c = Ut(c)),
                    (p = dc({}, p, C, tm)));
                  var L = dc({}, p.imports, C.imports, tm),
                    z = Vn(L),
                    q = bp(L, z),
                    Q,
                    ne,
                    we = 0,
                    Se = p.interpolate || Le,
                    Ee = "__p += '",
                    Ae = cd(
                      (p.escape || Le).source +
                        "|" +
                        Se.source +
                        "|" +
                        (Se === br ? Yr : Le).source +
                        "|" +
                        (p.evaluate || Le).source +
                        "|$",
                      "g",
                    ),
                    He =
                      "//# sourceURL=" +
                      (Pt.call(p, "sourceURL")
                        ? (p.sourceURL + "").replace(/\s/g, " ")
                        : "lodash.templateSources[" + ++pp + "]") +
                      `
`;
                  (c.replace(Ae, function (Ke, St, jt, cr, us, ur) {
                    return (
                      jt || (jt = cr),
                      (Ee += c.slice(we, ur).replace(zt, ad)),
                      St &&
                        ((Q = !0),
                        (Ee +=
                          `' +
__e(` +
                          St +
                          `) +
'`)),
                      us &&
                        ((ne = !0),
                        (Ee +=
                          `';
` +
                          us +
                          `;
__p += '`)),
                      jt &&
                        (Ee +=
                          `' +
((__t = (` +
                          jt +
                          `)) == null ? '' : __t) +
'`),
                      (we = ur + Ke.length),
                      Ke
                    );
                  }),
                    (Ee += `';
`));
                  var Ze = Pt.call(p, "variable") && p.variable;
                  if (!Ze)
                    Ee =
                      `with (obj) {
` +
                      Ee +
                      `
}
`;
                  else if (Dn.test(Ze)) throw new et(d);
                  ((Ee = (ne ? Ee.replace(Hc, "") : Ee)
                    .replace(lp, "$1")
                    .replace(Hr, "$1;")),
                    (Ee =
                      "function(" +
                      (Ze || "obj") +
                      `) {
` +
                      (Ze
                        ? ""
                        : `obj || (obj = {});
`) +
                      "var __t, __p = ''" +
                      (Q ? ", __e = _.escape" : "") +
                      (ne
                        ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`
                        : `;
`) +
                      Ee +
                      `return __p
}`));
                  var ht = eg(function () {
                    return pt(z, He + "return " + Ee).apply(n, q);
                  });
                  if (((ht.source = Ee), rh(ht))) throw ht;
                  return ht;
                }
                function el(c) {
                  return Ut(c).toLowerCase();
                }
                function tl(c) {
                  return Ut(c).toUpperCase();
                }
                function nl(c, p, x) {
                  if (((c = Ut(c)), c && (x || p === n))) return Rl(c);
                  if (!c || !(p = Ci(p))) return c;
                  var C = hn(c),
                    L = hn(p),
                    z = xp(C, L),
                    q = _p(C, L) + 1;
                  return sr(C, z, q).join("");
                }
                function af(c, p, x) {
                  if (((c = Ut(c)), c && (x || p === n)))
                    return c.slice(0, Ao(c) + 1);
                  if (!c || !(p = Ci(p))) return c;
                  var C = hn(c),
                    L = _p(C, hn(p)) + 1;
                  return sr(C, 0, L).join("");
                }
                function lf(c, p, x) {
                  if (((c = Ut(c)), c && (x || p === n)))
                    return c.replace(Co, "");
                  if (!c || !(p = Ci(p))) return c;
                  var C = hn(c),
                    L = xp(C, hn(p));
                  return sr(C, L).join("");
                }
                function il(c, p) {
                  var x = H,
                    C = X;
                  if (dn(p)) {
                    var L = "separator" in p ? p.separator : L;
                    ((x = "length" in p ? Qe(p.length) : x),
                      (C = "omission" in p ? Ci(p.omission) : C));
                  }
                  c = Ut(c);
                  var z = c.length;
                  if (Ll(c)) {
                    var q = hn(c);
                    z = q.length;
                  }
                  if (x >= z) return c;
                  var Q = x - No(C);
                  if (Q < 1) return C;
                  var ne = q ? sr(q, 0, Q).join("") : c.slice(0, Q);
                  if (L === n) return ne + C;
                  if ((q && (Q += ne.length - Q), ef(L))) {
                    if (c.slice(Q).search(L)) {
                      var we,
                        Se = ne;
                      for (
                        L.global || (L = cd(L.source, Ut(Cl.exec(L)) + "g")),
                          L.lastIndex = 0;
                        (we = L.exec(Se));

                      )
                        var Ee = we.index;
                      ne = ne.slice(0, Ee === n ? Q : Ee);
                    }
                  } else if (c.indexOf(Ci(L), Q) != Q) {
                    var Ae = ne.lastIndexOf(L);
                    Ae > -1 && (ne = ne.slice(0, Ae));
                  }
                  return ne + C;
                }
                function ix(c) {
                  return ((c = Ut(c)), c && qi.test(c) ? c.replace(yr, Ov) : c);
                }
                var d0 = ql(function (c, p, x) {
                    return c + (x ? " " : "") + p.toUpperCase();
                  }),
                  Ql = Kp("toUpperCase");
                function h0(c, p, x) {
                  return (
                    (c = Ut(c)),
                    (p = x ? n : p),
                    p === n ? (wp(c) ? Nv(c) : d1(c)) : c.match(p) || []
                  );
                }
                var eg = rt(function (c, p) {
                    try {
                      return Vi(c, n, p);
                    } catch (x) {
                      return rh(x) ? x : new et(x);
                    }
                  }),
                  vh = Cr(function (c, p) {
                    return (
                      Wi(p, function (x) {
                        ((x = Oi(x)), Ji(c, x, th(c[x], c)));
                      }),
                      c
                    );
                  });
                function p0(c) {
                  var p = c == null ? 0 : c.length,
                    x = Ge();
                  return (
                    (c = p
                      ? cn(c, function (C) {
                          if (typeof C[1] != "function") throw new Qi(u);
                          return [x(C[0]), C[1]];
                        })
                      : []),
                    rt(function (C) {
                      for (var L = -1; ++L < p; ) {
                        var z = c[L];
                        if (Vi(z[0], this, C)) return Vi(z[1], this, C);
                      }
                    })
                  );
                }
                function sx(c) {
                  return Bv(pi(c, y));
                }
                function bc(c) {
                  return function () {
                    return c;
                  };
                }
                function yh(c, p) {
                  return c == null || c !== c ? p : c;
                }
                var m0 = tc(),
                  xc = tc(!0);
                function vi(c) {
                  return c;
                }
                function of(c) {
                  return Xo(typeof c == "function" ? c : pi(c, y));
                }
                function bh(c) {
                  return jd(pi(c, y));
                }
                function g0(c, p) {
                  return Dp(c, pi(p, y));
                }
                var rx = rt(function (c, p) {
                    return function (x) {
                      return ks(x, c, p);
                    };
                  }),
                  xh = rt(function (c, p) {
                    return function (x) {
                      return ks(c, x, p);
                    };
                  });
                function s(c, p, x) {
                  var C = Vn(p),
                    L = Jr(p, C);
                  x == null &&
                    !(dn(p) && (L.length || !C.length)) &&
                    ((x = p), (p = c), (c = this), (L = Jr(p, Vn(p))));
                  var z = !(dn(x) && "chain" in x) || !!x.chain,
                    q = os(c);
                  return (
                    Wi(L, function (Q) {
                      var ne = p[Q];
                      ((c[Q] = ne),
                        q &&
                          (c.prototype[Q] = function () {
                            var we = this.__chain__;
                            if (z || we) {
                              var Se = c(this.__wrapped__),
                                Ee = (Se.__actions__ = mi(this.__actions__));
                              return (
                                Ee.push({
                                  func: ne,
                                  args: arguments,
                                  thisArg: c,
                                }),
                                (Se.__chain__ = we),
                                Se
                              );
                            }
                            return ne.apply(c, Aa([this.value()], arguments));
                          }));
                    }),
                    c
                  );
                }
                function r() {
                  return (Bn._ === this && (Bn._ = Es), this);
                }
                function o() {}
                function f(c) {
                  return (
                    (c = Qe(c)),
                    rt(function (p) {
                      return Md(p, c);
                    })
                  );
                }
                var b = zd(cn),
                  _ = zd(xv),
                  A = zd(gp);
                function D(c) {
                  return Du(c) ? Al(Oi(c)) : Mn(c);
                }
                function $(c) {
                  return function (p) {
                    return c == null ? n : Er(c, p);
                  };
                }
                var se = Pd(),
                  ge = Pd(!0);
                function _e() {
                  return [];
                }
                function re() {
                  return !1;
                }
                function ue() {
                  return {};
                }
                function Ie() {
                  return "";
                }
                function Ve() {
                  return !0;
                }
                function Qt(c, p) {
                  if (((c = Qe(c)), c < 1 || c > de)) return [];
                  var x = F,
                    C = zn(c, F);
                  ((p = Ge(p)), (c -= F));
                  for (var L = rd(C, p); ++x < c; ) p(x);
                  return L;
                }
                function te(c) {
                  return tt(c) ? cn(c, Oi) : Li(c) ? [c] : mi(fm(Ut(c)));
                }
                function K(c) {
                  var p = ++Rv;
                  return Ut(c) + p;
                }
                var ie = Cu(function (c, p) {
                    return c + p;
                  }, 0),
                  ye = ju("ceil"),
                  qe = Cu(function (c, p) {
                    return c / p;
                  }, 1),
                  Rt = ju("floor");
                function Be(c) {
                  return c && c.length ? tr(c, vi, gu) : n;
                }
                function lt(c, p) {
                  return c && c.length ? tr(c, Ge(p, 2), gu) : n;
                }
                function yt(c) {
                  return id(c, vi);
                }
                function Lt(c, p) {
                  return id(c, Ge(p, 2));
                }
                function sl(c) {
                  return c && c.length ? tr(c, vi, fn) : n;
                }
                function ax(c, p) {
                  return c && c.length ? tr(c, Ge(p, 2), fn) : n;
                }
                var KO = Cu(function (c, p) {
                    return c * p;
                  }, 1),
                  JO = ju("round"),
                  ej = Cu(function (c, p) {
                    return c - p;
                  }, 0);
                function tj(c) {
                  return c && c.length ? sd(c, vi) : 0;
                }
                function nj(c, p) {
                  return c && c.length ? sd(c, Ge(p, 2)) : 0;
                }
                return (
                  (k.after = Ry),
                  (k.ary = jm),
                  (k.assign = Gy),
                  (k.assignIn = oh),
                  (k.assignInWith = dc),
                  (k.assignWith = q1),
                  (k.at = Ps),
                  (k.before = Mm),
                  (k.bind = th),
                  (k.bindAll = vh),
                  (k.bindKey = Nm),
                  (k.castArray = I1),
                  (k.chain = qu),
                  (k.chunk = cy),
                  (k.compact = dm),
                  (k.concat = hm),
                  (k.cond = p0),
                  (k.conforms = sx),
                  (k.constant = bc),
                  (k.countBy = wy),
                  (k.create = $m),
                  (k.curry = Wu),
                  (k.curryRight = Am),
                  (k.debounce = Rm),
                  (k.defaults = Vy),
                  (k.defaultsDeep = Wy),
                  (k.defer = qt),
                  (k.delay = Lm),
                  (k.difference = Wd),
                  (k.differenceBy = uy),
                  (k.differenceWith = ia),
                  (k.drop = Un),
                  (k.dropRight = pm),
                  (k.dropRightWhile = fy),
                  (k.dropWhile = Gn),
                  (k.fill = j1),
                  (k.filter = Em),
                  (k.flatMap = Ai),
                  (k.flatMapDeep = Ty),
                  (k.flatMapDepth = Ey),
                  (k.flatten = an),
                  (k.flattenDeep = ji),
                  (k.flattenDepth = sa),
                  (k.flip = k1),
                  (k.flow = m0),
                  (k.flowRight = xc),
                  (k.fromPairs = dy),
                  (k.functions = $1),
                  (k.functionsIn = G1),
                  (k.groupBy = Kd),
                  (k.initial = M1),
                  (k.intersection = Xd),
                  (k.intersectionBy = Mi),
                  (k.intersectionWith = ar),
                  (k.invert = V1),
                  (k.invertBy = W1),
                  (k.invokeMap = cc),
                  (k.iteratee = of),
                  (k.keyBy = Oy),
                  (k.keys = Vn),
                  (k.keysIn = Di),
                  (k.map = Gu),
                  (k.mapKeys = Q1),
                  (k.mapValues = Ky),
                  (k.matches = bh),
                  (k.matchesProperty = g0),
                  (k.memoize = Xu),
                  (k.merge = hc),
                  (k.mergeWith = pc),
                  (k.method = rx),
                  (k.methodOf = xh),
                  (k.mixin = s),
                  (k.negate = nh),
                  (k.nthArg = f),
                  (k.omit = Jy),
                  (k.omitBy = Z1),
                  (k.once = z1),
                  (k.orderBy = jy),
                  (k.over = b),
                  (k.overArgs = P1),
                  (k.overEvery = _),
                  (k.overSome = A),
                  (k.partial = fc),
                  (k.partialRight = Wl),
                  (k.partition = My),
                  (k.pick = mc),
                  (k.pickBy = gc),
                  (k.property = D),
                  (k.propertyOf = $),
                  (k.pull = $l),
                  (k.pullAll = jr),
                  (k.pullAllBy = ym),
                  (k.pullAllWith = bm),
                  (k.pullAt = lr),
                  (k.range = se),
                  (k.rangeRight = ge),
                  (k.rearg = Dm),
                  (k.reject = R1),
                  (k.remove = gy),
                  (k.rest = ih),
                  (k.reverse = $a),
                  (k.sampleSize = D1),
                  (k.set = uh),
                  (k.setWith = Vm),
                  (k.shuffle = Ny),
                  (k.slice = Fu),
                  (k.sortBy = eh),
                  (k.sortedUniq = Qd),
                  (k.sortedUniqBy = xy),
                  (k.split = gh),
                  (k.spread = km),
                  (k.tail = N1),
                  (k.take = A1),
                  (k.takeRight = kt),
                  (k.takeRightWhile = tn),
                  (k.takeWhile = mt),
                  (k.tap = _y),
                  (k.throttle = Qa),
                  (k.thru = Vl),
                  (k.toArray = $y),
                  (k.toPairs = fh),
                  (k.toPairsIn = rf),
                  (k.toPath = te),
                  (k.toPlainObject = lh),
                  (k.transform = t0),
                  (k.unary = Mr),
                  (k.union = vt),
                  (k.unionBy = Yt),
                  (k.unionWith = ss),
                  (k.uniq = Ga),
                  (k.uniqBy = ac),
                  (k.uniqWith = xm),
                  (k.unset = n0),
                  (k.unzip = or),
                  (k.unzipWith = mn),
                  (k.update = K1),
                  (k.updateWith = i0),
                  (k.values = vc),
                  (k.valuesIn = Wm),
                  (k.without = Va),
                  (k.words = h0),
                  (k.wrap = Qu),
                  (k.xor = Gl),
                  (k.xorBy = _m),
                  (k.xorWith = rs),
                  (k.zip = lc),
                  (k.zipObject = Yu),
                  (k.zipObjectDeep = Ni),
                  (k.zipWith = wm),
                  (k.entries = fh),
                  (k.entriesIn = rf),
                  (k.extend = oh),
                  (k.extendWith = dc),
                  s(k, k),
                  (k.add = ie),
                  (k.attempt = eg),
                  (k.camelCase = ph),
                  (k.capitalize = s0),
                  (k.ceil = ye),
                  (k.clamp = J1),
                  (k.clone = Ly),
                  (k.cloneDeep = ky),
                  (k.cloneDeepWith = zy),
                  (k.cloneWith = Dy),
                  (k.conformsTo = U1),
                  (k.deburr = yc),
                  (k.defaultTo = yh),
                  (k.divide = qe),
                  (k.endsWith = ex),
                  (k.eq = ls),
                  (k.escape = r0),
                  (k.escapeRegExp = a0),
                  (k.every = $u),
                  (k.find = as),
                  (k.findIndex = mm),
                  (k.findKey = Xy),
                  (k.findLast = Sy),
                  (k.findLastIndex = gm),
                  (k.findLastKey = sf),
                  (k.floor = Rt),
                  (k.forEach = Cy),
                  (k.forEachRight = la),
                  (k.forIn = Is),
                  (k.forInRight = Qy),
                  (k.forOwn = ch),
                  (k.forOwnRight = ca),
                  (k.get = Ja),
                  (k.gt = Py),
                  (k.gte = Iy),
                  (k.has = Zy),
                  (k.hasIn = Gm),
                  (k.head = vm),
                  (k.identity = vi),
                  (k.includes = Cm),
                  (k.indexOf = hy),
                  (k.inRange = dh),
                  (k.invoke = X1),
                  (k.isArguments = Xl),
                  (k.isArray = tt),
                  (k.isArrayBuffer = zm),
                  (k.isArrayLike = Ri),
                  (k.isArrayLikeObject = Nn),
                  (k.isBoolean = Zu),
                  (k.isBuffer = Za),
                  (k.isDate = Uy),
                  (k.isElement = gt),
                  (k.isEmpty = Pm),
                  (k.isEqual = sh),
                  (k.isEqualWith = Im),
                  (k.isError = rh),
                  (k.isFinite = Um),
                  (k.isFunction = os),
                  (k.isInteger = Ku),
                  (k.isLength = ah),
                  (k.isMap = Fy),
                  (k.isMatch = By),
                  (k.isMatchWith = Hy),
                  (k.isNaN = Xt),
                  (k.isNative = Fm),
                  (k.isNil = F1),
                  (k.isNull = ni),
                  (k.isNumber = Bm),
                  (k.isObject = dn),
                  (k.isObjectLike = Sn),
                  (k.isPlainObject = Ju),
                  (k.isRegExp = ef),
                  (k.isSafeInteger = Hm),
                  (k.isSet = tf),
                  (k.isString = nf),
                  (k.isSymbol = Li),
                  (k.isTypedArray = Ka),
                  (k.isUndefined = Ym),
                  (k.isWeakMap = B1),
                  (k.isWeakSet = Yy),
                  (k.join = py),
                  (k.kebabCase = l0),
                  (k.last = ln),
                  (k.lastIndexOf = my),
                  (k.lowerCase = o0),
                  (k.lowerFirst = Xm),
                  (k.lt = H1),
                  (k.lte = qy),
                  (k.max = Be),
                  (k.maxBy = lt),
                  (k.mean = yt),
                  (k.meanBy = Lt),
                  (k.min = sl),
                  (k.minBy = ax),
                  (k.stubArray = _e),
                  (k.stubFalse = re),
                  (k.stubObject = ue),
                  (k.stubString = Ie),
                  (k.stubTrue = Ve),
                  (k.multiply = KO),
                  (k.nth = ra),
                  (k.noConflict = r),
                  (k.noop = o),
                  (k.now = Vu),
                  (k.pad = c0),
                  (k.padEnd = u0),
                  (k.padStart = mh),
                  (k.parseInt = tx),
                  (k.random = hh),
                  (k.reduce = Jd),
                  (k.reduceRight = Om),
                  (k.repeat = nx),
                  (k.replace = Qm),
                  (k.result = e0),
                  (k.round = JO),
                  (k.runInContext = ee),
                  (k.sample = L1),
                  (k.size = Ay),
                  (k.snakeCase = Zm),
                  (k.some = uc),
                  (k.sortedIndex = Bu),
                  (k.sortedIndexBy = rc),
                  (k.sortedIndexOf = vy),
                  (k.sortedLastIndex = yy),
                  (k.sortedLastIndexBy = Hu),
                  (k.sortedLastIndexOf = by),
                  (k.startCase = Km),
                  (k.startsWith = f0),
                  (k.subtract = ej),
                  (k.sum = tj),
                  (k.sumBy = nj),
                  (k.template = Jm),
                  (k.times = Qt),
                  (k.toFinite = oa),
                  (k.toInteger = Qe),
                  (k.toLength = qm),
                  (k.toLower = el),
                  (k.toNumber = cs),
                  (k.toSafeInteger = Y1),
                  (k.toString = Ut),
                  (k.toUpper = tl),
                  (k.trim = nl),
                  (k.trimEnd = af),
                  (k.trimStart = lf),
                  (k.truncate = il),
                  (k.unescape = ix),
                  (k.uniqueId = K),
                  (k.upperCase = d0),
                  (k.upperFirst = Ql),
                  (k.each = Cy),
                  (k.eachRight = la),
                  (k.first = vm),
                  s(
                    k,
                    (function () {
                      var c = {};
                      return (
                        nr(k, function (p, x) {
                          Pt.call(k.prototype, x) || (c[x] = p);
                        }),
                        c
                      );
                    })(),
                    { chain: !1 },
                  ),
                  (k.VERSION = i),
                  Wi(
                    [
                      "bind",
                      "bindKey",
                      "curry",
                      "curryRight",
                      "partial",
                      "partialRight",
                    ],
                    function (c) {
                      k[c].placeholder = k;
                    },
                  ),
                  Wi(["drop", "take"], function (c, p) {
                    ((it.prototype[c] = function (x) {
                      x = x === n ? 1 : xn(Qe(x), 0);
                      var C =
                        this.__filtered__ && !p ? new it(this) : this.clone();
                      return (
                        C.__filtered__
                          ? (C.__takeCount__ = zn(x, C.__takeCount__))
                          : C.__views__.push({
                              size: zn(x, F),
                              type: c + (C.__dir__ < 0 ? "Right" : ""),
                            }),
                        C
                      );
                    }),
                      (it.prototype[c + "Right"] = function (x) {
                        return this.reverse()[c](x).reverse();
                      }));
                  }),
                  Wi(["filter", "map", "takeWhile"], function (c, p) {
                    var x = p + 1,
                      C = x == be || x == V;
                    it.prototype[c] = function (L) {
                      var z = this.clone();
                      return (
                        z.__iteratees__.push({ iteratee: Ge(L, 3), type: x }),
                        (z.__filtered__ = z.__filtered__ || C),
                        z
                      );
                    };
                  }),
                  Wi(["head", "last"], function (c, p) {
                    var x = "take" + (p ? "Right" : "");
                    it.prototype[c] = function () {
                      return this[x](1).value()[0];
                    };
                  }),
                  Wi(["initial", "tail"], function (c, p) {
                    var x = "drop" + (p ? "" : "Right");
                    it.prototype[c] = function () {
                      return this.__filtered__ ? new it(this) : this[x](1);
                    };
                  }),
                  (it.prototype.compact = function () {
                    return this.filter(vi);
                  }),
                  (it.prototype.find = function (c) {
                    return this.filter(c).head();
                  }),
                  (it.prototype.findLast = function (c) {
                    return this.reverse().find(c);
                  }),
                  (it.prototype.invokeMap = rt(function (c, p) {
                    return typeof c == "function"
                      ? new it(this)
                      : this.map(function (x) {
                          return ks(x, c, p);
                        });
                  })),
                  (it.prototype.reject = function (c) {
                    return this.filter(nh(Ge(c)));
                  }),
                  (it.prototype.slice = function (c, p) {
                    c = Qe(c);
                    var x = this;
                    return x.__filtered__ && (c > 0 || p < 0)
                      ? new it(x)
                      : (c < 0 ? (x = x.takeRight(-c)) : c && (x = x.drop(c)),
                        p !== n &&
                          ((p = Qe(p)),
                          (x = p < 0 ? x.dropRight(-p) : x.take(p - c))),
                        x);
                  }),
                  (it.prototype.takeRightWhile = function (c) {
                    return this.reverse().takeWhile(c).reverse();
                  }),
                  (it.prototype.toArray = function () {
                    return this.take(F);
                  }),
                  nr(it.prototype, function (c, p) {
                    var x = /^(?:filter|find|map|reject)|While$/.test(p),
                      C = /^(?:head|last)$/.test(p),
                      L = k[C ? "take" + (p == "last" ? "Right" : "") : p],
                      z = C || /^find/.test(p);
                    L &&
                      (k.prototype[p] = function () {
                        var q = this.__wrapped__,
                          Q = C ? [1] : arguments,
                          ne = q instanceof it,
                          we = Q[0],
                          Se = ne || tt(q),
                          Ee = function (St) {
                            var jt = L.apply(k, Aa([St], Q));
                            return C && Ae ? jt[0] : jt;
                          };
                        Se &&
                          x &&
                          typeof we == "function" &&
                          we.length != 1 &&
                          (ne = Se = !1);
                        var Ae = this.__chain__,
                          He = !!this.__actions__.length,
                          Ze = z && !Ae,
                          ht = ne && !He;
                        if (!z && Se) {
                          q = ht ? q : new it(this);
                          var Ke = c.apply(q, Q);
                          return (
                            Ke.__actions__.push({
                              func: Vl,
                              args: [Ee],
                              thisArg: n,
                            }),
                            new Ti(Ke, Ae)
                          );
                        }
                        return Ze && ht
                          ? c.apply(this, Q)
                          : ((Ke = this.thru(Ee)),
                            Ze ? (C ? Ke.value()[0] : Ke.value()) : Ke);
                      });
                  }),
                  Wi(
                    ["pop", "push", "shift", "sort", "splice", "unshift"],
                    function (c) {
                      var p = lu[c],
                        x = /^(?:push|sort|unshift)$/.test(c) ? "tap" : "thru",
                        C = /^(?:pop|shift)$/.test(c);
                      k.prototype[c] = function () {
                        var L = arguments;
                        if (C && !this.__chain__) {
                          var z = this.value();
                          return p.apply(tt(z) ? z : [], L);
                        }
                        return this[x](function (q) {
                          return p.apply(tt(q) ? q : [], L);
                        });
                      };
                    },
                  ),
                  nr(it.prototype, function (c, p) {
                    var x = k[p];
                    if (x) {
                      var C = x.name + "";
                      (Pt.call(It, C) || (It[C] = []),
                        It[C].push({ name: p, func: x }));
                    }
                  }),
                  (It[nc(n, O).name] = [{ name: "wrapper", func: n }]),
                  (it.prototype.clone = Qr),
                  (it.prototype.reverse = Pa),
                  (it.prototype.value = Zr),
                  (k.prototype.at = Zd),
                  (k.prototype.chain = Wa),
                  (k.prototype.commit = Yn),
                  (k.prototype.next = Xa),
                  (k.prototype.plant = aa),
                  (k.prototype.reverse = Sm),
                  (k.prototype.toJSON =
                    k.prototype.valueOf =
                    k.prototype.value =
                      Tm),
                  (k.prototype.first = k.prototype.head),
                  Kn && (k.prototype[Kn] = oc),
                  k
                );
              },
              Ro = Ep();
            Qs ? (((Qs.exports = Ro)._ = Ro), (tu._ = Ro)) : (Bn._ = Ro);
          }).call(lI);
        })(xg, xg.exports)),
      xg.exports
    );
  }
  var cI = oI();
  const uI = aw(cI),
    fI = () => {
      const {
          showError: t,
          showServerErrorMsg: e,
          showServerSuccessMsg: n,
        } = wa(),
        i = ys(),
        a = sn();
      U.useEffect(() => {
        i.pathname === "/qeydiyyat/otp-verification" &&
          !sessionStorage.getItem("email_for_verify") &&
          a("/qeydiyyat");
      }, [i]);
      const [l, u] = W.useState(""),
        [d, m] = W.useState(""),
        [g, v] = W.useState(120),
        [y, w] = W.useState(!1),
        S = W.useCallback(
          uI.debounce((G) => {
            m(G);
          }, 2e3),
          [],
        );
      W.useEffect(() => {
        if (g <= 0) {
          w(!0);
          return;
        }
        const G = setInterval(() => {
          v((Y) => Y - 1);
        }, 1e3);
        return () => clearInterval(G);
      }, [g]);
      const T = () => {
          (v(120), w(!1), u(""));
        },
        [E, j] = U.useState(!1),
        O = async () => {
          var G, Y, B, I, H, X, fe, ve, be;
          j(!0);
          try {
            const Oe = {
                email: sessionStorage.getItem("email_for_verify") || "",
              },
              V = await Xe.post(`${Ii}resend-otp`, Oe);
            V.data
              ? n((G = V.data) == null ? void 0 : G.message)
              : (console.log(V.status),
                n((Y = V.data) == null ? void 0 : Y.message));
          } catch (Oe) {
            (Xe.isAxiosError(Oe)
              ? (I = (B = Oe.response) == null ? void 0 : B.data) != null &&
                I.message
                ? e(
                    (X = (H = Oe.response) == null ? void 0 : H.data) == null
                      ? void 0
                      : X.message,
                  )
                : ((fe = Oe.response) == null ? void 0 : fe.status) === 401
                  ? e(
                      (be = (ve = Oe.response) == null ? void 0 : ve.data) ==
                        null
                        ? void 0
                        : be.message,
                    )
                  : t()
              : t(),
              console.log(Oe));
          } finally {
            j(!1);
          }
        },
        M = Math.floor(g / 60),
        N = g % 60,
        [R, P] = U.useState(!1);
      return h.jsx("div", {
        className: "login-page-wrapper",
        children: h.jsx("div", {
          className: "login-page",
          children: h.jsxs("form", {
            onSubmit: async (G) => {
              var Y, B, I, H;
              (G.preventDefault(), P(!0));
              try {
                const X = {
                    email: sessionStorage.getItem("email_for_verify") || "",
                    otp_code: d,
                  },
                  fe = await Xe.post(`${Ii}email/verify`, X);
                fe.data
                  ? (n(((Y = fe.data) == null ? void 0 : Y.message) || ""),
                    sessionStorage.clear(),
                    a("/daxil-ol", { replace: !0 }))
                  : console.log(fe.status);
              } catch (X) {
                (Xe.isAxiosError(X)
                  ? (B = X.response) != null &&
                    B.data.message &&
                    e(
                      (H =
                        (I = X == null ? void 0 : X.response) == null
                          ? void 0
                          : I.data) == null
                        ? void 0
                        : H.message,
                    )
                  : xt.error("500 Internal Server Error", {
                      position: "top-right",
                    }),
                  console.log(X));
              } finally {
                P(!1);
              }
            },
            className: "login-form",
            children: [
              h.jsx("div", {
                className: "top",
                children: h.jsx(_t, {
                  to: "/qeydiyyat",
                  className: "get-back",
                  children: h.jsx(KM, {
                    className: "left",
                    style: { fontSize: "21px", color: "black" },
                  }),
                }),
              }),
              h.jsx("div", {
                className: "form-content",
                children: h.jsxs("div", {
                  className: "form",
                  children: [
                    h.jsxs("article", {
                      className: "top-title",
                      children: [
                        h.jsx("h1", { children: "OTP kodun təsdiqi" }),
                        h.jsxs("p", {
                          children: [
                            h.jsx(_t, {
                              to: "mailto:",
                              style: { color: "#1472E2" },
                              children:
                                sessionStorage.getItem("email_for_verify") ||
                                "...",
                            }),
                            " ",
                            "ünvanına altı rəqəmli OTP kodunu daxil edin.",
                          ],
                        }),
                      ],
                    }),
                    h.jsxs("div", {
                      className: "input-container",
                      children: [
                        h.jsx("div", {
                          className: "top-inputs",
                          children: h.jsx(aI, {
                            containerStyle: { gap: "12px" },
                            inputStyle: {
                              width: "60px",
                              minWidth: "60px",
                              height: "60px",
                              minHeight: "60px",
                            },
                            value: l,
                            onChange: (G) => {
                              (u(G), S(G));
                            },
                            numInputs: 6,
                            renderInput: (G) =>
                              h.jsx("input", {
                                name: "otp_code",
                                required: !0,
                                ...G,
                              }),
                          }),
                        }),
                        h.jsx("div", {
                          className: "button-content",
                          children: R
                            ? h.jsx(ze, {
                                style: { height: "30px" },
                                styleLoader: { height: "30px" },
                              })
                            : h.jsx("button", {
                                type: "submit",
                                children: "Təsdiq et",
                              }),
                        }),
                        h.jsxs("div", {
                          className: "message-otp",
                          children: [
                            h.jsx("span", {
                              className: "time",
                              style: { display: y ? "none" : "flex" },
                              children: `${M}:${N < 10 ? "0" : ""}${N}`,
                            }),
                            h.jsx("button", {
                              type: "button",
                              className: `send-a-code ${y ? "active" : ""}`,
                              onClick: () => {
                                (T(), O());
                              },
                              children: E
                                ? h.jsx(ze, { style: { height: "30px" } })
                                : "Kodu yenidən göndər",
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
              }),
            ],
          }),
        }),
      });
    },
    dI = () => {
      const { loading: t, handleForgotPassword: e } = i1(),
        [n, i] = U.useState({ email: "" });
      return h.jsxs("div", {
        className: "login",
        children: [
          h.jsxs("form", {
            onSubmit: (a) => {
              (a.preventDefault(), e(n));
            },
            acceptCharset: "UTF-8",
            className: "left",
            children: [
              h.jsx("div", {
                className: "button-get-back",
                children: h.jsx(_t, {
                  to: "/",
                  className: "btn",
                  children: h.jsx("img", {
                    src: "/ArrowLeft.svg",
                    alt: "arrow-left",
                  }),
                }),
              }),
              h.jsxs("div", {
                className: "form-container",
                children: [
                  h.jsxs("div", {
                    className: "title-content",
                    children: [
                      h.jsx("h1", { children: "Şifrənin bərpası" }),
                      h.jsx("p", {
                        children:
                          "Şifrəni yeniləmək üçün email ünvanınızı daxil edin",
                      }),
                    ],
                  }),
                  h.jsx("div", {
                    className: "content",
                    children: h.jsxs("div", {
                      className: "input-container",
                      children: [
                        h.jsx("div", {
                          className: "input-field",
                          children: h.jsx("input", {
                            type: "email",
                            placeholder: "Email",
                            name: "email",
                            value: n == null ? void 0 : n.email,
                            required: !0,
                            onChange: (a) =>
                              i((l) => ({ ...l, email: a.target.value })),
                          }),
                        }),
                        t[3]
                          ? h.jsx(ze, {
                              style: { height: "30px" },
                              styleLoader: { height: "30px" },
                            })
                          : h.jsx(Ct, {
                              buttonType: "submit",
                              title: "Link göndər",
                              isButton: !0,
                              style: { width: "100%" },
                              disabled: t[3],
                            }),
                      ],
                    }),
                  }),
                ],
              }),
            ],
          }),
          h.jsx("div", { className: "right" }),
        ],
      });
    },
    hI = () => {
      const [t] = XE(),
        e = t.get("token"),
        n = t.get("email"),
        [i, a] = U.useState({}),
        { handleChangePassword: l, loading: u } = i1(),
        [d, m] = U.useState({
          email: n || "",
          password: "",
          password_confirmation: "",
          token: e || "",
        });
      return h.jsxs("div", {
        className: "login",
        children: [
          h.jsxs("form", {
            onSubmit: (g) => {
              (g.preventDefault(), l(d));
            },
            acceptCharset: "UTF-8",
            className: "left",
            children: [
              h.jsx("div", {
                className: "button-get-back",
                children: h.jsx(_t, {
                  to: "/",
                  className: "btn",
                  children: h.jsx("img", {
                    src: "/ArrowLeft.svg",
                    alt: "arrow-left",
                  }),
                }),
              }),
              h.jsxs("div", {
                className: "form-container",
                children: [
                  h.jsxs("div", {
                    className: "title-content",
                    children: [
                      h.jsx("h1", { children: "Şifrəni bərpa et" }),
                      h.jsx("p", {
                        children:
                          "Şifrəni bərpa etmək üçün yeni şifrə təyin et",
                      }),
                    ],
                  }),
                  h.jsx("div", {
                    className: "content",
                    children: h.jsxs("div", {
                      className: "input-container",
                      children: [
                        h.jsxs("div", {
                          className: "input-field",
                          children: [
                            i[1]
                              ? h.jsx(jb, {
                                  className: "eye",
                                  onClick: () => a((g) => ({ ...g, 1: !1 })),
                                })
                              : h.jsx(wb, {
                                  className: "eye",
                                  onClick: () => a((g) => ({ ...g, 1: !0 })),
                                }),
                            h.jsx("input", {
                              type: i[1] ? "text" : "password",
                              placeholder: "Şifrə",
                              name: "password",
                              value: d == null ? void 0 : d.password,
                              required: !0,
                              onChange: (g) =>
                                m((v) => ({ ...v, password: g.target.value })),
                            }),
                          ],
                        }),
                        h.jsxs("div", {
                          className: "input-field",
                          children: [
                            i[2]
                              ? h.jsx(jb, {
                                  className: "eye",
                                  onClick: () => a((g) => ({ ...g, 1: !1 })),
                                })
                              : h.jsx(wb, {
                                  className: "eye",
                                  onClick: () => a((g) => ({ ...g, 1: !0 })),
                                }),
                            h.jsx("input", {
                              type: i[2] ? "text" : "password",
                              placeholder: "Şifrə təkrarı",
                              name: "password_confirmation",
                              value:
                                d == null ? void 0 : d.password_confirmation,
                              required: !0,
                              onChange: (g) =>
                                m((v) => ({
                                  ...v,
                                  password_confirmation: g.target.value,
                                })),
                            }),
                          ],
                        }),
                        u[4]
                          ? h.jsx(ze, {
                              style: { height: "30px" },
                              styleLoader: { height: "30px" },
                            })
                          : h.jsx(Ct, {
                              buttonType: "submit",
                              title: "Link göndər",
                              isButton: !0,
                              style: { width: "100%" },
                              disabled: u[4],
                            }),
                      ],
                    }),
                  }),
                ],
              }),
            ],
          }),
          h.jsx("div", { className: "right" }),
        ],
      });
    },
    pI = (t) => {
      const e = ys();
      return (
        W.useEffect(() => {
          e.hash || window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
        }, [e]),
        h.jsx(h.Fragment, { children: t.children })
      );
    },
    mI = () => {
      const { t } = Ot();
      return h.jsx(_t, {
        to: `https://wa.me/${t("your_telephone_number")}`,
        rel: "noopener noreferrer",
        target: "_blank",
        className: "whatsapp-call",
        children: h.jsx("img", {
          src: "/WhatsApp icon.svg",
          alt: "WhatsApp icon",
        }),
      });
    },
    NF = () =>
      h.jsxs("section", {
        className: "not-found-page",
        children: [
          h.jsx("title", { children: "404 — Səhifə tapılmadı" }),
          h.jsx("meta", { name: "robots", content: "noindex, nofollow" }),
          h.jsx("p", { className: "not-found-code", children: "404" }),
          h.jsx("h1", { children: "Səhifə tapılmadı" }),
          h.jsx("p", {
            children:
              "Axtardığınız səhifə silinib, ünvanı dəyişib və ya mövcud deyil.",
          }),
          h.jsx(_t, {
            to: "/",
            className: "not-found-home-link",
            children: "Ana səhifəyə qayıt",
          }),
        ],
      }),
    gI = new nR({
      defaultOptions: {
        queries: {
          staleTime: 1e3 * 60 * 60,
          refetchOnWindowFocus: !1,
          retry: 1,
        },
      },
    });
  hj.createRoot(document.getElementById("root")).render(
    h.jsx(MR, {
      store: K8,
      children: h.jsx(iR, {
        client: gI,
        children: h.jsx(zM, {
          children: h.jsx(_5, {
            children: h.jsx(MA, {
              children: h.jsxs(pI, {
                children: [
                  h.jsx(mI, {}),
                  h.jsx(Z8, {}),
                  h.jsx(iI, {}),
                  h.jsx(pL, { style: { zIndex: 1e7 }, autoClose: 1500 }),
                  h.jsxs(fM, {
                    children: [
                      h.jsx(hf, { path: "/daxil-ol", element: h.jsx(sI, {}) }),
                      h.jsx(hf, {
                        path: "/sifremi-unuttum",
                        element: h.jsx(dI, {}),
                      }),
                      h.jsx(hf, {
                        path: "/custom-password-reset",
                        element: h.jsx(hI, {}),
                      }),
                      h.jsx(hf, { path: "/qeydiyyat", element: h.jsx(rI, {}) }),
                      h.jsx(hf, {
                        path: "/qeydiyyat/otp-verification",
                        element: h.jsx(fI, {}),
                      }),
                      U8.map((t) =>
                        h.jsx(
                          hf,
                          { path: t.route, element: t.component },
                          t.id,
                        ),
                      ),
                      h.jsx(hf, { path: "*", element: h.jsx(NF, {}) }),
                    ],
                  }),
                  h.jsx(J8, {}),
                ],
              }),
            }),
          }),
        }),
      }),
    }),
  );
});
export default vI();
